export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: string; output: string; }
  Enumerable: { input: unknown; output: unknown; }
  JSON: { input: unknown; output: unknown; }
  JSONObject: { input: unknown; output: unknown; }
  JSONSchema: { input: unknown; output: unknown; }
  UUID: { input: string; output: string; }
  Upload: { input: unknown; output: unknown; }
  jsonb: { input: unknown; output: unknown; }
  lquery: { input: unknown; output: unknown; }
  ltree: { input: unknown; output: unknown; }
  ltxtquery: { input: unknown; output: unknown; }
  timestamp: { input: unknown; output: unknown; }
  timestamptz: { input: string; output: string; }
  uuid: { input: string; output: string; }
};

export type ApplySchemaInvokeInput = {
  sheetName?: InputMaybe<Scalars['String']['input']>;
  spreadsheetId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ApplySchemaInvokeOutput = {
  __typename?: 'ApplySchemaInvokeOutput';
  operationId: Scalars['String']['output'];
};

export type ApplySchemaInvokeResponse = ApplySchemaInvokeOutput | ClientError;

/** columns and relationships of "area_codes" */
export type AreaCodes = {
  __typename?: 'AreaCodes';
  /** An object relationship */
  country: Countries;
  countryId: Scalars['String']['output'];
  globalCode: Scalars['String']['output'];
  globalName: Scalars['String']['output'];
  intermediateRegionCode?: Maybe<Scalars['String']['output']>;
  intermediateRegionName?: Maybe<Scalars['String']['output']>;
  m49Code: Scalars['String']['output'];
  m49Name: Scalars['String']['output'];
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  subRegionCode?: Maybe<Scalars['String']['output']>;
  subRegionName?: Maybe<Scalars['String']['output']>;
};

/** aggregated selection of "area_codes" */
export type AreaCodesAggregate = {
  __typename?: 'AreaCodesAggregate';
  aggregate?: Maybe<AreaCodesAggregateFields>;
  nodes: Array<AreaCodes>;
};

/** aggregate fields of "area_codes" */
export type AreaCodesAggregateFields = {
  __typename?: 'AreaCodesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<AreaCodesMaxFields>;
  min?: Maybe<AreaCodesMinFields>;
};


/** aggregate fields of "area_codes" */
export type AreaCodesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<AreaCodesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "area_codes". All fields are combined with a logical 'AND'. */
export type AreaCodesBoolExp = {
  _and?: InputMaybe<Array<AreaCodesBoolExp>>;
  _not?: InputMaybe<AreaCodesBoolExp>;
  _or?: InputMaybe<Array<AreaCodesBoolExp>>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  globalCode?: InputMaybe<StringComparisonExp>;
  globalName?: InputMaybe<StringComparisonExp>;
  intermediateRegionCode?: InputMaybe<StringComparisonExp>;
  intermediateRegionName?: InputMaybe<StringComparisonExp>;
  m49Code?: InputMaybe<StringComparisonExp>;
  m49Name?: InputMaybe<StringComparisonExp>;
  regionCode?: InputMaybe<StringComparisonExp>;
  regionName?: InputMaybe<StringComparisonExp>;
  subRegionCode?: InputMaybe<StringComparisonExp>;
  subRegionName?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "area_codes" */
export const AreaCodesConstraint = {
  /** unique or primary key constraint on columns "country_id" */
  AreaCodesPkey: 'area_codes_pkey'
} as const;

export type AreaCodesConstraint = typeof AreaCodesConstraint[keyof typeof AreaCodesConstraint];
/** input type for inserting data into table "area_codes" */
export type AreaCodesInsertInput = {
  country?: InputMaybe<CountriesObjRelInsertInput>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  globalCode?: InputMaybe<Scalars['String']['input']>;
  globalName?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionCode?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionName?: InputMaybe<Scalars['String']['input']>;
  m49Code?: InputMaybe<Scalars['String']['input']>;
  m49Name?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  subRegionCode?: InputMaybe<Scalars['String']['input']>;
  subRegionName?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type AreaCodesMaxFields = {
  __typename?: 'AreaCodesMaxFields';
  countryId?: Maybe<Scalars['String']['output']>;
  globalCode?: Maybe<Scalars['String']['output']>;
  globalName?: Maybe<Scalars['String']['output']>;
  intermediateRegionCode?: Maybe<Scalars['String']['output']>;
  intermediateRegionName?: Maybe<Scalars['String']['output']>;
  m49Code?: Maybe<Scalars['String']['output']>;
  m49Name?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  subRegionCode?: Maybe<Scalars['String']['output']>;
  subRegionName?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type AreaCodesMinFields = {
  __typename?: 'AreaCodesMinFields';
  countryId?: Maybe<Scalars['String']['output']>;
  globalCode?: Maybe<Scalars['String']['output']>;
  globalName?: Maybe<Scalars['String']['output']>;
  intermediateRegionCode?: Maybe<Scalars['String']['output']>;
  intermediateRegionName?: Maybe<Scalars['String']['output']>;
  m49Code?: Maybe<Scalars['String']['output']>;
  m49Name?: Maybe<Scalars['String']['output']>;
  regionCode?: Maybe<Scalars['String']['output']>;
  regionName?: Maybe<Scalars['String']['output']>;
  subRegionCode?: Maybe<Scalars['String']['output']>;
  subRegionName?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "area_codes" */
export type AreaCodesMutationResponse = {
  __typename?: 'AreaCodesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<AreaCodes>;
};

/** input type for inserting object relation for remote table "area_codes" */
export type AreaCodesObjRelInsertInput = {
  data: AreaCodesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<AreaCodesOnConflict>;
};

/** on_conflict condition type for table "area_codes" */
export type AreaCodesOnConflict = {
  constraint: AreaCodesConstraint;
  updateColumns?: Array<AreaCodesUpdateColumn>;
  where?: InputMaybe<AreaCodesBoolExp>;
};

/** Ordering options when selecting data from "area_codes". */
export type AreaCodesOrderBy = {
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  globalCode?: InputMaybe<OrderBy>;
  globalName?: InputMaybe<OrderBy>;
  intermediateRegionCode?: InputMaybe<OrderBy>;
  intermediateRegionName?: InputMaybe<OrderBy>;
  m49Code?: InputMaybe<OrderBy>;
  m49Name?: InputMaybe<OrderBy>;
  regionCode?: InputMaybe<OrderBy>;
  regionName?: InputMaybe<OrderBy>;
  subRegionCode?: InputMaybe<OrderBy>;
  subRegionName?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: area_codes */
export type AreaCodesPkColumnsInput = {
  countryId: Scalars['String']['input'];
};

/** select columns of table "area_codes" */
export const AreaCodesSelectColumn = {
  /** column name */
  CountryId: 'countryId',
  /** column name */
  GlobalCode: 'globalCode',
  /** column name */
  GlobalName: 'globalName',
  /** column name */
  IntermediateRegionCode: 'intermediateRegionCode',
  /** column name */
  IntermediateRegionName: 'intermediateRegionName',
  /** column name */
  M49Code: 'm49Code',
  /** column name */
  M49Name: 'm49Name',
  /** column name */
  RegionCode: 'regionCode',
  /** column name */
  RegionName: 'regionName',
  /** column name */
  SubRegionCode: 'subRegionCode',
  /** column name */
  SubRegionName: 'subRegionName'
} as const;

export type AreaCodesSelectColumn = typeof AreaCodesSelectColumn[keyof typeof AreaCodesSelectColumn];
/** input type for updating data in table "area_codes" */
export type AreaCodesSetInput = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  globalCode?: InputMaybe<Scalars['String']['input']>;
  globalName?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionCode?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionName?: InputMaybe<Scalars['String']['input']>;
  m49Code?: InputMaybe<Scalars['String']['input']>;
  m49Name?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  subRegionCode?: InputMaybe<Scalars['String']['input']>;
  subRegionName?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "area_codes" */
export type AreaCodesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: AreaCodesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type AreaCodesStreamCursorValueInput = {
  countryId?: InputMaybe<Scalars['String']['input']>;
  globalCode?: InputMaybe<Scalars['String']['input']>;
  globalName?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionCode?: InputMaybe<Scalars['String']['input']>;
  intermediateRegionName?: InputMaybe<Scalars['String']['input']>;
  m49Code?: InputMaybe<Scalars['String']['input']>;
  m49Name?: InputMaybe<Scalars['String']['input']>;
  regionCode?: InputMaybe<Scalars['String']['input']>;
  regionName?: InputMaybe<Scalars['String']['input']>;
  subRegionCode?: InputMaybe<Scalars['String']['input']>;
  subRegionName?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "area_codes" */
export const AreaCodesUpdateColumn = {
  /** column name */
  CountryId: 'countryId',
  /** column name */
  GlobalCode: 'globalCode',
  /** column name */
  GlobalName: 'globalName',
  /** column name */
  IntermediateRegionCode: 'intermediateRegionCode',
  /** column name */
  IntermediateRegionName: 'intermediateRegionName',
  /** column name */
  M49Code: 'm49Code',
  /** column name */
  M49Name: 'm49Name',
  /** column name */
  RegionCode: 'regionCode',
  /** column name */
  RegionName: 'regionName',
  /** column name */
  SubRegionCode: 'subRegionCode',
  /** column name */
  SubRegionName: 'subRegionName'
} as const;

export type AreaCodesUpdateColumn = typeof AreaCodesUpdateColumn[keyof typeof AreaCodesUpdateColumn];
export type AreaCodesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<AreaCodesSetInput>;
  /** filter the rows which have to be updated */
  where: AreaCodesBoolExp;
};

export type AttributedDataSourceInput = {
  attributedPropertySchema: AttributedPropertySchemaInput;
  categoryName: Scalars['String']['input'];
};

export type AttributedPropertySchemaInput = {
  date: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['String']['input']>;
  title: Scalars['String']['input'];
};

export type BatchChangeRequestReviewsJobGetDryRunResultInput = {
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestReviewsJobRunUpdateInput = {
  id: Scalars['UUID']['input'];
  status: JobRunStatus;
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestReviewsJobRunUpdateOutput = {
  __typename?: 'BatchChangeRequestReviewsJobRunUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRuns = {
  __typename?: 'BatchChangeRequestReviewsJobRuns';
  /** An object relationship */
  batchChangeRequestReviewsJob: BatchChangeRequestReviewsJobs;
  batchChangeRequestReviewsJobId: Scalars['uuid']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsAggregate = {
  __typename?: 'BatchChangeRequestReviewsJobRunsAggregate';
  aggregate?: Maybe<BatchChangeRequestReviewsJobRunsAggregateFields>;
  nodes: Array<BatchChangeRequestReviewsJobRuns>;
};

export type BatchChangeRequestReviewsJobRunsAggregateBoolExp = {
  count?: InputMaybe<BatchChangeRequestReviewsJobRunsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsAggregateFields = {
  __typename?: 'BatchChangeRequestReviewsJobRunsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchChangeRequestReviewsJobRunsMaxFields>;
  min?: Maybe<BatchChangeRequestReviewsJobRunsMinFields>;
};


/** aggregate fields of "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchChangeRequestReviewsJobRunsMaxOrderBy>;
  min?: InputMaybe<BatchChangeRequestReviewsJobRunsMinOrderBy>;
};

/** input type for inserting array relation for remote table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsArrRelInsertInput = {
  data: Array<BatchChangeRequestReviewsJobRunsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobRunsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_change_request_reviews_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobRunsBoolExp = {
  _and?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsBoolExp>>;
  _not?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
  _or?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsBoolExp>>;
  batchChangeRequestReviewsJob?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
  batchChangeRequestReviewsJobId?: InputMaybe<UuidComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  s3LogPath?: InputMaybe<StringComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "batch_change_request_reviews_job_runs" */
export const BatchChangeRequestReviewsJobRunsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchChangeRequestReviewsJobRunsPkey: 'batch_change_request_reviews_job_runs_pkey'
} as const;

export type BatchChangeRequestReviewsJobRunsConstraint = typeof BatchChangeRequestReviewsJobRunsConstraint[keyof typeof BatchChangeRequestReviewsJobRunsConstraint];
/** input type for inserting data into table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsInsertInput = {
  batchChangeRequestReviewsJob?: InputMaybe<BatchChangeRequestReviewsJobsObjRelInsertInput>;
  batchChangeRequestReviewsJobId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BatchChangeRequestReviewsJobRunsMaxFields = {
  __typename?: 'BatchChangeRequestReviewsJobRunsMaxFields';
  batchChangeRequestReviewsJobId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsMaxOrderBy = {
  batchChangeRequestReviewsJobId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchChangeRequestReviewsJobRunsMinFields = {
  __typename?: 'BatchChangeRequestReviewsJobRunsMinFields';
  batchChangeRequestReviewsJobId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsMinOrderBy = {
  batchChangeRequestReviewsJobId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsMutationResponse = {
  __typename?: 'BatchChangeRequestReviewsJobRunsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchChangeRequestReviewsJobRuns>;
};

/** on_conflict condition type for table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsOnConflict = {
  constraint: BatchChangeRequestReviewsJobRunsConstraint;
  updateColumns?: Array<BatchChangeRequestReviewsJobRunsUpdateColumn>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};

/** Ordering options when selecting data from "batch_change_request_reviews_job_runs". */
export type BatchChangeRequestReviewsJobRunsOrderBy = {
  batchChangeRequestReviewsJob?: InputMaybe<BatchChangeRequestReviewsJobsOrderBy>;
  batchChangeRequestReviewsJobId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_change_request_reviews_job_runs */
export type BatchChangeRequestReviewsJobRunsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "batch_change_request_reviews_job_runs" */
export const BatchChangeRequestReviewsJobRunsSelectColumn = {
  /** column name */
  BatchChangeRequestReviewsJobId: 'batchChangeRequestReviewsJobId',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchChangeRequestReviewsJobRunsSelectColumn = typeof BatchChangeRequestReviewsJobRunsSelectColumn[keyof typeof BatchChangeRequestReviewsJobRunsSelectColumn];
/** input type for updating data in table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsSetInput = {
  batchChangeRequestReviewsJobId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "batch_change_request_reviews_job_runs" */
export type BatchChangeRequestReviewsJobRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchChangeRequestReviewsJobRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchChangeRequestReviewsJobRunsStreamCursorValueInput = {
  batchChangeRequestReviewsJobId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "batch_change_request_reviews_job_runs" */
export const BatchChangeRequestReviewsJobRunsUpdateColumn = {
  /** column name */
  BatchChangeRequestReviewsJobId: 'batchChangeRequestReviewsJobId',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchChangeRequestReviewsJobRunsUpdateColumn = typeof BatchChangeRequestReviewsJobRunsUpdateColumn[keyof typeof BatchChangeRequestReviewsJobRunsUpdateColumn];
export type BatchChangeRequestReviewsJobRunsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchChangeRequestReviewsJobRunsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchChangeRequestReviewsJobRunsBoolExp;
};

export type BatchChangeRequestReviewsJobSubmitOutput = {
  __typename?: 'BatchChangeRequestReviewsJobSubmitOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type BatchChangeRequestReviewsJobSubmitResponse = BatchChangeRequestReviewsJobSubmitOutput | ValidationError;

/** columns and relationships of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobs = {
  __typename?: 'BatchChangeRequestReviewsJobs';
  /** An array relationship */
  batchChangeRequestReviewsJobRuns: Array<BatchChangeRequestReviewsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobRunsAggregate: BatchChangeRequestReviewsJobRunsAggregate;
  batchChangeRequestsJobId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  reviewTypeId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsBatchChangeRequestReviewsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


/** columns and relationships of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsBatchChangeRequestReviewsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};

/** aggregated selection of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsAggregate = {
  __typename?: 'BatchChangeRequestReviewsJobsAggregate';
  aggregate?: Maybe<BatchChangeRequestReviewsJobsAggregateFields>;
  nodes: Array<BatchChangeRequestReviewsJobs>;
};

export type BatchChangeRequestReviewsJobsAggregateBoolExp = {
  count?: InputMaybe<BatchChangeRequestReviewsJobsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsAggregateFields = {
  __typename?: 'BatchChangeRequestReviewsJobsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchChangeRequestReviewsJobsMaxFields>;
  min?: Maybe<BatchChangeRequestReviewsJobsMinFields>;
};


/** aggregate fields of "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchChangeRequestReviewsJobsMaxOrderBy>;
  min?: InputMaybe<BatchChangeRequestReviewsJobsMinOrderBy>;
};

/** input type for inserting array relation for remote table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsArrRelInsertInput = {
  data: Array<BatchChangeRequestReviewsJobsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_change_request_reviews_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestReviewsJobsBoolExp = {
  _and?: InputMaybe<Array<BatchChangeRequestReviewsJobsBoolExp>>;
  _not?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
  _or?: InputMaybe<Array<BatchChangeRequestReviewsJobsBoolExp>>;
  batchChangeRequestReviewsJobRuns?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
  batchChangeRequestReviewsJobRunsAggregate?: InputMaybe<BatchChangeRequestReviewsJobRunsAggregateBoolExp>;
  batchChangeRequestsJobId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  reviewTypeId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "batch_change_request_reviews_jobs" */
export const BatchChangeRequestReviewsJobsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchChangeRequestReviewsJobsPkey: 'batch_change_request_reviews_jobs_pkey'
} as const;

export type BatchChangeRequestReviewsJobsConstraint = typeof BatchChangeRequestReviewsJobsConstraint[keyof typeof BatchChangeRequestReviewsJobsConstraint];
/** input type for inserting data into table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsInsertInput = {
  batchChangeRequestReviewsJobRuns?: InputMaybe<BatchChangeRequestReviewsJobRunsArrRelInsertInput>;
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reviewTypeId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BatchChangeRequestReviewsJobsMaxFields = {
  __typename?: 'BatchChangeRequestReviewsJobsMaxFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reviewTypeId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsMaxOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reviewTypeId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchChangeRequestReviewsJobsMinFields = {
  __typename?: 'BatchChangeRequestReviewsJobsMinFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  reviewTypeId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsMinOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reviewTypeId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsMutationResponse = {
  __typename?: 'BatchChangeRequestReviewsJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchChangeRequestReviewsJobs>;
};

/** input type for inserting object relation for remote table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsObjRelInsertInput = {
  data: BatchChangeRequestReviewsJobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobsOnConflict>;
};

/** on_conflict condition type for table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsOnConflict = {
  constraint: BatchChangeRequestReviewsJobsConstraint;
  updateColumns?: Array<BatchChangeRequestReviewsJobsUpdateColumn>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};

/** Ordering options when selecting data from "batch_change_request_reviews_jobs". */
export type BatchChangeRequestReviewsJobsOrderBy = {
  batchChangeRequestReviewsJobRunsAggregate?: InputMaybe<BatchChangeRequestReviewsJobRunsAggregateOrderBy>;
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  reviewTypeId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_change_request_reviews_jobs */
export type BatchChangeRequestReviewsJobsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "batch_change_request_reviews_jobs" */
export const BatchChangeRequestReviewsJobsSelectColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ReviewTypeId: 'reviewTypeId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestReviewsJobsSelectColumn = typeof BatchChangeRequestReviewsJobsSelectColumn[keyof typeof BatchChangeRequestReviewsJobsSelectColumn];
/** input type for updating data in table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsSetInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reviewTypeId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "batch_change_request_reviews_jobs" */
export type BatchChangeRequestReviewsJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchChangeRequestReviewsJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchChangeRequestReviewsJobsStreamCursorValueInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  reviewTypeId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "batch_change_request_reviews_jobs" */
export const BatchChangeRequestReviewsJobsUpdateColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ReviewTypeId: 'reviewTypeId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestReviewsJobsUpdateColumn = typeof BatchChangeRequestReviewsJobsUpdateColumn[keyof typeof BatchChangeRequestReviewsJobsUpdateColumn];
export type BatchChangeRequestReviewsJobsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchChangeRequestReviewsJobsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchChangeRequestReviewsJobsBoolExp;
};

export type BatchChangeRequestsJobActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobActivateOutput = {
  __typename?: 'BatchChangeRequestsJobActivateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchChangeRequestsJobCreateInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  jobType: BatchChangeRequestsJobType;
  name?: InputMaybe<Scalars['String']['input']>;
  recordComposerDefinitionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobCreateOutput = {
  __typename?: 'BatchChangeRequestsJobCreateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchChangeRequestsJobCreateResponse = BatchChangeRequestsJobCreateOutput | ValidationError;

export type BatchChangeRequestsJobDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobDeactivateOutput = {
  __typename?: 'BatchChangeRequestsJobDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchChangeRequestsJobExportDryRunResultInput = {
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobGetDryRunResultInput = {
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

/** columns and relationships of "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitions = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitions';
  /** An object relationship */
  batchChangeRequestsJob: BatchChangeRequestsJobs;
  batchChangeRequestsJobId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsAggregate = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateFields>;
  nodes: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
};

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp = {
  count?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateFields = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMaxFields>;
  min?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsMaxOrderBy>;
  min?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsArrRelInsertInput = {
  data: Array<BatchChangeRequestsJobRecordComposerDefinitionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_change_requests_job_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>>;
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  batchChangeRequestsJobId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "batch_change_requests_job_record_composer_definitions" */
export const BatchChangeRequestsJobRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id", "batch_change_requests_job_id" */
  BatchChangeRequestsJobRecordComposerDefinitionsPkey: 'batch_change_requests_job_record_composer_definitions_pkey'
} as const;

export type BatchChangeRequestsJobRecordComposerDefinitionsConstraint = typeof BatchChangeRequestsJobRecordComposerDefinitionsConstraint[keyof typeof BatchChangeRequestsJobRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsInsertInput = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsObjRelInsertInput>;
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BatchChangeRequestsJobRecordComposerDefinitionsMaxFields = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitionsMaxFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsMaxOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchChangeRequestsJobRecordComposerDefinitionsMinFields = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitionsMinFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsMinOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse = {
  __typename?: 'BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
};

/** on_conflict condition type for table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsOnConflict = {
  constraint: BatchChangeRequestsJobRecordComposerDefinitionsConstraint;
  updateColumns?: Array<BatchChangeRequestsJobRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "batch_change_requests_job_record_composer_definitions". */
export type BatchChangeRequestsJobRecordComposerDefinitionsOrderBy = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsOrderBy>;
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_change_requests_job_record_composer_definitions */
export type BatchChangeRequestsJobRecordComposerDefinitionsPkColumnsInput = {
  batchChangeRequestsJobId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "batch_change_requests_job_record_composer_definitions" */
export const BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn = typeof BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn[keyof typeof BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsSetInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "batch_change_requests_job_record_composer_definitions" */
export type BatchChangeRequestsJobRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchChangeRequestsJobRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchChangeRequestsJobRecordComposerDefinitionsStreamCursorValueInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "batch_change_requests_job_record_composer_definitions" */
export const BatchChangeRequestsJobRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestsJobRecordComposerDefinitionsUpdateColumn = typeof BatchChangeRequestsJobRecordComposerDefinitionsUpdateColumn[keyof typeof BatchChangeRequestsJobRecordComposerDefinitionsUpdateColumn];
export type BatchChangeRequestsJobRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp;
};

export type BatchChangeRequestsJobRunUpdateInput = {
  id: Scalars['UUID']['input'];
  status: JobRunStatus;
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobRunUpdateOutput = {
  __typename?: 'BatchChangeRequestsJobRunUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRuns = {
  __typename?: 'BatchChangeRequestsJobRuns';
  /** An object relationship */
  batchChangeRequestsJob: BatchChangeRequestsJobs;
  batchChangeRequestsJobId: Scalars['uuid']['output'];
  /** An array relationship */
  changeRequests: Array<ChangeRequests>;
  /** An aggregate relationship */
  changeRequestsAggregate: ChangeRequestsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  mappingLog: Scalars['jsonb']['output'];
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


/** columns and relationships of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


/** columns and relationships of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsMappingLogArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsAggregate = {
  __typename?: 'BatchChangeRequestsJobRunsAggregate';
  aggregate?: Maybe<BatchChangeRequestsJobRunsAggregateFields>;
  nodes: Array<BatchChangeRequestsJobRuns>;
};

export type BatchChangeRequestsJobRunsAggregateBoolExp = {
  count?: InputMaybe<BatchChangeRequestsJobRunsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsAggregateFields = {
  __typename?: 'BatchChangeRequestsJobRunsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchChangeRequestsJobRunsMaxFields>;
  min?: Maybe<BatchChangeRequestsJobRunsMinFields>;
};


/** aggregate fields of "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchChangeRequestsJobRunsMaxOrderBy>;
  min?: InputMaybe<BatchChangeRequestsJobRunsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BatchChangeRequestsJobRunsAppendInput = {
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsArrRelInsertInput = {
  data: Array<BatchChangeRequestsJobRunsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestsJobRunsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_change_requests_job_runs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobRunsBoolExp = {
  _and?: InputMaybe<Array<BatchChangeRequestsJobRunsBoolExp>>;
  _not?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
  _or?: InputMaybe<Array<BatchChangeRequestsJobRunsBoolExp>>;
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  batchChangeRequestsJobId?: InputMaybe<UuidComparisonExp>;
  changeRequests?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestsAggregate?: InputMaybe<ChangeRequestsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  mappingLog?: InputMaybe<JsonbComparisonExp>;
  s3LogPath?: InputMaybe<StringComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "batch_change_requests_job_runs" */
export const BatchChangeRequestsJobRunsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchChangeRequestsJobRunsPkey: 'batch_change_requests_job_runs_pkey'
} as const;

export type BatchChangeRequestsJobRunsConstraint = typeof BatchChangeRequestsJobRunsConstraint[keyof typeof BatchChangeRequestsJobRunsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BatchChangeRequestsJobRunsDeleteAtPathInput = {
  mappingLog?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BatchChangeRequestsJobRunsDeleteElemInput = {
  mappingLog?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BatchChangeRequestsJobRunsDeleteKeyInput = {
  mappingLog?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsInsertInput = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsObjRelInsertInput>;
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequests?: InputMaybe<ChangeRequestsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BatchChangeRequestsJobRunsMaxFields = {
  __typename?: 'BatchChangeRequestsJobRunsMaxFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsMaxOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchChangeRequestsJobRunsMinFields = {
  __typename?: 'BatchChangeRequestsJobRunsMinFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsMinOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsMutationResponse = {
  __typename?: 'BatchChangeRequestsJobRunsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchChangeRequestsJobRuns>;
};

/** input type for inserting object relation for remote table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsObjRelInsertInput = {
  data: BatchChangeRequestsJobRunsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestsJobRunsOnConflict>;
};

/** on_conflict condition type for table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsOnConflict = {
  constraint: BatchChangeRequestsJobRunsConstraint;
  updateColumns?: Array<BatchChangeRequestsJobRunsUpdateColumn>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};

/** Ordering options when selecting data from "batch_change_requests_job_runs". */
export type BatchChangeRequestsJobRunsOrderBy = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsOrderBy>;
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  changeRequestsAggregate?: InputMaybe<ChangeRequestsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  mappingLog?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_change_requests_job_runs */
export type BatchChangeRequestsJobRunsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BatchChangeRequestsJobRunsPrependInput = {
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "batch_change_requests_job_runs" */
export const BatchChangeRequestsJobRunsSelectColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  MappingLog: 'mappingLog',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchChangeRequestsJobRunsSelectColumn = typeof BatchChangeRequestsJobRunsSelectColumn[keyof typeof BatchChangeRequestsJobRunsSelectColumn];
/** input type for updating data in table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsSetInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "batch_change_requests_job_runs" */
export type BatchChangeRequestsJobRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchChangeRequestsJobRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchChangeRequestsJobRunsStreamCursorValueInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "batch_change_requests_job_runs" */
export const BatchChangeRequestsJobRunsUpdateColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  MappingLog: 'mappingLog',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchChangeRequestsJobRunsUpdateColumn = typeof BatchChangeRequestsJobRunsUpdateColumn[keyof typeof BatchChangeRequestsJobRunsUpdateColumn];
export type BatchChangeRequestsJobRunsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BatchChangeRequestsJobRunsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BatchChangeRequestsJobRunsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BatchChangeRequestsJobRunsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BatchChangeRequestsJobRunsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BatchChangeRequestsJobRunsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchChangeRequestsJobRunsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchChangeRequestsJobRunsBoolExp;
};

export type BatchChangeRequestsJobSubmitInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  dryRunOptions?: InputMaybe<DryRunOptions>;
  jobId: Scalars['UUID']['input'];
  logLevel?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobSubmitOutput = {
  __typename?: 'BatchChangeRequestsJobSubmitOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type BatchChangeRequestsJobSubmitResponse = BatchChangeRequestsJobSubmitOutput | ClientError;

export const BatchChangeRequestsJobType = {
  EntityComposer: 'entity_composer',
  RelationComposer: 'relation_composer',
  S3Script: 's3_script'
} as const;

export type BatchChangeRequestsJobType = typeof BatchChangeRequestsJobType[keyof typeof BatchChangeRequestsJobType];
export type BatchChangeRequestsJobUpdateInput = {
  id: Scalars['UUID']['input'];
  jobType: BatchChangeRequestsJobType;
  name?: InputMaybe<Scalars['String']['input']>;
  recordComposerDefinitionIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchChangeRequestsJobUpdateOutput = {
  __typename?: 'BatchChangeRequestsJobUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchChangeRequestsJobUpdateResponse = BatchChangeRequestsJobUpdateOutput | ValidationError;

/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobs = {
  __typename?: 'BatchChangeRequestsJobs';
  /** An array relationship */
  batchChangeRequestReviewsJobs: Array<BatchChangeRequestReviewsJobs>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobsAggregate: BatchChangeRequestReviewsJobsAggregate;
  /** An array relationship */
  batchChangeRequestsJobRecordComposerDefinitions: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An aggregate relationship */
  batchChangeRequestsJobRecordComposerDefinitionsAggregate: BatchChangeRequestsJobRecordComposerDefinitionsAggregate;
  /** An array relationship */
  batchChangeRequestsJobRuns: Array<BatchChangeRequestsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestsJobRunsAggregate: BatchChangeRequestsJobRunsAggregate;
  /** An array relationship */
  changeRequests: Array<ChangeRequests>;
  /** An aggregate relationship */
  changeRequestsAggregate: ChangeRequestsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  evidenceSet?: Maybe<EvidenceSets>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id: Scalars['uuid']['output'];
  jobTypeId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestReviewsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestReviewsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestsJobRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsBatchChangeRequestsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


/** columns and relationships of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};

/** aggregated selection of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsAggregate = {
  __typename?: 'BatchChangeRequestsJobsAggregate';
  aggregate?: Maybe<BatchChangeRequestsJobsAggregateFields>;
  nodes: Array<BatchChangeRequestsJobs>;
};

export type BatchChangeRequestsJobsAggregateBoolExp = {
  count?: InputMaybe<BatchChangeRequestsJobsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsAggregateFields = {
  __typename?: 'BatchChangeRequestsJobsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchChangeRequestsJobsMaxFields>;
  min?: Maybe<BatchChangeRequestsJobsMinFields>;
};


/** aggregate fields of "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchChangeRequestsJobsMaxOrderBy>;
  min?: InputMaybe<BatchChangeRequestsJobsMinOrderBy>;
};

/** input type for inserting array relation for remote table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsArrRelInsertInput = {
  data: Array<BatchChangeRequestsJobsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestsJobsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_change_requests_jobs". All fields are combined with a logical 'AND'. */
export type BatchChangeRequestsJobsBoolExp = {
  _and?: InputMaybe<Array<BatchChangeRequestsJobsBoolExp>>;
  _not?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  _or?: InputMaybe<Array<BatchChangeRequestsJobsBoolExp>>;
  batchChangeRequestReviewsJobs?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
  batchChangeRequestReviewsJobsAggregate?: InputMaybe<BatchChangeRequestReviewsJobsAggregateBoolExp>;
  batchChangeRequestsJobRecordComposerDefinitions?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp>;
  batchChangeRequestsJobRuns?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
  batchChangeRequestsJobRunsAggregate?: InputMaybe<BatchChangeRequestsJobRunsAggregateBoolExp>;
  changeRequests?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestsAggregate?: InputMaybe<ChangeRequestsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jobTypeId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  s3Path?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "batch_change_requests_jobs" */
export const BatchChangeRequestsJobsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchChangeRequestsJobsPkey: 'batch_change_requests_jobs_pkey'
} as const;

export type BatchChangeRequestsJobsConstraint = typeof BatchChangeRequestsJobsConstraint[keyof typeof BatchChangeRequestsJobsConstraint];
/** input type for inserting data into table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsInsertInput = {
  batchChangeRequestReviewsJobs?: InputMaybe<BatchChangeRequestReviewsJobsArrRelInsertInput>;
  batchChangeRequestsJobRecordComposerDefinitions?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsArrRelInsertInput>;
  batchChangeRequestsJobRuns?: InputMaybe<BatchChangeRequestsJobRunsArrRelInsertInput>;
  changeRequests?: InputMaybe<ChangeRequestsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BatchChangeRequestsJobsMaxFields = {
  __typename?: 'BatchChangeRequestsJobsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTypeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchChangeRequestsJobsMinFields = {
  __typename?: 'BatchChangeRequestsJobsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTypeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsMutationResponse = {
  __typename?: 'BatchChangeRequestsJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchChangeRequestsJobs>;
};

/** input type for inserting object relation for remote table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsObjRelInsertInput = {
  data: BatchChangeRequestsJobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchChangeRequestsJobsOnConflict>;
};

/** on_conflict condition type for table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsOnConflict = {
  constraint: BatchChangeRequestsJobsConstraint;
  updateColumns?: Array<BatchChangeRequestsJobsUpdateColumn>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};

/** Ordering options when selecting data from "batch_change_requests_jobs". */
export type BatchChangeRequestsJobsOrderBy = {
  batchChangeRequestReviewsJobsAggregate?: InputMaybe<BatchChangeRequestReviewsJobsAggregateOrderBy>;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateOrderBy>;
  batchChangeRequestsJobRunsAggregate?: InputMaybe<BatchChangeRequestsJobRunsAggregateOrderBy>;
  changeRequestsAggregate?: InputMaybe<ChangeRequestsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_change_requests_jobs */
export type BatchChangeRequestsJobsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "batch_change_requests_jobs" */
export const BatchChangeRequestsJobsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  JobTypeId: 'jobTypeId',
  /** column name */
  Name: 'name',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestsJobsSelectColumn = typeof BatchChangeRequestsJobsSelectColumn[keyof typeof BatchChangeRequestsJobsSelectColumn];
/** input type for updating data in table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "batch_change_requests_jobs" */
export type BatchChangeRequestsJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchChangeRequestsJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchChangeRequestsJobsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "batch_change_requests_jobs" */
export const BatchChangeRequestsJobsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  JobTypeId: 'jobTypeId',
  /** column name */
  Name: 'name',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchChangeRequestsJobsUpdateColumn = typeof BatchChangeRequestsJobsUpdateColumn[keyof typeof BatchChangeRequestsJobsUpdateColumn];
export type BatchChangeRequestsJobsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchChangeRequestsJobsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchChangeRequestsJobsBoolExp;
};

/** columns and relationships of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRuns = {
  __typename?: 'BatchEvidenceCommitsJobRuns';
  /** An object relationship */
  batchEvidenceCommitsJob: BatchEvidenceCommitsJobs;
  batchEvidenceCommitsJobId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  jobResult?: Maybe<Scalars['jsonb']['output']>;
  mapping: Scalars['jsonb']['output'];
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsJobResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsMappingArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsAggregate = {
  __typename?: 'BatchEvidenceCommitsJobRunsAggregate';
  aggregate?: Maybe<BatchEvidenceCommitsJobRunsAggregateFields>;
  nodes: Array<BatchEvidenceCommitsJobRuns>;
};

export type BatchEvidenceCommitsJobRunsAggregateBoolExp = {
  count?: InputMaybe<BatchEvidenceCommitsJobRunsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsAggregateFields = {
  __typename?: 'BatchEvidenceCommitsJobRunsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchEvidenceCommitsJobRunsMaxFields>;
  min?: Maybe<BatchEvidenceCommitsJobRunsMinFields>;
};


/** aggregate fields of "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchEvidenceCommitsJobRunsMaxOrderBy>;
  min?: InputMaybe<BatchEvidenceCommitsJobRunsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BatchEvidenceCommitsJobRunsAppendInput = {
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mapping?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsArrRelInsertInput = {
  data: Array<BatchEvidenceCommitsJobRunsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidenceCommitsJobRunsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_evidence_commits_job_runs". All fields are combined with a logical 'AND'. */
export type BatchEvidenceCommitsJobRunsBoolExp = {
  _and?: InputMaybe<Array<BatchEvidenceCommitsJobRunsBoolExp>>;
  _not?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
  _or?: InputMaybe<Array<BatchEvidenceCommitsJobRunsBoolExp>>;
  batchEvidenceCommitsJob?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
  batchEvidenceCommitsJobId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jobResult?: InputMaybe<JsonbComparisonExp>;
  mapping?: InputMaybe<JsonbComparisonExp>;
  s3LogPath?: InputMaybe<StringComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "batch_evidence_commits_job_runs" */
export const BatchEvidenceCommitsJobRunsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchEvidenceCommitsJobRunsPkey: 'batch_evidence_commits_job_runs_pkey'
} as const;

export type BatchEvidenceCommitsJobRunsConstraint = typeof BatchEvidenceCommitsJobRunsConstraint[keyof typeof BatchEvidenceCommitsJobRunsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BatchEvidenceCommitsJobRunsDeleteAtPathInput = {
  jobResult?: InputMaybe<Array<Scalars['String']['input']>>;
  mapping?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BatchEvidenceCommitsJobRunsDeleteElemInput = {
  jobResult?: InputMaybe<Scalars['Int']['input']>;
  mapping?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BatchEvidenceCommitsJobRunsDeleteKeyInput = {
  jobResult?: InputMaybe<Scalars['String']['input']>;
  mapping?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsInsertInput = {
  batchEvidenceCommitsJob?: InputMaybe<BatchEvidenceCommitsJobsObjRelInsertInput>;
  batchEvidenceCommitsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mapping?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BatchEvidenceCommitsJobRunsMaxFields = {
  __typename?: 'BatchEvidenceCommitsJobRunsMaxFields';
  batchEvidenceCommitsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsMaxOrderBy = {
  batchEvidenceCommitsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchEvidenceCommitsJobRunsMinFields = {
  __typename?: 'BatchEvidenceCommitsJobRunsMinFields';
  batchEvidenceCommitsJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsMinOrderBy = {
  batchEvidenceCommitsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsMutationResponse = {
  __typename?: 'BatchEvidenceCommitsJobRunsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchEvidenceCommitsJobRuns>;
};

/** on_conflict condition type for table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsOnConflict = {
  constraint: BatchEvidenceCommitsJobRunsConstraint;
  updateColumns?: Array<BatchEvidenceCommitsJobRunsUpdateColumn>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};

/** Ordering options when selecting data from "batch_evidence_commits_job_runs". */
export type BatchEvidenceCommitsJobRunsOrderBy = {
  batchEvidenceCommitsJob?: InputMaybe<BatchEvidenceCommitsJobsOrderBy>;
  batchEvidenceCommitsJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobResult?: InputMaybe<OrderBy>;
  mapping?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_evidence_commits_job_runs */
export type BatchEvidenceCommitsJobRunsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BatchEvidenceCommitsJobRunsPrependInput = {
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mapping?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "batch_evidence_commits_job_runs" */
export const BatchEvidenceCommitsJobRunsSelectColumn = {
  /** column name */
  BatchEvidenceCommitsJobId: 'batchEvidenceCommitsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  JobResult: 'jobResult',
  /** column name */
  Mapping: 'mapping',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchEvidenceCommitsJobRunsSelectColumn = typeof BatchEvidenceCommitsJobRunsSelectColumn[keyof typeof BatchEvidenceCommitsJobRunsSelectColumn];
/** input type for updating data in table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsSetInput = {
  batchEvidenceCommitsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mapping?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "batch_evidence_commits_job_runs" */
export type BatchEvidenceCommitsJobRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchEvidenceCommitsJobRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchEvidenceCommitsJobRunsStreamCursorValueInput = {
  batchEvidenceCommitsJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mapping?: InputMaybe<Scalars['jsonb']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "batch_evidence_commits_job_runs" */
export const BatchEvidenceCommitsJobRunsUpdateColumn = {
  /** column name */
  BatchEvidenceCommitsJobId: 'batchEvidenceCommitsJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  JobResult: 'jobResult',
  /** column name */
  Mapping: 'mapping',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchEvidenceCommitsJobRunsUpdateColumn = typeof BatchEvidenceCommitsJobRunsUpdateColumn[keyof typeof BatchEvidenceCommitsJobRunsUpdateColumn];
export type BatchEvidenceCommitsJobRunsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BatchEvidenceCommitsJobRunsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BatchEvidenceCommitsJobRunsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchEvidenceCommitsJobRunsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchEvidenceCommitsJobRunsBoolExp;
};

export type BatchEvidenceCommitsJobSubmitInput = {
  batchEvidencesJobId: Scalars['UUID']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidenceCommitsJobSubmitOutput = {
  __typename?: 'BatchEvidenceCommitsJobSubmitOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type BatchEvidenceCommitsJobSubmitResponse = BatchEvidenceCommitsJobSubmitOutput | ValidationError;

/** columns and relationships of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobs = {
  __typename?: 'BatchEvidenceCommitsJobs';
  /** An array relationship */
  batchEvidenceCommitsJobRuns: Array<BatchEvidenceCommitsJobRuns>;
  /** An aggregate relationship */
  batchEvidenceCommitsJobRunsAggregate: BatchEvidenceCommitsJobRunsAggregate;
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsBatchEvidenceCommitsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


/** columns and relationships of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsBatchEvidenceCommitsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};

/** aggregated selection of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsAggregate = {
  __typename?: 'BatchEvidenceCommitsJobsAggregate';
  aggregate?: Maybe<BatchEvidenceCommitsJobsAggregateFields>;
  nodes: Array<BatchEvidenceCommitsJobs>;
};

/** aggregate fields of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsAggregateFields = {
  __typename?: 'BatchEvidenceCommitsJobsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchEvidenceCommitsJobsMaxFields>;
  min?: Maybe<BatchEvidenceCommitsJobsMinFields>;
};


/** aggregate fields of "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchEvidenceCommitsJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "batch_evidence_commits_jobs". All fields are combined with a logical 'AND'. */
export type BatchEvidenceCommitsJobsBoolExp = {
  _and?: InputMaybe<Array<BatchEvidenceCommitsJobsBoolExp>>;
  _not?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
  _or?: InputMaybe<Array<BatchEvidenceCommitsJobsBoolExp>>;
  batchEvidenceCommitsJobRuns?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
  batchEvidenceCommitsJobRunsAggregate?: InputMaybe<BatchEvidenceCommitsJobRunsAggregateBoolExp>;
  batchEvidencesJobId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "batch_evidence_commits_jobs" */
export const BatchEvidenceCommitsJobsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchEvidenceCommitsJobsPkey: 'batch_evidence_commits_jobs_pkey'
} as const;

export type BatchEvidenceCommitsJobsConstraint = typeof BatchEvidenceCommitsJobsConstraint[keyof typeof BatchEvidenceCommitsJobsConstraint];
/** input type for inserting data into table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsInsertInput = {
  batchEvidenceCommitsJobRuns?: InputMaybe<BatchEvidenceCommitsJobRunsArrRelInsertInput>;
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BatchEvidenceCommitsJobsMaxFields = {
  __typename?: 'BatchEvidenceCommitsJobsMaxFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type BatchEvidenceCommitsJobsMinFields = {
  __typename?: 'BatchEvidenceCommitsJobsMinFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsMutationResponse = {
  __typename?: 'BatchEvidenceCommitsJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchEvidenceCommitsJobs>;
};

/** input type for inserting object relation for remote table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsObjRelInsertInput = {
  data: BatchEvidenceCommitsJobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidenceCommitsJobsOnConflict>;
};

/** on_conflict condition type for table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsOnConflict = {
  constraint: BatchEvidenceCommitsJobsConstraint;
  updateColumns?: Array<BatchEvidenceCommitsJobsUpdateColumn>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};

/** Ordering options when selecting data from "batch_evidence_commits_jobs". */
export type BatchEvidenceCommitsJobsOrderBy = {
  batchEvidenceCommitsJobRunsAggregate?: InputMaybe<BatchEvidenceCommitsJobRunsAggregateOrderBy>;
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_evidence_commits_jobs */
export type BatchEvidenceCommitsJobsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "batch_evidence_commits_jobs" */
export const BatchEvidenceCommitsJobsSelectColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchEvidenceCommitsJobsSelectColumn = typeof BatchEvidenceCommitsJobsSelectColumn[keyof typeof BatchEvidenceCommitsJobsSelectColumn];
/** input type for updating data in table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsSetInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "batch_evidence_commits_jobs" */
export type BatchEvidenceCommitsJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchEvidenceCommitsJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchEvidenceCommitsJobsStreamCursorValueInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "batch_evidence_commits_jobs" */
export const BatchEvidenceCommitsJobsUpdateColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchEvidenceCommitsJobsUpdateColumn = typeof BatchEvidenceCommitsJobsUpdateColumn[keyof typeof BatchEvidenceCommitsJobsUpdateColumn];
export type BatchEvidenceCommitsJobsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchEvidenceCommitsJobsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchEvidenceCommitsJobsBoolExp;
};

export type BatchEvidencesJobActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobActivateOutput = {
  __typename?: 'BatchEvidencesJobActivateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchEvidencesJobCreateInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  dataSourceId: Scalars['UUID']['input'];
  evidenceImporterId?: InputMaybe<Scalars['UUID']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobCreateOutput = {
  __typename?: 'BatchEvidencesJobCreateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchEvidencesJobCreateResponse = BatchEvidencesJobCreateOutput | ValidationError;

export type BatchEvidencesJobDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobDeactivateOutput = {
  __typename?: 'BatchEvidencesJobDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchEvidencesJobExportDryRunResultInput = {
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobGetDryRunResultInput = {
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobRunUpdateInput = {
  id: Scalars['UUID']['input'];
  status: JobRunStatus;
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobRunUpdateOutput = {
  __typename?: 'BatchEvidencesJobRunUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "batch_evidences_job_runs" */
export type BatchEvidencesJobRuns = {
  __typename?: 'BatchEvidencesJobRuns';
  /** An object relationship */
  batchEvidencesJob: BatchEvidencesJobs;
  batchEvidencesJobId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  id: Scalars['uuid']['output'];
  jobResult?: Maybe<Scalars['jsonb']['output']>;
  mappingLog: Scalars['jsonb']['output'];
  outputMode: Scalars['String']['output'];
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsJobResultArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMappingLogArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsAggregate = {
  __typename?: 'BatchEvidencesJobRunsAggregate';
  aggregate?: Maybe<BatchEvidencesJobRunsAggregateFields>;
  nodes: Array<BatchEvidencesJobRuns>;
};

export type BatchEvidencesJobRunsAggregateBoolExp = {
  count?: InputMaybe<BatchEvidencesJobRunsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsAggregateFields = {
  __typename?: 'BatchEvidencesJobRunsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchEvidencesJobRunsMaxFields>;
  min?: Maybe<BatchEvidencesJobRunsMinFields>;
};


/** aggregate fields of "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchEvidencesJobRunsMaxOrderBy>;
  min?: InputMaybe<BatchEvidencesJobRunsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type BatchEvidencesJobRunsAppendInput = {
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsArrRelInsertInput = {
  data: Array<BatchEvidencesJobRunsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidencesJobRunsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_evidences_job_runs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobRunsBoolExp = {
  _and?: InputMaybe<Array<BatchEvidencesJobRunsBoolExp>>;
  _not?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
  _or?: InputMaybe<Array<BatchEvidencesJobRunsBoolExp>>;
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidences?: InputMaybe<EvidencesBoolExp>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jobResult?: InputMaybe<JsonbComparisonExp>;
  mappingLog?: InputMaybe<JsonbComparisonExp>;
  outputMode?: InputMaybe<StringComparisonExp>;
  s3LogPath?: InputMaybe<StringComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "batch_evidences_job_runs" */
export const BatchEvidencesJobRunsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchEvidencesJobRunsPkey: 'batch_evidences_job_runs_pkey'
} as const;

export type BatchEvidencesJobRunsConstraint = typeof BatchEvidencesJobRunsConstraint[keyof typeof BatchEvidencesJobRunsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type BatchEvidencesJobRunsDeleteAtPathInput = {
  jobResult?: InputMaybe<Array<Scalars['String']['input']>>;
  mappingLog?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type BatchEvidencesJobRunsDeleteElemInput = {
  jobResult?: InputMaybe<Scalars['Int']['input']>;
  mappingLog?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type BatchEvidencesJobRunsDeleteKeyInput = {
  jobResult?: InputMaybe<Scalars['String']['input']>;
  mappingLog?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsInsertInput = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsObjRelInsertInput>;
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidences?: InputMaybe<EvidencesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  outputMode?: InputMaybe<Scalars['String']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type BatchEvidencesJobRunsMaxFields = {
  __typename?: 'BatchEvidencesJobRunsMaxFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  outputMode?: Maybe<Scalars['String']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMaxOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  outputMode?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchEvidencesJobRunsMinFields = {
  __typename?: 'BatchEvidencesJobRunsMinFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  outputMode?: Maybe<Scalars['String']['output']>;
  s3LogPath?: Maybe<Scalars['String']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMinOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  outputMode?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsMutationResponse = {
  __typename?: 'BatchEvidencesJobRunsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchEvidencesJobRuns>;
};

/** input type for inserting object relation for remote table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsObjRelInsertInput = {
  data: BatchEvidencesJobRunsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidencesJobRunsOnConflict>;
};

/** on_conflict condition type for table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsOnConflict = {
  constraint: BatchEvidencesJobRunsConstraint;
  updateColumns?: Array<BatchEvidencesJobRunsUpdateColumn>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};

/** Ordering options when selecting data from "batch_evidences_job_runs". */
export type BatchEvidencesJobRunsOrderBy = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsOrderBy>;
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  jobResult?: InputMaybe<OrderBy>;
  mappingLog?: InputMaybe<OrderBy>;
  outputMode?: InputMaybe<OrderBy>;
  s3LogPath?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_evidences_job_runs */
export type BatchEvidencesJobRunsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type BatchEvidencesJobRunsPrependInput = {
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "batch_evidences_job_runs" */
export const BatchEvidencesJobRunsSelectColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  JobResult: 'jobResult',
  /** column name */
  MappingLog: 'mappingLog',
  /** column name */
  OutputMode: 'outputMode',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchEvidencesJobRunsSelectColumn = typeof BatchEvidencesJobRunsSelectColumn[keyof typeof BatchEvidencesJobRunsSelectColumn];
/** input type for updating data in table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsSetInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  outputMode?: InputMaybe<Scalars['String']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "batch_evidences_job_runs" */
export type BatchEvidencesJobRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchEvidencesJobRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchEvidencesJobRunsStreamCursorValueInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobResult?: InputMaybe<Scalars['jsonb']['input']>;
  mappingLog?: InputMaybe<Scalars['jsonb']['input']>;
  outputMode?: InputMaybe<Scalars['String']['input']>;
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "batch_evidences_job_runs" */
export const BatchEvidencesJobRunsUpdateColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  JobResult: 'jobResult',
  /** column name */
  MappingLog: 'mappingLog',
  /** column name */
  OutputMode: 'outputMode',
  /** column name */
  S3LogPath: 's3LogPath',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type BatchEvidencesJobRunsUpdateColumn = typeof BatchEvidencesJobRunsUpdateColumn[keyof typeof BatchEvidencesJobRunsUpdateColumn];
export type BatchEvidencesJobRunsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<BatchEvidencesJobRunsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<BatchEvidencesJobRunsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<BatchEvidencesJobRunsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<BatchEvidencesJobRunsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<BatchEvidencesJobRunsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchEvidencesJobRunsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchEvidencesJobRunsBoolExp;
};

export type BatchEvidencesJobSubmitInput = {
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  dryRunOptions?: InputMaybe<DryRunOptions>;
  jobId: Scalars['UUID']['input'];
  logLevel?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobSubmitOutput = {
  __typename?: 'BatchEvidencesJobSubmitOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type BatchEvidencesJobSubmitResponse = BatchEvidencesJobSubmitOutput | ClientError;

export type BatchEvidencesJobUpdateInput = {
  evidenceImporterId?: InputMaybe<Scalars['UUID']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type BatchEvidencesJobUpdateOutput = {
  __typename?: 'BatchEvidencesJobUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type BatchEvidencesJobUpdateResponse = BatchEvidencesJobUpdateOutput | ValidationError;

/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobs = {
  __typename?: 'BatchEvidencesJobs';
  /** An array relationship */
  batchEvidencesJobRuns: Array<BatchEvidencesJobRuns>;
  /** An aggregate relationship */
  batchEvidencesJobRunsAggregate: BatchEvidencesJobRunsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  evidenceImporter?: Maybe<EvidenceImporters>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  id: Scalars['uuid']['output'];
  jobTypeId: Scalars['String']['output'];
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  /** An array relationship */
  unifiedEvidenceDrafts: Array<UnifiedEvidenceDrafts>;
  /** An aggregate relationship */
  unifiedEvidenceDraftsAggregate: UnifiedEvidenceDraftsAggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsBatchEvidencesJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsBatchEvidencesJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsUnifiedEvidenceDraftsArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


/** columns and relationships of "batch_evidences_jobs" */
export type BatchEvidencesJobsUnifiedEvidenceDraftsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};

/** aggregated selection of "batch_evidences_jobs" */
export type BatchEvidencesJobsAggregate = {
  __typename?: 'BatchEvidencesJobsAggregate';
  aggregate?: Maybe<BatchEvidencesJobsAggregateFields>;
  nodes: Array<BatchEvidencesJobs>;
};

export type BatchEvidencesJobsAggregateBoolExp = {
  count?: InputMaybe<BatchEvidencesJobsAggregateBoolExpCount>;
};

/** aggregate fields of "batch_evidences_jobs" */
export type BatchEvidencesJobsAggregateFields = {
  __typename?: 'BatchEvidencesJobsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<BatchEvidencesJobsMaxFields>;
  min?: Maybe<BatchEvidencesJobsMinFields>;
};


/** aggregate fields of "batch_evidences_jobs" */
export type BatchEvidencesJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "batch_evidences_jobs" */
export type BatchEvidencesJobsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<BatchEvidencesJobsMaxOrderBy>;
  min?: InputMaybe<BatchEvidencesJobsMinOrderBy>;
};

/** input type for inserting array relation for remote table "batch_evidences_jobs" */
export type BatchEvidencesJobsArrRelInsertInput = {
  data: Array<BatchEvidencesJobsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidencesJobsOnConflict>;
};

/** Boolean expression to filter rows from the table "batch_evidences_jobs". All fields are combined with a logical 'AND'. */
export type BatchEvidencesJobsBoolExp = {
  _and?: InputMaybe<Array<BatchEvidencesJobsBoolExp>>;
  _not?: InputMaybe<BatchEvidencesJobsBoolExp>;
  _or?: InputMaybe<Array<BatchEvidencesJobsBoolExp>>;
  batchEvidencesJobRuns?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
  batchEvidencesJobRunsAggregate?: InputMaybe<BatchEvidencesJobRunsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceImporter?: InputMaybe<EvidenceImportersBoolExp>;
  evidenceImporterId?: InputMaybe<UuidComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  evidences?: InputMaybe<EvidencesBoolExp>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jobTypeId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  s3Path?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  unifiedEvidenceDrafts?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
  unifiedEvidenceDraftsAggregate?: InputMaybe<UnifiedEvidenceDraftsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "batch_evidences_jobs" */
export const BatchEvidencesJobsConstraint = {
  /** unique or primary key constraint on columns "id" */
  BatchEvidencesJobsPkey: 'batch_evidences_jobs_pkey'
} as const;

export type BatchEvidencesJobsConstraint = typeof BatchEvidencesJobsConstraint[keyof typeof BatchEvidencesJobsConstraint];
/** input type for inserting data into table "batch_evidences_jobs" */
export type BatchEvidencesJobsInsertInput = {
  batchEvidencesJobRuns?: InputMaybe<BatchEvidencesJobRunsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceImporter?: InputMaybe<EvidenceImportersObjRelInsertInput>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  evidences?: InputMaybe<EvidencesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  unifiedEvidenceDrafts?: InputMaybe<UnifiedEvidenceDraftsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type BatchEvidencesJobsMaxFields = {
  __typename?: 'BatchEvidencesJobsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTypeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type BatchEvidencesJobsMinFields = {
  __typename?: 'BatchEvidencesJobsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobTypeId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "batch_evidences_jobs" */
export type BatchEvidencesJobsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "batch_evidences_jobs" */
export type BatchEvidencesJobsMutationResponse = {
  __typename?: 'BatchEvidencesJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<BatchEvidencesJobs>;
};

/** input type for inserting object relation for remote table "batch_evidences_jobs" */
export type BatchEvidencesJobsObjRelInsertInput = {
  data: BatchEvidencesJobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<BatchEvidencesJobsOnConflict>;
};

/** on_conflict condition type for table "batch_evidences_jobs" */
export type BatchEvidencesJobsOnConflict = {
  constraint: BatchEvidencesJobsConstraint;
  updateColumns?: Array<BatchEvidencesJobsUpdateColumn>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};

/** Ordering options when selecting data from "batch_evidences_jobs". */
export type BatchEvidencesJobsOrderBy = {
  batchEvidencesJobRunsAggregate?: InputMaybe<BatchEvidencesJobRunsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceImporter?: InputMaybe<EvidenceImportersOrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  jobTypeId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  unifiedEvidenceDraftsAggregate?: InputMaybe<UnifiedEvidenceDraftsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: batch_evidences_jobs */
export type BatchEvidencesJobsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "batch_evidences_jobs" */
export const BatchEvidencesJobsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  JobTypeId: 'jobTypeId',
  /** column name */
  Name: 'name',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchEvidencesJobsSelectColumn = typeof BatchEvidencesJobsSelectColumn[keyof typeof BatchEvidencesJobsSelectColumn];
/** input type for updating data in table "batch_evidences_jobs" */
export type BatchEvidencesJobsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "batch_evidences_jobs" */
export type BatchEvidencesJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: BatchEvidencesJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type BatchEvidencesJobsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobTypeId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "batch_evidences_jobs" */
export const BatchEvidencesJobsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  JobTypeId: 'jobTypeId',
  /** column name */
  Name: 'name',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type BatchEvidencesJobsUpdateColumn = typeof BatchEvidencesJobsUpdateColumn[keyof typeof BatchEvidencesJobsUpdateColumn];
export type BatchEvidencesJobsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<BatchEvidencesJobsSetInput>;
  /** filter the rows which have to be updated */
  where: BatchEvidencesJobsBoolExp;
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type BooleanComparisonExp = {
  _eq?: InputMaybe<Scalars['Boolean']['input']>;
  _gt?: InputMaybe<Scalars['Boolean']['input']>;
  _gte?: InputMaybe<Scalars['Boolean']['input']>;
  _in?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Boolean']['input']>;
  _lte?: InputMaybe<Scalars['Boolean']['input']>;
  _neq?: InputMaybe<Scalars['Boolean']['input']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type BootstrapDataImportProjectV2DataSourceInput = {
  dataSource: DataSourceInImportProjectCreateInput;
  schemaMappings: Array<BootstrapDataImportProjectV2DataSourceSchemaMappingInput>;
};

export type BootstrapDataImportProjectV2DataSourceSchemaMappingInput = {
  categoryId: Scalars['UUID']['input'];
  categoryPropertyName?: InputMaybe<Scalars['String']['input']>;
  dataSourcePropertyLabel?: InputMaybe<Scalars['String']['input']>;
  fkResolver?: InputMaybe<SetupDataImportJobsSchemaMappingForeignKeyResolver>;
  type: SetupDataImportJobsSchemaMappingType;
  /**
   * Literal variantKey for this mapping's output slot. When a category is mapped more than once in one
   * data source, distinct variantKeys keep the slots as distinct composers (and distinct
   * evidence-lineage identities) instead of collapsing into one merged record. Must match
   * [A-Za-z0-9_-]+. Omitted mappings group together under the default key (today's behavior).
   */
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

export type BootstrapDataImportProjectV2Input = {
  dataImportProjectId: Scalars['UUID']['input'];
  dataSources: Array<BootstrapDataImportProjectV2DataSourceInput>;
  tenantId: Scalars['UUID']['input'];
};

export type BootstrapDataImportProjectV2Output = {
  __typename?: 'BootstrapDataImportProjectV2Output';
  batchChangeRequestsJobIds: Array<Scalars['UUID']['output']>;
  batchEvidencesJobIds: Array<Scalars['UUID']['output']>;
  dataImportProjectId: Scalars['UUID']['output'];
  dataSourceIds: Array<Scalars['UUID']['output']>;
};

export type BootstrapDataImportProjectV2Response = BootstrapDataImportProjectV2Output | ClientError | ValidationError;

export type BulkCreateUsersFromFileInput = {
  file: Scalars['Upload']['input'];
};

export type BulkCreateUsersOutput = {
  __typename?: 'BulkCreateUsersOutput';
  failedUsers: Array<BulkUserCreationFailure>;
  failureCount: Scalars['Int']['output'];
  successCount: Scalars['Int']['output'];
  successfulUsers: Array<BulkUserCreationSuccess>;
  totalProcessed: Scalars['Int']['output'];
};

export type BulkUserCreationFailure = {
  __typename?: 'BulkUserCreationFailure';
  email?: Maybe<Scalars['String']['output']>;
  error: Scalars['String']['output'];
  rowNumber: Scalars['Int']['output'];
  savedUserId?: Maybe<Scalars['UUID']['output']>;
};

export type BulkUserCreationSuccess = {
  __typename?: 'BulkUserCreationSuccess';
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

/** columns and relationships of "categories" */
export type Categories = {
  __typename?: 'Categories';
  /** An object relationship */
  categoryPath?: Maybe<CategoryPaths>;
  /** An array relationship */
  categoryPropertySchemaSet: Array<CategoryPropertySchemaSets>;
  /** An aggregate relationship */
  categoryPropertySchemaSetAggregate: CategoryPropertySchemaSetsAggregate;
  /** An object relationship */
  categoryType: CategoryTypes;
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  i18nLabel: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  recordMetadataCategories: Array<RecordMetadataCategories>;
  /** An aggregate relationship */
  recordMetadataCategoriesAggregate: RecordMetadataCategoriesAggregate;
  /** An object relationship */
  relationType?: Maybe<RelationTypes>;
  relationTypeId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  sourceRelationTypes: Array<RelationTypes>;
  /** An aggregate relationship */
  sourceRelationTypesAggregate: RelationTypesAggregate;
  /** An array relationship */
  targetRelationTypes: Array<RelationTypes>;
  /** An aggregate relationship */
  targetRelationTypesAggregate: RelationTypesAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  typeId: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "categories" */
export type CategoriesCategoryPropertySchemaSetArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesCategoryPropertySchemaSetAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesI18nLabelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "categories" */
export type CategoriesRecordMetadataCategoriesArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesRecordMetadataCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesSourceRelationTypesArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesSourceRelationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesTargetRelationTypesArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


/** columns and relationships of "categories" */
export type CategoriesTargetRelationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};

/** aggregated selection of "categories" */
export type CategoriesAggregate = {
  __typename?: 'CategoriesAggregate';
  aggregate?: Maybe<CategoriesAggregateFields>;
  nodes: Array<Categories>;
};

export type CategoriesAggregateBoolExp = {
  count?: InputMaybe<CategoriesAggregateBoolExpCount>;
};

/** aggregate fields of "categories" */
export type CategoriesAggregateFields = {
  __typename?: 'CategoriesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CategoriesMaxFields>;
  min?: Maybe<CategoriesMinFields>;
};


/** aggregate fields of "categories" */
export type CategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "categories" */
export type CategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CategoriesMaxOrderBy>;
  min?: InputMaybe<CategoriesMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CategoriesAppendInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "categories" */
export type CategoriesArrRelInsertInput = {
  data: Array<CategoriesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "categories". All fields are combined with a logical 'AND'. */
export type CategoriesBoolExp = {
  _and?: InputMaybe<Array<CategoriesBoolExp>>;
  _not?: InputMaybe<CategoriesBoolExp>;
  _or?: InputMaybe<Array<CategoriesBoolExp>>;
  categoryPath?: InputMaybe<CategoryPathsBoolExp>;
  categoryPropertySchemaSet?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
  categoryPropertySchemaSetAggregate?: InputMaybe<CategoryPropertySchemaSetsAggregateBoolExp>;
  categoryType?: InputMaybe<CategoryTypesBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  documentUrl?: InputMaybe<StringComparisonExp>;
  i18nLabel?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  recordMetadataCategories?: InputMaybe<RecordMetadataCategoriesBoolExp>;
  recordMetadataCategoriesAggregate?: InputMaybe<RecordMetadataCategoriesAggregateBoolExp>;
  relationType?: InputMaybe<RelationTypesBoolExp>;
  relationTypeId?: InputMaybe<UuidComparisonExp>;
  sourceRelationTypes?: InputMaybe<RelationTypesBoolExp>;
  sourceRelationTypesAggregate?: InputMaybe<RelationTypesAggregateBoolExp>;
  targetRelationTypes?: InputMaybe<RelationTypesBoolExp>;
  targetRelationTypesAggregate?: InputMaybe<RelationTypesAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  typeId?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "categories" */
export const CategoriesConstraint = {
  /** unique or primary key constraint on columns "name" */
  CategoriesNameKey: 'categories_name_key',
  /** unique or primary key constraint on columns "id" */
  CategoriesPkey: 'categories_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  CategoriesTenantIdIdKey: 'categories_tenant_id_id_key'
} as const;

export type CategoriesConstraint = typeof CategoriesConstraint[keyof typeof CategoriesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CategoriesDeleteAtPathInput = {
  i18nLabel?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CategoriesDeleteElemInput = {
  i18nLabel?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CategoriesDeleteKeyInput = {
  i18nLabel?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "categories" */
export type CategoriesInsertInput = {
  categoryPath?: InputMaybe<CategoryPathsObjRelInsertInput>;
  categoryPropertySchemaSet?: InputMaybe<CategoryPropertySchemaSetsArrRelInsertInput>;
  categoryType?: InputMaybe<CategoryTypesObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordMetadataCategories?: InputMaybe<RecordMetadataCategoriesArrRelInsertInput>;
  relationType?: InputMaybe<RelationTypesObjRelInsertInput>;
  relationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRelationTypes?: InputMaybe<RelationTypesArrRelInsertInput>;
  targetRelationTypes?: InputMaybe<RelationTypesArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CategoriesMaxFields = {
  __typename?: 'CategoriesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relationTypeId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "categories" */
export type CategoriesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  documentUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  relationTypeId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  typeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CategoriesMinFields = {
  __typename?: 'CategoriesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  relationTypeId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "categories" */
export type CategoriesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  documentUrl?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  relationTypeId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  typeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "categories" */
export type CategoriesMutationResponse = {
  __typename?: 'CategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Categories>;
};

/** input type for inserting object relation for remote table "categories" */
export type CategoriesObjRelInsertInput = {
  data: CategoriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CategoriesOnConflict>;
};

/** on_conflict condition type for table "categories" */
export type CategoriesOnConflict = {
  constraint: CategoriesConstraint;
  updateColumns?: Array<CategoriesUpdateColumn>;
  where?: InputMaybe<CategoriesBoolExp>;
};

/** Ordering options when selecting data from "categories". */
export type CategoriesOrderBy = {
  categoryPath?: InputMaybe<CategoryPathsOrderBy>;
  categoryPropertySchemaSetAggregate?: InputMaybe<CategoryPropertySchemaSetsAggregateOrderBy>;
  categoryType?: InputMaybe<CategoryTypesOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  documentUrl?: InputMaybe<OrderBy>;
  i18nLabel?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  recordMetadataCategoriesAggregate?: InputMaybe<RecordMetadataCategoriesAggregateOrderBy>;
  relationType?: InputMaybe<RelationTypesOrderBy>;
  relationTypeId?: InputMaybe<OrderBy>;
  sourceRelationTypesAggregate?: InputMaybe<RelationTypesAggregateOrderBy>;
  targetRelationTypesAggregate?: InputMaybe<RelationTypesAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  typeId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: categories */
export type CategoriesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CategoriesPrependInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "categories" */
export const CategoriesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  RelationTypeId: 'relationTypeId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  TypeId: 'typeId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoriesSelectColumn = typeof CategoriesSelectColumn[keyof typeof CategoriesSelectColumn];
/** input type for updating data in table "categories" */
export type CategoriesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "categories" */
export type CategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoriesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  relationTypeId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "categories" */
export const CategoriesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  RelationTypeId: 'relationTypeId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  TypeId: 'typeId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoriesUpdateColumn = typeof CategoriesUpdateColumn[keyof typeof CategoriesUpdateColumn];
export type CategoriesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CategoriesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CategoriesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CategoriesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CategoriesDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CategoriesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: CategoriesBoolExp;
};

export type CategoryActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CategoryActivateOutput = {
  __typename?: 'CategoryActivateOutput';
  id: Scalars['UUID']['output'];
};

export type CategoryDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CategoryDeactivateOutput = {
  __typename?: 'CategoryDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type CategoryDeactivateResponse = CategoryDeactivateOutput | ValidationError;

export type CategoryListItem = {
  __typename?: 'CategoryListItem';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  titlePropertyName?: Maybe<Scalars['String']['output']>;
  typeId: Scalars['String']['output'];
};

export type CategoryPathInput = {
  path: Scalars['String']['input'];
};

/** columns and relationships of "category_paths" */
export type CategoryPaths = {
  __typename?: 'CategoryPaths';
  /** An object relationship */
  category: Categories;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  path: Scalars['ltree']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "category_paths" */
export type CategoryPathsAggregate = {
  __typename?: 'CategoryPathsAggregate';
  aggregate?: Maybe<CategoryPathsAggregateFields>;
  nodes: Array<CategoryPaths>;
};

/** aggregate fields of "category_paths" */
export type CategoryPathsAggregateFields = {
  __typename?: 'CategoryPathsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CategoryPathsMaxFields>;
  min?: Maybe<CategoryPathsMinFields>;
};


/** aggregate fields of "category_paths" */
export type CategoryPathsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CategoryPathsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "category_paths". All fields are combined with a logical 'AND'. */
export type CategoryPathsBoolExp = {
  _and?: InputMaybe<Array<CategoryPathsBoolExp>>;
  _not?: InputMaybe<CategoryPathsBoolExp>;
  _or?: InputMaybe<Array<CategoryPathsBoolExp>>;
  category?: InputMaybe<CategoriesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  path?: InputMaybe<LtreeComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "category_paths" */
export const CategoryPathsConstraint = {
  /** unique or primary key constraint on columns "path" */
  CategoryPathsPathKey: 'category_paths_path_key',
  /** unique or primary key constraint on columns "category_id" */
  CategoryPathsPkey: 'category_paths_pkey'
} as const;

export type CategoryPathsConstraint = typeof CategoryPathsConstraint[keyof typeof CategoryPathsConstraint];
/** input type for inserting data into table "category_paths" */
export type CategoryPathsInsertInput = {
  category?: InputMaybe<CategoriesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  path?: InputMaybe<Scalars['ltree']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CategoryPathsMaxFields = {
  __typename?: 'CategoryPathsMaxFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  path?: Maybe<Scalars['ltree']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CategoryPathsMinFields = {
  __typename?: 'CategoryPathsMinFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  path?: Maybe<Scalars['ltree']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "category_paths" */
export type CategoryPathsMutationResponse = {
  __typename?: 'CategoryPathsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CategoryPaths>;
};

/** input type for inserting object relation for remote table "category_paths" */
export type CategoryPathsObjRelInsertInput = {
  data: CategoryPathsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CategoryPathsOnConflict>;
};

/** on_conflict condition type for table "category_paths" */
export type CategoryPathsOnConflict = {
  constraint: CategoryPathsConstraint;
  updateColumns?: Array<CategoryPathsUpdateColumn>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};

/** Ordering options when selecting data from "category_paths". */
export type CategoryPathsOrderBy = {
  category?: InputMaybe<CategoriesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  path?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: category_paths */
export type CategoryPathsPkColumnsInput = {
  categoryId: Scalars['uuid']['input'];
};

/** select columns of table "category_paths" */
export const CategoryPathsSelectColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Path: 'path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryPathsSelectColumn = typeof CategoryPathsSelectColumn[keyof typeof CategoryPathsSelectColumn];
/** input type for updating data in table "category_paths" */
export type CategoryPathsSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  path?: InputMaybe<Scalars['ltree']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "category_paths" */
export type CategoryPathsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CategoryPathsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoryPathsStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  path?: InputMaybe<Scalars['ltree']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "category_paths" */
export const CategoryPathsUpdateColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Path: 'path',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryPathsUpdateColumn = typeof CategoryPathsUpdateColumn[keyof typeof CategoryPathsUpdateColumn];
export type CategoryPathsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CategoryPathsSetInput>;
  /** filter the rows which have to be updated */
  where: CategoryPathsBoolExp;
};

export type CategoryPropertySchemaItem = {
  __typename?: 'CategoryPropertySchemaItem';
  attributeType?: Maybe<PropertyAttributeTypeId>;
  description?: Maybe<Scalars['String']['output']>;
  label: Scalars['JSONObject']['output'];
  metadataKey: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  required?: Maybe<Scalars['Boolean']['output']>;
  selectOptions?: Maybe<Array<PropertySelectOption>>;
  type: PropertySchemaType;
};

/** columns and relationships of "category_property_schema_sets" */
export type CategoryPropertySchemaSets = {
  __typename?: 'CategoryPropertySchemaSets';
  /** An object relationship */
  category: Categories;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "category_property_schema_sets" */
export type CategoryPropertySchemaSetsAggregate = {
  __typename?: 'CategoryPropertySchemaSetsAggregate';
  aggregate?: Maybe<CategoryPropertySchemaSetsAggregateFields>;
  nodes: Array<CategoryPropertySchemaSets>;
};

export type CategoryPropertySchemaSetsAggregateBoolExp = {
  count?: InputMaybe<CategoryPropertySchemaSetsAggregateBoolExpCount>;
};

/** aggregate fields of "category_property_schema_sets" */
export type CategoryPropertySchemaSetsAggregateFields = {
  __typename?: 'CategoryPropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CategoryPropertySchemaSetsMaxFields>;
  min?: Maybe<CategoryPropertySchemaSetsMinFields>;
};


/** aggregate fields of "category_property_schema_sets" */
export type CategoryPropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CategoryPropertySchemaSetsMaxOrderBy>;
  min?: InputMaybe<CategoryPropertySchemaSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsArrRelInsertInput = {
  data: Array<CategoryPropertySchemaSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CategoryPropertySchemaSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "category_property_schema_sets". All fields are combined with a logical 'AND'. */
export type CategoryPropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<CategoryPropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<CategoryPropertySchemaSetsBoolExp>>;
  category?: InputMaybe<CategoriesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "category_property_schema_sets" */
export const CategoryPropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "category_id" */
  CategoryPropertySchemaSetsPkey: 'category_property_schema_sets_pkey',
  /** unique or primary key constraint on columns "property_schema_set_id" */
  CategoryPropertySchemaSetsPropertySchemaSetIdKey: 'category_property_schema_sets_property_schema_set_id_key'
} as const;

export type CategoryPropertySchemaSetsConstraint = typeof CategoryPropertySchemaSetsConstraint[keyof typeof CategoryPropertySchemaSetsConstraint];
/** input type for inserting data into table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsInsertInput = {
  category?: InputMaybe<CategoriesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CategoryPropertySchemaSetsMaxFields = {
  __typename?: 'CategoryPropertySchemaSetsMaxFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CategoryPropertySchemaSetsMinFields = {
  __typename?: 'CategoryPropertySchemaSetsMinFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsMutationResponse = {
  __typename?: 'CategoryPropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CategoryPropertySchemaSets>;
};

/** on_conflict condition type for table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsOnConflict = {
  constraint: CategoryPropertySchemaSetsConstraint;
  updateColumns?: Array<CategoryPropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "category_property_schema_sets". */
export type CategoryPropertySchemaSetsOrderBy = {
  category?: InputMaybe<CategoriesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: category_property_schema_sets */
export type CategoryPropertySchemaSetsPkColumnsInput = {
  categoryId: Scalars['uuid']['input'];
};

/** select columns of table "category_property_schema_sets" */
export const CategoryPropertySchemaSetsSelectColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryPropertySchemaSetsSelectColumn = typeof CategoryPropertySchemaSetsSelectColumn[keyof typeof CategoryPropertySchemaSetsSelectColumn];
/** input type for updating data in table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "category_property_schema_sets" */
export type CategoryPropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CategoryPropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoryPropertySchemaSetsStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "category_property_schema_sets" */
export const CategoryPropertySchemaSetsUpdateColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryPropertySchemaSetsUpdateColumn = typeof CategoryPropertySchemaSetsUpdateColumn[keyof typeof CategoryPropertySchemaSetsUpdateColumn];
export type CategoryPropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CategoryPropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: CategoryPropertySchemaSetsBoolExp;
};

export type CategorySchemaMigrationDeferredChange = {
  __typename?: 'CategorySchemaMigrationDeferredChange';
  newName: Scalars['String']['output'];
  oldName: Scalars['String']['output'];
  reason: Scalars['String']['output'];
};

export type CategorySchemaMigrationItem = {
  __typename?: 'CategorySchemaMigrationItem';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  deferredChanges: Array<CategorySchemaMigrationDeferredChange>;
  executionJobRunId?: Maybe<Scalars['UUID']['output']>;
  pages: Array<CategorySchemaMigrationPage>;
  planKey: Scalars['String']['output'];
  runnable: Scalars['Boolean']['output'];
  schemaVersion: Scalars['String']['output'];
  withdrawnAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategorySchemaMigrationJobExecution = {
  __typename?: 'CategorySchemaMigrationJobExecution';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type CategorySchemaMigrationPage = {
  __typename?: 'CategorySchemaMigrationPage';
  batchChangeRequestsJobIds: Array<Scalars['UUID']['output']>;
  batchEvidencesJobIds: Array<Scalars['UUID']['output']>;
  dataImportProjectActive: Scalars['Boolean']['output'];
  dataImportProjectId: Scalars['UUID']['output'];
  dataImportProjectStatus?: Maybe<DataImportProjectReviewStatus>;
  settled: Scalars['Boolean']['output'];
};

export type CategorySchemaMigrationSubmitInput = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  dryRun: Scalars['Boolean']['input'];
  planKey: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CategorySchemaMigrationSubmitOutput = {
  __typename?: 'CategorySchemaMigrationSubmitOutput';
  batchChangeRequestsJobs: Array<CategorySchemaMigrationJobExecution>;
  batchEvidencesJobs: Array<CategorySchemaMigrationJobExecution>;
  jobRunId: Scalars['UUID']['output'];
};

export type CategorySchemaMigrationSubmitResponse = CategorySchemaMigrationSubmitOutput | ClientError;

export const CategoryType = {
  Entity: 'entity',
  Relation: 'relation'
} as const;

export type CategoryType = typeof CategoryType[keyof typeof CategoryType];
/** columns and relationships of "category_types" */
export type CategoryTypes = {
  __typename?: 'CategoryTypes';
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categoriesAggregate: CategoriesAggregate;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "category_types" */
export type CategoryTypesCategoriesArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


/** columns and relationships of "category_types" */
export type CategoryTypesCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};

/** aggregated selection of "category_types" */
export type CategoryTypesAggregate = {
  __typename?: 'CategoryTypesAggregate';
  aggregate?: Maybe<CategoryTypesAggregateFields>;
  nodes: Array<CategoryTypes>;
};

/** aggregate fields of "category_types" */
export type CategoryTypesAggregateFields = {
  __typename?: 'CategoryTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CategoryTypesMaxFields>;
  min?: Maybe<CategoryTypesMinFields>;
};


/** aggregate fields of "category_types" */
export type CategoryTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CategoryTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "category_types". All fields are combined with a logical 'AND'. */
export type CategoryTypesBoolExp = {
  _and?: InputMaybe<Array<CategoryTypesBoolExp>>;
  _not?: InputMaybe<CategoryTypesBoolExp>;
  _or?: InputMaybe<Array<CategoryTypesBoolExp>>;
  categories?: InputMaybe<CategoriesBoolExp>;
  categoriesAggregate?: InputMaybe<CategoriesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "category_types" */
export const CategoryTypesConstraint = {
  /** unique or primary key constraint on columns "id" */
  CategoryTypesPkey: 'category_types_pkey'
} as const;

export type CategoryTypesConstraint = typeof CategoryTypesConstraint[keyof typeof CategoryTypesConstraint];
/** input type for inserting data into table "category_types" */
export type CategoryTypesInsertInput = {
  categories?: InputMaybe<CategoriesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type CategoryTypesMaxFields = {
  __typename?: 'CategoryTypesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CategoryTypesMinFields = {
  __typename?: 'CategoryTypesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "category_types" */
export type CategoryTypesMutationResponse = {
  __typename?: 'CategoryTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CategoryTypes>;
};

/** input type for inserting object relation for remote table "category_types" */
export type CategoryTypesObjRelInsertInput = {
  data: CategoryTypesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CategoryTypesOnConflict>;
};

/** on_conflict condition type for table "category_types" */
export type CategoryTypesOnConflict = {
  constraint: CategoryTypesConstraint;
  updateColumns?: Array<CategoryTypesUpdateColumn>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};

/** Ordering options when selecting data from "category_types". */
export type CategoryTypesOrderBy = {
  categoriesAggregate?: InputMaybe<CategoriesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: category_types */
export type CategoryTypesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "category_types" */
export const CategoryTypesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryTypesSelectColumn = typeof CategoryTypesSelectColumn[keyof typeof CategoryTypesSelectColumn];
/** input type for updating data in table "category_types" */
export type CategoryTypesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "category_types" */
export type CategoryTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CategoryTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CategoryTypesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "category_types" */
export const CategoryTypesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CategoryTypesUpdateColumn = typeof CategoryTypesUpdateColumn[keyof typeof CategoryTypesUpdateColumn];
export type CategoryTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CategoryTypesSetInput>;
  /** filter the rows which have to be updated */
  where: CategoryTypesBoolExp;
};

export type CategoryUpsertInput = {
  categoryPath: CategoryPathInput;
  categoryPropertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  i18nLabel?: InputMaybe<I18nLabelInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  relationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId: Scalars['UUID']['input'];
  typeId: CategoryType;
};

export type CategoryUpsertOutput = {
  __typename?: 'CategoryUpsertOutput';
  id: Scalars['UUID']['output'];
};

export type CategoryUpsertResponse = CategoryUpsertOutput | ValidationError;

/** columns and relationships of "change_request_commits" */
export type ChangeRequestCommits = {
  __typename?: 'ChangeRequestCommits';
  /** An object relationship */
  changeRequest: ChangeRequests;
  changeRequestId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An array relationship */
  items: Array<ChangeRequestItemCommits>;
  /** An aggregate relationship */
  itemsAggregate: ChangeRequestItemCommitsAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};


/** columns and relationships of "change_request_commits" */
export type ChangeRequestCommitsItemsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


/** columns and relationships of "change_request_commits" */
export type ChangeRequestCommitsItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};

/** aggregated selection of "change_request_commits" */
export type ChangeRequestCommitsAggregate = {
  __typename?: 'ChangeRequestCommitsAggregate';
  aggregate?: Maybe<ChangeRequestCommitsAggregateFields>;
  nodes: Array<ChangeRequestCommits>;
};

/** aggregate fields of "change_request_commits" */
export type ChangeRequestCommitsAggregateFields = {
  __typename?: 'ChangeRequestCommitsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestCommitsMaxFields>;
  min?: Maybe<ChangeRequestCommitsMinFields>;
};


/** aggregate fields of "change_request_commits" */
export type ChangeRequestCommitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestCommitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "change_request_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestCommitsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestCommitsBoolExp>>;
  _not?: InputMaybe<ChangeRequestCommitsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestCommitsBoolExp>>;
  changeRequest?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
  itemsAggregate?: InputMaybe<ChangeRequestItemCommitsAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "change_request_commits" */
export const ChangeRequestCommitsConstraint = {
  /** unique or primary key constraint on columns "change_request_id" */
  ChangeRequestCommitsChangeRequestIdKey: 'change_request_commits_change_request_id_key',
  /** unique or primary key constraint on columns "id" */
  ChangeRequestCommitsPkey: 'change_request_commits_pkey'
} as const;

export type ChangeRequestCommitsConstraint = typeof ChangeRequestCommitsConstraint[keyof typeof ChangeRequestCommitsConstraint];
/** input type for inserting data into table "change_request_commits" */
export type ChangeRequestCommitsInsertInput = {
  changeRequest?: InputMaybe<ChangeRequestsObjRelInsertInput>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items?: InputMaybe<ChangeRequestItemCommitsArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestCommitsMaxFields = {
  __typename?: 'ChangeRequestCommitsMaxFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type ChangeRequestCommitsMinFields = {
  __typename?: 'ChangeRequestCommitsMinFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "change_request_commits" */
export type ChangeRequestCommitsMutationResponse = {
  __typename?: 'ChangeRequestCommitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestCommits>;
};

/** input type for inserting object relation for remote table "change_request_commits" */
export type ChangeRequestCommitsObjRelInsertInput = {
  data: ChangeRequestCommitsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestCommitsOnConflict>;
};

/** on_conflict condition type for table "change_request_commits" */
export type ChangeRequestCommitsOnConflict = {
  constraint: ChangeRequestCommitsConstraint;
  updateColumns?: Array<ChangeRequestCommitsUpdateColumn>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};

/** Ordering options when selecting data from "change_request_commits". */
export type ChangeRequestCommitsOrderBy = {
  changeRequest?: InputMaybe<ChangeRequestsOrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<ChangeRequestItemCommitsAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_commits */
export type ChangeRequestCommitsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "change_request_commits" */
export const ChangeRequestCommitsSelectColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestCommitsSelectColumn = typeof ChangeRequestCommitsSelectColumn[keyof typeof ChangeRequestCommitsSelectColumn];
/** input type for updating data in table "change_request_commits" */
export type ChangeRequestCommitsSetInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "change_request_commits" */
export type ChangeRequestCommitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestCommitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestCommitsStreamCursorValueInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "change_request_commits" */
export const ChangeRequestCommitsUpdateColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestCommitsUpdateColumn = typeof ChangeRequestCommitsUpdateColumn[keyof typeof ChangeRequestCommitsUpdateColumn];
export type ChangeRequestCommitsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestCommitsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestCommitsBoolExp;
};

export type ChangeRequestCreateInput = {
  cascadeRelationIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  context: Scalars['JSONObject']['input'];
  description: Scalars['String']['input'];
  entityId?: InputMaybe<Scalars['UUID']['input']>;
  evidenceId?: InputMaybe<Scalars['UUID']['input']>;
  modelPropsInput: Scalars['JSONObject']['input'];
  recordMetadataId?: InputMaybe<Scalars['UUID']['input']>;
  relationId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ChangeRequestCreateOutput = {
  __typename?: 'ChangeRequestCreateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "change_request_item_commits" */
export type ChangeRequestItemCommits = {
  __typename?: 'ChangeRequestItemCommits';
  /** An object relationship */
  changeRequestCommit: ChangeRequestCommits;
  changeRequestCommitId: Scalars['uuid']['output'];
  /** An object relationship */
  changeRequestItem: ChangeRequestItems;
  changeRequestItemId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  properties: Scalars['jsonb']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};


/** columns and relationships of "change_request_item_commits" */
export type ChangeRequestItemCommitsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "change_request_item_commits" */
export type ChangeRequestItemCommitsAggregate = {
  __typename?: 'ChangeRequestItemCommitsAggregate';
  aggregate?: Maybe<ChangeRequestItemCommitsAggregateFields>;
  nodes: Array<ChangeRequestItemCommits>;
};

export type ChangeRequestItemCommitsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestItemCommitsAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_item_commits" */
export type ChangeRequestItemCommitsAggregateFields = {
  __typename?: 'ChangeRequestItemCommitsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestItemCommitsMaxFields>;
  min?: Maybe<ChangeRequestItemCommitsMinFields>;
};


/** aggregate fields of "change_request_item_commits" */
export type ChangeRequestItemCommitsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_item_commits" */
export type ChangeRequestItemCommitsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestItemCommitsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestItemCommitsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestItemCommitsAppendInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "change_request_item_commits" */
export type ChangeRequestItemCommitsArrRelInsertInput = {
  data: Array<ChangeRequestItemCommitsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemCommitsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_item_commits". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemCommitsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestItemCommitsBoolExp>>;
  _not?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestItemCommitsBoolExp>>;
  changeRequestCommit?: InputMaybe<ChangeRequestCommitsBoolExp>;
  changeRequestCommitId?: InputMaybe<UuidComparisonExp>;
  changeRequestItem?: InputMaybe<ChangeRequestItemsBoolExp>;
  changeRequestItemId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "change_request_item_commits" */
export const ChangeRequestItemCommitsConstraint = {
  /** unique or primary key constraint on columns "change_request_item_id" */
  ChangeRequestItemCommitsChangeRequestItemIdKey: 'change_request_item_commits_change_request_item_id_key',
  /** unique or primary key constraint on columns "change_request_item_id", "change_request_commit_id" */
  ChangeRequestItemCommitsPkey: 'change_request_item_commits_pkey'
} as const;

export type ChangeRequestItemCommitsConstraint = typeof ChangeRequestItemCommitsConstraint[keyof typeof ChangeRequestItemCommitsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ChangeRequestItemCommitsDeleteAtPathInput = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ChangeRequestItemCommitsDeleteElemInput = {
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ChangeRequestItemCommitsDeleteKeyInput = {
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "change_request_item_commits" */
export type ChangeRequestItemCommitsInsertInput = {
  changeRequestCommit?: InputMaybe<ChangeRequestCommitsObjRelInsertInput>;
  changeRequestCommitId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestItem?: InputMaybe<ChangeRequestItemsObjRelInsertInput>;
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestItemCommitsMaxFields = {
  __typename?: 'ChangeRequestItemCommitsMaxFields';
  changeRequestCommitId?: Maybe<Scalars['uuid']['output']>;
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "change_request_item_commits" */
export type ChangeRequestItemCommitsMaxOrderBy = {
  changeRequestCommitId?: InputMaybe<OrderBy>;
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestItemCommitsMinFields = {
  __typename?: 'ChangeRequestItemCommitsMinFields';
  changeRequestCommitId?: Maybe<Scalars['uuid']['output']>;
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "change_request_item_commits" */
export type ChangeRequestItemCommitsMinOrderBy = {
  changeRequestCommitId?: InputMaybe<OrderBy>;
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_item_commits" */
export type ChangeRequestItemCommitsMutationResponse = {
  __typename?: 'ChangeRequestItemCommitsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestItemCommits>;
};

/** input type for inserting object relation for remote table "change_request_item_commits" */
export type ChangeRequestItemCommitsObjRelInsertInput = {
  data: ChangeRequestItemCommitsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemCommitsOnConflict>;
};

/** on_conflict condition type for table "change_request_item_commits" */
export type ChangeRequestItemCommitsOnConflict = {
  constraint: ChangeRequestItemCommitsConstraint;
  updateColumns?: Array<ChangeRequestItemCommitsUpdateColumn>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};

/** Ordering options when selecting data from "change_request_item_commits". */
export type ChangeRequestItemCommitsOrderBy = {
  changeRequestCommit?: InputMaybe<ChangeRequestCommitsOrderBy>;
  changeRequestCommitId?: InputMaybe<OrderBy>;
  changeRequestItem?: InputMaybe<ChangeRequestItemsOrderBy>;
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_item_commits */
export type ChangeRequestItemCommitsPkColumnsInput = {
  changeRequestCommitId: Scalars['uuid']['input'];
  changeRequestItemId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestItemCommitsPrependInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "change_request_item_commits" */
export const ChangeRequestItemCommitsSelectColumn = {
  /** column name */
  ChangeRequestCommitId: 'changeRequestCommitId',
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Properties: 'properties',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestItemCommitsSelectColumn = typeof ChangeRequestItemCommitsSelectColumn[keyof typeof ChangeRequestItemCommitsSelectColumn];
/** input type for updating data in table "change_request_item_commits" */
export type ChangeRequestItemCommitsSetInput = {
  changeRequestCommitId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "change_request_item_commits" */
export type ChangeRequestItemCommitsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestItemCommitsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestItemCommitsStreamCursorValueInput = {
  changeRequestCommitId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "change_request_item_commits" */
export const ChangeRequestItemCommitsUpdateColumn = {
  /** column name */
  ChangeRequestCommitId: 'changeRequestCommitId',
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Properties: 'properties',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestItemCommitsUpdateColumn = typeof ChangeRequestItemCommitsUpdateColumn[keyof typeof ChangeRequestItemCommitsUpdateColumn];
export type ChangeRequestItemCommitsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ChangeRequestItemCommitsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ChangeRequestItemCommitsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ChangeRequestItemCommitsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ChangeRequestItemCommitsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ChangeRequestItemCommitsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestItemCommitsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestItemCommitsBoolExp;
};

/** columns and relationships of "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadata = {
  __typename?: 'ChangeRequestItemRecordMetadata';
  /** An object relationship */
  changeRequestItem: ChangeRequestItems;
  changeRequestItemId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  recordMetadata?: Maybe<RecordMetadata>;
  recordMetadataId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataAggregate = {
  __typename?: 'ChangeRequestItemRecordMetadataAggregate';
  aggregate?: Maybe<ChangeRequestItemRecordMetadataAggregateFields>;
  nodes: Array<ChangeRequestItemRecordMetadata>;
};

export type ChangeRequestItemRecordMetadataAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestItemRecordMetadataAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataAggregateFields = {
  __typename?: 'ChangeRequestItemRecordMetadataAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestItemRecordMetadataMaxFields>;
  min?: Maybe<ChangeRequestItemRecordMetadataMinFields>;
};


/** aggregate fields of "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestItemRecordMetadataMaxOrderBy>;
  min?: InputMaybe<ChangeRequestItemRecordMetadataMinOrderBy>;
};

/** input type for inserting array relation for remote table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataArrRelInsertInput = {
  data: Array<ChangeRequestItemRecordMetadataInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemRecordMetadataOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_item_record_metadata". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordMetadataBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestItemRecordMetadataBoolExp>>;
  _not?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestItemRecordMetadataBoolExp>>;
  changeRequestItem?: InputMaybe<ChangeRequestItemsBoolExp>;
  changeRequestItemId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  recordMetadata?: InputMaybe<RecordMetadataBoolExp>;
  recordMetadataId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "change_request_item_record_metadata" */
export const ChangeRequestItemRecordMetadataConstraint = {
  /** unique or primary key constraint on columns "change_request_item_id" */
  ChangeRequestItemRecordMetadataChangeRequestItemIdKey: 'change_request_item_record_metadata_change_request_item_id_key',
  /** unique or primary key constraint on columns "change_request_item_id", "record_metadata_id" */
  ChangeRequestItemRecordMetadataPkey: 'change_request_item_record_metadata_pkey'
} as const;

export type ChangeRequestItemRecordMetadataConstraint = typeof ChangeRequestItemRecordMetadataConstraint[keyof typeof ChangeRequestItemRecordMetadataConstraint];
/** input type for inserting data into table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataInsertInput = {
  changeRequestItem?: InputMaybe<ChangeRequestItemsObjRelInsertInput>;
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadata?: InputMaybe<RecordMetadataObjRelInsertInput>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestItemRecordMetadataMaxFields = {
  __typename?: 'ChangeRequestItemRecordMetadataMaxFields';
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataMaxOrderBy = {
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestItemRecordMetadataMinFields = {
  __typename?: 'ChangeRequestItemRecordMetadataMinFields';
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataMinOrderBy = {
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataMutationResponse = {
  __typename?: 'ChangeRequestItemRecordMetadataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestItemRecordMetadata>;
};

/** input type for inserting object relation for remote table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataObjRelInsertInput = {
  data: ChangeRequestItemRecordMetadataInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemRecordMetadataOnConflict>;
};

/** on_conflict condition type for table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataOnConflict = {
  constraint: ChangeRequestItemRecordMetadataConstraint;
  updateColumns?: Array<ChangeRequestItemRecordMetadataUpdateColumn>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};

/** Ordering options when selecting data from "change_request_item_record_metadata". */
export type ChangeRequestItemRecordMetadataOrderBy = {
  changeRequestItem?: InputMaybe<ChangeRequestItemsOrderBy>;
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadata?: InputMaybe<RecordMetadataOrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_item_record_metadata */
export type ChangeRequestItemRecordMetadataPkColumnsInput = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};

/** select columns of table "change_request_item_record_metadata" */
export const ChangeRequestItemRecordMetadataSelectColumn = {
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemRecordMetadataSelectColumn = typeof ChangeRequestItemRecordMetadataSelectColumn[keyof typeof ChangeRequestItemRecordMetadataSelectColumn];
/** input type for updating data in table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataSetInput = {
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "change_request_item_record_metadata" */
export type ChangeRequestItemRecordMetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestItemRecordMetadataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestItemRecordMetadataStreamCursorValueInput = {
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "change_request_item_record_metadata" */
export const ChangeRequestItemRecordMetadataUpdateColumn = {
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemRecordMetadataUpdateColumn = typeof ChangeRequestItemRecordMetadataUpdateColumn[keyof typeof ChangeRequestItemRecordMetadataUpdateColumn];
export type ChangeRequestItemRecordMetadataUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestItemRecordMetadataSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestItemRecordMetadataBoolExp;
};

/** columns and relationships of "change_request_item_records" */
export type ChangeRequestItemRecords = {
  __typename?: 'ChangeRequestItemRecords';
  /** An object relationship */
  changeRequestItem: ChangeRequestItems;
  changeRequestItemId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  record?: Maybe<Records>;
  recordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "change_request_item_records" */
export type ChangeRequestItemRecordsAggregate = {
  __typename?: 'ChangeRequestItemRecordsAggregate';
  aggregate?: Maybe<ChangeRequestItemRecordsAggregateFields>;
  nodes: Array<ChangeRequestItemRecords>;
};

export type ChangeRequestItemRecordsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestItemRecordsAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_item_records" */
export type ChangeRequestItemRecordsAggregateFields = {
  __typename?: 'ChangeRequestItemRecordsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestItemRecordsMaxFields>;
  min?: Maybe<ChangeRequestItemRecordsMinFields>;
};


/** aggregate fields of "change_request_item_records" */
export type ChangeRequestItemRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_item_records" */
export type ChangeRequestItemRecordsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestItemRecordsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestItemRecordsMinOrderBy>;
};

/** input type for inserting array relation for remote table "change_request_item_records" */
export type ChangeRequestItemRecordsArrRelInsertInput = {
  data: Array<ChangeRequestItemRecordsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemRecordsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_item_records". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemRecordsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestItemRecordsBoolExp>>;
  _not?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestItemRecordsBoolExp>>;
  changeRequestItem?: InputMaybe<ChangeRequestItemsBoolExp>;
  changeRequestItemId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "change_request_item_records" */
export const ChangeRequestItemRecordsConstraint = {
  /** unique or primary key constraint on columns "change_request_item_id" */
  ChangeRequestItemRecordsChangeRequestItemIdKey: 'change_request_item_records_change_request_item_id_key',
  /** unique or primary key constraint on columns "change_request_item_id", "record_id" */
  ChangeRequestItemRecordsPkey: 'change_request_item_records_pkey'
} as const;

export type ChangeRequestItemRecordsConstraint = typeof ChangeRequestItemRecordsConstraint[keyof typeof ChangeRequestItemRecordsConstraint];
/** input type for inserting data into table "change_request_item_records" */
export type ChangeRequestItemRecordsInsertInput = {
  changeRequestItem?: InputMaybe<ChangeRequestItemsObjRelInsertInput>;
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestItemRecordsMaxFields = {
  __typename?: 'ChangeRequestItemRecordsMaxFields';
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "change_request_item_records" */
export type ChangeRequestItemRecordsMaxOrderBy = {
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestItemRecordsMinFields = {
  __typename?: 'ChangeRequestItemRecordsMinFields';
  changeRequestItemId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "change_request_item_records" */
export type ChangeRequestItemRecordsMinOrderBy = {
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_item_records" */
export type ChangeRequestItemRecordsMutationResponse = {
  __typename?: 'ChangeRequestItemRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestItemRecords>;
};

/** input type for inserting object relation for remote table "change_request_item_records" */
export type ChangeRequestItemRecordsObjRelInsertInput = {
  data: ChangeRequestItemRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemRecordsOnConflict>;
};

/** on_conflict condition type for table "change_request_item_records" */
export type ChangeRequestItemRecordsOnConflict = {
  constraint: ChangeRequestItemRecordsConstraint;
  updateColumns?: Array<ChangeRequestItemRecordsUpdateColumn>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};

/** Ordering options when selecting data from "change_request_item_records". */
export type ChangeRequestItemRecordsOrderBy = {
  changeRequestItem?: InputMaybe<ChangeRequestItemsOrderBy>;
  changeRequestItemId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_item_records */
export type ChangeRequestItemRecordsPkColumnsInput = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "change_request_item_records" */
export const ChangeRequestItemRecordsSelectColumn = {
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemRecordsSelectColumn = typeof ChangeRequestItemRecordsSelectColumn[keyof typeof ChangeRequestItemRecordsSelectColumn];
/** input type for updating data in table "change_request_item_records" */
export type ChangeRequestItemRecordsSetInput = {
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "change_request_item_records" */
export type ChangeRequestItemRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestItemRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestItemRecordsStreamCursorValueInput = {
  changeRequestItemId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "change_request_item_records" */
export const ChangeRequestItemRecordsUpdateColumn = {
  /** column name */
  ChangeRequestItemId: 'changeRequestItemId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemRecordsUpdateColumn = typeof ChangeRequestItemRecordsUpdateColumn[keyof typeof ChangeRequestItemRecordsUpdateColumn];
export type ChangeRequestItemRecordsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestItemRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestItemRecordsBoolExp;
};

/** columns and relationships of "change_request_items" */
export type ChangeRequestItems = {
  __typename?: 'ChangeRequestItems';
  /** An object relationship */
  changeRequest: ChangeRequests;
  changeRequestId: Scalars['uuid']['output'];
  /** An object relationship */
  changeRequestItemRecord?: Maybe<ChangeRequestItemRecords>;
  /** An object relationship */
  changeRequestItemRecordMetadata?: Maybe<ChangeRequestItemRecordMetadata>;
  /** An object relationship */
  commit?: Maybe<ChangeRequestItemCommits>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  modelType: Scalars['String']['output'];
  operationType: Scalars['String']['output'];
  properties: Scalars['jsonb']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "change_request_items" */
export type ChangeRequestItemsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "change_request_items" */
export type ChangeRequestItemsAggregate = {
  __typename?: 'ChangeRequestItemsAggregate';
  aggregate?: Maybe<ChangeRequestItemsAggregateFields>;
  nodes: Array<ChangeRequestItems>;
};

export type ChangeRequestItemsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestItemsAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_items" */
export type ChangeRequestItemsAggregateFields = {
  __typename?: 'ChangeRequestItemsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestItemsMaxFields>;
  min?: Maybe<ChangeRequestItemsMinFields>;
};


/** aggregate fields of "change_request_items" */
export type ChangeRequestItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_items" */
export type ChangeRequestItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestItemsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestItemsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestItemsAppendInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "change_request_items" */
export type ChangeRequestItemsArrRelInsertInput = {
  data: Array<ChangeRequestItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_items". All fields are combined with a logical 'AND'. */
export type ChangeRequestItemsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestItemsBoolExp>>;
  _not?: InputMaybe<ChangeRequestItemsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestItemsBoolExp>>;
  changeRequest?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestId?: InputMaybe<UuidComparisonExp>;
  changeRequestItemRecord?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
  changeRequestItemRecordMetadata?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
  commit?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  modelType?: InputMaybe<StringComparisonExp>;
  operationType?: InputMaybe<StringComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "change_request_items" */
export const ChangeRequestItemsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ChangeRequestItemsPkey: 'change_request_items_pkey'
} as const;

export type ChangeRequestItemsConstraint = typeof ChangeRequestItemsConstraint[keyof typeof ChangeRequestItemsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ChangeRequestItemsDeleteAtPathInput = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ChangeRequestItemsDeleteElemInput = {
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ChangeRequestItemsDeleteKeyInput = {
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "change_request_items" */
export type ChangeRequestItemsInsertInput = {
  changeRequest?: InputMaybe<ChangeRequestsObjRelInsertInput>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestItemRecord?: InputMaybe<ChangeRequestItemRecordsObjRelInsertInput>;
  changeRequestItemRecordMetadata?: InputMaybe<ChangeRequestItemRecordMetadataObjRelInsertInput>;
  commit?: InputMaybe<ChangeRequestItemCommitsObjRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestItemsMaxFields = {
  __typename?: 'ChangeRequestItemsMaxFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modelType?: Maybe<Scalars['String']['output']>;
  operationType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "change_request_items" */
export type ChangeRequestItemsMaxOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modelType?: InputMaybe<OrderBy>;
  operationType?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestItemsMinFields = {
  __typename?: 'ChangeRequestItemsMinFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  modelType?: Maybe<Scalars['String']['output']>;
  operationType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "change_request_items" */
export type ChangeRequestItemsMinOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modelType?: InputMaybe<OrderBy>;
  operationType?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_items" */
export type ChangeRequestItemsMutationResponse = {
  __typename?: 'ChangeRequestItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestItems>;
};

/** input type for inserting object relation for remote table "change_request_items" */
export type ChangeRequestItemsObjRelInsertInput = {
  data: ChangeRequestItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestItemsOnConflict>;
};

/** on_conflict condition type for table "change_request_items" */
export type ChangeRequestItemsOnConflict = {
  constraint: ChangeRequestItemsConstraint;
  updateColumns?: Array<ChangeRequestItemsUpdateColumn>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};

/** Ordering options when selecting data from "change_request_items". */
export type ChangeRequestItemsOrderBy = {
  changeRequest?: InputMaybe<ChangeRequestsOrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  changeRequestItemRecord?: InputMaybe<ChangeRequestItemRecordsOrderBy>;
  changeRequestItemRecordMetadata?: InputMaybe<ChangeRequestItemRecordMetadataOrderBy>;
  commit?: InputMaybe<ChangeRequestItemCommitsOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  modelType?: InputMaybe<OrderBy>;
  operationType?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_items */
export type ChangeRequestItemsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestItemsPrependInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "change_request_items" */
export const ChangeRequestItemsSelectColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ModelType: 'modelType',
  /** column name */
  OperationType: 'operationType',
  /** column name */
  Properties: 'properties',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemsSelectColumn = typeof ChangeRequestItemsSelectColumn[keyof typeof ChangeRequestItemsSelectColumn];
/** input type for updating data in table "change_request_items" */
export type ChangeRequestItemsSetInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "change_request_items" */
export type ChangeRequestItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestItemsStreamCursorValueInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  modelType?: InputMaybe<Scalars['String']['input']>;
  operationType?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "change_request_items" */
export const ChangeRequestItemsUpdateColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ModelType: 'modelType',
  /** column name */
  OperationType: 'operationType',
  /** column name */
  Properties: 'properties',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestItemsUpdateColumn = typeof ChangeRequestItemsUpdateColumn[keyof typeof ChangeRequestItemsUpdateColumn];
export type ChangeRequestItemsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ChangeRequestItemsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ChangeRequestItemsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ChangeRequestItemsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ChangeRequestItemsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ChangeRequestItemsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestItemsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestItemsBoolExp;
};

export const ChangeRequestModelType = {
  Entity: 'entity',
  RecordMetadata: 'recordMetadata',
  Relation: 'relation'
} as const;

export type ChangeRequestModelType = typeof ChangeRequestModelType[keyof typeof ChangeRequestModelType];
export const ChangeRequestOperation = {
  Create: 'create',
  Update: 'update'
} as const;

export type ChangeRequestOperation = typeof ChangeRequestOperation[keyof typeof ChangeRequestOperation];
export const ChangeRequestOperationType = {
  Create: 'create',
  Deactivated: 'deactivated',
  Invalid: 'invalid',
  Skipped: 'skipped',
  Unchanged: 'unchanged',
  Update: 'update'
} as const;

export type ChangeRequestOperationType = typeof ChangeRequestOperationType[keyof typeof ChangeRequestOperationType];
/** columns and relationships of "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitions = {
  __typename?: 'ChangeRequestRecordComposerDefinitions';
  /** An object relationship */
  changeRequest: ChangeRequests;
  changeRequestId: Scalars['uuid']['output'];
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsAggregate = {
  __typename?: 'ChangeRequestRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<ChangeRequestRecordComposerDefinitionsAggregateFields>;
  nodes: Array<ChangeRequestRecordComposerDefinitions>;
};

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsAggregateFields = {
  __typename?: 'ChangeRequestRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestRecordComposerDefinitionsMaxFields>;
  min?: Maybe<ChangeRequestRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestRecordComposerDefinitionsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestRecordComposerDefinitionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsArrRelInsertInput = {
  data: Array<ChangeRequestRecordComposerDefinitionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestRecordComposerDefinitionsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type ChangeRequestRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsBoolExp>>;
  changeRequest?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestId?: InputMaybe<UuidComparisonExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "change_request_record_composer_definitions" */
export const ChangeRequestRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "change_request_id" */
  ChangeRequestRecordComposerDefinitionsPkey: 'change_request_record_composer_definitions_pkey'
} as const;

export type ChangeRequestRecordComposerDefinitionsConstraint = typeof ChangeRequestRecordComposerDefinitionsConstraint[keyof typeof ChangeRequestRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsInsertInput = {
  changeRequest?: InputMaybe<ChangeRequestsObjRelInsertInput>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestRecordComposerDefinitionsMaxFields = {
  __typename?: 'ChangeRequestRecordComposerDefinitionsMaxFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsMaxOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestRecordComposerDefinitionsMinFields = {
  __typename?: 'ChangeRequestRecordComposerDefinitionsMinFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsMinOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsMutationResponse = {
  __typename?: 'ChangeRequestRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsObjRelInsertInput = {
  data: ChangeRequestRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsOnConflict = {
  constraint: ChangeRequestRecordComposerDefinitionsConstraint;
  updateColumns?: Array<ChangeRequestRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "change_request_record_composer_definitions". */
export type ChangeRequestRecordComposerDefinitionsOrderBy = {
  changeRequest?: InputMaybe<ChangeRequestsOrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_record_composer_definitions */
export type ChangeRequestRecordComposerDefinitionsPkColumnsInput = {
  changeRequestId: Scalars['uuid']['input'];
};

/** select columns of table "change_request_record_composer_definitions" */
export const ChangeRequestRecordComposerDefinitionsSelectColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestRecordComposerDefinitionsSelectColumn = typeof ChangeRequestRecordComposerDefinitionsSelectColumn[keyof typeof ChangeRequestRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsSetInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "change_request_record_composer_definitions" */
export type ChangeRequestRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestRecordComposerDefinitionsStreamCursorValueInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "change_request_record_composer_definitions" */
export const ChangeRequestRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ChangeRequestRecordComposerDefinitionsUpdateColumn = typeof ChangeRequestRecordComposerDefinitionsUpdateColumn[keyof typeof ChangeRequestRecordComposerDefinitionsUpdateColumn];
export type ChangeRequestRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestRecordComposerDefinitionsBoolExp;
};

export type ChangeRequestReviewCreateInput = {
  changeRequestId: Scalars['UUID']['input'];
  comment?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
  type: ChangeRequestReviewType;
};

export type ChangeRequestReviewCreateOutput = {
  __typename?: 'ChangeRequestReviewCreateOutput';
  id: Scalars['UUID']['output'];
};

export type ChangeRequestReviewCreateResponse = ChangeRequestReviewCreateOutput | ClientError;

export const ChangeRequestReviewType = {
  Approve: 'approve',
  BatchApprove: 'batchApprove',
  Comment: 'comment',
  Reject: 'reject'
} as const;

export type ChangeRequestReviewType = typeof ChangeRequestReviewType[keyof typeof ChangeRequestReviewType];
/** columns and relationships of "change_request_review_types" */
export type ChangeRequestReviewTypes = {
  __typename?: 'ChangeRequestReviewTypes';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "change_request_review_types" */
export type ChangeRequestReviewTypesAggregate = {
  __typename?: 'ChangeRequestReviewTypesAggregate';
  aggregate?: Maybe<ChangeRequestReviewTypesAggregateFields>;
  nodes: Array<ChangeRequestReviewTypes>;
};

/** aggregate fields of "change_request_review_types" */
export type ChangeRequestReviewTypesAggregateFields = {
  __typename?: 'ChangeRequestReviewTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestReviewTypesMaxFields>;
  min?: Maybe<ChangeRequestReviewTypesMinFields>;
};


/** aggregate fields of "change_request_review_types" */
export type ChangeRequestReviewTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestReviewTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "change_request_review_types". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewTypesBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestReviewTypesBoolExp>>;
  _not?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestReviewTypesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "change_request_review_types" */
export const ChangeRequestReviewTypesConstraint = {
  /** unique or primary key constraint on columns "id" */
  ChangeRequestReviewTypesPkey: 'change_request_review_types_pkey'
} as const;

export type ChangeRequestReviewTypesConstraint = typeof ChangeRequestReviewTypesConstraint[keyof typeof ChangeRequestReviewTypesConstraint];
/** input type for inserting data into table "change_request_review_types" */
export type ChangeRequestReviewTypesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestReviewTypesMaxFields = {
  __typename?: 'ChangeRequestReviewTypesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ChangeRequestReviewTypesMinFields = {
  __typename?: 'ChangeRequestReviewTypesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "change_request_review_types" */
export type ChangeRequestReviewTypesMutationResponse = {
  __typename?: 'ChangeRequestReviewTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestReviewTypes>;
};

/** input type for inserting object relation for remote table "change_request_review_types" */
export type ChangeRequestReviewTypesObjRelInsertInput = {
  data: ChangeRequestReviewTypesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestReviewTypesOnConflict>;
};

/** on_conflict condition type for table "change_request_review_types" */
export type ChangeRequestReviewTypesOnConflict = {
  constraint: ChangeRequestReviewTypesConstraint;
  updateColumns?: Array<ChangeRequestReviewTypesUpdateColumn>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};

/** Ordering options when selecting data from "change_request_review_types". */
export type ChangeRequestReviewTypesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_review_types */
export type ChangeRequestReviewTypesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "change_request_review_types" */
export const ChangeRequestReviewTypesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestReviewTypesSelectColumn = typeof ChangeRequestReviewTypesSelectColumn[keyof typeof ChangeRequestReviewTypesSelectColumn];
/** input type for updating data in table "change_request_review_types" */
export type ChangeRequestReviewTypesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "change_request_review_types" */
export type ChangeRequestReviewTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestReviewTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestReviewTypesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "change_request_review_types" */
export const ChangeRequestReviewTypesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestReviewTypesUpdateColumn = typeof ChangeRequestReviewTypesUpdateColumn[keyof typeof ChangeRequestReviewTypesUpdateColumn];
export type ChangeRequestReviewTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestReviewTypesSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestReviewTypesBoolExp;
};

/** columns and relationships of "change_request_reviews" */
export type ChangeRequestReviews = {
  __typename?: 'ChangeRequestReviews';
  batchChangeRequestReviewsJobRunId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  changeRequest: ChangeRequests;
  changeRequestId: Scalars['uuid']['output'];
  comment?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  /** An object relationship */
  type: ChangeRequestReviewTypes;
  typeId: Scalars['String']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "change_request_reviews" */
export type ChangeRequestReviewsAggregate = {
  __typename?: 'ChangeRequestReviewsAggregate';
  aggregate?: Maybe<ChangeRequestReviewsAggregateFields>;
  nodes: Array<ChangeRequestReviews>;
};

export type ChangeRequestReviewsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestReviewsAggregateBoolExpCount>;
};

/** aggregate fields of "change_request_reviews" */
export type ChangeRequestReviewsAggregateFields = {
  __typename?: 'ChangeRequestReviewsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestReviewsMaxFields>;
  min?: Maybe<ChangeRequestReviewsMinFields>;
};


/** aggregate fields of "change_request_reviews" */
export type ChangeRequestReviewsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_request_reviews" */
export type ChangeRequestReviewsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestReviewsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestReviewsMinOrderBy>;
};

/** input type for inserting array relation for remote table "change_request_reviews" */
export type ChangeRequestReviewsArrRelInsertInput = {
  data: Array<ChangeRequestReviewsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestReviewsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_request_reviews". All fields are combined with a logical 'AND'. */
export type ChangeRequestReviewsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestReviewsBoolExp>>;
  _not?: InputMaybe<ChangeRequestReviewsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestReviewsBoolExp>>;
  batchChangeRequestReviewsJobRunId?: InputMaybe<UuidComparisonExp>;
  changeRequest?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestId?: InputMaybe<UuidComparisonExp>;
  comment?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  type?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
  typeId?: InputMaybe<StringComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "change_request_reviews" */
export const ChangeRequestReviewsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ChangeRequestReviewsPkey: 'change_request_reviews_pkey'
} as const;

export type ChangeRequestReviewsConstraint = typeof ChangeRequestReviewsConstraint[keyof typeof ChangeRequestReviewsConstraint];
/** input type for inserting data into table "change_request_reviews" */
export type ChangeRequestReviewsInsertInput = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequest?: InputMaybe<ChangeRequestsObjRelInsertInput>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  type?: InputMaybe<ChangeRequestReviewTypesObjRelInsertInput>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestReviewsMaxFields = {
  __typename?: 'ChangeRequestReviewsMaxFields';
  batchChangeRequestReviewsJobRunId?: Maybe<Scalars['uuid']['output']>;
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "change_request_reviews" */
export type ChangeRequestReviewsMaxOrderBy = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<OrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  typeId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestReviewsMinFields = {
  __typename?: 'ChangeRequestReviewsMinFields';
  batchChangeRequestReviewsJobRunId?: Maybe<Scalars['uuid']['output']>;
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  comment?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  typeId?: Maybe<Scalars['String']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "change_request_reviews" */
export type ChangeRequestReviewsMinOrderBy = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<OrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  typeId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_request_reviews" */
export type ChangeRequestReviewsMutationResponse = {
  __typename?: 'ChangeRequestReviewsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestReviews>;
};

/** on_conflict condition type for table "change_request_reviews" */
export type ChangeRequestReviewsOnConflict = {
  constraint: ChangeRequestReviewsConstraint;
  updateColumns?: Array<ChangeRequestReviewsUpdateColumn>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};

/** Ordering options when selecting data from "change_request_reviews". */
export type ChangeRequestReviewsOrderBy = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<OrderBy>;
  changeRequest?: InputMaybe<ChangeRequestsOrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  comment?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  type?: InputMaybe<ChangeRequestReviewTypesOrderBy>;
  typeId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_reviews */
export type ChangeRequestReviewsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "change_request_reviews" */
export const ChangeRequestReviewsSelectColumn = {
  /** column name */
  BatchChangeRequestReviewsJobRunId: 'batchChangeRequestReviewsJobRunId',
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  TypeId: 'typeId',
  /** column name */
  UserId: 'userId'
} as const;

export type ChangeRequestReviewsSelectColumn = typeof ChangeRequestReviewsSelectColumn[keyof typeof ChangeRequestReviewsSelectColumn];
/** input type for updating data in table "change_request_reviews" */
export type ChangeRequestReviewsSetInput = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "change_request_reviews" */
export type ChangeRequestReviewsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestReviewsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestReviewsStreamCursorValueInput = {
  batchChangeRequestReviewsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  comment?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  typeId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "change_request_reviews" */
export const ChangeRequestReviewsUpdateColumn = {
  /** column name */
  BatchChangeRequestReviewsJobRunId: 'batchChangeRequestReviewsJobRunId',
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  Comment: 'comment',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  TypeId: 'typeId',
  /** column name */
  UserId: 'userId'
} as const;

export type ChangeRequestReviewsUpdateColumn = typeof ChangeRequestReviewsUpdateColumn[keyof typeof ChangeRequestReviewsUpdateColumn];
export type ChangeRequestReviewsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestReviewsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestReviewsBoolExp;
};

/** columns and relationships of "change_request_statuses" */
export type ChangeRequestStatuses = {
  __typename?: 'ChangeRequestStatuses';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "change_request_statuses" */
export type ChangeRequestStatusesAggregate = {
  __typename?: 'ChangeRequestStatusesAggregate';
  aggregate?: Maybe<ChangeRequestStatusesAggregateFields>;
  nodes: Array<ChangeRequestStatuses>;
};

/** aggregate fields of "change_request_statuses" */
export type ChangeRequestStatusesAggregateFields = {
  __typename?: 'ChangeRequestStatusesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestStatusesMaxFields>;
  min?: Maybe<ChangeRequestStatusesMinFields>;
};


/** aggregate fields of "change_request_statuses" */
export type ChangeRequestStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "change_request_statuses". All fields are combined with a logical 'AND'. */
export type ChangeRequestStatusesBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestStatusesBoolExp>>;
  _not?: InputMaybe<ChangeRequestStatusesBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "change_request_statuses" */
export const ChangeRequestStatusesConstraint = {
  /** unique or primary key constraint on columns "id" */
  ChangeRequestStatusesPkey: 'change_request_statuses_pkey'
} as const;

export type ChangeRequestStatusesConstraint = typeof ChangeRequestStatusesConstraint[keyof typeof ChangeRequestStatusesConstraint];
/** input type for inserting data into table "change_request_statuses" */
export type ChangeRequestStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestStatusesMaxFields = {
  __typename?: 'ChangeRequestStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ChangeRequestStatusesMinFields = {
  __typename?: 'ChangeRequestStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "change_request_statuses" */
export type ChangeRequestStatusesMutationResponse = {
  __typename?: 'ChangeRequestStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequestStatuses>;
};

/** input type for inserting object relation for remote table "change_request_statuses" */
export type ChangeRequestStatusesObjRelInsertInput = {
  data: ChangeRequestStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestStatusesOnConflict>;
};

/** on_conflict condition type for table "change_request_statuses" */
export type ChangeRequestStatusesOnConflict = {
  constraint: ChangeRequestStatusesConstraint;
  updateColumns?: Array<ChangeRequestStatusesUpdateColumn>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};

/** Ordering options when selecting data from "change_request_statuses". */
export type ChangeRequestStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_request_statuses */
export type ChangeRequestStatusesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "change_request_statuses" */
export const ChangeRequestStatusesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestStatusesSelectColumn = typeof ChangeRequestStatusesSelectColumn[keyof typeof ChangeRequestStatusesSelectColumn];
/** input type for updating data in table "change_request_statuses" */
export type ChangeRequestStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "change_request_statuses" */
export type ChangeRequestStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "change_request_statuses" */
export const ChangeRequestStatusesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ChangeRequestStatusesUpdateColumn = typeof ChangeRequestStatusesUpdateColumn[keyof typeof ChangeRequestStatusesUpdateColumn];
export type ChangeRequestStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestStatusesBoolExp;
};

/** columns and relationships of "change_requests" */
export type ChangeRequests = {
  __typename?: 'ChangeRequests';
  /** An object relationship */
  batchChangeRequestsJob?: Maybe<BatchChangeRequestsJobs>;
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  batchChangeRequestsJobRun?: Maybe<BatchChangeRequestsJobRuns>;
  batchChangeRequestsJobRunId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  changeRequestRecordComposerDefinition?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** An object relationship */
  commit?: Maybe<ChangeRequestCommits>;
  composerKey?: Maybe<Scalars['String']['output']>;
  context: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  description: Scalars['String']['output'];
  /** An array relationship */
  evidenceChangeRequests: Array<EvidenceChangeRequests>;
  /** An aggregate relationship */
  evidenceChangeRequestsAggregate: EvidenceChangeRequestsAggregate;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  items: Array<ChangeRequestItems>;
  /** An aggregate relationship */
  itemsAggregate: ChangeRequestItemsAggregate;
  /** An array relationship */
  reviews: Array<ChangeRequestReviews>;
  /** An aggregate relationship */
  reviewsAggregate: ChangeRequestReviewsAggregate;
  /** An object relationship */
  status: ChangeRequestStatuses;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsContextArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsEvidenceChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsEvidenceChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsItemsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsReviewsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


/** columns and relationships of "change_requests" */
export type ChangeRequestsReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};

/** aggregated selection of "change_requests" */
export type ChangeRequestsAggregate = {
  __typename?: 'ChangeRequestsAggregate';
  aggregate?: Maybe<ChangeRequestsAggregateFields>;
  nodes: Array<ChangeRequests>;
};

export type ChangeRequestsAggregateBoolExp = {
  count?: InputMaybe<ChangeRequestsAggregateBoolExpCount>;
};

/** aggregate fields of "change_requests" */
export type ChangeRequestsAggregateFields = {
  __typename?: 'ChangeRequestsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ChangeRequestsMaxFields>;
  min?: Maybe<ChangeRequestsMinFields>;
};


/** aggregate fields of "change_requests" */
export type ChangeRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "change_requests" */
export type ChangeRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ChangeRequestsMaxOrderBy>;
  min?: InputMaybe<ChangeRequestsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestsAppendInput = {
  context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "change_requests" */
export type ChangeRequestsArrRelInsertInput = {
  data: Array<ChangeRequestsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestsOnConflict>;
};

/** Boolean expression to filter rows from the table "change_requests". All fields are combined with a logical 'AND'. */
export type ChangeRequestsBoolExp = {
  _and?: InputMaybe<Array<ChangeRequestsBoolExp>>;
  _not?: InputMaybe<ChangeRequestsBoolExp>;
  _or?: InputMaybe<Array<ChangeRequestsBoolExp>>;
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  batchChangeRequestsJobId?: InputMaybe<UuidComparisonExp>;
  batchChangeRequestsJobRun?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
  batchChangeRequestsJobRunId?: InputMaybe<UuidComparisonExp>;
  changeRequestRecordComposerDefinition?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
  commit?: InputMaybe<ChangeRequestCommitsBoolExp>;
  composerKey?: InputMaybe<StringComparisonExp>;
  context?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsBoolExp>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  items?: InputMaybe<ChangeRequestItemsBoolExp>;
  itemsAggregate?: InputMaybe<ChangeRequestItemsAggregateBoolExp>;
  reviews?: InputMaybe<ChangeRequestReviewsBoolExp>;
  reviewsAggregate?: InputMaybe<ChangeRequestReviewsAggregateBoolExp>;
  status?: InputMaybe<ChangeRequestStatusesBoolExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "change_requests" */
export const ChangeRequestsConstraint = {
  /** unique or primary key constraint on columns "id" */
  ChangeRequestsPkey: 'change_requests_pkey'
} as const;

export type ChangeRequestsConstraint = typeof ChangeRequestsConstraint[keyof typeof ChangeRequestsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type ChangeRequestsDeleteAtPathInput = {
  context?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type ChangeRequestsDeleteElemInput = {
  context?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type ChangeRequestsDeleteKeyInput = {
  context?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "change_requests" */
export type ChangeRequestsInsertInput = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsObjRelInsertInput>;
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchChangeRequestsJobRun?: InputMaybe<BatchChangeRequestsJobRunsObjRelInsertInput>;
  batchChangeRequestsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  changeRequestRecordComposerDefinition?: InputMaybe<ChangeRequestRecordComposerDefinitionsObjRelInsertInput>;
  commit?: InputMaybe<ChangeRequestCommitsObjRelInsertInput>;
  composerKey?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  items?: InputMaybe<ChangeRequestItemsArrRelInsertInput>;
  reviews?: InputMaybe<ChangeRequestReviewsArrRelInsertInput>;
  status?: InputMaybe<ChangeRequestStatusesObjRelInsertInput>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ChangeRequestsMaxFields = {
  __typename?: 'ChangeRequestsMaxFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  batchChangeRequestsJobRunId?: Maybe<Scalars['uuid']['output']>;
  composerKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "change_requests" */
export type ChangeRequestsMaxOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  batchChangeRequestsJobRunId?: InputMaybe<OrderBy>;
  composerKey?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ChangeRequestsMinFields = {
  __typename?: 'ChangeRequestsMinFields';
  batchChangeRequestsJobId?: Maybe<Scalars['uuid']['output']>;
  batchChangeRequestsJobRunId?: Maybe<Scalars['uuid']['output']>;
  composerKey?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "change_requests" */
export type ChangeRequestsMinOrderBy = {
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  batchChangeRequestsJobRunId?: InputMaybe<OrderBy>;
  composerKey?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "change_requests" */
export type ChangeRequestsMutationResponse = {
  __typename?: 'ChangeRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ChangeRequests>;
};

/** input type for inserting object relation for remote table "change_requests" */
export type ChangeRequestsObjRelInsertInput = {
  data: ChangeRequestsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ChangeRequestsOnConflict>;
};

/** on_conflict condition type for table "change_requests" */
export type ChangeRequestsOnConflict = {
  constraint: ChangeRequestsConstraint;
  updateColumns?: Array<ChangeRequestsUpdateColumn>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};

/** Ordering options when selecting data from "change_requests". */
export type ChangeRequestsOrderBy = {
  batchChangeRequestsJob?: InputMaybe<BatchChangeRequestsJobsOrderBy>;
  batchChangeRequestsJobId?: InputMaybe<OrderBy>;
  batchChangeRequestsJobRun?: InputMaybe<BatchChangeRequestsJobRunsOrderBy>;
  batchChangeRequestsJobRunId?: InputMaybe<OrderBy>;
  changeRequestRecordComposerDefinition?: InputMaybe<ChangeRequestRecordComposerDefinitionsOrderBy>;
  commit?: InputMaybe<ChangeRequestCommitsOrderBy>;
  composerKey?: InputMaybe<OrderBy>;
  context?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  itemsAggregate?: InputMaybe<ChangeRequestItemsAggregateOrderBy>;
  reviewsAggregate?: InputMaybe<ChangeRequestReviewsAggregateOrderBy>;
  status?: InputMaybe<ChangeRequestStatusesOrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: change_requests */
export type ChangeRequestsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type ChangeRequestsPrependInput = {
  context?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "change_requests" */
export const ChangeRequestsSelectColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  BatchChangeRequestsJobRunId: 'batchChangeRequestsJobRunId',
  /** column name */
  ComposerKey: 'composerKey',
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type ChangeRequestsSelectColumn = typeof ChangeRequestsSelectColumn[keyof typeof ChangeRequestsSelectColumn];
/** input type for updating data in table "change_requests" */
export type ChangeRequestsSetInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchChangeRequestsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  composerKey?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "change_requests" */
export type ChangeRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ChangeRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ChangeRequestsStreamCursorValueInput = {
  batchChangeRequestsJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchChangeRequestsJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  composerKey?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "change_requests" */
export const ChangeRequestsUpdateColumn = {
  /** column name */
  BatchChangeRequestsJobId: 'batchChangeRequestsJobId',
  /** column name */
  BatchChangeRequestsJobRunId: 'batchChangeRequestsJobRunId',
  /** column name */
  ComposerKey: 'composerKey',
  /** column name */
  Context: 'context',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type ChangeRequestsUpdateColumn = typeof ChangeRequestsUpdateColumn[keyof typeof ChangeRequestsUpdateColumn];
export type ChangeRequestsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<ChangeRequestsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<ChangeRequestsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<ChangeRequestsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<ChangeRequestsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<ChangeRequestsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ChangeRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: ChangeRequestsBoolExp;
};

export type CitationInput = {
  page?: InputMaybe<Scalars['String']['input']>;
};

export type ClaspPushSidebarInput = {
  scriptId: Scalars['String']['input'];
  spreadsheetName?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ClaspPushSidebarOutput = {
  __typename?: 'ClaspPushSidebarOutput';
  scriptId: Scalars['String']['output'];
};

export type ClaspPushSidebarResponse = ClaspPushSidebarOutput | ClientError;

export type ClientError = {
  __typename?: 'ClientError';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
};

export type CnutDataImportJobDiagnosis = {
  __typename?: 'CnutDataImportJobDiagnosis';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  errorMessage?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  projectId: Scalars['UUID']['output'];
  requestedAt: Scalars['DateTime']['output'];
  requestedBy: Scalars['String']['output'];
  results: Array<CnutDataImportJobDiagnosisRuleResult>;
  status: CnutDataImportJobDiagnosisStatus;
  summary?: Maybe<Scalars['String']['output']>;
};

export type CnutDataImportJobDiagnosisRuleResult = {
  __typename?: 'CnutDataImportJobDiagnosisRuleResult';
  details: Scalars['JSONObject']['output'];
  message: Scalars['String']['output'];
  ruleType: CnutDataImportJobDiagnosisRuleType;
  severity: CnutDataImportJobDiagnosisSeverity;
  suggestion: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export const CnutDataImportJobDiagnosisRuleType = {
  DataSourceSchemaMismatch: 'data_source_schema_mismatch',
  InvalidComposerDataSource: 'invalid_composer_data_source',
  InvalidCompositionSchema: 'invalid_composition_schema',
  InvalidEvidenceFieldReference: 'invalid_evidence_field_reference',
  InvalidRecordUpdateOverride: 'invalid_record_update_override',
  InvalidRelationResolver: 'invalid_relation_resolver',
  InvalidSelectValueRange: 'invalid_select_value_range',
  NotReadyDataSourceRows: 'not_ready_data_source_rows',
  UnmappedDataSourceFields: 'unmapped_data_source_fields',
  UnmappedEvidenceFields: 'unmapped_evidence_fields'
} as const;

export type CnutDataImportJobDiagnosisRuleType = typeof CnutDataImportJobDiagnosisRuleType[keyof typeof CnutDataImportJobDiagnosisRuleType];
export const CnutDataImportJobDiagnosisSeverity = {
  Error: 'error',
  Info: 'info',
  Ok: 'ok',
  Warning: 'warning'
} as const;

export type CnutDataImportJobDiagnosisSeverity = typeof CnutDataImportJobDiagnosisSeverity[keyof typeof CnutDataImportJobDiagnosisSeverity];
export const CnutDataImportJobDiagnosisStatus = {
  Completed: 'completed',
  Failed: 'failed',
  Pending: 'pending',
  Running: 'running'
} as const;

export type CnutDataImportJobDiagnosisStatus = typeof CnutDataImportJobDiagnosisStatus[keyof typeof CnutDataImportJobDiagnosisStatus];
export type CnutGetDataImportJobDiagnosisInput = {
  diagnosisId: Scalars['UUID']['input'];
  projectId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CnutInvokeDataImportJobDiagnosisInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CnutInvokeDataImportJobDiagnosisPayload = {
  __typename?: 'CnutInvokeDataImportJobDiagnosisPayload';
  diagnosisId: Scalars['UUID']['output'];
};

export type CnutListDataImportJobDiagnosesInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ColumnMapItemInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecords = {
  __typename?: 'CompoundCompoundRecords';
  categoryIdArray: Array<Scalars['uuid']['output']>;
  categoryNameArray: Array<Scalars['String']['output']>;
  compoundRecordMetadataId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamp']['output'];
  date?: Maybe<Scalars['String']['output']>;
  dateArray: Array<Scalars['String']['output']>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  dateJdnArray: Array<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateArray: Array<Scalars['String']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  endDateJdnArray: Array<Scalars['Int']['output']>;
  geoLocationArray: Array<Scalars['jsonb']['output']>;
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  metadata: Scalars['jsonb']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameArray: Array<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  nameJaArray: Array<Scalars['String']['output']>;
  properties: Scalars['jsonb']['output'];
  recordIdArray: Array<Scalars['uuid']['output']>;
  recordType: Scalars['String']['output'];
  referenceArray: Array<Scalars['jsonb']['output']>;
  /** An object relationship */
  sourceCompoundEntity?: Maybe<CompoundCompoundRecords>;
  /** An array relationship */
  sourceCompoundRelations: Array<CompoundCompoundRecords>;
  /** An aggregate relationship */
  sourceCompoundRelationsAggregate: CompoundCompoundRecordsAggregate;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  targetCompoundEntity?: Maybe<CompoundCompoundRecords>;
  /** An array relationship */
  targetCompoundRelations: Array<CompoundCompoundRecords>;
  /** An aggregate relationship */
  targetCompoundRelationsAggregate: CompoundCompoundRecordsAggregate;
  targetId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamp']['output'];
  v: Scalars['String']['output'];
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsSourceCompoundRelationsArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsSourceCompoundRelationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsTargetCompoundRelationsArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


/** columns and relationships of "compound.compound_records" */
export type CompoundCompoundRecordsTargetCompoundRelationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};

/** aggregated selection of "compound.compound_records" */
export type CompoundCompoundRecordsAggregate = {
  __typename?: 'CompoundCompoundRecordsAggregate';
  aggregate?: Maybe<CompoundCompoundRecordsAggregateFields>;
  nodes: Array<CompoundCompoundRecords>;
};

export type CompoundCompoundRecordsAggregateBoolExp = {
  count?: InputMaybe<CompoundCompoundRecordsAggregateBoolExpCount>;
};

/** aggregate fields of "compound.compound_records" */
export type CompoundCompoundRecordsAggregateFields = {
  __typename?: 'CompoundCompoundRecordsAggregateFields';
  avg?: Maybe<CompoundCompoundRecordsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CompoundCompoundRecordsMaxFields>;
  min?: Maybe<CompoundCompoundRecordsMinFields>;
  stddev?: Maybe<CompoundCompoundRecordsStddevFields>;
  stddevPop?: Maybe<CompoundCompoundRecordsStddevPopFields>;
  stddevSamp?: Maybe<CompoundCompoundRecordsStddevSampFields>;
  sum?: Maybe<CompoundCompoundRecordsSumFields>;
  varPop?: Maybe<CompoundCompoundRecordsVarPopFields>;
  varSamp?: Maybe<CompoundCompoundRecordsVarSampFields>;
  variance?: Maybe<CompoundCompoundRecordsVarianceFields>;
};


/** aggregate fields of "compound.compound_records" */
export type CompoundCompoundRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "compound.compound_records" */
export type CompoundCompoundRecordsAggregateOrderBy = {
  avg?: InputMaybe<CompoundCompoundRecordsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CompoundCompoundRecordsMaxOrderBy>;
  min?: InputMaybe<CompoundCompoundRecordsMinOrderBy>;
  stddev?: InputMaybe<CompoundCompoundRecordsStddevOrderBy>;
  stddevPop?: InputMaybe<CompoundCompoundRecordsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<CompoundCompoundRecordsStddevSampOrderBy>;
  sum?: InputMaybe<CompoundCompoundRecordsSumOrderBy>;
  varPop?: InputMaybe<CompoundCompoundRecordsVarPopOrderBy>;
  varSamp?: InputMaybe<CompoundCompoundRecordsVarSampOrderBy>;
  variance?: InputMaybe<CompoundCompoundRecordsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CompoundCompoundRecordsAppendInput = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "compound.compound_records" */
export type CompoundCompoundRecordsArrRelInsertInput = {
  data: Array<CompoundCompoundRecordsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CompoundCompoundRecordsOnConflict>;
};

/** aggregate avg on columns */
export type CompoundCompoundRecordsAvgFields = {
  __typename?: 'CompoundCompoundRecordsAvgFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsAvgOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "compound.compound_records". All fields are combined with a logical 'AND'. */
export type CompoundCompoundRecordsBoolExp = {
  _and?: InputMaybe<Array<CompoundCompoundRecordsBoolExp>>;
  _not?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  _or?: InputMaybe<Array<CompoundCompoundRecordsBoolExp>>;
  categoryIdArray?: InputMaybe<UuidArrayComparisonExp>;
  categoryNameArray?: InputMaybe<StringArrayComparisonExp>;
  compoundRecordMetadataId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestampComparisonExp>;
  date?: InputMaybe<StringComparisonExp>;
  dateArray?: InputMaybe<StringArrayComparisonExp>;
  dateJdn?: InputMaybe<IntComparisonExp>;
  dateJdnArray?: InputMaybe<IntArrayComparisonExp>;
  endDate?: InputMaybe<StringComparisonExp>;
  endDateArray?: InputMaybe<StringArrayComparisonExp>;
  endDateJdn?: InputMaybe<IntComparisonExp>;
  endDateJdnArray?: InputMaybe<IntArrayComparisonExp>;
  geoLocationArray?: InputMaybe<JsonbArrayComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  nameArray?: InputMaybe<StringArrayComparisonExp>;
  nameJa?: InputMaybe<StringComparisonExp>;
  nameJaArray?: InputMaybe<StringArrayComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  recordIdArray?: InputMaybe<UuidArrayComparisonExp>;
  recordType?: InputMaybe<StringComparisonExp>;
  referenceArray?: InputMaybe<JsonbArrayComparisonExp>;
  sourceCompoundEntity?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  sourceCompoundRelations?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  sourceCompoundRelationsAggregate?: InputMaybe<CompoundCompoundRecordsAggregateBoolExp>;
  sourceId?: InputMaybe<UuidComparisonExp>;
  targetCompoundEntity?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  targetCompoundRelations?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  targetCompoundRelationsAggregate?: InputMaybe<CompoundCompoundRecordsAggregateBoolExp>;
  targetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestampComparisonExp>;
  v?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "compound.compound_records" */
export const CompoundCompoundRecordsConstraint = {
  /** unique or primary key constraint on columns "compound_record_metadata_id", "v" */
  CompoundRecordsCompoundRecordMetadataIdKey: 'compound_records_compound_record_metadata_id_key',
  /** unique or primary key constraint on columns "key", "v" */
  CompoundRecordsPkey: 'compound_records_pkey'
} as const;

export type CompoundCompoundRecordsConstraint = typeof CompoundCompoundRecordsConstraint[keyof typeof CompoundCompoundRecordsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CompoundCompoundRecordsDeleteAtPathInput = {
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CompoundCompoundRecordsDeleteElemInput = {
  metadata?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CompoundCompoundRecordsDeleteKeyInput = {
  metadata?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "compound.compound_records" */
export type CompoundCompoundRecordsIncInput = {
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "compound.compound_records" */
export type CompoundCompoundRecordsInsertInput = {
  categoryIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  categoryNameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  compoundRecordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  dateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  endDateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  geoLocationArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  nameJaArray?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  referenceArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  sourceCompoundEntity?: InputMaybe<CompoundCompoundRecordsObjRelInsertInput>;
  sourceCompoundRelations?: InputMaybe<CompoundCompoundRecordsArrRelInsertInput>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  targetCompoundEntity?: InputMaybe<CompoundCompoundRecordsObjRelInsertInput>;
  targetCompoundRelations?: InputMaybe<CompoundCompoundRecordsArrRelInsertInput>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  v?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CompoundCompoundRecordsMaxFields = {
  __typename?: 'CompoundCompoundRecordsMaxFields';
  categoryIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  categoryNameArray?: Maybe<Array<Scalars['String']['output']>>;
  compoundRecordMetadataId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateArray?: Maybe<Array<Scalars['String']['output']>>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  dateJdnArray?: Maybe<Array<Scalars['Int']['output']>>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateArray?: Maybe<Array<Scalars['String']['output']>>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  endDateJdnArray?: Maybe<Array<Scalars['Int']['output']>>;
  geoLocationArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameArray?: Maybe<Array<Scalars['String']['output']>>;
  nameJa?: Maybe<Scalars['String']['output']>;
  nameJaArray?: Maybe<Array<Scalars['String']['output']>>;
  recordIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  recordType?: Maybe<Scalars['String']['output']>;
  referenceArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  v?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsMaxOrderBy = {
  categoryIdArray?: InputMaybe<OrderBy>;
  categoryNameArray?: InputMaybe<OrderBy>;
  compoundRecordMetadataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  dateArray?: InputMaybe<OrderBy>;
  dateJdn?: InputMaybe<OrderBy>;
  dateJdnArray?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateArray?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
  endDateJdnArray?: InputMaybe<OrderBy>;
  geoLocationArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameArray?: InputMaybe<OrderBy>;
  nameJa?: InputMaybe<OrderBy>;
  nameJaArray?: InputMaybe<OrderBy>;
  recordIdArray?: InputMaybe<OrderBy>;
  recordType?: InputMaybe<OrderBy>;
  referenceArray?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  targetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  v?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CompoundCompoundRecordsMinFields = {
  __typename?: 'CompoundCompoundRecordsMinFields';
  categoryIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  categoryNameArray?: Maybe<Array<Scalars['String']['output']>>;
  compoundRecordMetadataId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamp']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateArray?: Maybe<Array<Scalars['String']['output']>>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  dateJdnArray?: Maybe<Array<Scalars['Int']['output']>>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateArray?: Maybe<Array<Scalars['String']['output']>>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  endDateJdnArray?: Maybe<Array<Scalars['Int']['output']>>;
  geoLocationArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameArray?: Maybe<Array<Scalars['String']['output']>>;
  nameJa?: Maybe<Scalars['String']['output']>;
  nameJaArray?: Maybe<Array<Scalars['String']['output']>>;
  recordIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  recordType?: Maybe<Scalars['String']['output']>;
  referenceArray?: Maybe<Array<Scalars['jsonb']['output']>>;
  sourceId?: Maybe<Scalars['uuid']['output']>;
  targetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamp']['output']>;
  v?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsMinOrderBy = {
  categoryIdArray?: InputMaybe<OrderBy>;
  categoryNameArray?: InputMaybe<OrderBy>;
  compoundRecordMetadataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  dateArray?: InputMaybe<OrderBy>;
  dateJdn?: InputMaybe<OrderBy>;
  dateJdnArray?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateArray?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
  endDateJdnArray?: InputMaybe<OrderBy>;
  geoLocationArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameArray?: InputMaybe<OrderBy>;
  nameJa?: InputMaybe<OrderBy>;
  nameJaArray?: InputMaybe<OrderBy>;
  recordIdArray?: InputMaybe<OrderBy>;
  recordType?: InputMaybe<OrderBy>;
  referenceArray?: InputMaybe<OrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  targetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  v?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "compound.compound_records" */
export type CompoundCompoundRecordsMutationResponse = {
  __typename?: 'CompoundCompoundRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompoundCompoundRecords>;
};

/** input type for inserting object relation for remote table "compound.compound_records" */
export type CompoundCompoundRecordsObjRelInsertInput = {
  data: CompoundCompoundRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompoundCompoundRecordsOnConflict>;
};

/** on_conflict condition type for table "compound.compound_records" */
export type CompoundCompoundRecordsOnConflict = {
  constraint: CompoundCompoundRecordsConstraint;
  updateColumns?: Array<CompoundCompoundRecordsUpdateColumn>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};

/** Ordering options when selecting data from "compound.compound_records". */
export type CompoundCompoundRecordsOrderBy = {
  categoryIdArray?: InputMaybe<OrderBy>;
  categoryNameArray?: InputMaybe<OrderBy>;
  compoundRecordMetadataId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  dateArray?: InputMaybe<OrderBy>;
  dateJdn?: InputMaybe<OrderBy>;
  dateJdnArray?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateArray?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
  endDateJdnArray?: InputMaybe<OrderBy>;
  geoLocationArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameArray?: InputMaybe<OrderBy>;
  nameJa?: InputMaybe<OrderBy>;
  nameJaArray?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  recordIdArray?: InputMaybe<OrderBy>;
  recordType?: InputMaybe<OrderBy>;
  referenceArray?: InputMaybe<OrderBy>;
  sourceCompoundEntity?: InputMaybe<CompoundCompoundRecordsOrderBy>;
  sourceCompoundRelationsAggregate?: InputMaybe<CompoundCompoundRecordsAggregateOrderBy>;
  sourceId?: InputMaybe<OrderBy>;
  targetCompoundEntity?: InputMaybe<CompoundCompoundRecordsOrderBy>;
  targetCompoundRelationsAggregate?: InputMaybe<CompoundCompoundRecordsAggregateOrderBy>;
  targetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  v?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: compound.compound_records */
export type CompoundCompoundRecordsPkColumnsInput = {
  key: Scalars['String']['input'];
  v: Scalars['String']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CompoundCompoundRecordsPrependInput = {
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "compound.compound_records" */
export const CompoundCompoundRecordsSelectColumn = {
  /** column name */
  CategoryIdArray: 'categoryIdArray',
  /** column name */
  CategoryNameArray: 'categoryNameArray',
  /** column name */
  CompoundRecordMetadataId: 'compoundRecordMetadataId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DateArray: 'dateArray',
  /** column name */
  DateJdn: 'dateJdn',
  /** column name */
  DateJdnArray: 'dateJdnArray',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  EndDateArray: 'endDateArray',
  /** column name */
  EndDateJdn: 'endDateJdn',
  /** column name */
  EndDateJdnArray: 'endDateJdnArray',
  /** column name */
  GeoLocationArray: 'geoLocationArray',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Name: 'name',
  /** column name */
  NameArray: 'nameArray',
  /** column name */
  NameJa: 'nameJa',
  /** column name */
  NameJaArray: 'nameJaArray',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordIdArray: 'recordIdArray',
  /** column name */
  RecordType: 'recordType',
  /** column name */
  ReferenceArray: 'referenceArray',
  /** column name */
  SourceId: 'sourceId',
  /** column name */
  TargetId: 'targetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  V: 'v'
} as const;

export type CompoundCompoundRecordsSelectColumn = typeof CompoundCompoundRecordsSelectColumn[keyof typeof CompoundCompoundRecordsSelectColumn];
/** input type for updating data in table "compound.compound_records" */
export type CompoundCompoundRecordsSetInput = {
  categoryIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  categoryNameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  compoundRecordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  dateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  endDateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  geoLocationArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  nameJaArray?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  referenceArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  v?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate stddev on columns */
export type CompoundCompoundRecordsStddevFields = {
  __typename?: 'CompoundCompoundRecordsStddevFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type CompoundCompoundRecordsStddevPopFields = {
  __typename?: 'CompoundCompoundRecordsStddevPopFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevPopOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type CompoundCompoundRecordsStddevSampFields = {
  __typename?: 'CompoundCompoundRecordsStddevSampFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsStddevSampOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "compound_compound_records" */
export type CompoundCompoundRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompoundCompoundRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompoundCompoundRecordsStreamCursorValueInput = {
  categoryIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  categoryNameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  compoundRecordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamp']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  dateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateArray?: InputMaybe<Array<Scalars['String']['input']>>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  endDateJdnArray?: InputMaybe<Array<Scalars['Int']['input']>>;
  geoLocationArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameArray?: InputMaybe<Array<Scalars['String']['input']>>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  nameJaArray?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  referenceArray?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  sourceId?: InputMaybe<Scalars['uuid']['input']>;
  targetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamp']['input']>;
  v?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate sum on columns */
export type CompoundCompoundRecordsSumFields = {
  __typename?: 'CompoundCompoundRecordsSumFields';
  dateJdn?: Maybe<Scalars['Int']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsSumOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** update columns of table "compound.compound_records" */
export const CompoundCompoundRecordsUpdateColumn = {
  /** column name */
  CategoryIdArray: 'categoryIdArray',
  /** column name */
  CategoryNameArray: 'categoryNameArray',
  /** column name */
  CompoundRecordMetadataId: 'compoundRecordMetadataId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DateArray: 'dateArray',
  /** column name */
  DateJdn: 'dateJdn',
  /** column name */
  DateJdnArray: 'dateJdnArray',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  EndDateArray: 'endDateArray',
  /** column name */
  EndDateJdn: 'endDateJdn',
  /** column name */
  EndDateJdnArray: 'endDateJdnArray',
  /** column name */
  GeoLocationArray: 'geoLocationArray',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Name: 'name',
  /** column name */
  NameArray: 'nameArray',
  /** column name */
  NameJa: 'nameJa',
  /** column name */
  NameJaArray: 'nameJaArray',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordIdArray: 'recordIdArray',
  /** column name */
  RecordType: 'recordType',
  /** column name */
  ReferenceArray: 'referenceArray',
  /** column name */
  SourceId: 'sourceId',
  /** column name */
  TargetId: 'targetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  V: 'v'
} as const;

export type CompoundCompoundRecordsUpdateColumn = typeof CompoundCompoundRecordsUpdateColumn[keyof typeof CompoundCompoundRecordsUpdateColumn];
export type CompoundCompoundRecordsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CompoundCompoundRecordsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CompoundCompoundRecordsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CompoundCompoundRecordsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CompoundCompoundRecordsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CompoundCompoundRecordsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CompoundCompoundRecordsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompoundCompoundRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: CompoundCompoundRecordsBoolExp;
};

/** aggregate varPop on columns */
export type CompoundCompoundRecordsVarPopFields = {
  __typename?: 'CompoundCompoundRecordsVarPopFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarPopOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type CompoundCompoundRecordsVarSampFields = {
  __typename?: 'CompoundCompoundRecordsVarSampFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarSampOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type CompoundCompoundRecordsVarianceFields = {
  __typename?: 'CompoundCompoundRecordsVarianceFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "compound.compound_records" */
export type CompoundCompoundRecordsVarianceOrderBy = {
  dateJdn?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
};

export type CompoundRecordComposer = {
  __typename?: 'CompoundRecordComposer';
  categoryId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['UUID']['output'];
  key: Scalars['String']['output'];
  properties: Scalars['JSON']['output'];
  recordType: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type CompoundRecordComposerBatchUpsertSuccessItem = {
  __typename?: 'CompoundRecordComposerBatchUpsertSuccessItem';
  compoundCandidateId: Scalars['UUID']['output'];
  id: Scalars['UUID']['output'];
  mainCandidateId: Scalars['UUID']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export const CompoundRecordComposerCandidateIdType = {
  RecordId: 'RECORD_ID',
  RecordMetadataId: 'RECORD_METADATA_ID'
} as const;

export type CompoundRecordComposerCandidateIdType = typeof CompoundRecordComposerCandidateIdType[keyof typeof CompoundRecordComposerCandidateIdType];
export type CompoundRecordComposerDeleteInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CompoundRecordComposerDeleteOutput = {
  __typename?: 'CompoundRecordComposerDeleteOutput';
  id: Scalars['UUID']['output'];
};

export type CompoundRecordComposerDeleteResponse = CompoundRecordComposerDeleteOutput | ValidationError;

export type CompoundRecordComposerFileUploadInput = {
  candidateIdType?: InputMaybe<CompoundRecordComposerCandidateIdType>;
  file: Scalars['Upload']['input'];
  tenantId: Scalars['UUID']['input'];
  uploadId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CompoundRecordComposerFileUploadOutput = {
  __typename?: 'CompoundRecordComposerFileUploadOutput';
  finalizeStatus?: Maybe<Scalars['String']['output']>;
  hasComposerDeletions: Scalars['Boolean']['output'];
  jobId?: Maybe<Scalars['UUID']['output']>;
  jobRunId?: Maybe<Scalars['UUID']['output']>;
  successfulComposers: Array<CompoundRecordComposerBatchUpsertSuccessItem>;
  targetComposerIds: Array<Scalars['UUID']['output']>;
  totalProcessed: Scalars['Int']['output'];
  updateMode?: Maybe<Scalars['String']['output']>;
  uploadId?: Maybe<Scalars['UUID']['output']>;
};

export type CompoundRecordComposerFileUploadResponse = CompoundRecordComposerFileUploadOutput | ValidationError;

export type CompoundRecordComposerGetInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type CompoundRecordComposerGetOutput = {
  __typename?: 'CompoundRecordComposerGetOutput';
  compoundRecordComposer: CompoundRecordComposer;
};

export type CompoundRecordComposerGetResponse = CompoundRecordComposerGetOutput | ValidationError;

/** columns and relationships of "compound_record_composers" */
export type CompoundRecordComposers = {
  __typename?: 'CompoundRecordComposers';
  categoryId: Scalars['uuid']['output'];
  compoundRecordMetadataComposerId?: Maybe<Scalars['uuid']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  key: Scalars['String']['output'];
  properties: Scalars['jsonb']['output'];
  /** An array relationship */
  recordCompoundRecordComposers: Array<RecordCompoundRecordComposers>;
  /** An aggregate relationship */
  recordCompoundRecordComposersAggregate: RecordCompoundRecordComposersAggregate;
  recordType: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "compound_record_composers" */
export type CompoundRecordComposersPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "compound_record_composers" */
export type CompoundRecordComposersRecordCompoundRecordComposersArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


/** columns and relationships of "compound_record_composers" */
export type CompoundRecordComposersRecordCompoundRecordComposersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};

/** aggregated selection of "compound_record_composers" */
export type CompoundRecordComposersAggregate = {
  __typename?: 'CompoundRecordComposersAggregate';
  aggregate?: Maybe<CompoundRecordComposersAggregateFields>;
  nodes: Array<CompoundRecordComposers>;
};

/** aggregate fields of "compound_record_composers" */
export type CompoundRecordComposersAggregateFields = {
  __typename?: 'CompoundRecordComposersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompoundRecordComposersMaxFields>;
  min?: Maybe<CompoundRecordComposersMinFields>;
};


/** aggregate fields of "compound_record_composers" */
export type CompoundRecordComposersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompoundRecordComposersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type CompoundRecordComposersAppendInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "compound_record_composers". All fields are combined with a logical 'AND'. */
export type CompoundRecordComposersBoolExp = {
  _and?: InputMaybe<Array<CompoundRecordComposersBoolExp>>;
  _not?: InputMaybe<CompoundRecordComposersBoolExp>;
  _or?: InputMaybe<Array<CompoundRecordComposersBoolExp>>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  compoundRecordMetadataComposerId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  key?: InputMaybe<StringComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  recordCompoundRecordComposers?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
  recordCompoundRecordComposersAggregate?: InputMaybe<RecordCompoundRecordComposersAggregateBoolExp>;
  recordType?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "compound_record_composers" */
export const CompoundRecordComposersConstraint = {
  /** unique or primary key constraint on columns "key" */
  CompoundRecordComposersKeyKey: 'compound_record_composers_key_key',
  /** unique or primary key constraint on columns "id" */
  CompoundRecordComposersPkey: 'compound_record_composers_pkey',
  /** unique or primary key constraint on columns "compound_record_metadata_composer_id" */
  CrcCrmcIdKey: 'crc_crmc_id_key'
} as const;

export type CompoundRecordComposersConstraint = typeof CompoundRecordComposersConstraint[keyof typeof CompoundRecordComposersConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type CompoundRecordComposersDeleteAtPathInput = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type CompoundRecordComposersDeleteElemInput = {
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type CompoundRecordComposersDeleteKeyInput = {
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "compound_record_composers" */
export type CompoundRecordComposersInsertInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  compoundRecordMetadataComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordCompoundRecordComposers?: InputMaybe<RecordCompoundRecordComposersArrRelInsertInput>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type CompoundRecordComposersListInput = {
  categoryIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  idsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  keysFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Scalars['String']['input']>;
  recordTypesFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type CompoundRecordComposersListOutput = {
  __typename?: 'CompoundRecordComposersListOutput';
  compoundRecordComposers: Array<CompoundRecordComposer>;
};

export type CompoundRecordComposersListResponse = CompoundRecordComposersListOutput | ValidationError;

/** aggregate max on columns */
export type CompoundRecordComposersMaxFields = {
  __typename?: 'CompoundRecordComposersMaxFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  compoundRecordMetadataComposerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type CompoundRecordComposersMinFields = {
  __typename?: 'CompoundRecordComposersMinFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  compoundRecordMetadataComposerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  key?: Maybe<Scalars['String']['output']>;
  recordType?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "compound_record_composers" */
export type CompoundRecordComposersMutationResponse = {
  __typename?: 'CompoundRecordComposersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompoundRecordComposers>;
};

/** input type for inserting object relation for remote table "compound_record_composers" */
export type CompoundRecordComposersObjRelInsertInput = {
  data: CompoundRecordComposersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CompoundRecordComposersOnConflict>;
};

/** on_conflict condition type for table "compound_record_composers" */
export type CompoundRecordComposersOnConflict = {
  constraint: CompoundRecordComposersConstraint;
  updateColumns?: Array<CompoundRecordComposersUpdateColumn>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};

/** Ordering options when selecting data from "compound_record_composers". */
export type CompoundRecordComposersOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  compoundRecordMetadataComposerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  key?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  recordCompoundRecordComposersAggregate?: InputMaybe<RecordCompoundRecordComposersAggregateOrderBy>;
  recordType?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: compound_record_composers */
export type CompoundRecordComposersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type CompoundRecordComposersPrependInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "compound_record_composers" */
export const CompoundRecordComposersSelectColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CompoundRecordMetadataComposerId: 'compoundRecordMetadataComposerId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordType: 'recordType',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CompoundRecordComposersSelectColumn = typeof CompoundRecordComposersSelectColumn[keyof typeof CompoundRecordComposersSelectColumn];
/** input type for updating data in table "compound_record_composers" */
export type CompoundRecordComposersSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  compoundRecordMetadataComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "compound_record_composers" */
export type CompoundRecordComposersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompoundRecordComposersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompoundRecordComposersStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  compoundRecordMetadataComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  key?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordType?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "compound_record_composers" */
export const CompoundRecordComposersUpdateColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CompoundRecordMetadataComposerId: 'compoundRecordMetadataComposerId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Key: 'key',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordType: 'recordType',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type CompoundRecordComposersUpdateColumn = typeof CompoundRecordComposersUpdateColumn[keyof typeof CompoundRecordComposersUpdateColumn];
export type CompoundRecordComposersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<CompoundRecordComposersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<CompoundRecordComposersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<CompoundRecordComposersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<CompoundRecordComposersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<CompoundRecordComposersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompoundRecordComposersSetInput>;
  /** filter the rows which have to be updated */
  where: CompoundRecordComposersBoolExp;
};

export type CompoundRecordEvidencesGetByCompoundRecordIdsInput = {
  compoundRecordIds: Array<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type CompoundRecordEvidencesGetByCompoundRecordIdsOutput = {
  __typename?: 'CompoundRecordEvidencesGetByCompoundRecordIdsOutput';
  compoundRecords: Array<CompoundRecordEvidencesGetOutput>;
};

export type CompoundRecordEvidencesGetByCompoundRecordIdsResponse = CompoundRecordEvidencesGetByCompoundRecordIdsOutput | ValidationError;

export type CompoundRecordEvidencesGetInput = {
  compoundRecordId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type CompoundRecordEvidencesGetOutput = {
  __typename?: 'CompoundRecordEvidencesGetOutput';
  compoundRecordId: Scalars['UUID']['output'];
  records: Array<RecordWithEvidences>;
  version: Scalars['String']['output'];
};

export type CompoundRecordEvidencesGetResponse = CompoundRecordEvidencesGetOutput | ValidationError;

export type CompoundRecordVersionCreateInput = {
  tenantId: Scalars['UUID']['input'];
  version: Scalars['String']['input'];
};

export type CompoundRecordVersionCreateOutput = {
  __typename?: 'CompoundRecordVersionCreateOutput';
  id: Scalars['UUID']['output'];
};

export type CompoundRecordVersionCreateResponse = CompoundRecordVersionCreateOutput | ValidationError;

/** columns and relationships of "compound_record_versions" */
export type CompoundRecordVersions = {
  __typename?: 'CompoundRecordVersions';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  version: Scalars['String']['output'];
};

/** aggregated selection of "compound_record_versions" */
export type CompoundRecordVersionsAggregate = {
  __typename?: 'CompoundRecordVersionsAggregate';
  aggregate?: Maybe<CompoundRecordVersionsAggregateFields>;
  nodes: Array<CompoundRecordVersions>;
};

/** aggregate fields of "compound_record_versions" */
export type CompoundRecordVersionsAggregateFields = {
  __typename?: 'CompoundRecordVersionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CompoundRecordVersionsMaxFields>;
  min?: Maybe<CompoundRecordVersionsMinFields>;
};


/** aggregate fields of "compound_record_versions" */
export type CompoundRecordVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CompoundRecordVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "compound_record_versions". All fields are combined with a logical 'AND'. */
export type CompoundRecordVersionsBoolExp = {
  _and?: InputMaybe<Array<CompoundRecordVersionsBoolExp>>;
  _not?: InputMaybe<CompoundRecordVersionsBoolExp>;
  _or?: InputMaybe<Array<CompoundRecordVersionsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "compound_record_versions" */
export const CompoundRecordVersionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  CompoundRecordVersionsPkey: 'compound_record_versions_pkey',
  /** unique or primary key constraint on columns "version" */
  CompoundRecordVersionsVersionKey: 'compound_record_versions_version_key'
} as const;

export type CompoundRecordVersionsConstraint = typeof CompoundRecordVersionsConstraint[keyof typeof CompoundRecordVersionsConstraint];
/** input type for inserting data into table "compound_record_versions" */
export type CompoundRecordVersionsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CompoundRecordVersionsMaxFields = {
  __typename?: 'CompoundRecordVersionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** aggregate min on columns */
export type CompoundRecordVersionsMinFields = {
  __typename?: 'CompoundRecordVersionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['String']['output']>;
};

/** response of any mutation on the table "compound_record_versions" */
export type CompoundRecordVersionsMutationResponse = {
  __typename?: 'CompoundRecordVersionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CompoundRecordVersions>;
};

/** on_conflict condition type for table "compound_record_versions" */
export type CompoundRecordVersionsOnConflict = {
  constraint: CompoundRecordVersionsConstraint;
  updateColumns?: Array<CompoundRecordVersionsUpdateColumn>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};

/** Ordering options when selecting data from "compound_record_versions". */
export type CompoundRecordVersionsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: compound_record_versions */
export type CompoundRecordVersionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "compound_record_versions" */
export const CompoundRecordVersionsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Version: 'version'
} as const;

export type CompoundRecordVersionsSelectColumn = typeof CompoundRecordVersionsSelectColumn[keyof typeof CompoundRecordVersionsSelectColumn];
/** input type for updating data in table "compound_record_versions" */
export type CompoundRecordVersionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "compound_record_versions" */
export type CompoundRecordVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CompoundRecordVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CompoundRecordVersionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "compound_record_versions" */
export const CompoundRecordVersionsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Version: 'version'
} as const;

export type CompoundRecordVersionsUpdateColumn = typeof CompoundRecordVersionsUpdateColumn[keyof typeof CompoundRecordVersionsUpdateColumn];
export type CompoundRecordVersionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CompoundRecordVersionsSetInput>;
  /** filter the rows which have to be updated */
  where: CompoundRecordVersionsBoolExp;
};

/** columns and relationships of "countries" */
export type Countries = {
  __typename?: 'Countries';
  alpha3: Scalars['String']['output'];
  /** An object relationship */
  areaCode?: Maybe<AreaCodes>;
  /** An array relationship */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** An aggregate relationship */
  countrySubdivisionsAggregate: CountrySubdivisionsAggregate;
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  numeric: Scalars['Int']['output'];
};


/** columns and relationships of "countries" */
export type CountriesCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


/** columns and relationships of "countries" */
export type CountriesCountrySubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};

/** aggregated selection of "countries" */
export type CountriesAggregate = {
  __typename?: 'CountriesAggregate';
  aggregate?: Maybe<CountriesAggregateFields>;
  nodes: Array<Countries>;
};

/** aggregate fields of "countries" */
export type CountriesAggregateFields = {
  __typename?: 'CountriesAggregateFields';
  avg?: Maybe<CountriesAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<CountriesMaxFields>;
  min?: Maybe<CountriesMinFields>;
  stddev?: Maybe<CountriesStddevFields>;
  stddevPop?: Maybe<CountriesStddevPopFields>;
  stddevSamp?: Maybe<CountriesStddevSampFields>;
  sum?: Maybe<CountriesSumFields>;
  varPop?: Maybe<CountriesVarPopFields>;
  varSamp?: Maybe<CountriesVarSampFields>;
  variance?: Maybe<CountriesVarianceFields>;
};


/** aggregate fields of "countries" */
export type CountriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type CountriesAvgFields = {
  __typename?: 'CountriesAvgFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "countries". All fields are combined with a logical 'AND'. */
export type CountriesBoolExp = {
  _and?: InputMaybe<Array<CountriesBoolExp>>;
  _not?: InputMaybe<CountriesBoolExp>;
  _or?: InputMaybe<Array<CountriesBoolExp>>;
  alpha3?: InputMaybe<StringComparisonExp>;
  areaCode?: InputMaybe<AreaCodesBoolExp>;
  countrySubdivisions?: InputMaybe<CountrySubdivisionsBoolExp>;
  countrySubdivisionsAggregate?: InputMaybe<CountrySubdivisionsAggregateBoolExp>;
  id?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  numeric?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "countries" */
export const CountriesConstraint = {
  /** unique or primary key constraint on columns "alpha2" */
  CountriesPkey: 'countries_pkey'
} as const;

export type CountriesConstraint = typeof CountriesConstraint[keyof typeof CountriesConstraint];
/** input type for incrementing numeric columns in table "countries" */
export type CountriesIncInput = {
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "countries" */
export type CountriesInsertInput = {
  alpha3?: InputMaybe<Scalars['String']['input']>;
  areaCode?: InputMaybe<AreaCodesObjRelInsertInput>;
  countrySubdivisions?: InputMaybe<CountrySubdivisionsArrRelInsertInput>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type CountriesMaxFields = {
  __typename?: 'CountriesMaxFields';
  alpha3?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type CountriesMinFields = {
  __typename?: 'CountriesMinFields';
  alpha3?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  numeric?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "countries" */
export type CountriesMutationResponse = {
  __typename?: 'CountriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Countries>;
};

/** input type for inserting object relation for remote table "countries" */
export type CountriesObjRelInsertInput = {
  data: CountriesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<CountriesOnConflict>;
};

/** on_conflict condition type for table "countries" */
export type CountriesOnConflict = {
  constraint: CountriesConstraint;
  updateColumns?: Array<CountriesUpdateColumn>;
  where?: InputMaybe<CountriesBoolExp>;
};

/** Ordering options when selecting data from "countries". */
export type CountriesOrderBy = {
  alpha3?: InputMaybe<OrderBy>;
  areaCode?: InputMaybe<AreaCodesOrderBy>;
  countrySubdivisionsAggregate?: InputMaybe<CountrySubdivisionsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  numeric?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: countries */
export type CountriesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "countries" */
export const CountriesSelectColumn = {
  /** column name */
  Alpha3: 'alpha3',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Numeric: 'numeric'
} as const;

export type CountriesSelectColumn = typeof CountriesSelectColumn[keyof typeof CountriesSelectColumn];
/** input type for updating data in table "countries" */
export type CountriesSetInput = {
  alpha3?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type CountriesStddevFields = {
  __typename?: 'CountriesStddevFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type CountriesStddevPopFields = {
  __typename?: 'CountriesStddevPopFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type CountriesStddevSampFields = {
  __typename?: 'CountriesStddevSampFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "countries" */
export type CountriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountriesStreamCursorValueInput = {
  alpha3?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  numeric?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type CountriesSumFields = {
  __typename?: 'CountriesSumFields';
  numeric?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "countries" */
export const CountriesUpdateColumn = {
  /** column name */
  Alpha3: 'alpha3',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Numeric: 'numeric'
} as const;

export type CountriesUpdateColumn = typeof CountriesUpdateColumn[keyof typeof CountriesUpdateColumn];
export type CountriesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<CountriesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountriesSetInput>;
  /** filter the rows which have to be updated */
  where: CountriesBoolExp;
};

/** aggregate varPop on columns */
export type CountriesVarPopFields = {
  __typename?: 'CountriesVarPopFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type CountriesVarSampFields = {
  __typename?: 'CountriesVarSampFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type CountriesVarianceFields = {
  __typename?: 'CountriesVarianceFields';
  numeric?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "country_subdivisions" */
export type CountrySubdivisions = {
  __typename?: 'CountrySubdivisions';
  code: Scalars['String']['output'];
  /** An object relationship */
  country: Countries;
  countryId: Scalars['String']['output'];
  name: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

/** aggregated selection of "country_subdivisions" */
export type CountrySubdivisionsAggregate = {
  __typename?: 'CountrySubdivisionsAggregate';
  aggregate?: Maybe<CountrySubdivisionsAggregateFields>;
  nodes: Array<CountrySubdivisions>;
};

export type CountrySubdivisionsAggregateBoolExp = {
  count?: InputMaybe<CountrySubdivisionsAggregateBoolExpCount>;
};

/** aggregate fields of "country_subdivisions" */
export type CountrySubdivisionsAggregateFields = {
  __typename?: 'CountrySubdivisionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<CountrySubdivisionsMaxFields>;
  min?: Maybe<CountrySubdivisionsMinFields>;
};


/** aggregate fields of "country_subdivisions" */
export type CountrySubdivisionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "country_subdivisions" */
export type CountrySubdivisionsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<CountrySubdivisionsMaxOrderBy>;
  min?: InputMaybe<CountrySubdivisionsMinOrderBy>;
};

/** input type for inserting array relation for remote table "country_subdivisions" */
export type CountrySubdivisionsArrRelInsertInput = {
  data: Array<CountrySubdivisionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};

/** Boolean expression to filter rows from the table "country_subdivisions". All fields are combined with a logical 'AND'. */
export type CountrySubdivisionsBoolExp = {
  _and?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  _not?: InputMaybe<CountrySubdivisionsBoolExp>;
  _or?: InputMaybe<Array<CountrySubdivisionsBoolExp>>;
  code?: InputMaybe<StringComparisonExp>;
  country?: InputMaybe<CountriesBoolExp>;
  countryId?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  type?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "country_subdivisions" */
export const CountrySubdivisionsConstraint = {
  /** unique or primary key constraint on columns "code" */
  CountrySubdivisionsPkey: 'country_subdivisions_pkey'
} as const;

export type CountrySubdivisionsConstraint = typeof CountrySubdivisionsConstraint[keyof typeof CountrySubdivisionsConstraint];
/** input type for inserting data into table "country_subdivisions" */
export type CountrySubdivisionsInsertInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<CountriesObjRelInsertInput>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type CountrySubdivisionsMaxFields = {
  __typename?: 'CountrySubdivisionsMaxFields';
  code?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMaxOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type CountrySubdivisionsMinFields = {
  __typename?: 'CountrySubdivisionsMinFields';
  code?: Maybe<Scalars['String']['output']>;
  countryId?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "country_subdivisions" */
export type CountrySubdivisionsMinOrderBy = {
  code?: InputMaybe<OrderBy>;
  countryId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "country_subdivisions" */
export type CountrySubdivisionsMutationResponse = {
  __typename?: 'CountrySubdivisionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<CountrySubdivisions>;
};

/** on_conflict condition type for table "country_subdivisions" */
export type CountrySubdivisionsOnConflict = {
  constraint: CountrySubdivisionsConstraint;
  updateColumns?: Array<CountrySubdivisionsUpdateColumn>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};

/** Ordering options when selecting data from "country_subdivisions". */
export type CountrySubdivisionsOrderBy = {
  code?: InputMaybe<OrderBy>;
  country?: InputMaybe<CountriesOrderBy>;
  countryId?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  type?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: country_subdivisions */
export type CountrySubdivisionsPkColumnsInput = {
  code: Scalars['String']['input'];
};

/** select columns of table "country_subdivisions" */
export const CountrySubdivisionsSelectColumn = {
  /** column name */
  Code: 'code',
  /** column name */
  CountryId: 'countryId',
  /** column name */
  Name: 'name',
  /** column name */
  Type: 'type'
} as const;

export type CountrySubdivisionsSelectColumn = typeof CountrySubdivisionsSelectColumn[keyof typeof CountrySubdivisionsSelectColumn];
/** input type for updating data in table "country_subdivisions" */
export type CountrySubdivisionsSetInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "country_subdivisions" */
export type CountrySubdivisionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: CountrySubdivisionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type CountrySubdivisionsStreamCursorValueInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  countryId?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "country_subdivisions" */
export const CountrySubdivisionsUpdateColumn = {
  /** column name */
  Code: 'code',
  /** column name */
  CountryId: 'countryId',
  /** column name */
  Name: 'name',
  /** column name */
  Type: 'type'
} as const;

export type CountrySubdivisionsUpdateColumn = typeof CountrySubdivisionsUpdateColumn[keyof typeof CountrySubdivisionsUpdateColumn];
export type CountrySubdivisionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  /** filter the rows which have to be updated */
  where: CountrySubdivisionsBoolExp;
};

/** ordering argument of a cursor */
export const CursorOrdering = {
  /** ascending ordering of the cursor */
  Asc: 'ASC',
  /** descending ordering of the cursor */
  Desc: 'DESC'
} as const;

export type CursorOrdering = typeof CursorOrdering[keyof typeof CursorOrdering];
export type DataImportPipelineJobSubmitInput = {
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  batchChangeRequestsJobIds: Array<Scalars['UUID']['input']>;
  batchEvidencesJobIds: Array<Scalars['UUID']['input']>;
  deactivateUnderivedRecords?: InputMaybe<Scalars['Boolean']['input']>;
  dispatchTarget?: InputMaybe<DispatchTarget>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  dryRunOptions?: InputMaybe<DryRunOptions>;
  logLevel?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
  underivedRecordDeactivationCap?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportPipelineJobSubmitOutput = {
  __typename?: 'DataImportPipelineJobSubmitOutput';
  batchChangeRequestsJobs: Array<JobExecution>;
  batchEvidencesJobs: Array<JobExecution>;
  jobRunId: Scalars['UUID']['output'];
};

export type DataImportPipelineJobSubmitResponse = ClientError | DataImportPipelineJobSubmitOutput;

export type DataImportProjectActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataImportProjectActivateOutput = {
  __typename?: 'DataImportProjectActivateOutput';
  id: Scalars['UUID']['output'];
};

export type DataImportProjectAddMembersInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};

export type DataImportProjectAddMembersOutput = {
  __typename?: 'DataImportProjectAddMembersOutput';
  id: Scalars['UUID']['output'];
};

export type DataImportProjectAddMembersResponse = DataImportProjectAddMembersOutput | ValidationError;

export type DataImportProjectBootstrapInput = {
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  dataSourcePropertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  dataSourceTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  description: Scalars['String']['input'];
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  jsonData?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  referenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tenantId: Scalars['UUID']['input'];
  userIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportProjectBootstrapOutput = {
  __typename?: 'DataImportProjectBootstrapOutput';
  id: Scalars['UUID']['output'];
};

export type DataImportProjectBootstrapResponse = DataImportProjectBootstrapOutput | ValidationError;

export type DataImportProjectCreateInput = {
  description: Scalars['String']['input'];
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  userIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type DataImportProjectCreateOutput = {
  __typename?: 'DataImportProjectCreateOutput';
  id: Scalars['UUID']['output'];
};

export type DataImportProjectCreateResponse = DataImportProjectCreateOutput | ValidationError;

export type DataImportProjectDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataImportProjectDeactivateOutput = {
  __typename?: 'DataImportProjectDeactivateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitions = {
  __typename?: 'DataImportProjectRecordComposerDefinitions';
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsAggregate = {
  __typename?: 'DataImportProjectRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<DataImportProjectRecordComposerDefinitionsAggregateFields>;
  nodes: Array<DataImportProjectRecordComposerDefinitions>;
};

/** aggregate fields of "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsAggregateFields = {
  __typename?: 'DataImportProjectRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataImportProjectRecordComposerDefinitionsMaxFields>;
  min?: Maybe<DataImportProjectRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsBoolExp>>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "data_import_project_record_composer_definitions" */
export const DataImportProjectRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id", "data_import_project_id" */
  DataImportProjectRecordComposerDefinitionsPkey: 'data_import_project_record_composer_definitions_pkey',
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  DataImportProjectRecordComposerDefinitionsRecordCompKey: 'data_import_project_record_composer_definitions_record_comp_key'
} as const;

export type DataImportProjectRecordComposerDefinitionsConstraint = typeof DataImportProjectRecordComposerDefinitionsConstraint[keyof typeof DataImportProjectRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsInsertInput = {
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DataImportProjectRecordComposerDefinitionsMaxFields = {
  __typename?: 'DataImportProjectRecordComposerDefinitionsMaxFields';
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type DataImportProjectRecordComposerDefinitionsMinFields = {
  __typename?: 'DataImportProjectRecordComposerDefinitionsMinFields';
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsMutationResponse = {
  __typename?: 'DataImportProjectRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataImportProjectRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsObjRelInsertInput = {
  data: DataImportProjectRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataImportProjectRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsOnConflict = {
  constraint: DataImportProjectRecordComposerDefinitionsConstraint;
  updateColumns?: Array<DataImportProjectRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "data_import_project_record_composer_definitions". */
export type DataImportProjectRecordComposerDefinitionsOrderBy = {
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_import_project_record_composer_definitions */
export type DataImportProjectRecordComposerDefinitionsPkColumnsInput = {
  dataImportProjectId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "data_import_project_record_composer_definitions" */
export const DataImportProjectRecordComposerDefinitionsSelectColumn = {
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataImportProjectRecordComposerDefinitionsSelectColumn = typeof DataImportProjectRecordComposerDefinitionsSelectColumn[keyof typeof DataImportProjectRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsSetInput = {
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "data_import_project_record_composer_definitions" */
export type DataImportProjectRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataImportProjectRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataImportProjectRecordComposerDefinitionsStreamCursorValueInput = {
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "data_import_project_record_composer_definitions" */
export const DataImportProjectRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataImportProjectRecordComposerDefinitionsUpdateColumn = typeof DataImportProjectRecordComposerDefinitionsUpdateColumn[keyof typeof DataImportProjectRecordComposerDefinitionsUpdateColumn];
export type DataImportProjectRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataImportProjectRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: DataImportProjectRecordComposerDefinitionsBoolExp;
};

export const DataImportProjectReviewStatus = {
  DataApproval: 'DataApproval',
  DataInput: 'DataInput',
  Done: 'Done',
  ErComposition: 'ERComposition',
  EvidenceImport: 'EvidenceImport',
  Inbox: 'Inbox',
  Planning: 'Planning'
} as const;

export type DataImportProjectReviewStatus = typeof DataImportProjectReviewStatus[keyof typeof DataImportProjectReviewStatus];
/** columns and relationships of "data_import_project_status_logs" */
export type DataImportProjectStatusLogs = {
  __typename?: 'DataImportProjectStatusLogs';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  dataImportProjectStatus: DataImportProjectStatuses;
  id: Scalars['uuid']['output'];
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_import_project_status_logs" */
export type DataImportProjectStatusLogsAggregate = {
  __typename?: 'DataImportProjectStatusLogsAggregate';
  aggregate?: Maybe<DataImportProjectStatusLogsAggregateFields>;
  nodes: Array<DataImportProjectStatusLogs>;
};

export type DataImportProjectStatusLogsAggregateBoolExp = {
  count?: InputMaybe<DataImportProjectStatusLogsAggregateBoolExpCount>;
};

/** aggregate fields of "data_import_project_status_logs" */
export type DataImportProjectStatusLogsAggregateFields = {
  __typename?: 'DataImportProjectStatusLogsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataImportProjectStatusLogsMaxFields>;
  min?: Maybe<DataImportProjectStatusLogsMinFields>;
};


/** aggregate fields of "data_import_project_status_logs" */
export type DataImportProjectStatusLogsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataImportProjectStatusLogsMaxOrderBy>;
  min?: InputMaybe<DataImportProjectStatusLogsMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsArrRelInsertInput = {
  data: Array<DataImportProjectStatusLogsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataImportProjectStatusLogsOnConflict>;
};

/** Boolean expression to filter rows from the table "data_import_project_status_logs". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusLogsBoolExp = {
  _and?: InputMaybe<Array<DataImportProjectStatusLogsBoolExp>>;
  _not?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
  _or?: InputMaybe<Array<DataImportProjectStatusLogsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_import_project_status_logs" */
export const DataImportProjectStatusLogsConstraint = {
  /** unique or primary key constraint on columns "status_id", "data_import_project_id" */
  DataImportProjectStatusLogsDataImportProjectIdStatKey: 'data_import_project_status_logs_data_import_project_id_stat_key',
  /** unique or primary key constraint on columns "id" */
  DataImportProjectStatusLogsPkey: 'data_import_project_status_logs_pkey'
} as const;

export type DataImportProjectStatusLogsConstraint = typeof DataImportProjectStatusLogsConstraint[keyof typeof DataImportProjectStatusLogsConstraint];
/** input type for inserting data into table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataImportProjectStatusLogsMaxFields = {
  __typename?: 'DataImportProjectStatusLogsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataImportProjectStatusLogsMinFields = {
  __typename?: 'DataImportProjectStatusLogsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsMutationResponse = {
  __typename?: 'DataImportProjectStatusLogsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataImportProjectStatusLogs>;
};

/** on_conflict condition type for table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsOnConflict = {
  constraint: DataImportProjectStatusLogsConstraint;
  updateColumns?: Array<DataImportProjectStatusLogsUpdateColumn>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};

/** Ordering options when selecting data from "data_import_project_status_logs". */
export type DataImportProjectStatusLogsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesOrderBy>;
  id?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_import_project_status_logs */
export type DataImportProjectStatusLogsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "data_import_project_status_logs" */
export const DataImportProjectStatusLogsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  Id: 'id',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectStatusLogsSelectColumn = typeof DataImportProjectStatusLogsSelectColumn[keyof typeof DataImportProjectStatusLogsSelectColumn];
/** input type for updating data in table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_import_project_status_logs" */
export type DataImportProjectStatusLogsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataImportProjectStatusLogsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataImportProjectStatusLogsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_import_project_status_logs" */
export const DataImportProjectStatusLogsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  Id: 'id',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectStatusLogsUpdateColumn = typeof DataImportProjectStatusLogsUpdateColumn[keyof typeof DataImportProjectStatusLogsUpdateColumn];
export type DataImportProjectStatusLogsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataImportProjectStatusLogsSetInput>;
  /** filter the rows which have to be updated */
  where: DataImportProjectStatusLogsBoolExp;
};

export type DataImportProjectStatusUpdateInput = {
  id: Scalars['UUID']['input'];
  statusId: DataImportProjectReviewStatus;
  tenantId: Scalars['UUID']['input'];
};

export type DataImportProjectStatusUpdateOutput = {
  __typename?: 'DataImportProjectStatusUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "data_import_project_statuses" */
export type DataImportProjectStatuses = {
  __typename?: 'DataImportProjectStatuses';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_import_project_statuses" */
export type DataImportProjectStatusesAggregate = {
  __typename?: 'DataImportProjectStatusesAggregate';
  aggregate?: Maybe<DataImportProjectStatusesAggregateFields>;
  nodes: Array<DataImportProjectStatuses>;
};

/** aggregate fields of "data_import_project_statuses" */
export type DataImportProjectStatusesAggregateFields = {
  __typename?: 'DataImportProjectStatusesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataImportProjectStatusesMaxFields>;
  min?: Maybe<DataImportProjectStatusesMinFields>;
};


/** aggregate fields of "data_import_project_statuses" */
export type DataImportProjectStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataImportProjectStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_import_project_statuses". All fields are combined with a logical 'AND'. */
export type DataImportProjectStatusesBoolExp = {
  _and?: InputMaybe<Array<DataImportProjectStatusesBoolExp>>;
  _not?: InputMaybe<DataImportProjectStatusesBoolExp>;
  _or?: InputMaybe<Array<DataImportProjectStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_import_project_statuses" */
export const DataImportProjectStatusesConstraint = {
  /** unique or primary key constraint on columns "id" */
  DataImportProjectStatusesPkey: 'data_import_project_statuses_pkey'
} as const;

export type DataImportProjectStatusesConstraint = typeof DataImportProjectStatusesConstraint[keyof typeof DataImportProjectStatusesConstraint];
/** input type for inserting data into table "data_import_project_statuses" */
export type DataImportProjectStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataImportProjectStatusesMaxFields = {
  __typename?: 'DataImportProjectStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DataImportProjectStatusesMinFields = {
  __typename?: 'DataImportProjectStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "data_import_project_statuses" */
export type DataImportProjectStatusesMutationResponse = {
  __typename?: 'DataImportProjectStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataImportProjectStatuses>;
};

/** input type for inserting object relation for remote table "data_import_project_statuses" */
export type DataImportProjectStatusesObjRelInsertInput = {
  data: DataImportProjectStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataImportProjectStatusesOnConflict>;
};

/** on_conflict condition type for table "data_import_project_statuses" */
export type DataImportProjectStatusesOnConflict = {
  constraint: DataImportProjectStatusesConstraint;
  updateColumns?: Array<DataImportProjectStatusesUpdateColumn>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};

/** Ordering options when selecting data from "data_import_project_statuses". */
export type DataImportProjectStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_import_project_statuses */
export type DataImportProjectStatusesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "data_import_project_statuses" */
export const DataImportProjectStatusesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectStatusesSelectColumn = typeof DataImportProjectStatusesSelectColumn[keyof typeof DataImportProjectStatusesSelectColumn];
/** input type for updating data in table "data_import_project_statuses" */
export type DataImportProjectStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_import_project_statuses" */
export type DataImportProjectStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataImportProjectStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataImportProjectStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_import_project_statuses" */
export const DataImportProjectStatusesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectStatusesUpdateColumn = typeof DataImportProjectStatusesUpdateColumn[keyof typeof DataImportProjectStatusesUpdateColumn];
export type DataImportProjectStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataImportProjectStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: DataImportProjectStatusesBoolExp;
};

export type DataImportProjectUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  statusId?: InputMaybe<DataImportProjectReviewStatus>;
  tenantId: Scalars['UUID']['input'];
  userIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type DataImportProjectUpdateOutput = {
  __typename?: 'DataImportProjectUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "data_import_project_users" */
export type DataImportProjectUsers = {
  __typename?: 'DataImportProjectUsers';
  createdAt: Scalars['timestamptz']['output'];
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "data_import_project_users" */
export type DataImportProjectUsersAggregate = {
  __typename?: 'DataImportProjectUsersAggregate';
  aggregate?: Maybe<DataImportProjectUsersAggregateFields>;
  nodes: Array<DataImportProjectUsers>;
};

export type DataImportProjectUsersAggregateBoolExp = {
  count?: InputMaybe<DataImportProjectUsersAggregateBoolExpCount>;
};

/** aggregate fields of "data_import_project_users" */
export type DataImportProjectUsersAggregateFields = {
  __typename?: 'DataImportProjectUsersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataImportProjectUsersMaxFields>;
  min?: Maybe<DataImportProjectUsersMinFields>;
};


/** aggregate fields of "data_import_project_users" */
export type DataImportProjectUsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_import_project_users" */
export type DataImportProjectUsersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataImportProjectUsersMaxOrderBy>;
  min?: InputMaybe<DataImportProjectUsersMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_import_project_users" */
export type DataImportProjectUsersArrRelInsertInput = {
  data: Array<DataImportProjectUsersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataImportProjectUsersOnConflict>;
};

/** Boolean expression to filter rows from the table "data_import_project_users". All fields are combined with a logical 'AND'. */
export type DataImportProjectUsersBoolExp = {
  _and?: InputMaybe<Array<DataImportProjectUsersBoolExp>>;
  _not?: InputMaybe<DataImportProjectUsersBoolExp>;
  _or?: InputMaybe<Array<DataImportProjectUsersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "data_import_project_users" */
export const DataImportProjectUsersConstraint = {
  /** unique or primary key constraint on columns "user_id", "data_import_project_id" */
  DataImportProjectUsersPkey: 'data_import_project_users_pkey'
} as const;

export type DataImportProjectUsersConstraint = typeof DataImportProjectUsersConstraint[keyof typeof DataImportProjectUsersConstraint];
/** input type for inserting data into table "data_import_project_users" */
export type DataImportProjectUsersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DataImportProjectUsersMaxFields = {
  __typename?: 'DataImportProjectUsersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "data_import_project_users" */
export type DataImportProjectUsersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataImportProjectUsersMinFields = {
  __typename?: 'DataImportProjectUsersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "data_import_project_users" */
export type DataImportProjectUsersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_import_project_users" */
export type DataImportProjectUsersMutationResponse = {
  __typename?: 'DataImportProjectUsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataImportProjectUsers>;
};

/** on_conflict condition type for table "data_import_project_users" */
export type DataImportProjectUsersOnConflict = {
  constraint: DataImportProjectUsersConstraint;
  updateColumns?: Array<DataImportProjectUsersUpdateColumn>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};

/** Ordering options when selecting data from "data_import_project_users". */
export type DataImportProjectUsersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_import_project_users */
export type DataImportProjectUsersPkColumnsInput = {
  dataImportProjectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "data_import_project_users" */
export const DataImportProjectUsersSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type DataImportProjectUsersSelectColumn = typeof DataImportProjectUsersSelectColumn[keyof typeof DataImportProjectUsersSelectColumn];
/** input type for updating data in table "data_import_project_users" */
export type DataImportProjectUsersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "data_import_project_users" */
export type DataImportProjectUsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataImportProjectUsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataImportProjectUsersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "data_import_project_users" */
export const DataImportProjectUsersUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type DataImportProjectUsersUpdateColumn = typeof DataImportProjectUsersUpdateColumn[keyof typeof DataImportProjectUsersUpdateColumn];
export type DataImportProjectUsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataImportProjectUsersSetInput>;
  /** filter the rows which have to be updated */
  where: DataImportProjectUsersBoolExp;
};

/** columns and relationships of "data_import_projects" */
export type DataImportProjects = {
  __typename?: 'DataImportProjects';
  /** An array relationship */
  batchChangeRequestsJobs: Array<BatchChangeRequestsJobs>;
  /** An aggregate relationship */
  batchChangeRequestsJobsAggregate: BatchChangeRequestsJobsAggregate;
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProjectStatus: DataImportProjectStatuses;
  /** An array relationship */
  dataImportProjectStatusLogs: Array<DataImportProjectStatusLogs>;
  /** An aggregate relationship */
  dataImportProjectStatusLogsAggregate: DataImportProjectStatusLogsAggregate;
  /** An array relationship */
  dataImportProjectUsers: Array<DataImportProjectUsers>;
  /** An aggregate relationship */
  dataImportProjectUsersAggregate: DataImportProjectUsersAggregate;
  /** An array relationship */
  dataSourceImportProjects: Array<DataSourceImportProjects>;
  /** An aggregate relationship */
  dataSourceImportProjectsAggregate: DataSourceImportProjectsAggregate;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description: Scalars['String']['output'];
  documentUrl?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  evidenceSetImportProjects: Array<EvidenceSetImportProjects>;
  /** An aggregate relationship */
  evidenceSetImportProjectsAggregate: EvidenceSetImportProjectsAggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  seq: Scalars['Int']['output'];
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsBatchChangeRequestsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsBatchChangeRequestsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataImportProjectStatusLogsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataImportProjectStatusLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataImportProjectUsersArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataImportProjectUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataSourceImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsDataSourceImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsEvidenceSetImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


/** columns and relationships of "data_import_projects" */
export type DataImportProjectsEvidenceSetImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};

/** aggregated selection of "data_import_projects" */
export type DataImportProjectsAggregate = {
  __typename?: 'DataImportProjectsAggregate';
  aggregate?: Maybe<DataImportProjectsAggregateFields>;
  nodes: Array<DataImportProjects>;
};

/** aggregate fields of "data_import_projects" */
export type DataImportProjectsAggregateFields = {
  __typename?: 'DataImportProjectsAggregateFields';
  avg?: Maybe<DataImportProjectsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DataImportProjectsMaxFields>;
  min?: Maybe<DataImportProjectsMinFields>;
  stddev?: Maybe<DataImportProjectsStddevFields>;
  stddevPop?: Maybe<DataImportProjectsStddevPopFields>;
  stddevSamp?: Maybe<DataImportProjectsStddevSampFields>;
  sum?: Maybe<DataImportProjectsSumFields>;
  varPop?: Maybe<DataImportProjectsVarPopFields>;
  varSamp?: Maybe<DataImportProjectsVarSampFields>;
  variance?: Maybe<DataImportProjectsVarianceFields>;
};


/** aggregate fields of "data_import_projects" */
export type DataImportProjectsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataImportProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DataImportProjectsAvgFields = {
  __typename?: 'DataImportProjectsAvgFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "data_import_projects". All fields are combined with a logical 'AND'. */
export type DataImportProjectsBoolExp = {
  _and?: InputMaybe<Array<DataImportProjectsBoolExp>>;
  _not?: InputMaybe<DataImportProjectsBoolExp>;
  _or?: InputMaybe<Array<DataImportProjectsBoolExp>>;
  batchChangeRequestsJobs?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  batchChangeRequestsJobsAggregate?: InputMaybe<BatchChangeRequestsJobsAggregateBoolExp>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesBoolExp>;
  dataImportProjectStatusLogs?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
  dataImportProjectStatusLogsAggregate?: InputMaybe<DataImportProjectStatusLogsAggregateBoolExp>;
  dataImportProjectUsers?: InputMaybe<DataImportProjectUsersBoolExp>;
  dataImportProjectUsersAggregate?: InputMaybe<DataImportProjectUsersAggregateBoolExp>;
  dataSourceImportProjects?: InputMaybe<DataSourceImportProjectsBoolExp>;
  dataSourceImportProjectsAggregate?: InputMaybe<DataSourceImportProjectsAggregateBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  documentUrl?: InputMaybe<StringComparisonExp>;
  endDate?: InputMaybe<TimestamptzComparisonExp>;
  evidenceSetImportProjects?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
  evidenceSetImportProjectsAggregate?: InputMaybe<EvidenceSetImportProjectsAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  seq?: InputMaybe<IntComparisonExp>;
  startDate?: InputMaybe<TimestamptzComparisonExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_import_projects" */
export const DataImportProjectsConstraint = {
  /** unique or primary key constraint on columns "name" */
  DataImportProjectsNameKey: 'data_import_projects_name_key',
  /** unique or primary key constraint on columns "id" */
  DataImportProjectsPkey: 'data_import_projects_pkey',
  /** unique or primary key constraint on columns "seq" */
  DataImportProjectsSeqKey: 'data_import_projects_seq_key',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  DataImportProjectsTenantIdIdKey: 'data_import_projects_tenant_id_id_key'
} as const;

export type DataImportProjectsConstraint = typeof DataImportProjectsConstraint[keyof typeof DataImportProjectsConstraint];
/** input type for incrementing numeric columns in table "data_import_projects" */
export type DataImportProjectsIncInput = {
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "data_import_projects" */
export type DataImportProjectsInsertInput = {
  batchChangeRequestsJobs?: InputMaybe<BatchChangeRequestsJobsArrRelInsertInput>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesObjRelInsertInput>;
  dataImportProjectStatusLogs?: InputMaybe<DataImportProjectStatusLogsArrRelInsertInput>;
  dataImportProjectUsers?: InputMaybe<DataImportProjectUsersArrRelInsertInput>;
  dataSourceImportProjects?: InputMaybe<DataSourceImportProjectsArrRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetImportProjects?: InputMaybe<EvidenceSetImportProjectsArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataImportProjectsMaxFields = {
  __typename?: 'DataImportProjectsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DataImportProjectsMinFields = {
  __typename?: 'DataImportProjectsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  startDate?: Maybe<Scalars['timestamptz']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "data_import_projects" */
export type DataImportProjectsMutationResponse = {
  __typename?: 'DataImportProjectsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataImportProjects>;
};

/** input type for inserting object relation for remote table "data_import_projects" */
export type DataImportProjectsObjRelInsertInput = {
  data: DataImportProjectsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataImportProjectsOnConflict>;
};

/** on_conflict condition type for table "data_import_projects" */
export type DataImportProjectsOnConflict = {
  constraint: DataImportProjectsConstraint;
  updateColumns?: Array<DataImportProjectsUpdateColumn>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};

/** Ordering options when selecting data from "data_import_projects". */
export type DataImportProjectsOrderBy = {
  batchChangeRequestsJobsAggregate?: InputMaybe<BatchChangeRequestsJobsAggregateOrderBy>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectStatus?: InputMaybe<DataImportProjectStatusesOrderBy>;
  dataImportProjectStatusLogsAggregate?: InputMaybe<DataImportProjectStatusLogsAggregateOrderBy>;
  dataImportProjectUsersAggregate?: InputMaybe<DataImportProjectUsersAggregateOrderBy>;
  dataSourceImportProjectsAggregate?: InputMaybe<DataSourceImportProjectsAggregateOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  documentUrl?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  evidenceSetImportProjectsAggregate?: InputMaybe<EvidenceSetImportProjectsAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  seq?: InputMaybe<OrderBy>;
  startDate?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_import_projects */
export type DataImportProjectsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "data_import_projects" */
export const DataImportProjectsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Seq: 'seq',
  /** column name */
  StartDate: 'startDate',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectsSelectColumn = typeof DataImportProjectsSelectColumn[keyof typeof DataImportProjectsSelectColumn];
/** input type for updating data in table "data_import_projects" */
export type DataImportProjectsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type DataImportProjectsStddevFields = {
  __typename?: 'DataImportProjectsStddevFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type DataImportProjectsStddevPopFields = {
  __typename?: 'DataImportProjectsStddevPopFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type DataImportProjectsStddevSampFields = {
  __typename?: 'DataImportProjectsStddevSampFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "data_import_projects" */
export type DataImportProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataImportProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataImportProjectsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  endDate?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  startDate?: InputMaybe<Scalars['timestamptz']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type DataImportProjectsSumFields = {
  __typename?: 'DataImportProjectsSumFields';
  seq?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "data_import_projects" */
export const DataImportProjectsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Seq: 'seq',
  /** column name */
  StartDate: 'startDate',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataImportProjectsUpdateColumn = typeof DataImportProjectsUpdateColumn[keyof typeof DataImportProjectsUpdateColumn];
export type DataImportProjectsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DataImportProjectsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataImportProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: DataImportProjectsBoolExp;
};

/** aggregate varPop on columns */
export type DataImportProjectsVarPopFields = {
  __typename?: 'DataImportProjectsVarPopFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type DataImportProjectsVarSampFields = {
  __typename?: 'DataImportProjectsVarSampFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DataImportProjectsVarianceFields = {
  __typename?: 'DataImportProjectsVarianceFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

export type DataSourceActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceActivateOutput = {
  __typename?: 'DataSourceActivateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceAutofixInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceAutofixOutput = {
  __typename?: 'DataSourceAutofixOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceBatchUpdateInput = {
  dataSources: Array<DataSourceUpdateInput>;
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceBatchUpdateOutput = {
  __typename?: 'DataSourceBatchUpdateOutput';
  ids: Array<Scalars['String']['output']>;
};

export type DataSourceBatchUpdateResponse = DataSourceBatchUpdateOutput | ValidationError;

export type DataSourceDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceDeactivateOutput = {
  __typename?: 'DataSourceDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceGSheetsClaspPushInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceGSheetsClaspPushOutput = {
  __typename?: 'DataSourceGSheetsClaspPushOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "data_source_gsheets" */
export type DataSourceGsheets = {
  __typename?: 'DataSourceGsheets';
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  googleAppsScriptId?: Maybe<Scalars['String']['output']>;
  googleSheetId: Scalars['Int']['output'];
  googleSpreadsheetId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "data_source_gsheets" */
export type DataSourceGsheetsAggregate = {
  __typename?: 'DataSourceGsheetsAggregate';
  aggregate?: Maybe<DataSourceGsheetsAggregateFields>;
  nodes: Array<DataSourceGsheets>;
};

/** aggregate fields of "data_source_gsheets" */
export type DataSourceGsheetsAggregateFields = {
  __typename?: 'DataSourceGsheetsAggregateFields';
  avg?: Maybe<DataSourceGsheetsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceGsheetsMaxFields>;
  min?: Maybe<DataSourceGsheetsMinFields>;
  stddev?: Maybe<DataSourceGsheetsStddevFields>;
  stddevPop?: Maybe<DataSourceGsheetsStddevPopFields>;
  stddevSamp?: Maybe<DataSourceGsheetsStddevSampFields>;
  sum?: Maybe<DataSourceGsheetsSumFields>;
  varPop?: Maybe<DataSourceGsheetsVarPopFields>;
  varSamp?: Maybe<DataSourceGsheetsVarSampFields>;
  variance?: Maybe<DataSourceGsheetsVarianceFields>;
};


/** aggregate fields of "data_source_gsheets" */
export type DataSourceGsheetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceGsheetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type DataSourceGsheetsAvgFields = {
  __typename?: 'DataSourceGsheetsAvgFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "data_source_gsheets". All fields are combined with a logical 'AND'. */
export type DataSourceGsheetsBoolExp = {
  _and?: InputMaybe<Array<DataSourceGsheetsBoolExp>>;
  _not?: InputMaybe<DataSourceGsheetsBoolExp>;
  _or?: InputMaybe<Array<DataSourceGsheetsBoolExp>>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  googleAppsScriptId?: InputMaybe<StringComparisonExp>;
  googleSheetId?: InputMaybe<IntComparisonExp>;
  googleSpreadsheetId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "data_source_gsheets" */
export const DataSourceGsheetsConstraint = {
  /** unique or primary key constraint on columns "google_spreadsheet_id", "google_sheet_id" */
  DataSourceGsheetsGoogleSpreadsheetIdGoogleSheetIdKey: 'data_source_gsheets_google_spreadsheet_id_google_sheet_id_key',
  /** unique or primary key constraint on columns "data_source_id" */
  DataSourceGsheetsPkey: 'data_source_gsheets_pkey'
} as const;

export type DataSourceGsheetsConstraint = typeof DataSourceGsheetsConstraint[keyof typeof DataSourceGsheetsConstraint];
/** input type for incrementing numeric columns in table "data_source_gsheets" */
export type DataSourceGsheetsIncInput = {
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "data_source_gsheets" */
export type DataSourceGsheetsInsertInput = {
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  googleAppsScriptId?: InputMaybe<Scalars['String']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DataSourceGsheetsMaxFields = {
  __typename?: 'DataSourceGsheetsMaxFields';
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  googleAppsScriptId?: Maybe<Scalars['String']['output']>;
  googleSheetId?: Maybe<Scalars['Int']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type DataSourceGsheetsMinFields = {
  __typename?: 'DataSourceGsheetsMinFields';
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  googleAppsScriptId?: Maybe<Scalars['String']['output']>;
  googleSheetId?: Maybe<Scalars['Int']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "data_source_gsheets" */
export type DataSourceGsheetsMutationResponse = {
  __typename?: 'DataSourceGsheetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceGsheets>;
};

/** input type for inserting object relation for remote table "data_source_gsheets" */
export type DataSourceGsheetsObjRelInsertInput = {
  data: DataSourceGsheetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceGsheetsOnConflict>;
};

/** on_conflict condition type for table "data_source_gsheets" */
export type DataSourceGsheetsOnConflict = {
  constraint: DataSourceGsheetsConstraint;
  updateColumns?: Array<DataSourceGsheetsUpdateColumn>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};

/** Ordering options when selecting data from "data_source_gsheets". */
export type DataSourceGsheetsOrderBy = {
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  googleAppsScriptId?: InputMaybe<OrderBy>;
  googleSheetId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_gsheets */
export type DataSourceGsheetsPkColumnsInput = {
  dataSourceId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_gsheets" */
export const DataSourceGsheetsSelectColumn = {
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  GoogleAppsScriptId: 'googleAppsScriptId',
  /** column name */
  GoogleSheetId: 'googleSheetId',
  /** column name */
  GoogleSpreadsheetId: 'googleSpreadsheetId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceGsheetsSelectColumn = typeof DataSourceGsheetsSelectColumn[keyof typeof DataSourceGsheetsSelectColumn];
/** input type for updating data in table "data_source_gsheets" */
export type DataSourceGsheetsSetInput = {
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  googleAppsScriptId?: InputMaybe<Scalars['String']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate stddev on columns */
export type DataSourceGsheetsStddevFields = {
  __typename?: 'DataSourceGsheetsStddevFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type DataSourceGsheetsStddevPopFields = {
  __typename?: 'DataSourceGsheetsStddevPopFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type DataSourceGsheetsStddevSampFields = {
  __typename?: 'DataSourceGsheetsStddevSampFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "data_source_gsheets" */
export type DataSourceGsheetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceGsheetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceGsheetsStreamCursorValueInput = {
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  googleAppsScriptId?: InputMaybe<Scalars['String']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate sum on columns */
export type DataSourceGsheetsSumFields = {
  __typename?: 'DataSourceGsheetsSumFields';
  googleSheetId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "data_source_gsheets" */
export const DataSourceGsheetsUpdateColumn = {
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  GoogleAppsScriptId: 'googleAppsScriptId',
  /** column name */
  GoogleSheetId: 'googleSheetId',
  /** column name */
  GoogleSpreadsheetId: 'googleSpreadsheetId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceGsheetsUpdateColumn = typeof DataSourceGsheetsUpdateColumn[keyof typeof DataSourceGsheetsUpdateColumn];
export type DataSourceGsheetsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DataSourceGsheetsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceGsheetsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceGsheetsBoolExp;
};

/** aggregate varPop on columns */
export type DataSourceGsheetsVarPopFields = {
  __typename?: 'DataSourceGsheetsVarPopFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type DataSourceGsheetsVarSampFields = {
  __typename?: 'DataSourceGsheetsVarSampFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DataSourceGsheetsVarianceFields = {
  __typename?: 'DataSourceGsheetsVarianceFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitions = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitions';
  dataImportProjectId: Scalars['uuid']['output'];
  dataSourceId: Scalars['uuid']['output'];
  /** An object relationship */
  dataSourceImportProject: DataSourceImportProjects;
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsAggregate = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<DataSourceImportProjectRecordComposerDefinitionsAggregateFields>;
  nodes: Array<DataSourceImportProjectRecordComposerDefinitions>;
};

/** aggregate fields of "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsAggregateFields = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceImportProjectRecordComposerDefinitionsMaxFields>;
  min?: Maybe<DataSourceImportProjectRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_source_import_project_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsBoolExp>>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  dataSourceImportProject?: InputMaybe<DataSourceImportProjectsBoolExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "data_source_import_project_record_composer_definitions" */
export const DataSourceImportProjectRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id", "data_source_id", "data_import_project_id" */
  DataSourceImportProjectRecordComposerDefinitionsPkey: 'data_source_import_project_record_composer_definitions_pkey',
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  DataSourceImportProjectRecordComposerDefinitionsRecoKey: 'data_source_import_project_record_composer_definitions_reco_key'
} as const;

export type DataSourceImportProjectRecordComposerDefinitionsConstraint = typeof DataSourceImportProjectRecordComposerDefinitionsConstraint[keyof typeof DataSourceImportProjectRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsInsertInput = {
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceImportProject?: InputMaybe<DataSourceImportProjectsObjRelInsertInput>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DataSourceImportProjectRecordComposerDefinitionsMaxFields = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitionsMaxFields';
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type DataSourceImportProjectRecordComposerDefinitionsMinFields = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitionsMinFields';
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsMutationResponse = {
  __typename?: 'DataSourceImportProjectRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceImportProjectRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsObjRelInsertInput = {
  data: DataSourceImportProjectRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsOnConflict = {
  constraint: DataSourceImportProjectRecordComposerDefinitionsConstraint;
  updateColumns?: Array<DataSourceImportProjectRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "data_source_import_project_record_composer_definitions". */
export type DataSourceImportProjectRecordComposerDefinitionsOrderBy = {
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  dataSourceImportProject?: InputMaybe<DataSourceImportProjectsOrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_import_project_record_composer_definitions */
export type DataSourceImportProjectRecordComposerDefinitionsPkColumnsInput = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_import_project_record_composer_definitions" */
export const DataSourceImportProjectRecordComposerDefinitionsSelectColumn = {
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceImportProjectRecordComposerDefinitionsSelectColumn = typeof DataSourceImportProjectRecordComposerDefinitionsSelectColumn[keyof typeof DataSourceImportProjectRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsSetInput = {
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "data_source_import_project_record_composer_definitions" */
export type DataSourceImportProjectRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceImportProjectRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceImportProjectRecordComposerDefinitionsStreamCursorValueInput = {
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "data_source_import_project_record_composer_definitions" */
export const DataSourceImportProjectRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceImportProjectRecordComposerDefinitionsUpdateColumn = typeof DataSourceImportProjectRecordComposerDefinitionsUpdateColumn[keyof typeof DataSourceImportProjectRecordComposerDefinitionsUpdateColumn];
export type DataSourceImportProjectRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceImportProjectRecordComposerDefinitionsBoolExp;
};

/** columns and relationships of "data_source_import_projects" */
export type DataSourceImportProjects = {
  __typename?: 'DataSourceImportProjects';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_source_import_projects" */
export type DataSourceImportProjectsAggregate = {
  __typename?: 'DataSourceImportProjectsAggregate';
  aggregate?: Maybe<DataSourceImportProjectsAggregateFields>;
  nodes: Array<DataSourceImportProjects>;
};

export type DataSourceImportProjectsAggregateBoolExp = {
  count?: InputMaybe<DataSourceImportProjectsAggregateBoolExpCount>;
};

/** aggregate fields of "data_source_import_projects" */
export type DataSourceImportProjectsAggregateFields = {
  __typename?: 'DataSourceImportProjectsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceImportProjectsMaxFields>;
  min?: Maybe<DataSourceImportProjectsMinFields>;
};


/** aggregate fields of "data_source_import_projects" */
export type DataSourceImportProjectsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_source_import_projects" */
export type DataSourceImportProjectsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataSourceImportProjectsMaxOrderBy>;
  min?: InputMaybe<DataSourceImportProjectsMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_source_import_projects" */
export type DataSourceImportProjectsArrRelInsertInput = {
  data: Array<DataSourceImportProjectsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceImportProjectsOnConflict>;
};

/** Boolean expression to filter rows from the table "data_source_import_projects". All fields are combined with a logical 'AND'. */
export type DataSourceImportProjectsBoolExp = {
  _and?: InputMaybe<Array<DataSourceImportProjectsBoolExp>>;
  _not?: InputMaybe<DataSourceImportProjectsBoolExp>;
  _or?: InputMaybe<Array<DataSourceImportProjectsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_source_import_projects" */
export const DataSourceImportProjectsConstraint = {
  /** unique or primary key constraint on columns "data_source_id", "data_import_project_id" */
  DataSourceImportProjectsPkey: 'data_source_import_projects_pkey'
} as const;

export type DataSourceImportProjectsConstraint = typeof DataSourceImportProjectsConstraint[keyof typeof DataSourceImportProjectsConstraint];
/** input type for inserting data into table "data_source_import_projects" */
export type DataSourceImportProjectsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourceImportProjectsMaxFields = {
  __typename?: 'DataSourceImportProjectsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "data_source_import_projects" */
export type DataSourceImportProjectsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataSourceImportProjectsMinFields = {
  __typename?: 'DataSourceImportProjectsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "data_source_import_projects" */
export type DataSourceImportProjectsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_source_import_projects" */
export type DataSourceImportProjectsMutationResponse = {
  __typename?: 'DataSourceImportProjectsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceImportProjects>;
};

/** input type for inserting object relation for remote table "data_source_import_projects" */
export type DataSourceImportProjectsObjRelInsertInput = {
  data: DataSourceImportProjectsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceImportProjectsOnConflict>;
};

/** on_conflict condition type for table "data_source_import_projects" */
export type DataSourceImportProjectsOnConflict = {
  constraint: DataSourceImportProjectsConstraint;
  updateColumns?: Array<DataSourceImportProjectsUpdateColumn>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};

/** Ordering options when selecting data from "data_source_import_projects". */
export type DataSourceImportProjectsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_import_projects */
export type DataSourceImportProjectsPkColumnsInput = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_import_projects" */
export const DataSourceImportProjectsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceImportProjectsSelectColumn = typeof DataSourceImportProjectsSelectColumn[keyof typeof DataSourceImportProjectsSelectColumn];
/** input type for updating data in table "data_source_import_projects" */
export type DataSourceImportProjectsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_source_import_projects" */
export type DataSourceImportProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceImportProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceImportProjectsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_source_import_projects" */
export const DataSourceImportProjectsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceImportProjectsUpdateColumn = typeof DataSourceImportProjectsUpdateColumn[keyof typeof DataSourceImportProjectsUpdateColumn];
export type DataSourceImportProjectsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceImportProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceImportProjectsBoolExp;
};

export type DataSourceInImportProjectBatchCreateInput = {
  dataSources: Array<DataSourceInImportProjectCreateInput>;
  importProjectId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceInImportProjectBatchCreateOutput = {
  __typename?: 'DataSourceInImportProjectBatchCreateOutput';
  dataSources: Array<DataSourceInImportProjectCreateOutput>;
  importProjectId: Scalars['UUID']['output'];
};

export type DataSourceInImportProjectBatchCreateResponse = DataSourceInImportProjectBatchCreateOutput | ValidationError;

export type DataSourceInImportProjectCreateInput = {
  dataSourcePropertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  dataSourceTemplateId?: InputMaybe<Scalars['UUID']['input']>;
  gSheetsConfig?: InputMaybe<GSheetsConfigInput>;
  importProjectId: Scalars['UUID']['input'];
  jsonData?: InputMaybe<Scalars['JSONObject']['input']>;
  name: Scalars['String']['input'];
  referenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceInImportProjectCreateOutput = {
  __typename?: 'DataSourceInImportProjectCreateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceInImportProjectCreateResponse = DataSourceInImportProjectCreateOutput | ValidationError;

export type DataSourceJsonDataUpdateInput = {
  dataSourceId: Scalars['UUID']['input'];
  expectedS3Path: Scalars['String']['input'];
  jsonData: Scalars['JSONObject']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceJsonDataUpdateOutput = {
  __typename?: 'DataSourceJsonDataUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceJsonDataUpdateResponse = DataSourceJsonDataUpdateOutput | ValidationError;

export type DataSourceJsonInput = {
  /** Legacy shorthand that maps same-named data source and category properties. */
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  dataSourceDescription?: InputMaybe<Scalars['String']['input']>;
  dataSourceName?: InputMaybe<Scalars['String']['input']>;
  dataSourcePropertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  /** REIMPORT refuses to add, remove or change the identity mapping of an entity slot the project composes. */
  identityMappings?: InputMaybe<Array<ImportDirectIdentityMappingInput>>;
  jsonData: JsonDataInput;
  /** Explicit source-agnostic mappings. Use these when one data source feeds multiple category slots. */
  propertyMappings?: InputMaybe<Array<ImportDirectPropertyMappingInput>>;
  referenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  relationMappings?: InputMaybe<Array<RelationMappingInput>>;
};

/** columns and relationships of "data_source_jsons" */
export type DataSourceJsons = {
  __typename?: 'DataSourceJsons';
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  s3Path: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "data_source_jsons" */
export type DataSourceJsonsAggregate = {
  __typename?: 'DataSourceJsonsAggregate';
  aggregate?: Maybe<DataSourceJsonsAggregateFields>;
  nodes: Array<DataSourceJsons>;
};

/** aggregate fields of "data_source_jsons" */
export type DataSourceJsonsAggregateFields = {
  __typename?: 'DataSourceJsonsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceJsonsMaxFields>;
  min?: Maybe<DataSourceJsonsMinFields>;
};


/** aggregate fields of "data_source_jsons" */
export type DataSourceJsonsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceJsonsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_source_jsons". All fields are combined with a logical 'AND'. */
export type DataSourceJsonsBoolExp = {
  _and?: InputMaybe<Array<DataSourceJsonsBoolExp>>;
  _not?: InputMaybe<DataSourceJsonsBoolExp>;
  _or?: InputMaybe<Array<DataSourceJsonsBoolExp>>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  s3Path?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "data_source_jsons" */
export const DataSourceJsonsConstraint = {
  /** unique or primary key constraint on columns "data_source_id" */
  DataSourceJsonsPkey: 'data_source_jsons_pkey'
} as const;

export type DataSourceJsonsConstraint = typeof DataSourceJsonsConstraint[keyof typeof DataSourceJsonsConstraint];
/** input type for inserting data into table "data_source_jsons" */
export type DataSourceJsonsInsertInput = {
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DataSourceJsonsMaxFields = {
  __typename?: 'DataSourceJsonsMaxFields';
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type DataSourceJsonsMinFields = {
  __typename?: 'DataSourceJsonsMinFields';
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  s3Path?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "data_source_jsons" */
export type DataSourceJsonsMutationResponse = {
  __typename?: 'DataSourceJsonsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceJsons>;
};

/** input type for inserting object relation for remote table "data_source_jsons" */
export type DataSourceJsonsObjRelInsertInput = {
  data: DataSourceJsonsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceJsonsOnConflict>;
};

/** on_conflict condition type for table "data_source_jsons" */
export type DataSourceJsonsOnConflict = {
  constraint: DataSourceJsonsConstraint;
  updateColumns?: Array<DataSourceJsonsUpdateColumn>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};

/** Ordering options when selecting data from "data_source_jsons". */
export type DataSourceJsonsOrderBy = {
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  s3Path?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_jsons */
export type DataSourceJsonsPkColumnsInput = {
  dataSourceId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_jsons" */
export const DataSourceJsonsSelectColumn = {
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceJsonsSelectColumn = typeof DataSourceJsonsSelectColumn[keyof typeof DataSourceJsonsSelectColumn];
/** input type for updating data in table "data_source_jsons" */
export type DataSourceJsonsSetInput = {
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "data_source_jsons" */
export type DataSourceJsonsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceJsonsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceJsonsStreamCursorValueInput = {
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  s3Path?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "data_source_jsons" */
export const DataSourceJsonsUpdateColumn = {
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  S3Path: 's3Path',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type DataSourceJsonsUpdateColumn = typeof DataSourceJsonsUpdateColumn[keyof typeof DataSourceJsonsUpdateColumn];
export type DataSourceJsonsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceJsonsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceJsonsBoolExp;
};

/** columns and relationships of "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSets = {
  __typename?: 'DataSourcePropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsAggregate = {
  __typename?: 'DataSourcePropertySchemaSetsAggregate';
  aggregate?: Maybe<DataSourcePropertySchemaSetsAggregateFields>;
  nodes: Array<DataSourcePropertySchemaSets>;
};

export type DataSourcePropertySchemaSetsAggregateBoolExp = {
  count?: InputMaybe<DataSourcePropertySchemaSetsAggregateBoolExpCount>;
};

/** aggregate fields of "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsAggregateFields = {
  __typename?: 'DataSourcePropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourcePropertySchemaSetsMaxFields>;
  min?: Maybe<DataSourcePropertySchemaSetsMinFields>;
};


/** aggregate fields of "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataSourcePropertySchemaSetsMaxOrderBy>;
  min?: InputMaybe<DataSourcePropertySchemaSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsArrRelInsertInput = {
  data: Array<DataSourcePropertySchemaSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourcePropertySchemaSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "data_source_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourcePropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<DataSourcePropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<DataSourcePropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_source_property_schema_sets" */
export const DataSourcePropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "data_source_id" */
  DataSourcePropertySchemaSetsPkey: 'data_source_property_schema_sets_pkey',
  /** unique or primary key constraint on columns "property_schema_set_id" */
  DataSourcePropertySchemaSetsPropertySchemaSetIdKey: 'data_source_property_schema_sets_property_schema_set_id_key'
} as const;

export type DataSourcePropertySchemaSetsConstraint = typeof DataSourcePropertySchemaSetsConstraint[keyof typeof DataSourcePropertySchemaSetsConstraint];
/** input type for inserting data into table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourcePropertySchemaSetsMaxFields = {
  __typename?: 'DataSourcePropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataSourcePropertySchemaSetsMinFields = {
  __typename?: 'DataSourcePropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsMutationResponse = {
  __typename?: 'DataSourcePropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourcePropertySchemaSets>;
};

/** on_conflict condition type for table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsOnConflict = {
  constraint: DataSourcePropertySchemaSetsConstraint;
  updateColumns?: Array<DataSourcePropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "data_source_property_schema_sets". */
export type DataSourcePropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_property_schema_sets */
export type DataSourcePropertySchemaSetsPkColumnsInput = {
  dataSourceId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_property_schema_sets" */
export const DataSourcePropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourcePropertySchemaSetsSelectColumn = typeof DataSourcePropertySchemaSetsSelectColumn[keyof typeof DataSourcePropertySchemaSetsSelectColumn];
/** input type for updating data in table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_source_property_schema_sets" */
export type DataSourcePropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourcePropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourcePropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_source_property_schema_sets" */
export const DataSourcePropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourcePropertySchemaSetsUpdateColumn = typeof DataSourcePropertySchemaSetsUpdateColumn[keyof typeof DataSourcePropertySchemaSetsUpdateColumn];
export type DataSourcePropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourcePropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourcePropertySchemaSetsBoolExp;
};

/** columns and relationships of "data_source_references" */
export type DataSourceReferences = {
  __typename?: 'DataSourceReferences';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  /** An object relationship */
  reference: References;
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_source_references" */
export type DataSourceReferencesAggregate = {
  __typename?: 'DataSourceReferencesAggregate';
  aggregate?: Maybe<DataSourceReferencesAggregateFields>;
  nodes: Array<DataSourceReferences>;
};

export type DataSourceReferencesAggregateBoolExp = {
  count?: InputMaybe<DataSourceReferencesAggregateBoolExpCount>;
};

/** aggregate fields of "data_source_references" */
export type DataSourceReferencesAggregateFields = {
  __typename?: 'DataSourceReferencesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceReferencesMaxFields>;
  min?: Maybe<DataSourceReferencesMinFields>;
};


/** aggregate fields of "data_source_references" */
export type DataSourceReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_source_references" */
export type DataSourceReferencesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataSourceReferencesMaxOrderBy>;
  min?: InputMaybe<DataSourceReferencesMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_source_references" */
export type DataSourceReferencesArrRelInsertInput = {
  data: Array<DataSourceReferencesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceReferencesOnConflict>;
};

/** Boolean expression to filter rows from the table "data_source_references". All fields are combined with a logical 'AND'. */
export type DataSourceReferencesBoolExp = {
  _and?: InputMaybe<Array<DataSourceReferencesBoolExp>>;
  _not?: InputMaybe<DataSourceReferencesBoolExp>;
  _or?: InputMaybe<Array<DataSourceReferencesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  reference?: InputMaybe<ReferencesBoolExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_source_references" */
export const DataSourceReferencesConstraint = {
  /** unique or primary key constraint on columns "data_source_id", "reference_id" */
  DataSourceReferencesPkey: 'data_source_references_pkey'
} as const;

export type DataSourceReferencesConstraint = typeof DataSourceReferencesConstraint[keyof typeof DataSourceReferencesConstraint];
/** input type for inserting data into table "data_source_references" */
export type DataSourceReferencesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  reference?: InputMaybe<ReferencesObjRelInsertInput>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourceReferencesMaxFields = {
  __typename?: 'DataSourceReferencesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "data_source_references" */
export type DataSourceReferencesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataSourceReferencesMinFields = {
  __typename?: 'DataSourceReferencesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "data_source_references" */
export type DataSourceReferencesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_source_references" */
export type DataSourceReferencesMutationResponse = {
  __typename?: 'DataSourceReferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceReferences>;
};

/** on_conflict condition type for table "data_source_references" */
export type DataSourceReferencesOnConflict = {
  constraint: DataSourceReferencesConstraint;
  updateColumns?: Array<DataSourceReferencesUpdateColumn>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};

/** Ordering options when selecting data from "data_source_references". */
export type DataSourceReferencesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  reference?: InputMaybe<ReferencesOrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_references */
export type DataSourceReferencesPkColumnsInput = {
  dataSourceId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_references" */
export const DataSourceReferencesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceReferencesSelectColumn = typeof DataSourceReferencesSelectColumn[keyof typeof DataSourceReferencesSelectColumn];
/** input type for updating data in table "data_source_references" */
export type DataSourceReferencesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_source_references" */
export type DataSourceReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceReferencesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_source_references" */
export const DataSourceReferencesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceReferencesUpdateColumn = typeof DataSourceReferencesUpdateColumn[keyof typeof DataSourceReferencesUpdateColumn];
export type DataSourceReferencesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceReferencesSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceReferencesBoolExp;
};

export type DataSourceTemplateActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceTemplateActivateOutput = {
  __typename?: 'DataSourceTemplateActivateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceTemplateCreateInput = {
  name: Scalars['String']['input'];
  propertySchemaAssociations: Array<PropertySchemaAssociationInput>;
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceTemplateCreateOutput = {
  __typename?: 'DataSourceTemplateCreateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceTemplateCreateResponse = DataSourceTemplateCreateOutput | ValidationError;

export type DataSourceTemplateDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceTemplateDeactivateOutput = {
  __typename?: 'DataSourceTemplateDeactivateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSets = {
  __typename?: 'DataSourceTemplatePropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataSourceTemplate: DataSourceTemplates;
  dataSourceTemplateId: Scalars['uuid']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsAggregate = {
  __typename?: 'DataSourceTemplatePropertySchemaSetsAggregate';
  aggregate?: Maybe<DataSourceTemplatePropertySchemaSetsAggregateFields>;
  nodes: Array<DataSourceTemplatePropertySchemaSets>;
};

export type DataSourceTemplatePropertySchemaSetsAggregateBoolExp = {
  count?: InputMaybe<DataSourceTemplatePropertySchemaSetsAggregateBoolExpCount>;
};

/** aggregate fields of "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsAggregateFields = {
  __typename?: 'DataSourceTemplatePropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceTemplatePropertySchemaSetsMaxFields>;
  min?: Maybe<DataSourceTemplatePropertySchemaSetsMinFields>;
};


/** aggregate fields of "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DataSourceTemplatePropertySchemaSetsMaxOrderBy>;
  min?: InputMaybe<DataSourceTemplatePropertySchemaSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsArrRelInsertInput = {
  data: Array<DataSourceTemplatePropertySchemaSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceTemplatePropertySchemaSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "data_source_template_property_schema_sets". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatePropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSourceTemplate?: InputMaybe<DataSourceTemplatesBoolExp>;
  dataSourceTemplateId?: InputMaybe<UuidComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_source_template_property_schema_sets" */
export const DataSourceTemplatePropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "data_source_template_id" */
  DataSourceTemplatePropertySchemaSetsPkey: 'data_source_template_property_schema_sets_pkey',
  /** unique or primary key constraint on columns "property_schema_set_id" */
  DataSourceTemplatePropertySchemaSetsPropertySchemaSKey: 'data_source_template_property_schema_sets_property_schema_s_key'
} as const;

export type DataSourceTemplatePropertySchemaSetsConstraint = typeof DataSourceTemplatePropertySchemaSetsConstraint[keyof typeof DataSourceTemplatePropertySchemaSetsConstraint];
/** input type for inserting data into table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceTemplate?: InputMaybe<DataSourceTemplatesObjRelInsertInput>;
  dataSourceTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourceTemplatePropertySchemaSetsMaxFields = {
  __typename?: 'DataSourceTemplatePropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceTemplateId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceTemplateId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DataSourceTemplatePropertySchemaSetsMinFields = {
  __typename?: 'DataSourceTemplatePropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceTemplateId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceTemplateId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsMutationResponse = {
  __typename?: 'DataSourceTemplatePropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceTemplatePropertySchemaSets>;
};

/** input type for inserting object relation for remote table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsObjRelInsertInput = {
  data: DataSourceTemplatePropertySchemaSetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceTemplatePropertySchemaSetsOnConflict>;
};

/** on_conflict condition type for table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsOnConflict = {
  constraint: DataSourceTemplatePropertySchemaSetsConstraint;
  updateColumns?: Array<DataSourceTemplatePropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "data_source_template_property_schema_sets". */
export type DataSourceTemplatePropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceTemplate?: InputMaybe<DataSourceTemplatesOrderBy>;
  dataSourceTemplateId?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_template_property_schema_sets */
export type DataSourceTemplatePropertySchemaSetsPkColumnsInput = {
  dataSourceTemplateId: Scalars['uuid']['input'];
};

/** select columns of table "data_source_template_property_schema_sets" */
export const DataSourceTemplatePropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceTemplateId: 'dataSourceTemplateId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceTemplatePropertySchemaSetsSelectColumn = typeof DataSourceTemplatePropertySchemaSetsSelectColumn[keyof typeof DataSourceTemplatePropertySchemaSetsSelectColumn];
/** input type for updating data in table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_source_template_property_schema_sets" */
export type DataSourceTemplatePropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceTemplatePropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceTemplatePropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceTemplateId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_source_template_property_schema_sets" */
export const DataSourceTemplatePropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceTemplateId: 'dataSourceTemplateId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceTemplatePropertySchemaSetsUpdateColumn = typeof DataSourceTemplatePropertySchemaSetsUpdateColumn[keyof typeof DataSourceTemplatePropertySchemaSetsUpdateColumn];
export type DataSourceTemplatePropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceTemplatePropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceTemplatePropertySchemaSetsBoolExp;
};

export type DataSourceTemplateUpdateInput = {
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  propertySchemaAssociations: Array<PropertySchemaAssociationInput>;
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceTemplateUpdateOutput = {
  __typename?: 'DataSourceTemplateUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceTemplateUpdateResponse = DataSourceTemplateUpdateOutput | ValidationError;

/** columns and relationships of "data_source_templates" */
export type DataSourceTemplates = {
  __typename?: 'DataSourceTemplates';
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  dataSourceTemplatePropertySchemaSet: Array<DataSourceTemplatePropertySchemaSets>;
  /** An aggregate relationship */
  dataSourceTemplatePropertySchemaSetAggregate: DataSourceTemplatePropertySchemaSetsAggregate;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "data_source_templates" */
export type DataSourceTemplatesDataSourceTemplatePropertySchemaSetArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


/** columns and relationships of "data_source_templates" */
export type DataSourceTemplatesDataSourceTemplatePropertySchemaSetAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};

/** aggregated selection of "data_source_templates" */
export type DataSourceTemplatesAggregate = {
  __typename?: 'DataSourceTemplatesAggregate';
  aggregate?: Maybe<DataSourceTemplatesAggregateFields>;
  nodes: Array<DataSourceTemplates>;
};

/** aggregate fields of "data_source_templates" */
export type DataSourceTemplatesAggregateFields = {
  __typename?: 'DataSourceTemplatesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourceTemplatesMaxFields>;
  min?: Maybe<DataSourceTemplatesMinFields>;
};


/** aggregate fields of "data_source_templates" */
export type DataSourceTemplatesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourceTemplatesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_source_templates". All fields are combined with a logical 'AND'. */
export type DataSourceTemplatesBoolExp = {
  _and?: InputMaybe<Array<DataSourceTemplatesBoolExp>>;
  _not?: InputMaybe<DataSourceTemplatesBoolExp>;
  _or?: InputMaybe<Array<DataSourceTemplatesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSourceTemplatePropertySchemaSet?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
  dataSourceTemplatePropertySchemaSetAggregate?: InputMaybe<DataSourceTemplatePropertySchemaSetsAggregateBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_source_templates" */
export const DataSourceTemplatesConstraint = {
  /** unique or primary key constraint on columns "id" */
  DataSourceTemplatesPkey: 'data_source_templates_pkey'
} as const;

export type DataSourceTemplatesConstraint = typeof DataSourceTemplatesConstraint[keyof typeof DataSourceTemplatesConstraint];
/** input type for inserting data into table "data_source_templates" */
export type DataSourceTemplatesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceTemplatePropertySchemaSet?: InputMaybe<DataSourceTemplatePropertySchemaSetsArrRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourceTemplatesMaxFields = {
  __typename?: 'DataSourceTemplatesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DataSourceTemplatesMinFields = {
  __typename?: 'DataSourceTemplatesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "data_source_templates" */
export type DataSourceTemplatesMutationResponse = {
  __typename?: 'DataSourceTemplatesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSourceTemplates>;
};

/** input type for inserting object relation for remote table "data_source_templates" */
export type DataSourceTemplatesObjRelInsertInput = {
  data: DataSourceTemplatesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourceTemplatesOnConflict>;
};

/** on_conflict condition type for table "data_source_templates" */
export type DataSourceTemplatesOnConflict = {
  constraint: DataSourceTemplatesConstraint;
  updateColumns?: Array<DataSourceTemplatesUpdateColumn>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};

/** Ordering options when selecting data from "data_source_templates". */
export type DataSourceTemplatesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataSourceTemplatePropertySchemaSetAggregate?: InputMaybe<DataSourceTemplatePropertySchemaSetsAggregateOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_source_templates */
export type DataSourceTemplatesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "data_source_templates" */
export const DataSourceTemplatesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceTemplatesSelectColumn = typeof DataSourceTemplatesSelectColumn[keyof typeof DataSourceTemplatesSelectColumn];
/** input type for updating data in table "data_source_templates" */
export type DataSourceTemplatesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_source_templates" */
export type DataSourceTemplatesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourceTemplatesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourceTemplatesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_source_templates" */
export const DataSourceTemplatesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourceTemplatesUpdateColumn = typeof DataSourceTemplatesUpdateColumn[keyof typeof DataSourceTemplatesUpdateColumn];
export type DataSourceTemplatesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourceTemplatesSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourceTemplatesBoolExp;
};

export type DataSourceUpdateInput = {
  dataSourcePropertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  googleAppsScriptId?: InputMaybe<Scalars['String']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  id: Scalars['UUID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  referenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type DataSourceUpdateOutput = {
  __typename?: 'DataSourceUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type DataSourceUpdateResponse = DataSourceUpdateOutput | ValidationError;

/** columns and relationships of "data_sources" */
export type DataSources = {
  __typename?: 'DataSources';
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataSourceGSheets?: Maybe<DataSourceGsheets>;
  /** An array relationship */
  dataSourceImportProjects: Array<DataSourceImportProjects>;
  /** An aggregate relationship */
  dataSourceImportProjectsAggregate: DataSourceImportProjectsAggregate;
  /** An object relationship */
  dataSourceJson?: Maybe<DataSourceJsons>;
  /** An array relationship */
  dataSourcePropertySchemaSet: Array<DataSourcePropertySchemaSets>;
  /** An aggregate relationship */
  dataSourcePropertySchemaSetAggregate: DataSourcePropertySchemaSetsAggregate;
  /** An array relationship */
  dataSourceReferences: Array<DataSourceReferences>;
  /** An aggregate relationship */
  dataSourceReferencesAggregate: DataSourceReferencesAggregate;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "data_sources" */
export type DataSourcesBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourceImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourceImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourcePropertySchemaSetArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourcePropertySchemaSetAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourceReferencesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


/** columns and relationships of "data_sources" */
export type DataSourcesDataSourceReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};

/** aggregated selection of "data_sources" */
export type DataSourcesAggregate = {
  __typename?: 'DataSourcesAggregate';
  aggregate?: Maybe<DataSourcesAggregateFields>;
  nodes: Array<DataSources>;
};

/** aggregate fields of "data_sources" */
export type DataSourcesAggregateFields = {
  __typename?: 'DataSourcesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DataSourcesMaxFields>;
  min?: Maybe<DataSourcesMinFields>;
};


/** aggregate fields of "data_sources" */
export type DataSourcesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DataSourcesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "data_sources". All fields are combined with a logical 'AND'. */
export type DataSourcesBoolExp = {
  _and?: InputMaybe<Array<DataSourcesBoolExp>>;
  _not?: InputMaybe<DataSourcesBoolExp>;
  _or?: InputMaybe<Array<DataSourcesBoolExp>>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSourceGSheets?: InputMaybe<DataSourceGsheetsBoolExp>;
  dataSourceImportProjects?: InputMaybe<DataSourceImportProjectsBoolExp>;
  dataSourceImportProjectsAggregate?: InputMaybe<DataSourceImportProjectsAggregateBoolExp>;
  dataSourceJson?: InputMaybe<DataSourceJsonsBoolExp>;
  dataSourcePropertySchemaSet?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
  dataSourcePropertySchemaSetAggregate?: InputMaybe<DataSourcePropertySchemaSetsAggregateBoolExp>;
  dataSourceReferences?: InputMaybe<DataSourceReferencesBoolExp>;
  dataSourceReferencesAggregate?: InputMaybe<DataSourceReferencesAggregateBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "data_sources" */
export const DataSourcesConstraint = {
  /** unique or primary key constraint on columns "id" */
  DataSourcesPkey: 'data_sources_pkey'
} as const;

export type DataSourcesConstraint = typeof DataSourcesConstraint[keyof typeof DataSourcesConstraint];
/** input type for inserting data into table "data_sources" */
export type DataSourcesInsertInput = {
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceGSheets?: InputMaybe<DataSourceGsheetsObjRelInsertInput>;
  dataSourceImportProjects?: InputMaybe<DataSourceImportProjectsArrRelInsertInput>;
  dataSourceJson?: InputMaybe<DataSourceJsonsObjRelInsertInput>;
  dataSourcePropertySchemaSet?: InputMaybe<DataSourcePropertySchemaSetsArrRelInsertInput>;
  dataSourceReferences?: InputMaybe<DataSourceReferencesArrRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DataSourcesMaxFields = {
  __typename?: 'DataSourcesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DataSourcesMinFields = {
  __typename?: 'DataSourcesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "data_sources" */
export type DataSourcesMutationResponse = {
  __typename?: 'DataSourcesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DataSources>;
};

/** input type for inserting object relation for remote table "data_sources" */
export type DataSourcesObjRelInsertInput = {
  data: DataSourcesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DataSourcesOnConflict>;
};

/** on_conflict condition type for table "data_sources" */
export type DataSourcesOnConflict = {
  constraint: DataSourcesConstraint;
  updateColumns?: Array<DataSourcesUpdateColumn>;
  where?: InputMaybe<DataSourcesBoolExp>;
};

/** Ordering options when selecting data from "data_sources". */
export type DataSourcesOrderBy = {
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataSourceGSheets?: InputMaybe<DataSourceGsheetsOrderBy>;
  dataSourceImportProjectsAggregate?: InputMaybe<DataSourceImportProjectsAggregateOrderBy>;
  dataSourceJson?: InputMaybe<DataSourceJsonsOrderBy>;
  dataSourcePropertySchemaSetAggregate?: InputMaybe<DataSourcePropertySchemaSetsAggregateOrderBy>;
  dataSourceReferencesAggregate?: InputMaybe<DataSourceReferencesAggregateOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: data_sources */
export type DataSourcesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "data_sources" */
export const DataSourcesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourcesSelectColumn = typeof DataSourcesSelectColumn[keyof typeof DataSourcesSelectColumn];
/** input type for updating data in table "data_sources" */
export type DataSourcesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "data_sources" */
export type DataSourcesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DataSourcesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DataSourcesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "data_sources" */
export const DataSourcesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DataSourcesUpdateColumn = typeof DataSourcesUpdateColumn[keyof typeof DataSourcesUpdateColumn];
export type DataSourcesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DataSourcesSetInput>;
  /** filter the rows which have to be updated */
  where: DataSourcesBoolExp;
};

/** columns and relationships of "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRuns = {
  __typename?: 'DbpjkitWorkerJobRuns';
  awsBatchJobId?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['timestamptz']['output'];
  dbpjkitWorkerJobId: Scalars['uuid']['output'];
  /** An object relationship */
  dbpjkit_worker_job: DbpjkitWorkerJobs;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  queuedAt: Scalars['timestamptz']['output'];
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  status: JobRunStatuses;
  statusId: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsAggregate = {
  __typename?: 'DbpjkitWorkerJobRunsAggregate';
  aggregate?: Maybe<DbpjkitWorkerJobRunsAggregateFields>;
  nodes: Array<DbpjkitWorkerJobRuns>;
};

export type DbpjkitWorkerJobRunsAggregateBoolExp = {
  count?: InputMaybe<DbpjkitWorkerJobRunsAggregateBoolExpCount>;
};

/** aggregate fields of "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsAggregateFields = {
  __typename?: 'DbpjkitWorkerJobRunsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<DbpjkitWorkerJobRunsMaxFields>;
  min?: Maybe<DbpjkitWorkerJobRunsMinFields>;
};


/** aggregate fields of "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<DbpjkitWorkerJobRunsMaxOrderBy>;
  min?: InputMaybe<DbpjkitWorkerJobRunsMinOrderBy>;
};

/** input type for inserting array relation for remote table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsArrRelInsertInput = {
  data: Array<DbpjkitWorkerJobRunsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<DbpjkitWorkerJobRunsOnConflict>;
};

/** Boolean expression to filter rows from the table "dbpjkit_worker_job_runs". All fields are combined with a logical 'AND'. */
export type DbpjkitWorkerJobRunsBoolExp = {
  _and?: InputMaybe<Array<DbpjkitWorkerJobRunsBoolExp>>;
  _not?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
  _or?: InputMaybe<Array<DbpjkitWorkerJobRunsBoolExp>>;
  awsBatchJobId?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dbpjkitWorkerJobId?: InputMaybe<UuidComparisonExp>;
  dbpjkit_worker_job?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
  finishedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  queuedAt?: InputMaybe<TimestamptzComparisonExp>;
  startedAt?: InputMaybe<TimestamptzComparisonExp>;
  status?: InputMaybe<JobRunStatusesBoolExp>;
  statusId?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "dbpjkit_worker_job_runs" */
export const DbpjkitWorkerJobRunsConstraint = {
  /** unique or primary key constraint on columns "id" */
  DbpjkitWorkerJobRunsPkey: 'dbpjkit_worker_job_runs_pkey'
} as const;

export type DbpjkitWorkerJobRunsConstraint = typeof DbpjkitWorkerJobRunsConstraint[keyof typeof DbpjkitWorkerJobRunsConstraint];
/** input type for inserting data into table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsInsertInput = {
  awsBatchJobId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dbpjkitWorkerJobId?: InputMaybe<Scalars['uuid']['input']>;
  dbpjkit_worker_job?: InputMaybe<DbpjkitWorkerJobsObjRelInsertInput>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  status?: InputMaybe<JobRunStatusesObjRelInsertInput>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type DbpjkitWorkerJobRunsMaxFields = {
  __typename?: 'DbpjkitWorkerJobRunsMaxFields';
  awsBatchJobId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dbpjkitWorkerJobId?: Maybe<Scalars['uuid']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuedAt?: Maybe<Scalars['timestamptz']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsMaxOrderBy = {
  awsBatchJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbpjkitWorkerJobId?: InputMaybe<OrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queuedAt?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type DbpjkitWorkerJobRunsMinFields = {
  __typename?: 'DbpjkitWorkerJobRunsMinFields';
  awsBatchJobId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dbpjkitWorkerJobId?: Maybe<Scalars['uuid']['output']>;
  finishedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  queuedAt?: Maybe<Scalars['timestamptz']['output']>;
  startedAt?: Maybe<Scalars['timestamptz']['output']>;
  statusId?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsMinOrderBy = {
  awsBatchJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbpjkitWorkerJobId?: InputMaybe<OrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queuedAt?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsMutationResponse = {
  __typename?: 'DbpjkitWorkerJobRunsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DbpjkitWorkerJobRuns>;
};

/** on_conflict condition type for table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsOnConflict = {
  constraint: DbpjkitWorkerJobRunsConstraint;
  updateColumns?: Array<DbpjkitWorkerJobRunsUpdateColumn>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};

/** Ordering options when selecting data from "dbpjkit_worker_job_runs". */
export type DbpjkitWorkerJobRunsOrderBy = {
  awsBatchJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbpjkitWorkerJobId?: InputMaybe<OrderBy>;
  dbpjkit_worker_job?: InputMaybe<DbpjkitWorkerJobsOrderBy>;
  finishedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  queuedAt?: InputMaybe<OrderBy>;
  startedAt?: InputMaybe<OrderBy>;
  status?: InputMaybe<JobRunStatusesOrderBy>;
  statusId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: dbpjkit_worker_job_runs */
export type DbpjkitWorkerJobRunsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "dbpjkit_worker_job_runs" */
export const DbpjkitWorkerJobRunsSelectColumn = {
  /** column name */
  AwsBatchJobId: 'awsBatchJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DbpjkitWorkerJobId: 'dbpjkitWorkerJobId',
  /** column name */
  FinishedAt: 'finishedAt',
  /** column name */
  Id: 'id',
  /** column name */
  QueuedAt: 'queuedAt',
  /** column name */
  StartedAt: 'startedAt',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type DbpjkitWorkerJobRunsSelectColumn = typeof DbpjkitWorkerJobRunsSelectColumn[keyof typeof DbpjkitWorkerJobRunsSelectColumn];
/** input type for updating data in table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsSetInput = {
  awsBatchJobId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dbpjkitWorkerJobId?: InputMaybe<Scalars['uuid']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "dbpjkit_worker_job_runs" */
export type DbpjkitWorkerJobRunsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DbpjkitWorkerJobRunsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbpjkitWorkerJobRunsStreamCursorValueInput = {
  awsBatchJobId?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dbpjkitWorkerJobId?: InputMaybe<Scalars['uuid']['input']>;
  finishedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  queuedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  startedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  statusId?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "dbpjkit_worker_job_runs" */
export const DbpjkitWorkerJobRunsUpdateColumn = {
  /** column name */
  AwsBatchJobId: 'awsBatchJobId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DbpjkitWorkerJobId: 'dbpjkitWorkerJobId',
  /** column name */
  FinishedAt: 'finishedAt',
  /** column name */
  Id: 'id',
  /** column name */
  QueuedAt: 'queuedAt',
  /** column name */
  StartedAt: 'startedAt',
  /** column name */
  StatusId: 'statusId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type DbpjkitWorkerJobRunsUpdateColumn = typeof DbpjkitWorkerJobRunsUpdateColumn[keyof typeof DbpjkitWorkerJobRunsUpdateColumn];
export type DbpjkitWorkerJobRunsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DbpjkitWorkerJobRunsSetInput>;
  /** filter the rows which have to be updated */
  where: DbpjkitWorkerJobRunsBoolExp;
};

/** columns and relationships of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobs = {
  __typename?: 'DbpjkitWorkerJobs';
  arguments: Scalars['jsonb']['output'];
  commandName: Scalars['String']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An aggregate relationship */
  dbpjkitWorkerJobRunsAggregate: DbpjkitWorkerJobRunsAggregate;
  /** An array relationship */
  dbpjkit_worker_job_runs: Array<DbpjkitWorkerJobRuns>;
  googleSheetId: Scalars['Int']['output'];
  googleSpreadsheetId: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsArgumentsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsDbpjkitWorkerJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


/** columns and relationships of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsDbpjkit_Worker_Job_RunsArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};

/** aggregated selection of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsAggregate = {
  __typename?: 'DbpjkitWorkerJobsAggregate';
  aggregate?: Maybe<DbpjkitWorkerJobsAggregateFields>;
  nodes: Array<DbpjkitWorkerJobs>;
};

/** aggregate fields of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsAggregateFields = {
  __typename?: 'DbpjkitWorkerJobsAggregateFields';
  avg?: Maybe<DbpjkitWorkerJobsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<DbpjkitWorkerJobsMaxFields>;
  min?: Maybe<DbpjkitWorkerJobsMinFields>;
  stddev?: Maybe<DbpjkitWorkerJobsStddevFields>;
  stddevPop?: Maybe<DbpjkitWorkerJobsStddevPopFields>;
  stddevSamp?: Maybe<DbpjkitWorkerJobsStddevSampFields>;
  sum?: Maybe<DbpjkitWorkerJobsSumFields>;
  varPop?: Maybe<DbpjkitWorkerJobsVarPopFields>;
  varSamp?: Maybe<DbpjkitWorkerJobsVarSampFields>;
  variance?: Maybe<DbpjkitWorkerJobsVarianceFields>;
};


/** aggregate fields of "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<DbpjkitWorkerJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type DbpjkitWorkerJobsAppendInput = {
  arguments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type DbpjkitWorkerJobsAvgFields = {
  __typename?: 'DbpjkitWorkerJobsAvgFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "dbpjkit_worker_jobs". All fields are combined with a logical 'AND'. */
export type DbpjkitWorkerJobsBoolExp = {
  _and?: InputMaybe<Array<DbpjkitWorkerJobsBoolExp>>;
  _not?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
  _or?: InputMaybe<Array<DbpjkitWorkerJobsBoolExp>>;
  arguments?: InputMaybe<JsonbComparisonExp>;
  commandName?: InputMaybe<StringComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dbpjkit_worker_job_runs?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
  dbpjkit_worker_job_runsAggregate?: InputMaybe<DbpjkitWorkerJobRunsAggregateBoolExp>;
  googleSheetId?: InputMaybe<IntComparisonExp>;
  googleSpreadsheetId?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "dbpjkit_worker_jobs" */
export const DbpjkitWorkerJobsConstraint = {
  /** unique or primary key constraint on columns "id" */
  DbpjkitWorkerJobsPkey: 'dbpjkit_worker_jobs_pkey'
} as const;

export type DbpjkitWorkerJobsConstraint = typeof DbpjkitWorkerJobsConstraint[keyof typeof DbpjkitWorkerJobsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type DbpjkitWorkerJobsDeleteAtPathInput = {
  arguments?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type DbpjkitWorkerJobsDeleteElemInput = {
  arguments?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type DbpjkitWorkerJobsDeleteKeyInput = {
  arguments?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsIncInput = {
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsInsertInput = {
  arguments?: InputMaybe<Scalars['jsonb']['input']>;
  commandName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dbpjkit_worker_job_runs?: InputMaybe<DbpjkitWorkerJobRunsArrRelInsertInput>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type DbpjkitWorkerJobsMaxFields = {
  __typename?: 'DbpjkitWorkerJobsMaxFields';
  commandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  googleSheetId?: Maybe<Scalars['Int']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type DbpjkitWorkerJobsMinFields = {
  __typename?: 'DbpjkitWorkerJobsMinFields';
  commandName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  googleSheetId?: Maybe<Scalars['Int']['output']>;
  googleSpreadsheetId?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsMutationResponse = {
  __typename?: 'DbpjkitWorkerJobsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<DbpjkitWorkerJobs>;
};

/** input type for inserting object relation for remote table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsObjRelInsertInput = {
  data: DbpjkitWorkerJobsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<DbpjkitWorkerJobsOnConflict>;
};

/** on_conflict condition type for table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsOnConflict = {
  constraint: DbpjkitWorkerJobsConstraint;
  updateColumns?: Array<DbpjkitWorkerJobsUpdateColumn>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};

/** Ordering options when selecting data from "dbpjkit_worker_jobs". */
export type DbpjkitWorkerJobsOrderBy = {
  arguments?: InputMaybe<OrderBy>;
  commandName?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dbpjkit_worker_job_runsAggregate?: InputMaybe<DbpjkitWorkerJobRunsAggregateOrderBy>;
  googleSheetId?: InputMaybe<OrderBy>;
  googleSpreadsheetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: dbpjkit_worker_jobs */
export type DbpjkitWorkerJobsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type DbpjkitWorkerJobsPrependInput = {
  arguments?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "dbpjkit_worker_jobs" */
export const DbpjkitWorkerJobsSelectColumn = {
  /** column name */
  Arguments: 'arguments',
  /** column name */
  CommandName: 'commandName',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  GoogleSheetId: 'googleSheetId',
  /** column name */
  GoogleSpreadsheetId: 'googleSpreadsheetId',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DbpjkitWorkerJobsSelectColumn = typeof DbpjkitWorkerJobsSelectColumn[keyof typeof DbpjkitWorkerJobsSelectColumn];
/** input type for updating data in table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsSetInput = {
  arguments?: InputMaybe<Scalars['jsonb']['input']>;
  commandName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type DbpjkitWorkerJobsStddevFields = {
  __typename?: 'DbpjkitWorkerJobsStddevFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type DbpjkitWorkerJobsStddevPopFields = {
  __typename?: 'DbpjkitWorkerJobsStddevPopFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type DbpjkitWorkerJobsStddevSampFields = {
  __typename?: 'DbpjkitWorkerJobsStddevSampFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "dbpjkit_worker_jobs" */
export type DbpjkitWorkerJobsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: DbpjkitWorkerJobsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type DbpjkitWorkerJobsStreamCursorValueInput = {
  arguments?: InputMaybe<Scalars['jsonb']['input']>;
  commandName?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  googleSheetId?: InputMaybe<Scalars['Int']['input']>;
  googleSpreadsheetId?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type DbpjkitWorkerJobsSumFields = {
  __typename?: 'DbpjkitWorkerJobsSumFields';
  googleSheetId?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "dbpjkit_worker_jobs" */
export const DbpjkitWorkerJobsUpdateColumn = {
  /** column name */
  Arguments: 'arguments',
  /** column name */
  CommandName: 'commandName',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  GoogleSheetId: 'googleSheetId',
  /** column name */
  GoogleSpreadsheetId: 'googleSpreadsheetId',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type DbpjkitWorkerJobsUpdateColumn = typeof DbpjkitWorkerJobsUpdateColumn[keyof typeof DbpjkitWorkerJobsUpdateColumn];
export type DbpjkitWorkerJobsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<DbpjkitWorkerJobsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<DbpjkitWorkerJobsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<DbpjkitWorkerJobsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<DbpjkitWorkerJobsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<DbpjkitWorkerJobsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<DbpjkitWorkerJobsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<DbpjkitWorkerJobsSetInput>;
  /** filter the rows which have to be updated */
  where: DbpjkitWorkerJobsBoolExp;
};

/** aggregate varPop on columns */
export type DbpjkitWorkerJobsVarPopFields = {
  __typename?: 'DbpjkitWorkerJobsVarPopFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type DbpjkitWorkerJobsVarSampFields = {
  __typename?: 'DbpjkitWorkerJobsVarSampFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type DbpjkitWorkerJobsVarianceFields = {
  __typename?: 'DbpjkitWorkerJobsVarianceFields';
  googleSheetId?: Maybe<Scalars['Float']['output']>;
};

export type DefinitionMetadataMappingInput = {
  sourceMetadataName: Scalars['String']['input'];
  targetMetadataName: Scalars['String']['input'];
};

export type DefinitionPropertyMappingInput = {
  sourcePropertyName: Scalars['String']['input'];
  targetPropertyName?: InputMaybe<Scalars['String']['input']>;
};

export const DispatchTarget = {
  Batch: 'batch',
  Lambda: 'lambda'
} as const;

export type DispatchTarget = typeof DispatchTarget[keyof typeof DispatchTarget];
export type DryRunBatchChangeRequestReviewsJobInvalidRecord = {
  __typename?: 'DryRunBatchChangeRequestReviewsJobInvalidRecord';
  changeRequestId: Scalars['String']['output'];
  modelType: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  recordId?: Maybe<Scalars['String']['output']>;
};

export type DryRunBatchChangeRequestReviewsJobOutput = {
  __typename?: 'DryRunBatchChangeRequestReviewsJobOutput';
  invalidRecords: Array<DryRunBatchChangeRequestReviewsJobInvalidRecord>;
  summary: DryRunBatchChangeRequestReviewsJobSummary;
};

export type DryRunBatchChangeRequestReviewsJobResponse = DryRunBatchChangeRequestReviewsJobOutput | ValidationError;

export type DryRunBatchChangeRequestReviewsJobSummary = {
  __typename?: 'DryRunBatchChangeRequestReviewsJobSummary';
  failed: Scalars['Int']['output'];
  passed: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type DryRunBatchChangeRequestsJobCategory = {
  __typename?: 'DryRunBatchChangeRequestsJobCategory';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
};

export type DryRunBatchChangeRequestsJobChangeRequest = {
  __typename?: 'DryRunBatchChangeRequestsJobChangeRequest';
  categories: Array<DryRunBatchChangeRequestsJobCategory>;
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['UUID']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
};

export type DryRunBatchChangeRequestsJobDetailRecord = {
  __typename?: 'DryRunBatchChangeRequestsJobDetailRecord';
  categories: Array<DryRunBatchChangeRequestsJobCategory>;
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
};

export type DryRunBatchChangeRequestsJobEntityDetails = {
  __typename?: 'DryRunBatchChangeRequestsJobEntityDetails';
  changeRequest?: Maybe<DryRunBatchChangeRequestsJobChangeRequest>;
  evidences?: Maybe<Array<DryRunBatchChangeRequestsJobEvidence>>;
  model?: Maybe<DryRunBatchChangeRequestsJobDetailRecord>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DryRunBatchChangeRequestsJobEntityOutput = {
  __typename?: 'DryRunBatchChangeRequestsJobEntityOutput';
  changeRequestId?: Maybe<Scalars['UUID']['output']>;
  changeRequestOperation?: Maybe<ChangeRequestOperation>;
  changeType: ChangeRequestOperationType;
  composerKey: Scalars['String']['output'];
  details?: Maybe<DryRunBatchChangeRequestsJobEntityDetails>;
  dryRun: Scalars['Boolean']['output'];
  modelId?: Maybe<Scalars['UUID']['output']>;
  type: ChangeRequestModelType;
};

export type DryRunBatchChangeRequestsJobEvidence = {
  __typename?: 'DryRunBatchChangeRequestsJobEvidence';
  citation?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSONObject']['output'];
  properties: Scalars['JSONObject']['output'];
};

export type DryRunBatchChangeRequestsJobOutput = {
  __typename?: 'DryRunBatchChangeRequestsJobOutput';
  entities: Array<DryRunBatchChangeRequestsJobEntityOutput>;
  metadata: Array<DryRunBatchChangeRequestsJobRecordMetadataOutput>;
  relations: Array<DryRunBatchChangeRequestsJobRelationOutput>;
};

export type DryRunBatchChangeRequestsJobRecordMetadataDetails = {
  __typename?: 'DryRunBatchChangeRequestsJobRecordMetadataDetails';
  changeRequest?: Maybe<DryRunBatchChangeRequestsJobChangeRequest>;
  evidences?: Maybe<Array<DryRunBatchChangeRequestsJobEvidence>>;
  model?: Maybe<DryRunBatchChangeRequestsJobDetailRecord>;
  reason?: Maybe<Scalars['String']['output']>;
};

export type DryRunBatchChangeRequestsJobRecordMetadataOutput = {
  __typename?: 'DryRunBatchChangeRequestsJobRecordMetadataOutput';
  changeRequestId?: Maybe<Scalars['UUID']['output']>;
  changeRequestOperation?: Maybe<ChangeRequestOperation>;
  changeType: ChangeRequestOperationType;
  composerKey: Scalars['String']['output'];
  details?: Maybe<DryRunBatchChangeRequestsJobRecordMetadataDetails>;
  dryRun: Scalars['Boolean']['output'];
  modelId?: Maybe<Scalars['UUID']['output']>;
  type: ChangeRequestModelType;
};

export type DryRunBatchChangeRequestsJobRelationDetails = {
  __typename?: 'DryRunBatchChangeRequestsJobRelationDetails';
  changeRequest?: Maybe<DryRunBatchChangeRequestsJobChangeRequest>;
  evidences?: Maybe<Array<DryRunBatchChangeRequestsJobEvidence>>;
  model?: Maybe<DryRunBatchChangeRequestsJobDetailRecord>;
  reason?: Maybe<Scalars['String']['output']>;
  source?: Maybe<DryRunBatchChangeRequestsJobChangeRequest>;
  target?: Maybe<DryRunBatchChangeRequestsJobChangeRequest>;
};

export type DryRunBatchChangeRequestsJobRelationOutput = {
  __typename?: 'DryRunBatchChangeRequestsJobRelationOutput';
  changeRequestId?: Maybe<Scalars['UUID']['output']>;
  changeRequestOperation?: Maybe<ChangeRequestOperation>;
  changeType: ChangeRequestOperationType;
  composerKey: Scalars['String']['output'];
  details?: Maybe<DryRunBatchChangeRequestsJobRelationDetails>;
  dryRun: Scalars['Boolean']['output'];
  modelId?: Maybe<Scalars['UUID']['output']>;
  type: ChangeRequestModelType;
};

export type DryRunBatchChangeRequestsJobResponse = DryRunBatchChangeRequestsJobOutput | ValidationError;

export type DryRunBatchEvidencesJobEvidenceOutput = {
  __typename?: 'DryRunBatchEvidencesJobEvidenceOutput';
  action: Scalars['String']['output'];
  citation: Scalars['JSONObject']['output'];
  diff?: Maybe<EvidenceDiffOutput>;
  metadata: Scalars['JSONObject']['output'];
  properties: Scalars['JSONObject']['output'];
  referenceName: Scalars['String']['output'];
  userEmail: Scalars['String']['output'];
  userName?: Maybe<Scalars['String']['output']>;
};

export type DryRunBatchEvidencesJobOutput = {
  __typename?: 'DryRunBatchEvidencesJobOutput';
  evidences: Array<DryRunBatchEvidencesJobEvidenceOutput>;
  skippedCount: Scalars['Int']['output'];
  wikimediaCompletion: DryRunBatchEvidencesJobWikimediaCompletionOutput;
};

export type DryRunBatchEvidencesJobResponse = DryRunBatchEvidencesJobOutput | ValidationError;

export type DryRunBatchEvidencesJobWarningOutput = {
  __typename?: 'DryRunBatchEvidencesJobWarningOutput';
  code: Scalars['String']['output'];
  message: Scalars['String']['output'];
  propertyNames: Array<Scalars['String']['output']>;
  rowId: Scalars['String']['output'];
};

export type DryRunBatchEvidencesJobWikimediaCompletionOutput = {
  __typename?: 'DryRunBatchEvidencesJobWikimediaCompletionOutput';
  completedCount: Scalars['Int']['output'];
  warnings: Array<DryRunBatchEvidencesJobWarningOutput>;
};

export type DryRunOptions = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export const DryRunResultFileType = {
  Html: 'HTML',
  Json: 'JSON'
} as const;

export type DryRunResultFileType = typeof DryRunResultFileType[keyof typeof DryRunResultFileType];
export type DryRunResultUrl = {
  __typename?: 'DryRunResultUrl';
  expiresAt?: Maybe<Scalars['DateTime']['output']>;
  found: Scalars['Boolean']['output'];
  url?: Maybe<Scalars['String']['output']>;
};

export type EffectiveCategoryPropertySchemaItem = {
  __typename?: 'EffectiveCategoryPropertySchemaItem';
  attributeType?: Maybe<PropertyAttributeTypeId>;
  conflict: Scalars['Boolean']['output'];
  description?: Maybe<Scalars['String']['output']>;
  isOwn: Scalars['Boolean']['output'];
  label: Scalars['JSONObject']['output'];
  metadataKey: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  required: Scalars['Boolean']['output'];
  selectOptions?: Maybe<Array<PropertySelectOption>>;
  sourceCategoryId: Scalars['UUID']['output'];
  type: PropertySchemaType;
  unique: Scalars['Boolean']['output'];
  urlAllowList?: Maybe<Array<PropertyUrlAllowItem>>;
};

export type EntityAggregationPolicyInput = {
  /** Requested scope. SEMANTIC Entity slots whose actual category path is exactly ctn.universals use TENANT scope. */
  scope?: InputMaybe<EntityAggregationScope>;
  strategy: EntityAggregationStrategy;
};

export const EntityAggregationScope = {
  Reference: 'REFERENCE',
  Tenant: 'TENANT'
} as const;

export type EntityAggregationScope = typeof EntityAggregationScope[keyof typeof EntityAggregationScope];
export const EntityAggregationStrategy = {
  EvidenceLineage: 'EVIDENCE_LINEAGE',
  Semantic: 'SEMANTIC'
} as const;

export type EntityAggregationStrategy = typeof EntityAggregationStrategy[keyof typeof EntityAggregationStrategy];
/** columns and relationships of "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitions = {
  __typename?: 'EntityRecordComposerDefinitions';
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsAggregate = {
  __typename?: 'EntityRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<EntityRecordComposerDefinitionsAggregateFields>;
  nodes: Array<EntityRecordComposerDefinitions>;
};

/** aggregate fields of "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsAggregateFields = {
  __typename?: 'EntityRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntityRecordComposerDefinitionsMaxFields>;
  min?: Maybe<EntityRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntityRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "entity_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type EntityRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<EntityRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<EntityRecordComposerDefinitionsBoolExp>>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "entity_record_composer_definitions" */
export const EntityRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  EntityRecordComposerDefinitionsPkey: 'entity_record_composer_definitions_pkey'
} as const;

export type EntityRecordComposerDefinitionsConstraint = typeof EntityRecordComposerDefinitionsConstraint[keyof typeof EntityRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsInsertInput = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EntityRecordComposerDefinitionsMaxFields = {
  __typename?: 'EntityRecordComposerDefinitionsMaxFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type EntityRecordComposerDefinitionsMinFields = {
  __typename?: 'EntityRecordComposerDefinitionsMinFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsMutationResponse = {
  __typename?: 'EntityRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsObjRelInsertInput = {
  data: EntityRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EntityRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsOnConflict = {
  constraint: EntityRecordComposerDefinitionsConstraint;
  updateColumns?: Array<EntityRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "entity_record_composer_definitions". */
export type EntityRecordComposerDefinitionsOrderBy = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_record_composer_definitions */
export type EntityRecordComposerDefinitionsPkColumnsInput = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "entity_record_composer_definitions" */
export const EntityRecordComposerDefinitionsSelectColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type EntityRecordComposerDefinitionsSelectColumn = typeof EntityRecordComposerDefinitionsSelectColumn[keyof typeof EntityRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsSetInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "entity_record_composer_definitions" */
export type EntityRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntityRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityRecordComposerDefinitionsStreamCursorValueInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "entity_record_composer_definitions" */
export const EntityRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type EntityRecordComposerDefinitionsUpdateColumn = typeof EntityRecordComposerDefinitionsUpdateColumn[keyof typeof EntityRecordComposerDefinitionsUpdateColumn];
export type EntityRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityRecordComposerDefinitionsBoolExp;
};

/** columns and relationships of "entity_records" */
export type EntityRecords = {
  __typename?: 'EntityRecords';
  /** An object relationship */
  record: Records;
  recordId: Scalars['uuid']['output'];
  /** An array relationship */
  sourceRecordEdges: Array<SourceRecordEdges>;
  /** An aggregate relationship */
  sourceRecordEdgesAggregate: SourceRecordEdgesAggregate;
  /** An array relationship */
  targetRecordEdges: Array<TargetRecordEdges>;
  /** An aggregate relationship */
  targetRecordEdgesAggregate: TargetRecordEdgesAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};


/** columns and relationships of "entity_records" */
export type EntityRecordsSourceRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


/** columns and relationships of "entity_records" */
export type EntityRecordsSourceRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


/** columns and relationships of "entity_records" */
export type EntityRecordsTargetRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


/** columns and relationships of "entity_records" */
export type EntityRecordsTargetRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};

/** aggregated selection of "entity_records" */
export type EntityRecordsAggregate = {
  __typename?: 'EntityRecordsAggregate';
  aggregate?: Maybe<EntityRecordsAggregateFields>;
  nodes: Array<EntityRecords>;
};

/** aggregate fields of "entity_records" */
export type EntityRecordsAggregateFields = {
  __typename?: 'EntityRecordsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EntityRecordsMaxFields>;
  min?: Maybe<EntityRecordsMinFields>;
};


/** aggregate fields of "entity_records" */
export type EntityRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EntityRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "entity_records". All fields are combined with a logical 'AND'. */
export type EntityRecordsBoolExp = {
  _and?: InputMaybe<Array<EntityRecordsBoolExp>>;
  _not?: InputMaybe<EntityRecordsBoolExp>;
  _or?: InputMaybe<Array<EntityRecordsBoolExp>>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  sourceRecordEdges?: InputMaybe<SourceRecordEdgesBoolExp>;
  sourceRecordEdgesAggregate?: InputMaybe<SourceRecordEdgesAggregateBoolExp>;
  targetRecordEdges?: InputMaybe<TargetRecordEdgesBoolExp>;
  targetRecordEdgesAggregate?: InputMaybe<TargetRecordEdgesAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "entity_records" */
export const EntityRecordsConstraint = {
  /** unique or primary key constraint on columns "record_id" */
  EntityRecordsPkey: 'entity_records_pkey'
} as const;

export type EntityRecordsConstraint = typeof EntityRecordsConstraint[keyof typeof EntityRecordsConstraint];
/** input type for inserting data into table "entity_records" */
export type EntityRecordsInsertInput = {
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRecordEdges?: InputMaybe<SourceRecordEdgesArrRelInsertInput>;
  targetRecordEdges?: InputMaybe<TargetRecordEdgesArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type EntityRecordsMaxFields = {
  __typename?: 'EntityRecordsMaxFields';
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type EntityRecordsMinFields = {
  __typename?: 'EntityRecordsMinFields';
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "entity_records" */
export type EntityRecordsMutationResponse = {
  __typename?: 'EntityRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EntityRecords>;
};

/** input type for inserting object relation for remote table "entity_records" */
export type EntityRecordsObjRelInsertInput = {
  data: EntityRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EntityRecordsOnConflict>;
};

/** on_conflict condition type for table "entity_records" */
export type EntityRecordsOnConflict = {
  constraint: EntityRecordsConstraint;
  updateColumns?: Array<EntityRecordsUpdateColumn>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};

/** Ordering options when selecting data from "entity_records". */
export type EntityRecordsOrderBy = {
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  sourceRecordEdgesAggregate?: InputMaybe<SourceRecordEdgesAggregateOrderBy>;
  targetRecordEdgesAggregate?: InputMaybe<TargetRecordEdgesAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: entity_records */
export type EntityRecordsPkColumnsInput = {
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "entity_records" */
export const EntityRecordsSelectColumn = {
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type EntityRecordsSelectColumn = typeof EntityRecordsSelectColumn[keyof typeof EntityRecordsSelectColumn];
/** input type for updating data in table "entity_records" */
export type EntityRecordsSetInput = {
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "entity_records" */
export type EntityRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EntityRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EntityRecordsStreamCursorValueInput = {
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "entity_records" */
export const EntityRecordsUpdateColumn = {
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type EntityRecordsUpdateColumn = typeof EntityRecordsUpdateColumn[keyof typeof EntityRecordsUpdateColumn];
export type EntityRecordsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EntityRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: EntityRecordsBoolExp;
};

export type EvidenceActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceActivateOutput = {
  __typename?: 'EvidenceActivateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "evidence_change_requests" */
export type EvidenceChangeRequests = {
  __typename?: 'EvidenceChangeRequests';
  /** An object relationship */
  changeRequest: ChangeRequests;
  changeRequestId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence: Evidences;
  evidenceId: Scalars['uuid']['output'];
  /** An object relationship */
  evidenceVersion: EvidenceVersions;
  evidenceVersionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "evidence_change_requests" */
export type EvidenceChangeRequestsAggregate = {
  __typename?: 'EvidenceChangeRequestsAggregate';
  aggregate?: Maybe<EvidenceChangeRequestsAggregateFields>;
  nodes: Array<EvidenceChangeRequests>;
};

export type EvidenceChangeRequestsAggregateBoolExp = {
  count?: InputMaybe<EvidenceChangeRequestsAggregateBoolExpCount>;
};

/** aggregate fields of "evidence_change_requests" */
export type EvidenceChangeRequestsAggregateFields = {
  __typename?: 'EvidenceChangeRequestsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceChangeRequestsMaxFields>;
  min?: Maybe<EvidenceChangeRequestsMinFields>;
};


/** aggregate fields of "evidence_change_requests" */
export type EvidenceChangeRequestsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidence_change_requests" */
export type EvidenceChangeRequestsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidenceChangeRequestsMaxOrderBy>;
  min?: InputMaybe<EvidenceChangeRequestsMinOrderBy>;
};

/** input type for inserting array relation for remote table "evidence_change_requests" */
export type EvidenceChangeRequestsArrRelInsertInput = {
  data: Array<EvidenceChangeRequestsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceChangeRequestsOnConflict>;
};

/** Boolean expression to filter rows from the table "evidence_change_requests". All fields are combined with a logical 'AND'. */
export type EvidenceChangeRequestsBoolExp = {
  _and?: InputMaybe<Array<EvidenceChangeRequestsBoolExp>>;
  _not?: InputMaybe<EvidenceChangeRequestsBoolExp>;
  _or?: InputMaybe<Array<EvidenceChangeRequestsBoolExp>>;
  changeRequest?: InputMaybe<ChangeRequestsBoolExp>;
  changeRequestId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidence?: InputMaybe<EvidencesBoolExp>;
  evidenceId?: InputMaybe<UuidComparisonExp>;
  evidenceVersion?: InputMaybe<EvidenceVersionsBoolExp>;
  evidenceVersionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_change_requests" */
export const EvidenceChangeRequestsConstraint = {
  /** unique or primary key constraint on columns "evidence_version_id", "change_request_id" */
  EvcrsEvidenceVersionIdChangeRequestIdKey: 'evcrs_evidence_version_id_change_request_id_key',
  /** unique or primary key constraint on columns "evidence_id", "change_request_id" */
  EvidenceChangeRequestsPkey: 'evidence_change_requests_pkey'
} as const;

export type EvidenceChangeRequestsConstraint = typeof EvidenceChangeRequestsConstraint[keyof typeof EvidenceChangeRequestsConstraint];
/** input type for inserting data into table "evidence_change_requests" */
export type EvidenceChangeRequestsInsertInput = {
  changeRequest?: InputMaybe<ChangeRequestsObjRelInsertInput>;
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence?: InputMaybe<EvidencesObjRelInsertInput>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersion?: InputMaybe<EvidenceVersionsObjRelInsertInput>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceChangeRequestsMaxFields = {
  __typename?: 'EvidenceChangeRequestsMaxFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "evidence_change_requests" */
export type EvidenceChangeRequestsMaxOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidenceChangeRequestsMinFields = {
  __typename?: 'EvidenceChangeRequestsMinFields';
  changeRequestId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "evidence_change_requests" */
export type EvidenceChangeRequestsMinOrderBy = {
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidence_change_requests" */
export type EvidenceChangeRequestsMutationResponse = {
  __typename?: 'EvidenceChangeRequestsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceChangeRequests>;
};

/** on_conflict condition type for table "evidence_change_requests" */
export type EvidenceChangeRequestsOnConflict = {
  constraint: EvidenceChangeRequestsConstraint;
  updateColumns?: Array<EvidenceChangeRequestsUpdateColumn>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};

/** Ordering options when selecting data from "evidence_change_requests". */
export type EvidenceChangeRequestsOrderBy = {
  changeRequest?: InputMaybe<ChangeRequestsOrderBy>;
  changeRequestId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  evidence?: InputMaybe<EvidencesOrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersion?: InputMaybe<EvidenceVersionsOrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_change_requests */
export type EvidenceChangeRequestsPkColumnsInput = {
  changeRequestId: Scalars['uuid']['input'];
  evidenceId: Scalars['uuid']['input'];
};

/** select columns of table "evidence_change_requests" */
export const EvidenceChangeRequestsSelectColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceVersionId: 'evidenceVersionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceChangeRequestsSelectColumn = typeof EvidenceChangeRequestsSelectColumn[keyof typeof EvidenceChangeRequestsSelectColumn];
/** input type for updating data in table "evidence_change_requests" */
export type EvidenceChangeRequestsSetInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_change_requests" */
export type EvidenceChangeRequestsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceChangeRequestsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceChangeRequestsStreamCursorValueInput = {
  changeRequestId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_change_requests" */
export const EvidenceChangeRequestsUpdateColumn = {
  /** column name */
  ChangeRequestId: 'changeRequestId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceVersionId: 'evidenceVersionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceChangeRequestsUpdateColumn = typeof EvidenceChangeRequestsUpdateColumn[keyof typeof EvidenceChangeRequestsUpdateColumn];
export type EvidenceChangeRequestsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceChangeRequestsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceChangeRequestsBoolExp;
};

export type EvidenceCitation = {
  __typename?: 'EvidenceCitation';
  evidenceId: Scalars['UUID']['output'];
  page?: Maybe<Scalars['String']['output']>;
  reference: ReferenceInfo;
};

export type EvidenceDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceDeactivateOutput = {
  __typename?: 'EvidenceDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceDiffOutput = {
  __typename?: 'EvidenceDiffOutput';
  citation?: Maybe<Scalars['JSONObject']['output']>;
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
  wikipedia?: Maybe<Scalars['JSONObject']['output']>;
};

/** columns and relationships of "evidence_evidence_sets" */
export type EvidenceEvidenceSets = {
  __typename?: 'EvidenceEvidenceSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence: Evidences;
  evidenceId: Scalars['uuid']['output'];
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "evidence_evidence_sets" */
export type EvidenceEvidenceSetsAggregate = {
  __typename?: 'EvidenceEvidenceSetsAggregate';
  aggregate?: Maybe<EvidenceEvidenceSetsAggregateFields>;
  nodes: Array<EvidenceEvidenceSets>;
};

export type EvidenceEvidenceSetsAggregateBoolExp = {
  count?: InputMaybe<EvidenceEvidenceSetsAggregateBoolExpCount>;
};

/** aggregate fields of "evidence_evidence_sets" */
export type EvidenceEvidenceSetsAggregateFields = {
  __typename?: 'EvidenceEvidenceSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceEvidenceSetsMaxFields>;
  min?: Maybe<EvidenceEvidenceSetsMinFields>;
};


/** aggregate fields of "evidence_evidence_sets" */
export type EvidenceEvidenceSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidenceEvidenceSetsMaxOrderBy>;
  min?: InputMaybe<EvidenceEvidenceSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsArrRelInsertInput = {
  data: Array<EvidenceEvidenceSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceEvidenceSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "evidence_evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceEvidenceSetsBoolExp = {
  _and?: InputMaybe<Array<EvidenceEvidenceSetsBoolExp>>;
  _not?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
  _or?: InputMaybe<Array<EvidenceEvidenceSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidence?: InputMaybe<EvidencesBoolExp>;
  evidenceId?: InputMaybe<UuidComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_evidence_sets" */
export const EvidenceEvidenceSetsConstraint = {
  /** unique or primary key constraint on columns "evidence_id", "evidence_set_id" */
  EvidenceEvidenceSetsPkey: 'evidence_evidence_sets_pkey'
} as const;

export type EvidenceEvidenceSetsConstraint = typeof EvidenceEvidenceSetsConstraint[keyof typeof EvidenceEvidenceSetsConstraint];
/** input type for inserting data into table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence?: InputMaybe<EvidencesObjRelInsertInput>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceEvidenceSetsMaxFields = {
  __typename?: 'EvidenceEvidenceSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidenceEvidenceSetsMinFields = {
  __typename?: 'EvidenceEvidenceSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsMutationResponse = {
  __typename?: 'EvidenceEvidenceSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceEvidenceSets>;
};

/** on_conflict condition type for table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsOnConflict = {
  constraint: EvidenceEvidenceSetsConstraint;
  updateColumns?: Array<EvidenceEvidenceSetsUpdateColumn>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};

/** Ordering options when selecting data from "evidence_evidence_sets". */
export type EvidenceEvidenceSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidence?: InputMaybe<EvidencesOrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_evidence_sets */
export type EvidenceEvidenceSetsPkColumnsInput = {
  evidenceId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};

/** select columns of table "evidence_evidence_sets" */
export const EvidenceEvidenceSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceEvidenceSetsSelectColumn = typeof EvidenceEvidenceSetsSelectColumn[keyof typeof EvidenceEvidenceSetsSelectColumn];
/** input type for updating data in table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_evidence_sets" */
export type EvidenceEvidenceSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceEvidenceSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceEvidenceSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_evidence_sets" */
export const EvidenceEvidenceSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceEvidenceSetsUpdateColumn = typeof EvidenceEvidenceSetsUpdateColumn[keyof typeof EvidenceEvidenceSetsUpdateColumn];
export type EvidenceEvidenceSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceEvidenceSetsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceEvidenceSetsBoolExp;
};

export type EvidenceIdResolverInput = {
  metadata?: InputMaybe<JsonQueryInput>;
  properties?: InputMaybe<JsonQueryInput>;
};

export type EvidenceImporterActivateInput = {
  id: Scalars['UUID']['input'];
};

export type EvidenceImporterActivateOutput = {
  __typename?: 'EvidenceImporterActivateOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceImporterDeactivateInput = {
  id: Scalars['UUID']['input'];
};

export type EvidenceImporterDeactivateOutput = {
  __typename?: 'EvidenceImporterDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceImporterDefinitionInput = {
  dataSourceFilter?: InputMaybe<JsonQueryInput>;
  evidenceIdResolver?: InputMaybe<EvidenceIdResolverInput>;
  metadataDefaults?: InputMaybe<Scalars['JSON']['input']>;
  metadataMappings: Array<DefinitionMetadataMappingInput>;
  propertiesMappings: Array<DefinitionPropertyMappingInput>;
};

export type EvidenceImporterUpsertInput = {
  dataSourceId: Scalars['UUID']['input'];
  definition: EvidenceImporterDefinitionInput;
  id?: InputMaybe<Scalars['UUID']['input']>;
  importProjectId: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type EvidenceImporterUpsertOutput = {
  __typename?: 'EvidenceImporterUpsertOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceImporterUpsertResponse = EvidenceImporterUpsertOutput | ValidationError;

/** columns and relationships of "evidence_importers" */
export type EvidenceImporters = {
  __typename?: 'EvidenceImporters';
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  dataSource: DataSources;
  dataSourceId: Scalars['uuid']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  definition: Scalars['jsonb']['output'];
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "evidence_importers" */
export type EvidenceImportersBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "evidence_importers" */
export type EvidenceImportersBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "evidence_importers" */
export type EvidenceImportersDefinitionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidence_importers" */
export type EvidenceImportersEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "evidence_importers" */
export type EvidenceImportersEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};

/** aggregated selection of "evidence_importers" */
export type EvidenceImportersAggregate = {
  __typename?: 'EvidenceImportersAggregate';
  aggregate?: Maybe<EvidenceImportersAggregateFields>;
  nodes: Array<EvidenceImporters>;
};

/** aggregate fields of "evidence_importers" */
export type EvidenceImportersAggregateFields = {
  __typename?: 'EvidenceImportersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceImportersMaxFields>;
  min?: Maybe<EvidenceImportersMinFields>;
};


/** aggregate fields of "evidence_importers" */
export type EvidenceImportersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceImportersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EvidenceImportersAppendInput = {
  definition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "evidence_importers". All fields are combined with a logical 'AND'. */
export type EvidenceImportersBoolExp = {
  _and?: InputMaybe<Array<EvidenceImportersBoolExp>>;
  _not?: InputMaybe<EvidenceImportersBoolExp>;
  _or?: InputMaybe<Array<EvidenceImportersBoolExp>>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  dataSource?: InputMaybe<DataSourcesBoolExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  definition?: InputMaybe<JsonbComparisonExp>;
  evidences?: InputMaybe<EvidencesBoolExp>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_importers" */
export const EvidenceImportersConstraint = {
  /** unique or primary key constraint on columns "id" */
  EvidenceImportersPkey: 'evidence_importers_pkey'
} as const;

export type EvidenceImportersConstraint = typeof EvidenceImportersConstraint[keyof typeof EvidenceImportersConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EvidenceImportersDeleteAtPathInput = {
  definition?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EvidenceImportersDeleteElemInput = {
  definition?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EvidenceImportersDeleteKeyInput = {
  definition?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "evidence_importers" */
export type EvidenceImportersInsertInput = {
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSource?: InputMaybe<DataSourcesObjRelInsertInput>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  evidences?: InputMaybe<EvidencesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceImportersMaxFields = {
  __typename?: 'EvidenceImportersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EvidenceImportersMinFields = {
  __typename?: 'EvidenceImportersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "evidence_importers" */
export type EvidenceImportersMutationResponse = {
  __typename?: 'EvidenceImportersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceImporters>;
};

/** input type for inserting object relation for remote table "evidence_importers" */
export type EvidenceImportersObjRelInsertInput = {
  data: EvidenceImportersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceImportersOnConflict>;
};

/** on_conflict condition type for table "evidence_importers" */
export type EvidenceImportersOnConflict = {
  constraint: EvidenceImportersConstraint;
  updateColumns?: Array<EvidenceImportersUpdateColumn>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};

/** Ordering options when selecting data from "evidence_importers". */
export type EvidenceImportersOrderBy = {
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  dataSource?: InputMaybe<DataSourcesOrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  definition?: InputMaybe<OrderBy>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_importers */
export type EvidenceImportersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EvidenceImportersPrependInput = {
  definition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "evidence_importers" */
export const EvidenceImportersSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Definition: 'definition',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceImportersSelectColumn = typeof EvidenceImportersSelectColumn[keyof typeof EvidenceImportersSelectColumn];
/** input type for updating data in table "evidence_importers" */
export type EvidenceImportersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_importers" */
export type EvidenceImportersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceImportersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceImportersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_importers" */
export const EvidenceImportersUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Definition: 'definition',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceImportersUpdateColumn = typeof EvidenceImportersUpdateColumn[keyof typeof EvidenceImportersUpdateColumn];
export type EvidenceImportersUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EvidenceImportersAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EvidenceImportersDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EvidenceImportersDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EvidenceImportersDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EvidenceImportersPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceImportersSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceImportersBoolExp;
};

/** columns and relationships of "evidence_record_geo_items" */
export type EvidenceRecordGeoItems = {
  __typename?: 'EvidenceRecordGeoItems';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidence: Evidences;
  evidenceId: Scalars['uuid']['output'];
  /** An object relationship */
  evidenceVersion: EvidenceVersions;
  evidenceVersionId: Scalars['uuid']['output'];
  geoItemId: Scalars['uuid']['output'];
  /** An object relationship */
  recordGeoItem: RecordGeoItems;
  recordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsAggregate = {
  __typename?: 'EvidenceRecordGeoItemsAggregate';
  aggregate?: Maybe<EvidenceRecordGeoItemsAggregateFields>;
  nodes: Array<EvidenceRecordGeoItems>;
};

export type EvidenceRecordGeoItemsAggregateBoolExp = {
  count?: InputMaybe<EvidenceRecordGeoItemsAggregateBoolExpCount>;
};

/** aggregate fields of "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsAggregateFields = {
  __typename?: 'EvidenceRecordGeoItemsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceRecordGeoItemsMaxFields>;
  min?: Maybe<EvidenceRecordGeoItemsMinFields>;
};


/** aggregate fields of "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidenceRecordGeoItemsMaxOrderBy>;
  min?: InputMaybe<EvidenceRecordGeoItemsMinOrderBy>;
};

/** input type for inserting array relation for remote table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsArrRelInsertInput = {
  data: Array<EvidenceRecordGeoItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceRecordGeoItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "evidence_record_geo_items". All fields are combined with a logical 'AND'. */
export type EvidenceRecordGeoItemsBoolExp = {
  _and?: InputMaybe<Array<EvidenceRecordGeoItemsBoolExp>>;
  _not?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
  _or?: InputMaybe<Array<EvidenceRecordGeoItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidence?: InputMaybe<EvidencesBoolExp>;
  evidenceId?: InputMaybe<UuidComparisonExp>;
  evidenceVersion?: InputMaybe<EvidenceVersionsBoolExp>;
  evidenceVersionId?: InputMaybe<UuidComparisonExp>;
  geoItemId?: InputMaybe<UuidComparisonExp>;
  recordGeoItem?: InputMaybe<RecordGeoItemsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_record_geo_items" */
export const EvidenceRecordGeoItemsConstraint = {
  /** unique or primary key constraint on columns "evidence_id", "record_id", "geo_item_id" */
  EvidenceRecordGeoItemsPkey: 'evidence_record_geo_items_pkey'
} as const;

export type EvidenceRecordGeoItemsConstraint = typeof EvidenceRecordGeoItemsConstraint[keyof typeof EvidenceRecordGeoItemsConstraint];
/** input type for inserting data into table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence?: InputMaybe<EvidencesObjRelInsertInput>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersion?: InputMaybe<EvidenceVersionsObjRelInsertInput>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  recordGeoItem?: InputMaybe<RecordGeoItemsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceRecordGeoItemsMaxFields = {
  __typename?: 'EvidenceRecordGeoItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  geoItemId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidenceRecordGeoItemsMinFields = {
  __typename?: 'EvidenceRecordGeoItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  geoItemId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsMutationResponse = {
  __typename?: 'EvidenceRecordGeoItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceRecordGeoItems>;
};

/** on_conflict condition type for table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsOnConflict = {
  constraint: EvidenceRecordGeoItemsConstraint;
  updateColumns?: Array<EvidenceRecordGeoItemsUpdateColumn>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};

/** Ordering options when selecting data from "evidence_record_geo_items". */
export type EvidenceRecordGeoItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidence?: InputMaybe<EvidencesOrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceVersion?: InputMaybe<EvidenceVersionsOrderBy>;
  evidenceVersionId?: InputMaybe<OrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  recordGeoItem?: InputMaybe<RecordGeoItemsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_record_geo_items */
export type EvidenceRecordGeoItemsPkColumnsInput = {
  evidenceId: Scalars['uuid']['input'];
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "evidence_record_geo_items" */
export const EvidenceRecordGeoItemsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceVersionId: 'evidenceVersionId',
  /** column name */
  GeoItemId: 'geoItemId',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceRecordGeoItemsSelectColumn = typeof EvidenceRecordGeoItemsSelectColumn[keyof typeof EvidenceRecordGeoItemsSelectColumn];
/** input type for updating data in table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_record_geo_items" */
export type EvidenceRecordGeoItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceRecordGeoItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceRecordGeoItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_record_geo_items" */
export const EvidenceRecordGeoItemsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceVersionId: 'evidenceVersionId',
  /** column name */
  GeoItemId: 'geoItemId',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceRecordGeoItemsUpdateColumn = typeof EvidenceRecordGeoItemsUpdateColumn[keyof typeof EvidenceRecordGeoItemsUpdateColumn];
export type EvidenceRecordGeoItemsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceRecordGeoItemsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceRecordGeoItemsBoolExp;
};

export type EvidenceSetCreateFromFileInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetCreateOutput = {
  __typename?: 'EvidenceSetCreateOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceSetCreateResponse = EvidenceSetCreateOutput | ValidationError;

export type EvidenceSetExportInput = {
  format: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetExportOutput = {
  __typename?: 'EvidenceSetExportOutput';
  url: Scalars['String']['output'];
};

export type EvidenceSetExportResponse = EvidenceSetExportOutput | ValidationError;

export type EvidenceSetImportProjectCreateInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  evidenceSetId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetImportProjectCreateOutput = {
  __typename?: 'EvidenceSetImportProjectCreateOutput';
  dataImportProjectId: Scalars['UUID']['output'];
  evidenceSetId: Scalars['UUID']['output'];
};

export type EvidenceSetImportProjectCreateResponse = ClientError | EvidenceSetImportProjectCreateOutput;

export type EvidenceSetImportProjectDeleteInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  evidenceSetId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetImportProjectDeleteOutput = {
  __typename?: 'EvidenceSetImportProjectDeleteOutput';
  dataImportProjectId: Scalars['UUID']['output'];
  evidenceSetId: Scalars['UUID']['output'];
};

export type EvidenceSetImportProjectDeleteResponse = ClientError | EvidenceSetImportProjectDeleteOutput;

/** columns and relationships of "evidence_set_import_projects" */
export type EvidenceSetImportProjects = {
  __typename?: 'EvidenceSetImportProjects';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProject: DataImportProjects;
  dataImportProjectId: Scalars['uuid']['output'];
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "evidence_set_import_projects" */
export type EvidenceSetImportProjectsAggregate = {
  __typename?: 'EvidenceSetImportProjectsAggregate';
  aggregate?: Maybe<EvidenceSetImportProjectsAggregateFields>;
  nodes: Array<EvidenceSetImportProjects>;
};

export type EvidenceSetImportProjectsAggregateBoolExp = {
  count?: InputMaybe<EvidenceSetImportProjectsAggregateBoolExpCount>;
};

/** aggregate fields of "evidence_set_import_projects" */
export type EvidenceSetImportProjectsAggregateFields = {
  __typename?: 'EvidenceSetImportProjectsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceSetImportProjectsMaxFields>;
  min?: Maybe<EvidenceSetImportProjectsMinFields>;
};


/** aggregate fields of "evidence_set_import_projects" */
export type EvidenceSetImportProjectsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidenceSetImportProjectsMaxOrderBy>;
  min?: InputMaybe<EvidenceSetImportProjectsMinOrderBy>;
};

/** input type for inserting array relation for remote table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsArrRelInsertInput = {
  data: Array<EvidenceSetImportProjectsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceSetImportProjectsOnConflict>;
};

/** Boolean expression to filter rows from the table "evidence_set_import_projects". All fields are combined with a logical 'AND'. */
export type EvidenceSetImportProjectsBoolExp = {
  _and?: InputMaybe<Array<EvidenceSetImportProjectsBoolExp>>;
  _not?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
  _or?: InputMaybe<Array<EvidenceSetImportProjectsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProject?: InputMaybe<DataImportProjectsBoolExp>;
  dataImportProjectId?: InputMaybe<UuidComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_set_import_projects" */
export const EvidenceSetImportProjectsConstraint = {
  /** unique or primary key constraint on columns "data_import_project_id", "evidence_set_id" */
  EvidenceSetImportProjectsPkey: 'evidence_set_import_projects_pkey'
} as const;

export type EvidenceSetImportProjectsConstraint = typeof EvidenceSetImportProjectsConstraint[keyof typeof EvidenceSetImportProjectsConstraint];
/** input type for inserting data into table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProject?: InputMaybe<DataImportProjectsObjRelInsertInput>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceSetImportProjectsMaxFields = {
  __typename?: 'EvidenceSetImportProjectsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidenceSetImportProjectsMinFields = {
  __typename?: 'EvidenceSetImportProjectsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataImportProjectId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsMutationResponse = {
  __typename?: 'EvidenceSetImportProjectsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceSetImportProjects>;
};

/** on_conflict condition type for table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsOnConflict = {
  constraint: EvidenceSetImportProjectsConstraint;
  updateColumns?: Array<EvidenceSetImportProjectsUpdateColumn>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};

/** Ordering options when selecting data from "evidence_set_import_projects". */
export type EvidenceSetImportProjectsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  dataImportProject?: InputMaybe<DataImportProjectsOrderBy>;
  dataImportProjectId?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_set_import_projects */
export type EvidenceSetImportProjectsPkColumnsInput = {
  dataImportProjectId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};

/** select columns of table "evidence_set_import_projects" */
export const EvidenceSetImportProjectsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetImportProjectsSelectColumn = typeof EvidenceSetImportProjectsSelectColumn[keyof typeof EvidenceSetImportProjectsSelectColumn];
/** input type for updating data in table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_set_import_projects" */
export type EvidenceSetImportProjectsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceSetImportProjectsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceSetImportProjectsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_set_import_projects" */
export const EvidenceSetImportProjectsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataImportProjectId: 'dataImportProjectId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetImportProjectsUpdateColumn = typeof EvidenceSetImportProjectsUpdateColumn[keyof typeof EvidenceSetImportProjectsUpdateColumn];
export type EvidenceSetImportProjectsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceSetImportProjectsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceSetImportProjectsBoolExp;
};

export type EvidenceSetPreviewEvidence = {
  __typename?: 'EvidenceSetPreviewEvidence';
  id: Scalars['ID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
};

export type EvidenceSetPreviewInput = {
  categoryId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  query?: InputMaybe<RecordsQuery>;
  referenceId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetPreviewOutput = {
  __typename?: 'EvidenceSetPreviewOutput';
  records: Array<EvidenceSetPreviewRecord>;
  totalEvidenceCount: Scalars['Int']['output'];
  totalRecordCount: Scalars['Int']['output'];
};

export type EvidenceSetPreviewRecord = {
  __typename?: 'EvidenceSetPreviewRecord';
  evidences: Array<EvidenceSetPreviewEvidence>;
  recordId: Scalars['ID']['output'];
  recordName?: Maybe<Scalars['String']['output']>;
  recordProperties?: Maybe<Scalars['JSONObject']['output']>;
};

/** columns and relationships of "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSets = {
  __typename?: 'EvidenceSetPropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsAggregate = {
  __typename?: 'EvidenceSetPropertySchemaSetsAggregate';
  aggregate?: Maybe<EvidenceSetPropertySchemaSetsAggregateFields>;
  nodes: Array<EvidenceSetPropertySchemaSets>;
};

/** aggregate fields of "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsAggregateFields = {
  __typename?: 'EvidenceSetPropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceSetPropertySchemaSetsMaxFields>;
  min?: Maybe<EvidenceSetPropertySchemaSetsMinFields>;
};


/** aggregate fields of "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceSetPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "evidence_set_property_schema_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetPropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<EvidenceSetPropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<EvidenceSetPropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_set_property_schema_sets" */
export const EvidenceSetPropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "evidence_set_id" */
  EvidenceSetPropertySchemaSetsPkey: 'evidence_set_property_schema_sets_pkey'
} as const;

export type EvidenceSetPropertySchemaSetsConstraint = typeof EvidenceSetPropertySchemaSetsConstraint[keyof typeof EvidenceSetPropertySchemaSetsConstraint];
/** input type for inserting data into table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceSetPropertySchemaSetsMaxFields = {
  __typename?: 'EvidenceSetPropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EvidenceSetPropertySchemaSetsMinFields = {
  __typename?: 'EvidenceSetPropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsMutationResponse = {
  __typename?: 'EvidenceSetPropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceSetPropertySchemaSets>;
};

/** input type for inserting object relation for remote table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsObjRelInsertInput = {
  data: EvidenceSetPropertySchemaSetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceSetPropertySchemaSetsOnConflict>;
};

/** on_conflict condition type for table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsOnConflict = {
  constraint: EvidenceSetPropertySchemaSetsConstraint;
  updateColumns?: Array<EvidenceSetPropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "evidence_set_property_schema_sets". */
export type EvidenceSetPropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_set_property_schema_sets */
export type EvidenceSetPropertySchemaSetsPkColumnsInput = {
  evidenceSetId: Scalars['uuid']['input'];
};

/** select columns of table "evidence_set_property_schema_sets" */
export const EvidenceSetPropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetPropertySchemaSetsSelectColumn = typeof EvidenceSetPropertySchemaSetsSelectColumn[keyof typeof EvidenceSetPropertySchemaSetsSelectColumn];
/** input type for updating data in table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_set_property_schema_sets" */
export type EvidenceSetPropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceSetPropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceSetPropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_set_property_schema_sets" */
export const EvidenceSetPropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetPropertySchemaSetsUpdateColumn = typeof EvidenceSetPropertySchemaSetsUpdateColumn[keyof typeof EvidenceSetPropertySchemaSetsUpdateColumn];
export type EvidenceSetPropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceSetPropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceSetPropertySchemaSetsBoolExp;
};

export type EvidenceSetUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
  propertySchemaSet?: InputMaybe<PropertySchemaSetUpsertInput>;
  tenantId: Scalars['UUID']['input'];
};

export type EvidenceSetUpdateOutput = {
  __typename?: 'EvidenceSetUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type EvidenceSetUpdateResponse = EvidenceSetUpdateOutput | ValidationError;

/** columns and relationships of "evidence_sets" */
export type EvidenceSets = {
  __typename?: 'EvidenceSets';
  /** An array relationship */
  batchChangeRequestsJobs: Array<BatchChangeRequestsJobs>;
  /** An aggregate relationship */
  batchChangeRequestsJobsAggregate: BatchChangeRequestsJobsAggregate;
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  evidenceEvidenceSets: Array<EvidenceEvidenceSets>;
  /** An aggregate relationship */
  evidenceEvidenceSetsAggregate: EvidenceEvidenceSetsAggregate;
  /** An array relationship */
  evidenceSetImportProjects: Array<EvidenceSetImportProjects>;
  /** An aggregate relationship */
  evidenceSetImportProjectsAggregate: EvidenceSetImportProjectsAggregate;
  /** An object relationship */
  evidenceSetPropertySchemaSet?: Maybe<EvidenceSetPropertySchemaSets>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  recordComposerDefinitionEvidenceSets: Array<RecordComposerDefinitionEvidenceSets>;
  /** An aggregate relationship */
  recordComposerDefinitionEvidenceSetsAggregate: RecordComposerDefinitionEvidenceSetsAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsBatchChangeRequestsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsBatchChangeRequestsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsEvidenceEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsEvidenceEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsEvidenceSetImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsEvidenceSetImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsRecordComposerDefinitionEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


/** columns and relationships of "evidence_sets" */
export type EvidenceSetsRecordComposerDefinitionEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};

/** aggregated selection of "evidence_sets" */
export type EvidenceSetsAggregate = {
  __typename?: 'EvidenceSetsAggregate';
  aggregate?: Maybe<EvidenceSetsAggregateFields>;
  nodes: Array<EvidenceSets>;
};

/** aggregate fields of "evidence_sets" */
export type EvidenceSetsAggregateFields = {
  __typename?: 'EvidenceSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceSetsMaxFields>;
  min?: Maybe<EvidenceSetsMinFields>;
};


/** aggregate fields of "evidence_sets" */
export type EvidenceSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "evidence_sets". All fields are combined with a logical 'AND'. */
export type EvidenceSetsBoolExp = {
  _and?: InputMaybe<Array<EvidenceSetsBoolExp>>;
  _not?: InputMaybe<EvidenceSetsBoolExp>;
  _or?: InputMaybe<Array<EvidenceSetsBoolExp>>;
  batchChangeRequestsJobs?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  batchChangeRequestsJobsAggregate?: InputMaybe<BatchChangeRequestsJobsAggregateBoolExp>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  evidenceEvidenceSets?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
  evidenceEvidenceSetsAggregate?: InputMaybe<EvidenceEvidenceSetsAggregateBoolExp>;
  evidenceSetImportProjects?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
  evidenceSetImportProjectsAggregate?: InputMaybe<EvidenceSetImportProjectsAggregateBoolExp>;
  evidenceSetPropertySchemaSet?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  recordComposerDefinitionEvidenceSets?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
  recordComposerDefinitionEvidenceSetsAggregate?: InputMaybe<RecordComposerDefinitionEvidenceSetsAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "evidence_sets" */
export const EvidenceSetsConstraint = {
  /** unique or primary key constraint on columns "id" */
  EvidenceSetsPkey: 'evidence_sets_pkey'
} as const;

export type EvidenceSetsConstraint = typeof EvidenceSetsConstraint[keyof typeof EvidenceSetsConstraint];
/** input type for inserting data into table "evidence_sets" */
export type EvidenceSetsInsertInput = {
  batchChangeRequestsJobs?: InputMaybe<BatchChangeRequestsJobsArrRelInsertInput>;
  batchEvidencesJobs?: InputMaybe<BatchEvidencesJobsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  evidenceEvidenceSets?: InputMaybe<EvidenceEvidenceSetsArrRelInsertInput>;
  evidenceSetImportProjects?: InputMaybe<EvidenceSetImportProjectsArrRelInsertInput>;
  evidenceSetPropertySchemaSet?: InputMaybe<EvidenceSetPropertySchemaSetsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordComposerDefinitionEvidenceSets?: InputMaybe<RecordComposerDefinitionEvidenceSetsArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type EvidenceSetsMaxFields = {
  __typename?: 'EvidenceSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type EvidenceSetsMinFields = {
  __typename?: 'EvidenceSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "evidence_sets" */
export type EvidenceSetsMutationResponse = {
  __typename?: 'EvidenceSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceSets>;
};

/** input type for inserting object relation for remote table "evidence_sets" */
export type EvidenceSetsObjRelInsertInput = {
  data: EvidenceSetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceSetsOnConflict>;
};

/** on_conflict condition type for table "evidence_sets" */
export type EvidenceSetsOnConflict = {
  constraint: EvidenceSetsConstraint;
  updateColumns?: Array<EvidenceSetsUpdateColumn>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};

/** Ordering options when selecting data from "evidence_sets". */
export type EvidenceSetsOrderBy = {
  batchChangeRequestsJobsAggregate?: InputMaybe<BatchChangeRequestsJobsAggregateOrderBy>;
  batchEvidencesJobsAggregate?: InputMaybe<BatchEvidencesJobsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  evidenceEvidenceSetsAggregate?: InputMaybe<EvidenceEvidenceSetsAggregateOrderBy>;
  evidenceSetImportProjectsAggregate?: InputMaybe<EvidenceSetImportProjectsAggregateOrderBy>;
  evidenceSetPropertySchemaSet?: InputMaybe<EvidenceSetPropertySchemaSetsOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  recordComposerDefinitionEvidenceSetsAggregate?: InputMaybe<RecordComposerDefinitionEvidenceSetsAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_sets */
export type EvidenceSetsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "evidence_sets" */
export const EvidenceSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetsSelectColumn = typeof EvidenceSetsSelectColumn[keyof typeof EvidenceSetsSelectColumn];
/** input type for updating data in table "evidence_sets" */
export type EvidenceSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "evidence_sets" */
export type EvidenceSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "evidence_sets" */
export const EvidenceSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type EvidenceSetsUpdateColumn = typeof EvidenceSetsUpdateColumn[keyof typeof EvidenceSetsUpdateColumn];
export type EvidenceSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceSetsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceSetsBoolExp;
};

export type EvidenceUpsertInput = {
  citation?: InputMaybe<CitationInput>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  referenceId: Scalars['UUID']['input'];
};

/** columns and relationships of "evidence_versions" */
export type EvidenceVersions = {
  __typename?: 'EvidenceVersions';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  citation: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An object relationship */
  evidence: Evidences;
  /** An array relationship */
  evidenceChangeRequests: Array<EvidenceChangeRequests>;
  /** An aggregate relationship */
  evidenceChangeRequestsAggregate: EvidenceChangeRequestsAggregate;
  evidenceId: Scalars['uuid']['output'];
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  id: Scalars['uuid']['output'];
  jobRunId?: Maybe<Scalars['uuid']['output']>;
  metadata: Scalars['jsonb']['output'];
  operation: Scalars['String']['output'];
  properties: Scalars['jsonb']['output'];
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  userId?: Maybe<Scalars['uuid']['output']>;
  version: Scalars['Int']['output'];
  wikipediaJson: Scalars['jsonb']['output'];
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsCitationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsEvidenceChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsEvidenceChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidence_versions" */
export type EvidenceVersionsWikipediaJsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "evidence_versions" */
export type EvidenceVersionsAggregate = {
  __typename?: 'EvidenceVersionsAggregate';
  aggregate?: Maybe<EvidenceVersionsAggregateFields>;
  nodes: Array<EvidenceVersions>;
};

export type EvidenceVersionsAggregateBoolExp = {
  count?: InputMaybe<EvidenceVersionsAggregateBoolExpCount>;
};

/** aggregate fields of "evidence_versions" */
export type EvidenceVersionsAggregateFields = {
  __typename?: 'EvidenceVersionsAggregateFields';
  avg?: Maybe<EvidenceVersionsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EvidenceVersionsMaxFields>;
  min?: Maybe<EvidenceVersionsMinFields>;
  stddev?: Maybe<EvidenceVersionsStddevFields>;
  stddevPop?: Maybe<EvidenceVersionsStddevPopFields>;
  stddevSamp?: Maybe<EvidenceVersionsStddevSampFields>;
  sum?: Maybe<EvidenceVersionsSumFields>;
  varPop?: Maybe<EvidenceVersionsVarPopFields>;
  varSamp?: Maybe<EvidenceVersionsVarSampFields>;
  variance?: Maybe<EvidenceVersionsVarianceFields>;
};


/** aggregate fields of "evidence_versions" */
export type EvidenceVersionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidence_versions" */
export type EvidenceVersionsAggregateOrderBy = {
  avg?: InputMaybe<EvidenceVersionsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidenceVersionsMaxOrderBy>;
  min?: InputMaybe<EvidenceVersionsMinOrderBy>;
  stddev?: InputMaybe<EvidenceVersionsStddevOrderBy>;
  stddevPop?: InputMaybe<EvidenceVersionsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EvidenceVersionsStddevSampOrderBy>;
  sum?: InputMaybe<EvidenceVersionsSumOrderBy>;
  varPop?: InputMaybe<EvidenceVersionsVarPopOrderBy>;
  varSamp?: InputMaybe<EvidenceVersionsVarSampOrderBy>;
  variance?: InputMaybe<EvidenceVersionsVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EvidenceVersionsAppendInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "evidence_versions" */
export type EvidenceVersionsArrRelInsertInput = {
  data: Array<EvidenceVersionsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceVersionsOnConflict>;
};

/** aggregate avg on columns */
export type EvidenceVersionsAvgFields = {
  __typename?: 'EvidenceVersionsAvgFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "evidence_versions" */
export type EvidenceVersionsAvgOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "evidence_versions". All fields are combined with a logical 'AND'. */
export type EvidenceVersionsBoolExp = {
  _and?: InputMaybe<Array<EvidenceVersionsBoolExp>>;
  _not?: InputMaybe<EvidenceVersionsBoolExp>;
  _or?: InputMaybe<Array<EvidenceVersionsBoolExp>>;
  batchEvidencesJobId?: InputMaybe<UuidComparisonExp>;
  caller?: InputMaybe<StringComparisonExp>;
  citation?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidence?: InputMaybe<EvidencesBoolExp>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsBoolExp>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateBoolExp>;
  evidenceId?: InputMaybe<UuidComparisonExp>;
  evidenceImporterId?: InputMaybe<UuidComparisonExp>;
  evidenceSetIdArray?: InputMaybe<UuidArrayComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  jobRunId?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  operation?: InputMaybe<StringComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  wikipediaJson?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "evidence_versions" */
export const EvidenceVersionsConstraint = {
  /** unique or primary key constraint on columns "evidence_id", "version" */
  EvidenceVersionsEvidenceIdVersionKey: 'evidence_versions_evidence_id_version_key',
  /** unique or primary key constraint on columns "id" */
  EvidenceVersionsPkey: 'evidence_versions_pkey',
  /** unique or primary key constraint on columns "evidence_id", "id", "tenant_id" */
  EvidenceVersionsTenantIdEvidenceIdIdKey: 'evidence_versions_tenant_id_evidence_id_id_key'
} as const;

export type EvidenceVersionsConstraint = typeof EvidenceVersionsConstraint[keyof typeof EvidenceVersionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EvidenceVersionsDeleteAtPathInput = {
  citation?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
  wikipediaJson?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EvidenceVersionsDeleteElemInput = {
  citation?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EvidenceVersionsDeleteKeyInput = {
  citation?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  wikipediaJson?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "evidence_versions" */
export type EvidenceVersionsIncInput = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "evidence_versions" */
export type EvidenceVersionsInsertInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  caller?: InputMaybe<Scalars['String']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidence?: InputMaybe<EvidencesObjRelInsertInput>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsArrRelInsertInput>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobRunId?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type EvidenceVersionsMaxFields = {
  __typename?: 'EvidenceVersionsMaxFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobRunId?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "evidence_versions" */
export type EvidenceVersionsMaxOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  caller?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetIdArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobRunId?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidenceVersionsMinFields = {
  __typename?: 'EvidenceVersionsMinFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  caller?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetIdArray?: Maybe<Array<Scalars['uuid']['output']>>;
  id?: Maybe<Scalars['uuid']['output']>;
  jobRunId?: Maybe<Scalars['uuid']['output']>;
  operation?: Maybe<Scalars['String']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "evidence_versions" */
export type EvidenceVersionsMinOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  caller?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetIdArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobRunId?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidence_versions" */
export type EvidenceVersionsMutationResponse = {
  __typename?: 'EvidenceVersionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<EvidenceVersions>;
};

/** input type for inserting object relation for remote table "evidence_versions" */
export type EvidenceVersionsObjRelInsertInput = {
  data: EvidenceVersionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EvidenceVersionsOnConflict>;
};

/** on_conflict condition type for table "evidence_versions" */
export type EvidenceVersionsOnConflict = {
  constraint: EvidenceVersionsConstraint;
  updateColumns?: Array<EvidenceVersionsUpdateColumn>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};

/** Ordering options when selecting data from "evidence_versions". */
export type EvidenceVersionsOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  caller?: InputMaybe<OrderBy>;
  citation?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidence?: InputMaybe<EvidencesOrderBy>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateOrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetIdArray?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  jobRunId?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  operation?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  wikipediaJson?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidence_versions */
export type EvidenceVersionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EvidenceVersionsPrependInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "evidence_versions" */
export const EvidenceVersionsSelectColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  Caller: 'caller',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetIdArray: 'evidenceSetIdArray',
  /** column name */
  Id: 'id',
  /** column name */
  JobRunId: 'jobRunId',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Operation: 'operation',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UserId: 'userId',
  /** column name */
  Version: 'version',
  /** column name */
  WikipediaJson: 'wikipediaJson'
} as const;

export type EvidenceVersionsSelectColumn = typeof EvidenceVersionsSelectColumn[keyof typeof EvidenceVersionsSelectColumn];
/** input type for updating data in table "evidence_versions" */
export type EvidenceVersionsSetInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  caller?: InputMaybe<Scalars['String']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobRunId?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type EvidenceVersionsStddevFields = {
  __typename?: 'EvidenceVersionsStddevFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EvidenceVersionsStddevPopFields = {
  __typename?: 'EvidenceVersionsStddevPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EvidenceVersionsStddevSampFields = {
  __typename?: 'EvidenceVersionsStddevSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "evidence_versions" */
export type EvidenceVersionsStddevSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "evidence_versions" */
export type EvidenceVersionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidenceVersionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidenceVersionsStreamCursorValueInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  caller?: InputMaybe<Scalars['String']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetIdArray?: InputMaybe<Array<Scalars['uuid']['input']>>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  jobRunId?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  operation?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type EvidenceVersionsSumFields = {
  __typename?: 'EvidenceVersionsSumFields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "evidence_versions" */
export type EvidenceVersionsSumOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "evidence_versions" */
export const EvidenceVersionsUpdateColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  Caller: 'caller',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetIdArray: 'evidenceSetIdArray',
  /** column name */
  Id: 'id',
  /** column name */
  JobRunId: 'jobRunId',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Operation: 'operation',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UserId: 'userId',
  /** column name */
  Version: 'version',
  /** column name */
  WikipediaJson: 'wikipediaJson'
} as const;

export type EvidenceVersionsUpdateColumn = typeof EvidenceVersionsUpdateColumn[keyof typeof EvidenceVersionsUpdateColumn];
export type EvidenceVersionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EvidenceVersionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EvidenceVersionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EvidenceVersionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EvidenceVersionsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EvidenceVersionsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EvidenceVersionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidenceVersionsSetInput>;
  /** filter the rows which have to be updated */
  where: EvidenceVersionsBoolExp;
};

/** aggregate varPop on columns */
export type EvidenceVersionsVarPopFields = {
  __typename?: 'EvidenceVersionsVarPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "evidence_versions" */
export type EvidenceVersionsVarPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EvidenceVersionsVarSampFields = {
  __typename?: 'EvidenceVersionsVarSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "evidence_versions" */
export type EvidenceVersionsVarSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EvidenceVersionsVarianceFields = {
  __typename?: 'EvidenceVersionsVarianceFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "evidence_versions" */
export type EvidenceVersionsVarianceOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** columns and relationships of "evidences" */
export type Evidences = {
  __typename?: 'Evidences';
  /** An object relationship */
  batchEvidencesJob?: Maybe<BatchEvidencesJobs>;
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  batchEvidencesJobRun?: Maybe<BatchEvidencesJobRuns>;
  batchEvidencesJobRunId?: Maybe<Scalars['uuid']['output']>;
  citation: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  /** An array relationship */
  evidenceChangeRequests: Array<EvidenceChangeRequests>;
  /** An aggregate relationship */
  evidenceChangeRequestsAggregate: EvidenceChangeRequestsAggregate;
  /** An array relationship */
  evidenceEvidenceSets: Array<EvidenceEvidenceSets>;
  /** An aggregate relationship */
  evidenceEvidenceSetsAggregate: EvidenceEvidenceSetsAggregate;
  /** An object relationship */
  evidenceImporter?: Maybe<EvidenceImporters>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  /** An array relationship */
  evidenceRecordGeoItems: Array<EvidenceRecordGeoItems>;
  /** An aggregate relationship */
  evidenceRecordGeoItemsAggregate: EvidenceRecordGeoItemsAggregate;
  /** An array relationship */
  evidenceVersions: Array<EvidenceVersions>;
  /** An aggregate relationship */
  evidenceVersionsAggregate: EvidenceVersionsAggregate;
  /** An object relationship */
  headVersion?: Maybe<EvidenceVersions>;
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  properties: Scalars['jsonb']['output'];
  /** An object relationship */
  reference: References;
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  userId: Scalars['uuid']['output'];
  version: Scalars['Int']['output'];
  wikipediaJson: Scalars['jsonb']['output'];
};


/** columns and relationships of "evidences" */
export type EvidencesCitationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceVersionsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesEvidenceVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


/** columns and relationships of "evidences" */
export type EvidencesMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidences" */
export type EvidencesPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "evidences" */
export type EvidencesWikipediaJsonArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "evidences" */
export type EvidencesAggregate = {
  __typename?: 'EvidencesAggregate';
  aggregate?: Maybe<EvidencesAggregateFields>;
  nodes: Array<Evidences>;
};

export type EvidencesAggregateBoolExp = {
  count?: InputMaybe<EvidencesAggregateBoolExpCount>;
};

/** aggregate fields of "evidences" */
export type EvidencesAggregateFields = {
  __typename?: 'EvidencesAggregateFields';
  avg?: Maybe<EvidencesAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<EvidencesMaxFields>;
  min?: Maybe<EvidencesMinFields>;
  stddev?: Maybe<EvidencesStddevFields>;
  stddevPop?: Maybe<EvidencesStddevPopFields>;
  stddevSamp?: Maybe<EvidencesStddevSampFields>;
  sum?: Maybe<EvidencesSumFields>;
  varPop?: Maybe<EvidencesVarPopFields>;
  varSamp?: Maybe<EvidencesVarSampFields>;
  variance?: Maybe<EvidencesVarianceFields>;
};


/** aggregate fields of "evidences" */
export type EvidencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<EvidencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "evidences" */
export type EvidencesAggregateOrderBy = {
  avg?: InputMaybe<EvidencesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<EvidencesMaxOrderBy>;
  min?: InputMaybe<EvidencesMinOrderBy>;
  stddev?: InputMaybe<EvidencesStddevOrderBy>;
  stddevPop?: InputMaybe<EvidencesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<EvidencesStddevSampOrderBy>;
  sum?: InputMaybe<EvidencesSumOrderBy>;
  varPop?: InputMaybe<EvidencesVarPopOrderBy>;
  varSamp?: InputMaybe<EvidencesVarSampOrderBy>;
  variance?: InputMaybe<EvidencesVarianceOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type EvidencesAppendInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "evidences" */
export type EvidencesArrRelInsertInput = {
  data: Array<EvidencesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<EvidencesOnConflict>;
};

/** aggregate avg on columns */
export type EvidencesAvgFields = {
  __typename?: 'EvidencesAvgFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "evidences" */
export type EvidencesAvgOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "evidences". All fields are combined with a logical 'AND'. */
export type EvidencesBoolExp = {
  _and?: InputMaybe<Array<EvidencesBoolExp>>;
  _not?: InputMaybe<EvidencesBoolExp>;
  _or?: InputMaybe<Array<EvidencesBoolExp>>;
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobId?: InputMaybe<UuidComparisonExp>;
  batchEvidencesJobRun?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
  batchEvidencesJobRunId?: InputMaybe<UuidComparisonExp>;
  citation?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsBoolExp>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateBoolExp>;
  evidenceEvidenceSets?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
  evidenceEvidenceSetsAggregate?: InputMaybe<EvidenceEvidenceSetsAggregateBoolExp>;
  evidenceImporter?: InputMaybe<EvidenceImportersBoolExp>;
  evidenceImporterId?: InputMaybe<UuidComparisonExp>;
  evidenceRecordGeoItems?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
  evidenceRecordGeoItemsAggregate?: InputMaybe<EvidenceRecordGeoItemsAggregateBoolExp>;
  evidenceVersions?: InputMaybe<EvidenceVersionsBoolExp>;
  evidenceVersionsAggregate?: InputMaybe<EvidenceVersionsAggregateBoolExp>;
  headVersion?: InputMaybe<EvidenceVersionsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  reference?: InputMaybe<ReferencesBoolExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
  wikipediaJson?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "evidences" */
export const EvidencesConstraint = {
  /** unique or primary key constraint on columns "id" */
  EvidencesPkey: 'evidences_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  EvidencesTenantIdIdKey: 'evidences_tenant_id_id_key'
} as const;

export type EvidencesConstraint = typeof EvidencesConstraint[keyof typeof EvidencesConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type EvidencesDeleteAtPathInput = {
  citation?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
  wikipediaJson?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type EvidencesDeleteElemInput = {
  citation?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type EvidencesDeleteKeyInput = {
  citation?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  wikipediaJson?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "evidences" */
export type EvidencesIncInput = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "evidences" */
export type EvidencesInsertInput = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsObjRelInsertInput>;
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchEvidencesJobRun?: InputMaybe<BatchEvidencesJobRunsObjRelInsertInput>;
  batchEvidencesJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceChangeRequests?: InputMaybe<EvidenceChangeRequestsArrRelInsertInput>;
  evidenceEvidenceSets?: InputMaybe<EvidenceEvidenceSetsArrRelInsertInput>;
  evidenceImporter?: InputMaybe<EvidenceImportersObjRelInsertInput>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceRecordGeoItems?: InputMaybe<EvidenceRecordGeoItemsArrRelInsertInput>;
  evidenceVersions?: InputMaybe<EvidenceVersionsArrRelInsertInput>;
  headVersion?: InputMaybe<EvidenceVersionsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  reference?: InputMaybe<ReferencesObjRelInsertInput>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type EvidencesMaxFields = {
  __typename?: 'EvidencesMaxFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  batchEvidencesJobRunId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "evidences" */
export type EvidencesMaxOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  batchEvidencesJobRunId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type EvidencesMinFields = {
  __typename?: 'EvidencesMinFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  batchEvidencesJobRunId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "evidences" */
export type EvidencesMinOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  batchEvidencesJobRunId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "evidences" */
export type EvidencesMutationResponse = {
  __typename?: 'EvidencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Evidences>;
};

/** input type for inserting object relation for remote table "evidences" */
export type EvidencesObjRelInsertInput = {
  data: EvidencesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<EvidencesOnConflict>;
};

/** on_conflict condition type for table "evidences" */
export type EvidencesOnConflict = {
  constraint: EvidencesConstraint;
  updateColumns?: Array<EvidencesUpdateColumn>;
  where?: InputMaybe<EvidencesBoolExp>;
};

/** Ordering options when selecting data from "evidences". */
export type EvidencesOrderBy = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsOrderBy>;
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  batchEvidencesJobRun?: InputMaybe<BatchEvidencesJobRunsOrderBy>;
  batchEvidencesJobRunId?: InputMaybe<OrderBy>;
  citation?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceChangeRequestsAggregate?: InputMaybe<EvidenceChangeRequestsAggregateOrderBy>;
  evidenceEvidenceSetsAggregate?: InputMaybe<EvidenceEvidenceSetsAggregateOrderBy>;
  evidenceImporter?: InputMaybe<EvidenceImportersOrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceRecordGeoItemsAggregate?: InputMaybe<EvidenceRecordGeoItemsAggregateOrderBy>;
  evidenceVersionsAggregate?: InputMaybe<EvidenceVersionsAggregateOrderBy>;
  headVersion?: InputMaybe<EvidenceVersionsOrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  reference?: InputMaybe<ReferencesOrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
  wikipediaJson?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: evidences */
export type EvidencesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type EvidencesPrependInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "evidences" */
export const EvidencesSelectColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  BatchEvidencesJobRunId: 'batchEvidencesJobRunId',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Version: 'version',
  /** column name */
  WikipediaJson: 'wikipediaJson'
} as const;

export type EvidencesSelectColumn = typeof EvidencesSelectColumn[keyof typeof EvidencesSelectColumn];
/** input type for updating data in table "evidences" */
export type EvidencesSetInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchEvidencesJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate stddev on columns */
export type EvidencesStddevFields = {
  __typename?: 'EvidencesStddevFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "evidences" */
export type EvidencesStddevOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type EvidencesStddevPopFields = {
  __typename?: 'EvidencesStddevPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "evidences" */
export type EvidencesStddevPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type EvidencesStddevSampFields = {
  __typename?: 'EvidencesStddevSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "evidences" */
export type EvidencesStddevSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "evidences" */
export type EvidencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: EvidencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type EvidencesStreamCursorValueInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  batchEvidencesJobRunId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
  wikipediaJson?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate sum on columns */
export type EvidencesSumFields = {
  __typename?: 'EvidencesSumFields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "evidences" */
export type EvidencesSumOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** update columns of table "evidences" */
export const EvidencesUpdateColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  BatchEvidencesJobRunId: 'batchEvidencesJobRunId',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Version: 'version',
  /** column name */
  WikipediaJson: 'wikipediaJson'
} as const;

export type EvidencesUpdateColumn = typeof EvidencesUpdateColumn[keyof typeof EvidencesUpdateColumn];
export type EvidencesUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<EvidencesAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<EvidencesDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<EvidencesDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<EvidencesDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<EvidencesIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<EvidencesPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<EvidencesSetInput>;
  /** filter the rows which have to be updated */
  where: EvidencesBoolExp;
};

/** aggregate varPop on columns */
export type EvidencesVarPopFields = {
  __typename?: 'EvidencesVarPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "evidences" */
export type EvidencesVarPopOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type EvidencesVarSampFields = {
  __typename?: 'EvidencesVarSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "evidences" */
export type EvidencesVarSampOrderBy = {
  version?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type EvidencesVarianceFields = {
  __typename?: 'EvidencesVarianceFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "evidences" */
export type EvidencesVarianceOrderBy = {
  version?: InputMaybe<OrderBy>;
};

export type FirebaseUser = {
  __typename?: 'FirebaseUser';
  disabled: Scalars['Boolean']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  emailVerified: Scalars['Boolean']['output'];
  photoURL?: Maybe<Scalars['String']['output']>;
  uid: Scalars['String']['output'];
};

export type ForceOnEditInvokeInput = {
  numRows: Scalars['Int']['input'];
  rowIndex: Scalars['Int']['input'];
  sheetName: Scalars['String']['input'];
  spreadsheetId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ForceOnEditInvokeOutput = {
  __typename?: 'ForceOnEditInvokeOutput';
  result: Scalars['Boolean']['output'];
};

export type ForceOnEditInvokeResponse = ClientError | ForceOnEditInvokeOutput;

export type GSheetsConfigInput = {
  sheetName?: InputMaybe<Scalars['String']['input']>;
};

export type GeoItemActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemAreaInput = {
  featureCollection?: InputMaybe<Scalars['JSONObject']['input']>;
  geometry?: InputMaybe<Scalars['JSONObject']['input']>;
  h3Indexes?: InputMaybe<Array<Scalars['String']['input']>>;
  kind: GeoItemAreaKind;
};

export const GeoItemAreaKind = {
  FeatureCollection: 'feature_collection',
  Geometry: 'geometry',
  H3: 'h3'
} as const;

export type GeoItemAreaKind = typeof GeoItemAreaKind[keyof typeof GeoItemAreaKind];
export type GeoItemCoords = {
  lat: Scalars['Float']['input'];
  lng: Scalars['Float']['input'];
};

export type GeoItemCreateInput = {
  coords?: InputMaybe<GeoItemCoords>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countrySubdivisionCode?: InputMaybe<Scalars['String']['input']>;
  geometry?: InputMaybe<Scalars['JSONObject']['input']>;
  h3Indexes?: InputMaybe<Array<Scalars['String']['input']>>;
  i18nLabel?: InputMaybe<I18nLabelInput>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  recordGeoItems?: InputMaybe<Array<NestedGeoItemRecordGeoItemCreateInput>>;
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemGetInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemGetOutput = {
  __typename?: 'GeoItemGetOutput';
  centroid?: Maybe<Scalars['JSONObject']['output']>;
  coords?: Maybe<Scalars['JSONObject']['output']>;
  countryCode?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  h3Indexes: Array<Scalars['String']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  id: Scalars['UUID']['output'];
  metadata: Scalars['JSONObject']['output'];
  recordGeoItems: Array<GeoItemGetRecordGeoItemOutput>;
  updatedAt: Scalars['DateTime']['output'];
};

export type GeoItemGetRecordGeoItemOutput = {
  __typename?: 'GeoItemGetRecordGeoItemOutput';
  date?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  record: GeoItemGetRecordOutput;
};

export type GeoItemGetRecordOutput = {
  __typename?: 'GeoItemGetRecordOutput';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type GeoItemLabelInput = {
  lang: Scalars['String']['input'];
  preferred?: InputMaybe<Scalars['Boolean']['input']>;
  value: Scalars['String']['input'];
};

export type GeoItemOutput = {
  __typename?: 'GeoItemOutput';
  id: Scalars['UUID']['output'];
};

export type GeoItemReadOutput = {
  __typename?: 'GeoItemReadOutput';
  coords?: Maybe<Scalars['JSONObject']['output']>;
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  id: Scalars['UUID']['output'];
};

export type GeoItemSearchAreaInput = {
  geometry: Scalars['JSONObject']['input'];
  mode: GeoItemSearchAreaMode;
};

export const GeoItemSearchAreaMode = {
  Contains: 'contains',
  Covers: 'covers',
  Intersects: 'intersects',
  Within: 'within'
} as const;

export type GeoItemSearchAreaMode = typeof GeoItemSearchAreaMode[keyof typeof GeoItemSearchAreaMode];
export type GeoItemSearchInput = {
  area?: InputMaybe<GeoItemSearchAreaInput>;
  label?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  statuses?: InputMaybe<Array<GeoItemSearchStatus>>;
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemSearchItemOutput = {
  __typename?: 'GeoItemSearchItemOutput';
  coords?: Maybe<Scalars['JSONObject']['output']>;
  fromJdn?: Maybe<Scalars['Int']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  id: Scalars['UUID']['output'];
  recordGeoItems: Array<GeoItemSearchRecordGeoItemOutput>;
  toJdn?: Maybe<Scalars['Int']['output']>;
};

export type GeoItemSearchOutput = {
  __typename?: 'GeoItemSearchOutput';
  items: Array<GeoItemSearchItemOutput>;
  total: Scalars['Int']['output'];
};

export type GeoItemSearchRecordGeoItemOutput = {
  __typename?: 'GeoItemSearchRecordGeoItemOutput';
  i18nLabel: Scalars['JSONObject']['output'];
  record: GeoItemSearchRecordOutput;
};

export type GeoItemSearchRecordOutput = {
  __typename?: 'GeoItemSearchRecordOutput';
  id: Scalars['UUID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export const GeoItemSearchStatus = {
  Deactivated: 'deactivated',
  Draft: 'draft',
  Init: 'init',
  Published: 'published'
} as const;

export type GeoItemSearchStatus = typeof GeoItemSearchStatus[keyof typeof GeoItemSearchStatus];
export type GeoItemUpdateInput = {
  coords?: InputMaybe<GeoItemCoords>;
  countryCode?: InputMaybe<Scalars['String']['input']>;
  countrySubdivisionCode?: InputMaybe<Scalars['String']['input']>;
  entityOrRelationId?: InputMaybe<Scalars['UUID']['input']>;
  geometry?: InputMaybe<Scalars['JSONObject']['input']>;
  h3Indexes?: InputMaybe<Array<Scalars['String']['input']>>;
  i18nLabel?: InputMaybe<I18nLabelInput>;
  id: Scalars['UUID']['input'];
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  recordEndDate?: InputMaybe<Scalars['String']['input']>;
  recordI18nLabel?: InputMaybe<I18nLabelInput>;
  recordStartDate?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type GeoItemWithoutRecordCreateInput = {
  areaInput: GeoItemAreaInput;
  fromJdn?: InputMaybe<Scalars['Int']['input']>;
  labels?: InputMaybe<Array<GeoItemLabelInput>>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  parentKey?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
  toJdn?: InputMaybe<Scalars['Int']['input']>;
};

export type GetBatchChangeRequestJobDryRunResultUrlInput = {
  bcrJobRunId: Scalars['ID']['input'];
  fileType?: InputMaybe<DryRunResultFileType>;
  tenantId: Scalars['UUID']['input'];
};

export type GetBatchEvidenceJobDryRunResultUrlInput = {
  beJobRunId: Scalars['ID']['input'];
  fileType?: InputMaybe<DryRunResultFileType>;
  tenantId: Scalars['UUID']['input'];
};

export type GetCategoryPropertySchemasInput = {
  categoryId?: InputMaybe<Scalars['UUID']['input']>;
  categoryName?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type GetCategoryPropertySchemasOutput = {
  __typename?: 'GetCategoryPropertySchemasOutput';
  categoryId: Scalars['UUID']['output'];
  categoryName: Scalars['String']['output'];
  schemas: Array<CategoryPropertySchemaItem>;
};

export type GetCategoryPropertySchemasResponse = GetCategoryPropertySchemasOutput | ValidationError;

export type GetDataSourceJsonDataInput = {
  dataSourceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GetDataSourceJsonDataOutput = {
  __typename?: 'GetDataSourceJsonDataOutput';
  jsonData: Scalars['JSONObject']['output'];
  s3Path: Scalars['String']['output'];
};

export type GetDataSourceJsonDataResponse = GetDataSourceJsonDataOutput | ValidationError;

export type GetDataSourceJsonPresignedUrlInput = {
  dataSourceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GetDataSourceJsonPresignedUrlOutput = {
  __typename?: 'GetDataSourceJsonPresignedUrlOutput';
  url: Scalars['String']['output'];
};

export type GetDataSourceJsonPresignedUrlResponse = GetDataSourceJsonPresignedUrlOutput | ValidationError;

export type GetDataSourceStatsInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GetDataSourceStatsOutput = {
  __typename?: 'GetDataSourceStatsOutput';
  dataRowsCount: Scalars['Int']['output'];
  readyRowsCount: Scalars['Int']['output'];
};

export type GetDataSourceStatsResponse = ClientError | GetDataSourceStatsOutput;

export type GetJobLogPresignedUrlInput = {
  jobName: Scalars['String']['input'];
  jobRunId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type GetJobLogPresignedUrlOutput = {
  __typename?: 'GetJobLogPresignedUrlOutput';
  url: Scalars['String']['output'];
};

export type GetJobLogPresignedUrlResponse = GetJobLogPresignedUrlOutput | ValidationError;

export type GetSidebarBuildPolicyOutput = {
  __typename?: 'GetSidebarBuildPolicyOutput';
  minSupportedBuildAt: Scalars['DateTime']['output'];
  recommendedBuildAt: Scalars['DateTime']['output'];
};

export type I18nLabelCanonicalInput = {
  locale: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type I18nLabelInput = {
  canonical?: InputMaybe<Array<I18nLabelCanonicalInput>>;
  en?: InputMaybe<Scalars['String']['input']>;
  ja?: InputMaybe<Scalars['String']['input']>;
};

export type ImportDirectAttributedInput = {
  dataSources: Array<AttributedDataSourceInput>;
  name: Scalars['String']['input'];
  origin?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ImportDirectAttributedOutput = {
  __typename?: 'ImportDirectAttributedOutput';
  importId: Scalars['UUID']['output'];
};

export type ImportDirectAttributedResponse = ClientError | ImportDirectAttributedOutput | ValidationError;

export type ImportDirectCategoryMatchInput = {
  categoryId: Scalars['UUID']['input'];
  propertyLabel: Scalars['String']['input'];
};

export type ImportDirectEvidenceSelectorInput = {
  categoryMatches?: Array<ImportDirectCategoryMatchInput>;
  requiredPropertyLabels?: Array<Scalars['String']['input']>;
};

/**
 * Identifies the Entities of an entity slot of propertyMappings, (categoryId, variantKey), by the value of a data
 * source column, which is kept in the record metadata ops.identify.source_key and not in the Entity properties.
 * The value alone identifies the Entity in place of its title and wikidataID, and a slot identified this way takes
 * the sent property values over the stored ones. Requires SEMANTIC entity aggregation.
 */
export type ImportDirectIdentityMappingInput = {
  categoryId: Scalars['UUID']['input'];
  dataSourcePropertyLabel: Scalars['String']['input'];
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

export const ImportDirectOperation = {
  /**
   * Commits the prepared project using caller-selected options when supplied.
   * Omitted options use the tenant's current policy and defaults.
   */
  CommitPrepared: 'COMMIT_PREPARED',
  Execute: 'EXECUTE',
  Preview: 'PREVIEW',
  /**
   * Imports all current rows again into the project created by an earlier EXECUTE (projectId), reusing its
   * data source, import jobs and composers. Takes the input of EXECUTE with exactly one data source; name and
   * description are ignored. The project must aggregate entities semantically, and entityAggregationPolicy and
   * referenceIds must be the ones of the original EXECUTE. New columns and import slots are added to the project,
   * a changed mapping of an existing slot updates its composer, and new title conditions of a relation target are
   * added to its composer. Refused are a changed source or target resolver of an existing relation slot, an added,
   * removed or changed identity mapping of an existing entity slot, a slot
   * whose composer is deactivated, a changed property schema, required or unique of an existing column, and a slot that more
   * than one active composer of the project composes or whose composer composes several categories. Columns and
   * slots the request no longer has are kept, except that a required column and an entity slot whose composer has
   * no evidence filter must be included.
   * Target conditions are added only when neither they nor the conditions of the composer nest AND or OR.
   * A jsonData column must be declared by a property schema association of the request or the data source.
   * The evidence importer of the project must be active.
   */
  Reimport: 'REIMPORT',
  /**
   * Re-runs the prepared project as a preview using caller-selected options when supplied.
   * Omitted options use the tenant's current policy and defaults.
   */
  RepreviewPrepared: 'REPREVIEW_PREPARED'
} as const;

export type ImportDirectOperation = typeof ImportDirectOperation[keyof typeof ImportDirectOperation];
export type ImportDirectPropertyMappingInput = {
  categoryId: Scalars['UUID']['input'];
  categoryPropertyName: Scalars['String']['input'];
  dataSourcePropertyLabel: Scalars['String']['input'];
  evidenceSelector?: InputMaybe<ImportDirectEvidenceSelectorInput>;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  _eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _gte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['Int']['input']>>;
  _lte?: InputMaybe<Array<Scalars['Int']['input']>>;
  _neq?: InputMaybe<Array<Scalars['Int']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['Int']['input']>>>;
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type IntComparisonExp = {
  _eq?: InputMaybe<Scalars['Int']['input']>;
  _gt?: InputMaybe<Scalars['Int']['input']>;
  _gte?: InputMaybe<Scalars['Int']['input']>;
  _in?: InputMaybe<Array<Scalars['Int']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['Int']['input']>;
  _lte?: InputMaybe<Scalars['Int']['input']>;
  _neq?: InputMaybe<Scalars['Int']['input']>;
  _nin?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type InvokeWorkerInput = {
  arguments: Scalars['JSONObject']['input'];
  commandName: Scalars['String']['input'];
  dryRun: Scalars['Boolean']['input'];
  inputColumnMap?: InputMaybe<Array<ColumnMapItemInput>>;
  inputRowRange: Scalars['String']['input'];
  outputColumnMap?: InputMaybe<Array<ColumnMapItemInput>>;
  sheetId: Scalars['Int']['input'];
  spreadsheetId: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type InvokeWorkerOutput = {
  __typename?: 'InvokeWorkerOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type InvokeWorkerResponse = InvokeWorkerOutput | ValidationError;

export type JobExecution = {
  __typename?: 'JobExecution';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export const JobRunStatus = {
  Canceled: 'canceled',
  Failed: 'failed',
  InProgress: 'in_progress',
  Init: 'init',
  Succeeded: 'succeeded'
} as const;

export type JobRunStatus = typeof JobRunStatus[keyof typeof JobRunStatus];
/** columns and relationships of "job_run_statuses" */
export type JobRunStatuses = {
  __typename?: 'JobRunStatuses';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "job_run_statuses" */
export type JobRunStatusesAggregate = {
  __typename?: 'JobRunStatusesAggregate';
  aggregate?: Maybe<JobRunStatusesAggregateFields>;
  nodes: Array<JobRunStatuses>;
};

/** aggregate fields of "job_run_statuses" */
export type JobRunStatusesAggregateFields = {
  __typename?: 'JobRunStatusesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<JobRunStatusesMaxFields>;
  min?: Maybe<JobRunStatusesMinFields>;
};


/** aggregate fields of "job_run_statuses" */
export type JobRunStatusesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<JobRunStatusesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "job_run_statuses". All fields are combined with a logical 'AND'. */
export type JobRunStatusesBoolExp = {
  _and?: InputMaybe<Array<JobRunStatusesBoolExp>>;
  _not?: InputMaybe<JobRunStatusesBoolExp>;
  _or?: InputMaybe<Array<JobRunStatusesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "job_run_statuses" */
export const JobRunStatusesConstraint = {
  /** unique or primary key constraint on columns "id" */
  JobRunStatusesPkey: 'job_run_statuses_pkey'
} as const;

export type JobRunStatusesConstraint = typeof JobRunStatusesConstraint[keyof typeof JobRunStatusesConstraint];
/** input type for inserting data into table "job_run_statuses" */
export type JobRunStatusesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type JobRunStatusesMaxFields = {
  __typename?: 'JobRunStatusesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type JobRunStatusesMinFields = {
  __typename?: 'JobRunStatusesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "job_run_statuses" */
export type JobRunStatusesMutationResponse = {
  __typename?: 'JobRunStatusesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<JobRunStatuses>;
};

/** input type for inserting object relation for remote table "job_run_statuses" */
export type JobRunStatusesObjRelInsertInput = {
  data: JobRunStatusesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<JobRunStatusesOnConflict>;
};

/** on_conflict condition type for table "job_run_statuses" */
export type JobRunStatusesOnConflict = {
  constraint: JobRunStatusesConstraint;
  updateColumns?: Array<JobRunStatusesUpdateColumn>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};

/** Ordering options when selecting data from "job_run_statuses". */
export type JobRunStatusesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: job_run_statuses */
export type JobRunStatusesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "job_run_statuses" */
export const JobRunStatusesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type JobRunStatusesSelectColumn = typeof JobRunStatusesSelectColumn[keyof typeof JobRunStatusesSelectColumn];
/** input type for updating data in table "job_run_statuses" */
export type JobRunStatusesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "job_run_statuses" */
export type JobRunStatusesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: JobRunStatusesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type JobRunStatusesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "job_run_statuses" */
export const JobRunStatusesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type JobRunStatusesUpdateColumn = typeof JobRunStatusesUpdateColumn[keyof typeof JobRunStatusesUpdateColumn];
export type JobRunStatusesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<JobRunStatusesSetInput>;
  /** filter the rows which have to be updated */
  where: JobRunStatusesBoolExp;
};

export type JobRunUpdateInput = {
  completionNotifyImportId?: InputMaybe<Scalars['UUID']['input']>;
  completionNotifyOrigin?: InputMaybe<Scalars['String']['input']>;
  completionNotifyProductName?: InputMaybe<Scalars['String']['input']>;
  completionNotifyStatus?: InputMaybe<Scalars['String']['input']>;
  jobName: Scalars['String']['input'];
  jobRunId: Scalars['UUID']['input'];
  s3LogPath?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<JobRunStatus>;
  tenantId: Scalars['UUID']['input'];
};

export type JobRunUpdateOutput = {
  __typename?: 'JobRunUpdateOutput';
  jobName: Scalars['String']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type JobRunUpdateResponse = JobRunUpdateOutput | ValidationError;

export type JsonDataInput = {
  rows: Array<Scalars['JSONObject']['input']>;
  schemas: Array<Array<Scalars['String']['input']>>;
};

export type JsonQueryInput = {
  array_contains?: InputMaybe<Scalars['Enumerable']['input']>;
  equals?: InputMaybe<Scalars['Enumerable']['input']>;
  not?: InputMaybe<Scalars['Enumerable']['input']>;
  path: Array<Scalars['String']['input']>;
  string_ends_with?: InputMaybe<Scalars['String']['input']>;
  string_starts_with?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _eq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _gte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _lte?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _neq?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['jsonb']['input']>>>;
};

export type JsonbCastExp = {
  String?: InputMaybe<StringComparisonExp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type JsonbComparisonExp = {
  _cast?: InputMaybe<JsonbCastExp>;
  /** is the column contained in the given json value */
  _containedIn?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']['input']>;
  _eq?: InputMaybe<Scalars['jsonb']['input']>;
  _gt?: InputMaybe<Scalars['jsonb']['input']>;
  _gte?: InputMaybe<Scalars['jsonb']['input']>;
  /** does the string exist as a top-level key in the column */
  _hasKey?: InputMaybe<Scalars['String']['input']>;
  /** do all of these strings exist as top-level keys in the column */
  _hasKeysAll?: InputMaybe<Array<Scalars['String']['input']>>;
  /** do any of these strings exist as top-level keys in the column */
  _hasKeysAny?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['jsonb']['input']>;
  _lte?: InputMaybe<Scalars['jsonb']['input']>;
  _neq?: InputMaybe<Scalars['jsonb']['input']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']['input']>>;
};

export const LabelLocale = {
  En: 'en',
  Ja: 'ja'
} as const;

export type LabelLocale = typeof LabelLocale[keyof typeof LabelLocale];
export type ListCategoriesInput = {
  orderBy?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
  withDeactivated?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListCategoriesOutput = {
  __typename?: 'ListCategoriesOutput';
  categories: Array<CategoryListItem>;
};

export type ListCategoriesResponse = ListCategoriesOutput | ValidationError;

export type ListCategorySchemaMigrationsInput = {
  categoryId: Scalars['UUID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ListCategorySchemaMigrationsOutput = {
  __typename?: 'ListCategorySchemaMigrationsOutput';
  hasNextPage: Scalars['Boolean']['output'];
  migrations: Array<CategorySchemaMigrationItem>;
};

export type ListDataSourceColumnNamesInput = {
  dataSourceId: Scalars['UUID']['input'];
  sheetName?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type ListDataSourceColumnNamesOutput = {
  __typename?: 'ListDataSourceColumnNamesOutput';
  columnNames: Array<Scalars['String']['output']>;
};

export type ListDataSourceColumnNamesResponse = ClientError | ListDataSourceColumnNamesOutput;

export type ListDataSourceSheetsInput = {
  dataSourceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ListDataSourceSheetsOutput = {
  __typename?: 'ListDataSourceSheetsOutput';
  sheets: Array<SheetInfo>;
};

export type ListDataSourceSheetsResponse = ClientError | ListDataSourceSheetsOutput;

export type ListEffectiveCategoryPropertySchemasInput = {
  categoryId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ListEffectiveCategoryPropertySchemasOutput = {
  __typename?: 'ListEffectiveCategoryPropertySchemasOutput';
  categoryId: Scalars['UUID']['output'];
  categoryName: Scalars['String']['output'];
  schemas: Array<EffectiveCategoryPropertySchemaItem>;
};

export type ListEffectiveCategoryPropertySchemasResponse = ListEffectiveCategoryPropertySchemasOutput | ValidationError;

export type ListWorkerCommandsOutput = {
  __typename?: 'ListWorkerCommandsOutput';
  commands: Array<WorkerCommandDefinition>;
};

/** Boolean expression to compare columns of type "ltree". All fields are combined with logical 'AND'. */
export type LtreeComparisonExp = {
  /** is the left argument an ancestor of right (or equal)? */
  _ancestor?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain an ancestor of `ltree`? */
  _ancestorAny?: InputMaybe<Array<Scalars['ltree']['input']>>;
  /** is the left argument a descendant of right (or equal)? */
  _descendant?: InputMaybe<Scalars['ltree']['input']>;
  /** does array contain a descendant of `ltree`? */
  _descendantAny?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _eq?: InputMaybe<Scalars['ltree']['input']>;
  _gt?: InputMaybe<Scalars['ltree']['input']>;
  _gte?: InputMaybe<Scalars['ltree']['input']>;
  _in?: InputMaybe<Array<Scalars['ltree']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['ltree']['input']>;
  _lte?: InputMaybe<Scalars['ltree']['input']>;
  /** does `ltree` match `lquery`? */
  _matches?: InputMaybe<Scalars['lquery']['input']>;
  /** does `ltree` match any `lquery` in array? */
  _matchesAny?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does `ltree` match `ltxtquery`? */
  _matchesFulltext?: InputMaybe<Scalars['ltxtquery']['input']>;
  _neq?: InputMaybe<Scalars['ltree']['input']>;
  _nin?: InputMaybe<Array<Scalars['ltree']['input']>>;
};

export type NestedGeoItemRecordGeoItemCreateInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  entityOrRelationId: Scalars['UUID']['input'];
  evidences?: InputMaybe<Array<EvidenceUpsertInput>>;
  i18nLabel?: InputMaybe<I18nLabelInput>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  startDate: Scalars['String']['input'];
};

/** column ordering options */
export const OrderBy = {
  /** in ascending order, nulls last */
  Asc: 'ASC',
  /** in ascending order, nulls first */
  AscNullsFirst: 'ASC_NULLS_FIRST',
  /** in ascending order, nulls last */
  AscNullsLast: 'ASC_NULLS_LAST',
  /** in descending order, nulls first */
  Desc: 'DESC',
  /** in descending order, nulls first */
  DescNullsFirst: 'DESC_NULLS_FIRST',
  /** in descending order, nulls last */
  DescNullsLast: 'DESC_NULLS_LAST'
} as const;

export type OrderBy = typeof OrderBy[keyof typeof OrderBy];
export type OrganizationCreateInput = {
  kind: Scalars['String']['input'];
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type OrganizationCreateOutput = {
  __typename?: 'OrganizationCreateOutput';
  id: Scalars['UUID']['output'];
};

export type OrganizationCreateResponse = OrganizationCreateOutput | ValidationError;

/** columns and relationships of "organization_kinds" */
export type OrganizationKinds = {
  __typename?: 'OrganizationKinds';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "organization_kinds" */
export type OrganizationKindsAggregate = {
  __typename?: 'OrganizationKindsAggregate';
  aggregate?: Maybe<OrganizationKindsAggregateFields>;
  nodes: Array<OrganizationKinds>;
};

/** aggregate fields of "organization_kinds" */
export type OrganizationKindsAggregateFields = {
  __typename?: 'OrganizationKindsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrganizationKindsMaxFields>;
  min?: Maybe<OrganizationKindsMinFields>;
};


/** aggregate fields of "organization_kinds" */
export type OrganizationKindsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationKindsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organization_kinds". All fields are combined with a logical 'AND'. */
export type OrganizationKindsBoolExp = {
  _and?: InputMaybe<Array<OrganizationKindsBoolExp>>;
  _not?: InputMaybe<OrganizationKindsBoolExp>;
  _or?: InputMaybe<Array<OrganizationKindsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organization_kinds" */
export const OrganizationKindsConstraint = {
  /** unique or primary key constraint on columns "id" */
  OrganizationKindsPkey: 'organization_kinds_pkey'
} as const;

export type OrganizationKindsConstraint = typeof OrganizationKindsConstraint[keyof typeof OrganizationKindsConstraint];
/** input type for inserting data into table "organization_kinds" */
export type OrganizationKindsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganizationKindsMaxFields = {
  __typename?: 'OrganizationKindsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type OrganizationKindsMinFields = {
  __typename?: 'OrganizationKindsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organization_kinds" */
export type OrganizationKindsMutationResponse = {
  __typename?: 'OrganizationKindsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<OrganizationKinds>;
};

/** on_conflict condition type for table "organization_kinds" */
export type OrganizationKindsOnConflict = {
  constraint: OrganizationKindsConstraint;
  updateColumns?: Array<OrganizationKindsUpdateColumn>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};

/** Ordering options when selecting data from "organization_kinds". */
export type OrganizationKindsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organization_kinds */
export type OrganizationKindsPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "organization_kinds" */
export const OrganizationKindsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type OrganizationKindsSelectColumn = typeof OrganizationKindsSelectColumn[keyof typeof OrganizationKindsSelectColumn];
/** input type for updating data in table "organization_kinds" */
export type OrganizationKindsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organization_kinds" */
export type OrganizationKindsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrganizationKindsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationKindsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organization_kinds" */
export const OrganizationKindsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type OrganizationKindsUpdateColumn = typeof OrganizationKindsUpdateColumn[keyof typeof OrganizationKindsUpdateColumn];
export type OrganizationKindsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationKindsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationKindsBoolExp;
};

/** columns and relationships of "organizations" */
export type Organizations = {
  __typename?: 'Organizations';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  kind: Scalars['String']['output'];
  name: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenantsAggregate: TenantsAggregate;
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "organizations" */
export type OrganizationsTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


/** columns and relationships of "organizations" */
export type OrganizationsTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};

/** aggregated selection of "organizations" */
export type OrganizationsAggregate = {
  __typename?: 'OrganizationsAggregate';
  aggregate?: Maybe<OrganizationsAggregateFields>;
  nodes: Array<Organizations>;
};

/** aggregate fields of "organizations" */
export type OrganizationsAggregateFields = {
  __typename?: 'OrganizationsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<OrganizationsMaxFields>;
  min?: Maybe<OrganizationsMinFields>;
};


/** aggregate fields of "organizations" */
export type OrganizationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<OrganizationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "organizations". All fields are combined with a logical 'AND'. */
export type OrganizationsBoolExp = {
  _and?: InputMaybe<Array<OrganizationsBoolExp>>;
  _not?: InputMaybe<OrganizationsBoolExp>;
  _or?: InputMaybe<Array<OrganizationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  kind?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  shortCode?: InputMaybe<StringComparisonExp>;
  tenants?: InputMaybe<TenantsBoolExp>;
  tenantsAggregate?: InputMaybe<TenantsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "organizations" */
export const OrganizationsConstraint = {
  /** unique or primary key constraint on columns "id" */
  OrganizationsPkey: 'organizations_pkey',
  /** unique or primary key constraint on columns "short_code" */
  OrganizationsShortCodeKey: 'organizations_short_code_key'
} as const;

export type OrganizationsConstraint = typeof OrganizationsConstraint[keyof typeof OrganizationsConstraint];
/** input type for inserting data into table "organizations" */
export type OrganizationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  tenants?: InputMaybe<TenantsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type OrganizationsMaxFields = {
  __typename?: 'OrganizationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type OrganizationsMinFields = {
  __typename?: 'OrganizationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  kind?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "organizations" */
export type OrganizationsMutationResponse = {
  __typename?: 'OrganizationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations>;
};

/** input type for inserting object relation for remote table "organizations" */
export type OrganizationsObjRelInsertInput = {
  data: OrganizationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<OrganizationsOnConflict>;
};

/** on_conflict condition type for table "organizations" */
export type OrganizationsOnConflict = {
  constraint: OrganizationsConstraint;
  updateColumns?: Array<OrganizationsUpdateColumn>;
  where?: InputMaybe<OrganizationsBoolExp>;
};

/** Ordering options when selecting data from "organizations". */
export type OrganizationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  kind?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  shortCode?: InputMaybe<OrderBy>;
  tenantsAggregate?: InputMaybe<TenantsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: organizations */
export type OrganizationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "organizations" */
export const OrganizationsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  Name: 'name',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type OrganizationsSelectColumn = typeof OrganizationsSelectColumn[keyof typeof OrganizationsSelectColumn];
/** input type for updating data in table "organizations" */
export type OrganizationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "organizations" */
export type OrganizationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: OrganizationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type OrganizationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  kind?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "organizations" */
export const OrganizationsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Kind: 'kind',
  /** column name */
  Name: 'name',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type OrganizationsUpdateColumn = typeof OrganizationsUpdateColumn[keyof typeof OrganizationsUpdateColumn];
export type OrganizationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<OrganizationsSetInput>;
  /** filter the rows which have to be updated */
  where: OrganizationsBoolExp;
};

export type PlannedDataSourceColumn = {
  __typename?: 'PlannedDataSourceColumn';
  editable: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
  role: Scalars['String']['output'];
  target: Scalars['String']['output'];
};

export type PlannedDataSourceRow = {
  __typename?: 'PlannedDataSourceRow';
  categoryId: Scalars['ID']['output'];
  expectedVariantKey: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
  sourceEvidenceId: Scalars['ID']['output'];
  variantKey: Scalars['String']['output'];
};

export type PlannedDataSourceShape = {
  __typename?: 'PlannedDataSourceShape';
  columns: Array<PlannedDataSourceColumn>;
  rows: Array<PlannedDataSourceRow>;
};

export type PrepareEventNormalizationImportInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  file: Scalars['Upload']['input'];
  name: Scalars['String']['input'];
  referenceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type PrepareEventNormalizationImportOutput = {
  __typename?: 'PrepareEventNormalizationImportOutput';
  dataSourceIds: Array<Scalars['UUID']['output']>;
  projectId: Scalars['UUID']['output'];
};

export type PrepareEventNormalizationImportResponse = ClientError | PrepareEventNormalizationImportOutput | ValidationError;

export type Product = {
  __typename?: 'Product';
  createdAt: Scalars['DateTime']['output'];
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  id: Scalars['UUID']['output'];
  importDirectWebhookUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originHosts: Scalars['String']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

export type ProductActivateInput = {
  id: Scalars['UUID']['input'];
};

export type ProductActivateOutput = {
  __typename?: 'ProductActivateOutput';
  id: Scalars['UUID']['output'];
};

export type ProductDeactivateInput = {
  id: Scalars['UUID']['input'];
};

export type ProductDeactivateOutput = {
  __typename?: 'ProductDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type ProductRoleAssignmentsInput = {
  productId: Scalars['UUID']['input'];
  roleId: Scalars['UUID']['input'];
};

/** columns and relationships of "product_roles" */
export type ProductRoles = {
  __typename?: 'ProductRoles';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid']['output'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "product_roles" */
export type ProductRolesAggregate = {
  __typename?: 'ProductRolesAggregate';
  aggregate?: Maybe<ProductRolesAggregateFields>;
  nodes: Array<ProductRoles>;
};

export type ProductRolesAggregateBoolExp = {
  count?: InputMaybe<ProductRolesAggregateBoolExpCount>;
};

/** aggregate fields of "product_roles" */
export type ProductRolesAggregateFields = {
  __typename?: 'ProductRolesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProductRolesMaxFields>;
  min?: Maybe<ProductRolesMinFields>;
};


/** aggregate fields of "product_roles" */
export type ProductRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProductRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "product_roles" */
export type ProductRolesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ProductRolesMaxOrderBy>;
  min?: InputMaybe<ProductRolesMinOrderBy>;
};

/** input type for inserting array relation for remote table "product_roles" */
export type ProductRolesArrRelInsertInput = {
  data: Array<ProductRolesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ProductRolesOnConflict>;
};

/** Boolean expression to filter rows from the table "product_roles". All fields are combined with a logical 'AND'. */
export type ProductRolesBoolExp = {
  _and?: InputMaybe<Array<ProductRolesBoolExp>>;
  _not?: InputMaybe<ProductRolesBoolExp>;
  _or?: InputMaybe<Array<ProductRolesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  product?: InputMaybe<ProductsBoolExp>;
  productId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<RolesBoolExp>;
  roleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "product_roles" */
export const ProductRolesConstraint = {
  /** unique or primary key constraint on columns "product_id", "role_id" */
  ProductRolesPkey: 'product_roles_pkey'
} as const;

export type ProductRolesConstraint = typeof ProductRolesConstraint[keyof typeof ProductRolesConstraint];
/** input type for inserting data into table "product_roles" */
export type ProductRolesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  product?: InputMaybe<ProductsObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<RolesObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ProductRolesMaxFields = {
  __typename?: 'ProductRolesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "product_roles" */
export type ProductRolesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ProductRolesMinFields = {
  __typename?: 'ProductRolesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "product_roles" */
export type ProductRolesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "product_roles" */
export type ProductRolesMutationResponse = {
  __typename?: 'ProductRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ProductRoles>;
};

/** on_conflict condition type for table "product_roles" */
export type ProductRolesOnConflict = {
  constraint: ProductRolesConstraint;
  updateColumns?: Array<ProductRolesUpdateColumn>;
  where?: InputMaybe<ProductRolesBoolExp>;
};

/** Ordering options when selecting data from "product_roles". */
export type ProductRolesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  product?: InputMaybe<ProductsOrderBy>;
  productId?: InputMaybe<OrderBy>;
  role?: InputMaybe<RolesOrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: product_roles */
export type ProductRolesPkColumnsInput = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
};

/** select columns of table "product_roles" */
export const ProductRolesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ProductId: 'productId',
  /** column name */
  RoleId: 'roleId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ProductRolesSelectColumn = typeof ProductRolesSelectColumn[keyof typeof ProductRolesSelectColumn];
/** input type for updating data in table "product_roles" */
export type ProductRolesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "product_roles" */
export type ProductRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProductRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductRolesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "product_roles" */
export const ProductRolesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ProductId: 'productId',
  /** column name */
  RoleId: 'roleId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ProductRolesUpdateColumn = typeof ProductRolesUpdateColumn[keyof typeof ProductRolesUpdateColumn];
export type ProductRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductRolesSetInput>;
  /** filter the rows which have to be updated */
  where: ProductRolesBoolExp;
};

export type ProductUpsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  importDirectWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  originHosts: Scalars['String']['input'];
};

export type ProductUpsertResponse = Product | ValidationError;

/** columns and relationships of "products" */
export type Products = {
  __typename?: 'Products';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  importDirectWebhookUrl?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  originHosts: Scalars['String']['output'];
  /** An array relationship */
  productRoles: Array<ProductRoles>;
  /** An aggregate relationship */
  productRolesAggregate: ProductRolesAggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProductRoles: Array<UserProductRoles>;
  /** An aggregate relationship */
  userProductRolesAggregate: UserProductRolesAggregate;
};


/** columns and relationships of "products" */
export type ProductsProductRolesArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


/** columns and relationships of "products" */
export type ProductsProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


/** columns and relationships of "products" */
export type ProductsUserProductRolesArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


/** columns and relationships of "products" */
export type ProductsUserProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};

/** aggregated selection of "products" */
export type ProductsAggregate = {
  __typename?: 'ProductsAggregate';
  aggregate?: Maybe<ProductsAggregateFields>;
  nodes: Array<Products>;
};

/** aggregate fields of "products" */
export type ProductsAggregateFields = {
  __typename?: 'ProductsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ProductsMaxFields>;
  min?: Maybe<ProductsMinFields>;
};


/** aggregate fields of "products" */
export type ProductsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ProductsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "products". All fields are combined with a logical 'AND'. */
export type ProductsBoolExp = {
  _and?: InputMaybe<Array<ProductsBoolExp>>;
  _not?: InputMaybe<ProductsBoolExp>;
  _or?: InputMaybe<Array<ProductsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  importDirectWebhookUrl?: InputMaybe<StringComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  originHosts?: InputMaybe<StringComparisonExp>;
  productRoles?: InputMaybe<ProductRolesBoolExp>;
  productRolesAggregate?: InputMaybe<ProductRolesAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userProductRoles?: InputMaybe<UserProductRolesBoolExp>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateBoolExp>;
};

/** unique or primary key constraints on table "products" */
export const ProductsConstraint = {
  /** unique or primary key constraint on columns "name" */
  ProductsNameKey: 'products_name_key',
  /** unique or primary key constraint on columns "id" */
  ProductsPkey: 'products_pkey'
} as const;

export type ProductsConstraint = typeof ProductsConstraint[keyof typeof ProductsConstraint];
/** input type for inserting data into table "products" */
export type ProductsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importDirectWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originHosts?: InputMaybe<Scalars['String']['input']>;
  productRoles?: InputMaybe<ProductRolesArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProductRoles?: InputMaybe<UserProductRolesArrRelInsertInput>;
};

/** aggregate max on columns */
export type ProductsMaxFields = {
  __typename?: 'ProductsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importDirectWebhookUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originHosts?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ProductsMinFields = {
  __typename?: 'ProductsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  importDirectWebhookUrl?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  originHosts?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "products" */
export type ProductsMutationResponse = {
  __typename?: 'ProductsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Products>;
};

/** input type for inserting object relation for remote table "products" */
export type ProductsObjRelInsertInput = {
  data: ProductsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ProductsOnConflict>;
};

/** on_conflict condition type for table "products" */
export type ProductsOnConflict = {
  constraint: ProductsConstraint;
  updateColumns?: Array<ProductsUpdateColumn>;
  where?: InputMaybe<ProductsBoolExp>;
};

/** Ordering options when selecting data from "products". */
export type ProductsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  importDirectWebhookUrl?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  originHosts?: InputMaybe<OrderBy>;
  productRolesAggregate?: InputMaybe<ProductRolesAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateOrderBy>;
};

/** primary key columns input for table: products */
export type ProductsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "products" */
export const ProductsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  ImportDirectWebhookUrl: 'importDirectWebhookUrl',
  /** column name */
  Name: 'name',
  /** column name */
  OriginHosts: 'originHosts',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ProductsSelectColumn = typeof ProductsSelectColumn[keyof typeof ProductsSelectColumn];
/** input type for updating data in table "products" */
export type ProductsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importDirectWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originHosts?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "products" */
export type ProductsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ProductsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ProductsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  importDirectWebhookUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  originHosts?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "products" */
export const ProductsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  ImportDirectWebhookUrl: 'importDirectWebhookUrl',
  /** column name */
  Name: 'name',
  /** column name */
  OriginHosts: 'originHosts',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ProductsUpdateColumn = typeof ProductsUpdateColumn[keyof typeof ProductsUpdateColumn];
export type ProductsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ProductsSetInput>;
  /** filter the rows which have to be updated */
  where: ProductsBoolExp;
};

export const PropertyAttributeTypeId = {
  Date: 'date',
  EndDate: 'endDate',
  Title: 'title'
} as const;

export type PropertyAttributeTypeId = typeof PropertyAttributeTypeId[keyof typeof PropertyAttributeTypeId];
export type PropertySchemaAssociationInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  position?: InputMaybe<Scalars['Int']['input']>;
  propertyAttributeTypeId?: InputMaybe<PropertyAttributeTypeId>;
  propertySchema: PropertySchemaUpsertInput;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
};

/** columns and relationships of "property_schema_associations" */
export type PropertySchemaAssociations = {
  __typename?: 'PropertySchemaAssociations';
  createdAt: Scalars['timestamptz']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  position: Scalars['Int']['output'];
  propertyAttributeTypeId?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  propertySchema: PropertySchemas;
  propertySchemaId: Scalars['uuid']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  required: Scalars['Boolean']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  unique: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_schema_associations" */
export type PropertySchemaAssociationsAggregate = {
  __typename?: 'PropertySchemaAssociationsAggregate';
  aggregate?: Maybe<PropertySchemaAssociationsAggregateFields>;
  nodes: Array<PropertySchemaAssociations>;
};

export type PropertySchemaAssociationsAggregateBoolExp = {
  bool_and?: InputMaybe<PropertySchemaAssociationsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<PropertySchemaAssociationsAggregateBoolExpBool_Or>;
  count?: InputMaybe<PropertySchemaAssociationsAggregateBoolExpCount>;
};

/** aggregate fields of "property_schema_associations" */
export type PropertySchemaAssociationsAggregateFields = {
  __typename?: 'PropertySchemaAssociationsAggregateFields';
  avg?: Maybe<PropertySchemaAssociationsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<PropertySchemaAssociationsMaxFields>;
  min?: Maybe<PropertySchemaAssociationsMinFields>;
  stddev?: Maybe<PropertySchemaAssociationsStddevFields>;
  stddevPop?: Maybe<PropertySchemaAssociationsStddevPopFields>;
  stddevSamp?: Maybe<PropertySchemaAssociationsStddevSampFields>;
  sum?: Maybe<PropertySchemaAssociationsSumFields>;
  varPop?: Maybe<PropertySchemaAssociationsVarPopFields>;
  varSamp?: Maybe<PropertySchemaAssociationsVarSampFields>;
  variance?: Maybe<PropertySchemaAssociationsVarianceFields>;
};


/** aggregate fields of "property_schema_associations" */
export type PropertySchemaAssociationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "property_schema_associations" */
export type PropertySchemaAssociationsAggregateOrderBy = {
  avg?: InputMaybe<PropertySchemaAssociationsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<PropertySchemaAssociationsMaxOrderBy>;
  min?: InputMaybe<PropertySchemaAssociationsMinOrderBy>;
  stddev?: InputMaybe<PropertySchemaAssociationsStddevOrderBy>;
  stddevPop?: InputMaybe<PropertySchemaAssociationsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<PropertySchemaAssociationsStddevSampOrderBy>;
  sum?: InputMaybe<PropertySchemaAssociationsSumOrderBy>;
  varPop?: InputMaybe<PropertySchemaAssociationsVarPopOrderBy>;
  varSamp?: InputMaybe<PropertySchemaAssociationsVarSampOrderBy>;
  variance?: InputMaybe<PropertySchemaAssociationsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "property_schema_associations" */
export type PropertySchemaAssociationsArrRelInsertInput = {
  data: Array<PropertySchemaAssociationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<PropertySchemaAssociationsOnConflict>;
};

/** aggregate avg on columns */
export type PropertySchemaAssociationsAvgFields = {
  __typename?: 'PropertySchemaAssociationsAvgFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsAvgOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "property_schema_associations". All fields are combined with a logical 'AND'. */
export type PropertySchemaAssociationsBoolExp = {
  _and?: InputMaybe<Array<PropertySchemaAssociationsBoolExp>>;
  _not?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  _or?: InputMaybe<Array<PropertySchemaAssociationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  position?: InputMaybe<IntComparisonExp>;
  propertyAttributeTypeId?: InputMaybe<StringComparisonExp>;
  propertySchema?: InputMaybe<PropertySchemasBoolExp>;
  propertySchemaId?: InputMaybe<UuidComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  required?: InputMaybe<BooleanComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  unique?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "property_schema_associations" */
export const PropertySchemaAssociationsConstraint = {
  /** unique or primary key constraint on columns "id" */
  PropertySchemaAssociationsPkey: 'property_schema_associations_pkey',
  /** unique or primary key constraint on columns "property_schema_id" */
  PropertySchemaAssociationsPropertySchemaIdKey: 'property_schema_associations_property_schema_id_key',
  /** unique or primary key constraint on columns "name", "property_schema_set_id" */
  PropertySchemaAssociationsPropertySchemaSetIdNameKey: 'property_schema_associations_property_schema_set_id_name_key',
  /** unique or primary key constraint on columns "position", "property_schema_set_id" */
  PropertySchemaAssociationsPropertySchemaSetIdPositioKey: 'property_schema_associations_property_schema_set_id_positio_key'
} as const;

export type PropertySchemaAssociationsConstraint = typeof PropertySchemaAssociationsConstraint[keyof typeof PropertySchemaAssociationsConstraint];
/** input type for incrementing numeric columns in table "property_schema_associations" */
export type PropertySchemaAssociationsIncInput = {
  position?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "property_schema_associations" */
export type PropertySchemaAssociationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  propertyAttributeTypeId?: InputMaybe<Scalars['String']['input']>;
  propertySchema?: InputMaybe<PropertySchemasObjRelInsertInput>;
  propertySchemaId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PropertySchemaAssociationsMaxFields = {
  __typename?: 'PropertySchemaAssociationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  propertyAttributeTypeId?: Maybe<Scalars['String']['output']>;
  propertySchemaId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  propertyAttributeTypeId?: InputMaybe<OrderBy>;
  propertySchemaId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type PropertySchemaAssociationsMinFields = {
  __typename?: 'PropertySchemaAssociationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  propertyAttributeTypeId?: Maybe<Scalars['String']['output']>;
  propertySchemaId?: Maybe<Scalars['uuid']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  propertyAttributeTypeId?: InputMaybe<OrderBy>;
  propertySchemaId?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "property_schema_associations" */
export type PropertySchemaAssociationsMutationResponse = {
  __typename?: 'PropertySchemaAssociationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertySchemaAssociations>;
};

/** input type for inserting object relation for remote table "property_schema_associations" */
export type PropertySchemaAssociationsObjRelInsertInput = {
  data: PropertySchemaAssociationsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PropertySchemaAssociationsOnConflict>;
};

/** on_conflict condition type for table "property_schema_associations" */
export type PropertySchemaAssociationsOnConflict = {
  constraint: PropertySchemaAssociationsConstraint;
  updateColumns?: Array<PropertySchemaAssociationsUpdateColumn>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};

/** Ordering options when selecting data from "property_schema_associations". */
export type PropertySchemaAssociationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  position?: InputMaybe<OrderBy>;
  propertyAttributeTypeId?: InputMaybe<OrderBy>;
  propertySchema?: InputMaybe<PropertySchemasOrderBy>;
  propertySchemaId?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  required?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  unique?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: property_schema_associations */
export type PropertySchemaAssociationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_schema_associations" */
export const PropertySchemaAssociationsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Position: 'position',
  /** column name */
  PropertyAttributeTypeId: 'propertyAttributeTypeId',
  /** column name */
  PropertySchemaId: 'propertySchemaId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  Required: 'required',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  Unique: 'unique',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertySchemaAssociationsSelectColumn = typeof PropertySchemaAssociationsSelectColumn[keyof typeof PropertySchemaAssociationsSelectColumn];
/** select "propertySchemaAssociationsAggregateBoolExpBool_andArgumentsColumns" columns of table "property_schema_associations" */
export const PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns = {
  /** column name */
  Required: 'required',
  /** column name */
  Unique: 'unique'
} as const;

export type PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns = typeof PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns[keyof typeof PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns];
/** select "propertySchemaAssociationsAggregateBoolExpBool_orArgumentsColumns" columns of table "property_schema_associations" */
export const PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns = {
  /** column name */
  Required: 'required',
  /** column name */
  Unique: 'unique'
} as const;

export type PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns = typeof PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns[keyof typeof PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns];
/** input type for updating data in table "property_schema_associations" */
export type PropertySchemaAssociationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  propertyAttributeTypeId?: InputMaybe<Scalars['String']['input']>;
  propertySchemaId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type PropertySchemaAssociationsStddevFields = {
  __typename?: 'PropertySchemaAssociationsStddevFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type PropertySchemaAssociationsStddevPopFields = {
  __typename?: 'PropertySchemaAssociationsStddevPopFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type PropertySchemaAssociationsStddevSampFields = {
  __typename?: 'PropertySchemaAssociationsStddevSampFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsStddevSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "property_schema_associations" */
export type PropertySchemaAssociationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PropertySchemaAssociationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertySchemaAssociationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  position?: InputMaybe<Scalars['Int']['input']>;
  propertyAttributeTypeId?: InputMaybe<Scalars['String']['input']>;
  propertySchemaId?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  required?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  unique?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type PropertySchemaAssociationsSumFields = {
  __typename?: 'PropertySchemaAssociationsSumFields';
  position?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsSumOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** update columns of table "property_schema_associations" */
export const PropertySchemaAssociationsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  Position: 'position',
  /** column name */
  PropertyAttributeTypeId: 'propertyAttributeTypeId',
  /** column name */
  PropertySchemaId: 'propertySchemaId',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  Required: 'required',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  Unique: 'unique',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertySchemaAssociationsUpdateColumn = typeof PropertySchemaAssociationsUpdateColumn[keyof typeof PropertySchemaAssociationsUpdateColumn];
export type PropertySchemaAssociationsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<PropertySchemaAssociationsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertySchemaAssociationsSetInput>;
  /** filter the rows which have to be updated */
  where: PropertySchemaAssociationsBoolExp;
};

/** aggregate varPop on columns */
export type PropertySchemaAssociationsVarPopFields = {
  __typename?: 'PropertySchemaAssociationsVarPopFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarPopOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type PropertySchemaAssociationsVarSampFields = {
  __typename?: 'PropertySchemaAssociationsVarSampFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarSampOrderBy = {
  position?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type PropertySchemaAssociationsVarianceFields = {
  __typename?: 'PropertySchemaAssociationsVarianceFields';
  position?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "property_schema_associations" */
export type PropertySchemaAssociationsVarianceOrderBy = {
  position?: InputMaybe<OrderBy>;
};

export type PropertySchemaSetUpsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  schemas: Array<PropertySchemaAssociationInput>;
};

/** columns and relationships of "property_schema_sets" */
export type PropertySchemaSets = {
  __typename?: 'PropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  /** An array relationship */
  propertySchemaAssociations: Array<PropertySchemaAssociations>;
  /** An aggregate relationship */
  propertySchemaAssociationsAggregate: PropertySchemaAssociationsAggregate;
  /** An object relationship */
  propertySchemaSet?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "property_schema_sets" */
export type PropertySchemaSetsPropertySchemaAssociationsArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


/** columns and relationships of "property_schema_sets" */
export type PropertySchemaSetsPropertySchemaAssociationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};

/** aggregated selection of "property_schema_sets" */
export type PropertySchemaSetsAggregate = {
  __typename?: 'PropertySchemaSetsAggregate';
  aggregate?: Maybe<PropertySchemaSetsAggregateFields>;
  nodes: Array<PropertySchemaSets>;
};

/** aggregate fields of "property_schema_sets" */
export type PropertySchemaSetsAggregateFields = {
  __typename?: 'PropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PropertySchemaSetsMaxFields>;
  min?: Maybe<PropertySchemaSetsMinFields>;
};


/** aggregate fields of "property_schema_sets" */
export type PropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_schema_sets". All fields are combined with a logical 'AND'. */
export type PropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<PropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<PropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<PropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  propertySchemaAssociations?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  propertySchemaAssociationsAggregate?: InputMaybe<PropertySchemaAssociationsAggregateBoolExp>;
  propertySchemaSet?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "property_schema_sets" */
export const PropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "id" */
  PropertySchemaSetsPkey: 'property_schema_sets_pkey'
} as const;

export type PropertySchemaSetsConstraint = typeof PropertySchemaSetsConstraint[keyof typeof PropertySchemaSetsConstraint];
/** input type for inserting data into table "property_schema_sets" */
export type PropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaAssociations?: InputMaybe<PropertySchemaAssociationsArrRelInsertInput>;
  propertySchemaSet?: InputMaybe<DataSourceTemplatePropertySchemaSetsObjRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PropertySchemaSetsMaxFields = {
  __typename?: 'PropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PropertySchemaSetsMinFields = {
  __typename?: 'PropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "property_schema_sets" */
export type PropertySchemaSetsMutationResponse = {
  __typename?: 'PropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertySchemaSets>;
};

/** input type for inserting object relation for remote table "property_schema_sets" */
export type PropertySchemaSetsObjRelInsertInput = {
  data: PropertySchemaSetsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PropertySchemaSetsOnConflict>;
};

/** on_conflict condition type for table "property_schema_sets" */
export type PropertySchemaSetsOnConflict = {
  constraint: PropertySchemaSetsConstraint;
  updateColumns?: Array<PropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "property_schema_sets". */
export type PropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  propertySchemaAssociationsAggregate?: InputMaybe<PropertySchemaAssociationsAggregateOrderBy>;
  propertySchemaSet?: InputMaybe<DataSourceTemplatePropertySchemaSetsOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: property_schema_sets */
export type PropertySchemaSetsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "property_schema_sets" */
export const PropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertySchemaSetsSelectColumn = typeof PropertySchemaSetsSelectColumn[keyof typeof PropertySchemaSetsSelectColumn];
/** input type for updating data in table "property_schema_sets" */
export type PropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "property_schema_sets" */
export type PropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "property_schema_sets" */
export const PropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertySchemaSetsUpdateColumn = typeof PropertySchemaSetsUpdateColumn[keyof typeof PropertySchemaSetsUpdateColumn];
export type PropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: PropertySchemaSetsBoolExp;
};

export const PropertySchemaType = {
  Bool: 'bool',
  Dag: 'dag',
  Date: 'date',
  Formula: 'formula',
  Gdtf: 'gdtf',
  I18nLabel: 'i18nLabel',
  I18nLabels: 'i18nLabels',
  LinkEntities: 'linkEntities',
  LinkEntity: 'linkEntity',
  LinkGeoItems: 'linkGeoItems',
  LinkRelation: 'linkRelation',
  LinkRelations: 'linkRelations',
  Media: 'media',
  MultiSelect: 'multiSelect',
  Number: 'number',
  Numbers: 'numbers',
  Rollup: 'rollup',
  Select: 'select',
  String: 'string',
  Strings: 'strings',
  Url: 'url'
} as const;

export type PropertySchemaType = typeof PropertySchemaType[keyof typeof PropertySchemaType];
export type PropertySchemaUpsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  propertyTypeId: PropertySchemaType;
  propertyValueDagId?: InputMaybe<Scalars['UUID']['input']>;
  propertyValueLinkFilterId?: InputMaybe<Scalars['UUID']['input']>;
  selectOptions?: InputMaybe<Array<PropertySelectOptionInput>>;
  urlAllowList?: InputMaybe<Array<PropertyUrlAllowListItem>>;
};

/** columns and relationships of "property_schemas" */
export type PropertySchemas = {
  __typename?: 'PropertySchemas';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  i18nLabel: Scalars['jsonb']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  propertySchemaAssociation?: Maybe<PropertySchemaAssociations>;
  propertyTypeId: Scalars['String']['output'];
  propertyValueDagId?: Maybe<Scalars['uuid']['output']>;
  propertyValueLinkFilterId?: Maybe<Scalars['uuid']['output']>;
  selectOptions: Scalars['jsonb']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  urlAllowList?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "property_schemas" */
export type PropertySchemasI18nLabelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_schemas" */
export type PropertySchemasSelectOptionsArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "property_schemas" */
export type PropertySchemasUrlAllowListArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "property_schemas" */
export type PropertySchemasAggregate = {
  __typename?: 'PropertySchemasAggregate';
  aggregate?: Maybe<PropertySchemasAggregateFields>;
  nodes: Array<PropertySchemas>;
};

/** aggregate fields of "property_schemas" */
export type PropertySchemasAggregateFields = {
  __typename?: 'PropertySchemasAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PropertySchemasMaxFields>;
  min?: Maybe<PropertySchemasMinFields>;
};


/** aggregate fields of "property_schemas" */
export type PropertySchemasAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PropertySchemasSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type PropertySchemasAppendInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  selectOptions?: InputMaybe<Scalars['jsonb']['input']>;
  urlAllowList?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "property_schemas". All fields are combined with a logical 'AND'. */
export type PropertySchemasBoolExp = {
  _and?: InputMaybe<Array<PropertySchemasBoolExp>>;
  _not?: InputMaybe<PropertySchemasBoolExp>;
  _or?: InputMaybe<Array<PropertySchemasBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  i18nLabel?: InputMaybe<JsonbComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  propertySchemaAssociation?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  propertyTypeId?: InputMaybe<StringComparisonExp>;
  propertyValueDagId?: InputMaybe<UuidComparisonExp>;
  propertyValueLinkFilterId?: InputMaybe<UuidComparisonExp>;
  selectOptions?: InputMaybe<JsonbComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  urlAllowList?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "property_schemas" */
export const PropertySchemasConstraint = {
  /** unique or primary key constraint on columns "id" */
  PropertySchemasPkey: 'property_schemas_pkey'
} as const;

export type PropertySchemasConstraint = typeof PropertySchemasConstraint[keyof typeof PropertySchemasConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type PropertySchemasDeleteAtPathInput = {
  i18nLabel?: InputMaybe<Array<Scalars['String']['input']>>;
  selectOptions?: InputMaybe<Array<Scalars['String']['input']>>;
  urlAllowList?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type PropertySchemasDeleteElemInput = {
  i18nLabel?: InputMaybe<Scalars['Int']['input']>;
  selectOptions?: InputMaybe<Scalars['Int']['input']>;
  urlAllowList?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type PropertySchemasDeleteKeyInput = {
  i18nLabel?: InputMaybe<Scalars['String']['input']>;
  selectOptions?: InputMaybe<Scalars['String']['input']>;
  urlAllowList?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "property_schemas" */
export type PropertySchemasInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  propertySchemaAssociation?: InputMaybe<PropertySchemaAssociationsObjRelInsertInput>;
  propertyTypeId?: InputMaybe<Scalars['String']['input']>;
  propertyValueDagId?: InputMaybe<Scalars['uuid']['input']>;
  propertyValueLinkFilterId?: InputMaybe<Scalars['uuid']['input']>;
  selectOptions?: InputMaybe<Scalars['jsonb']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urlAllowList?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type PropertySchemasMaxFields = {
  __typename?: 'PropertySchemasMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  propertyTypeId?: Maybe<Scalars['String']['output']>;
  propertyValueDagId?: Maybe<Scalars['uuid']['output']>;
  propertyValueLinkFilterId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PropertySchemasMinFields = {
  __typename?: 'PropertySchemasMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  propertyTypeId?: Maybe<Scalars['String']['output']>;
  propertyValueDagId?: Maybe<Scalars['uuid']['output']>;
  propertyValueLinkFilterId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "property_schemas" */
export type PropertySchemasMutationResponse = {
  __typename?: 'PropertySchemasMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertySchemas>;
};

/** input type for inserting object relation for remote table "property_schemas" */
export type PropertySchemasObjRelInsertInput = {
  data: PropertySchemasInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PropertySchemasOnConflict>;
};

/** on_conflict condition type for table "property_schemas" */
export type PropertySchemasOnConflict = {
  constraint: PropertySchemasConstraint;
  updateColumns?: Array<PropertySchemasUpdateColumn>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};

/** Ordering options when selecting data from "property_schemas". */
export type PropertySchemasOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  i18nLabel?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  propertySchemaAssociation?: InputMaybe<PropertySchemaAssociationsOrderBy>;
  propertyTypeId?: InputMaybe<OrderBy>;
  propertyValueDagId?: InputMaybe<OrderBy>;
  propertyValueLinkFilterId?: InputMaybe<OrderBy>;
  selectOptions?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  urlAllowList?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: property_schemas */
export type PropertySchemasPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type PropertySchemasPrependInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  selectOptions?: InputMaybe<Scalars['jsonb']['input']>;
  urlAllowList?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "property_schemas" */
export const PropertySchemasSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Id: 'id',
  /** column name */
  PropertyTypeId: 'propertyTypeId',
  /** column name */
  PropertyValueDagId: 'propertyValueDagId',
  /** column name */
  PropertyValueLinkFilterId: 'propertyValueLinkFilterId',
  /** column name */
  SelectOptions: 'selectOptions',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UrlAllowList: 'urlAllowList'
} as const;

export type PropertySchemasSelectColumn = typeof PropertySchemasSelectColumn[keyof typeof PropertySchemasSelectColumn];
/** input type for updating data in table "property_schemas" */
export type PropertySchemasSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  propertyTypeId?: InputMaybe<Scalars['String']['input']>;
  propertyValueDagId?: InputMaybe<Scalars['uuid']['input']>;
  propertyValueLinkFilterId?: InputMaybe<Scalars['uuid']['input']>;
  selectOptions?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urlAllowList?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "property_schemas" */
export type PropertySchemasStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PropertySchemasStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertySchemasStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  propertyTypeId?: InputMaybe<Scalars['String']['input']>;
  propertyValueDagId?: InputMaybe<Scalars['uuid']['input']>;
  propertyValueLinkFilterId?: InputMaybe<Scalars['uuid']['input']>;
  selectOptions?: InputMaybe<Scalars['jsonb']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  urlAllowList?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "property_schemas" */
export const PropertySchemasUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Id: 'id',
  /** column name */
  PropertyTypeId: 'propertyTypeId',
  /** column name */
  PropertyValueDagId: 'propertyValueDagId',
  /** column name */
  PropertyValueLinkFilterId: 'propertyValueLinkFilterId',
  /** column name */
  SelectOptions: 'selectOptions',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UrlAllowList: 'urlAllowList'
} as const;

export type PropertySchemasUpdateColumn = typeof PropertySchemasUpdateColumn[keyof typeof PropertySchemasUpdateColumn];
export type PropertySchemasUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<PropertySchemasAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<PropertySchemasDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<PropertySchemasDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<PropertySchemasDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<PropertySchemasPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertySchemasSetInput>;
  /** filter the rows which have to be updated */
  where: PropertySchemasBoolExp;
};

export type PropertySelectOption = {
  __typename?: 'PropertySelectOption';
  id?: Maybe<Scalars['String']['output']>;
  label?: Maybe<Scalars['JSONObject']['output']>;
  value: Scalars['String']['output'];
};

export type PropertySelectOptionInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  label?: InputMaybe<I18nLabelInput>;
  value: Scalars['String']['input'];
};

/** columns and relationships of "property_types" */
export type PropertyTypes = {
  __typename?: 'PropertyTypes';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "property_types" */
export type PropertyTypesAggregate = {
  __typename?: 'PropertyTypesAggregate';
  aggregate?: Maybe<PropertyTypesAggregateFields>;
  nodes: Array<PropertyTypes>;
};

/** aggregate fields of "property_types" */
export type PropertyTypesAggregateFields = {
  __typename?: 'PropertyTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PropertyTypesMaxFields>;
  min?: Maybe<PropertyTypesMinFields>;
};


/** aggregate fields of "property_types" */
export type PropertyTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PropertyTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "property_types". All fields are combined with a logical 'AND'. */
export type PropertyTypesBoolExp = {
  _and?: InputMaybe<Array<PropertyTypesBoolExp>>;
  _not?: InputMaybe<PropertyTypesBoolExp>;
  _or?: InputMaybe<Array<PropertyTypesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "property_types" */
export const PropertyTypesConstraint = {
  /** unique or primary key constraint on columns "id" */
  PropertyTypesPkey: 'property_types_pkey'
} as const;

export type PropertyTypesConstraint = typeof PropertyTypesConstraint[keyof typeof PropertyTypesConstraint];
/** input type for inserting data into table "property_types" */
export type PropertyTypesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PropertyTypesMaxFields = {
  __typename?: 'PropertyTypesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PropertyTypesMinFields = {
  __typename?: 'PropertyTypesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "property_types" */
export type PropertyTypesMutationResponse = {
  __typename?: 'PropertyTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<PropertyTypes>;
};

/** on_conflict condition type for table "property_types" */
export type PropertyTypesOnConflict = {
  constraint: PropertyTypesConstraint;
  updateColumns?: Array<PropertyTypesUpdateColumn>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};

/** Ordering options when selecting data from "property_types". */
export type PropertyTypesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: property_types */
export type PropertyTypesPkColumnsInput = {
  id: Scalars['String']['input'];
};

/** select columns of table "property_types" */
export const PropertyTypesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertyTypesSelectColumn = typeof PropertyTypesSelectColumn[keyof typeof PropertyTypesSelectColumn];
/** input type for updating data in table "property_types" */
export type PropertyTypesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "property_types" */
export type PropertyTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PropertyTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PropertyTypesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "property_types" */
export const PropertyTypesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PropertyTypesUpdateColumn = typeof PropertyTypesUpdateColumn[keyof typeof PropertyTypesUpdateColumn];
export type PropertyTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PropertyTypesSetInput>;
  /** filter the rows which have to be updated */
  where: PropertyTypesBoolExp;
};

export type PropertyUrlAllowItem = {
  __typename?: 'PropertyUrlAllowItem';
  regex?: Maybe<Scalars['String']['output']>;
  value?: Maybe<Scalars['String']['output']>;
};

export type PropertyUrlAllowListItem = {
  id?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "publishers" */
export type Publishers = {
  __typename?: 'Publishers';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  referencePublishers: Array<ReferencePublishers>;
  /** An aggregate relationship */
  referencePublishersAggregate: ReferencePublishersAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "publishers" */
export type PublishersReferencePublishersArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


/** columns and relationships of "publishers" */
export type PublishersReferencePublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};

/** aggregated selection of "publishers" */
export type PublishersAggregate = {
  __typename?: 'PublishersAggregate';
  aggregate?: Maybe<PublishersAggregateFields>;
  nodes: Array<Publishers>;
};

/** aggregate fields of "publishers" */
export type PublishersAggregateFields = {
  __typename?: 'PublishersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<PublishersMaxFields>;
  min?: Maybe<PublishersMinFields>;
};


/** aggregate fields of "publishers" */
export type PublishersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<PublishersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "publishers". All fields are combined with a logical 'AND'. */
export type PublishersBoolExp = {
  _and?: InputMaybe<Array<PublishersBoolExp>>;
  _not?: InputMaybe<PublishersBoolExp>;
  _or?: InputMaybe<Array<PublishersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  referencePublishers?: InputMaybe<ReferencePublishersBoolExp>;
  referencePublishersAggregate?: InputMaybe<ReferencePublishersAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "publishers" */
export const PublishersConstraint = {
  /** unique or primary key constraint on columns "id" */
  PublishersPkey: 'publishers_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  PublishersTenantIdIdKey: 'publishers_tenant_id_id_key'
} as const;

export type PublishersConstraint = typeof PublishersConstraint[keyof typeof PublishersConstraint];
/** input type for inserting data into table "publishers" */
export type PublishersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  referencePublishers?: InputMaybe<ReferencePublishersArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type PublishersMaxFields = {
  __typename?: 'PublishersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type PublishersMinFields = {
  __typename?: 'PublishersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "publishers" */
export type PublishersMutationResponse = {
  __typename?: 'PublishersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Publishers>;
};

/** input type for inserting object relation for remote table "publishers" */
export type PublishersObjRelInsertInput = {
  data: PublishersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<PublishersOnConflict>;
};

/** on_conflict condition type for table "publishers" */
export type PublishersOnConflict = {
  constraint: PublishersConstraint;
  updateColumns?: Array<PublishersUpdateColumn>;
  where?: InputMaybe<PublishersBoolExp>;
};

/** Ordering options when selecting data from "publishers". */
export type PublishersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  referencePublishersAggregate?: InputMaybe<ReferencePublishersAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: publishers */
export type PublishersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "publishers" */
export const PublishersSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PublishersSelectColumn = typeof PublishersSelectColumn[keyof typeof PublishersSelectColumn];
/** input type for updating data in table "publishers" */
export type PublishersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "publishers" */
export type PublishersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: PublishersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type PublishersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "publishers" */
export const PublishersUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type PublishersUpdateColumn = typeof PublishersUpdateColumn[keyof typeof PublishersUpdateColumn];
export type PublishersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<PublishersSetInput>;
  /** filter the rows which have to be updated */
  where: PublishersBoolExp;
};

export type RecordComposerDefinitionActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordComposerDefinitionActivateOutput = {
  __typename?: 'RecordComposerDefinitionActivateOutput';
  id: Scalars['UUID']['output'];
};

export type RecordComposerDefinitionDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordComposerDefinitionDeactivateOutput = {
  __typename?: 'RecordComposerDefinitionDeactivateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSets = {
  __typename?: 'RecordComposerDefinitionEvidenceSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  evidenceSet: EvidenceSets;
  evidenceSetId: Scalars['uuid']['output'];
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsAggregate = {
  __typename?: 'RecordComposerDefinitionEvidenceSetsAggregate';
  aggregate?: Maybe<RecordComposerDefinitionEvidenceSetsAggregateFields>;
  nodes: Array<RecordComposerDefinitionEvidenceSets>;
};

export type RecordComposerDefinitionEvidenceSetsAggregateBoolExp = {
  count?: InputMaybe<RecordComposerDefinitionEvidenceSetsAggregateBoolExpCount>;
};

/** aggregate fields of "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsAggregateFields = {
  __typename?: 'RecordComposerDefinitionEvidenceSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordComposerDefinitionEvidenceSetsMaxFields>;
  min?: Maybe<RecordComposerDefinitionEvidenceSetsMinFields>;
};


/** aggregate fields of "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordComposerDefinitionEvidenceSetsMaxOrderBy>;
  min?: InputMaybe<RecordComposerDefinitionEvidenceSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsArrRelInsertInput = {
  data: Array<RecordComposerDefinitionEvidenceSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordComposerDefinitionEvidenceSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "record_composer_definition_evidence_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionEvidenceSetsBoolExp = {
  _and?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsBoolExp>>;
  _not?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
  _or?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceSet?: InputMaybe<EvidenceSetsBoolExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "record_composer_definition_evidence_sets" */
export const RecordComposerDefinitionEvidenceSetsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id", "evidence_set_id" */
  RecordComposerDefinitionEvidenceSetsPkey: 'record_composer_definition_evidence_sets_pkey'
} as const;

export type RecordComposerDefinitionEvidenceSetsConstraint = typeof RecordComposerDefinitionEvidenceSetsConstraint[keyof typeof RecordComposerDefinitionEvidenceSetsConstraint];
/** input type for inserting data into table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSet?: InputMaybe<EvidenceSetsObjRelInsertInput>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RecordComposerDefinitionEvidenceSetsMaxFields = {
  __typename?: 'RecordComposerDefinitionEvidenceSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordComposerDefinitionEvidenceSetsMinFields = {
  __typename?: 'RecordComposerDefinitionEvidenceSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsMutationResponse = {
  __typename?: 'RecordComposerDefinitionEvidenceSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordComposerDefinitionEvidenceSets>;
};

/** on_conflict condition type for table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsOnConflict = {
  constraint: RecordComposerDefinitionEvidenceSetsConstraint;
  updateColumns?: Array<RecordComposerDefinitionEvidenceSetsUpdateColumn>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};

/** Ordering options when selecting data from "record_composer_definition_evidence_sets". */
export type RecordComposerDefinitionEvidenceSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  evidenceSet?: InputMaybe<EvidenceSetsOrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_composer_definition_evidence_sets */
export type RecordComposerDefinitionEvidenceSetsPkColumnsInput = {
  evidenceSetId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "record_composer_definition_evidence_sets" */
export const RecordComposerDefinitionEvidenceSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RecordComposerDefinitionEvidenceSetsSelectColumn = typeof RecordComposerDefinitionEvidenceSetsSelectColumn[keyof typeof RecordComposerDefinitionEvidenceSetsSelectColumn];
/** input type for updating data in table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "record_composer_definition_evidence_sets" */
export type RecordComposerDefinitionEvidenceSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordComposerDefinitionEvidenceSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordComposerDefinitionEvidenceSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "record_composer_definition_evidence_sets" */
export const RecordComposerDefinitionEvidenceSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RecordComposerDefinitionEvidenceSetsUpdateColumn = typeof RecordComposerDefinitionEvidenceSetsUpdateColumn[keyof typeof RecordComposerDefinitionEvidenceSetsUpdateColumn];
export type RecordComposerDefinitionEvidenceSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordComposerDefinitionEvidenceSetsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordComposerDefinitionEvidenceSetsBoolExp;
};

/** columns and relationships of "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSets = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsAggregate = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSetsAggregate';
  aggregate?: Maybe<RecordComposerDefinitionPropertySchemaSetsAggregateFields>;
  nodes: Array<RecordComposerDefinitionPropertySchemaSets>;
};

export type RecordComposerDefinitionPropertySchemaSetsAggregateBoolExp = {
  count?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsAggregateBoolExpCount>;
};

/** aggregate fields of "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsAggregateFields = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordComposerDefinitionPropertySchemaSetsMaxFields>;
  min?: Maybe<RecordComposerDefinitionPropertySchemaSetsMinFields>;
};


/** aggregate fields of "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsMaxOrderBy>;
  min?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsArrRelInsertInput = {
  data: Array<RecordComposerDefinitionPropertySchemaSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "record_composer_definition_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionPropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_composer_definition_property_schema_sets" */
export const RecordComposerDefinitionPropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  RecordComposerDefinitionPropertySchemaSetsPkey: 'record_composer_definition_property_schema_sets_pkey',
  /** unique or primary key constraint on columns "property_schema_set_id" */
  RecordComposerDefinitionPropertySchemaSetsPropertyScKey: 'record_composer_definition_property_schema_sets_property_sc_key'
} as const;

export type RecordComposerDefinitionPropertySchemaSetsConstraint = typeof RecordComposerDefinitionPropertySchemaSetsConstraint[keyof typeof RecordComposerDefinitionPropertySchemaSetsConstraint];
/** input type for inserting data into table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordComposerDefinitionPropertySchemaSetsMaxFields = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordComposerDefinitionPropertySchemaSetsMinFields = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsMutationResponse = {
  __typename?: 'RecordComposerDefinitionPropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordComposerDefinitionPropertySchemaSets>;
};

/** on_conflict condition type for table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsOnConflict = {
  constraint: RecordComposerDefinitionPropertySchemaSetsConstraint;
  updateColumns?: Array<RecordComposerDefinitionPropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "record_composer_definition_property_schema_sets". */
export type RecordComposerDefinitionPropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_composer_definition_property_schema_sets */
export type RecordComposerDefinitionPropertySchemaSetsPkColumnsInput = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "record_composer_definition_property_schema_sets" */
export const RecordComposerDefinitionPropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordComposerDefinitionPropertySchemaSetsSelectColumn = typeof RecordComposerDefinitionPropertySchemaSetsSelectColumn[keyof typeof RecordComposerDefinitionPropertySchemaSetsSelectColumn];
/** input type for updating data in table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_composer_definition_property_schema_sets" */
export type RecordComposerDefinitionPropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordComposerDefinitionPropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordComposerDefinitionPropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_composer_definition_property_schema_sets" */
export const RecordComposerDefinitionPropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordComposerDefinitionPropertySchemaSetsUpdateColumn = typeof RecordComposerDefinitionPropertySchemaSetsUpdateColumn[keyof typeof RecordComposerDefinitionPropertySchemaSetsUpdateColumn];
export type RecordComposerDefinitionPropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordComposerDefinitionPropertySchemaSetsBoolExp;
};

export type RecordComposerDefinitionUpsertInput = {
  definition: Scalars['JSONObject']['input'];
  /**
   * Evidence sets this composer reads from. When provided, the join rows in
   * `record_composer_definition_evidence_sets` are replaced with this list.
   * Omit (or pass null) to leave the existing associations untouched on update,
   * or to leave them empty on first insert. Pass [] to explicitly clear.
   */
  evidenceSetIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  importProjectId?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  propertySchemaSet: PropertySchemaSetUpsertInput;
  tenantId: Scalars['UUID']['input'];
};

export type RecordComposerDefinitionUpsertOutput = {
  __typename?: 'RecordComposerDefinitionUpsertOutput';
  id: Scalars['UUID']['output'];
};

export type RecordComposerDefinitionUpsertResponse = RecordComposerDefinitionUpsertOutput | ValidationError;

/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitions = {
  __typename?: 'RecordComposerDefinitions';
  /** An array relationship */
  batchChangeRequestsJobRecordComposerDefinitions: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An aggregate relationship */
  batchChangeRequestsJobRecordComposerDefinitionsAggregate: BatchChangeRequestsJobRecordComposerDefinitionsAggregate;
  /** An array relationship */
  changeRequestRecordComposerDefinitions: Array<ChangeRequestRecordComposerDefinitions>;
  /** An aggregate relationship */
  changeRequestRecordComposerDefinitionsAggregate: ChangeRequestRecordComposerDefinitionsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  dataImportProjectRecordComposerDefinition?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** An object relationship */
  dataSourceImportProjectRecordComposerDefinition?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  definition: Scalars['jsonb']['output'];
  /** An object relationship */
  entityComposerDefinition?: Maybe<EntityRecordComposerDefinitions>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An array relationship */
  recordComposerDefinitionEvidenceSets: Array<RecordComposerDefinitionEvidenceSets>;
  /** An aggregate relationship */
  recordComposerDefinitionEvidenceSetsAggregate: RecordComposerDefinitionEvidenceSetsAggregate;
  /** An array relationship */
  recordComposerDefinitionPropertySchemaSet: Array<RecordComposerDefinitionPropertySchemaSets>;
  /** An aggregate relationship */
  recordComposerDefinitionPropertySchemaSetAggregate: RecordComposerDefinitionPropertySchemaSetsAggregate;
  /** An object relationship */
  recordUpdateComposerDefinition?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** An object relationship */
  relationComposerDefinition?: Maybe<RelationRecordComposerDefinitions>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsBatchChangeRequestsJobRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsChangeRequestRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsChangeRequestRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsDefinitionArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsRecordComposerDefinitionEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsRecordComposerDefinitionEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsRecordComposerDefinitionPropertySchemaSetArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


/** columns and relationships of "record_composer_definitions" */
export type RecordComposerDefinitionsRecordComposerDefinitionPropertySchemaSetAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};

/** aggregated selection of "record_composer_definitions" */
export type RecordComposerDefinitionsAggregate = {
  __typename?: 'RecordComposerDefinitionsAggregate';
  aggregate?: Maybe<RecordComposerDefinitionsAggregateFields>;
  nodes: Array<RecordComposerDefinitions>;
};

/** aggregate fields of "record_composer_definitions" */
export type RecordComposerDefinitionsAggregateFields = {
  __typename?: 'RecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordComposerDefinitionsMaxFields>;
  min?: Maybe<RecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "record_composer_definitions" */
export type RecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecordComposerDefinitionsAppendInput = {
  definition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Boolean expression to filter rows from the table "record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<RecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<RecordComposerDefinitionsBoolExp>>;
  batchChangeRequestsJobRecordComposerDefinitions?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExp>;
  changeRequestRecordComposerDefinitions?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
  changeRequestRecordComposerDefinitionsAggregate?: InputMaybe<ChangeRequestRecordComposerDefinitionsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataImportProjectRecordComposerDefinition?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
  dataSourceImportProjectRecordComposerDefinition?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  definition?: InputMaybe<JsonbComparisonExp>;
  entityComposerDefinition?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  recordComposerDefinitionEvidenceSets?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
  recordComposerDefinitionEvidenceSetsAggregate?: InputMaybe<RecordComposerDefinitionEvidenceSetsAggregateBoolExp>;
  recordComposerDefinitionPropertySchemaSet?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
  recordComposerDefinitionPropertySchemaSetAggregate?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsAggregateBoolExp>;
  recordUpdateComposerDefinition?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
  relationComposerDefinition?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_composer_definitions" */
export const RecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "id" */
  RecordComposerDefinitionsPkey: 'record_composer_definitions_pkey',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  RecordComposerDefinitionsTenantIdIdKey: 'record_composer_definitions_tenant_id_id_key'
} as const;

export type RecordComposerDefinitionsConstraint = typeof RecordComposerDefinitionsConstraint[keyof typeof RecordComposerDefinitionsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecordComposerDefinitionsDeleteAtPathInput = {
  definition?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecordComposerDefinitionsDeleteElemInput = {
  definition?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecordComposerDefinitionsDeleteKeyInput = {
  definition?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "record_composer_definitions" */
export type RecordComposerDefinitionsInsertInput = {
  batchChangeRequestsJobRecordComposerDefinitions?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsArrRelInsertInput>;
  changeRequestRecordComposerDefinitions?: InputMaybe<ChangeRequestRecordComposerDefinitionsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataImportProjectRecordComposerDefinition?: InputMaybe<DataImportProjectRecordComposerDefinitionsObjRelInsertInput>;
  dataSourceImportProjectRecordComposerDefinition?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsObjRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  entityComposerDefinition?: InputMaybe<EntityRecordComposerDefinitionsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  recordComposerDefinitionEvidenceSets?: InputMaybe<RecordComposerDefinitionEvidenceSetsArrRelInsertInput>;
  recordComposerDefinitionPropertySchemaSet?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsArrRelInsertInput>;
  recordUpdateComposerDefinition?: InputMaybe<RecordUpdateRecordComposerDefinitionsObjRelInsertInput>;
  relationComposerDefinition?: InputMaybe<RelationRecordComposerDefinitionsObjRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordComposerDefinitionsMaxFields = {
  __typename?: 'RecordComposerDefinitionsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RecordComposerDefinitionsMinFields = {
  __typename?: 'RecordComposerDefinitionsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "record_composer_definitions" */
export type RecordComposerDefinitionsMutationResponse = {
  __typename?: 'RecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "record_composer_definitions" */
export type RecordComposerDefinitionsObjRelInsertInput = {
  data: RecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "record_composer_definitions" */
export type RecordComposerDefinitionsOnConflict = {
  constraint: RecordComposerDefinitionsConstraint;
  updateColumns?: Array<RecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "record_composer_definitions". */
export type RecordComposerDefinitionsOrderBy = {
  batchChangeRequestsJobRecordComposerDefinitionsAggregate?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsAggregateOrderBy>;
  changeRequestRecordComposerDefinitionsAggregate?: InputMaybe<ChangeRequestRecordComposerDefinitionsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataImportProjectRecordComposerDefinition?: InputMaybe<DataImportProjectRecordComposerDefinitionsOrderBy>;
  dataSourceImportProjectRecordComposerDefinition?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  definition?: InputMaybe<OrderBy>;
  entityComposerDefinition?: InputMaybe<EntityRecordComposerDefinitionsOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  recordComposerDefinitionEvidenceSetsAggregate?: InputMaybe<RecordComposerDefinitionEvidenceSetsAggregateOrderBy>;
  recordComposerDefinitionPropertySchemaSetAggregate?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsAggregateOrderBy>;
  recordUpdateComposerDefinition?: InputMaybe<RecordUpdateRecordComposerDefinitionsOrderBy>;
  relationComposerDefinition?: InputMaybe<RelationRecordComposerDefinitionsOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_composer_definitions */
export type RecordComposerDefinitionsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecordComposerDefinitionsPrependInput = {
  definition?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "record_composer_definitions" */
export const RecordComposerDefinitionsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Definition: 'definition',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordComposerDefinitionsSelectColumn = typeof RecordComposerDefinitionsSelectColumn[keyof typeof RecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "record_composer_definitions" */
export type RecordComposerDefinitionsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_composer_definitions" */
export type RecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordComposerDefinitionsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  definition?: InputMaybe<Scalars['jsonb']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_composer_definitions" */
export const RecordComposerDefinitionsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Definition: 'definition',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordComposerDefinitionsUpdateColumn = typeof RecordComposerDefinitionsUpdateColumn[keyof typeof RecordComposerDefinitionsUpdateColumn];
export type RecordComposerDefinitionsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RecordComposerDefinitionsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RecordComposerDefinitionsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RecordComposerDefinitionsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RecordComposerDefinitionsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RecordComposerDefinitionsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordComposerDefinitionsBoolExp;
};

export type RecordCompoundRecordComposer = {
  __typename?: 'RecordCompoundRecordComposer';
  compoundRecordComposerId: Scalars['UUID']['output'];
  createdAt: Scalars['DateTime']['output'];
  recordId: Scalars['UUID']['output'];
  updatedAt: Scalars['DateTime']['output'];
};

/** columns and relationships of "record_compound_record_composers" */
export type RecordCompoundRecordComposers = {
  __typename?: 'RecordCompoundRecordComposers';
  /** An object relationship */
  compoundRecordComposer: CompoundRecordComposers;
  compoundRecordComposerId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  record: Records;
  recordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "record_compound_record_composers" */
export type RecordCompoundRecordComposersAggregate = {
  __typename?: 'RecordCompoundRecordComposersAggregate';
  aggregate?: Maybe<RecordCompoundRecordComposersAggregateFields>;
  nodes: Array<RecordCompoundRecordComposers>;
};

export type RecordCompoundRecordComposersAggregateBoolExp = {
  count?: InputMaybe<RecordCompoundRecordComposersAggregateBoolExpCount>;
};

/** aggregate fields of "record_compound_record_composers" */
export type RecordCompoundRecordComposersAggregateFields = {
  __typename?: 'RecordCompoundRecordComposersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordCompoundRecordComposersMaxFields>;
  min?: Maybe<RecordCompoundRecordComposersMinFields>;
};


/** aggregate fields of "record_compound_record_composers" */
export type RecordCompoundRecordComposersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_compound_record_composers" */
export type RecordCompoundRecordComposersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordCompoundRecordComposersMaxOrderBy>;
  min?: InputMaybe<RecordCompoundRecordComposersMinOrderBy>;
};

/** input type for inserting array relation for remote table "record_compound_record_composers" */
export type RecordCompoundRecordComposersArrRelInsertInput = {
  data: Array<RecordCompoundRecordComposersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordCompoundRecordComposersOnConflict>;
};

/** Boolean expression to filter rows from the table "record_compound_record_composers". All fields are combined with a logical 'AND'. */
export type RecordCompoundRecordComposersBoolExp = {
  _and?: InputMaybe<Array<RecordCompoundRecordComposersBoolExp>>;
  _not?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
  _or?: InputMaybe<Array<RecordCompoundRecordComposersBoolExp>>;
  compoundRecordComposer?: InputMaybe<CompoundRecordComposersBoolExp>;
  compoundRecordComposerId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_compound_record_composers" */
export const RecordCompoundRecordComposersConstraint = {
  /** unique or primary key constraint on columns "compound_record_composer_id", "record_id" */
  RecordCompoundRecordComposersPkey: 'record_compound_record_composers_pkey'
} as const;

export type RecordCompoundRecordComposersConstraint = typeof RecordCompoundRecordComposersConstraint[keyof typeof RecordCompoundRecordComposersConstraint];
/** input type for inserting data into table "record_compound_record_composers" */
export type RecordCompoundRecordComposersInsertInput = {
  compoundRecordComposer?: InputMaybe<CompoundRecordComposersObjRelInsertInput>;
  compoundRecordComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

export type RecordCompoundRecordComposersListInput = {
  compoundRecordComposerIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  recordIdsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordCompoundRecordComposersListOutput = {
  __typename?: 'RecordCompoundRecordComposersListOutput';
  recordCompoundRecordComposers: Array<RecordCompoundRecordComposer>;
};

export type RecordCompoundRecordComposersListResponse = RecordCompoundRecordComposersListOutput | ValidationError;

/** aggregate max on columns */
export type RecordCompoundRecordComposersMaxFields = {
  __typename?: 'RecordCompoundRecordComposersMaxFields';
  compoundRecordComposerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "record_compound_record_composers" */
export type RecordCompoundRecordComposersMaxOrderBy = {
  compoundRecordComposerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordCompoundRecordComposersMinFields = {
  __typename?: 'RecordCompoundRecordComposersMinFields';
  compoundRecordComposerId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "record_compound_record_composers" */
export type RecordCompoundRecordComposersMinOrderBy = {
  compoundRecordComposerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_compound_record_composers" */
export type RecordCompoundRecordComposersMutationResponse = {
  __typename?: 'RecordCompoundRecordComposersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordCompoundRecordComposers>;
};

/** on_conflict condition type for table "record_compound_record_composers" */
export type RecordCompoundRecordComposersOnConflict = {
  constraint: RecordCompoundRecordComposersConstraint;
  updateColumns?: Array<RecordCompoundRecordComposersUpdateColumn>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};

/** Ordering options when selecting data from "record_compound_record_composers". */
export type RecordCompoundRecordComposersOrderBy = {
  compoundRecordComposer?: InputMaybe<CompoundRecordComposersOrderBy>;
  compoundRecordComposerId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_compound_record_composers */
export type RecordCompoundRecordComposersPkColumnsInput = {
  compoundRecordComposerId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "record_compound_record_composers" */
export const RecordCompoundRecordComposersSelectColumn = {
  /** column name */
  CompoundRecordComposerId: 'compoundRecordComposerId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordCompoundRecordComposersSelectColumn = typeof RecordCompoundRecordComposersSelectColumn[keyof typeof RecordCompoundRecordComposersSelectColumn];
/** input type for updating data in table "record_compound_record_composers" */
export type RecordCompoundRecordComposersSetInput = {
  compoundRecordComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_compound_record_composers" */
export type RecordCompoundRecordComposersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordCompoundRecordComposersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordCompoundRecordComposersStreamCursorValueInput = {
  compoundRecordComposerId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_compound_record_composers" */
export const RecordCompoundRecordComposersUpdateColumn = {
  /** column name */
  CompoundRecordComposerId: 'compoundRecordComposerId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordCompoundRecordComposersUpdateColumn = typeof RecordCompoundRecordComposersUpdateColumn[keyof typeof RecordCompoundRecordComposersUpdateColumn];
export type RecordCompoundRecordComposersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordCompoundRecordComposersSetInput>;
  /** filter the rows which have to be updated */
  where: RecordCompoundRecordComposersBoolExp;
};

export type RecordGeoItemDeactivateInput = {
  entityOrRelationId: Scalars['UUID']['input'];
  geoItemId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordGeoItemDetailEntryOutput = {
  __typename?: 'RecordGeoItemDetailEntryOutput';
  attributed: Scalars['Boolean']['output'];
  date?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  metadata: Scalars['JSONObject']['output'];
};

export type RecordGeoItemDetailEvidenceOutput = {
  __typename?: 'RecordGeoItemDetailEvidenceOutput';
  citation: Scalars['JSONObject']['output'];
  id: Scalars['UUID']['output'];
  references: Array<RecordGeoItemDetailReferenceOutput>;
};

export type RecordGeoItemDetailGeoItemOutput = {
  __typename?: 'RecordGeoItemDetailGeoItemOutput';
  geometry?: Maybe<Scalars['JSONObject']['output']>;
  h3Indexes: Array<Scalars['String']['output']>;
  i18nLabel: Scalars['JSONObject']['output'];
  id: Scalars['UUID']['output'];
};

export type RecordGeoItemDetailInput = {
  geoItemId: Scalars['UUID']['input'];
  recordId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordGeoItemDetailOutput = {
  __typename?: 'RecordGeoItemDetailOutput';
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  entries: Array<RecordGeoItemDetailEntryOutput>;
  evidences: Array<RecordGeoItemDetailEvidenceOutput>;
  geoItem: RecordGeoItemDetailGeoItemOutput;
  geoItemId: Scalars['UUID']['output'];
  record: RecordGeoItemDetailRecordOutput;
};

export type RecordGeoItemDetailRecordOutput = {
  __typename?: 'RecordGeoItemDetailRecordOutput';
  id: Scalars['UUID']['output'];
  nameJa?: Maybe<Scalars['String']['output']>;
};

export type RecordGeoItemDetailReferenceOutput = {
  __typename?: 'RecordGeoItemDetailReferenceOutput';
  id: Scalars['UUID']['output'];
  title: Scalars['String']['output'];
};

export type RecordGeoItemDetailResponse = RecordGeoItemDetailOutput | ValidationError;

export type RecordGeoItemOutput = {
  __typename?: 'RecordGeoItemOutput';
  entityOrRelationId: Scalars['UUID']['output'];
  geoItemId: Scalars['UUID']['output'];
};

export type RecordGeoItemReadGeoItemOutput = {
  __typename?: 'RecordGeoItemReadGeoItemOutput';
  i18nLabel: Scalars['JSONObject']['output'];
};

export type RecordGeoItemReadOutput = {
  __typename?: 'RecordGeoItemReadOutput';
  countryCode?: Maybe<Scalars['String']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  geoItem?: Maybe<RecordGeoItemReadGeoItemOutput>;
  geoItemId: Scalars['UUID']['output'];
  i18nLabel: Scalars['JSONObject']['output'];
};

export type RecordGeoItemUpdateInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  entityOrRelationId: Scalars['UUID']['input'];
  evidences?: InputMaybe<Array<EvidenceUpsertInput>>;
  geoItemId: Scalars['UUID']['input'];
  i18nLabel?: InputMaybe<I18nLabelInput>;
  metadata?: InputMaybe<Scalars['JSONObject']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordGeoItemWithGeoItemReadOutput = {
  __typename?: 'RecordGeoItemWithGeoItemReadOutput';
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  geoItem: GeoItemReadOutput;
  geoItemId: Scalars['UUID']['output'];
  i18nLabel: Scalars['JSONObject']['output'];
  metadata: Scalars['JSONObject']['output'];
};

/** columns and relationships of "record_geo_items" */
export type RecordGeoItems = {
  __typename?: 'RecordGeoItems';
  createdAt: Scalars['timestamptz']['output'];
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  evidenceRecordGeoItems: Array<EvidenceRecordGeoItems>;
  /** An aggregate relationship */
  evidenceRecordGeoItemsAggregate: EvidenceRecordGeoItemsAggregate;
  geoItemId: Scalars['uuid']['output'];
  i18nLabel: Scalars['jsonb']['output'];
  metadata: Scalars['jsonb']['output'];
  /** An object relationship */
  record: Records;
  recordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "record_geo_items" */
export type RecordGeoItemsEvidenceRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


/** columns and relationships of "record_geo_items" */
export type RecordGeoItemsEvidenceRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


/** columns and relationships of "record_geo_items" */
export type RecordGeoItemsI18nLabelArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "record_geo_items" */
export type RecordGeoItemsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "record_geo_items" */
export type RecordGeoItemsAggregate = {
  __typename?: 'RecordGeoItemsAggregate';
  aggregate?: Maybe<RecordGeoItemsAggregateFields>;
  nodes: Array<RecordGeoItems>;
};

export type RecordGeoItemsAggregateBoolExp = {
  count?: InputMaybe<RecordGeoItemsAggregateBoolExpCount>;
};

/** aggregate fields of "record_geo_items" */
export type RecordGeoItemsAggregateFields = {
  __typename?: 'RecordGeoItemsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordGeoItemsMaxFields>;
  min?: Maybe<RecordGeoItemsMinFields>;
};


/** aggregate fields of "record_geo_items" */
export type RecordGeoItemsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_geo_items" */
export type RecordGeoItemsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordGeoItemsMaxOrderBy>;
  min?: InputMaybe<RecordGeoItemsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecordGeoItemsAppendInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "record_geo_items" */
export type RecordGeoItemsArrRelInsertInput = {
  data: Array<RecordGeoItemsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordGeoItemsOnConflict>;
};

/** Boolean expression to filter rows from the table "record_geo_items". All fields are combined with a logical 'AND'. */
export type RecordGeoItemsBoolExp = {
  _and?: InputMaybe<Array<RecordGeoItemsBoolExp>>;
  _not?: InputMaybe<RecordGeoItemsBoolExp>;
  _or?: InputMaybe<Array<RecordGeoItemsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  date?: InputMaybe<StringComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDate?: InputMaybe<StringComparisonExp>;
  evidenceRecordGeoItems?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
  evidenceRecordGeoItemsAggregate?: InputMaybe<EvidenceRecordGeoItemsAggregateBoolExp>;
  geoItemId?: InputMaybe<UuidComparisonExp>;
  i18nLabel?: InputMaybe<JsonbComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

export type RecordGeoItemsByRecordIdOutput = {
  __typename?: 'RecordGeoItemsByRecordIdOutput';
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  nameJa?: Maybe<Scalars['String']['output']>;
  recordGeoItems: Array<RecordGeoItemWithGeoItemReadOutput>;
};

export type RecordGeoItemsByRecordIdsInput = {
  recordIds: Array<Scalars['UUID']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordGeoItemsByRecordIdsOutput = {
  __typename?: 'RecordGeoItemsByRecordIdsOutput';
  records: Array<RecordGeoItemsByRecordIdOutput>;
};

export type RecordGeoItemsByRecordIdsResponse = RecordGeoItemsByRecordIdsOutput | ValidationError;

export type RecordGeoItemsByRecordInput = {
  recordId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordGeoItemsByRecordOutput = {
  __typename?: 'RecordGeoItemsByRecordOutput';
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  nameJa?: Maybe<Scalars['String']['output']>;
  recordGeoItems: Array<RecordGeoItemReadOutput>;
};

export type RecordGeoItemsByRecordResponse = RecordGeoItemsByRecordOutput | ValidationError;

/** unique or primary key constraints on table "record_geo_items" */
export const RecordGeoItemsConstraint = {
  /** unique or primary key constraint on columns "record_id", "geo_item_id" */
  RecordGeoItemsPkey: 'record_geo_items_pkey'
} as const;

export type RecordGeoItemsConstraint = typeof RecordGeoItemsConstraint[keyof typeof RecordGeoItemsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecordGeoItemsDeleteAtPathInput = {
  i18nLabel?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecordGeoItemsDeleteElemInput = {
  i18nLabel?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecordGeoItemsDeleteKeyInput = {
  i18nLabel?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "record_geo_items" */
export type RecordGeoItemsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  evidenceRecordGeoItems?: InputMaybe<EvidenceRecordGeoItemsArrRelInsertInput>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordGeoItemsMaxFields = {
  __typename?: 'RecordGeoItemsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  geoItemId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "record_geo_items" */
export type RecordGeoItemsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordGeoItemsMinFields = {
  __typename?: 'RecordGeoItemsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  geoItemId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "record_geo_items" */
export type RecordGeoItemsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_geo_items" */
export type RecordGeoItemsMutationResponse = {
  __typename?: 'RecordGeoItemsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordGeoItems>;
};

/** input type for inserting object relation for remote table "record_geo_items" */
export type RecordGeoItemsObjRelInsertInput = {
  data: RecordGeoItemsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RecordGeoItemsOnConflict>;
};

/** on_conflict condition type for table "record_geo_items" */
export type RecordGeoItemsOnConflict = {
  constraint: RecordGeoItemsConstraint;
  updateColumns?: Array<RecordGeoItemsUpdateColumn>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};

/** Ordering options when selecting data from "record_geo_items". */
export type RecordGeoItemsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  evidenceRecordGeoItemsAggregate?: InputMaybe<EvidenceRecordGeoItemsAggregateOrderBy>;
  geoItemId?: InputMaybe<OrderBy>;
  i18nLabel?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_geo_items */
export type RecordGeoItemsPkColumnsInput = {
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecordGeoItemsPrependInput = {
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "record_geo_items" */
export const RecordGeoItemsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  GeoItemId: 'geoItemId',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordGeoItemsSelectColumn = typeof RecordGeoItemsSelectColumn[keyof typeof RecordGeoItemsSelectColumn];
/** input type for updating data in table "record_geo_items" */
export type RecordGeoItemsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_geo_items" */
export type RecordGeoItemsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordGeoItemsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordGeoItemsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  geoItemId?: InputMaybe<Scalars['uuid']['input']>;
  i18nLabel?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_geo_items" */
export const RecordGeoItemsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  GeoItemId: 'geoItemId',
  /** column name */
  I18nLabel: 'i18nLabel',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordGeoItemsUpdateColumn = typeof RecordGeoItemsUpdateColumn[keyof typeof RecordGeoItemsUpdateColumn];
export type RecordGeoItemsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RecordGeoItemsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RecordGeoItemsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RecordGeoItemsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RecordGeoItemsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RecordGeoItemsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordGeoItemsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordGeoItemsBoolExp;
};

export type RecordIdsWithGeoItemsFilterInput = {
  recordIds: Array<Scalars['UUID']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordIdsWithGeoItemsListInput = {
  afterRecordId?: InputMaybe<Scalars['UUID']['input']>;
  limit: Scalars['Int']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordIdsWithGeoItemsOutput = {
  __typename?: 'RecordIdsWithGeoItemsOutput';
  recordIds: Array<Scalars['UUID']['output']>;
};

export type RecordIdsWithGeoItemsPage = {
  __typename?: 'RecordIdsWithGeoItemsPage';
  hasNextPage: Scalars['Boolean']['output'];
  nextCursor?: Maybe<Scalars['UUID']['output']>;
  recordIds: Array<Scalars['UUID']['output']>;
};

/** columns and relationships of "record_metadata" */
export type RecordMetadata = {
  __typename?: 'RecordMetadata';
  /** An array relationship */
  changeRequestItemRecordMetadata: Array<ChangeRequestItemRecordMetadata>;
  /** An aggregate relationship */
  changeRequestItemRecordMetadataAggregate: ChangeRequestItemRecordMetadataAggregate;
  createdAt: Scalars['timestamptz']['output'];
  data: Scalars['jsonb']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceLineageIdentity?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  /** An object relationship */
  record?: Maybe<Records>;
  recordDeactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId: Scalars['uuid']['output'];
  /** An array relationship */
  recordMetadataCategories: Array<RecordMetadataCategories>;
  /** An aggregate relationship */
  recordMetadataCategoriesAggregate: RecordMetadataCategoriesAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "record_metadata" */
export type RecordMetadataChangeRequestItemRecordMetadataArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


/** columns and relationships of "record_metadata" */
export type RecordMetadataChangeRequestItemRecordMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


/** columns and relationships of "record_metadata" */
export type RecordMetadataDataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "record_metadata" */
export type RecordMetadataRecordMetadataCategoriesArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


/** columns and relationships of "record_metadata" */
export type RecordMetadataRecordMetadataCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};

/** aggregated selection of "record_metadata" */
export type RecordMetadataAggregate = {
  __typename?: 'RecordMetadataAggregate';
  aggregate?: Maybe<RecordMetadataAggregateFields>;
  nodes: Array<RecordMetadata>;
};

/** aggregate fields of "record_metadata" */
export type RecordMetadataAggregateFields = {
  __typename?: 'RecordMetadataAggregateFields';
  avg?: Maybe<RecordMetadataAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RecordMetadataMaxFields>;
  min?: Maybe<RecordMetadataMinFields>;
  stddev?: Maybe<RecordMetadataStddevFields>;
  stddevPop?: Maybe<RecordMetadataStddevPopFields>;
  stddevSamp?: Maybe<RecordMetadataStddevSampFields>;
  sum?: Maybe<RecordMetadataSumFields>;
  varPop?: Maybe<RecordMetadataVarPopFields>;
  varSamp?: Maybe<RecordMetadataVarSampFields>;
  variance?: Maybe<RecordMetadataVarianceFields>;
};


/** aggregate fields of "record_metadata" */
export type RecordMetadataAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecordMetadataAppendInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type RecordMetadataAvgFields = {
  __typename?: 'RecordMetadataAvgFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "record_metadata". All fields are combined with a logical 'AND'. */
export type RecordMetadataBoolExp = {
  _and?: InputMaybe<Array<RecordMetadataBoolExp>>;
  _not?: InputMaybe<RecordMetadataBoolExp>;
  _or?: InputMaybe<Array<RecordMetadataBoolExp>>;
  changeRequestItemRecordMetadata?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
  changeRequestItemRecordMetadataAggregate?: InputMaybe<ChangeRequestItemRecordMetadataAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  data?: InputMaybe<JsonbComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceLineageIdentity?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordDeactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  recordMetadataCategories?: InputMaybe<RecordMetadataCategoriesBoolExp>;
  recordMetadataCategoriesAggregate?: InputMaybe<RecordMetadataCategoriesAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** columns and relationships of "record_metadata_categories" */
export type RecordMetadataCategories = {
  __typename?: 'RecordMetadataCategories';
  /** An object relationship */
  category: Categories;
  categoryId: Scalars['uuid']['output'];
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  recordMetadata: RecordMetadata;
  recordMetadataId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "record_metadata_categories" */
export type RecordMetadataCategoriesAggregate = {
  __typename?: 'RecordMetadataCategoriesAggregate';
  aggregate?: Maybe<RecordMetadataCategoriesAggregateFields>;
  nodes: Array<RecordMetadataCategories>;
};

export type RecordMetadataCategoriesAggregateBoolExp = {
  count?: InputMaybe<RecordMetadataCategoriesAggregateBoolExpCount>;
};

/** aggregate fields of "record_metadata_categories" */
export type RecordMetadataCategoriesAggregateFields = {
  __typename?: 'RecordMetadataCategoriesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordMetadataCategoriesMaxFields>;
  min?: Maybe<RecordMetadataCategoriesMinFields>;
};


/** aggregate fields of "record_metadata_categories" */
export type RecordMetadataCategoriesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_metadata_categories" */
export type RecordMetadataCategoriesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordMetadataCategoriesMaxOrderBy>;
  min?: InputMaybe<RecordMetadataCategoriesMinOrderBy>;
};

/** input type for inserting array relation for remote table "record_metadata_categories" */
export type RecordMetadataCategoriesArrRelInsertInput = {
  data: Array<RecordMetadataCategoriesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordMetadataCategoriesOnConflict>;
};

/** Boolean expression to filter rows from the table "record_metadata_categories". All fields are combined with a logical 'AND'. */
export type RecordMetadataCategoriesBoolExp = {
  _and?: InputMaybe<Array<RecordMetadataCategoriesBoolExp>>;
  _not?: InputMaybe<RecordMetadataCategoriesBoolExp>;
  _or?: InputMaybe<Array<RecordMetadataCategoriesBoolExp>>;
  category?: InputMaybe<CategoriesBoolExp>;
  categoryId?: InputMaybe<UuidComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  recordMetadata?: InputMaybe<RecordMetadataBoolExp>;
  recordMetadataId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_metadata_categories" */
export const RecordMetadataCategoriesConstraint = {
  /** unique or primary key constraint on columns "record_metadata_id", "category_id" */
  RecordMetadataCategoriesPkey: 'record_metadata_categories_pkey'
} as const;

export type RecordMetadataCategoriesConstraint = typeof RecordMetadataCategoriesConstraint[keyof typeof RecordMetadataCategoriesConstraint];
/** input type for inserting data into table "record_metadata_categories" */
export type RecordMetadataCategoriesInsertInput = {
  category?: InputMaybe<CategoriesObjRelInsertInput>;
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadata?: InputMaybe<RecordMetadataObjRelInsertInput>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordMetadataCategoriesMaxFields = {
  __typename?: 'RecordMetadataCategoriesMaxFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "record_metadata_categories" */
export type RecordMetadataCategoriesMaxOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordMetadataCategoriesMinFields = {
  __typename?: 'RecordMetadataCategoriesMinFields';
  categoryId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "record_metadata_categories" */
export type RecordMetadataCategoriesMinOrderBy = {
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_metadata_categories" */
export type RecordMetadataCategoriesMutationResponse = {
  __typename?: 'RecordMetadataCategoriesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordMetadataCategories>;
};

/** on_conflict condition type for table "record_metadata_categories" */
export type RecordMetadataCategoriesOnConflict = {
  constraint: RecordMetadataCategoriesConstraint;
  updateColumns?: Array<RecordMetadataCategoriesUpdateColumn>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};

/** Ordering options when selecting data from "record_metadata_categories". */
export type RecordMetadataCategoriesOrderBy = {
  category?: InputMaybe<CategoriesOrderBy>;
  categoryId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  recordMetadata?: InputMaybe<RecordMetadataOrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_metadata_categories */
export type RecordMetadataCategoriesPkColumnsInput = {
  categoryId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};

/** select columns of table "record_metadata_categories" */
export const RecordMetadataCategoriesSelectColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordMetadataCategoriesSelectColumn = typeof RecordMetadataCategoriesSelectColumn[keyof typeof RecordMetadataCategoriesSelectColumn];
/** input type for updating data in table "record_metadata_categories" */
export type RecordMetadataCategoriesSetInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_metadata_categories" */
export type RecordMetadataCategoriesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordMetadataCategoriesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordMetadataCategoriesStreamCursorValueInput = {
  categoryId?: InputMaybe<Scalars['uuid']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_metadata_categories" */
export const RecordMetadataCategoriesUpdateColumn = {
  /** column name */
  CategoryId: 'categoryId',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordMetadataCategoriesUpdateColumn = typeof RecordMetadataCategoriesUpdateColumn[keyof typeof RecordMetadataCategoriesUpdateColumn];
export type RecordMetadataCategoriesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordMetadataCategoriesSetInput>;
  /** filter the rows which have to be updated */
  where: RecordMetadataCategoriesBoolExp;
};

/** unique or primary key constraints on table "record_metadata" */
export const RecordMetadataConstraint = {
  /** unique or primary key constraint on columns "evidence_lineage_identity", "tenant_id" */
  RecordMetadataEvidenceLineageIdentityUniq: 'record_metadata_evidence_lineage_identity_uniq',
  /** unique or primary key constraint on columns "id" */
  RecordMetadataPkey: 'record_metadata_pkey',
  /** unique or primary key constraint on columns "record_id" */
  RecordMetadataRecordIdKey: 'record_metadata_record_id_key'
} as const;

export type RecordMetadataConstraint = typeof RecordMetadataConstraint[keyof typeof RecordMetadataConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecordMetadataDeleteAtPathInput = {
  data?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecordMetadataDeleteElemInput = {
  data?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecordMetadataDeleteKeyInput = {
  data?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "record_metadata" */
export type RecordMetadataIncInput = {
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "record_metadata" */
export type RecordMetadataInsertInput = {
  changeRequestItemRecordMetadata?: InputMaybe<ChangeRequestItemRecordMetadataArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceLineageIdentity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordDeactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  recordMetadataCategories?: InputMaybe<RecordMetadataCategoriesArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RecordMetadataMaxFields = {
  __typename?: 'RecordMetadataMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceLineageIdentity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  recordDeactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type RecordMetadataMinFields = {
  __typename?: 'RecordMetadataMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceLineageIdentity?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  recordDeactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "record_metadata" */
export type RecordMetadataMutationResponse = {
  __typename?: 'RecordMetadataMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordMetadata>;
};

/** input type for inserting object relation for remote table "record_metadata" */
export type RecordMetadataObjRelInsertInput = {
  data: RecordMetadataInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RecordMetadataOnConflict>;
};

/** on_conflict condition type for table "record_metadata" */
export type RecordMetadataOnConflict = {
  constraint: RecordMetadataConstraint;
  updateColumns?: Array<RecordMetadataUpdateColumn>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};

/** Ordering options when selecting data from "record_metadata". */
export type RecordMetadataOrderBy = {
  changeRequestItemRecordMetadataAggregate?: InputMaybe<ChangeRequestItemRecordMetadataAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  data?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceLineageIdentity?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordDeactivatedAt?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  recordMetadataCategoriesAggregate?: InputMaybe<RecordMetadataCategoriesAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_metadata */
export type RecordMetadataPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecordMetadataPrependInput = {
  data?: InputMaybe<Scalars['jsonb']['input']>;
};

/** columns and relationships of "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSets = {
  __typename?: 'RecordMetadataPropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsAggregate = {
  __typename?: 'RecordMetadataPropertySchemaSetsAggregate';
  aggregate?: Maybe<RecordMetadataPropertySchemaSetsAggregateFields>;
  nodes: Array<RecordMetadataPropertySchemaSets>;
};

/** aggregate fields of "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsAggregateFields = {
  __typename?: 'RecordMetadataPropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordMetadataPropertySchemaSetsMaxFields>;
  min?: Maybe<RecordMetadataPropertySchemaSetsMinFields>;
};


/** aggregate fields of "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordMetadataPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "record_metadata_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordMetadataPropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<RecordMetadataPropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<RecordMetadataPropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_metadata_property_schema_sets" */
export const RecordMetadataPropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "property_schema_set_id" */
  RecordMetadataPropertySchemaSetsPkey: 'record_metadata_property_schema_sets_pkey'
} as const;

export type RecordMetadataPropertySchemaSetsConstraint = typeof RecordMetadataPropertySchemaSetsConstraint[keyof typeof RecordMetadataPropertySchemaSetsConstraint];
/** input type for inserting data into table "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordMetadataPropertySchemaSetsMaxFields = {
  __typename?: 'RecordMetadataPropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RecordMetadataPropertySchemaSetsMinFields = {
  __typename?: 'RecordMetadataPropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsMutationResponse = {
  __typename?: 'RecordMetadataPropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordMetadataPropertySchemaSets>;
};

/** on_conflict condition type for table "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsOnConflict = {
  constraint: RecordMetadataPropertySchemaSetsConstraint;
  updateColumns?: Array<RecordMetadataPropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "record_metadata_property_schema_sets". */
export type RecordMetadataPropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_metadata_property_schema_sets */
export type RecordMetadataPropertySchemaSetsPkColumnsInput = {
  propertySchemaSetId: Scalars['uuid']['input'];
};

/** select columns of table "record_metadata_property_schema_sets" */
export const RecordMetadataPropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordMetadataPropertySchemaSetsSelectColumn = typeof RecordMetadataPropertySchemaSetsSelectColumn[keyof typeof RecordMetadataPropertySchemaSetsSelectColumn];
/** input type for updating data in table "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_metadata_property_schema_sets" */
export type RecordMetadataPropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordMetadataPropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordMetadataPropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_metadata_property_schema_sets" */
export const RecordMetadataPropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordMetadataPropertySchemaSetsUpdateColumn = typeof RecordMetadataPropertySchemaSetsUpdateColumn[keyof typeof RecordMetadataPropertySchemaSetsUpdateColumn];
export type RecordMetadataPropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordMetadataPropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordMetadataPropertySchemaSetsBoolExp;
};

export type RecordMetadataSchemaUpdateInput = {
  id: Scalars['UUID']['input'];
  propertySchemas?: InputMaybe<Array<PropertySchemaAssociationInput>>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordMetadataSchemaUpdateOutput = {
  __typename?: 'RecordMetadataSchemaUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** select columns of table "record_metadata" */
export const RecordMetadataSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Data: 'data',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceLineageIdentity: 'evidenceLineageIdentity',
  /** column name */
  Id: 'id',
  /** column name */
  RecordDeactivatedAt: 'recordDeactivatedAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type RecordMetadataSelectColumn = typeof RecordMetadataSelectColumn[keyof typeof RecordMetadataSelectColumn];
/** input type for updating data in table "record_metadata" */
export type RecordMetadataSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceLineageIdentity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recordDeactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type RecordMetadataStddevFields = {
  __typename?: 'RecordMetadataStddevFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RecordMetadataStddevPopFields = {
  __typename?: 'RecordMetadataStddevPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RecordMetadataStddevSampFields = {
  __typename?: 'RecordMetadataStddevSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "record_metadata" */
export type RecordMetadataStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordMetadataStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordMetadataStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  data?: InputMaybe<Scalars['jsonb']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceLineageIdentity?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  recordDeactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type RecordMetadataSumFields = {
  __typename?: 'RecordMetadataSumFields';
  version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "record_metadata" */
export const RecordMetadataUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Data: 'data',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceLineageIdentity: 'evidenceLineageIdentity',
  /** column name */
  Id: 'id',
  /** column name */
  RecordDeactivatedAt: 'recordDeactivatedAt',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type RecordMetadataUpdateColumn = typeof RecordMetadataUpdateColumn[keyof typeof RecordMetadataUpdateColumn];
export type RecordMetadataUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RecordMetadataAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RecordMetadataDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RecordMetadataDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RecordMetadataDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RecordMetadataIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RecordMetadataPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordMetadataSetInput>;
  /** filter the rows which have to be updated */
  where: RecordMetadataBoolExp;
};

/** aggregate varPop on columns */
export type RecordMetadataVarPopFields = {
  __typename?: 'RecordMetadataVarPopFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RecordMetadataVarSampFields = {
  __typename?: 'RecordMetadataVarSampFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RecordMetadataVarianceFields = {
  __typename?: 'RecordMetadataVarianceFields';
  version?: Maybe<Scalars['Float']['output']>;
};

/** columns and relationships of "record_property_schema_sets" */
export type RecordPropertySchemaSets = {
  __typename?: 'RecordPropertySchemaSets';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  propertySchemaSet: PropertySchemaSets;
  propertySchemaSetId: Scalars['uuid']['output'];
  /** An object relationship */
  record: Records;
  recordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "record_property_schema_sets" */
export type RecordPropertySchemaSetsAggregate = {
  __typename?: 'RecordPropertySchemaSetsAggregate';
  aggregate?: Maybe<RecordPropertySchemaSetsAggregateFields>;
  nodes: Array<RecordPropertySchemaSets>;
};

export type RecordPropertySchemaSetsAggregateBoolExp = {
  count?: InputMaybe<RecordPropertySchemaSetsAggregateBoolExpCount>;
};

/** aggregate fields of "record_property_schema_sets" */
export type RecordPropertySchemaSetsAggregateFields = {
  __typename?: 'RecordPropertySchemaSetsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordPropertySchemaSetsMaxFields>;
  min?: Maybe<RecordPropertySchemaSetsMinFields>;
};


/** aggregate fields of "record_property_schema_sets" */
export type RecordPropertySchemaSetsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "record_property_schema_sets" */
export type RecordPropertySchemaSetsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RecordPropertySchemaSetsMaxOrderBy>;
  min?: InputMaybe<RecordPropertySchemaSetsMinOrderBy>;
};

/** input type for inserting array relation for remote table "record_property_schema_sets" */
export type RecordPropertySchemaSetsArrRelInsertInput = {
  data: Array<RecordPropertySchemaSetsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RecordPropertySchemaSetsOnConflict>;
};

/** Boolean expression to filter rows from the table "record_property_schema_sets". All fields are combined with a logical 'AND'. */
export type RecordPropertySchemaSetsBoolExp = {
  _and?: InputMaybe<Array<RecordPropertySchemaSetsBoolExp>>;
  _not?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
  _or?: InputMaybe<Array<RecordPropertySchemaSetsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsBoolExp>;
  propertySchemaSetId?: InputMaybe<UuidComparisonExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "record_property_schema_sets" */
export const RecordPropertySchemaSetsConstraint = {
  /** unique or primary key constraint on columns "record_id" */
  RecordPropertySchemaSetsPkey: 'record_property_schema_sets_pkey',
  /** unique or primary key constraint on columns "property_schema_set_id" */
  RecordPropertySchemaSetsPropertySchemaSetIdKey: 'record_property_schema_sets_property_schema_set_id_key'
} as const;

export type RecordPropertySchemaSetsConstraint = typeof RecordPropertySchemaSetsConstraint[keyof typeof RecordPropertySchemaSetsConstraint];
/** input type for inserting data into table "record_property_schema_sets" */
export type RecordPropertySchemaSetsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsObjRelInsertInput>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RecordPropertySchemaSetsMaxFields = {
  __typename?: 'RecordPropertySchemaSetsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "record_property_schema_sets" */
export type RecordPropertySchemaSetsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RecordPropertySchemaSetsMinFields = {
  __typename?: 'RecordPropertySchemaSetsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  propertySchemaSetId?: Maybe<Scalars['uuid']['output']>;
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "record_property_schema_sets" */
export type RecordPropertySchemaSetsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "record_property_schema_sets" */
export type RecordPropertySchemaSetsMutationResponse = {
  __typename?: 'RecordPropertySchemaSetsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordPropertySchemaSets>;
};

/** on_conflict condition type for table "record_property_schema_sets" */
export type RecordPropertySchemaSetsOnConflict = {
  constraint: RecordPropertySchemaSetsConstraint;
  updateColumns?: Array<RecordPropertySchemaSetsUpdateColumn>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};

/** Ordering options when selecting data from "record_property_schema_sets". */
export type RecordPropertySchemaSetsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  propertySchemaSet?: InputMaybe<PropertySchemaSetsOrderBy>;
  propertySchemaSetId?: InputMaybe<OrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_property_schema_sets */
export type RecordPropertySchemaSetsPkColumnsInput = {
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "record_property_schema_sets" */
export const RecordPropertySchemaSetsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordPropertySchemaSetsSelectColumn = typeof RecordPropertySchemaSetsSelectColumn[keyof typeof RecordPropertySchemaSetsSelectColumn];
/** input type for updating data in table "record_property_schema_sets" */
export type RecordPropertySchemaSetsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "record_property_schema_sets" */
export type RecordPropertySchemaSetsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordPropertySchemaSetsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordPropertySchemaSetsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  propertySchemaSetId?: InputMaybe<Scalars['uuid']['input']>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "record_property_schema_sets" */
export const RecordPropertySchemaSetsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PropertySchemaSetId: 'propertySchemaSetId',
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RecordPropertySchemaSetsUpdateColumn = typeof RecordPropertySchemaSetsUpdateColumn[keyof typeof RecordPropertySchemaSetsUpdateColumn];
export type RecordPropertySchemaSetsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordPropertySchemaSetsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordPropertySchemaSetsBoolExp;
};

export type RecordUpdateCategoryOverrideEntryInput = {
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  composers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  to: Scalars['UUID']['input'];
};

export type RecordUpdateDirectiveExclusion = {
  __typename?: 'RecordUpdateDirectiveExclusion';
  reason: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
};

export const RecordUpdateLifecycle = {
  Deactivate: 'deactivate',
  Edit: 'edit'
} as const;

export type RecordUpdateLifecycle = typeof RecordUpdateLifecycle[keyof typeof RecordUpdateLifecycle];
export type RecordUpdateOverrideEntryInput = {
  composers?: InputMaybe<Array<Scalars['ID']['input']>>;
  entityProperties?: InputMaybe<Array<RecordUpdateOverridePropertyInput>>;
  relationProperties?: InputMaybe<Array<RecordUpdateOverridePropertyInput>>;
};

export type RecordUpdateOverridePropertyInput = {
  key: Scalars['String']['input'];
  template: Scalars['String']['input'];
};

export type RecordUpdatePreserveOnMissingEvidenceEntryInput = {
  composers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  properties: Array<Scalars['String']['input']>;
};

export type RecordUpdatePreviewCounts = {
  __typename?: 'RecordUpdatePreviewCounts';
  alreadyIdentified: Scalars['Int']['output'];
  conflict: Scalars['Int']['output'];
  toIdentify: Scalars['Int']['output'];
  unresolvable: Scalars['Int']['output'];
};

export type RecordUpdatePreviewEntry = {
  __typename?: 'RecordUpdatePreviewEntry';
  classification: Scalars['String']['output'];
  identity: Scalars['String']['output'];
  identityCategoryId: Scalars['ID']['output'];
  kind: Scalars['String']['output'];
  latestSourceEvidenceId: Scalars['ID']['output'];
  newestCommitIsManual: Scalars['Boolean']['output'];
  recordId: Scalars['ID']['output'];
  seedEvidenceId: Scalars['ID']['output'];
  selected: Scalars['Boolean']['output'];
  sourceLabel?: Maybe<Scalars['String']['output']>;
  storedIdentity?: Maybe<Scalars['String']['output']>;
  targetLabel?: Maybe<Scalars['String']['output']>;
  variantKey: Scalars['String']['output'];
};

export type RecordUpdatePreviewInput = {
  evidenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  keyRenames?: InputMaybe<Array<RecordUpdatePropertyKeyRenameInput>>;
  lifecycle?: InputMaybe<RecordUpdateLifecycle>;
  recordIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  retypes?: InputMaybe<Array<RecordUpdatePropertyRetypeInput>>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordUpdatePreviewOutput = {
  __typename?: 'RecordUpdatePreviewOutput';
  confirmationToken: Scalars['String']['output'];
  counts: RecordUpdatePreviewCounts;
  directiveExclusions?: Maybe<Array<RecordUpdateDirectiveExclusion>>;
  plannedDataSource: PlannedDataSourceShape;
  records: Array<RecordUpdatePreviewEntry>;
  renameReport?: Maybe<RecordUpdateRenameReport>;
  retypeReport?: Maybe<RecordUpdateRetypeReport>;
  unresolvable: Array<RecordUpdateUnresolvableEntry>;
  warnings: RecordUpdatePreviewWarnings;
};

export type RecordUpdatePreviewWarnings = {
  __typename?: 'RecordUpdatePreviewWarnings';
  newestCommitIsManual: Array<Scalars['ID']['output']>;
};

export type RecordUpdateProceedInput = {
  confirmationToken: Scalars['String']['input'];
  dataImportProjectId?: InputMaybe<Scalars['UUID']['input']>;
  evidenceIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  keyRenames?: InputMaybe<Array<RecordUpdatePropertyKeyRenameInput>>;
  lifecycle?: InputMaybe<RecordUpdateLifecycle>;
  recordIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  retypes?: InputMaybe<Array<RecordUpdatePropertyRetypeInput>>;
  tenantId: Scalars['UUID']['input'];
};

export type RecordUpdateProceedOutput = {
  __typename?: 'RecordUpdateProceedOutput';
  alreadyIdentifiedCount: Scalars['Int']['output'];
  batchChangeRequestsJobIds: Array<Scalars['ID']['output']>;
  batchEvidencesJobIds: Array<Scalars['ID']['output']>;
  dataImportProjectId?: Maybe<Scalars['ID']['output']>;
  dataSourceId?: Maybe<Scalars['ID']['output']>;
  unresolvableCount: Scalars['Int']['output'];
};

export type RecordUpdatePropertyKeyRenameInput = {
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  composers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  from: Scalars['String']['input'];
  to: Scalars['String']['input'];
};

export type RecordUpdatePropertyRetypeInput = {
  categories?: InputMaybe<Array<Scalars['UUID']['input']>>;
  composers?: InputMaybe<Array<Scalars['UUID']['input']>>;
  fromAttributeType?: InputMaybe<Scalars['String']['input']>;
  fromType: Scalars['String']['input'];
  key: Scalars['String']['input'];
  toAttributeType?: InputMaybe<Scalars['String']['input']>;
  toType: Scalars['String']['input'];
};

/** columns and relationships of "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitions = {
  __typename?: 'RecordUpdateRecordComposerDefinitions';
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsAggregate = {
  __typename?: 'RecordUpdateRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<RecordUpdateRecordComposerDefinitionsAggregateFields>;
  nodes: Array<RecordUpdateRecordComposerDefinitions>;
};

/** aggregate fields of "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsAggregateFields = {
  __typename?: 'RecordUpdateRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RecordUpdateRecordComposerDefinitionsMaxFields>;
  min?: Maybe<RecordUpdateRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "record_update_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RecordUpdateRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsBoolExp>>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "record_update_record_composer_definitions" */
export const RecordUpdateRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  RecordUpdateRecordComposerDefinitionsPkey: 'record_update_record_composer_definitions_pkey'
} as const;

export type RecordUpdateRecordComposerDefinitionsConstraint = typeof RecordUpdateRecordComposerDefinitionsConstraint[keyof typeof RecordUpdateRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsInsertInput = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RecordUpdateRecordComposerDefinitionsMaxFields = {
  __typename?: 'RecordUpdateRecordComposerDefinitionsMaxFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RecordUpdateRecordComposerDefinitionsMinFields = {
  __typename?: 'RecordUpdateRecordComposerDefinitionsMinFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsMutationResponse = {
  __typename?: 'RecordUpdateRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RecordUpdateRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsObjRelInsertInput = {
  data: RecordUpdateRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RecordUpdateRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsOnConflict = {
  constraint: RecordUpdateRecordComposerDefinitionsConstraint;
  updateColumns?: Array<RecordUpdateRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "record_update_record_composer_definitions". */
export type RecordUpdateRecordComposerDefinitionsOrderBy = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: record_update_record_composer_definitions */
export type RecordUpdateRecordComposerDefinitionsPkColumnsInput = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "record_update_record_composer_definitions" */
export const RecordUpdateRecordComposerDefinitionsSelectColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RecordUpdateRecordComposerDefinitionsSelectColumn = typeof RecordUpdateRecordComposerDefinitionsSelectColumn[keyof typeof RecordUpdateRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsSetInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "record_update_record_composer_definitions" */
export type RecordUpdateRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordUpdateRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordUpdateRecordComposerDefinitionsStreamCursorValueInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "record_update_record_composer_definitions" */
export const RecordUpdateRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RecordUpdateRecordComposerDefinitionsUpdateColumn = typeof RecordUpdateRecordComposerDefinitionsUpdateColumn[keyof typeof RecordUpdateRecordComposerDefinitionsUpdateColumn];
export type RecordUpdateRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordUpdateRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordUpdateRecordComposerDefinitionsBoolExp;
};

export type RecordUpdateRenameConflictEntry = {
  __typename?: 'RecordUpdateRenameConflictEntry';
  categoryId: Scalars['ID']['output'];
  from: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
  to: Scalars['String']['output'];
};

export type RecordUpdateRenameReport = {
  __typename?: 'RecordUpdateRenameReport';
  appliedCount: Scalars['Int']['output'];
  conflictCount: Scalars['Int']['output'];
  conflictedRecordIds: Array<Scalars['ID']['output']>;
  conflicts: Array<RecordUpdateRenameConflictEntry>;
};

export type RecordUpdateRetypeReport = {
  __typename?: 'RecordUpdateRetypeReport';
  convertibleCount: Scalars['Int']['output'];
  skipCount: Scalars['Int']['output'];
  skippedRecordIds: Array<Scalars['ID']['output']>;
  skips: Array<RecordUpdateRetypeSkipEntry>;
};

export type RecordUpdateRetypeSkipEntry = {
  __typename?: 'RecordUpdateRetypeSkipEntry';
  categoryId: Scalars['ID']['output'];
  key: Scalars['String']['output'];
  reason: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
};

export type RecordUpdateTarget = {
  __typename?: 'RecordUpdateTarget';
  sourceEvidenceId: Scalars['ID']['output'];
  targetRecordIds: Array<Scalars['ID']['output']>;
};

export type RecordUpdateTargetBatch = {
  __typename?: 'RecordUpdateTargetBatch';
  dataSourceId: Scalars['ID']['output'];
  status: Scalars['String']['output'];
  targets: Array<RecordUpdateTarget>;
};

export type RecordUpdateTargetsInput = {
  dataImportProjectId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RecordUpdateTargetsOutput = {
  __typename?: 'RecordUpdateTargetsOutput';
  batches: Array<RecordUpdateTargetBatch>;
  lifecycle?: Maybe<RecordUpdateLifecycle>;
};

export type RecordUpdateUnresolvableEntry = {
  __typename?: 'RecordUpdateUnresolvableEntry';
  detail?: Maybe<Scalars['String']['output']>;
  reason: Scalars['String']['output'];
  recordId: Scalars['ID']['output'];
  sourceLabel?: Maybe<Scalars['String']['output']>;
  targetLabel?: Maybe<Scalars['String']['output']>;
};

export type RecordWithEvidences = {
  __typename?: 'RecordWithEvidences';
  date?: Maybe<Scalars['String']['output']>;
  dateJDN?: Maybe<Scalars['Int']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateJDN?: Maybe<Scalars['Int']['output']>;
  evidences: Array<EvidenceCitation>;
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  recordId: Scalars['UUID']['output'];
};

/** columns and relationships of "records" */
export type Records = {
  __typename?: 'Records';
  /** An array relationship */
  changeRequestItemRecords: Array<ChangeRequestItemRecords>;
  /** An aggregate relationship */
  changeRequestItemRecordsAggregate: ChangeRequestItemRecordsAggregate;
  createdAt: Scalars['timestamptz']['output'];
  date?: Maybe<Scalars['String']['output']>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  /** An object relationship */
  entityRecord?: Maybe<EntityRecords>;
  id: Scalars['uuid']['output'];
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  properties: Scalars['jsonb']['output'];
  /** An array relationship */
  recordGeoItems: Array<RecordGeoItems>;
  /** An aggregate relationship */
  recordGeoItemsAggregate: RecordGeoItemsAggregate;
  /** An object relationship */
  recordMetadata: RecordMetadata;
  recordMetadataId: Scalars['uuid']['output'];
  /** An array relationship */
  recordPropertySchemaSets: Array<RecordPropertySchemaSets>;
  /** An aggregate relationship */
  recordPropertySchemaSetsAggregate: RecordPropertySchemaSetsAggregate;
  /** An object relationship */
  relationRecord?: Maybe<RelationRecords>;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  version: Scalars['Int']['output'];
};


/** columns and relationships of "records" */
export type RecordsChangeRequestItemRecordsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


/** columns and relationships of "records" */
export type RecordsChangeRequestItemRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


/** columns and relationships of "records" */
export type RecordsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "records" */
export type RecordsRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


/** columns and relationships of "records" */
export type RecordsRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


/** columns and relationships of "records" */
export type RecordsRecordPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


/** columns and relationships of "records" */
export type RecordsRecordPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};

/** aggregated selection of "records" */
export type RecordsAggregate = {
  __typename?: 'RecordsAggregate';
  aggregate?: Maybe<RecordsAggregateFields>;
  nodes: Array<Records>;
};

/** aggregate fields of "records" */
export type RecordsAggregateFields = {
  __typename?: 'RecordsAggregateFields';
  avg?: Maybe<RecordsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<RecordsMaxFields>;
  min?: Maybe<RecordsMinFields>;
  stddev?: Maybe<RecordsStddevFields>;
  stddevPop?: Maybe<RecordsStddevPopFields>;
  stddevSamp?: Maybe<RecordsStddevSampFields>;
  sum?: Maybe<RecordsSumFields>;
  varPop?: Maybe<RecordsVarPopFields>;
  varSamp?: Maybe<RecordsVarSampFields>;
  variance?: Maybe<RecordsVarianceFields>;
};


/** aggregate fields of "records" */
export type RecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type RecordsAppendInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate avg on columns */
export type RecordsAvgFields = {
  __typename?: 'RecordsAvgFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "records". All fields are combined with a logical 'AND'. */
export type RecordsBoolExp = {
  _and?: InputMaybe<Array<RecordsBoolExp>>;
  _not?: InputMaybe<RecordsBoolExp>;
  _or?: InputMaybe<Array<RecordsBoolExp>>;
  changeRequestItemRecords?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
  changeRequestItemRecordsAggregate?: InputMaybe<ChangeRequestItemRecordsAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  date?: InputMaybe<StringComparisonExp>;
  dateJdn?: InputMaybe<IntComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  endDate?: InputMaybe<StringComparisonExp>;
  endDateJdn?: InputMaybe<IntComparisonExp>;
  entityRecord?: InputMaybe<EntityRecordsBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  nameJa?: InputMaybe<StringComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  recordGeoItems?: InputMaybe<RecordGeoItemsBoolExp>;
  recordGeoItemsAggregate?: InputMaybe<RecordGeoItemsAggregateBoolExp>;
  recordMetadata?: InputMaybe<RecordMetadataBoolExp>;
  recordMetadataId?: InputMaybe<UuidComparisonExp>;
  recordPropertySchemaSets?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
  recordPropertySchemaSetsAggregate?: InputMaybe<RecordPropertySchemaSetsAggregateBoolExp>;
  relationRecord?: InputMaybe<RelationRecordsBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  version?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "records" */
export const RecordsConstraint = {
  /** unique or primary key constraint on columns "id" */
  RecordsPkey: 'records_pkey',
  /** unique or primary key constraint on columns "record_metadata_id" */
  RecordsRecordMetadataIdKey: 'records_record_metadata_id_key',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  RecordsTenantIdIdKey: 'records_tenant_id_id_key'
} as const;

export type RecordsConstraint = typeof RecordsConstraint[keyof typeof RecordsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type RecordsDeleteAtPathInput = {
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type RecordsDeleteElemInput = {
  properties?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type RecordsDeleteKeyInput = {
  properties?: InputMaybe<Scalars['String']['input']>;
};

/** input type for incrementing numeric columns in table "records" */
export type RecordsIncInput = {
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "records" */
export type RecordsInsertInput = {
  changeRequestItemRecords?: InputMaybe<ChangeRequestItemRecordsArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  entityRecord?: InputMaybe<EntityRecordsObjRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordGeoItems?: InputMaybe<RecordGeoItemsArrRelInsertInput>;
  recordMetadata?: InputMaybe<RecordMetadataObjRelInsertInput>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  recordPropertySchemaSets?: InputMaybe<RecordPropertySchemaSetsArrRelInsertInput>;
  relationRecord?: InputMaybe<RelationRecordsObjRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type RecordsMaxFields = {
  __typename?: 'RecordsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** aggregate min on columns */
export type RecordsMinFields = {
  __typename?: 'RecordsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  date?: Maybe<Scalars['String']['output']>;
  dateJdn?: Maybe<Scalars['Int']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  recordMetadataId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** response of any mutation on the table "records" */
export type RecordsMutationResponse = {
  __typename?: 'RecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Records>;
};

/** input type for inserting object relation for remote table "records" */
export type RecordsObjRelInsertInput = {
  data: RecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RecordsOnConflict>;
};

/** on_conflict condition type for table "records" */
export type RecordsOnConflict = {
  constraint: RecordsConstraint;
  updateColumns?: Array<RecordsUpdateColumn>;
  where?: InputMaybe<RecordsBoolExp>;
};

/** Ordering options when selecting data from "records". */
export type RecordsOrderBy = {
  changeRequestItemRecordsAggregate?: InputMaybe<ChangeRequestItemRecordsAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  date?: InputMaybe<OrderBy>;
  dateJdn?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  endDate?: InputMaybe<OrderBy>;
  endDateJdn?: InputMaybe<OrderBy>;
  entityRecord?: InputMaybe<EntityRecordsOrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  nameJa?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  recordGeoItemsAggregate?: InputMaybe<RecordGeoItemsAggregateOrderBy>;
  recordMetadata?: InputMaybe<RecordMetadataOrderBy>;
  recordMetadataId?: InputMaybe<OrderBy>;
  recordPropertySchemaSetsAggregate?: InputMaybe<RecordPropertySchemaSetsAggregateOrderBy>;
  relationRecord?: InputMaybe<RelationRecordsOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  version?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: records */
export type RecordsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type RecordsPrependInput = {
  properties?: InputMaybe<Scalars['jsonb']['input']>;
};

export type RecordsQuery = {
  metadata?: InputMaybe<JsonQueryInput>;
  properties?: InputMaybe<JsonQueryInput>;
  recordIdsFilter?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

/** select columns of table "records" */
export const RecordsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DateJdn: 'dateJdn',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  EndDateJdn: 'endDateJdn',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  NameJa: 'nameJa',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type RecordsSelectColumn = typeof RecordsSelectColumn[keyof typeof RecordsSelectColumn];
/** input type for updating data in table "records" */
export type RecordsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type RecordsStddevFields = {
  __typename?: 'RecordsStddevFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type RecordsStddevPopFields = {
  __typename?: 'RecordsStddevPopFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type RecordsStddevSampFields = {
  __typename?: 'RecordsStddevSampFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "records" */
export type RecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RecordsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  date?: InputMaybe<Scalars['String']['input']>;
  dateJdn?: InputMaybe<Scalars['Int']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  endDate?: InputMaybe<Scalars['String']['input']>;
  endDateJdn?: InputMaybe<Scalars['Int']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  nameJa?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  recordMetadataId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  version?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type RecordsSumFields = {
  __typename?: 'RecordsSumFields';
  dateJdn?: Maybe<Scalars['Int']['output']>;
  endDateJdn?: Maybe<Scalars['Int']['output']>;
  version?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "records" */
export const RecordsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Date: 'date',
  /** column name */
  DateJdn: 'dateJdn',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EndDate: 'endDate',
  /** column name */
  EndDateJdn: 'endDateJdn',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  NameJa: 'nameJa',
  /** column name */
  Properties: 'properties',
  /** column name */
  RecordMetadataId: 'recordMetadataId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Version: 'version'
} as const;

export type RecordsUpdateColumn = typeof RecordsUpdateColumn[keyof typeof RecordsUpdateColumn];
export type RecordsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<RecordsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<RecordsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<RecordsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<RecordsDeleteKeyInput>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<RecordsIncInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<RecordsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RecordsSetInput>;
  /** filter the rows which have to be updated */
  where: RecordsBoolExp;
};

/** aggregate varPop on columns */
export type RecordsVarPopFields = {
  __typename?: 'RecordsVarPopFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type RecordsVarSampFields = {
  __typename?: 'RecordsVarSampFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type RecordsVarianceFields = {
  __typename?: 'RecordsVarianceFields';
  dateJdn?: Maybe<Scalars['Float']['output']>;
  endDateJdn?: Maybe<Scalars['Float']['output']>;
  version?: Maybe<Scalars['Float']['output']>;
};

export type ReferenceActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceActivateOutput = {
  __typename?: 'ReferenceActivateOutput';
  id: Scalars['UUID']['output'];
};

export type ReferenceDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceDeactivateOutput = {
  __typename?: 'ReferenceDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type ReferenceFileEventHandleInput = {
  detailType: Scalars['String']['input'];
  inputBucket: Scalars['String']['input'];
  inputKey: Scalars['String']['input'];
  numPages?: InputMaybe<Scalars['Int']['input']>;
  outputBucket: Scalars['String']['input'];
  outputPrefix: Scalars['String']['input'];
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
  time: Scalars['DateTime']['input'];
};

export type ReferenceFileEventHandleOutput = {
  __typename?: 'ReferenceFileEventHandleOutput';
  result: Scalars['String']['output'];
};

export type ReferenceFileImagePresignedUrlInput = {
  page: Scalars['Int']['input'];
  referenceFileId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceFileImagePresignedUrlOutput = {
  __typename?: 'ReferenceFileImagePresignedUrlOutput';
  url: Scalars['String']['output'];
};

export type ReferenceFileJobSubmitInput = {
  gdriveFileId: Scalars['String']['input'];
  referenceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceFileJobSubmitOutput = {
  __typename?: 'ReferenceFileJobSubmitOutput';
  id: Scalars['UUID']['output'];
};

export type ReferenceFileUpdateInput = {
  folioOffset: Scalars['Int']['input'];
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceFileUpdateOutput = {
  __typename?: 'ReferenceFileUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type ReferenceFileUrlInput = {
  referenceFileId: Scalars['UUID']['input'];
  referenceId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ReferenceFileUrlOutput = {
  __typename?: 'ReferenceFileUrlOutput';
  url: Scalars['String']['output'];
};

/** columns and relationships of "reference_files" */
export type ReferenceFiles = {
  __typename?: 'ReferenceFiles';
  createdAt: Scalars['timestamptz']['output'];
  folioOffset?: Maybe<Scalars['Int']['output']>;
  googleDriveFileId: Scalars['String']['output'];
  googleDriveFileVersion: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  imagesCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
  imagesS3UriPrefix?: Maybe<Scalars['String']['output']>;
  latest: Scalars['Boolean']['output'];
  mimeType: Scalars['String']['output'];
  numPages?: Maybe<Scalars['Int']['output']>;
  originalFileS3Uri: Scalars['String']['output'];
  originalFileUploadedAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  reference: References;
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "reference_files" */
export type ReferenceFilesAggregate = {
  __typename?: 'ReferenceFilesAggregate';
  aggregate?: Maybe<ReferenceFilesAggregateFields>;
  nodes: Array<ReferenceFiles>;
};

export type ReferenceFilesAggregateBoolExp = {
  bool_and?: InputMaybe<ReferenceFilesAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<ReferenceFilesAggregateBoolExpBool_Or>;
  count?: InputMaybe<ReferenceFilesAggregateBoolExpCount>;
};

/** aggregate fields of "reference_files" */
export type ReferenceFilesAggregateFields = {
  __typename?: 'ReferenceFilesAggregateFields';
  avg?: Maybe<ReferenceFilesAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReferenceFilesMaxFields>;
  min?: Maybe<ReferenceFilesMinFields>;
  stddev?: Maybe<ReferenceFilesStddevFields>;
  stddevPop?: Maybe<ReferenceFilesStddevPopFields>;
  stddevSamp?: Maybe<ReferenceFilesStddevSampFields>;
  sum?: Maybe<ReferenceFilesSumFields>;
  varPop?: Maybe<ReferenceFilesVarPopFields>;
  varSamp?: Maybe<ReferenceFilesVarSampFields>;
  variance?: Maybe<ReferenceFilesVarianceFields>;
};


/** aggregate fields of "reference_files" */
export type ReferenceFilesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reference_files" */
export type ReferenceFilesAggregateOrderBy = {
  avg?: InputMaybe<ReferenceFilesAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReferenceFilesMaxOrderBy>;
  min?: InputMaybe<ReferenceFilesMinOrderBy>;
  stddev?: InputMaybe<ReferenceFilesStddevOrderBy>;
  stddevPop?: InputMaybe<ReferenceFilesStddevPopOrderBy>;
  stddevSamp?: InputMaybe<ReferenceFilesStddevSampOrderBy>;
  sum?: InputMaybe<ReferenceFilesSumOrderBy>;
  varPop?: InputMaybe<ReferenceFilesVarPopOrderBy>;
  varSamp?: InputMaybe<ReferenceFilesVarSampOrderBy>;
  variance?: InputMaybe<ReferenceFilesVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "reference_files" */
export type ReferenceFilesArrRelInsertInput = {
  data: Array<ReferenceFilesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ReferenceFilesOnConflict>;
};

/** aggregate avg on columns */
export type ReferenceFilesAvgFields = {
  __typename?: 'ReferenceFilesAvgFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "reference_files" */
export type ReferenceFilesAvgOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "reference_files". All fields are combined with a logical 'AND'. */
export type ReferenceFilesBoolExp = {
  _and?: InputMaybe<Array<ReferenceFilesBoolExp>>;
  _not?: InputMaybe<ReferenceFilesBoolExp>;
  _or?: InputMaybe<Array<ReferenceFilesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  folioOffset?: InputMaybe<IntComparisonExp>;
  googleDriveFileId?: InputMaybe<StringComparisonExp>;
  googleDriveFileVersion?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  imagesCreatedAt?: InputMaybe<TimestamptzComparisonExp>;
  imagesS3UriPrefix?: InputMaybe<StringComparisonExp>;
  latest?: InputMaybe<BooleanComparisonExp>;
  mimeType?: InputMaybe<StringComparisonExp>;
  numPages?: InputMaybe<IntComparisonExp>;
  originalFileS3Uri?: InputMaybe<StringComparisonExp>;
  originalFileUploadedAt?: InputMaybe<TimestamptzComparisonExp>;
  reference?: InputMaybe<ReferencesBoolExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "reference_files" */
export const ReferenceFilesConstraint = {
  /** unique or primary key constraint on columns "id" */
  ReferenceFilesPkey: 'reference_files_pkey',
  /** unique or primary key constraint on columns "reference_id" */
  ReferenceFilesReferenceIdLatest: 'reference_files_reference_id_latest'
} as const;

export type ReferenceFilesConstraint = typeof ReferenceFilesConstraint[keyof typeof ReferenceFilesConstraint];
/** input type for incrementing numeric columns in table "reference_files" */
export type ReferenceFilesIncInput = {
  folioOffset?: InputMaybe<Scalars['Int']['input']>;
  numPages?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "reference_files" */
export type ReferenceFilesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folioOffset?: InputMaybe<Scalars['Int']['input']>;
  googleDriveFileId?: InputMaybe<Scalars['String']['input']>;
  googleDriveFileVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagesCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  imagesS3UriPrefix?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  numPages?: InputMaybe<Scalars['Int']['input']>;
  originalFileS3Uri?: InputMaybe<Scalars['String']['input']>;
  originalFileUploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  reference?: InputMaybe<ReferencesObjRelInsertInput>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ReferenceFilesMaxFields = {
  __typename?: 'ReferenceFilesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  folioOffset?: Maybe<Scalars['Int']['output']>;
  googleDriveFileId?: Maybe<Scalars['String']['output']>;
  googleDriveFileVersion?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imagesCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
  imagesS3UriPrefix?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  numPages?: Maybe<Scalars['Int']['output']>;
  originalFileS3Uri?: Maybe<Scalars['String']['output']>;
  originalFileUploadedAt?: Maybe<Scalars['timestamptz']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "reference_files" */
export type ReferenceFilesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  folioOffset?: InputMaybe<OrderBy>;
  googleDriveFileId?: InputMaybe<OrderBy>;
  googleDriveFileVersion?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagesCreatedAt?: InputMaybe<OrderBy>;
  imagesS3UriPrefix?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
  originalFileS3Uri?: InputMaybe<OrderBy>;
  originalFileUploadedAt?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReferenceFilesMinFields = {
  __typename?: 'ReferenceFilesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  folioOffset?: Maybe<Scalars['Int']['output']>;
  googleDriveFileId?: Maybe<Scalars['String']['output']>;
  googleDriveFileVersion?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  imagesCreatedAt?: Maybe<Scalars['timestamptz']['output']>;
  imagesS3UriPrefix?: Maybe<Scalars['String']['output']>;
  mimeType?: Maybe<Scalars['String']['output']>;
  numPages?: Maybe<Scalars['Int']['output']>;
  originalFileS3Uri?: Maybe<Scalars['String']['output']>;
  originalFileUploadedAt?: Maybe<Scalars['timestamptz']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "reference_files" */
export type ReferenceFilesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  folioOffset?: InputMaybe<OrderBy>;
  googleDriveFileId?: InputMaybe<OrderBy>;
  googleDriveFileVersion?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagesCreatedAt?: InputMaybe<OrderBy>;
  imagesS3UriPrefix?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
  originalFileS3Uri?: InputMaybe<OrderBy>;
  originalFileUploadedAt?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "reference_files" */
export type ReferenceFilesMutationResponse = {
  __typename?: 'ReferenceFilesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReferenceFiles>;
};

/** on_conflict condition type for table "reference_files" */
export type ReferenceFilesOnConflict = {
  constraint: ReferenceFilesConstraint;
  updateColumns?: Array<ReferenceFilesUpdateColumn>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};

/** Ordering options when selecting data from "reference_files". */
export type ReferenceFilesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  folioOffset?: InputMaybe<OrderBy>;
  googleDriveFileId?: InputMaybe<OrderBy>;
  googleDriveFileVersion?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  imagesCreatedAt?: InputMaybe<OrderBy>;
  imagesS3UriPrefix?: InputMaybe<OrderBy>;
  latest?: InputMaybe<OrderBy>;
  mimeType?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
  originalFileS3Uri?: InputMaybe<OrderBy>;
  originalFileUploadedAt?: InputMaybe<OrderBy>;
  reference?: InputMaybe<ReferencesOrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reference_files */
export type ReferenceFilesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "reference_files" */
export const ReferenceFilesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FolioOffset: 'folioOffset',
  /** column name */
  GoogleDriveFileId: 'googleDriveFileId',
  /** column name */
  GoogleDriveFileVersion: 'googleDriveFileVersion',
  /** column name */
  Id: 'id',
  /** column name */
  ImagesCreatedAt: 'imagesCreatedAt',
  /** column name */
  ImagesS3UriPrefix: 'imagesS3UriPrefix',
  /** column name */
  Latest: 'latest',
  /** column name */
  MimeType: 'mimeType',
  /** column name */
  NumPages: 'numPages',
  /** column name */
  OriginalFileS3Uri: 'originalFileS3Uri',
  /** column name */
  OriginalFileUploadedAt: 'originalFileUploadedAt',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ReferenceFilesSelectColumn = typeof ReferenceFilesSelectColumn[keyof typeof ReferenceFilesSelectColumn];
/** select "referenceFilesAggregateBoolExpBool_andArgumentsColumns" columns of table "reference_files" */
export const ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns = {
  /** column name */
  Latest: 'latest'
} as const;

export type ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns = typeof ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns[keyof typeof ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns];
/** select "referenceFilesAggregateBoolExpBool_orArgumentsColumns" columns of table "reference_files" */
export const ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns = {
  /** column name */
  Latest: 'latest'
} as const;

export type ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns = typeof ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns[keyof typeof ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns];
/** input type for updating data in table "reference_files" */
export type ReferenceFilesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folioOffset?: InputMaybe<Scalars['Int']['input']>;
  googleDriveFileId?: InputMaybe<Scalars['String']['input']>;
  googleDriveFileVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagesCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  imagesS3UriPrefix?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  numPages?: InputMaybe<Scalars['Int']['input']>;
  originalFileS3Uri?: InputMaybe<Scalars['String']['input']>;
  originalFileUploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ReferenceFilesStddevFields = {
  __typename?: 'ReferenceFilesStddevFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "reference_files" */
export type ReferenceFilesStddevOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type ReferenceFilesStddevPopFields = {
  __typename?: 'ReferenceFilesStddevPopFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "reference_files" */
export type ReferenceFilesStddevPopOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type ReferenceFilesStddevSampFields = {
  __typename?: 'ReferenceFilesStddevSampFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "reference_files" */
export type ReferenceFilesStddevSampOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "reference_files" */
export type ReferenceFilesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReferenceFilesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferenceFilesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  folioOffset?: InputMaybe<Scalars['Int']['input']>;
  googleDriveFileId?: InputMaybe<Scalars['String']['input']>;
  googleDriveFileVersion?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  imagesCreatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  imagesS3UriPrefix?: InputMaybe<Scalars['String']['input']>;
  latest?: InputMaybe<Scalars['Boolean']['input']>;
  mimeType?: InputMaybe<Scalars['String']['input']>;
  numPages?: InputMaybe<Scalars['Int']['input']>;
  originalFileS3Uri?: InputMaybe<Scalars['String']['input']>;
  originalFileUploadedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ReferenceFilesSumFields = {
  __typename?: 'ReferenceFilesSumFields';
  folioOffset?: Maybe<Scalars['Int']['output']>;
  numPages?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "reference_files" */
export type ReferenceFilesSumOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** update columns of table "reference_files" */
export const ReferenceFilesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  FolioOffset: 'folioOffset',
  /** column name */
  GoogleDriveFileId: 'googleDriveFileId',
  /** column name */
  GoogleDriveFileVersion: 'googleDriveFileVersion',
  /** column name */
  Id: 'id',
  /** column name */
  ImagesCreatedAt: 'imagesCreatedAt',
  /** column name */
  ImagesS3UriPrefix: 'imagesS3UriPrefix',
  /** column name */
  Latest: 'latest',
  /** column name */
  MimeType: 'mimeType',
  /** column name */
  NumPages: 'numPages',
  /** column name */
  OriginalFileS3Uri: 'originalFileS3Uri',
  /** column name */
  OriginalFileUploadedAt: 'originalFileUploadedAt',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ReferenceFilesUpdateColumn = typeof ReferenceFilesUpdateColumn[keyof typeof ReferenceFilesUpdateColumn];
export type ReferenceFilesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReferenceFilesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferenceFilesSetInput>;
  /** filter the rows which have to be updated */
  where: ReferenceFilesBoolExp;
};

/** aggregate varPop on columns */
export type ReferenceFilesVarPopFields = {
  __typename?: 'ReferenceFilesVarPopFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "reference_files" */
export type ReferenceFilesVarPopOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type ReferenceFilesVarSampFields = {
  __typename?: 'ReferenceFilesVarSampFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "reference_files" */
export type ReferenceFilesVarSampOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type ReferenceFilesVarianceFields = {
  __typename?: 'ReferenceFilesVarianceFields';
  folioOffset?: Maybe<Scalars['Float']['output']>;
  numPages?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "reference_files" */
export type ReferenceFilesVarianceOrderBy = {
  folioOffset?: InputMaybe<OrderBy>;
  numPages?: InputMaybe<OrderBy>;
};

export type ReferenceInfo = {
  __typename?: 'ReferenceInfo';
  authors: Array<Scalars['String']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  isbn: Scalars['String']['output'];
  shortCode: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

/**
 * 出版社の指定。publisherId と name のどちらか一方だけを与える。
 * publisherId は既存の出版社を選ぶ。name は同名の出版社があっても別の ID で新規登録する。
 */
export type ReferencePublisherInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  publisherId?: InputMaybe<Scalars['UUID']['input']>;
};

/** columns and relationships of "reference_publishers" */
export type ReferencePublishers = {
  __typename?: 'ReferencePublishers';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  publisher?: Maybe<Publishers>;
  publisherId: Scalars['uuid']['output'];
  /** An object relationship */
  reference?: Maybe<References>;
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "reference_publishers" */
export type ReferencePublishersAggregate = {
  __typename?: 'ReferencePublishersAggregate';
  aggregate?: Maybe<ReferencePublishersAggregateFields>;
  nodes: Array<ReferencePublishers>;
};

export type ReferencePublishersAggregateBoolExp = {
  count?: InputMaybe<ReferencePublishersAggregateBoolExpCount>;
};

/** aggregate fields of "reference_publishers" */
export type ReferencePublishersAggregateFields = {
  __typename?: 'ReferencePublishersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<ReferencePublishersMaxFields>;
  min?: Maybe<ReferencePublishersMinFields>;
};


/** aggregate fields of "reference_publishers" */
export type ReferencePublishersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "reference_publishers" */
export type ReferencePublishersAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<ReferencePublishersMaxOrderBy>;
  min?: InputMaybe<ReferencePublishersMinOrderBy>;
};

/** input type for inserting array relation for remote table "reference_publishers" */
export type ReferencePublishersArrRelInsertInput = {
  data: Array<ReferencePublishersInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<ReferencePublishersOnConflict>;
};

/** Boolean expression to filter rows from the table "reference_publishers". All fields are combined with a logical 'AND'. */
export type ReferencePublishersBoolExp = {
  _and?: InputMaybe<Array<ReferencePublishersBoolExp>>;
  _not?: InputMaybe<ReferencePublishersBoolExp>;
  _or?: InputMaybe<Array<ReferencePublishersBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  publisher?: InputMaybe<PublishersBoolExp>;
  publisherId?: InputMaybe<UuidComparisonExp>;
  reference?: InputMaybe<ReferencesBoolExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "reference_publishers" */
export const ReferencePublishersConstraint = {
  /** unique or primary key constraint on columns "reference_id", "publisher_id" */
  ReferencePublishersPkey: 'reference_publishers_pkey'
} as const;

export type ReferencePublishersConstraint = typeof ReferencePublishersConstraint[keyof typeof ReferencePublishersConstraint];
/** input type for inserting data into table "reference_publishers" */
export type ReferencePublishersInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publisher?: InputMaybe<PublishersObjRelInsertInput>;
  publisherId?: InputMaybe<Scalars['uuid']['input']>;
  reference?: InputMaybe<ReferencesObjRelInsertInput>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type ReferencePublishersMaxFields = {
  __typename?: 'ReferencePublishersMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  publisherId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "reference_publishers" */
export type ReferencePublishersMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  publisherId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type ReferencePublishersMinFields = {
  __typename?: 'ReferencePublishersMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  publisherId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "reference_publishers" */
export type ReferencePublishersMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  publisherId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "reference_publishers" */
export type ReferencePublishersMutationResponse = {
  __typename?: 'ReferencePublishersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<ReferencePublishers>;
};

/** on_conflict condition type for table "reference_publishers" */
export type ReferencePublishersOnConflict = {
  constraint: ReferencePublishersConstraint;
  updateColumns?: Array<ReferencePublishersUpdateColumn>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};

/** Ordering options when selecting data from "reference_publishers". */
export type ReferencePublishersOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  publisher?: InputMaybe<PublishersOrderBy>;
  publisherId?: InputMaybe<OrderBy>;
  reference?: InputMaybe<ReferencesOrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: reference_publishers */
export type ReferencePublishersPkColumnsInput = {
  publisherId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};

/** select columns of table "reference_publishers" */
export const ReferencePublishersSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PublisherId: 'publisherId',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ReferencePublishersSelectColumn = typeof ReferencePublishersSelectColumn[keyof typeof ReferencePublishersSelectColumn];
/** input type for updating data in table "reference_publishers" */
export type ReferencePublishersSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publisherId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "reference_publishers" */
export type ReferencePublishersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReferencePublishersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferencePublishersStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  publisherId?: InputMaybe<Scalars['uuid']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "reference_publishers" */
export const ReferencePublishersUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  PublisherId: 'publisherId',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type ReferencePublishersUpdateColumn = typeof ReferencePublishersUpdateColumn[keyof typeof ReferencePublishersUpdateColumn];
export type ReferencePublishersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferencePublishersSetInput>;
  /** filter the rows which have to be updated */
  where: ReferencePublishersBoolExp;
};

export type ReferenceUpsertInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  /**
   * 版表示。"第3版" "改訂新版" など自由文字列。
   * 省略すると変更しない（null を送ると消える）。
   */
  edition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isbn: Scalars['String']['input'];
  /**
   * 出版日。YYYY / YYYY-MM / YYYY-MM-DD のいずれか。奥付が「1985年」までしか書いていない
   * 文献があるので、分かっている精度だけを送る。省略すると変更しない（null を送ると消える）。
   */
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  /**
   * 出版社。既存の出版社は ID で選び、名前を指定すると同名の出版社があっても新規作成する。更新は全置換。
   * 省略すると変更しない（[] を送ると紐付けが消える）。
   */
  publishers?: InputMaybe<Array<ReferencePublisherInput>>;
  shortCode: Scalars['String']['input'];
  tenantId: Scalars['UUID']['input'];
  title: Scalars['String']['input'];
};

export type ReferenceUpsertOutput = {
  __typename?: 'ReferenceUpsertOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "references" */
export type References = {
  __typename?: 'References';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  createdAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  dataSourceReferences: Array<DataSourceReferences>;
  /** An aggregate relationship */
  dataSourceReferencesAggregate: DataSourceReferencesAggregate;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  edition?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  id: Scalars['uuid']['output'];
  isbn: Scalars['String']['output'];
  publishedDate?: Maybe<Scalars['String']['output']>;
  /** An array relationship */
  referenceFiles: Array<ReferenceFiles>;
  /** An aggregate relationship */
  referenceFilesAggregate: ReferenceFilesAggregate;
  /** An array relationship */
  referencePublishers: Array<ReferencePublishers>;
  /** An aggregate relationship */
  referencePublishersAggregate: ReferencePublishersAggregate;
  seq: Scalars['Int']['output'];
  shortCode: Scalars['String']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  title: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "references" */
export type ReferencesDataSourceReferencesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesDataSourceReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesReferenceFilesArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesReferenceFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesReferencePublishersArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


/** columns and relationships of "references" */
export type ReferencesReferencePublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};

/** aggregated selection of "references" */
export type ReferencesAggregate = {
  __typename?: 'ReferencesAggregate';
  aggregate?: Maybe<ReferencesAggregateFields>;
  nodes: Array<References>;
};

/** aggregate fields of "references" */
export type ReferencesAggregateFields = {
  __typename?: 'ReferencesAggregateFields';
  avg?: Maybe<ReferencesAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<ReferencesMaxFields>;
  min?: Maybe<ReferencesMinFields>;
  stddev?: Maybe<ReferencesStddevFields>;
  stddevPop?: Maybe<ReferencesStddevPopFields>;
  stddevSamp?: Maybe<ReferencesStddevSampFields>;
  sum?: Maybe<ReferencesSumFields>;
  varPop?: Maybe<ReferencesVarPopFields>;
  varSamp?: Maybe<ReferencesVarSampFields>;
  variance?: Maybe<ReferencesVarianceFields>;
};


/** aggregate fields of "references" */
export type ReferencesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<ReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type ReferencesAvgFields = {
  __typename?: 'ReferencesAvgFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "references". All fields are combined with a logical 'AND'. */
export type ReferencesBoolExp = {
  _and?: InputMaybe<Array<ReferencesBoolExp>>;
  _not?: InputMaybe<ReferencesBoolExp>;
  _or?: InputMaybe<Array<ReferencesBoolExp>>;
  authors?: InputMaybe<StringArrayComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSourceReferences?: InputMaybe<DataSourceReferencesBoolExp>;
  dataSourceReferencesAggregate?: InputMaybe<DataSourceReferencesAggregateBoolExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  documentUrl?: InputMaybe<StringComparisonExp>;
  edition?: InputMaybe<StringComparisonExp>;
  evidences?: InputMaybe<EvidencesBoolExp>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateBoolExp>;
  id?: InputMaybe<UuidComparisonExp>;
  isbn?: InputMaybe<StringComparisonExp>;
  publishedDate?: InputMaybe<StringComparisonExp>;
  referenceFiles?: InputMaybe<ReferenceFilesBoolExp>;
  referenceFilesAggregate?: InputMaybe<ReferenceFilesAggregateBoolExp>;
  referencePublishers?: InputMaybe<ReferencePublishersBoolExp>;
  referencePublishersAggregate?: InputMaybe<ReferencePublishersAggregateBoolExp>;
  seq?: InputMaybe<IntComparisonExp>;
  shortCode?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  title?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "references" */
export const ReferencesConstraint = {
  /** unique or primary key constraint on columns "id" */
  ReferencesPkey: 'references_pkey',
  /** unique or primary key constraint on columns "seq" */
  ReferencesSeqKey: 'references_seq_key',
  /** unique or primary key constraint on columns "id", "tenant_id" */
  ReferencesTenantIdIdKey: 'references_tenant_id_id_key',
  /** unique or primary key constraint on columns "isbn", "tenant_id" */
  ReferencesTenantIdIsbnKey: 'references_tenant_id_isbn_key',
  /** unique or primary key constraint on columns "short_code", "tenant_id" */
  ReferencesTenantIdShortCodeKey: 'references_tenant_id_short_code_key'
} as const;

export type ReferencesConstraint = typeof ReferencesConstraint[keyof typeof ReferencesConstraint];
/** input type for incrementing numeric columns in table "references" */
export type ReferencesIncInput = {
  seq?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "references" */
export type ReferencesInsertInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceReferences?: InputMaybe<DataSourceReferencesArrRelInsertInput>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  evidences?: InputMaybe<EvidencesArrRelInsertInput>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  referenceFiles?: InputMaybe<ReferenceFilesArrRelInsertInput>;
  referencePublishers?: InputMaybe<ReferencePublishersArrRelInsertInput>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type ReferencesMaxFields = {
  __typename?: 'ReferencesMaxFields';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  edition?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type ReferencesMinFields = {
  __typename?: 'ReferencesMinFields';
  authors?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  documentUrl?: Maybe<Scalars['String']['output']>;
  edition?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  isbn?: Maybe<Scalars['String']['output']>;
  publishedDate?: Maybe<Scalars['String']['output']>;
  seq?: Maybe<Scalars['Int']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "references" */
export type ReferencesMutationResponse = {
  __typename?: 'ReferencesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<References>;
};

/** input type for inserting object relation for remote table "references" */
export type ReferencesObjRelInsertInput = {
  data: ReferencesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<ReferencesOnConflict>;
};

/** on_conflict condition type for table "references" */
export type ReferencesOnConflict = {
  constraint: ReferencesConstraint;
  updateColumns?: Array<ReferencesUpdateColumn>;
  where?: InputMaybe<ReferencesBoolExp>;
};

/** Ordering options when selecting data from "references". */
export type ReferencesOrderBy = {
  authors?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataSourceReferencesAggregate?: InputMaybe<DataSourceReferencesAggregateOrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  documentUrl?: InputMaybe<OrderBy>;
  edition?: InputMaybe<OrderBy>;
  evidencesAggregate?: InputMaybe<EvidencesAggregateOrderBy>;
  id?: InputMaybe<OrderBy>;
  isbn?: InputMaybe<OrderBy>;
  publishedDate?: InputMaybe<OrderBy>;
  referenceFilesAggregate?: InputMaybe<ReferenceFilesAggregateOrderBy>;
  referencePublishersAggregate?: InputMaybe<ReferencePublishersAggregateOrderBy>;
  seq?: InputMaybe<OrderBy>;
  shortCode?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  title?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: references */
export type ReferencesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "references" */
export const ReferencesSelectColumn = {
  /** column name */
  Authors: 'authors',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  Edition: 'edition',
  /** column name */
  Id: 'id',
  /** column name */
  Isbn: 'isbn',
  /** column name */
  PublishedDate: 'publishedDate',
  /** column name */
  Seq: 'seq',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ReferencesSelectColumn = typeof ReferencesSelectColumn[keyof typeof ReferencesSelectColumn];
/** input type for updating data in table "references" */
export type ReferencesSetInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type ReferencesStddevFields = {
  __typename?: 'ReferencesStddevFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type ReferencesStddevPopFields = {
  __typename?: 'ReferencesStddevPopFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type ReferencesStddevSampFields = {
  __typename?: 'ReferencesStddevSampFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "references" */
export type ReferencesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: ReferencesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type ReferencesStreamCursorValueInput = {
  authors?: InputMaybe<Array<Scalars['String']['input']>>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  documentUrl?: InputMaybe<Scalars['String']['input']>;
  edition?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  isbn?: InputMaybe<Scalars['String']['input']>;
  publishedDate?: InputMaybe<Scalars['String']['input']>;
  seq?: InputMaybe<Scalars['Int']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type ReferencesSumFields = {
  __typename?: 'ReferencesSumFields';
  seq?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "references" */
export const ReferencesUpdateColumn = {
  /** column name */
  Authors: 'authors',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  DocumentUrl: 'documentUrl',
  /** column name */
  Edition: 'edition',
  /** column name */
  Id: 'id',
  /** column name */
  Isbn: 'isbn',
  /** column name */
  PublishedDate: 'publishedDate',
  /** column name */
  Seq: 'seq',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  Title: 'title',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type ReferencesUpdateColumn = typeof ReferencesUpdateColumn[keyof typeof ReferencesUpdateColumn];
export type ReferencesUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<ReferencesIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<ReferencesSetInput>;
  /** filter the rows which have to be updated */
  where: ReferencesBoolExp;
};

/** aggregate varPop on columns */
export type ReferencesVarPopFields = {
  __typename?: 'ReferencesVarPopFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type ReferencesVarSampFields = {
  __typename?: 'ReferencesVarSampFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type ReferencesVarianceFields = {
  __typename?: 'ReferencesVarianceFields';
  seq?: Maybe<Scalars['Float']['output']>;
};

export type RelationMappingInput = {
  categoryId: Scalars['UUID']['input'];
  evidenceSelector?: InputMaybe<ImportDirectEvidenceSelectorInput>;
  fkResolver: SetupDataImportJobsSchemaMappingForeignKeyResolver;
  type: RelationMappingType;
  variantKey?: InputMaybe<Scalars['String']['input']>;
};

export const RelationMappingType = {
  RelationSource: 'RELATION_SOURCE',
  RelationTarget: 'RELATION_TARGET'
} as const;

export type RelationMappingType = typeof RelationMappingType[keyof typeof RelationMappingType];
/** columns and relationships of "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitions = {
  __typename?: 'RelationRecordComposerDefinitions';
  /** An object relationship */
  recordComposerDefinition: RecordComposerDefinitions;
  recordComposerDefinitionId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsAggregate = {
  __typename?: 'RelationRecordComposerDefinitionsAggregate';
  aggregate?: Maybe<RelationRecordComposerDefinitionsAggregateFields>;
  nodes: Array<RelationRecordComposerDefinitions>;
};

/** aggregate fields of "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsAggregateFields = {
  __typename?: 'RelationRecordComposerDefinitionsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RelationRecordComposerDefinitionsMaxFields>;
  min?: Maybe<RelationRecordComposerDefinitionsMinFields>;
};


/** aggregate fields of "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RelationRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "relation_record_composer_definitions". All fields are combined with a logical 'AND'. */
export type RelationRecordComposerDefinitionsBoolExp = {
  _and?: InputMaybe<Array<RelationRecordComposerDefinitionsBoolExp>>;
  _not?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
  _or?: InputMaybe<Array<RelationRecordComposerDefinitionsBoolExp>>;
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsBoolExp>;
  recordComposerDefinitionId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "relation_record_composer_definitions" */
export const RelationRecordComposerDefinitionsConstraint = {
  /** unique or primary key constraint on columns "record_composer_definition_id" */
  RelationRecordComposerDefinitionsPkey: 'relation_record_composer_definitions_pkey'
} as const;

export type RelationRecordComposerDefinitionsConstraint = typeof RelationRecordComposerDefinitionsConstraint[keyof typeof RelationRecordComposerDefinitionsConstraint];
/** input type for inserting data into table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsInsertInput = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsObjRelInsertInput>;
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RelationRecordComposerDefinitionsMaxFields = {
  __typename?: 'RelationRecordComposerDefinitionsMaxFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RelationRecordComposerDefinitionsMinFields = {
  __typename?: 'RelationRecordComposerDefinitionsMinFields';
  recordComposerDefinitionId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsMutationResponse = {
  __typename?: 'RelationRecordComposerDefinitionsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationRecordComposerDefinitions>;
};

/** input type for inserting object relation for remote table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsObjRelInsertInput = {
  data: RelationRecordComposerDefinitionsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RelationRecordComposerDefinitionsOnConflict>;
};

/** on_conflict condition type for table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsOnConflict = {
  constraint: RelationRecordComposerDefinitionsConstraint;
  updateColumns?: Array<RelationRecordComposerDefinitionsUpdateColumn>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};

/** Ordering options when selecting data from "relation_record_composer_definitions". */
export type RelationRecordComposerDefinitionsOrderBy = {
  recordComposerDefinition?: InputMaybe<RecordComposerDefinitionsOrderBy>;
  recordComposerDefinitionId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: relation_record_composer_definitions */
export type RelationRecordComposerDefinitionsPkColumnsInput = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};

/** select columns of table "relation_record_composer_definitions" */
export const RelationRecordComposerDefinitionsSelectColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RelationRecordComposerDefinitionsSelectColumn = typeof RelationRecordComposerDefinitionsSelectColumn[keyof typeof RelationRecordComposerDefinitionsSelectColumn];
/** input type for updating data in table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsSetInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "relation_record_composer_definitions" */
export type RelationRecordComposerDefinitionsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RelationRecordComposerDefinitionsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationRecordComposerDefinitionsStreamCursorValueInput = {
  recordComposerDefinitionId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "relation_record_composer_definitions" */
export const RelationRecordComposerDefinitionsUpdateColumn = {
  /** column name */
  RecordComposerDefinitionId: 'recordComposerDefinitionId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RelationRecordComposerDefinitionsUpdateColumn = typeof RelationRecordComposerDefinitionsUpdateColumn[keyof typeof RelationRecordComposerDefinitionsUpdateColumn];
export type RelationRecordComposerDefinitionsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationRecordComposerDefinitionsSetInput>;
  /** filter the rows which have to be updated */
  where: RelationRecordComposerDefinitionsBoolExp;
};

/** columns and relationships of "relation_records" */
export type RelationRecords = {
  __typename?: 'RelationRecords';
  /** An object relationship */
  firstSourceRecordEdge?: Maybe<SourceRecordEdges>;
  /** An object relationship */
  firstTargetRecordEdge?: Maybe<TargetRecordEdges>;
  /** An object relationship */
  record: Records;
  recordId: Scalars['uuid']['output'];
  /** An array relationship */
  sourceRecordEdges: Array<SourceRecordEdges>;
  /** An aggregate relationship */
  sourceRecordEdgesAggregate: SourceRecordEdgesAggregate;
  /** An array relationship */
  targetRecordEdges: Array<TargetRecordEdges>;
  /** An aggregate relationship */
  targetRecordEdgesAggregate: TargetRecordEdgesAggregate;
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};


/** columns and relationships of "relation_records" */
export type RelationRecordsSourceRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


/** columns and relationships of "relation_records" */
export type RelationRecordsSourceRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


/** columns and relationships of "relation_records" */
export type RelationRecordsTargetRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


/** columns and relationships of "relation_records" */
export type RelationRecordsTargetRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};

/** aggregated selection of "relation_records" */
export type RelationRecordsAggregate = {
  __typename?: 'RelationRecordsAggregate';
  aggregate?: Maybe<RelationRecordsAggregateFields>;
  nodes: Array<RelationRecords>;
};

/** aggregate fields of "relation_records" */
export type RelationRecordsAggregateFields = {
  __typename?: 'RelationRecordsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RelationRecordsMaxFields>;
  min?: Maybe<RelationRecordsMinFields>;
};


/** aggregate fields of "relation_records" */
export type RelationRecordsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RelationRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "relation_records". All fields are combined with a logical 'AND'. */
export type RelationRecordsBoolExp = {
  _and?: InputMaybe<Array<RelationRecordsBoolExp>>;
  _not?: InputMaybe<RelationRecordsBoolExp>;
  _or?: InputMaybe<Array<RelationRecordsBoolExp>>;
  firstSourceRecordEdge?: InputMaybe<SourceRecordEdgesBoolExp>;
  firstTargetRecordEdge?: InputMaybe<TargetRecordEdgesBoolExp>;
  record?: InputMaybe<RecordsBoolExp>;
  recordId?: InputMaybe<UuidComparisonExp>;
  sourceRecordEdges?: InputMaybe<SourceRecordEdgesBoolExp>;
  sourceRecordEdgesAggregate?: InputMaybe<SourceRecordEdgesAggregateBoolExp>;
  targetRecordEdges?: InputMaybe<TargetRecordEdgesBoolExp>;
  targetRecordEdgesAggregate?: InputMaybe<TargetRecordEdgesAggregateBoolExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "relation_records" */
export const RelationRecordsConstraint = {
  /** unique or primary key constraint on columns "record_id" */
  RelationRecordsPkey: 'relation_records_pkey'
} as const;

export type RelationRecordsConstraint = typeof RelationRecordsConstraint[keyof typeof RelationRecordsConstraint];
/** input type for inserting data into table "relation_records" */
export type RelationRecordsInsertInput = {
  firstSourceRecordEdge?: InputMaybe<SourceRecordEdgesObjRelInsertInput>;
  firstTargetRecordEdge?: InputMaybe<TargetRecordEdgesObjRelInsertInput>;
  record?: InputMaybe<RecordsObjRelInsertInput>;
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  sourceRecordEdges?: InputMaybe<SourceRecordEdgesArrRelInsertInput>;
  targetRecordEdges?: InputMaybe<TargetRecordEdgesArrRelInsertInput>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type RelationRecordsMaxFields = {
  __typename?: 'RelationRecordsMaxFields';
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** aggregate min on columns */
export type RelationRecordsMinFields = {
  __typename?: 'RelationRecordsMinFields';
  recordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** response of any mutation on the table "relation_records" */
export type RelationRecordsMutationResponse = {
  __typename?: 'RelationRecordsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationRecords>;
};

/** input type for inserting object relation for remote table "relation_records" */
export type RelationRecordsObjRelInsertInput = {
  data: RelationRecordsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RelationRecordsOnConflict>;
};

/** on_conflict condition type for table "relation_records" */
export type RelationRecordsOnConflict = {
  constraint: RelationRecordsConstraint;
  updateColumns?: Array<RelationRecordsUpdateColumn>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};

/** Ordering options when selecting data from "relation_records". */
export type RelationRecordsOrderBy = {
  firstSourceRecordEdge?: InputMaybe<SourceRecordEdgesOrderBy>;
  firstTargetRecordEdge?: InputMaybe<TargetRecordEdgesOrderBy>;
  record?: InputMaybe<RecordsOrderBy>;
  recordId?: InputMaybe<OrderBy>;
  sourceRecordEdgesAggregate?: InputMaybe<SourceRecordEdgesAggregateOrderBy>;
  targetRecordEdgesAggregate?: InputMaybe<TargetRecordEdgesAggregateOrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: relation_records */
export type RelationRecordsPkColumnsInput = {
  recordId: Scalars['uuid']['input'];
};

/** select columns of table "relation_records" */
export const RelationRecordsSelectColumn = {
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RelationRecordsSelectColumn = typeof RelationRecordsSelectColumn[keyof typeof RelationRecordsSelectColumn];
/** input type for updating data in table "relation_records" */
export type RelationRecordsSetInput = {
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "relation_records" */
export type RelationRecordsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RelationRecordsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationRecordsStreamCursorValueInput = {
  recordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "relation_records" */
export const RelationRecordsUpdateColumn = {
  /** column name */
  RecordId: 'recordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type RelationRecordsUpdateColumn = typeof RelationRecordsUpdateColumn[keyof typeof RelationRecordsUpdateColumn];
export type RelationRecordsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationRecordsSetInput>;
  /** filter the rows which have to be updated */
  where: RelationRecordsBoolExp;
};

export type RelationTypeActivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RelationTypeActivateOutput = {
  __typename?: 'RelationTypeActivateOutput';
  id: Scalars['UUID']['output'];
};

export type RelationTypeDeactivateInput = {
  id: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RelationTypeDeactivateOutput = {
  __typename?: 'RelationTypeDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type RelationTypeUpsertInput = {
  id?: InputMaybe<Scalars['UUID']['input']>;
  name: Scalars['String']['input'];
  sourceCategoryId: Scalars['UUID']['input'];
  targetCategoryId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RelationTypeUpsertOutput = {
  __typename?: 'RelationTypeUpsertOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "relation_types" */
export type RelationTypes = {
  __typename?: 'RelationTypes';
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categoriesAggregate: CategoriesAggregate;
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  sourceCategory: Categories;
  sourceCategoryId: Scalars['uuid']['output'];
  /** An object relationship */
  targetCategory: Categories;
  targetCategoryId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};


/** columns and relationships of "relation_types" */
export type RelationTypesCategoriesArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


/** columns and relationships of "relation_types" */
export type RelationTypesCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};

/** aggregated selection of "relation_types" */
export type RelationTypesAggregate = {
  __typename?: 'RelationTypesAggregate';
  aggregate?: Maybe<RelationTypesAggregateFields>;
  nodes: Array<RelationTypes>;
};

export type RelationTypesAggregateBoolExp = {
  count?: InputMaybe<RelationTypesAggregateBoolExpCount>;
};

/** aggregate fields of "relation_types" */
export type RelationTypesAggregateFields = {
  __typename?: 'RelationTypesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RelationTypesMaxFields>;
  min?: Maybe<RelationTypesMinFields>;
};


/** aggregate fields of "relation_types" */
export type RelationTypesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RelationTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "relation_types" */
export type RelationTypesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<RelationTypesMaxOrderBy>;
  min?: InputMaybe<RelationTypesMinOrderBy>;
};

/** input type for inserting array relation for remote table "relation_types" */
export type RelationTypesArrRelInsertInput = {
  data: Array<RelationTypesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<RelationTypesOnConflict>;
};

/** Boolean expression to filter rows from the table "relation_types". All fields are combined with a logical 'AND'. */
export type RelationTypesBoolExp = {
  _and?: InputMaybe<Array<RelationTypesBoolExp>>;
  _not?: InputMaybe<RelationTypesBoolExp>;
  _or?: InputMaybe<Array<RelationTypesBoolExp>>;
  categories?: InputMaybe<CategoriesBoolExp>;
  categoriesAggregate?: InputMaybe<CategoriesAggregateBoolExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  sourceCategory?: InputMaybe<CategoriesBoolExp>;
  sourceCategoryId?: InputMaybe<UuidComparisonExp>;
  targetCategory?: InputMaybe<CategoriesBoolExp>;
  targetCategoryId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "relation_types" */
export const RelationTypesConstraint = {
  /** unique or primary key constraint on columns "name" */
  RelationTypesNameKey: 'relation_types_name_key',
  /** unique or primary key constraint on columns "id" */
  RelationTypesPkey: 'relation_types_pkey',
  /** unique or primary key constraint on columns "target_category_id", "source_category_id" */
  RelationTypesSourceCategoryIdTargetCategoryIdKey: 'relation_types_source_category_id_target_category_id_key'
} as const;

export type RelationTypesConstraint = typeof RelationTypesConstraint[keyof typeof RelationTypesConstraint];
/** input type for inserting data into table "relation_types" */
export type RelationTypesInsertInput = {
  categories?: InputMaybe<CategoriesArrRelInsertInput>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceCategory?: InputMaybe<CategoriesObjRelInsertInput>;
  sourceCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  targetCategory?: InputMaybe<CategoriesObjRelInsertInput>;
  targetCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type RelationTypesMaxFields = {
  __typename?: 'RelationTypesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceCategoryId?: Maybe<Scalars['uuid']['output']>;
  targetCategoryId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "relation_types" */
export type RelationTypesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sourceCategoryId?: InputMaybe<OrderBy>;
  targetCategoryId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type RelationTypesMinFields = {
  __typename?: 'RelationTypesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  sourceCategoryId?: Maybe<Scalars['uuid']['output']>;
  targetCategoryId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "relation_types" */
export type RelationTypesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sourceCategoryId?: InputMaybe<OrderBy>;
  targetCategoryId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "relation_types" */
export type RelationTypesMutationResponse = {
  __typename?: 'RelationTypesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<RelationTypes>;
};

/** input type for inserting object relation for remote table "relation_types" */
export type RelationTypesObjRelInsertInput = {
  data: RelationTypesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RelationTypesOnConflict>;
};

/** on_conflict condition type for table "relation_types" */
export type RelationTypesOnConflict = {
  constraint: RelationTypesConstraint;
  updateColumns?: Array<RelationTypesUpdateColumn>;
  where?: InputMaybe<RelationTypesBoolExp>;
};

/** Ordering options when selecting data from "relation_types". */
export type RelationTypesOrderBy = {
  categoriesAggregate?: InputMaybe<CategoriesAggregateOrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  sourceCategory?: InputMaybe<CategoriesOrderBy>;
  sourceCategoryId?: InputMaybe<OrderBy>;
  targetCategory?: InputMaybe<CategoriesOrderBy>;
  targetCategoryId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: relation_types */
export type RelationTypesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "relation_types" */
export const RelationTypesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SourceCategoryId: 'sourceCategoryId',
  /** column name */
  TargetCategoryId: 'targetCategoryId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RelationTypesSelectColumn = typeof RelationTypesSelectColumn[keyof typeof RelationTypesSelectColumn];
/** input type for updating data in table "relation_types" */
export type RelationTypesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  targetCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "relation_types" */
export type RelationTypesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RelationTypesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RelationTypesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  sourceCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  targetCategoryId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "relation_types" */
export const RelationTypesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  SourceCategoryId: 'sourceCategoryId',
  /** column name */
  TargetCategoryId: 'targetCategoryId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RelationTypesUpdateColumn = typeof RelationTypesUpdateColumn[keyof typeof RelationTypesUpdateColumn];
export type RelationTypesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RelationTypesSetInput>;
  /** filter the rows which have to be updated */
  where: RelationTypesBoolExp;
};

export type RerunWorkerJobInput = {
  dryRun: Scalars['Boolean']['input'];
  jobId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type RerunWorkerJobOutput = {
  __typename?: 'RerunWorkerJobOutput';
  jobId: Scalars['UUID']['output'];
  jobRunId: Scalars['UUID']['output'];
};

export type RerunWorkerJobResponse = RerunWorkerJobOutput | ValidationError;

/** columns and relationships of "roles" */
export type Roles = {
  __typename?: 'Roles';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProductRoles: Array<UserProductRoles>;
  /** An aggregate relationship */
  userProductRolesAggregate: UserProductRolesAggregate;
};


/** columns and relationships of "roles" */
export type RolesUserProductRolesArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


/** columns and relationships of "roles" */
export type RolesUserProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};

/** aggregated selection of "roles" */
export type RolesAggregate = {
  __typename?: 'RolesAggregate';
  aggregate?: Maybe<RolesAggregateFields>;
  nodes: Array<Roles>;
};

/** aggregate fields of "roles" */
export type RolesAggregateFields = {
  __typename?: 'RolesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<RolesMaxFields>;
  min?: Maybe<RolesMinFields>;
};


/** aggregate fields of "roles" */
export type RolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<RolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "roles". All fields are combined with a logical 'AND'. */
export type RolesBoolExp = {
  _and?: InputMaybe<Array<RolesBoolExp>>;
  _not?: InputMaybe<RolesBoolExp>;
  _or?: InputMaybe<Array<RolesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userProductRoles?: InputMaybe<UserProductRolesBoolExp>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateBoolExp>;
};

/** unique or primary key constraints on table "roles" */
export const RolesConstraint = {
  /** unique or primary key constraint on columns "name" */
  RolesNameKey: 'roles_name_key',
  /** unique or primary key constraint on columns "id" */
  RolesPkey: 'roles_pkey',
  /** unique or primary key constraint on columns "name" */
  UserRolesNameKey: 'user_roles_name_key'
} as const;

export type RolesConstraint = typeof RolesConstraint[keyof typeof RolesConstraint];
/** input type for inserting data into table "roles" */
export type RolesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProductRoles?: InputMaybe<UserProductRolesArrRelInsertInput>;
};

/** aggregate max on columns */
export type RolesMaxFields = {
  __typename?: 'RolesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type RolesMinFields = {
  __typename?: 'RolesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "roles" */
export type RolesMutationResponse = {
  __typename?: 'RolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Roles>;
};

/** input type for inserting object relation for remote table "roles" */
export type RolesObjRelInsertInput = {
  data: RolesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<RolesOnConflict>;
};

/** on_conflict condition type for table "roles" */
export type RolesOnConflict = {
  constraint: RolesConstraint;
  updateColumns?: Array<RolesUpdateColumn>;
  where?: InputMaybe<RolesBoolExp>;
};

/** Ordering options when selecting data from "roles". */
export type RolesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateOrderBy>;
};

/** primary key columns input for table: roles */
export type RolesPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "roles" */
export const RolesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RolesSelectColumn = typeof RolesSelectColumn[keyof typeof RolesSelectColumn];
/** input type for updating data in table "roles" */
export type RolesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "roles" */
export type RolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: RolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type RolesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "roles" */
export const RolesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type RolesUpdateColumn = typeof RolesUpdateColumn[keyof typeof RolesUpdateColumn];
export type RolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<RolesSetInput>;
  /** filter the rows which have to be updated */
  where: RolesBoolExp;
};

export type RunBatchChangeRequestReviewsJobInput = {
  batchChangeRequestsJobId: Scalars['UUID']['input'];
  batchChangeRequestsJobRunId?: InputMaybe<Scalars['UUID']['input']>;
  changeRequestIds?: InputMaybe<Array<Scalars['UUID']['input']>>;
  comment?: InputMaybe<Scalars['String']['input']>;
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  tenantId: Scalars['UUID']['input'];
  type: ChangeRequestReviewType;
};

export type SearchEntitiesInput = {
  category: Scalars['String']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  properties: Array<Scalars['String']['input']>;
  query: Scalars['String']['input'];
  size?: InputMaybe<Scalars['Int']['input']>;
  tenantId: Scalars['UUID']['input'];
};

export type SearchEntitiesOutput = {
  __typename?: 'SearchEntitiesOutput';
  items: Array<SearchEntityItem>;
};

export type SearchEntityItem = {
  __typename?: 'SearchEntityItem';
  date?: Maybe<Scalars['String']['output']>;
  endDate?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  metadata?: Maybe<Scalars['JSONObject']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  nameJa?: Maybe<Scalars['String']['output']>;
  properties?: Maybe<Scalars['JSONObject']['output']>;
};

export type SetupDataImportJobsSchemaMappingForeignKeyConstraint = {
  fkColumnLabel: Scalars['String']['input'];
  linkedCategoryName: Scalars['String']['input'];
  linkedInstanceLabel: Scalars['String']['input'];
};

export type SetupDataImportJobsSchemaMappingForeignKeyQuery = {
  categoryNames?: InputMaybe<Array<Scalars['String']['input']>>;
  evidenceIdsFilter?: InputMaybe<Array<Scalars['UUID']['input']>>;
  evidenceMetadata?: InputMaybe<JsonQueryInput>;
  evidenceProperties?: InputMaybe<JsonQueryInput>;
  or?: InputMaybe<Array<SetupDataImportJobsSchemaMappingForeignKeyQuery>>;
  recordId?: InputMaybe<Scalars['UUID']['input']>;
  recordMetadata?: InputMaybe<JsonQueryInput>;
  recordProperties?: InputMaybe<JsonQueryInput>;
  referenceIdsFilter?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type SetupDataImportJobsSchemaMappingForeignKeyResolver = {
  fkConstraint?: InputMaybe<SetupDataImportJobsSchemaMappingForeignKeyConstraint>;
  query: SetupDataImportJobsSchemaMappingForeignKeyQuery;
};

export const SetupDataImportJobsSchemaMappingType = {
  Properties: 'PROPERTIES',
  RelationSource: 'RELATION_SOURCE',
  RelationTarget: 'RELATION_TARGET'
} as const;

export type SetupDataImportJobsSchemaMappingType = typeof SetupDataImportJobsSchemaMappingType[keyof typeof SetupDataImportJobsSchemaMappingType];
export type SheetInfo = {
  __typename?: 'SheetInfo';
  sheetId: Scalars['Int']['output'];
  sheetName: Scalars['String']['output'];
};

/** columns and relationships of "source_record_edges" */
export type SourceRecordEdges = {
  __typename?: 'SourceRecordEdges';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  entity?: Maybe<Records>;
  /** An object relationship */
  entityRecord: EntityRecords;
  entityRecordId: Scalars['uuid']['output'];
  /** An object relationship */
  relation?: Maybe<Records>;
  /** An object relationship */
  relationRecord: RelationRecords;
  relationRecordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "source_record_edges" */
export type SourceRecordEdgesAggregate = {
  __typename?: 'SourceRecordEdgesAggregate';
  aggregate?: Maybe<SourceRecordEdgesAggregateFields>;
  nodes: Array<SourceRecordEdges>;
};

export type SourceRecordEdgesAggregateBoolExp = {
  count?: InputMaybe<SourceRecordEdgesAggregateBoolExpCount>;
};

/** aggregate fields of "source_record_edges" */
export type SourceRecordEdgesAggregateFields = {
  __typename?: 'SourceRecordEdgesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<SourceRecordEdgesMaxFields>;
  min?: Maybe<SourceRecordEdgesMinFields>;
};


/** aggregate fields of "source_record_edges" */
export type SourceRecordEdgesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "source_record_edges" */
export type SourceRecordEdgesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<SourceRecordEdgesMaxOrderBy>;
  min?: InputMaybe<SourceRecordEdgesMinOrderBy>;
};

/** input type for inserting array relation for remote table "source_record_edges" */
export type SourceRecordEdgesArrRelInsertInput = {
  data: Array<SourceRecordEdgesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<SourceRecordEdgesOnConflict>;
};

/** Boolean expression to filter rows from the table "source_record_edges". All fields are combined with a logical 'AND'. */
export type SourceRecordEdgesBoolExp = {
  _and?: InputMaybe<Array<SourceRecordEdgesBoolExp>>;
  _not?: InputMaybe<SourceRecordEdgesBoolExp>;
  _or?: InputMaybe<Array<SourceRecordEdgesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entity?: InputMaybe<RecordsBoolExp>;
  entityRecord?: InputMaybe<EntityRecordsBoolExp>;
  entityRecordId?: InputMaybe<UuidComparisonExp>;
  relation?: InputMaybe<RecordsBoolExp>;
  relationRecord?: InputMaybe<RelationRecordsBoolExp>;
  relationRecordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "source_record_edges" */
export const SourceRecordEdgesConstraint = {
  /** unique or primary key constraint on columns "relation_record_id", "entity_record_id" */
  SourceRecordEdgesPkey: 'source_record_edges_pkey'
} as const;

export type SourceRecordEdgesConstraint = typeof SourceRecordEdgesConstraint[keyof typeof SourceRecordEdgesConstraint];
/** input type for inserting data into table "source_record_edges" */
export type SourceRecordEdgesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entity?: InputMaybe<RecordsObjRelInsertInput>;
  entityRecord?: InputMaybe<EntityRecordsObjRelInsertInput>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relation?: InputMaybe<RecordsObjRelInsertInput>;
  relationRecord?: InputMaybe<RelationRecordsObjRelInsertInput>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type SourceRecordEdgesMaxFields = {
  __typename?: 'SourceRecordEdgesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityRecordId?: Maybe<Scalars['uuid']['output']>;
  relationRecordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "source_record_edges" */
export type SourceRecordEdgesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type SourceRecordEdgesMinFields = {
  __typename?: 'SourceRecordEdgesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityRecordId?: Maybe<Scalars['uuid']['output']>;
  relationRecordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "source_record_edges" */
export type SourceRecordEdgesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "source_record_edges" */
export type SourceRecordEdgesMutationResponse = {
  __typename?: 'SourceRecordEdgesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<SourceRecordEdges>;
};

/** input type for inserting object relation for remote table "source_record_edges" */
export type SourceRecordEdgesObjRelInsertInput = {
  data: SourceRecordEdgesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<SourceRecordEdgesOnConflict>;
};

/** on_conflict condition type for table "source_record_edges" */
export type SourceRecordEdgesOnConflict = {
  constraint: SourceRecordEdgesConstraint;
  updateColumns?: Array<SourceRecordEdgesUpdateColumn>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};

/** Ordering options when selecting data from "source_record_edges". */
export type SourceRecordEdgesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entity?: InputMaybe<RecordsOrderBy>;
  entityRecord?: InputMaybe<EntityRecordsOrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relation?: InputMaybe<RecordsOrderBy>;
  relationRecord?: InputMaybe<RelationRecordsOrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: source_record_edges */
export type SourceRecordEdgesPkColumnsInput = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};

/** select columns of table "source_record_edges" */
export const SourceRecordEdgesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EntityRecordId: 'entityRecordId',
  /** column name */
  RelationRecordId: 'relationRecordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type SourceRecordEdgesSelectColumn = typeof SourceRecordEdgesSelectColumn[keyof typeof SourceRecordEdgesSelectColumn];
/** input type for updating data in table "source_record_edges" */
export type SourceRecordEdgesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "source_record_edges" */
export type SourceRecordEdgesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: SourceRecordEdgesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type SourceRecordEdgesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "source_record_edges" */
export const SourceRecordEdgesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EntityRecordId: 'entityRecordId',
  /** column name */
  RelationRecordId: 'relationRecordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type SourceRecordEdgesUpdateColumn = typeof SourceRecordEdgesUpdateColumn[keyof typeof SourceRecordEdgesUpdateColumn];
export type SourceRecordEdgesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<SourceRecordEdgesSetInput>;
  /** filter the rows which have to be updated */
  where: SourceRecordEdgesBoolExp;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']['input']>>;
  _eq?: InputMaybe<Array<Scalars['String']['input']>>;
  _gt?: InputMaybe<Array<Scalars['String']['input']>>;
  _gte?: InputMaybe<Array<Scalars['String']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['String']['input']>>;
  _lte?: InputMaybe<Array<Scalars['String']['input']>>;
  _neq?: InputMaybe<Array<Scalars['String']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']['input']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type StringComparisonExp = {
  _eq?: InputMaybe<Scalars['String']['input']>;
  _gt?: InputMaybe<Scalars['String']['input']>;
  _gte?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']['input']>;
  _in?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']['input']>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']['input']>;
  _lt?: InputMaybe<Scalars['String']['input']>;
  _lte?: InputMaybe<Scalars['String']['input']>;
  _neq?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']['input']>;
  _nin?: InputMaybe<Array<Scalars['String']['input']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']['input']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']['input']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']['input']>;
};

/** columns and relationships of "target_record_edges" */
export type TargetRecordEdges = {
  __typename?: 'TargetRecordEdges';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  entity?: Maybe<Records>;
  /** An object relationship */
  entityRecord: EntityRecords;
  entityRecordId: Scalars['uuid']['output'];
  /** An object relationship */
  relation?: Maybe<Records>;
  /** An object relationship */
  relationRecord: RelationRecords;
  relationRecordId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
};

/** aggregated selection of "target_record_edges" */
export type TargetRecordEdgesAggregate = {
  __typename?: 'TargetRecordEdgesAggregate';
  aggregate?: Maybe<TargetRecordEdgesAggregateFields>;
  nodes: Array<TargetRecordEdges>;
};

export type TargetRecordEdgesAggregateBoolExp = {
  count?: InputMaybe<TargetRecordEdgesAggregateBoolExpCount>;
};

/** aggregate fields of "target_record_edges" */
export type TargetRecordEdgesAggregateFields = {
  __typename?: 'TargetRecordEdgesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TargetRecordEdgesMaxFields>;
  min?: Maybe<TargetRecordEdgesMinFields>;
};


/** aggregate fields of "target_record_edges" */
export type TargetRecordEdgesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "target_record_edges" */
export type TargetRecordEdgesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TargetRecordEdgesMaxOrderBy>;
  min?: InputMaybe<TargetRecordEdgesMinOrderBy>;
};

/** input type for inserting array relation for remote table "target_record_edges" */
export type TargetRecordEdgesArrRelInsertInput = {
  data: Array<TargetRecordEdgesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TargetRecordEdgesOnConflict>;
};

/** Boolean expression to filter rows from the table "target_record_edges". All fields are combined with a logical 'AND'. */
export type TargetRecordEdgesBoolExp = {
  _and?: InputMaybe<Array<TargetRecordEdgesBoolExp>>;
  _not?: InputMaybe<TargetRecordEdgesBoolExp>;
  _or?: InputMaybe<Array<TargetRecordEdgesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  entity?: InputMaybe<RecordsBoolExp>;
  entityRecord?: InputMaybe<EntityRecordsBoolExp>;
  entityRecordId?: InputMaybe<UuidComparisonExp>;
  relation?: InputMaybe<RecordsBoolExp>;
  relationRecord?: InputMaybe<RelationRecordsBoolExp>;
  relationRecordId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "target_record_edges" */
export const TargetRecordEdgesConstraint = {
  /** unique or primary key constraint on columns "relation_record_id", "entity_record_id" */
  TargetRecordEdgesPkey: 'target_record_edges_pkey'
} as const;

export type TargetRecordEdgesConstraint = typeof TargetRecordEdgesConstraint[keyof typeof TargetRecordEdgesConstraint];
/** input type for inserting data into table "target_record_edges" */
export type TargetRecordEdgesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entity?: InputMaybe<RecordsObjRelInsertInput>;
  entityRecord?: InputMaybe<EntityRecordsObjRelInsertInput>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relation?: InputMaybe<RecordsObjRelInsertInput>;
  relationRecord?: InputMaybe<RelationRecordsObjRelInsertInput>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type TargetRecordEdgesMaxFields = {
  __typename?: 'TargetRecordEdgesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityRecordId?: Maybe<Scalars['uuid']['output']>;
  relationRecordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "target_record_edges" */
export type TargetRecordEdgesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TargetRecordEdgesMinFields = {
  __typename?: 'TargetRecordEdgesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  entityRecordId?: Maybe<Scalars['uuid']['output']>;
  relationRecordId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "target_record_edges" */
export type TargetRecordEdgesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "target_record_edges" */
export type TargetRecordEdgesMutationResponse = {
  __typename?: 'TargetRecordEdgesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TargetRecordEdges>;
};

/** input type for inserting object relation for remote table "target_record_edges" */
export type TargetRecordEdgesObjRelInsertInput = {
  data: TargetRecordEdgesInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TargetRecordEdgesOnConflict>;
};

/** on_conflict condition type for table "target_record_edges" */
export type TargetRecordEdgesOnConflict = {
  constraint: TargetRecordEdgesConstraint;
  updateColumns?: Array<TargetRecordEdgesUpdateColumn>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};

/** Ordering options when selecting data from "target_record_edges". */
export type TargetRecordEdgesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  entity?: InputMaybe<RecordsOrderBy>;
  entityRecord?: InputMaybe<EntityRecordsOrderBy>;
  entityRecordId?: InputMaybe<OrderBy>;
  relation?: InputMaybe<RecordsOrderBy>;
  relationRecord?: InputMaybe<RelationRecordsOrderBy>;
  relationRecordId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: target_record_edges */
export type TargetRecordEdgesPkColumnsInput = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};

/** select columns of table "target_record_edges" */
export const TargetRecordEdgesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EntityRecordId: 'entityRecordId',
  /** column name */
  RelationRecordId: 'relationRecordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type TargetRecordEdgesSelectColumn = typeof TargetRecordEdgesSelectColumn[keyof typeof TargetRecordEdgesSelectColumn];
/** input type for updating data in table "target_record_edges" */
export type TargetRecordEdgesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "target_record_edges" */
export type TargetRecordEdgesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TargetRecordEdgesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TargetRecordEdgesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  entityRecordId?: InputMaybe<Scalars['uuid']['input']>;
  relationRecordId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "target_record_edges" */
export const TargetRecordEdgesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  EntityRecordId: 'entityRecordId',
  /** column name */
  RelationRecordId: 'relationRecordId',
  /** column name */
  TenantId: 'tenantId'
} as const;

export type TargetRecordEdgesUpdateColumn = typeof TargetRecordEdgesUpdateColumn[keyof typeof TargetRecordEdgesUpdateColumn];
export type TargetRecordEdgesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TargetRecordEdgesSetInput>;
  /** filter the rows which have to be updated */
  where: TargetRecordEdgesBoolExp;
};

export type TenantActivateInput = {
  id: Scalars['UUID']['input'];
};

export type TenantActivateOutput = {
  __typename?: 'TenantActivateOutput';
  id: Scalars['UUID']['output'];
};

export type TenantActivateResponse = TenantActivateOutput | ValidationError;

export type TenantAddMembersInput = {
  id: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};

export type TenantAddMembersOutput = {
  __typename?: 'TenantAddMembersOutput';
  id: Scalars['UUID']['output'];
};

export type TenantAddMembersResponse = TenantAddMembersOutput | ValidationError;

export type TenantAddProductMembersInput = {
  id: Scalars['UUID']['input'];
  members: Array<TenantProductMemberAccessInput>;
  productId: Scalars['UUID']['input'];
};

export type TenantCreateInput = {
  allowAutoApproveChangeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  name: Scalars['String']['input'];
  shortCode: Scalars['String']['input'];
};

export type TenantCreateOutput = {
  __typename?: 'TenantCreateOutput';
  id: Scalars['UUID']['output'];
};

export type TenantCreateResponse = TenantCreateOutput | ValidationError;

export type TenantDeactivateInput = {
  id: Scalars['UUID']['input'];
};

export type TenantDeactivateOutput = {
  __typename?: 'TenantDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type TenantDeactivateResponse = TenantDeactivateOutput | ValidationError;

export type TenantInstallProductInput = {
  id: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
  visibility?: InputMaybe<TenantProductVisibility>;
};

export type TenantInstallProductOutput = {
  __typename?: 'TenantInstallProductOutput';
  id: Scalars['UUID']['output'];
};

export type TenantInstallProductResponse = TenantInstallProductOutput | ValidationError;

export type TenantMemberPhoto = {
  __typename?: 'TenantMemberPhoto';
  photoUrl: Scalars['String']['output'];
  userId: Scalars['UUID']['output'];
};

export type TenantMemberPhotosInput = {
  tenantId: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};

export type TenantMemberPhotosOutput = {
  __typename?: 'TenantMemberPhotosOutput';
  users: Array<TenantMemberPhoto>;
};

export const TenantMembershipRole = {
  Manager: 'manager',
  Member: 'member'
} as const;

export type TenantMembershipRole = typeof TenantMembershipRole[keyof typeof TenantMembershipRole];
/** columns and relationships of "tenant_product_installations" */
export type TenantProductInstallations = {
  __typename?: 'TenantProductInstallations';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['uuid']['output'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  visibility: Scalars['String']['output'];
};

/** aggregated selection of "tenant_product_installations" */
export type TenantProductInstallationsAggregate = {
  __typename?: 'TenantProductInstallationsAggregate';
  aggregate?: Maybe<TenantProductInstallationsAggregateFields>;
  nodes: Array<TenantProductInstallations>;
};

export type TenantProductInstallationsAggregateBoolExp = {
  count?: InputMaybe<TenantProductInstallationsAggregateBoolExpCount>;
};

/** aggregate fields of "tenant_product_installations" */
export type TenantProductInstallationsAggregateFields = {
  __typename?: 'TenantProductInstallationsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TenantProductInstallationsMaxFields>;
  min?: Maybe<TenantProductInstallationsMinFields>;
};


/** aggregate fields of "tenant_product_installations" */
export type TenantProductInstallationsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenant_product_installations" */
export type TenantProductInstallationsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TenantProductInstallationsMaxOrderBy>;
  min?: InputMaybe<TenantProductInstallationsMinOrderBy>;
};

/** input type for inserting array relation for remote table "tenant_product_installations" */
export type TenantProductInstallationsArrRelInsertInput = {
  data: Array<TenantProductInstallationsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TenantProductInstallationsOnConflict>;
};

/** Boolean expression to filter rows from the table "tenant_product_installations". All fields are combined with a logical 'AND'. */
export type TenantProductInstallationsBoolExp = {
  _and?: InputMaybe<Array<TenantProductInstallationsBoolExp>>;
  _not?: InputMaybe<TenantProductInstallationsBoolExp>;
  _or?: InputMaybe<Array<TenantProductInstallationsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  product?: InputMaybe<ProductsBoolExp>;
  productId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  visibility?: InputMaybe<StringComparisonExp>;
};

/** unique or primary key constraints on table "tenant_product_installations" */
export const TenantProductInstallationsConstraint = {
  /** unique or primary key constraint on columns "id" */
  TenantProductInstallationsPkey: 'tenant_product_installations_pkey',
  /** unique or primary key constraint on columns "product_id", "tenant_id" */
  TenantProductInstallationsTenantIdProductIdKey: 'tenant_product_installations_tenant_id_product_id_key'
} as const;

export type TenantProductInstallationsConstraint = typeof TenantProductInstallationsConstraint[keyof typeof TenantProductInstallationsConstraint];
/** input type for inserting data into table "tenant_product_installations" */
export type TenantProductInstallationsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  product?: InputMaybe<ProductsObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** aggregate max on columns */
export type TenantProductInstallationsMaxFields = {
  __typename?: 'TenantProductInstallationsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by max() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visibility?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TenantProductInstallationsMinFields = {
  __typename?: 'TenantProductInstallationsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  visibility?: Maybe<Scalars['String']['output']>;
};

/** order by min() on columns of table "tenant_product_installations" */
export type TenantProductInstallationsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visibility?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tenant_product_installations" */
export type TenantProductInstallationsMutationResponse = {
  __typename?: 'TenantProductInstallationsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<TenantProductInstallations>;
};

/** on_conflict condition type for table "tenant_product_installations" */
export type TenantProductInstallationsOnConflict = {
  constraint: TenantProductInstallationsConstraint;
  updateColumns?: Array<TenantProductInstallationsUpdateColumn>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};

/** Ordering options when selecting data from "tenant_product_installations". */
export type TenantProductInstallationsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  product?: InputMaybe<ProductsOrderBy>;
  productId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  visibility?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: tenant_product_installations */
export type TenantProductInstallationsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenant_product_installations" */
export const TenantProductInstallationsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ProductId: 'productId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Visibility: 'visibility'
} as const;

export type TenantProductInstallationsSelectColumn = typeof TenantProductInstallationsSelectColumn[keyof typeof TenantProductInstallationsSelectColumn];
/** input type for updating data in table "tenant_product_installations" */
export type TenantProductInstallationsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** Streaming cursor of the table "tenant_product_installations" */
export type TenantProductInstallationsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TenantProductInstallationsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantProductInstallationsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  visibility?: InputMaybe<Scalars['String']['input']>;
};

/** update columns of table "tenant_product_installations" */
export const TenantProductInstallationsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  ProductId: 'productId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  Visibility: 'visibility'
} as const;

export type TenantProductInstallationsUpdateColumn = typeof TenantProductInstallationsUpdateColumn[keyof typeof TenantProductInstallationsUpdateColumn];
export type TenantProductInstallationsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantProductInstallationsSetInput>;
  /** filter the rows which have to be updated */
  where: TenantProductInstallationsBoolExp;
};

export type TenantProductMemberAccessInput = {
  membershipRole: TenantMembershipRole;
  productRole: TenantProductMemberRole;
  userId: Scalars['UUID']['input'];
};

export type TenantProductMemberAccessOutput = {
  __typename?: 'TenantProductMemberAccessOutput';
  id: Scalars['UUID']['output'];
};

export type TenantProductMemberAccessResponse = TenantProductMemberAccessOutput | ValidationError;

/** Product roles assignable through Ranga's member-management API. */
export const TenantProductMemberRole = {
  Admin: 'admin',
  Editor: 'editor',
  Viewer: 'viewer'
} as const;

export type TenantProductMemberRole = typeof TenantProductMemberRole[keyof typeof TenantProductMemberRole];
export const TenantProductVisibility = {
  Authenticated: 'authenticated',
  Organization: 'organization',
  Private: 'private'
} as const;

export type TenantProductVisibility = typeof TenantProductVisibility[keyof typeof TenantProductVisibility];
export type TenantRemoveMembersInput = {
  id: Scalars['UUID']['input'];
  userIds: Array<Scalars['UUID']['input']>;
};

export type TenantRemoveMembersOutput = {
  __typename?: 'TenantRemoveMembersOutput';
  id: Scalars['UUID']['output'];
};

export type TenantRemoveMembersResponse = TenantRemoveMembersOutput | ValidationError;

export type TenantRemoveProductMemberAccessInput = {
  id: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
  userId: Scalars['UUID']['input'];
};

export type TenantUpdateInput = {
  allowAutoApproveChangeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type TenantUpdateMemberRoleInput = {
  id: Scalars['UUID']['input'];
  role: TenantMembershipRole;
  userId: Scalars['UUID']['input'];
};

export type TenantUpdateMemberRoleOutput = {
  __typename?: 'TenantUpdateMemberRoleOutput';
  id: Scalars['UUID']['output'];
};

export type TenantUpdateMemberRoleResponse = TenantUpdateMemberRoleOutput | ValidationError;

export type TenantUpdateOutput = {
  __typename?: 'TenantUpdateOutput';
  id: Scalars['UUID']['output'];
};

export type TenantUpdateOwnerInput = {
  id: Scalars['UUID']['input'];
  ownerUserId: Scalars['UUID']['input'];
};

export type TenantUpdateOwnerOutput = {
  __typename?: 'TenantUpdateOwnerOutput';
  id: Scalars['UUID']['output'];
};

export type TenantUpdateOwnerResponse = TenantUpdateOwnerOutput | ValidationError;

export type TenantUpdateProductMemberAccessInput = {
  id: Scalars['UUID']['input'];
  member: TenantProductMemberAccessInput;
  productId: Scalars['UUID']['input'];
};

export type TenantUpdateProductVisibilityInput = {
  id: Scalars['UUID']['input'];
  productId: Scalars['UUID']['input'];
  visibility: TenantProductVisibility;
};

export type TenantUpdateProductVisibilityOutput = {
  __typename?: 'TenantUpdateProductVisibilityOutput';
  id: Scalars['UUID']['output'];
};

export type TenantUpdateProductVisibilityResponse = TenantUpdateProductVisibilityOutput | ValidationError;

export type TenantUpdateResponse = TenantUpdateOutput | ValidationError;

/** columns and relationships of "tenants" */
export type Tenants = {
  __typename?: 'Tenants';
  allowAutoApproveChangeRequests: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
  /** An object relationship */
  ownerUser: Users;
  ownerUserId: Scalars['uuid']['output'];
  shortCode: Scalars['String']['output'];
  /** An array relationship */
  tenantProductInstallations: Array<TenantProductInstallations>;
  /** An aggregate relationship */
  tenantProductInstallationsAggregate: TenantProductInstallationsAggregate;
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
};


/** columns and relationships of "tenants" */
export type TenantsTenantProductInstallationsArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsTenantProductInstallationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


/** columns and relationships of "tenants" */
export type TenantsUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};

/** aggregated selection of "tenants" */
export type TenantsAggregate = {
  __typename?: 'TenantsAggregate';
  aggregate?: Maybe<TenantsAggregateFields>;
  nodes: Array<Tenants>;
};

export type TenantsAggregateBoolExp = {
  bool_and?: InputMaybe<TenantsAggregateBoolExpBool_And>;
  bool_or?: InputMaybe<TenantsAggregateBoolExpBool_Or>;
  count?: InputMaybe<TenantsAggregateBoolExpCount>;
};

/** aggregate fields of "tenants" */
export type TenantsAggregateFields = {
  __typename?: 'TenantsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<TenantsMaxFields>;
  min?: Maybe<TenantsMinFields>;
};


/** aggregate fields of "tenants" */
export type TenantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<TenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "tenants" */
export type TenantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<TenantsMaxOrderBy>;
  min?: InputMaybe<TenantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "tenants" */
export type TenantsArrRelInsertInput = {
  data: Array<TenantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<TenantsOnConflict>;
};

/** Boolean expression to filter rows from the table "tenants". All fields are combined with a logical 'AND'. */
export type TenantsBoolExp = {
  _and?: InputMaybe<Array<TenantsBoolExp>>;
  _not?: InputMaybe<TenantsBoolExp>;
  _or?: InputMaybe<Array<TenantsBoolExp>>;
  allowAutoApproveChangeRequests?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  ownerUser?: InputMaybe<UsersBoolExp>;
  ownerUserId?: InputMaybe<UuidComparisonExp>;
  shortCode?: InputMaybe<StringComparisonExp>;
  tenantProductInstallations?: InputMaybe<TenantProductInstallationsBoolExp>;
  tenantProductInstallationsAggregate?: InputMaybe<TenantProductInstallationsAggregateBoolExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userTenants?: InputMaybe<UserTenantsBoolExp>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateBoolExp>;
};

/** unique or primary key constraints on table "tenants" */
export const TenantsConstraint = {
  /** unique or primary key constraint on columns "id", "organization_id" */
  TenantsIdOrganizationIdKey: 'tenants_id_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  TenantsPkey: 'tenants_pkey',
  /** unique or primary key constraint on columns "short_code" */
  TenantsShortCodeKey: 'tenants_short_code_key'
} as const;

export type TenantsConstraint = typeof TenantsConstraint[keyof typeof TenantsConstraint];
/** input type for inserting data into table "tenants" */
export type TenantsInsertInput = {
  allowAutoApproveChangeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  ownerUser?: InputMaybe<UsersObjRelInsertInput>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  tenantProductInstallations?: InputMaybe<TenantProductInstallationsArrRelInsertInput>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userTenants?: InputMaybe<UserTenantsArrRelInsertInput>;
};

/** aggregate max on columns */
export type TenantsMaxFields = {
  __typename?: 'TenantsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  ownerUserId?: Maybe<Scalars['uuid']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by max() on columns of table "tenants" */
export type TenantsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  shortCode?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type TenantsMinFields = {
  __typename?: 'TenantsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  ownerUserId?: Maybe<Scalars['uuid']['output']>;
  shortCode?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** order by min() on columns of table "tenants" */
export type TenantsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  shortCode?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "tenants" */
export type TenantsMutationResponse = {
  __typename?: 'TenantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Tenants>;
};

/** input type for inserting object relation for remote table "tenants" */
export type TenantsObjRelInsertInput = {
  data: TenantsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<TenantsOnConflict>;
};

/** on_conflict condition type for table "tenants" */
export type TenantsOnConflict = {
  constraint: TenantsConstraint;
  updateColumns?: Array<TenantsUpdateColumn>;
  where?: InputMaybe<TenantsBoolExp>;
};

/** Ordering options when selecting data from "tenants". */
export type TenantsOrderBy = {
  allowAutoApproveChangeRequests?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  ownerUser?: InputMaybe<UsersOrderBy>;
  ownerUserId?: InputMaybe<OrderBy>;
  shortCode?: InputMaybe<OrderBy>;
  tenantProductInstallationsAggregate?: InputMaybe<TenantProductInstallationsAggregateOrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateOrderBy>;
};

/** primary key columns input for table: tenants */
export type TenantsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "tenants" */
export const TenantsSelectColumn = {
  /** column name */
  AllowAutoApproveChangeRequests: 'allowAutoApproveChangeRequests',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  OwnerUserId: 'ownerUserId',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type TenantsSelectColumn = typeof TenantsSelectColumn[keyof typeof TenantsSelectColumn];
/** select "tenantsAggregateBoolExpBool_andArgumentsColumns" columns of table "tenants" */
export const TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns = {
  /** column name */
  AllowAutoApproveChangeRequests: 'allowAutoApproveChangeRequests'
} as const;

export type TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns = typeof TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns[keyof typeof TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns];
/** select "tenantsAggregateBoolExpBool_orArgumentsColumns" columns of table "tenants" */
export const TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns = {
  /** column name */
  AllowAutoApproveChangeRequests: 'allowAutoApproveChangeRequests'
} as const;

export type TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns = typeof TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns[keyof typeof TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns];
/** input type for updating data in table "tenants" */
export type TenantsSetInput = {
  allowAutoApproveChangeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "tenants" */
export type TenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: TenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type TenantsStreamCursorValueInput = {
  allowAutoApproveChangeRequests?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  ownerUserId?: InputMaybe<Scalars['uuid']['input']>;
  shortCode?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "tenants" */
export const TenantsUpdateColumn = {
  /** column name */
  AllowAutoApproveChangeRequests: 'allowAutoApproveChangeRequests',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  OwnerUserId: 'ownerUserId',
  /** column name */
  ShortCode: 'shortCode',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type TenantsUpdateColumn = typeof TenantsUpdateColumn[keyof typeof TenantsUpdateColumn];
export type TenantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<TenantsSetInput>;
  /** filter the rows which have to be updated */
  where: TenantsBoolExp;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type TimestampComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamp']['input']>;
  _gt?: InputMaybe<Scalars['timestamp']['input']>;
  _gte?: InputMaybe<Scalars['timestamp']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamp']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamp']['input']>;
  _lte?: InputMaybe<Scalars['timestamp']['input']>;
  _neq?: InputMaybe<Scalars['timestamp']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']['input']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type TimestamptzComparisonExp = {
  _eq?: InputMaybe<Scalars['timestamptz']['input']>;
  _gt?: InputMaybe<Scalars['timestamptz']['input']>;
  _gte?: InputMaybe<Scalars['timestamptz']['input']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['timestamptz']['input']>;
  _lte?: InputMaybe<Scalars['timestamptz']['input']>;
  _neq?: InputMaybe<Scalars['timestamptz']['input']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']['input']>>;
};

/** columns and relationships of "unified_evidence_drafts" */
export type UnifiedEvidenceDrafts = {
  __typename?: 'UnifiedEvidenceDrafts';
  /** An object relationship */
  batchEvidencesJob: BatchEvidencesJobs;
  batchEvidencesJobId: Scalars['uuid']['output'];
  citation: Scalars['jsonb']['output'];
  createdAt: Scalars['timestamptz']['output'];
  dataSourceId: Scalars['uuid']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId: Scalars['uuid']['output'];
  evidenceImporterId: Scalars['uuid']['output'];
  evidenceSetId: Scalars['uuid']['output'];
  id: Scalars['uuid']['output'];
  metadata: Scalars['jsonb']['output'];
  parentEvidenceId?: Maybe<Scalars['uuid']['output']>;
  /** An object relationship */
  parentEvidenceVersion?: Maybe<EvidenceVersions>;
  parentEvidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  properties: Scalars['jsonb']['output'];
  referenceId: Scalars['uuid']['output'];
  /** An object relationship */
  tenant: Tenants;
  tenantId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  wikipedia?: Maybe<Scalars['jsonb']['output']>;
};


/** columns and relationships of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsCitationArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMetadataArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsPropertiesArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};


/** columns and relationships of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsWikipediaArgs = {
  path?: InputMaybe<Scalars['String']['input']>;
};

/** aggregated selection of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsAggregate = {
  __typename?: 'UnifiedEvidenceDraftsAggregate';
  aggregate?: Maybe<UnifiedEvidenceDraftsAggregateFields>;
  nodes: Array<UnifiedEvidenceDrafts>;
};

export type UnifiedEvidenceDraftsAggregateBoolExp = {
  count?: InputMaybe<UnifiedEvidenceDraftsAggregateBoolExpCount>;
};

/** aggregate fields of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsAggregateFields = {
  __typename?: 'UnifiedEvidenceDraftsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UnifiedEvidenceDraftsMaxFields>;
  min?: Maybe<UnifiedEvidenceDraftsMinFields>;
};


/** aggregate fields of "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UnifiedEvidenceDraftsMaxOrderBy>;
  min?: InputMaybe<UnifiedEvidenceDraftsMinOrderBy>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type UnifiedEvidenceDraftsAppendInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipedia?: InputMaybe<Scalars['jsonb']['input']>;
};

/** input type for inserting array relation for remote table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsArrRelInsertInput = {
  data: Array<UnifiedEvidenceDraftsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UnifiedEvidenceDraftsOnConflict>;
};

/** Boolean expression to filter rows from the table "unified_evidence_drafts". All fields are combined with a logical 'AND'. */
export type UnifiedEvidenceDraftsBoolExp = {
  _and?: InputMaybe<Array<UnifiedEvidenceDraftsBoolExp>>;
  _not?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
  _or?: InputMaybe<Array<UnifiedEvidenceDraftsBoolExp>>;
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsBoolExp>;
  batchEvidencesJobId?: InputMaybe<UuidComparisonExp>;
  citation?: InputMaybe<JsonbComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  dataSourceId?: InputMaybe<UuidComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  evidenceId?: InputMaybe<UuidComparisonExp>;
  evidenceImporterId?: InputMaybe<UuidComparisonExp>;
  evidenceSetId?: InputMaybe<UuidComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  metadata?: InputMaybe<JsonbComparisonExp>;
  parentEvidenceId?: InputMaybe<UuidComparisonExp>;
  parentEvidenceVersion?: InputMaybe<EvidenceVersionsBoolExp>;
  parentEvidenceVersionId?: InputMaybe<UuidComparisonExp>;
  properties?: InputMaybe<JsonbComparisonExp>;
  referenceId?: InputMaybe<UuidComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  wikipedia?: InputMaybe<JsonbComparisonExp>;
};

/** unique or primary key constraints on table "unified_evidence_drafts" */
export const UnifiedEvidenceDraftsConstraint = {
  /** unique or primary key constraint on columns "id" */
  UnifiedEvidenceDraftsPkey: 'unified_evidence_drafts_pkey',
  /** unique or primary key constraint on columns "evidence_id" */
  UqUnifiedEvDraftsEvidenceIdActive: 'uq_unified_ev_drafts_evidence_id_active',
  /** unique or primary key constraint on columns "parent_evidence_id", "tenant_id" */
  UqUnifiedEvDraftsParentActive: 'uq_unified_ev_drafts_parent_active'
} as const;

export type UnifiedEvidenceDraftsConstraint = typeof UnifiedEvidenceDraftsConstraint[keyof typeof UnifiedEvidenceDraftsConstraint];
/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type UnifiedEvidenceDraftsDeleteAtPathInput = {
  citation?: InputMaybe<Array<Scalars['String']['input']>>;
  metadata?: InputMaybe<Array<Scalars['String']['input']>>;
  properties?: InputMaybe<Array<Scalars['String']['input']>>;
  wikipedia?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type UnifiedEvidenceDraftsDeleteElemInput = {
  citation?: InputMaybe<Scalars['Int']['input']>;
  metadata?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Scalars['Int']['input']>;
  wikipedia?: InputMaybe<Scalars['Int']['input']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type UnifiedEvidenceDraftsDeleteKeyInput = {
  citation?: InputMaybe<Scalars['String']['input']>;
  metadata?: InputMaybe<Scalars['String']['input']>;
  properties?: InputMaybe<Scalars['String']['input']>;
  wikipedia?: InputMaybe<Scalars['String']['input']>;
};

/** input type for inserting data into table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsInsertInput = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsObjRelInsertInput>;
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  parentEvidenceId?: InputMaybe<Scalars['uuid']['input']>;
  parentEvidenceVersion?: InputMaybe<EvidenceVersionsObjRelInsertInput>;
  parentEvidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  wikipedia?: InputMaybe<Scalars['jsonb']['input']>;
};

/** aggregate max on columns */
export type UnifiedEvidenceDraftsMaxFields = {
  __typename?: 'UnifiedEvidenceDraftsMaxFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parentEvidenceId?: Maybe<Scalars['uuid']['output']>;
  parentEvidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMaxOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentEvidenceId?: InputMaybe<OrderBy>;
  parentEvidenceVersionId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UnifiedEvidenceDraftsMinFields = {
  __typename?: 'UnifiedEvidenceDraftsMinFields';
  batchEvidencesJobId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  dataSourceId?: Maybe<Scalars['uuid']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  evidenceId?: Maybe<Scalars['uuid']['output']>;
  evidenceImporterId?: Maybe<Scalars['uuid']['output']>;
  evidenceSetId?: Maybe<Scalars['uuid']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  parentEvidenceId?: Maybe<Scalars['uuid']['output']>;
  parentEvidenceVersionId?: Maybe<Scalars['uuid']['output']>;
  referenceId?: Maybe<Scalars['uuid']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMinOrderBy = {
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  parentEvidenceId?: InputMaybe<OrderBy>;
  parentEvidenceVersionId?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsMutationResponse = {
  __typename?: 'UnifiedEvidenceDraftsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UnifiedEvidenceDrafts>;
};

/** on_conflict condition type for table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsOnConflict = {
  constraint: UnifiedEvidenceDraftsConstraint;
  updateColumns?: Array<UnifiedEvidenceDraftsUpdateColumn>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};

/** Ordering options when selecting data from "unified_evidence_drafts". */
export type UnifiedEvidenceDraftsOrderBy = {
  batchEvidencesJob?: InputMaybe<BatchEvidencesJobsOrderBy>;
  batchEvidencesJobId?: InputMaybe<OrderBy>;
  citation?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  dataSourceId?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  evidenceId?: InputMaybe<OrderBy>;
  evidenceImporterId?: InputMaybe<OrderBy>;
  evidenceSetId?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  metadata?: InputMaybe<OrderBy>;
  parentEvidenceId?: InputMaybe<OrderBy>;
  parentEvidenceVersion?: InputMaybe<EvidenceVersionsOrderBy>;
  parentEvidenceVersionId?: InputMaybe<OrderBy>;
  properties?: InputMaybe<OrderBy>;
  referenceId?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  wikipedia?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: unified_evidence_drafts */
export type UnifiedEvidenceDraftsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type UnifiedEvidenceDraftsPrependInput = {
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  wikipedia?: InputMaybe<Scalars['jsonb']['input']>;
};

/** select columns of table "unified_evidence_drafts" */
export const UnifiedEvidenceDraftsSelectColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ParentEvidenceId: 'parentEvidenceId',
  /** column name */
  ParentEvidenceVersionId: 'parentEvidenceVersionId',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Wikipedia: 'wikipedia'
} as const;

export type UnifiedEvidenceDraftsSelectColumn = typeof UnifiedEvidenceDraftsSelectColumn[keyof typeof UnifiedEvidenceDraftsSelectColumn];
/** input type for updating data in table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsSetInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  parentEvidenceId?: InputMaybe<Scalars['uuid']['input']>;
  parentEvidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  wikipedia?: InputMaybe<Scalars['jsonb']['input']>;
};

/** Streaming cursor of the table "unified_evidence_drafts" */
export type UnifiedEvidenceDraftsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UnifiedEvidenceDraftsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UnifiedEvidenceDraftsStreamCursorValueInput = {
  batchEvidencesJobId?: InputMaybe<Scalars['uuid']['input']>;
  citation?: InputMaybe<Scalars['jsonb']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  dataSourceId?: InputMaybe<Scalars['uuid']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  evidenceId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceImporterId?: InputMaybe<Scalars['uuid']['input']>;
  evidenceSetId?: InputMaybe<Scalars['uuid']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  metadata?: InputMaybe<Scalars['jsonb']['input']>;
  parentEvidenceId?: InputMaybe<Scalars['uuid']['input']>;
  parentEvidenceVersionId?: InputMaybe<Scalars['uuid']['input']>;
  properties?: InputMaybe<Scalars['jsonb']['input']>;
  referenceId?: InputMaybe<Scalars['uuid']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  wikipedia?: InputMaybe<Scalars['jsonb']['input']>;
};

/** update columns of table "unified_evidence_drafts" */
export const UnifiedEvidenceDraftsUpdateColumn = {
  /** column name */
  BatchEvidencesJobId: 'batchEvidencesJobId',
  /** column name */
  Citation: 'citation',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DataSourceId: 'dataSourceId',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  EvidenceId: 'evidenceId',
  /** column name */
  EvidenceImporterId: 'evidenceImporterId',
  /** column name */
  EvidenceSetId: 'evidenceSetId',
  /** column name */
  Id: 'id',
  /** column name */
  Metadata: 'metadata',
  /** column name */
  ParentEvidenceId: 'parentEvidenceId',
  /** column name */
  ParentEvidenceVersionId: 'parentEvidenceVersionId',
  /** column name */
  Properties: 'properties',
  /** column name */
  ReferenceId: 'referenceId',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  Wikipedia: 'wikipedia'
} as const;

export type UnifiedEvidenceDraftsUpdateColumn = typeof UnifiedEvidenceDraftsUpdateColumn[keyof typeof UnifiedEvidenceDraftsUpdateColumn];
export type UnifiedEvidenceDraftsUpdates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<UnifiedEvidenceDraftsAppendInput>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _deleteAtPath?: InputMaybe<UnifiedEvidenceDraftsDeleteAtPathInput>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _deleteElem?: InputMaybe<UnifiedEvidenceDraftsDeleteElemInput>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _deleteKey?: InputMaybe<UnifiedEvidenceDraftsDeleteKeyInput>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<UnifiedEvidenceDraftsPrependInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UnifiedEvidenceDraftsSetInput>;
  /** filter the rows which have to be updated */
  where: UnifiedEvidenceDraftsBoolExp;
};

export type UpdateProductAvailableRolesInput = {
  productId: Scalars['UUID']['input'];
  roleIds: Array<Scalars['UUID']['input']>;
};

export type UpdateProductAvailableRolesOutput = {
  __typename?: 'UpdateProductAvailableRolesOutput';
  productId: Scalars['UUID']['output'];
};

export type UpdateRecordUpdateComposerDefinitionInput = {
  /**
   * Category reassignments to store on the definition. Omit (or pass null) to leave the stored
   * entries untouched, so callers that only set overrides keep working. Pass [] to explicitly clear.
   */
  categoryOverrides?: InputMaybe<Array<RecordUpdateCategoryOverrideEntryInput>>;
  overrides: Array<RecordUpdateOverrideEntryInput>;
  /**
   * Omitted leaves the stored entries untouched. Pass [] to clear. An entry only applies to Record
   * Update composition; ordinary composer definitions and future normal imports are unchanged.
   */
  preserveOnMissingEvidence?: InputMaybe<Array<RecordUpdatePreserveOnMissingEvidenceEntryInput>>;
  recordUpdateComposerDefinitionId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type UpdateRecordUpdateComposerDefinitionOutput = {
  __typename?: 'UpdateRecordUpdateComposerDefinitionOutput';
  recordUpdateComposerDefinitionId: Scalars['ID']['output'];
};

export type UserActivateInput = {
  id: Scalars['UUID']['input'];
};

export type UserActivateOutput = {
  __typename?: 'UserActivateOutput';
  id: Scalars['UUID']['output'];
};

export type UserCreateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  organizationShortCode: Scalars['String']['input'];
  productRoleAssignments: Array<ProductRoleAssignmentsInput>;
  userGroupIds: Array<Scalars['UUID']['input']>;
  userSegmentIds: Array<Scalars['Int']['input']>;
};

export type UserCreateOutput = {
  __typename?: 'UserCreateOutput';
  id: Scalars['UUID']['output'];
};

export type UserDataImportInput = {
  /**
   * Overrides the tenant auto-approval default when permitted.
   * true requires the tenant policy to allow auto approval; false disables it.
   */
  autoApprove?: InputMaybe<Scalars['Boolean']['input']>;
  /** Controls automatic compounding. Defaults to true when omitted. */
  autoCompound?: InputMaybe<Scalars['Boolean']['input']>;
  dataSources?: InputMaybe<Array<DataSourceJsonInput>>;
  description?: InputMaybe<Scalars['String']['input']>;
  /** Legacy PREVIEW selector. Prefer operation for new callers. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  entityAggregationPolicy?: InputMaybe<EntityAggregationPolicyInput>;
  name?: InputMaybe<Scalars['String']['input']>;
  operation?: InputMaybe<ImportDirectOperation>;
  origin?: InputMaybe<Scalars['String']['input']>;
  projectId?: InputMaybe<Scalars['UUID']['input']>;
  tenantId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserDataImportOutput = {
  __typename?: 'UserDataImportOutput';
  importId: Scalars['ID']['output'];
  projectId: Scalars['UUID']['output'];
};

export type UserDataImportResponse = ClientError | UserDataImportOutput | ValidationError;

export type UserDeactivateInput = {
  id: Scalars['UUID']['input'];
};

export type UserDeactivateOutput = {
  __typename?: 'UserDeactivateOutput';
  id: Scalars['UUID']['output'];
};

export type UserEmailChangeOutput = {
  __typename?: 'UserEmailChangeOutput';
  newEmail: Scalars['String']['output'];
  oldEmail: Scalars['String']['output'];
  status: Scalars['String']['output'];
};

export type UserGetOutput = {
  __typename?: 'UserGetOutput';
  email?: Maybe<Scalars['String']['output']>;
  firebaseUser?: Maybe<FirebaseUser>;
  id: Scalars['UUID']['output'];
  loginPreparationPending: Scalars['Boolean']['output'];
  user?: Maybe<Users>;
};

export type UserGroup = {
  __typename?: 'UserGroup';
  createdAt: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type UserGroupAssignInput = {
  userGroupIds: Array<Scalars['UUID']['input']>;
  userId: Scalars['UUID']['input'];
};

export type UserGroupAssignOutput = {
  __typename?: 'UserGroupAssignOutput';
  id: Scalars['UUID']['output'];
};

export type UserGroupCreateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
};

export type UserGroupCreateOutput = {
  __typename?: 'UserGroupCreateOutput';
  id: Scalars['UUID']['output'];
};

export type UserGroupListInput = {
  idsFilter?: InputMaybe<Array<Scalars['String']['input']>>;
  nameFilter?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserGroupListOutput = {
  __typename?: 'UserGroupListOutput';
  groups: Array<UserGroup>;
};

export type UserGroupUpdateInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['UUID']['input'];
  name: Scalars['String']['input'];
};

export type UserGroupUpdateOutput = {
  __typename?: 'UserGroupUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "user_groups" */
export type UserGroups = {
  __typename?: 'UserGroups';
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['uuid']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  users: Array<UserUserGroups>;
  /** An aggregate relationship */
  usersAggregate: UserUserGroupsAggregate;
};


/** columns and relationships of "user_groups" */
export type UserGroupsUsersArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


/** columns and relationships of "user_groups" */
export type UserGroupsUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};

/** aggregated selection of "user_groups" */
export type UserGroupsAggregate = {
  __typename?: 'UserGroupsAggregate';
  aggregate?: Maybe<UserGroupsAggregateFields>;
  nodes: Array<UserGroups>;
};

/** aggregate fields of "user_groups" */
export type UserGroupsAggregateFields = {
  __typename?: 'UserGroupsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserGroupsMaxFields>;
  min?: Maybe<UserGroupsMinFields>;
};


/** aggregate fields of "user_groups" */
export type UserGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "user_groups". All fields are combined with a logical 'AND'. */
export type UserGroupsBoolExp = {
  _and?: InputMaybe<Array<UserGroupsBoolExp>>;
  _not?: InputMaybe<UserGroupsBoolExp>;
  _or?: InputMaybe<Array<UserGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  description?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  users?: InputMaybe<UserUserGroupsBoolExp>;
  usersAggregate?: InputMaybe<UserUserGroupsAggregateBoolExp>;
};

/** unique or primary key constraints on table "user_groups" */
export const UserGroupsConstraint = {
  /** unique or primary key constraint on columns "name" */
  UserGroupsNameKey: 'user_groups_name_key',
  /** unique or primary key constraint on columns "id" */
  UserGroupsPkey: 'user_groups_pkey'
} as const;

export type UserGroupsConstraint = typeof UserGroupsConstraint[keyof typeof UserGroupsConstraint];
/** input type for inserting data into table "user_groups" */
export type UserGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  users?: InputMaybe<UserUserGroupsArrRelInsertInput>;
};

/** aggregate max on columns */
export type UserGroupsMaxFields = {
  __typename?: 'UserGroupsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UserGroupsMinFields = {
  __typename?: 'UserGroupsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user_groups" */
export type UserGroupsMutationResponse = {
  __typename?: 'UserGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserGroups>;
};

/** input type for inserting object relation for remote table "user_groups" */
export type UserGroupsObjRelInsertInput = {
  data: UserGroupsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserGroupsOnConflict>;
};

/** on_conflict condition type for table "user_groups" */
export type UserGroupsOnConflict = {
  constraint: UserGroupsConstraint;
  updateColumns?: Array<UserGroupsUpdateColumn>;
  where?: InputMaybe<UserGroupsBoolExp>;
};

/** Ordering options when selecting data from "user_groups". */
export type UserGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  description?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  usersAggregate?: InputMaybe<UserUserGroupsAggregateOrderBy>;
};

/** primary key columns input for table: user_groups */
export type UserGroupsPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "user_groups" */
export const UserGroupsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UserGroupsSelectColumn = typeof UserGroupsSelectColumn[keyof typeof UserGroupsSelectColumn];
/** input type for updating data in table "user_groups" */
export type UserGroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "user_groups" */
export type UserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserGroupsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "user_groups" */
export const UserGroupsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  Description: 'description',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UserGroupsUpdateColumn = typeof UserGroupsUpdateColumn[keyof typeof UserGroupsUpdateColumn];
export type UserGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: UserGroupsBoolExp;
};

export type UserMeOutput = {
  __typename?: 'UserMeOutput';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['UUID']['output'];
  roles: Array<Scalars['String']['output']>;
  tenants: Array<UserMeTenantOutput>;
};

export type UserMeResponse = UserMeOutput | ValidationError;

export type UserMeTenantOutput = {
  __typename?: 'UserMeTenantOutput';
  id: Scalars['UUID']['output'];
  name: Scalars['String']['output'];
  role: TenantMembershipRole;
  shortCode: Scalars['String']['output'];
};

export type UserProductRoleOutput = {
  __typename?: 'UserProductRoleOutput';
  id: Scalars['UUID']['output'];
};

export type UserProductRoleResponse = UserProductRoleOutput | ValidationError;

/** columns and relationships of "user_product_roles" */
export type UserProductRoles = {
  __typename?: 'UserProductRoles';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  product: Products;
  productId: Scalars['uuid']['output'];
  /** An object relationship */
  role: Roles;
  roleId: Scalars['uuid']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "user_product_roles" */
export type UserProductRolesAggregate = {
  __typename?: 'UserProductRolesAggregate';
  aggregate?: Maybe<UserProductRolesAggregateFields>;
  nodes: Array<UserProductRoles>;
};

export type UserProductRolesAggregateBoolExp = {
  count?: InputMaybe<UserProductRolesAggregateBoolExpCount>;
};

/** aggregate fields of "user_product_roles" */
export type UserProductRolesAggregateFields = {
  __typename?: 'UserProductRolesAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserProductRolesMaxFields>;
  min?: Maybe<UserProductRolesMinFields>;
};


/** aggregate fields of "user_product_roles" */
export type UserProductRolesAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_product_roles" */
export type UserProductRolesAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserProductRolesMaxOrderBy>;
  min?: InputMaybe<UserProductRolesMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_product_roles" */
export type UserProductRolesArrRelInsertInput = {
  data: Array<UserProductRolesInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserProductRolesOnConflict>;
};

/** Boolean expression to filter rows from the table "user_product_roles". All fields are combined with a logical 'AND'. */
export type UserProductRolesBoolExp = {
  _and?: InputMaybe<Array<UserProductRolesBoolExp>>;
  _not?: InputMaybe<UserProductRolesBoolExp>;
  _or?: InputMaybe<Array<UserProductRolesBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  product?: InputMaybe<ProductsBoolExp>;
  productId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<RolesBoolExp>;
  roleId?: InputMaybe<UuidComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_product_roles" */
export const UserProductRolesConstraint = {
  /** unique or primary key constraint on columns "user_id", "product_id", "role_id" */
  UserProductRolesPkey: 'user_product_roles_pkey',
  /** unique or primary key constraint on columns "user_id", "product_id" */
  UserProductRolesUserIdProductIdKey: 'user_product_roles_user_id_product_id_key'
} as const;

export type UserProductRolesConstraint = typeof UserProductRolesConstraint[keyof typeof UserProductRolesConstraint];
/** input type for inserting data into table "user_product_roles" */
export type UserProductRolesInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  product?: InputMaybe<ProductsObjRelInsertInput>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<RolesObjRelInsertInput>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserProductRolesMaxFields = {
  __typename?: 'UserProductRolesMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_product_roles" */
export type UserProductRolesMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserProductRolesMinFields = {
  __typename?: 'UserProductRolesMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  productId?: Maybe<Scalars['uuid']['output']>;
  roleId?: Maybe<Scalars['uuid']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_product_roles" */
export type UserProductRolesMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  productId?: InputMaybe<OrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_product_roles" */
export type UserProductRolesMutationResponse = {
  __typename?: 'UserProductRolesMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserProductRoles>;
};

/** on_conflict condition type for table "user_product_roles" */
export type UserProductRolesOnConflict = {
  constraint: UserProductRolesConstraint;
  updateColumns?: Array<UserProductRolesUpdateColumn>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};

/** Ordering options when selecting data from "user_product_roles". */
export type UserProductRolesOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  product?: InputMaybe<ProductsOrderBy>;
  productId?: InputMaybe<OrderBy>;
  role?: InputMaybe<RolesOrderBy>;
  roleId?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_product_roles */
export type UserProductRolesPkColumnsInput = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_product_roles" */
export const UserProductRolesSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ProductId: 'productId',
  /** column name */
  RoleId: 'roleId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type UserProductRolesSelectColumn = typeof UserProductRolesSelectColumn[keyof typeof UserProductRolesSelectColumn];
/** input type for updating data in table "user_product_roles" */
export type UserProductRolesSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_product_roles" */
export type UserProductRolesStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserProductRolesStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserProductRolesStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  productId?: InputMaybe<Scalars['uuid']['input']>;
  roleId?: InputMaybe<Scalars['uuid']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_product_roles" */
export const UserProductRolesUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  ProductId: 'productId',
  /** column name */
  RoleId: 'roleId',
  /** column name */
  UpdatedAt: 'updatedAt',
  /** column name */
  UserId: 'userId'
} as const;

export type UserProductRolesUpdateColumn = typeof UserProductRolesUpdateColumn[keyof typeof UserProductRolesUpdateColumn];
export type UserProductRolesUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserProductRolesSetInput>;
  /** filter the rows which have to be updated */
  where: UserProductRolesBoolExp;
};

export type UserProfileImageUpdateInput = {
  image: Scalars['String']['input'];
};

export type UserProfileImageUpdateOutput = {
  __typename?: 'UserProfileImageUpdateOutput';
  photoUrl: Scalars['String']['output'];
};

export type UserProfileImageUpdateResponse = UserProfileImageUpdateOutput | ValidationError;

export type UserProfileUpdateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
};

export type UserProfileUpdateOutput = {
  __typename?: 'UserProfileUpdateOutput';
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
};

export type UserProfileUpdateResponse = UserProfileUpdateOutput | ValidationError;

export type UserRemoveProductRoleInput = {
  userId: Scalars['UUID']['input'];
};

/** columns and relationships of "user_segments" */
export type UserSegments = {
  __typename?: 'UserSegments';
  createdAt: Scalars['timestamptz']['output'];
  id: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  updatedAt: Scalars['timestamptz']['output'];
};

/** aggregated selection of "user_segments" */
export type UserSegmentsAggregate = {
  __typename?: 'UserSegmentsAggregate';
  aggregate?: Maybe<UserSegmentsAggregateFields>;
  nodes: Array<UserSegments>;
};

/** aggregate fields of "user_segments" */
export type UserSegmentsAggregateFields = {
  __typename?: 'UserSegmentsAggregateFields';
  avg?: Maybe<UserSegmentsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserSegmentsMaxFields>;
  min?: Maybe<UserSegmentsMinFields>;
  stddev?: Maybe<UserSegmentsStddevFields>;
  stddevPop?: Maybe<UserSegmentsStddevPopFields>;
  stddevSamp?: Maybe<UserSegmentsStddevSampFields>;
  sum?: Maybe<UserSegmentsSumFields>;
  varPop?: Maybe<UserSegmentsVarPopFields>;
  varSamp?: Maybe<UserSegmentsVarSampFields>;
  variance?: Maybe<UserSegmentsVarianceFields>;
};


/** aggregate fields of "user_segments" */
export type UserSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** aggregate avg on columns */
export type UserSegmentsAvgFields = {
  __typename?: 'UserSegmentsAvgFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Boolean expression to filter rows from the table "user_segments". All fields are combined with a logical 'AND'. */
export type UserSegmentsBoolExp = {
  _and?: InputMaybe<Array<UserSegmentsBoolExp>>;
  _not?: InputMaybe<UserSegmentsBoolExp>;
  _or?: InputMaybe<Array<UserSegmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  id?: InputMaybe<IntComparisonExp>;
  name?: InputMaybe<StringComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
};

/** unique or primary key constraints on table "user_segments" */
export const UserSegmentsConstraint = {
  /** unique or primary key constraint on columns "name" */
  UserSegmentsNameKey: 'user_segments_name_key',
  /** unique or primary key constraint on columns "id" */
  UserSegmentsPkey: 'user_segments_pkey'
} as const;

export type UserSegmentsConstraint = typeof UserSegmentsConstraint[keyof typeof UserSegmentsConstraint];
/** input type for incrementing numeric columns in table "user_segments" */
export type UserSegmentsIncInput = {
  id?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_segments" */
export type UserSegmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate max on columns */
export type UserSegmentsMaxFields = {
  __typename?: 'UserSegmentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UserSegmentsMinFields = {
  __typename?: 'UserSegmentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "user_segments" */
export type UserSegmentsMutationResponse = {
  __typename?: 'UserSegmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserSegments>;
};

/** input type for inserting object relation for remote table "user_segments" */
export type UserSegmentsObjRelInsertInput = {
  data: UserSegmentsInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UserSegmentsOnConflict>;
};

/** on_conflict condition type for table "user_segments" */
export type UserSegmentsOnConflict = {
  constraint: UserSegmentsConstraint;
  updateColumns?: Array<UserSegmentsUpdateColumn>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};

/** Ordering options when selecting data from "user_segments". */
export type UserSegmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  name?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_segments */
export type UserSegmentsPkColumnsInput = {
  id: Scalars['Int']['input'];
};

/** select columns of table "user_segments" */
export const UserSegmentsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UserSegmentsSelectColumn = typeof UserSegmentsSelectColumn[keyof typeof UserSegmentsSelectColumn];
/** input type for updating data in table "user_segments" */
export type UserSegmentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate stddev on columns */
export type UserSegmentsStddevFields = {
  __typename?: 'UserSegmentsStddevFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevPop on columns */
export type UserSegmentsStddevPopFields = {
  __typename?: 'UserSegmentsStddevPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate stddevSamp on columns */
export type UserSegmentsStddevSampFields = {
  __typename?: 'UserSegmentsStddevSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** Streaming cursor of the table "user_segments" */
export type UserSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserSegmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  id?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** aggregate sum on columns */
export type UserSegmentsSumFields = {
  __typename?: 'UserSegmentsSumFields';
  id?: Maybe<Scalars['Int']['output']>;
};

/** update columns of table "user_segments" */
export const UserSegmentsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  Id: 'id',
  /** column name */
  Name: 'name',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UserSegmentsUpdateColumn = typeof UserSegmentsUpdateColumn[keyof typeof UserSegmentsUpdateColumn];
export type UserSegmentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserSegmentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserSegmentsSetInput>;
  /** filter the rows which have to be updated */
  where: UserSegmentsBoolExp;
};

/** aggregate varPop on columns */
export type UserSegmentsVarPopFields = {
  __typename?: 'UserSegmentsVarPopFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate varSamp on columns */
export type UserSegmentsVarSampFields = {
  __typename?: 'UserSegmentsVarSampFields';
  id?: Maybe<Scalars['Float']['output']>;
};

/** aggregate variance on columns */
export type UserSegmentsVarianceFields = {
  __typename?: 'UserSegmentsVarianceFields';
  id?: Maybe<Scalars['Float']['output']>;
};

export type UserSetProductRoleInput = {
  role: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};

/** columns and relationships of "user_tenants" */
export type UserTenants = {
  __typename?: 'UserTenants';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
  role: Scalars['String']['output'];
  /** An object relationship */
  tenant?: Maybe<Tenants>;
  tenantId: Scalars['uuid']['output'];
  /** An object relationship */
  user?: Maybe<Users>;
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "user_tenants" */
export type UserTenantsAggregate = {
  __typename?: 'UserTenantsAggregate';
  aggregate?: Maybe<UserTenantsAggregateFields>;
  nodes: Array<UserTenants>;
};

export type UserTenantsAggregateBoolExp = {
  count?: InputMaybe<UserTenantsAggregateBoolExpCount>;
};

/** aggregate fields of "user_tenants" */
export type UserTenantsAggregateFields = {
  __typename?: 'UserTenantsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserTenantsMaxFields>;
  min?: Maybe<UserTenantsMinFields>;
};


/** aggregate fields of "user_tenants" */
export type UserTenantsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_tenants" */
export type UserTenantsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserTenantsMaxOrderBy>;
  min?: InputMaybe<UserTenantsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_tenants" */
export type UserTenantsArrRelInsertInput = {
  data: Array<UserTenantsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserTenantsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_tenants". All fields are combined with a logical 'AND'. */
export type UserTenantsBoolExp = {
  _and?: InputMaybe<Array<UserTenantsBoolExp>>;
  _not?: InputMaybe<UserTenantsBoolExp>;
  _or?: InputMaybe<Array<UserTenantsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  role?: InputMaybe<StringComparisonExp>;
  tenant?: InputMaybe<TenantsBoolExp>;
  tenantId?: InputMaybe<UuidComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_tenants" */
export const UserTenantsConstraint = {
  /** unique or primary key constraint on columns "user_id", "tenant_id" */
  UserTenantsPkey: 'user_tenants_pkey'
} as const;

export type UserTenantsConstraint = typeof UserTenantsConstraint[keyof typeof UserTenantsConstraint];
/** input type for inserting data into table "user_tenants" */
export type UserTenantsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenant?: InputMaybe<TenantsObjRelInsertInput>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserTenantsMaxFields = {
  __typename?: 'UserTenantsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_tenants" */
export type UserTenantsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserTenantsMinFields = {
  __typename?: 'UserTenantsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  tenantId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_tenants" */
export type UserTenantsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_tenants" */
export type UserTenantsMutationResponse = {
  __typename?: 'UserTenantsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserTenants>;
};

/** on_conflict condition type for table "user_tenants" */
export type UserTenantsOnConflict = {
  constraint: UserTenantsConstraint;
  updateColumns?: Array<UserTenantsUpdateColumn>;
  where?: InputMaybe<UserTenantsBoolExp>;
};

/** Ordering options when selecting data from "user_tenants". */
export type UserTenantsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  role?: InputMaybe<OrderBy>;
  tenant?: InputMaybe<TenantsOrderBy>;
  tenantId?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_tenants */
export type UserTenantsPkColumnsInput = {
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_tenants" */
export const UserTenantsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  Role: 'role',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UserId: 'userId'
} as const;

export type UserTenantsSelectColumn = typeof UserTenantsSelectColumn[keyof typeof UserTenantsSelectColumn];
/** input type for updating data in table "user_tenants" */
export type UserTenantsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_tenants" */
export type UserTenantsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserTenantsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserTenantsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  role?: InputMaybe<Scalars['String']['input']>;
  tenantId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_tenants" */
export const UserTenantsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  Role: 'role',
  /** column name */
  TenantId: 'tenantId',
  /** column name */
  UserId: 'userId'
} as const;

export type UserTenantsUpdateColumn = typeof UserTenantsUpdateColumn[keyof typeof UserTenantsUpdateColumn];
export type UserTenantsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserTenantsSetInput>;
  /** filter the rows which have to be updated */
  where: UserTenantsBoolExp;
};

export type UserUpdateInput = {
  displayName?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  id: Scalars['UUID']['input'];
  memo?: InputMaybe<Scalars['String']['input']>;
  productRoleAssignments: Array<ProductRoleAssignmentsInput>;
  userGroupIds: Array<Scalars['UUID']['input']>;
  userSegmentIds: Array<Scalars['Int']['input']>;
};

export type UserUpdateOrganizationInput = {
  organizationShortCode: Scalars['String']['input'];
  removeMembershipsOutsideDestination: Scalars['Boolean']['input'];
  userId: Scalars['UUID']['input'];
};

export type UserUpdateOrganizationOutput = {
  __typename?: 'UserUpdateOrganizationOutput';
  id: Scalars['UUID']['output'];
};

export type UserUpdateOrganizationResponse = UserUpdateOrganizationOutput | ValidationError;

export type UserUpdateOutput = {
  __typename?: 'UserUpdateOutput';
  id: Scalars['UUID']['output'];
};

/** columns and relationships of "user_user_groups" */
export type UserUserGroups = {
  __typename?: 'UserUserGroups';
  createdAt: Scalars['timestamptz']['output'];
  /** An object relationship */
  user: Users;
  /** An object relationship */
  userGroup: UserGroups;
  userGroupId: Scalars['uuid']['output'];
  userId: Scalars['uuid']['output'];
};

/** aggregated selection of "user_user_groups" */
export type UserUserGroupsAggregate = {
  __typename?: 'UserUserGroupsAggregate';
  aggregate?: Maybe<UserUserGroupsAggregateFields>;
  nodes: Array<UserUserGroups>;
};

export type UserUserGroupsAggregateBoolExp = {
  count?: InputMaybe<UserUserGroupsAggregateBoolExpCount>;
};

/** aggregate fields of "user_user_groups" */
export type UserUserGroupsAggregateFields = {
  __typename?: 'UserUserGroupsAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UserUserGroupsMaxFields>;
  min?: Maybe<UserUserGroupsMinFields>;
};


/** aggregate fields of "user_user_groups" */
export type UserUserGroupsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_user_groups" */
export type UserUserGroupsAggregateOrderBy = {
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserUserGroupsMaxOrderBy>;
  min?: InputMaybe<UserUserGroupsMinOrderBy>;
};

/** input type for inserting array relation for remote table "user_user_groups" */
export type UserUserGroupsArrRelInsertInput = {
  data: Array<UserUserGroupsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserUserGroupsOnConflict>;
};

/** Boolean expression to filter rows from the table "user_user_groups". All fields are combined with a logical 'AND'. */
export type UserUserGroupsBoolExp = {
  _and?: InputMaybe<Array<UserUserGroupsBoolExp>>;
  _not?: InputMaybe<UserUserGroupsBoolExp>;
  _or?: InputMaybe<Array<UserUserGroupsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  user?: InputMaybe<UsersBoolExp>;
  userGroup?: InputMaybe<UserGroupsBoolExp>;
  userGroupId?: InputMaybe<UuidComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
};

/** unique or primary key constraints on table "user_user_groups" */
export const UserUserGroupsConstraint = {
  /** unique or primary key constraint on columns "user_id", "user_group_id" */
  UserUserGroupsPkey: 'user_user_groups_pkey'
} as const;

export type UserUserGroupsConstraint = typeof UserUserGroupsConstraint[keyof typeof UserUserGroupsConstraint];
/** input type for inserting data into table "user_user_groups" */
export type UserUserGroupsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  user?: InputMaybe<UsersObjRelInsertInput>;
  userGroup?: InputMaybe<UserGroupsObjRelInsertInput>;
  userGroupId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** aggregate max on columns */
export type UserUserGroupsMaxFields = {
  __typename?: 'UserUserGroupsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  userGroupId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by max() on columns of table "user_user_groups" */
export type UserUserGroupsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userGroupId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserUserGroupsMinFields = {
  __typename?: 'UserUserGroupsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  userGroupId?: Maybe<Scalars['uuid']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
};

/** order by min() on columns of table "user_user_groups" */
export type UserUserGroupsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userGroupId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_user_groups" */
export type UserUserGroupsMutationResponse = {
  __typename?: 'UserUserGroupsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserUserGroups>;
};

/** on_conflict condition type for table "user_user_groups" */
export type UserUserGroupsOnConflict = {
  constraint: UserUserGroupsConstraint;
  updateColumns?: Array<UserUserGroupsUpdateColumn>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};

/** Ordering options when selecting data from "user_user_groups". */
export type UserUserGroupsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  user?: InputMaybe<UsersOrderBy>;
  userGroup?: InputMaybe<UserGroupsOrderBy>;
  userGroupId?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_user_groups */
export type UserUserGroupsPkColumnsInput = {
  userGroupId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};

/** select columns of table "user_user_groups" */
export const UserUserGroupsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  UserGroupId: 'userGroupId',
  /** column name */
  UserId: 'userId'
} as const;

export type UserUserGroupsSelectColumn = typeof UserUserGroupsSelectColumn[keyof typeof UserUserGroupsSelectColumn];
/** input type for updating data in table "user_user_groups" */
export type UserUserGroupsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userGroupId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** Streaming cursor of the table "user_user_groups" */
export type UserUserGroupsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserUserGroupsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserUserGroupsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userGroupId?: InputMaybe<Scalars['uuid']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
};

/** update columns of table "user_user_groups" */
export const UserUserGroupsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  UserGroupId: 'userGroupId',
  /** column name */
  UserId: 'userId'
} as const;

export type UserUserGroupsUpdateColumn = typeof UserUserGroupsUpdateColumn[keyof typeof UserUserGroupsUpdateColumn];
export type UserUserGroupsUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserUserGroupsSetInput>;
  /** filter the rows which have to be updated */
  where: UserUserGroupsBoolExp;
};

/** columns and relationships of "user_user_segments" */
export type UserUserSegments = {
  __typename?: 'UserUserSegments';
  createdAt: Scalars['timestamptz']['output'];
  userId: Scalars['uuid']['output'];
  /** An object relationship */
  userSegment: UserSegments;
  userSegmentId: Scalars['Int']['output'];
};

/** aggregated selection of "user_user_segments" */
export type UserUserSegmentsAggregate = {
  __typename?: 'UserUserSegmentsAggregate';
  aggregate?: Maybe<UserUserSegmentsAggregateFields>;
  nodes: Array<UserUserSegments>;
};

export type UserUserSegmentsAggregateBoolExp = {
  count?: InputMaybe<UserUserSegmentsAggregateBoolExpCount>;
};

/** aggregate fields of "user_user_segments" */
export type UserUserSegmentsAggregateFields = {
  __typename?: 'UserUserSegmentsAggregateFields';
  avg?: Maybe<UserUserSegmentsAvgFields>;
  count: Scalars['Int']['output'];
  max?: Maybe<UserUserSegmentsMaxFields>;
  min?: Maybe<UserUserSegmentsMinFields>;
  stddev?: Maybe<UserUserSegmentsStddevFields>;
  stddevPop?: Maybe<UserUserSegmentsStddevPopFields>;
  stddevSamp?: Maybe<UserUserSegmentsStddevSampFields>;
  sum?: Maybe<UserUserSegmentsSumFields>;
  varPop?: Maybe<UserUserSegmentsVarPopFields>;
  varSamp?: Maybe<UserUserSegmentsVarSampFields>;
  variance?: Maybe<UserUserSegmentsVarianceFields>;
};


/** aggregate fields of "user_user_segments" */
export type UserUserSegmentsAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** order by aggregate values of table "user_user_segments" */
export type UserUserSegmentsAggregateOrderBy = {
  avg?: InputMaybe<UserUserSegmentsAvgOrderBy>;
  count?: InputMaybe<OrderBy>;
  max?: InputMaybe<UserUserSegmentsMaxOrderBy>;
  min?: InputMaybe<UserUserSegmentsMinOrderBy>;
  stddev?: InputMaybe<UserUserSegmentsStddevOrderBy>;
  stddevPop?: InputMaybe<UserUserSegmentsStddevPopOrderBy>;
  stddevSamp?: InputMaybe<UserUserSegmentsStddevSampOrderBy>;
  sum?: InputMaybe<UserUserSegmentsSumOrderBy>;
  varPop?: InputMaybe<UserUserSegmentsVarPopOrderBy>;
  varSamp?: InputMaybe<UserUserSegmentsVarSampOrderBy>;
  variance?: InputMaybe<UserUserSegmentsVarianceOrderBy>;
};

/** input type for inserting array relation for remote table "user_user_segments" */
export type UserUserSegmentsArrRelInsertInput = {
  data: Array<UserUserSegmentsInsertInput>;
  /** upsert condition */
  onConflict?: InputMaybe<UserUserSegmentsOnConflict>;
};

/** aggregate avg on columns */
export type UserUserSegmentsAvgFields = {
  __typename?: 'UserUserSegmentsAvgFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by avg() on columns of table "user_user_segments" */
export type UserUserSegmentsAvgOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** Boolean expression to filter rows from the table "user_user_segments". All fields are combined with a logical 'AND'. */
export type UserUserSegmentsBoolExp = {
  _and?: InputMaybe<Array<UserUserSegmentsBoolExp>>;
  _not?: InputMaybe<UserUserSegmentsBoolExp>;
  _or?: InputMaybe<Array<UserUserSegmentsBoolExp>>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  userId?: InputMaybe<UuidComparisonExp>;
  userSegment?: InputMaybe<UserSegmentsBoolExp>;
  userSegmentId?: InputMaybe<IntComparisonExp>;
};

/** unique or primary key constraints on table "user_user_segments" */
export const UserUserSegmentsConstraint = {
  /** unique or primary key constraint on columns "user_id", "user_segment_id" */
  UserUserSegmentsPkey: 'user_user_segments_pkey'
} as const;

export type UserUserSegmentsConstraint = typeof UserUserSegmentsConstraint[keyof typeof UserUserSegmentsConstraint];
/** input type for incrementing numeric columns in table "user_user_segments" */
export type UserUserSegmentsIncInput = {
  userSegmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** input type for inserting data into table "user_user_segments" */
export type UserUserSegmentsInsertInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userSegment?: InputMaybe<UserSegmentsObjRelInsertInput>;
  userSegmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate max on columns */
export type UserUserSegmentsMaxFields = {
  __typename?: 'UserUserSegmentsMaxFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userSegmentId?: Maybe<Scalars['Int']['output']>;
};

/** order by max() on columns of table "user_user_segments" */
export type UserUserSegmentsMaxOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userSegmentId?: InputMaybe<OrderBy>;
};

/** aggregate min on columns */
export type UserUserSegmentsMinFields = {
  __typename?: 'UserUserSegmentsMinFields';
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  userId?: Maybe<Scalars['uuid']['output']>;
  userSegmentId?: Maybe<Scalars['Int']['output']>;
};

/** order by min() on columns of table "user_user_segments" */
export type UserUserSegmentsMinOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userSegmentId?: InputMaybe<OrderBy>;
};

/** response of any mutation on the table "user_user_segments" */
export type UserUserSegmentsMutationResponse = {
  __typename?: 'UserUserSegmentsMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<UserUserSegments>;
};

/** on_conflict condition type for table "user_user_segments" */
export type UserUserSegmentsOnConflict = {
  constraint: UserUserSegmentsConstraint;
  updateColumns?: Array<UserUserSegmentsUpdateColumn>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};

/** Ordering options when selecting data from "user_user_segments". */
export type UserUserSegmentsOrderBy = {
  createdAt?: InputMaybe<OrderBy>;
  userId?: InputMaybe<OrderBy>;
  userSegment?: InputMaybe<UserSegmentsOrderBy>;
  userSegmentId?: InputMaybe<OrderBy>;
};

/** primary key columns input for table: user_user_segments */
export type UserUserSegmentsPkColumnsInput = {
  userId: Scalars['uuid']['input'];
  userSegmentId: Scalars['Int']['input'];
};

/** select columns of table "user_user_segments" */
export const UserUserSegmentsSelectColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  UserSegmentId: 'userSegmentId'
} as const;

export type UserUserSegmentsSelectColumn = typeof UserUserSegmentsSelectColumn[keyof typeof UserUserSegmentsSelectColumn];
/** input type for updating data in table "user_user_segments" */
export type UserUserSegmentsSetInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userSegmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate stddev on columns */
export type UserUserSegmentsStddevFields = {
  __typename?: 'UserUserSegmentsStddevFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddev() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** aggregate stddevPop on columns */
export type UserUserSegmentsStddevPopFields = {
  __typename?: 'UserUserSegmentsStddevPopFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevPop() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevPopOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** aggregate stddevSamp on columns */
export type UserUserSegmentsStddevSampFields = {
  __typename?: 'UserUserSegmentsStddevSampFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by stddevSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsStddevSampOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** Streaming cursor of the table "user_user_segments" */
export type UserUserSegmentsStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UserUserSegmentsStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UserUserSegmentsStreamCursorValueInput = {
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userId?: InputMaybe<Scalars['uuid']['input']>;
  userSegmentId?: InputMaybe<Scalars['Int']['input']>;
};

/** aggregate sum on columns */
export type UserUserSegmentsSumFields = {
  __typename?: 'UserUserSegmentsSumFields';
  userSegmentId?: Maybe<Scalars['Int']['output']>;
};

/** order by sum() on columns of table "user_user_segments" */
export type UserUserSegmentsSumOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** update columns of table "user_user_segments" */
export const UserUserSegmentsUpdateColumn = {
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  UserId: 'userId',
  /** column name */
  UserSegmentId: 'userSegmentId'
} as const;

export type UserUserSegmentsUpdateColumn = typeof UserUserSegmentsUpdateColumn[keyof typeof UserUserSegmentsUpdateColumn];
export type UserUserSegmentsUpdates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<UserUserSegmentsIncInput>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UserUserSegmentsSetInput>;
  /** filter the rows which have to be updated */
  where: UserUserSegmentsBoolExp;
};

/** aggregate varPop on columns */
export type UserUserSegmentsVarPopFields = {
  __typename?: 'UserUserSegmentsVarPopFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by varPop() on columns of table "user_user_segments" */
export type UserUserSegmentsVarPopOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** aggregate varSamp on columns */
export type UserUserSegmentsVarSampFields = {
  __typename?: 'UserUserSegmentsVarSampFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by varSamp() on columns of table "user_user_segments" */
export type UserUserSegmentsVarSampOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** aggregate variance on columns */
export type UserUserSegmentsVarianceFields = {
  __typename?: 'UserUserSegmentsVarianceFields';
  userSegmentId?: Maybe<Scalars['Float']['output']>;
};

/** order by variance() on columns of table "user_user_segments" */
export type UserUserSegmentsVarianceOrderBy = {
  userSegmentId?: InputMaybe<OrderBy>;
};

/** columns and relationships of "users" */
export type Users = {
  __typename?: 'Users';
  cotenId?: Maybe<Scalars['uuid']['output']>;
  cotenLoginPreparationRequired: Scalars['Boolean']['output'];
  createdAt: Scalars['timestamptz']['output'];
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email: Scalars['String']['output'];
  id: Scalars['uuid']['output'];
  lockeRegistrationEmail?: Maybe<Scalars['String']['output']>;
  lockeRegistrationId?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  /** An object relationship */
  organization: Organizations;
  organizationId: Scalars['uuid']['output'];
  photoUrl?: Maybe<Scalars['String']['output']>;
  system: Scalars['Boolean']['output'];
  updatedAt: Scalars['timestamptz']['output'];
  /** An array relationship */
  userProductRoles: Array<UserProductRoles>;
  /** An aggregate relationship */
  userProductRolesAggregate: UserProductRolesAggregate;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
  /** An array relationship */
  userUserGroups: Array<UserUserGroups>;
  /** An aggregate relationship */
  userUserGroupsAggregate: UserUserGroupsAggregate;
  /** An array relationship */
  userUserSegments: Array<UserUserSegments>;
  /** An aggregate relationship */
  userUserSegmentsAggregate: UserUserSegmentsAggregate;
};


/** columns and relationships of "users" */
export type UsersUserProductRolesArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserUserGroupsArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserUserGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserUserSegmentsArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


/** columns and relationships of "users" */
export type UsersUserUserSegmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};

/** aggregated selection of "users" */
export type UsersAggregate = {
  __typename?: 'UsersAggregate';
  aggregate?: Maybe<UsersAggregateFields>;
  nodes: Array<Users>;
};

/** aggregate fields of "users" */
export type UsersAggregateFields = {
  __typename?: 'UsersAggregateFields';
  count: Scalars['Int']['output'];
  max?: Maybe<UsersMaxFields>;
  min?: Maybe<UsersMinFields>;
};


/** aggregate fields of "users" */
export type UsersAggregateFieldsCountArgs = {
  columns?: InputMaybe<Array<UsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Boolean expression to filter rows from the table "users". All fields are combined with a logical 'AND'. */
export type UsersBoolExp = {
  _and?: InputMaybe<Array<UsersBoolExp>>;
  _not?: InputMaybe<UsersBoolExp>;
  _or?: InputMaybe<Array<UsersBoolExp>>;
  cotenId?: InputMaybe<UuidComparisonExp>;
  cotenLoginPreparationRequired?: InputMaybe<BooleanComparisonExp>;
  createdAt?: InputMaybe<TimestamptzComparisonExp>;
  deactivatedAt?: InputMaybe<TimestamptzComparisonExp>;
  displayName?: InputMaybe<StringComparisonExp>;
  email?: InputMaybe<StringComparisonExp>;
  id?: InputMaybe<UuidComparisonExp>;
  lockeRegistrationEmail?: InputMaybe<StringComparisonExp>;
  lockeRegistrationId?: InputMaybe<UuidComparisonExp>;
  memo?: InputMaybe<StringComparisonExp>;
  organization?: InputMaybe<OrganizationsBoolExp>;
  organizationId?: InputMaybe<UuidComparisonExp>;
  photoUrl?: InputMaybe<StringComparisonExp>;
  system?: InputMaybe<BooleanComparisonExp>;
  updatedAt?: InputMaybe<TimestamptzComparisonExp>;
  userProductRoles?: InputMaybe<UserProductRolesBoolExp>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateBoolExp>;
  userTenants?: InputMaybe<UserTenantsBoolExp>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateBoolExp>;
  userUserGroups?: InputMaybe<UserUserGroupsBoolExp>;
  userUserGroupsAggregate?: InputMaybe<UserUserGroupsAggregateBoolExp>;
  userUserSegments?: InputMaybe<UserUserSegmentsBoolExp>;
  userUserSegmentsAggregate?: InputMaybe<UserUserSegmentsAggregateBoolExp>;
};

/** unique or primary key constraints on table "users" */
export const UsersConstraint = {
  /** unique or primary key constraint on columns "coten_id" */
  UsersCotenIdKey: 'users_coten_id_key',
  /** unique or primary key constraint on columns "email" */
  UsersEmailKey: 'users_email_key',
  /** unique or primary key constraint on columns "id", "organization_id" */
  UsersIdOrganizationIdKey: 'users_id_organization_id_key',
  /** unique or primary key constraint on columns "locke_registration_id" */
  UsersLockeRegistrationIdKey: 'users_locke_registration_id_key',
  /** unique or primary key constraint on columns "id" */
  UsersPkey: 'users_pkey'
} as const;

export type UsersConstraint = typeof UsersConstraint[keyof typeof UsersConstraint];
/** input type for inserting data into table "users" */
export type UsersInsertInput = {
  cotenId?: InputMaybe<Scalars['uuid']['input']>;
  cotenLoginPreparationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lockeRegistrationEmail?: InputMaybe<Scalars['String']['input']>;
  lockeRegistrationId?: InputMaybe<Scalars['uuid']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  organization?: InputMaybe<OrganizationsObjRelInsertInput>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  userProductRoles?: InputMaybe<UserProductRolesArrRelInsertInput>;
  userTenants?: InputMaybe<UserTenantsArrRelInsertInput>;
  userUserGroups?: InputMaybe<UserUserGroupsArrRelInsertInput>;
  userUserSegments?: InputMaybe<UserUserSegmentsArrRelInsertInput>;
};

/** aggregate max on columns */
export type UsersMaxFields = {
  __typename?: 'UsersMaxFields';
  cotenId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lockeRegistrationEmail?: Maybe<Scalars['String']['output']>;
  lockeRegistrationId?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** aggregate min on columns */
export type UsersMinFields = {
  __typename?: 'UsersMinFields';
  cotenId?: Maybe<Scalars['uuid']['output']>;
  createdAt?: Maybe<Scalars['timestamptz']['output']>;
  deactivatedAt?: Maybe<Scalars['timestamptz']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['uuid']['output']>;
  lockeRegistrationEmail?: Maybe<Scalars['String']['output']>;
  lockeRegistrationId?: Maybe<Scalars['uuid']['output']>;
  memo?: Maybe<Scalars['String']['output']>;
  organizationId?: Maybe<Scalars['uuid']['output']>;
  photoUrl?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['timestamptz']['output']>;
};

/** response of any mutation on the table "users" */
export type UsersMutationResponse = {
  __typename?: 'UsersMutationResponse';
  /** number of rows affected by the mutation */
  affectedRows: Scalars['Int']['output'];
  /** data from the rows affected by the mutation */
  returning: Array<Users>;
};

/** input type for inserting object relation for remote table "users" */
export type UsersObjRelInsertInput = {
  data: UsersInsertInput;
  /** upsert condition */
  onConflict?: InputMaybe<UsersOnConflict>;
};

/** on_conflict condition type for table "users" */
export type UsersOnConflict = {
  constraint: UsersConstraint;
  updateColumns?: Array<UsersUpdateColumn>;
  where?: InputMaybe<UsersBoolExp>;
};

/** Ordering options when selecting data from "users". */
export type UsersOrderBy = {
  cotenId?: InputMaybe<OrderBy>;
  cotenLoginPreparationRequired?: InputMaybe<OrderBy>;
  createdAt?: InputMaybe<OrderBy>;
  deactivatedAt?: InputMaybe<OrderBy>;
  displayName?: InputMaybe<OrderBy>;
  email?: InputMaybe<OrderBy>;
  id?: InputMaybe<OrderBy>;
  lockeRegistrationEmail?: InputMaybe<OrderBy>;
  lockeRegistrationId?: InputMaybe<OrderBy>;
  memo?: InputMaybe<OrderBy>;
  organization?: InputMaybe<OrganizationsOrderBy>;
  organizationId?: InputMaybe<OrderBy>;
  photoUrl?: InputMaybe<OrderBy>;
  system?: InputMaybe<OrderBy>;
  updatedAt?: InputMaybe<OrderBy>;
  userProductRolesAggregate?: InputMaybe<UserProductRolesAggregateOrderBy>;
  userTenantsAggregate?: InputMaybe<UserTenantsAggregateOrderBy>;
  userUserGroupsAggregate?: InputMaybe<UserUserGroupsAggregateOrderBy>;
  userUserSegmentsAggregate?: InputMaybe<UserUserSegmentsAggregateOrderBy>;
};

/** primary key columns input for table: users */
export type UsersPkColumnsInput = {
  id: Scalars['uuid']['input'];
};

/** select columns of table "users" */
export const UsersSelectColumn = {
  /** column name */
  CotenId: 'cotenId',
  /** column name */
  CotenLoginPreparationRequired: 'cotenLoginPreparationRequired',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  DisplayName: 'displayName',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  LockeRegistrationEmail: 'lockeRegistrationEmail',
  /** column name */
  LockeRegistrationId: 'lockeRegistrationId',
  /** column name */
  Memo: 'memo',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  PhotoUrl: 'photoUrl',
  /** column name */
  System: 'system',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UsersSelectColumn = typeof UsersSelectColumn[keyof typeof UsersSelectColumn];
/** input type for updating data in table "users" */
export type UsersSetInput = {
  cotenId?: InputMaybe<Scalars['uuid']['input']>;
  cotenLoginPreparationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lockeRegistrationEmail?: InputMaybe<Scalars['String']['input']>;
  lockeRegistrationId?: InputMaybe<Scalars['uuid']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** Streaming cursor of the table "users" */
export type UsersStreamCursorInput = {
  /** Stream column input with initial value */
  initialValue: UsersStreamCursorValueInput;
  /** cursor ordering */
  ordering?: InputMaybe<CursorOrdering>;
};

/** Initial value of the column from where the streaming should start */
export type UsersStreamCursorValueInput = {
  cotenId?: InputMaybe<Scalars['uuid']['input']>;
  cotenLoginPreparationRequired?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['timestamptz']['input']>;
  deactivatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
  displayName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['uuid']['input']>;
  lockeRegistrationEmail?: InputMaybe<Scalars['String']['input']>;
  lockeRegistrationId?: InputMaybe<Scalars['uuid']['input']>;
  memo?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['uuid']['input']>;
  photoUrl?: InputMaybe<Scalars['String']['input']>;
  system?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']['input']>;
};

/** update columns of table "users" */
export const UsersUpdateColumn = {
  /** column name */
  CotenId: 'cotenId',
  /** column name */
  CotenLoginPreparationRequired: 'cotenLoginPreparationRequired',
  /** column name */
  CreatedAt: 'createdAt',
  /** column name */
  DeactivatedAt: 'deactivatedAt',
  /** column name */
  DisplayName: 'displayName',
  /** column name */
  Email: 'email',
  /** column name */
  Id: 'id',
  /** column name */
  LockeRegistrationEmail: 'lockeRegistrationEmail',
  /** column name */
  LockeRegistrationId: 'lockeRegistrationId',
  /** column name */
  Memo: 'memo',
  /** column name */
  OrganizationId: 'organizationId',
  /** column name */
  PhotoUrl: 'photoUrl',
  /** column name */
  System: 'system',
  /** column name */
  UpdatedAt: 'updatedAt'
} as const;

export type UsersUpdateColumn = typeof UsersUpdateColumn[keyof typeof UsersUpdateColumn];
export type UsersUpdates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<UsersSetInput>;
  /** filter the rows which have to be updated */
  where: UsersBoolExp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidArrayComparisonExp = {
  /** is the array contained in the given array value */
  _containedIn?: InputMaybe<Array<Scalars['uuid']['input']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _eq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _gte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _in?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _lte?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _neq?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _nin?: InputMaybe<Array<Array<Scalars['uuid']['input']>>>;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type UuidComparisonExp = {
  _eq?: InputMaybe<Scalars['uuid']['input']>;
  _gt?: InputMaybe<Scalars['uuid']['input']>;
  _gte?: InputMaybe<Scalars['uuid']['input']>;
  _in?: InputMaybe<Array<Scalars['uuid']['input']>>;
  _isNull?: InputMaybe<Scalars['Boolean']['input']>;
  _lt?: InputMaybe<Scalars['uuid']['input']>;
  _lte?: InputMaybe<Scalars['uuid']['input']>;
  _neq?: InputMaybe<Scalars['uuid']['input']>;
  _nin?: InputMaybe<Array<Scalars['uuid']['input']>>;
};

export type ValidateWorkerJobRerunInput = {
  jobId: Scalars['UUID']['input'];
  tenantId: Scalars['UUID']['input'];
};

export type ValidateWorkerJobRerunOutput = {
  __typename?: 'ValidateWorkerJobRerunOutput';
  dryRunSupported: Scalars['Boolean']['output'];
  reasons: Array<Scalars['String']['output']>;
  rerunnable: Scalars['Boolean']['output'];
};

export type ValidationError = {
  __typename?: 'ValidationError';
  code: Scalars['String']['output'];
  fields: Array<ValidationErrorField>;
  message: Scalars['String']['output'];
};

export type ValidationErrorField = {
  __typename?: 'ValidationErrorField';
  code?: Maybe<Scalars['String']['output']>;
  message: Scalars['String']['output'];
  path: Scalars['String']['output'];
};

export type WorkerCommandColumn = {
  __typename?: 'WorkerCommandColumn';
  defaultName: Scalars['String']['output'];
  key: Scalars['String']['output'];
};

export type WorkerCommandDefinition = {
  __typename?: 'WorkerCommandDefinition';
  argumentSchema: Scalars['JSONSchema']['output'];
  commandName: Scalars['String']['output'];
  description: Scalars['String']['output'];
  dryRunSupported: Scalars['Boolean']['output'];
  inputColumnKeys: Array<Scalars['String']['output']>;
  inputColumns: Array<WorkerCommandColumn>;
  outputColumnKeys: Array<Scalars['String']['output']>;
  outputColumns: Array<WorkerCommandColumn>;
  usageNotes: Array<Scalars['String']['output']>;
};

export type BatchChangeRequestReviewsJobRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestReviewsJobsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchChangeRequestsJobsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchEvidenceCommitsJobRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchEvidencesJobRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
  predicate: IntComparisonExp;
};

export type BatchEvidencesJobsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<BatchEvidencesJobsBoolExp>;
  predicate: IntComparisonExp;
};

export type CategoriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CategoriesBoolExp>;
  predicate: IntComparisonExp;
};

export type CategoryPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemCommitsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemRecordMetadataAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemRecordsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestRecordComposerDefinitionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestReviewsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestReviewsBoolExp>;
  predicate: IntComparisonExp;
};

export type ChangeRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ChangeRequestsBoolExp>;
  predicate: IntComparisonExp;
};

export type CompoundCompoundRecordsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CompoundCompoundRecordsBoolExp>;
  predicate: IntComparisonExp;
};

export type CountrySubdivisionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<CountrySubdivisionsBoolExp>;
  predicate: IntComparisonExp;
};

export type DataImportProjectStatusLogsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
  predicate: IntComparisonExp;
};

export type DataImportProjectUsersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataImportProjectUsersBoolExp>;
  predicate: IntComparisonExp;
};

export type DataSourceImportProjectsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataSourceImportProjectsBoolExp>;
  predicate: IntComparisonExp;
};

export type DataSourcePropertySchemaSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type DataSourceReferencesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataSourceReferencesBoolExp>;
  predicate: IntComparisonExp;
};

export type DataSourceTemplatePropertySchemaSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type DbpjkitWorkerJobRunsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidenceChangeRequestsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidenceChangeRequestsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidenceEvidenceSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidenceRecordGeoItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidenceSetImportProjectsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidenceVersionsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidenceVersionsBoolExp>;
  predicate: IntComparisonExp;
};

export type EvidencesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<EvidencesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<EvidencesBoolExp>;
  predicate: IntComparisonExp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  cnutActivateBatchChangeRequestsJob: BatchChangeRequestsJobActivateOutput;
  cnutActivateBatchEvidencesJob: BatchEvidencesJobActivateOutput;
  cnutActivateCategory: CategoryActivateOutput;
  cnutActivateDataImportProject: DataImportProjectActivateOutput;
  cnutActivateDataSource: DataSourceActivateOutput;
  cnutActivateDataSourceTemplate: DataSourceTemplateActivateOutput;
  cnutActivateEvidence: EvidenceActivateOutput;
  cnutActivateEvidenceImporter: EvidenceImporterActivateOutput;
  cnutActivateGeoItem: GeoItemOutput;
  cnutActivateProduct: ProductActivateOutput;
  cnutActivateRecordComposerDefinition: RecordComposerDefinitionActivateOutput;
  cnutActivateReference: ReferenceActivateOutput;
  cnutActivateRelationType: RelationTypeActivateOutput;
  cnutActivateTenant: TenantActivateResponse;
  cnutActivateUser: UserActivateOutput;
  cnutAddDataImportProjectMembers: DataImportProjectAddMembersResponse;
  cnutAddTenantMembers: TenantAddMembersResponse;
  cnutAddTenantProductMembers: TenantProductMemberAccessResponse;
  cnutAssignUserGroups: UserGroupAssignOutput;
  cnutAutofixDataSource: DataSourceAutofixOutput;
  cnutBatchCreateDataSourcesInImportProject: DataSourceInImportProjectBatchCreateResponse;
  cnutBatchUpdateDataSources: DataSourceBatchUpdateResponse;
  cnutBootstrapDataImportProject: DataImportProjectBootstrapResponse;
  cnutBootstrapDataImportProjectV2: BootstrapDataImportProjectV2Response;
  cnutBulkCreateUsersFromFile: BulkCreateUsersOutput;
  cnutCancelUserEmailChange: Scalars['Boolean']['output'];
  cnutClaspPushDataSourceGSheets: DataSourceGSheetsClaspPushOutput;
  cnutClaspPushSidebar: ClaspPushSidebarResponse;
  cnutCreateBatchChangeRequestsJob: BatchChangeRequestsJobCreateResponse;
  cnutCreateBatchEvidencesJob: BatchEvidencesJobCreateResponse;
  cnutCreateChangeRequest: ChangeRequestCreateOutput;
  cnutCreateChangeRequestReview: ChangeRequestReviewCreateResponse;
  cnutCreateCompoundRecordVersion: CompoundRecordVersionCreateResponse;
  cnutCreateDataImportProject: DataImportProjectCreateResponse;
  cnutCreateDataSourceInImportProject: DataSourceInImportProjectCreateResponse;
  cnutCreateDataSourceTemplate: DataSourceTemplateCreateResponse;
  cnutCreateEvidenceSetFromFile: EvidenceSetCreateResponse;
  cnutCreateEvidenceSetImportProject: EvidenceSetImportProjectCreateResponse;
  cnutCreateGeoItem: GeoItemOutput;
  cnutCreateGeoItemWithoutRecord: GeoItemOutput;
  cnutCreateOrganization: OrganizationCreateResponse;
  cnutCreateTenant: TenantCreateResponse;
  cnutCreateUser: UserCreateOutput;
  cnutCreateUserGroup: UserGroupCreateOutput;
  cnutDeactivateBatchChangeRequestsJob: BatchChangeRequestsJobDeactivateOutput;
  cnutDeactivateBatchEvidencesJob: BatchEvidencesJobDeactivateOutput;
  cnutDeactivateCategory: CategoryDeactivateResponse;
  cnutDeactivateDataImportProject: DataImportProjectDeactivateOutput;
  cnutDeactivateDataSource: DataSourceDeactivateOutput;
  cnutDeactivateDataSourceTemplate: DataSourceTemplateDeactivateOutput;
  cnutDeactivateEvidence: EvidenceDeactivateOutput;
  cnutDeactivateEvidenceImporter: EvidenceImporterDeactivateOutput;
  cnutDeactivateGeoItem: GeoItemOutput;
  cnutDeactivateProduct: ProductDeactivateOutput;
  cnutDeactivateRecordComposerDefinition: RecordComposerDefinitionDeactivateOutput;
  cnutDeactivateRecordGeoItem: RecordGeoItemOutput;
  cnutDeactivateReference: ReferenceDeactivateOutput;
  cnutDeactivateRelationType: RelationTypeDeactivateOutput;
  cnutDeactivateTenant: TenantDeactivateResponse;
  cnutDeactivateUser: UserDeactivateOutput;
  cnutDeleteCompoundRecordComposer: CompoundRecordComposerDeleteResponse;
  cnutDeleteEvidenceSetImportProject: EvidenceSetImportProjectDeleteResponse;
  cnutExportEvidenceSet: EvidenceSetExportResponse;
  cnutHandleReferenceFileEvent: ReferenceFileEventHandleOutput;
  cnutImportDirect: UserDataImportResponse;
  cnutImportDirectAttributed: ImportDirectAttributedResponse;
  cnutInstallTenantProduct: TenantInstallProductResponse;
  cnutInvokeApplySchema: ApplySchemaInvokeResponse;
  cnutInvokeDataImportJobDiagnosis: CnutInvokeDataImportJobDiagnosisPayload;
  cnutInvokeForceOnEdit: ForceOnEditInvokeResponse;
  cnutInvokeWorker: InvokeWorkerResponse;
  cnutPrepareEventNormalizationImport: PrepareEventNormalizationImportResponse;
  cnutPrepareUserLogin: UserUpdateOutput;
  cnutProceedRecordUpdateDataImportProject: RecordUpdateProceedOutput;
  cnutRefreshUserEmailChange?: Maybe<UserEmailChangeOutput>;
  cnutRemoveTenantMembers: TenantRemoveMembersResponse;
  cnutRemoveTenantProductMemberAccess: TenantProductMemberAccessResponse;
  cnutRemoveUserProductRole: UserProductRoleResponse;
  cnutRequestUserEmailChange: UserEmailChangeOutput;
  cnutRerunWorkerJob: RerunWorkerJobResponse;
  cnutSetUserProductRole: UserProductRoleResponse;
  cnutSubmitBatchChangeRequestReviewsJob: BatchChangeRequestReviewsJobSubmitResponse;
  cnutSubmitBatchChangeRequestsJob: BatchChangeRequestsJobSubmitResponse;
  cnutSubmitBatchEvidenceCommitsJob: BatchEvidenceCommitsJobSubmitResponse;
  cnutSubmitBatchEvidencesJob: BatchEvidencesJobSubmitResponse;
  cnutSubmitCategorySchemaMigration: CategorySchemaMigrationSubmitResponse;
  cnutSubmitDataImportPipelineJob: DataImportPipelineJobSubmitResponse;
  cnutSubmitReferenceFileJob: ReferenceFileJobSubmitOutput;
  cnutUpdateBatchChangeRequestReviewsJobRun: BatchChangeRequestReviewsJobRunUpdateOutput;
  cnutUpdateBatchChangeRequestsJob: BatchChangeRequestsJobUpdateResponse;
  cnutUpdateBatchChangeRequestsJobRun: BatchChangeRequestsJobRunUpdateOutput;
  cnutUpdateBatchEvidencesJob: BatchEvidencesJobUpdateResponse;
  cnutUpdateBatchEvidencesJobRun: BatchEvidencesJobRunUpdateOutput;
  cnutUpdateDataImportProject: DataImportProjectUpdateOutput;
  cnutUpdateDataImportProjectStatus: DataImportProjectStatusUpdateOutput;
  cnutUpdateDataSource: DataSourceUpdateResponse;
  cnutUpdateDataSourceJsonData: DataSourceJsonDataUpdateResponse;
  cnutUpdateDataSourceTemplate: DataSourceTemplateUpdateResponse;
  cnutUpdateEvidenceSet: EvidenceSetUpdateResponse;
  cnutUpdateGeoItem: GeoItemOutput;
  cnutUpdateJobRun: JobRunUpdateResponse;
  cnutUpdateMyProfile: UserProfileUpdateResponse;
  cnutUpdateMyProfileImage: UserProfileImageUpdateResponse;
  cnutUpdateProductAvailableRoles: UpdateProductAvailableRolesOutput;
  cnutUpdateRecordGeoItem: RecordGeoItemOutput;
  cnutUpdateRecordMetadataSchema: RecordMetadataSchemaUpdateOutput;
  cnutUpdateRecordUpdateComposerDefinition: UpdateRecordUpdateComposerDefinitionOutput;
  cnutUpdateReferenceFile: ReferenceFileUpdateOutput;
  cnutUpdateTenant: TenantUpdateResponse;
  cnutUpdateTenantMemberRole: TenantUpdateMemberRoleResponse;
  cnutUpdateTenantOwner: TenantUpdateOwnerResponse;
  cnutUpdateTenantProductMemberAccess: TenantProductMemberAccessResponse;
  cnutUpdateTenantProductVisibility: TenantUpdateProductVisibilityResponse;
  cnutUpdateUser: UserUpdateOutput;
  cnutUpdateUserGroup: UserGroupUpdateOutput;
  cnutUpdateUserOrganization: UserUpdateOrganizationResponse;
  cnutUploadCompoundRecordComposersFile: CompoundRecordComposerFileUploadResponse;
  cnutUpsertCategory: CategoryUpsertResponse;
  cnutUpsertEntityComposerDefinition: RecordComposerDefinitionUpsertResponse;
  cnutUpsertEvidenceImporter: EvidenceImporterUpsertResponse;
  cnutUpsertProduct: ProductUpsertResponse;
  cnutUpsertReference: ReferenceUpsertOutput;
  cnutUpsertRelationComposerDefinition: RecordComposerDefinitionUpsertResponse;
  cnutUpsertRelationType: RelationTypeUpsertOutput;
  /** delete data from the table: "area_codes" */
  deleteAreaCodes?: Maybe<AreaCodesMutationResponse>;
  /** delete single row from the table: "area_codes" */
  deleteAreaCodesByPk?: Maybe<AreaCodes>;
  /** delete data from the table: "batch_change_request_reviews_job_runs" */
  deleteBatchChangeRequestReviewsJobRuns?: Maybe<BatchChangeRequestReviewsJobRunsMutationResponse>;
  /** delete single row from the table: "batch_change_request_reviews_job_runs" */
  deleteBatchChangeRequestReviewsJobRunsByPk?: Maybe<BatchChangeRequestReviewsJobRuns>;
  /** delete data from the table: "batch_change_request_reviews_jobs" */
  deleteBatchChangeRequestReviewsJobs?: Maybe<BatchChangeRequestReviewsJobsMutationResponse>;
  /** delete single row from the table: "batch_change_request_reviews_jobs" */
  deleteBatchChangeRequestReviewsJobsByPk?: Maybe<BatchChangeRequestReviewsJobs>;
  /** delete data from the table: "batch_change_requests_job_record_composer_definitions" */
  deleteBatchChangeRequestsJobRecordComposerDefinitions?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "batch_change_requests_job_record_composer_definitions" */
  deleteBatchChangeRequestsJobRecordComposerDefinitionsByPk?: Maybe<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** delete data from the table: "batch_change_requests_job_runs" */
  deleteBatchChangeRequestsJobRuns?: Maybe<BatchChangeRequestsJobRunsMutationResponse>;
  /** delete single row from the table: "batch_change_requests_job_runs" */
  deleteBatchChangeRequestsJobRunsByPk?: Maybe<BatchChangeRequestsJobRuns>;
  /** delete data from the table: "batch_change_requests_jobs" */
  deleteBatchChangeRequestsJobs?: Maybe<BatchChangeRequestsJobsMutationResponse>;
  /** delete single row from the table: "batch_change_requests_jobs" */
  deleteBatchChangeRequestsJobsByPk?: Maybe<BatchChangeRequestsJobs>;
  /** delete data from the table: "batch_evidence_commits_job_runs" */
  deleteBatchEvidenceCommitsJobRuns?: Maybe<BatchEvidenceCommitsJobRunsMutationResponse>;
  /** delete single row from the table: "batch_evidence_commits_job_runs" */
  deleteBatchEvidenceCommitsJobRunsByPk?: Maybe<BatchEvidenceCommitsJobRuns>;
  /** delete data from the table: "batch_evidence_commits_jobs" */
  deleteBatchEvidenceCommitsJobs?: Maybe<BatchEvidenceCommitsJobsMutationResponse>;
  /** delete single row from the table: "batch_evidence_commits_jobs" */
  deleteBatchEvidenceCommitsJobsByPk?: Maybe<BatchEvidenceCommitsJobs>;
  /** delete data from the table: "batch_evidences_job_runs" */
  deleteBatchEvidencesJobRuns?: Maybe<BatchEvidencesJobRunsMutationResponse>;
  /** delete single row from the table: "batch_evidences_job_runs" */
  deleteBatchEvidencesJobRunsByPk?: Maybe<BatchEvidencesJobRuns>;
  /** delete data from the table: "batch_evidences_jobs" */
  deleteBatchEvidencesJobs?: Maybe<BatchEvidencesJobsMutationResponse>;
  /** delete single row from the table: "batch_evidences_jobs" */
  deleteBatchEvidencesJobsByPk?: Maybe<BatchEvidencesJobs>;
  /** delete data from the table: "categories" */
  deleteCategories?: Maybe<CategoriesMutationResponse>;
  /** delete single row from the table: "categories" */
  deleteCategoriesByPk?: Maybe<Categories>;
  /** delete data from the table: "category_paths" */
  deleteCategoryPaths?: Maybe<CategoryPathsMutationResponse>;
  /** delete single row from the table: "category_paths" */
  deleteCategoryPathsByPk?: Maybe<CategoryPaths>;
  /** delete data from the table: "category_property_schema_sets" */
  deleteCategoryPropertySchemaSets?: Maybe<CategoryPropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "category_property_schema_sets" */
  deleteCategoryPropertySchemaSetsByPk?: Maybe<CategoryPropertySchemaSets>;
  /** delete data from the table: "category_types" */
  deleteCategoryTypes?: Maybe<CategoryTypesMutationResponse>;
  /** delete single row from the table: "category_types" */
  deleteCategoryTypesByPk?: Maybe<CategoryTypes>;
  /** delete data from the table: "change_request_commits" */
  deleteChangeRequestCommits?: Maybe<ChangeRequestCommitsMutationResponse>;
  /** delete single row from the table: "change_request_commits" */
  deleteChangeRequestCommitsByPk?: Maybe<ChangeRequestCommits>;
  /** delete data from the table: "change_request_item_commits" */
  deleteChangeRequestItemCommits?: Maybe<ChangeRequestItemCommitsMutationResponse>;
  /** delete single row from the table: "change_request_item_commits" */
  deleteChangeRequestItemCommitsByPk?: Maybe<ChangeRequestItemCommits>;
  /** delete data from the table: "change_request_item_record_metadata" */
  deleteChangeRequestItemRecordMetadata?: Maybe<ChangeRequestItemRecordMetadataMutationResponse>;
  /** delete single row from the table: "change_request_item_record_metadata" */
  deleteChangeRequestItemRecordMetadataByPk?: Maybe<ChangeRequestItemRecordMetadata>;
  /** delete data from the table: "change_request_item_records" */
  deleteChangeRequestItemRecords?: Maybe<ChangeRequestItemRecordsMutationResponse>;
  /** delete single row from the table: "change_request_item_records" */
  deleteChangeRequestItemRecordsByPk?: Maybe<ChangeRequestItemRecords>;
  /** delete data from the table: "change_request_items" */
  deleteChangeRequestItems?: Maybe<ChangeRequestItemsMutationResponse>;
  /** delete single row from the table: "change_request_items" */
  deleteChangeRequestItemsByPk?: Maybe<ChangeRequestItems>;
  /** delete data from the table: "change_request_record_composer_definitions" */
  deleteChangeRequestRecordComposerDefinitions?: Maybe<ChangeRequestRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "change_request_record_composer_definitions" */
  deleteChangeRequestRecordComposerDefinitionsByPk?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** delete data from the table: "change_request_review_types" */
  deleteChangeRequestReviewTypes?: Maybe<ChangeRequestReviewTypesMutationResponse>;
  /** delete single row from the table: "change_request_review_types" */
  deleteChangeRequestReviewTypesByPk?: Maybe<ChangeRequestReviewTypes>;
  /** delete data from the table: "change_request_reviews" */
  deleteChangeRequestReviews?: Maybe<ChangeRequestReviewsMutationResponse>;
  /** delete single row from the table: "change_request_reviews" */
  deleteChangeRequestReviewsByPk?: Maybe<ChangeRequestReviews>;
  /** delete data from the table: "change_request_statuses" */
  deleteChangeRequestStatuses?: Maybe<ChangeRequestStatusesMutationResponse>;
  /** delete single row from the table: "change_request_statuses" */
  deleteChangeRequestStatusesByPk?: Maybe<ChangeRequestStatuses>;
  /** delete data from the table: "change_requests" */
  deleteChangeRequests?: Maybe<ChangeRequestsMutationResponse>;
  /** delete single row from the table: "change_requests" */
  deleteChangeRequestsByPk?: Maybe<ChangeRequests>;
  /** delete data from the table: "compound.compound_records" */
  deleteCompoundCompoundRecords?: Maybe<CompoundCompoundRecordsMutationResponse>;
  /** delete single row from the table: "compound.compound_records" */
  deleteCompoundCompoundRecordsByPk?: Maybe<CompoundCompoundRecords>;
  /** delete data from the table: "compound_record_composers" */
  deleteCompoundRecordComposers?: Maybe<CompoundRecordComposersMutationResponse>;
  /** delete single row from the table: "compound_record_composers" */
  deleteCompoundRecordComposersByPk?: Maybe<CompoundRecordComposers>;
  /** delete data from the table: "compound_record_versions" */
  deleteCompoundRecordVersions?: Maybe<CompoundRecordVersionsMutationResponse>;
  /** delete single row from the table: "compound_record_versions" */
  deleteCompoundRecordVersionsByPk?: Maybe<CompoundRecordVersions>;
  /** delete data from the table: "countries" */
  deleteCountries?: Maybe<CountriesMutationResponse>;
  /** delete single row from the table: "countries" */
  deleteCountriesByPk?: Maybe<Countries>;
  /** delete data from the table: "country_subdivisions" */
  deleteCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** delete single row from the table: "country_subdivisions" */
  deleteCountrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** delete data from the table: "data_import_project_record_composer_definitions" */
  deleteDataImportProjectRecordComposerDefinitions?: Maybe<DataImportProjectRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "data_import_project_record_composer_definitions" */
  deleteDataImportProjectRecordComposerDefinitionsByPk?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** delete data from the table: "data_import_project_status_logs" */
  deleteDataImportProjectStatusLogs?: Maybe<DataImportProjectStatusLogsMutationResponse>;
  /** delete single row from the table: "data_import_project_status_logs" */
  deleteDataImportProjectStatusLogsByPk?: Maybe<DataImportProjectStatusLogs>;
  /** delete data from the table: "data_import_project_statuses" */
  deleteDataImportProjectStatuses?: Maybe<DataImportProjectStatusesMutationResponse>;
  /** delete single row from the table: "data_import_project_statuses" */
  deleteDataImportProjectStatusesByPk?: Maybe<DataImportProjectStatuses>;
  /** delete data from the table: "data_import_project_users" */
  deleteDataImportProjectUsers?: Maybe<DataImportProjectUsersMutationResponse>;
  /** delete single row from the table: "data_import_project_users" */
  deleteDataImportProjectUsersByPk?: Maybe<DataImportProjectUsers>;
  /** delete data from the table: "data_import_projects" */
  deleteDataImportProjects?: Maybe<DataImportProjectsMutationResponse>;
  /** delete single row from the table: "data_import_projects" */
  deleteDataImportProjectsByPk?: Maybe<DataImportProjects>;
  /** delete data from the table: "data_source_gsheets" */
  deleteDataSourceGsheets?: Maybe<DataSourceGsheetsMutationResponse>;
  /** delete single row from the table: "data_source_gsheets" */
  deleteDataSourceGsheetsByPk?: Maybe<DataSourceGsheets>;
  /** delete data from the table: "data_source_import_project_record_composer_definitions" */
  deleteDataSourceImportProjectRecordComposerDefinitions?: Maybe<DataSourceImportProjectRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "data_source_import_project_record_composer_definitions" */
  deleteDataSourceImportProjectRecordComposerDefinitionsByPk?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  /** delete data from the table: "data_source_import_projects" */
  deleteDataSourceImportProjects?: Maybe<DataSourceImportProjectsMutationResponse>;
  /** delete single row from the table: "data_source_import_projects" */
  deleteDataSourceImportProjectsByPk?: Maybe<DataSourceImportProjects>;
  /** delete data from the table: "data_source_jsons" */
  deleteDataSourceJsons?: Maybe<DataSourceJsonsMutationResponse>;
  /** delete single row from the table: "data_source_jsons" */
  deleteDataSourceJsonsByPk?: Maybe<DataSourceJsons>;
  /** delete data from the table: "data_source_property_schema_sets" */
  deleteDataSourcePropertySchemaSets?: Maybe<DataSourcePropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "data_source_property_schema_sets" */
  deleteDataSourcePropertySchemaSetsByPk?: Maybe<DataSourcePropertySchemaSets>;
  /** delete data from the table: "data_source_references" */
  deleteDataSourceReferences?: Maybe<DataSourceReferencesMutationResponse>;
  /** delete single row from the table: "data_source_references" */
  deleteDataSourceReferencesByPk?: Maybe<DataSourceReferences>;
  /** delete data from the table: "data_source_template_property_schema_sets" */
  deleteDataSourceTemplatePropertySchemaSets?: Maybe<DataSourceTemplatePropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "data_source_template_property_schema_sets" */
  deleteDataSourceTemplatePropertySchemaSetsByPk?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** delete data from the table: "data_source_templates" */
  deleteDataSourceTemplates?: Maybe<DataSourceTemplatesMutationResponse>;
  /** delete single row from the table: "data_source_templates" */
  deleteDataSourceTemplatesByPk?: Maybe<DataSourceTemplates>;
  /** delete data from the table: "data_sources" */
  deleteDataSources?: Maybe<DataSourcesMutationResponse>;
  /** delete single row from the table: "data_sources" */
  deleteDataSourcesByPk?: Maybe<DataSources>;
  /** delete data from the table: "dbpjkit_worker_job_runs" */
  deleteDbpjkitWorkerJobRuns?: Maybe<DbpjkitWorkerJobRunsMutationResponse>;
  /** delete single row from the table: "dbpjkit_worker_job_runs" */
  deleteDbpjkitWorkerJobRunsByPk?: Maybe<DbpjkitWorkerJobRuns>;
  /** delete data from the table: "dbpjkit_worker_jobs" */
  deleteDbpjkitWorkerJobs?: Maybe<DbpjkitWorkerJobsMutationResponse>;
  /** delete single row from the table: "dbpjkit_worker_jobs" */
  deleteDbpjkitWorkerJobsByPk?: Maybe<DbpjkitWorkerJobs>;
  /** delete data from the table: "entity_record_composer_definitions" */
  deleteEntityRecordComposerDefinitions?: Maybe<EntityRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "entity_record_composer_definitions" */
  deleteEntityRecordComposerDefinitionsByPk?: Maybe<EntityRecordComposerDefinitions>;
  /** delete data from the table: "entity_records" */
  deleteEntityRecords?: Maybe<EntityRecordsMutationResponse>;
  /** delete single row from the table: "entity_records" */
  deleteEntityRecordsByPk?: Maybe<EntityRecords>;
  /** delete data from the table: "evidence_change_requests" */
  deleteEvidenceChangeRequests?: Maybe<EvidenceChangeRequestsMutationResponse>;
  /** delete single row from the table: "evidence_change_requests" */
  deleteEvidenceChangeRequestsByPk?: Maybe<EvidenceChangeRequests>;
  /** delete data from the table: "evidence_evidence_sets" */
  deleteEvidenceEvidenceSets?: Maybe<EvidenceEvidenceSetsMutationResponse>;
  /** delete single row from the table: "evidence_evidence_sets" */
  deleteEvidenceEvidenceSetsByPk?: Maybe<EvidenceEvidenceSets>;
  /** delete data from the table: "evidence_importers" */
  deleteEvidenceImporters?: Maybe<EvidenceImportersMutationResponse>;
  /** delete single row from the table: "evidence_importers" */
  deleteEvidenceImportersByPk?: Maybe<EvidenceImporters>;
  /** delete data from the table: "evidence_record_geo_items" */
  deleteEvidenceRecordGeoItems?: Maybe<EvidenceRecordGeoItemsMutationResponse>;
  /** delete single row from the table: "evidence_record_geo_items" */
  deleteEvidenceRecordGeoItemsByPk?: Maybe<EvidenceRecordGeoItems>;
  /** delete data from the table: "evidence_set_import_projects" */
  deleteEvidenceSetImportProjects?: Maybe<EvidenceSetImportProjectsMutationResponse>;
  /** delete single row from the table: "evidence_set_import_projects" */
  deleteEvidenceSetImportProjectsByPk?: Maybe<EvidenceSetImportProjects>;
  /** delete data from the table: "evidence_set_property_schema_sets" */
  deleteEvidenceSetPropertySchemaSets?: Maybe<EvidenceSetPropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "evidence_set_property_schema_sets" */
  deleteEvidenceSetPropertySchemaSetsByPk?: Maybe<EvidenceSetPropertySchemaSets>;
  /** delete data from the table: "evidence_sets" */
  deleteEvidenceSets?: Maybe<EvidenceSetsMutationResponse>;
  /** delete single row from the table: "evidence_sets" */
  deleteEvidenceSetsByPk?: Maybe<EvidenceSets>;
  /** delete data from the table: "evidence_versions" */
  deleteEvidenceVersions?: Maybe<EvidenceVersionsMutationResponse>;
  /** delete single row from the table: "evidence_versions" */
  deleteEvidenceVersionsByPk?: Maybe<EvidenceVersions>;
  /** delete data from the table: "evidences" */
  deleteEvidences?: Maybe<EvidencesMutationResponse>;
  /** delete single row from the table: "evidences" */
  deleteEvidencesByPk?: Maybe<Evidences>;
  /** delete data from the table: "job_run_statuses" */
  deleteJobRunStatuses?: Maybe<JobRunStatusesMutationResponse>;
  /** delete single row from the table: "job_run_statuses" */
  deleteJobRunStatusesByPk?: Maybe<JobRunStatuses>;
  /** delete data from the table: "organization_kinds" */
  deleteOrganizationKinds?: Maybe<OrganizationKindsMutationResponse>;
  /** delete single row from the table: "organization_kinds" */
  deleteOrganizationKindsByPk?: Maybe<OrganizationKinds>;
  /** delete data from the table: "organizations" */
  deleteOrganizations?: Maybe<OrganizationsMutationResponse>;
  /** delete single row from the table: "organizations" */
  deleteOrganizationsByPk?: Maybe<Organizations>;
  /** delete data from the table: "product_roles" */
  deleteProductRoles?: Maybe<ProductRolesMutationResponse>;
  /** delete single row from the table: "product_roles" */
  deleteProductRolesByPk?: Maybe<ProductRoles>;
  /** delete data from the table: "products" */
  deleteProducts?: Maybe<ProductsMutationResponse>;
  /** delete single row from the table: "products" */
  deleteProductsByPk?: Maybe<Products>;
  /** delete data from the table: "property_schema_associations" */
  deletePropertySchemaAssociations?: Maybe<PropertySchemaAssociationsMutationResponse>;
  /** delete single row from the table: "property_schema_associations" */
  deletePropertySchemaAssociationsByPk?: Maybe<PropertySchemaAssociations>;
  /** delete data from the table: "property_schema_sets" */
  deletePropertySchemaSets?: Maybe<PropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "property_schema_sets" */
  deletePropertySchemaSetsByPk?: Maybe<PropertySchemaSets>;
  /** delete data from the table: "property_schemas" */
  deletePropertySchemas?: Maybe<PropertySchemasMutationResponse>;
  /** delete single row from the table: "property_schemas" */
  deletePropertySchemasByPk?: Maybe<PropertySchemas>;
  /** delete data from the table: "property_types" */
  deletePropertyTypes?: Maybe<PropertyTypesMutationResponse>;
  /** delete single row from the table: "property_types" */
  deletePropertyTypesByPk?: Maybe<PropertyTypes>;
  /** delete data from the table: "publishers" */
  deletePublishers?: Maybe<PublishersMutationResponse>;
  /** delete single row from the table: "publishers" */
  deletePublishersByPk?: Maybe<Publishers>;
  /** delete data from the table: "record_composer_definition_evidence_sets" */
  deleteRecordComposerDefinitionEvidenceSets?: Maybe<RecordComposerDefinitionEvidenceSetsMutationResponse>;
  /** delete single row from the table: "record_composer_definition_evidence_sets" */
  deleteRecordComposerDefinitionEvidenceSetsByPk?: Maybe<RecordComposerDefinitionEvidenceSets>;
  /** delete data from the table: "record_composer_definition_property_schema_sets" */
  deleteRecordComposerDefinitionPropertySchemaSets?: Maybe<RecordComposerDefinitionPropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "record_composer_definition_property_schema_sets" */
  deleteRecordComposerDefinitionPropertySchemaSetsByPk?: Maybe<RecordComposerDefinitionPropertySchemaSets>;
  /** delete data from the table: "record_composer_definitions" */
  deleteRecordComposerDefinitions?: Maybe<RecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "record_composer_definitions" */
  deleteRecordComposerDefinitionsByPk?: Maybe<RecordComposerDefinitions>;
  /** delete data from the table: "record_compound_record_composers" */
  deleteRecordCompoundRecordComposers?: Maybe<RecordCompoundRecordComposersMutationResponse>;
  /** delete single row from the table: "record_compound_record_composers" */
  deleteRecordCompoundRecordComposersByPk?: Maybe<RecordCompoundRecordComposers>;
  /** delete data from the table: "record_geo_items" */
  deleteRecordGeoItems?: Maybe<RecordGeoItemsMutationResponse>;
  /** delete single row from the table: "record_geo_items" */
  deleteRecordGeoItemsByPk?: Maybe<RecordGeoItems>;
  /** delete data from the table: "record_metadata" */
  deleteRecordMetadata?: Maybe<RecordMetadataMutationResponse>;
  /** delete single row from the table: "record_metadata" */
  deleteRecordMetadataByPk?: Maybe<RecordMetadata>;
  /** delete data from the table: "record_metadata_categories" */
  deleteRecordMetadataCategories?: Maybe<RecordMetadataCategoriesMutationResponse>;
  /** delete single row from the table: "record_metadata_categories" */
  deleteRecordMetadataCategoriesByPk?: Maybe<RecordMetadataCategories>;
  /** delete data from the table: "record_metadata_property_schema_sets" */
  deleteRecordMetadataPropertySchemaSets?: Maybe<RecordMetadataPropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "record_metadata_property_schema_sets" */
  deleteRecordMetadataPropertySchemaSetsByPk?: Maybe<RecordMetadataPropertySchemaSets>;
  /** delete data from the table: "record_property_schema_sets" */
  deleteRecordPropertySchemaSets?: Maybe<RecordPropertySchemaSetsMutationResponse>;
  /** delete single row from the table: "record_property_schema_sets" */
  deleteRecordPropertySchemaSetsByPk?: Maybe<RecordPropertySchemaSets>;
  /** delete data from the table: "record_update_record_composer_definitions" */
  deleteRecordUpdateRecordComposerDefinitions?: Maybe<RecordUpdateRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "record_update_record_composer_definitions" */
  deleteRecordUpdateRecordComposerDefinitionsByPk?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** delete data from the table: "records" */
  deleteRecords?: Maybe<RecordsMutationResponse>;
  /** delete single row from the table: "records" */
  deleteRecordsByPk?: Maybe<Records>;
  /** delete data from the table: "reference_files" */
  deleteReferenceFiles?: Maybe<ReferenceFilesMutationResponse>;
  /** delete single row from the table: "reference_files" */
  deleteReferenceFilesByPk?: Maybe<ReferenceFiles>;
  /** delete data from the table: "reference_publishers" */
  deleteReferencePublishers?: Maybe<ReferencePublishersMutationResponse>;
  /** delete single row from the table: "reference_publishers" */
  deleteReferencePublishersByPk?: Maybe<ReferencePublishers>;
  /** delete data from the table: "references" */
  deleteReferences?: Maybe<ReferencesMutationResponse>;
  /** delete single row from the table: "references" */
  deleteReferencesByPk?: Maybe<References>;
  /** delete data from the table: "relation_record_composer_definitions" */
  deleteRelationRecordComposerDefinitions?: Maybe<RelationRecordComposerDefinitionsMutationResponse>;
  /** delete single row from the table: "relation_record_composer_definitions" */
  deleteRelationRecordComposerDefinitionsByPk?: Maybe<RelationRecordComposerDefinitions>;
  /** delete data from the table: "relation_records" */
  deleteRelationRecords?: Maybe<RelationRecordsMutationResponse>;
  /** delete single row from the table: "relation_records" */
  deleteRelationRecordsByPk?: Maybe<RelationRecords>;
  /** delete data from the table: "relation_types" */
  deleteRelationTypes?: Maybe<RelationTypesMutationResponse>;
  /** delete single row from the table: "relation_types" */
  deleteRelationTypesByPk?: Maybe<RelationTypes>;
  /** delete data from the table: "roles" */
  deleteRoles?: Maybe<RolesMutationResponse>;
  /** delete single row from the table: "roles" */
  deleteRolesByPk?: Maybe<Roles>;
  /** delete data from the table: "source_record_edges" */
  deleteSourceRecordEdges?: Maybe<SourceRecordEdgesMutationResponse>;
  /** delete single row from the table: "source_record_edges" */
  deleteSourceRecordEdgesByPk?: Maybe<SourceRecordEdges>;
  /** delete data from the table: "target_record_edges" */
  deleteTargetRecordEdges?: Maybe<TargetRecordEdgesMutationResponse>;
  /** delete single row from the table: "target_record_edges" */
  deleteTargetRecordEdgesByPk?: Maybe<TargetRecordEdges>;
  /** delete data from the table: "tenant_product_installations" */
  deleteTenantProductInstallations?: Maybe<TenantProductInstallationsMutationResponse>;
  /** delete single row from the table: "tenant_product_installations" */
  deleteTenantProductInstallationsByPk?: Maybe<TenantProductInstallations>;
  /** delete data from the table: "tenants" */
  deleteTenants?: Maybe<TenantsMutationResponse>;
  /** delete single row from the table: "tenants" */
  deleteTenantsByPk?: Maybe<Tenants>;
  /** delete data from the table: "unified_evidence_drafts" */
  deleteUnifiedEvidenceDrafts?: Maybe<UnifiedEvidenceDraftsMutationResponse>;
  /** delete single row from the table: "unified_evidence_drafts" */
  deleteUnifiedEvidenceDraftsByPk?: Maybe<UnifiedEvidenceDrafts>;
  /** delete data from the table: "user_groups" */
  deleteUserGroups?: Maybe<UserGroupsMutationResponse>;
  /** delete single row from the table: "user_groups" */
  deleteUserGroupsByPk?: Maybe<UserGroups>;
  /** delete data from the table: "user_product_roles" */
  deleteUserProductRoles?: Maybe<UserProductRolesMutationResponse>;
  /** delete single row from the table: "user_product_roles" */
  deleteUserProductRolesByPk?: Maybe<UserProductRoles>;
  /** delete data from the table: "user_segments" */
  deleteUserSegments?: Maybe<UserSegmentsMutationResponse>;
  /** delete single row from the table: "user_segments" */
  deleteUserSegmentsByPk?: Maybe<UserSegments>;
  /** delete data from the table: "user_tenants" */
  deleteUserTenants?: Maybe<UserTenantsMutationResponse>;
  /** delete single row from the table: "user_tenants" */
  deleteUserTenantsByPk?: Maybe<UserTenants>;
  /** delete data from the table: "user_user_groups" */
  deleteUserUserGroups?: Maybe<UserUserGroupsMutationResponse>;
  /** delete single row from the table: "user_user_groups" */
  deleteUserUserGroupsByPk?: Maybe<UserUserGroups>;
  /** delete data from the table: "user_user_segments" */
  deleteUserUserSegments?: Maybe<UserUserSegmentsMutationResponse>;
  /** delete single row from the table: "user_user_segments" */
  deleteUserUserSegmentsByPk?: Maybe<UserUserSegments>;
  /** delete data from the table: "users" */
  deleteUsers?: Maybe<UsersMutationResponse>;
  /** delete single row from the table: "users" */
  deleteUsersByPk?: Maybe<Users>;
  /** insert data into the table: "area_codes" */
  insertAreaCodes?: Maybe<AreaCodesMutationResponse>;
  /** insert a single row into the table: "area_codes" */
  insertAreaCodesOne?: Maybe<AreaCodes>;
  /** insert data into the table: "batch_change_request_reviews_job_runs" */
  insertBatchChangeRequestReviewsJobRuns?: Maybe<BatchChangeRequestReviewsJobRunsMutationResponse>;
  /** insert a single row into the table: "batch_change_request_reviews_job_runs" */
  insertBatchChangeRequestReviewsJobRunsOne?: Maybe<BatchChangeRequestReviewsJobRuns>;
  /** insert data into the table: "batch_change_request_reviews_jobs" */
  insertBatchChangeRequestReviewsJobs?: Maybe<BatchChangeRequestReviewsJobsMutationResponse>;
  /** insert a single row into the table: "batch_change_request_reviews_jobs" */
  insertBatchChangeRequestReviewsJobsOne?: Maybe<BatchChangeRequestReviewsJobs>;
  /** insert data into the table: "batch_change_requests_job_record_composer_definitions" */
  insertBatchChangeRequestsJobRecordComposerDefinitions?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "batch_change_requests_job_record_composer_definitions" */
  insertBatchChangeRequestsJobRecordComposerDefinitionsOne?: Maybe<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** insert data into the table: "batch_change_requests_job_runs" */
  insertBatchChangeRequestsJobRuns?: Maybe<BatchChangeRequestsJobRunsMutationResponse>;
  /** insert a single row into the table: "batch_change_requests_job_runs" */
  insertBatchChangeRequestsJobRunsOne?: Maybe<BatchChangeRequestsJobRuns>;
  /** insert data into the table: "batch_change_requests_jobs" */
  insertBatchChangeRequestsJobs?: Maybe<BatchChangeRequestsJobsMutationResponse>;
  /** insert a single row into the table: "batch_change_requests_jobs" */
  insertBatchChangeRequestsJobsOne?: Maybe<BatchChangeRequestsJobs>;
  /** insert data into the table: "batch_evidence_commits_job_runs" */
  insertBatchEvidenceCommitsJobRuns?: Maybe<BatchEvidenceCommitsJobRunsMutationResponse>;
  /** insert a single row into the table: "batch_evidence_commits_job_runs" */
  insertBatchEvidenceCommitsJobRunsOne?: Maybe<BatchEvidenceCommitsJobRuns>;
  /** insert data into the table: "batch_evidence_commits_jobs" */
  insertBatchEvidenceCommitsJobs?: Maybe<BatchEvidenceCommitsJobsMutationResponse>;
  /** insert a single row into the table: "batch_evidence_commits_jobs" */
  insertBatchEvidenceCommitsJobsOne?: Maybe<BatchEvidenceCommitsJobs>;
  /** insert data into the table: "batch_evidences_job_runs" */
  insertBatchEvidencesJobRuns?: Maybe<BatchEvidencesJobRunsMutationResponse>;
  /** insert a single row into the table: "batch_evidences_job_runs" */
  insertBatchEvidencesJobRunsOne?: Maybe<BatchEvidencesJobRuns>;
  /** insert data into the table: "batch_evidences_jobs" */
  insertBatchEvidencesJobs?: Maybe<BatchEvidencesJobsMutationResponse>;
  /** insert a single row into the table: "batch_evidences_jobs" */
  insertBatchEvidencesJobsOne?: Maybe<BatchEvidencesJobs>;
  /** insert data into the table: "categories" */
  insertCategories?: Maybe<CategoriesMutationResponse>;
  /** insert a single row into the table: "categories" */
  insertCategoriesOne?: Maybe<Categories>;
  /** insert data into the table: "category_paths" */
  insertCategoryPaths?: Maybe<CategoryPathsMutationResponse>;
  /** insert a single row into the table: "category_paths" */
  insertCategoryPathsOne?: Maybe<CategoryPaths>;
  /** insert data into the table: "category_property_schema_sets" */
  insertCategoryPropertySchemaSets?: Maybe<CategoryPropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "category_property_schema_sets" */
  insertCategoryPropertySchemaSetsOne?: Maybe<CategoryPropertySchemaSets>;
  /** insert data into the table: "category_types" */
  insertCategoryTypes?: Maybe<CategoryTypesMutationResponse>;
  /** insert a single row into the table: "category_types" */
  insertCategoryTypesOne?: Maybe<CategoryTypes>;
  /** insert data into the table: "change_request_commits" */
  insertChangeRequestCommits?: Maybe<ChangeRequestCommitsMutationResponse>;
  /** insert a single row into the table: "change_request_commits" */
  insertChangeRequestCommitsOne?: Maybe<ChangeRequestCommits>;
  /** insert data into the table: "change_request_item_commits" */
  insertChangeRequestItemCommits?: Maybe<ChangeRequestItemCommitsMutationResponse>;
  /** insert a single row into the table: "change_request_item_commits" */
  insertChangeRequestItemCommitsOne?: Maybe<ChangeRequestItemCommits>;
  /** insert data into the table: "change_request_item_record_metadata" */
  insertChangeRequestItemRecordMetadata?: Maybe<ChangeRequestItemRecordMetadataMutationResponse>;
  /** insert a single row into the table: "change_request_item_record_metadata" */
  insertChangeRequestItemRecordMetadataOne?: Maybe<ChangeRequestItemRecordMetadata>;
  /** insert data into the table: "change_request_item_records" */
  insertChangeRequestItemRecords?: Maybe<ChangeRequestItemRecordsMutationResponse>;
  /** insert a single row into the table: "change_request_item_records" */
  insertChangeRequestItemRecordsOne?: Maybe<ChangeRequestItemRecords>;
  /** insert data into the table: "change_request_items" */
  insertChangeRequestItems?: Maybe<ChangeRequestItemsMutationResponse>;
  /** insert a single row into the table: "change_request_items" */
  insertChangeRequestItemsOne?: Maybe<ChangeRequestItems>;
  /** insert data into the table: "change_request_record_composer_definitions" */
  insertChangeRequestRecordComposerDefinitions?: Maybe<ChangeRequestRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "change_request_record_composer_definitions" */
  insertChangeRequestRecordComposerDefinitionsOne?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** insert data into the table: "change_request_review_types" */
  insertChangeRequestReviewTypes?: Maybe<ChangeRequestReviewTypesMutationResponse>;
  /** insert a single row into the table: "change_request_review_types" */
  insertChangeRequestReviewTypesOne?: Maybe<ChangeRequestReviewTypes>;
  /** insert data into the table: "change_request_reviews" */
  insertChangeRequestReviews?: Maybe<ChangeRequestReviewsMutationResponse>;
  /** insert a single row into the table: "change_request_reviews" */
  insertChangeRequestReviewsOne?: Maybe<ChangeRequestReviews>;
  /** insert data into the table: "change_request_statuses" */
  insertChangeRequestStatuses?: Maybe<ChangeRequestStatusesMutationResponse>;
  /** insert a single row into the table: "change_request_statuses" */
  insertChangeRequestStatusesOne?: Maybe<ChangeRequestStatuses>;
  /** insert data into the table: "change_requests" */
  insertChangeRequests?: Maybe<ChangeRequestsMutationResponse>;
  /** insert a single row into the table: "change_requests" */
  insertChangeRequestsOne?: Maybe<ChangeRequests>;
  /** insert data into the table: "compound.compound_records" */
  insertCompoundCompoundRecords?: Maybe<CompoundCompoundRecordsMutationResponse>;
  /** insert a single row into the table: "compound.compound_records" */
  insertCompoundCompoundRecordsOne?: Maybe<CompoundCompoundRecords>;
  /** insert data into the table: "compound_record_composers" */
  insertCompoundRecordComposers?: Maybe<CompoundRecordComposersMutationResponse>;
  /** insert a single row into the table: "compound_record_composers" */
  insertCompoundRecordComposersOne?: Maybe<CompoundRecordComposers>;
  /** insert data into the table: "compound_record_versions" */
  insertCompoundRecordVersions?: Maybe<CompoundRecordVersionsMutationResponse>;
  /** insert a single row into the table: "compound_record_versions" */
  insertCompoundRecordVersionsOne?: Maybe<CompoundRecordVersions>;
  /** insert data into the table: "countries" */
  insertCountries?: Maybe<CountriesMutationResponse>;
  /** insert a single row into the table: "countries" */
  insertCountriesOne?: Maybe<Countries>;
  /** insert data into the table: "country_subdivisions" */
  insertCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** insert a single row into the table: "country_subdivisions" */
  insertCountrySubdivisionsOne?: Maybe<CountrySubdivisions>;
  /** insert data into the table: "data_import_project_record_composer_definitions" */
  insertDataImportProjectRecordComposerDefinitions?: Maybe<DataImportProjectRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "data_import_project_record_composer_definitions" */
  insertDataImportProjectRecordComposerDefinitionsOne?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** insert data into the table: "data_import_project_status_logs" */
  insertDataImportProjectStatusLogs?: Maybe<DataImportProjectStatusLogsMutationResponse>;
  /** insert a single row into the table: "data_import_project_status_logs" */
  insertDataImportProjectStatusLogsOne?: Maybe<DataImportProjectStatusLogs>;
  /** insert data into the table: "data_import_project_statuses" */
  insertDataImportProjectStatuses?: Maybe<DataImportProjectStatusesMutationResponse>;
  /** insert a single row into the table: "data_import_project_statuses" */
  insertDataImportProjectStatusesOne?: Maybe<DataImportProjectStatuses>;
  /** insert data into the table: "data_import_project_users" */
  insertDataImportProjectUsers?: Maybe<DataImportProjectUsersMutationResponse>;
  /** insert a single row into the table: "data_import_project_users" */
  insertDataImportProjectUsersOne?: Maybe<DataImportProjectUsers>;
  /** insert data into the table: "data_import_projects" */
  insertDataImportProjects?: Maybe<DataImportProjectsMutationResponse>;
  /** insert a single row into the table: "data_import_projects" */
  insertDataImportProjectsOne?: Maybe<DataImportProjects>;
  /** insert data into the table: "data_source_gsheets" */
  insertDataSourceGsheets?: Maybe<DataSourceGsheetsMutationResponse>;
  /** insert a single row into the table: "data_source_gsheets" */
  insertDataSourceGsheetsOne?: Maybe<DataSourceGsheets>;
  /** insert data into the table: "data_source_import_project_record_composer_definitions" */
  insertDataSourceImportProjectRecordComposerDefinitions?: Maybe<DataSourceImportProjectRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "data_source_import_project_record_composer_definitions" */
  insertDataSourceImportProjectRecordComposerDefinitionsOne?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  /** insert data into the table: "data_source_import_projects" */
  insertDataSourceImportProjects?: Maybe<DataSourceImportProjectsMutationResponse>;
  /** insert a single row into the table: "data_source_import_projects" */
  insertDataSourceImportProjectsOne?: Maybe<DataSourceImportProjects>;
  /** insert data into the table: "data_source_jsons" */
  insertDataSourceJsons?: Maybe<DataSourceJsonsMutationResponse>;
  /** insert a single row into the table: "data_source_jsons" */
  insertDataSourceJsonsOne?: Maybe<DataSourceJsons>;
  /** insert data into the table: "data_source_property_schema_sets" */
  insertDataSourcePropertySchemaSets?: Maybe<DataSourcePropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "data_source_property_schema_sets" */
  insertDataSourcePropertySchemaSetsOne?: Maybe<DataSourcePropertySchemaSets>;
  /** insert data into the table: "data_source_references" */
  insertDataSourceReferences?: Maybe<DataSourceReferencesMutationResponse>;
  /** insert a single row into the table: "data_source_references" */
  insertDataSourceReferencesOne?: Maybe<DataSourceReferences>;
  /** insert data into the table: "data_source_template_property_schema_sets" */
  insertDataSourceTemplatePropertySchemaSets?: Maybe<DataSourceTemplatePropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "data_source_template_property_schema_sets" */
  insertDataSourceTemplatePropertySchemaSetsOne?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** insert data into the table: "data_source_templates" */
  insertDataSourceTemplates?: Maybe<DataSourceTemplatesMutationResponse>;
  /** insert a single row into the table: "data_source_templates" */
  insertDataSourceTemplatesOne?: Maybe<DataSourceTemplates>;
  /** insert data into the table: "data_sources" */
  insertDataSources?: Maybe<DataSourcesMutationResponse>;
  /** insert a single row into the table: "data_sources" */
  insertDataSourcesOne?: Maybe<DataSources>;
  /** insert data into the table: "dbpjkit_worker_job_runs" */
  insertDbpjkitWorkerJobRuns?: Maybe<DbpjkitWorkerJobRunsMutationResponse>;
  /** insert a single row into the table: "dbpjkit_worker_job_runs" */
  insertDbpjkitWorkerJobRunsOne?: Maybe<DbpjkitWorkerJobRuns>;
  /** insert data into the table: "dbpjkit_worker_jobs" */
  insertDbpjkitWorkerJobs?: Maybe<DbpjkitWorkerJobsMutationResponse>;
  /** insert a single row into the table: "dbpjkit_worker_jobs" */
  insertDbpjkitWorkerJobsOne?: Maybe<DbpjkitWorkerJobs>;
  /** insert data into the table: "entity_record_composer_definitions" */
  insertEntityRecordComposerDefinitions?: Maybe<EntityRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "entity_record_composer_definitions" */
  insertEntityRecordComposerDefinitionsOne?: Maybe<EntityRecordComposerDefinitions>;
  /** insert data into the table: "entity_records" */
  insertEntityRecords?: Maybe<EntityRecordsMutationResponse>;
  /** insert a single row into the table: "entity_records" */
  insertEntityRecordsOne?: Maybe<EntityRecords>;
  /** insert data into the table: "evidence_change_requests" */
  insertEvidenceChangeRequests?: Maybe<EvidenceChangeRequestsMutationResponse>;
  /** insert a single row into the table: "evidence_change_requests" */
  insertEvidenceChangeRequestsOne?: Maybe<EvidenceChangeRequests>;
  /** insert data into the table: "evidence_evidence_sets" */
  insertEvidenceEvidenceSets?: Maybe<EvidenceEvidenceSetsMutationResponse>;
  /** insert a single row into the table: "evidence_evidence_sets" */
  insertEvidenceEvidenceSetsOne?: Maybe<EvidenceEvidenceSets>;
  /** insert data into the table: "evidence_importers" */
  insertEvidenceImporters?: Maybe<EvidenceImportersMutationResponse>;
  /** insert a single row into the table: "evidence_importers" */
  insertEvidenceImportersOne?: Maybe<EvidenceImporters>;
  /** insert data into the table: "evidence_record_geo_items" */
  insertEvidenceRecordGeoItems?: Maybe<EvidenceRecordGeoItemsMutationResponse>;
  /** insert a single row into the table: "evidence_record_geo_items" */
  insertEvidenceRecordGeoItemsOne?: Maybe<EvidenceRecordGeoItems>;
  /** insert data into the table: "evidence_set_import_projects" */
  insertEvidenceSetImportProjects?: Maybe<EvidenceSetImportProjectsMutationResponse>;
  /** insert a single row into the table: "evidence_set_import_projects" */
  insertEvidenceSetImportProjectsOne?: Maybe<EvidenceSetImportProjects>;
  /** insert data into the table: "evidence_set_property_schema_sets" */
  insertEvidenceSetPropertySchemaSets?: Maybe<EvidenceSetPropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "evidence_set_property_schema_sets" */
  insertEvidenceSetPropertySchemaSetsOne?: Maybe<EvidenceSetPropertySchemaSets>;
  /** insert data into the table: "evidence_sets" */
  insertEvidenceSets?: Maybe<EvidenceSetsMutationResponse>;
  /** insert a single row into the table: "evidence_sets" */
  insertEvidenceSetsOne?: Maybe<EvidenceSets>;
  /** insert data into the table: "evidence_versions" */
  insertEvidenceVersions?: Maybe<EvidenceVersionsMutationResponse>;
  /** insert a single row into the table: "evidence_versions" */
  insertEvidenceVersionsOne?: Maybe<EvidenceVersions>;
  /** insert data into the table: "evidences" */
  insertEvidences?: Maybe<EvidencesMutationResponse>;
  /** insert a single row into the table: "evidences" */
  insertEvidencesOne?: Maybe<Evidences>;
  /** insert data into the table: "job_run_statuses" */
  insertJobRunStatuses?: Maybe<JobRunStatusesMutationResponse>;
  /** insert a single row into the table: "job_run_statuses" */
  insertJobRunStatusesOne?: Maybe<JobRunStatuses>;
  /** insert data into the table: "organization_kinds" */
  insertOrganizationKinds?: Maybe<OrganizationKindsMutationResponse>;
  /** insert a single row into the table: "organization_kinds" */
  insertOrganizationKindsOne?: Maybe<OrganizationKinds>;
  /** insert data into the table: "organizations" */
  insertOrganizations?: Maybe<OrganizationsMutationResponse>;
  /** insert a single row into the table: "organizations" */
  insertOrganizationsOne?: Maybe<Organizations>;
  /** insert data into the table: "product_roles" */
  insertProductRoles?: Maybe<ProductRolesMutationResponse>;
  /** insert a single row into the table: "product_roles" */
  insertProductRolesOne?: Maybe<ProductRoles>;
  /** insert data into the table: "products" */
  insertProducts?: Maybe<ProductsMutationResponse>;
  /** insert a single row into the table: "products" */
  insertProductsOne?: Maybe<Products>;
  /** insert data into the table: "property_schema_associations" */
  insertPropertySchemaAssociations?: Maybe<PropertySchemaAssociationsMutationResponse>;
  /** insert a single row into the table: "property_schema_associations" */
  insertPropertySchemaAssociationsOne?: Maybe<PropertySchemaAssociations>;
  /** insert data into the table: "property_schema_sets" */
  insertPropertySchemaSets?: Maybe<PropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "property_schema_sets" */
  insertPropertySchemaSetsOne?: Maybe<PropertySchemaSets>;
  /** insert data into the table: "property_schemas" */
  insertPropertySchemas?: Maybe<PropertySchemasMutationResponse>;
  /** insert a single row into the table: "property_schemas" */
  insertPropertySchemasOne?: Maybe<PropertySchemas>;
  /** insert data into the table: "property_types" */
  insertPropertyTypes?: Maybe<PropertyTypesMutationResponse>;
  /** insert a single row into the table: "property_types" */
  insertPropertyTypesOne?: Maybe<PropertyTypes>;
  /** insert data into the table: "publishers" */
  insertPublishers?: Maybe<PublishersMutationResponse>;
  /** insert a single row into the table: "publishers" */
  insertPublishersOne?: Maybe<Publishers>;
  /** insert data into the table: "record_composer_definition_evidence_sets" */
  insertRecordComposerDefinitionEvidenceSets?: Maybe<RecordComposerDefinitionEvidenceSetsMutationResponse>;
  /** insert a single row into the table: "record_composer_definition_evidence_sets" */
  insertRecordComposerDefinitionEvidenceSetsOne?: Maybe<RecordComposerDefinitionEvidenceSets>;
  /** insert data into the table: "record_composer_definition_property_schema_sets" */
  insertRecordComposerDefinitionPropertySchemaSets?: Maybe<RecordComposerDefinitionPropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "record_composer_definition_property_schema_sets" */
  insertRecordComposerDefinitionPropertySchemaSetsOne?: Maybe<RecordComposerDefinitionPropertySchemaSets>;
  /** insert data into the table: "record_composer_definitions" */
  insertRecordComposerDefinitions?: Maybe<RecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "record_composer_definitions" */
  insertRecordComposerDefinitionsOne?: Maybe<RecordComposerDefinitions>;
  /** insert data into the table: "record_compound_record_composers" */
  insertRecordCompoundRecordComposers?: Maybe<RecordCompoundRecordComposersMutationResponse>;
  /** insert a single row into the table: "record_compound_record_composers" */
  insertRecordCompoundRecordComposersOne?: Maybe<RecordCompoundRecordComposers>;
  /** insert data into the table: "record_geo_items" */
  insertRecordGeoItems?: Maybe<RecordGeoItemsMutationResponse>;
  /** insert a single row into the table: "record_geo_items" */
  insertRecordGeoItemsOne?: Maybe<RecordGeoItems>;
  /** insert data into the table: "record_metadata" */
  insertRecordMetadata?: Maybe<RecordMetadataMutationResponse>;
  /** insert data into the table: "record_metadata_categories" */
  insertRecordMetadataCategories?: Maybe<RecordMetadataCategoriesMutationResponse>;
  /** insert a single row into the table: "record_metadata_categories" */
  insertRecordMetadataCategoriesOne?: Maybe<RecordMetadataCategories>;
  /** insert a single row into the table: "record_metadata" */
  insertRecordMetadataOne?: Maybe<RecordMetadata>;
  /** insert data into the table: "record_metadata_property_schema_sets" */
  insertRecordMetadataPropertySchemaSets?: Maybe<RecordMetadataPropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "record_metadata_property_schema_sets" */
  insertRecordMetadataPropertySchemaSetsOne?: Maybe<RecordMetadataPropertySchemaSets>;
  /** insert data into the table: "record_property_schema_sets" */
  insertRecordPropertySchemaSets?: Maybe<RecordPropertySchemaSetsMutationResponse>;
  /** insert a single row into the table: "record_property_schema_sets" */
  insertRecordPropertySchemaSetsOne?: Maybe<RecordPropertySchemaSets>;
  /** insert data into the table: "record_update_record_composer_definitions" */
  insertRecordUpdateRecordComposerDefinitions?: Maybe<RecordUpdateRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "record_update_record_composer_definitions" */
  insertRecordUpdateRecordComposerDefinitionsOne?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** insert data into the table: "records" */
  insertRecords?: Maybe<RecordsMutationResponse>;
  /** insert a single row into the table: "records" */
  insertRecordsOne?: Maybe<Records>;
  /** insert data into the table: "reference_files" */
  insertReferenceFiles?: Maybe<ReferenceFilesMutationResponse>;
  /** insert a single row into the table: "reference_files" */
  insertReferenceFilesOne?: Maybe<ReferenceFiles>;
  /** insert data into the table: "reference_publishers" */
  insertReferencePublishers?: Maybe<ReferencePublishersMutationResponse>;
  /** insert a single row into the table: "reference_publishers" */
  insertReferencePublishersOne?: Maybe<ReferencePublishers>;
  /** insert data into the table: "references" */
  insertReferences?: Maybe<ReferencesMutationResponse>;
  /** insert a single row into the table: "references" */
  insertReferencesOne?: Maybe<References>;
  /** insert data into the table: "relation_record_composer_definitions" */
  insertRelationRecordComposerDefinitions?: Maybe<RelationRecordComposerDefinitionsMutationResponse>;
  /** insert a single row into the table: "relation_record_composer_definitions" */
  insertRelationRecordComposerDefinitionsOne?: Maybe<RelationRecordComposerDefinitions>;
  /** insert data into the table: "relation_records" */
  insertRelationRecords?: Maybe<RelationRecordsMutationResponse>;
  /** insert a single row into the table: "relation_records" */
  insertRelationRecordsOne?: Maybe<RelationRecords>;
  /** insert data into the table: "relation_types" */
  insertRelationTypes?: Maybe<RelationTypesMutationResponse>;
  /** insert a single row into the table: "relation_types" */
  insertRelationTypesOne?: Maybe<RelationTypes>;
  /** insert data into the table: "roles" */
  insertRoles?: Maybe<RolesMutationResponse>;
  /** insert a single row into the table: "roles" */
  insertRolesOne?: Maybe<Roles>;
  /** insert data into the table: "source_record_edges" */
  insertSourceRecordEdges?: Maybe<SourceRecordEdgesMutationResponse>;
  /** insert a single row into the table: "source_record_edges" */
  insertSourceRecordEdgesOne?: Maybe<SourceRecordEdges>;
  /** insert data into the table: "target_record_edges" */
  insertTargetRecordEdges?: Maybe<TargetRecordEdgesMutationResponse>;
  /** insert a single row into the table: "target_record_edges" */
  insertTargetRecordEdgesOne?: Maybe<TargetRecordEdges>;
  /** insert data into the table: "tenant_product_installations" */
  insertTenantProductInstallations?: Maybe<TenantProductInstallationsMutationResponse>;
  /** insert a single row into the table: "tenant_product_installations" */
  insertTenantProductInstallationsOne?: Maybe<TenantProductInstallations>;
  /** insert data into the table: "tenants" */
  insertTenants?: Maybe<TenantsMutationResponse>;
  /** insert a single row into the table: "tenants" */
  insertTenantsOne?: Maybe<Tenants>;
  /** insert data into the table: "unified_evidence_drafts" */
  insertUnifiedEvidenceDrafts?: Maybe<UnifiedEvidenceDraftsMutationResponse>;
  /** insert a single row into the table: "unified_evidence_drafts" */
  insertUnifiedEvidenceDraftsOne?: Maybe<UnifiedEvidenceDrafts>;
  /** insert data into the table: "user_groups" */
  insertUserGroups?: Maybe<UserGroupsMutationResponse>;
  /** insert a single row into the table: "user_groups" */
  insertUserGroupsOne?: Maybe<UserGroups>;
  /** insert data into the table: "user_product_roles" */
  insertUserProductRoles?: Maybe<UserProductRolesMutationResponse>;
  /** insert a single row into the table: "user_product_roles" */
  insertUserProductRolesOne?: Maybe<UserProductRoles>;
  /** insert data into the table: "user_segments" */
  insertUserSegments?: Maybe<UserSegmentsMutationResponse>;
  /** insert a single row into the table: "user_segments" */
  insertUserSegmentsOne?: Maybe<UserSegments>;
  /** insert data into the table: "user_tenants" */
  insertUserTenants?: Maybe<UserTenantsMutationResponse>;
  /** insert a single row into the table: "user_tenants" */
  insertUserTenantsOne?: Maybe<UserTenants>;
  /** insert data into the table: "user_user_groups" */
  insertUserUserGroups?: Maybe<UserUserGroupsMutationResponse>;
  /** insert a single row into the table: "user_user_groups" */
  insertUserUserGroupsOne?: Maybe<UserUserGroups>;
  /** insert data into the table: "user_user_segments" */
  insertUserUserSegments?: Maybe<UserUserSegmentsMutationResponse>;
  /** insert a single row into the table: "user_user_segments" */
  insertUserUserSegmentsOne?: Maybe<UserUserSegments>;
  /** insert data into the table: "users" */
  insertUsers?: Maybe<UsersMutationResponse>;
  /** insert a single row into the table: "users" */
  insertUsersOne?: Maybe<Users>;
  /** update data of the table: "area_codes" */
  updateAreaCodes?: Maybe<AreaCodesMutationResponse>;
  /** update single row of the table: "area_codes" */
  updateAreaCodesByPk?: Maybe<AreaCodes>;
  /** update multiples rows of table: "area_codes" */
  updateAreaCodesMany?: Maybe<Array<Maybe<AreaCodesMutationResponse>>>;
  /** update data of the table: "batch_change_request_reviews_job_runs" */
  updateBatchChangeRequestReviewsJobRuns?: Maybe<BatchChangeRequestReviewsJobRunsMutationResponse>;
  /** update single row of the table: "batch_change_request_reviews_job_runs" */
  updateBatchChangeRequestReviewsJobRunsByPk?: Maybe<BatchChangeRequestReviewsJobRuns>;
  /** update multiples rows of table: "batch_change_request_reviews_job_runs" */
  updateBatchChangeRequestReviewsJobRunsMany?: Maybe<Array<Maybe<BatchChangeRequestReviewsJobRunsMutationResponse>>>;
  /** update data of the table: "batch_change_request_reviews_jobs" */
  updateBatchChangeRequestReviewsJobs?: Maybe<BatchChangeRequestReviewsJobsMutationResponse>;
  /** update single row of the table: "batch_change_request_reviews_jobs" */
  updateBatchChangeRequestReviewsJobsByPk?: Maybe<BatchChangeRequestReviewsJobs>;
  /** update multiples rows of table: "batch_change_request_reviews_jobs" */
  updateBatchChangeRequestReviewsJobsMany?: Maybe<Array<Maybe<BatchChangeRequestReviewsJobsMutationResponse>>>;
  /** update data of the table: "batch_change_requests_job_record_composer_definitions" */
  updateBatchChangeRequestsJobRecordComposerDefinitions?: Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "batch_change_requests_job_record_composer_definitions" */
  updateBatchChangeRequestsJobRecordComposerDefinitionsByPk?: Maybe<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** update multiples rows of table: "batch_change_requests_job_record_composer_definitions" */
  updateBatchChangeRequestsJobRecordComposerDefinitionsMany?: Maybe<Array<Maybe<BatchChangeRequestsJobRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "batch_change_requests_job_runs" */
  updateBatchChangeRequestsJobRuns?: Maybe<BatchChangeRequestsJobRunsMutationResponse>;
  /** update single row of the table: "batch_change_requests_job_runs" */
  updateBatchChangeRequestsJobRunsByPk?: Maybe<BatchChangeRequestsJobRuns>;
  /** update multiples rows of table: "batch_change_requests_job_runs" */
  updateBatchChangeRequestsJobRunsMany?: Maybe<Array<Maybe<BatchChangeRequestsJobRunsMutationResponse>>>;
  /** update data of the table: "batch_change_requests_jobs" */
  updateBatchChangeRequestsJobs?: Maybe<BatchChangeRequestsJobsMutationResponse>;
  /** update single row of the table: "batch_change_requests_jobs" */
  updateBatchChangeRequestsJobsByPk?: Maybe<BatchChangeRequestsJobs>;
  /** update multiples rows of table: "batch_change_requests_jobs" */
  updateBatchChangeRequestsJobsMany?: Maybe<Array<Maybe<BatchChangeRequestsJobsMutationResponse>>>;
  /** update data of the table: "batch_evidence_commits_job_runs" */
  updateBatchEvidenceCommitsJobRuns?: Maybe<BatchEvidenceCommitsJobRunsMutationResponse>;
  /** update single row of the table: "batch_evidence_commits_job_runs" */
  updateBatchEvidenceCommitsJobRunsByPk?: Maybe<BatchEvidenceCommitsJobRuns>;
  /** update multiples rows of table: "batch_evidence_commits_job_runs" */
  updateBatchEvidenceCommitsJobRunsMany?: Maybe<Array<Maybe<BatchEvidenceCommitsJobRunsMutationResponse>>>;
  /** update data of the table: "batch_evidence_commits_jobs" */
  updateBatchEvidenceCommitsJobs?: Maybe<BatchEvidenceCommitsJobsMutationResponse>;
  /** update single row of the table: "batch_evidence_commits_jobs" */
  updateBatchEvidenceCommitsJobsByPk?: Maybe<BatchEvidenceCommitsJobs>;
  /** update multiples rows of table: "batch_evidence_commits_jobs" */
  updateBatchEvidenceCommitsJobsMany?: Maybe<Array<Maybe<BatchEvidenceCommitsJobsMutationResponse>>>;
  /** update data of the table: "batch_evidences_job_runs" */
  updateBatchEvidencesJobRuns?: Maybe<BatchEvidencesJobRunsMutationResponse>;
  /** update single row of the table: "batch_evidences_job_runs" */
  updateBatchEvidencesJobRunsByPk?: Maybe<BatchEvidencesJobRuns>;
  /** update multiples rows of table: "batch_evidences_job_runs" */
  updateBatchEvidencesJobRunsMany?: Maybe<Array<Maybe<BatchEvidencesJobRunsMutationResponse>>>;
  /** update data of the table: "batch_evidences_jobs" */
  updateBatchEvidencesJobs?: Maybe<BatchEvidencesJobsMutationResponse>;
  /** update single row of the table: "batch_evidences_jobs" */
  updateBatchEvidencesJobsByPk?: Maybe<BatchEvidencesJobs>;
  /** update multiples rows of table: "batch_evidences_jobs" */
  updateBatchEvidencesJobsMany?: Maybe<Array<Maybe<BatchEvidencesJobsMutationResponse>>>;
  /** update data of the table: "categories" */
  updateCategories?: Maybe<CategoriesMutationResponse>;
  /** update single row of the table: "categories" */
  updateCategoriesByPk?: Maybe<Categories>;
  /** update multiples rows of table: "categories" */
  updateCategoriesMany?: Maybe<Array<Maybe<CategoriesMutationResponse>>>;
  /** update data of the table: "category_paths" */
  updateCategoryPaths?: Maybe<CategoryPathsMutationResponse>;
  /** update single row of the table: "category_paths" */
  updateCategoryPathsByPk?: Maybe<CategoryPaths>;
  /** update multiples rows of table: "category_paths" */
  updateCategoryPathsMany?: Maybe<Array<Maybe<CategoryPathsMutationResponse>>>;
  /** update data of the table: "category_property_schema_sets" */
  updateCategoryPropertySchemaSets?: Maybe<CategoryPropertySchemaSetsMutationResponse>;
  /** update single row of the table: "category_property_schema_sets" */
  updateCategoryPropertySchemaSetsByPk?: Maybe<CategoryPropertySchemaSets>;
  /** update multiples rows of table: "category_property_schema_sets" */
  updateCategoryPropertySchemaSetsMany?: Maybe<Array<Maybe<CategoryPropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "category_types" */
  updateCategoryTypes?: Maybe<CategoryTypesMutationResponse>;
  /** update single row of the table: "category_types" */
  updateCategoryTypesByPk?: Maybe<CategoryTypes>;
  /** update multiples rows of table: "category_types" */
  updateCategoryTypesMany?: Maybe<Array<Maybe<CategoryTypesMutationResponse>>>;
  /** update data of the table: "change_request_commits" */
  updateChangeRequestCommits?: Maybe<ChangeRequestCommitsMutationResponse>;
  /** update single row of the table: "change_request_commits" */
  updateChangeRequestCommitsByPk?: Maybe<ChangeRequestCommits>;
  /** update multiples rows of table: "change_request_commits" */
  updateChangeRequestCommitsMany?: Maybe<Array<Maybe<ChangeRequestCommitsMutationResponse>>>;
  /** update data of the table: "change_request_item_commits" */
  updateChangeRequestItemCommits?: Maybe<ChangeRequestItemCommitsMutationResponse>;
  /** update single row of the table: "change_request_item_commits" */
  updateChangeRequestItemCommitsByPk?: Maybe<ChangeRequestItemCommits>;
  /** update multiples rows of table: "change_request_item_commits" */
  updateChangeRequestItemCommitsMany?: Maybe<Array<Maybe<ChangeRequestItemCommitsMutationResponse>>>;
  /** update data of the table: "change_request_item_record_metadata" */
  updateChangeRequestItemRecordMetadata?: Maybe<ChangeRequestItemRecordMetadataMutationResponse>;
  /** update single row of the table: "change_request_item_record_metadata" */
  updateChangeRequestItemRecordMetadataByPk?: Maybe<ChangeRequestItemRecordMetadata>;
  /** update multiples rows of table: "change_request_item_record_metadata" */
  updateChangeRequestItemRecordMetadataMany?: Maybe<Array<Maybe<ChangeRequestItemRecordMetadataMutationResponse>>>;
  /** update data of the table: "change_request_item_records" */
  updateChangeRequestItemRecords?: Maybe<ChangeRequestItemRecordsMutationResponse>;
  /** update single row of the table: "change_request_item_records" */
  updateChangeRequestItemRecordsByPk?: Maybe<ChangeRequestItemRecords>;
  /** update multiples rows of table: "change_request_item_records" */
  updateChangeRequestItemRecordsMany?: Maybe<Array<Maybe<ChangeRequestItemRecordsMutationResponse>>>;
  /** update data of the table: "change_request_items" */
  updateChangeRequestItems?: Maybe<ChangeRequestItemsMutationResponse>;
  /** update single row of the table: "change_request_items" */
  updateChangeRequestItemsByPk?: Maybe<ChangeRequestItems>;
  /** update multiples rows of table: "change_request_items" */
  updateChangeRequestItemsMany?: Maybe<Array<Maybe<ChangeRequestItemsMutationResponse>>>;
  /** update data of the table: "change_request_record_composer_definitions" */
  updateChangeRequestRecordComposerDefinitions?: Maybe<ChangeRequestRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "change_request_record_composer_definitions" */
  updateChangeRequestRecordComposerDefinitionsByPk?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** update multiples rows of table: "change_request_record_composer_definitions" */
  updateChangeRequestRecordComposerDefinitionsMany?: Maybe<Array<Maybe<ChangeRequestRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "change_request_review_types" */
  updateChangeRequestReviewTypes?: Maybe<ChangeRequestReviewTypesMutationResponse>;
  /** update single row of the table: "change_request_review_types" */
  updateChangeRequestReviewTypesByPk?: Maybe<ChangeRequestReviewTypes>;
  /** update multiples rows of table: "change_request_review_types" */
  updateChangeRequestReviewTypesMany?: Maybe<Array<Maybe<ChangeRequestReviewTypesMutationResponse>>>;
  /** update data of the table: "change_request_reviews" */
  updateChangeRequestReviews?: Maybe<ChangeRequestReviewsMutationResponse>;
  /** update single row of the table: "change_request_reviews" */
  updateChangeRequestReviewsByPk?: Maybe<ChangeRequestReviews>;
  /** update multiples rows of table: "change_request_reviews" */
  updateChangeRequestReviewsMany?: Maybe<Array<Maybe<ChangeRequestReviewsMutationResponse>>>;
  /** update data of the table: "change_request_statuses" */
  updateChangeRequestStatuses?: Maybe<ChangeRequestStatusesMutationResponse>;
  /** update single row of the table: "change_request_statuses" */
  updateChangeRequestStatusesByPk?: Maybe<ChangeRequestStatuses>;
  /** update multiples rows of table: "change_request_statuses" */
  updateChangeRequestStatusesMany?: Maybe<Array<Maybe<ChangeRequestStatusesMutationResponse>>>;
  /** update data of the table: "change_requests" */
  updateChangeRequests?: Maybe<ChangeRequestsMutationResponse>;
  /** update single row of the table: "change_requests" */
  updateChangeRequestsByPk?: Maybe<ChangeRequests>;
  /** update multiples rows of table: "change_requests" */
  updateChangeRequestsMany?: Maybe<Array<Maybe<ChangeRequestsMutationResponse>>>;
  /** update data of the table: "compound.compound_records" */
  updateCompoundCompoundRecords?: Maybe<CompoundCompoundRecordsMutationResponse>;
  /** update single row of the table: "compound.compound_records" */
  updateCompoundCompoundRecordsByPk?: Maybe<CompoundCompoundRecords>;
  /** update multiples rows of table: "compound.compound_records" */
  updateCompoundCompoundRecordsMany?: Maybe<Array<Maybe<CompoundCompoundRecordsMutationResponse>>>;
  /** update data of the table: "compound_record_composers" */
  updateCompoundRecordComposers?: Maybe<CompoundRecordComposersMutationResponse>;
  /** update single row of the table: "compound_record_composers" */
  updateCompoundRecordComposersByPk?: Maybe<CompoundRecordComposers>;
  /** update multiples rows of table: "compound_record_composers" */
  updateCompoundRecordComposersMany?: Maybe<Array<Maybe<CompoundRecordComposersMutationResponse>>>;
  /** update data of the table: "compound_record_versions" */
  updateCompoundRecordVersions?: Maybe<CompoundRecordVersionsMutationResponse>;
  /** update single row of the table: "compound_record_versions" */
  updateCompoundRecordVersionsByPk?: Maybe<CompoundRecordVersions>;
  /** update multiples rows of table: "compound_record_versions" */
  updateCompoundRecordVersionsMany?: Maybe<Array<Maybe<CompoundRecordVersionsMutationResponse>>>;
  /** update data of the table: "countries" */
  updateCountries?: Maybe<CountriesMutationResponse>;
  /** update single row of the table: "countries" */
  updateCountriesByPk?: Maybe<Countries>;
  /** update multiples rows of table: "countries" */
  updateCountriesMany?: Maybe<Array<Maybe<CountriesMutationResponse>>>;
  /** update data of the table: "country_subdivisions" */
  updateCountrySubdivisions?: Maybe<CountrySubdivisionsMutationResponse>;
  /** update single row of the table: "country_subdivisions" */
  updateCountrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** update multiples rows of table: "country_subdivisions" */
  updateCountrySubdivisionsMany?: Maybe<Array<Maybe<CountrySubdivisionsMutationResponse>>>;
  /** update data of the table: "data_import_project_record_composer_definitions" */
  updateDataImportProjectRecordComposerDefinitions?: Maybe<DataImportProjectRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "data_import_project_record_composer_definitions" */
  updateDataImportProjectRecordComposerDefinitionsByPk?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** update multiples rows of table: "data_import_project_record_composer_definitions" */
  updateDataImportProjectRecordComposerDefinitionsMany?: Maybe<Array<Maybe<DataImportProjectRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "data_import_project_status_logs" */
  updateDataImportProjectStatusLogs?: Maybe<DataImportProjectStatusLogsMutationResponse>;
  /** update single row of the table: "data_import_project_status_logs" */
  updateDataImportProjectStatusLogsByPk?: Maybe<DataImportProjectStatusLogs>;
  /** update multiples rows of table: "data_import_project_status_logs" */
  updateDataImportProjectStatusLogsMany?: Maybe<Array<Maybe<DataImportProjectStatusLogsMutationResponse>>>;
  /** update data of the table: "data_import_project_statuses" */
  updateDataImportProjectStatuses?: Maybe<DataImportProjectStatusesMutationResponse>;
  /** update single row of the table: "data_import_project_statuses" */
  updateDataImportProjectStatusesByPk?: Maybe<DataImportProjectStatuses>;
  /** update multiples rows of table: "data_import_project_statuses" */
  updateDataImportProjectStatusesMany?: Maybe<Array<Maybe<DataImportProjectStatusesMutationResponse>>>;
  /** update data of the table: "data_import_project_users" */
  updateDataImportProjectUsers?: Maybe<DataImportProjectUsersMutationResponse>;
  /** update single row of the table: "data_import_project_users" */
  updateDataImportProjectUsersByPk?: Maybe<DataImportProjectUsers>;
  /** update multiples rows of table: "data_import_project_users" */
  updateDataImportProjectUsersMany?: Maybe<Array<Maybe<DataImportProjectUsersMutationResponse>>>;
  /** update data of the table: "data_import_projects" */
  updateDataImportProjects?: Maybe<DataImportProjectsMutationResponse>;
  /** update single row of the table: "data_import_projects" */
  updateDataImportProjectsByPk?: Maybe<DataImportProjects>;
  /** update multiples rows of table: "data_import_projects" */
  updateDataImportProjectsMany?: Maybe<Array<Maybe<DataImportProjectsMutationResponse>>>;
  /** update data of the table: "data_source_gsheets" */
  updateDataSourceGsheets?: Maybe<DataSourceGsheetsMutationResponse>;
  /** update single row of the table: "data_source_gsheets" */
  updateDataSourceGsheetsByPk?: Maybe<DataSourceGsheets>;
  /** update multiples rows of table: "data_source_gsheets" */
  updateDataSourceGsheetsMany?: Maybe<Array<Maybe<DataSourceGsheetsMutationResponse>>>;
  /** update data of the table: "data_source_import_project_record_composer_definitions" */
  updateDataSourceImportProjectRecordComposerDefinitions?: Maybe<DataSourceImportProjectRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "data_source_import_project_record_composer_definitions" */
  updateDataSourceImportProjectRecordComposerDefinitionsByPk?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  /** update multiples rows of table: "data_source_import_project_record_composer_definitions" */
  updateDataSourceImportProjectRecordComposerDefinitionsMany?: Maybe<Array<Maybe<DataSourceImportProjectRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "data_source_import_projects" */
  updateDataSourceImportProjects?: Maybe<DataSourceImportProjectsMutationResponse>;
  /** update single row of the table: "data_source_import_projects" */
  updateDataSourceImportProjectsByPk?: Maybe<DataSourceImportProjects>;
  /** update multiples rows of table: "data_source_import_projects" */
  updateDataSourceImportProjectsMany?: Maybe<Array<Maybe<DataSourceImportProjectsMutationResponse>>>;
  /** update data of the table: "data_source_jsons" */
  updateDataSourceJsons?: Maybe<DataSourceJsonsMutationResponse>;
  /** update single row of the table: "data_source_jsons" */
  updateDataSourceJsonsByPk?: Maybe<DataSourceJsons>;
  /** update multiples rows of table: "data_source_jsons" */
  updateDataSourceJsonsMany?: Maybe<Array<Maybe<DataSourceJsonsMutationResponse>>>;
  /** update data of the table: "data_source_property_schema_sets" */
  updateDataSourcePropertySchemaSets?: Maybe<DataSourcePropertySchemaSetsMutationResponse>;
  /** update single row of the table: "data_source_property_schema_sets" */
  updateDataSourcePropertySchemaSetsByPk?: Maybe<DataSourcePropertySchemaSets>;
  /** update multiples rows of table: "data_source_property_schema_sets" */
  updateDataSourcePropertySchemaSetsMany?: Maybe<Array<Maybe<DataSourcePropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "data_source_references" */
  updateDataSourceReferences?: Maybe<DataSourceReferencesMutationResponse>;
  /** update single row of the table: "data_source_references" */
  updateDataSourceReferencesByPk?: Maybe<DataSourceReferences>;
  /** update multiples rows of table: "data_source_references" */
  updateDataSourceReferencesMany?: Maybe<Array<Maybe<DataSourceReferencesMutationResponse>>>;
  /** update data of the table: "data_source_template_property_schema_sets" */
  updateDataSourceTemplatePropertySchemaSets?: Maybe<DataSourceTemplatePropertySchemaSetsMutationResponse>;
  /** update single row of the table: "data_source_template_property_schema_sets" */
  updateDataSourceTemplatePropertySchemaSetsByPk?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** update multiples rows of table: "data_source_template_property_schema_sets" */
  updateDataSourceTemplatePropertySchemaSetsMany?: Maybe<Array<Maybe<DataSourceTemplatePropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "data_source_templates" */
  updateDataSourceTemplates?: Maybe<DataSourceTemplatesMutationResponse>;
  /** update single row of the table: "data_source_templates" */
  updateDataSourceTemplatesByPk?: Maybe<DataSourceTemplates>;
  /** update multiples rows of table: "data_source_templates" */
  updateDataSourceTemplatesMany?: Maybe<Array<Maybe<DataSourceTemplatesMutationResponse>>>;
  /** update data of the table: "data_sources" */
  updateDataSources?: Maybe<DataSourcesMutationResponse>;
  /** update single row of the table: "data_sources" */
  updateDataSourcesByPk?: Maybe<DataSources>;
  /** update multiples rows of table: "data_sources" */
  updateDataSourcesMany?: Maybe<Array<Maybe<DataSourcesMutationResponse>>>;
  /** update data of the table: "dbpjkit_worker_job_runs" */
  updateDbpjkitWorkerJobRuns?: Maybe<DbpjkitWorkerJobRunsMutationResponse>;
  /** update single row of the table: "dbpjkit_worker_job_runs" */
  updateDbpjkitWorkerJobRunsByPk?: Maybe<DbpjkitWorkerJobRuns>;
  /** update multiples rows of table: "dbpjkit_worker_job_runs" */
  updateDbpjkitWorkerJobRunsMany?: Maybe<Array<Maybe<DbpjkitWorkerJobRunsMutationResponse>>>;
  /** update data of the table: "dbpjkit_worker_jobs" */
  updateDbpjkitWorkerJobs?: Maybe<DbpjkitWorkerJobsMutationResponse>;
  /** update single row of the table: "dbpjkit_worker_jobs" */
  updateDbpjkitWorkerJobsByPk?: Maybe<DbpjkitWorkerJobs>;
  /** update multiples rows of table: "dbpjkit_worker_jobs" */
  updateDbpjkitWorkerJobsMany?: Maybe<Array<Maybe<DbpjkitWorkerJobsMutationResponse>>>;
  /** update data of the table: "entity_record_composer_definitions" */
  updateEntityRecordComposerDefinitions?: Maybe<EntityRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "entity_record_composer_definitions" */
  updateEntityRecordComposerDefinitionsByPk?: Maybe<EntityRecordComposerDefinitions>;
  /** update multiples rows of table: "entity_record_composer_definitions" */
  updateEntityRecordComposerDefinitionsMany?: Maybe<Array<Maybe<EntityRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "entity_records" */
  updateEntityRecords?: Maybe<EntityRecordsMutationResponse>;
  /** update single row of the table: "entity_records" */
  updateEntityRecordsByPk?: Maybe<EntityRecords>;
  /** update multiples rows of table: "entity_records" */
  updateEntityRecordsMany?: Maybe<Array<Maybe<EntityRecordsMutationResponse>>>;
  /** update data of the table: "evidence_change_requests" */
  updateEvidenceChangeRequests?: Maybe<EvidenceChangeRequestsMutationResponse>;
  /** update single row of the table: "evidence_change_requests" */
  updateEvidenceChangeRequestsByPk?: Maybe<EvidenceChangeRequests>;
  /** update multiples rows of table: "evidence_change_requests" */
  updateEvidenceChangeRequestsMany?: Maybe<Array<Maybe<EvidenceChangeRequestsMutationResponse>>>;
  /** update data of the table: "evidence_evidence_sets" */
  updateEvidenceEvidenceSets?: Maybe<EvidenceEvidenceSetsMutationResponse>;
  /** update single row of the table: "evidence_evidence_sets" */
  updateEvidenceEvidenceSetsByPk?: Maybe<EvidenceEvidenceSets>;
  /** update multiples rows of table: "evidence_evidence_sets" */
  updateEvidenceEvidenceSetsMany?: Maybe<Array<Maybe<EvidenceEvidenceSetsMutationResponse>>>;
  /** update data of the table: "evidence_importers" */
  updateEvidenceImporters?: Maybe<EvidenceImportersMutationResponse>;
  /** update single row of the table: "evidence_importers" */
  updateEvidenceImportersByPk?: Maybe<EvidenceImporters>;
  /** update multiples rows of table: "evidence_importers" */
  updateEvidenceImportersMany?: Maybe<Array<Maybe<EvidenceImportersMutationResponse>>>;
  /** update data of the table: "evidence_record_geo_items" */
  updateEvidenceRecordGeoItems?: Maybe<EvidenceRecordGeoItemsMutationResponse>;
  /** update single row of the table: "evidence_record_geo_items" */
  updateEvidenceRecordGeoItemsByPk?: Maybe<EvidenceRecordGeoItems>;
  /** update multiples rows of table: "evidence_record_geo_items" */
  updateEvidenceRecordGeoItemsMany?: Maybe<Array<Maybe<EvidenceRecordGeoItemsMutationResponse>>>;
  /** update data of the table: "evidence_set_import_projects" */
  updateEvidenceSetImportProjects?: Maybe<EvidenceSetImportProjectsMutationResponse>;
  /** update single row of the table: "evidence_set_import_projects" */
  updateEvidenceSetImportProjectsByPk?: Maybe<EvidenceSetImportProjects>;
  /** update multiples rows of table: "evidence_set_import_projects" */
  updateEvidenceSetImportProjectsMany?: Maybe<Array<Maybe<EvidenceSetImportProjectsMutationResponse>>>;
  /** update data of the table: "evidence_set_property_schema_sets" */
  updateEvidenceSetPropertySchemaSets?: Maybe<EvidenceSetPropertySchemaSetsMutationResponse>;
  /** update single row of the table: "evidence_set_property_schema_sets" */
  updateEvidenceSetPropertySchemaSetsByPk?: Maybe<EvidenceSetPropertySchemaSets>;
  /** update multiples rows of table: "evidence_set_property_schema_sets" */
  updateEvidenceSetPropertySchemaSetsMany?: Maybe<Array<Maybe<EvidenceSetPropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "evidence_sets" */
  updateEvidenceSets?: Maybe<EvidenceSetsMutationResponse>;
  /** update single row of the table: "evidence_sets" */
  updateEvidenceSetsByPk?: Maybe<EvidenceSets>;
  /** update multiples rows of table: "evidence_sets" */
  updateEvidenceSetsMany?: Maybe<Array<Maybe<EvidenceSetsMutationResponse>>>;
  /** update data of the table: "evidence_versions" */
  updateEvidenceVersions?: Maybe<EvidenceVersionsMutationResponse>;
  /** update single row of the table: "evidence_versions" */
  updateEvidenceVersionsByPk?: Maybe<EvidenceVersions>;
  /** update multiples rows of table: "evidence_versions" */
  updateEvidenceVersionsMany?: Maybe<Array<Maybe<EvidenceVersionsMutationResponse>>>;
  /** update data of the table: "evidences" */
  updateEvidences?: Maybe<EvidencesMutationResponse>;
  /** update single row of the table: "evidences" */
  updateEvidencesByPk?: Maybe<Evidences>;
  /** update multiples rows of table: "evidences" */
  updateEvidencesMany?: Maybe<Array<Maybe<EvidencesMutationResponse>>>;
  /** update data of the table: "job_run_statuses" */
  updateJobRunStatuses?: Maybe<JobRunStatusesMutationResponse>;
  /** update single row of the table: "job_run_statuses" */
  updateJobRunStatusesByPk?: Maybe<JobRunStatuses>;
  /** update multiples rows of table: "job_run_statuses" */
  updateJobRunStatusesMany?: Maybe<Array<Maybe<JobRunStatusesMutationResponse>>>;
  /** update data of the table: "organization_kinds" */
  updateOrganizationKinds?: Maybe<OrganizationKindsMutationResponse>;
  /** update single row of the table: "organization_kinds" */
  updateOrganizationKindsByPk?: Maybe<OrganizationKinds>;
  /** update multiples rows of table: "organization_kinds" */
  updateOrganizationKindsMany?: Maybe<Array<Maybe<OrganizationKindsMutationResponse>>>;
  /** update data of the table: "organizations" */
  updateOrganizations?: Maybe<OrganizationsMutationResponse>;
  /** update single row of the table: "organizations" */
  updateOrganizationsByPk?: Maybe<Organizations>;
  /** update multiples rows of table: "organizations" */
  updateOrganizationsMany?: Maybe<Array<Maybe<OrganizationsMutationResponse>>>;
  /** update data of the table: "product_roles" */
  updateProductRoles?: Maybe<ProductRolesMutationResponse>;
  /** update single row of the table: "product_roles" */
  updateProductRolesByPk?: Maybe<ProductRoles>;
  /** update multiples rows of table: "product_roles" */
  updateProductRolesMany?: Maybe<Array<Maybe<ProductRolesMutationResponse>>>;
  /** update data of the table: "products" */
  updateProducts?: Maybe<ProductsMutationResponse>;
  /** update single row of the table: "products" */
  updateProductsByPk?: Maybe<Products>;
  /** update multiples rows of table: "products" */
  updateProductsMany?: Maybe<Array<Maybe<ProductsMutationResponse>>>;
  /** update data of the table: "property_schema_associations" */
  updatePropertySchemaAssociations?: Maybe<PropertySchemaAssociationsMutationResponse>;
  /** update single row of the table: "property_schema_associations" */
  updatePropertySchemaAssociationsByPk?: Maybe<PropertySchemaAssociations>;
  /** update multiples rows of table: "property_schema_associations" */
  updatePropertySchemaAssociationsMany?: Maybe<Array<Maybe<PropertySchemaAssociationsMutationResponse>>>;
  /** update data of the table: "property_schema_sets" */
  updatePropertySchemaSets?: Maybe<PropertySchemaSetsMutationResponse>;
  /** update single row of the table: "property_schema_sets" */
  updatePropertySchemaSetsByPk?: Maybe<PropertySchemaSets>;
  /** update multiples rows of table: "property_schema_sets" */
  updatePropertySchemaSetsMany?: Maybe<Array<Maybe<PropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "property_schemas" */
  updatePropertySchemas?: Maybe<PropertySchemasMutationResponse>;
  /** update single row of the table: "property_schemas" */
  updatePropertySchemasByPk?: Maybe<PropertySchemas>;
  /** update multiples rows of table: "property_schemas" */
  updatePropertySchemasMany?: Maybe<Array<Maybe<PropertySchemasMutationResponse>>>;
  /** update data of the table: "property_types" */
  updatePropertyTypes?: Maybe<PropertyTypesMutationResponse>;
  /** update single row of the table: "property_types" */
  updatePropertyTypesByPk?: Maybe<PropertyTypes>;
  /** update multiples rows of table: "property_types" */
  updatePropertyTypesMany?: Maybe<Array<Maybe<PropertyTypesMutationResponse>>>;
  /** update data of the table: "publishers" */
  updatePublishers?: Maybe<PublishersMutationResponse>;
  /** update single row of the table: "publishers" */
  updatePublishersByPk?: Maybe<Publishers>;
  /** update multiples rows of table: "publishers" */
  updatePublishersMany?: Maybe<Array<Maybe<PublishersMutationResponse>>>;
  /** update data of the table: "record_composer_definition_evidence_sets" */
  updateRecordComposerDefinitionEvidenceSets?: Maybe<RecordComposerDefinitionEvidenceSetsMutationResponse>;
  /** update single row of the table: "record_composer_definition_evidence_sets" */
  updateRecordComposerDefinitionEvidenceSetsByPk?: Maybe<RecordComposerDefinitionEvidenceSets>;
  /** update multiples rows of table: "record_composer_definition_evidence_sets" */
  updateRecordComposerDefinitionEvidenceSetsMany?: Maybe<Array<Maybe<RecordComposerDefinitionEvidenceSetsMutationResponse>>>;
  /** update data of the table: "record_composer_definition_property_schema_sets" */
  updateRecordComposerDefinitionPropertySchemaSets?: Maybe<RecordComposerDefinitionPropertySchemaSetsMutationResponse>;
  /** update single row of the table: "record_composer_definition_property_schema_sets" */
  updateRecordComposerDefinitionPropertySchemaSetsByPk?: Maybe<RecordComposerDefinitionPropertySchemaSets>;
  /** update multiples rows of table: "record_composer_definition_property_schema_sets" */
  updateRecordComposerDefinitionPropertySchemaSetsMany?: Maybe<Array<Maybe<RecordComposerDefinitionPropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "record_composer_definitions" */
  updateRecordComposerDefinitions?: Maybe<RecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "record_composer_definitions" */
  updateRecordComposerDefinitionsByPk?: Maybe<RecordComposerDefinitions>;
  /** update multiples rows of table: "record_composer_definitions" */
  updateRecordComposerDefinitionsMany?: Maybe<Array<Maybe<RecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "record_compound_record_composers" */
  updateRecordCompoundRecordComposers?: Maybe<RecordCompoundRecordComposersMutationResponse>;
  /** update single row of the table: "record_compound_record_composers" */
  updateRecordCompoundRecordComposersByPk?: Maybe<RecordCompoundRecordComposers>;
  /** update multiples rows of table: "record_compound_record_composers" */
  updateRecordCompoundRecordComposersMany?: Maybe<Array<Maybe<RecordCompoundRecordComposersMutationResponse>>>;
  /** update data of the table: "record_geo_items" */
  updateRecordGeoItems?: Maybe<RecordGeoItemsMutationResponse>;
  /** update single row of the table: "record_geo_items" */
  updateRecordGeoItemsByPk?: Maybe<RecordGeoItems>;
  /** update multiples rows of table: "record_geo_items" */
  updateRecordGeoItemsMany?: Maybe<Array<Maybe<RecordGeoItemsMutationResponse>>>;
  /** update data of the table: "record_metadata" */
  updateRecordMetadata?: Maybe<RecordMetadataMutationResponse>;
  /** update single row of the table: "record_metadata" */
  updateRecordMetadataByPk?: Maybe<RecordMetadata>;
  /** update data of the table: "record_metadata_categories" */
  updateRecordMetadataCategories?: Maybe<RecordMetadataCategoriesMutationResponse>;
  /** update single row of the table: "record_metadata_categories" */
  updateRecordMetadataCategoriesByPk?: Maybe<RecordMetadataCategories>;
  /** update multiples rows of table: "record_metadata_categories" */
  updateRecordMetadataCategoriesMany?: Maybe<Array<Maybe<RecordMetadataCategoriesMutationResponse>>>;
  /** update multiples rows of table: "record_metadata" */
  updateRecordMetadataMany?: Maybe<Array<Maybe<RecordMetadataMutationResponse>>>;
  /** update data of the table: "record_metadata_property_schema_sets" */
  updateRecordMetadataPropertySchemaSets?: Maybe<RecordMetadataPropertySchemaSetsMutationResponse>;
  /** update single row of the table: "record_metadata_property_schema_sets" */
  updateRecordMetadataPropertySchemaSetsByPk?: Maybe<RecordMetadataPropertySchemaSets>;
  /** update multiples rows of table: "record_metadata_property_schema_sets" */
  updateRecordMetadataPropertySchemaSetsMany?: Maybe<Array<Maybe<RecordMetadataPropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "record_property_schema_sets" */
  updateRecordPropertySchemaSets?: Maybe<RecordPropertySchemaSetsMutationResponse>;
  /** update single row of the table: "record_property_schema_sets" */
  updateRecordPropertySchemaSetsByPk?: Maybe<RecordPropertySchemaSets>;
  /** update multiples rows of table: "record_property_schema_sets" */
  updateRecordPropertySchemaSetsMany?: Maybe<Array<Maybe<RecordPropertySchemaSetsMutationResponse>>>;
  /** update data of the table: "record_update_record_composer_definitions" */
  updateRecordUpdateRecordComposerDefinitions?: Maybe<RecordUpdateRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "record_update_record_composer_definitions" */
  updateRecordUpdateRecordComposerDefinitionsByPk?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** update multiples rows of table: "record_update_record_composer_definitions" */
  updateRecordUpdateRecordComposerDefinitionsMany?: Maybe<Array<Maybe<RecordUpdateRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "records" */
  updateRecords?: Maybe<RecordsMutationResponse>;
  /** update single row of the table: "records" */
  updateRecordsByPk?: Maybe<Records>;
  /** update multiples rows of table: "records" */
  updateRecordsMany?: Maybe<Array<Maybe<RecordsMutationResponse>>>;
  /** update data of the table: "reference_files" */
  updateReferenceFiles?: Maybe<ReferenceFilesMutationResponse>;
  /** update single row of the table: "reference_files" */
  updateReferenceFilesByPk?: Maybe<ReferenceFiles>;
  /** update multiples rows of table: "reference_files" */
  updateReferenceFilesMany?: Maybe<Array<Maybe<ReferenceFilesMutationResponse>>>;
  /** update data of the table: "reference_publishers" */
  updateReferencePublishers?: Maybe<ReferencePublishersMutationResponse>;
  /** update single row of the table: "reference_publishers" */
  updateReferencePublishersByPk?: Maybe<ReferencePublishers>;
  /** update multiples rows of table: "reference_publishers" */
  updateReferencePublishersMany?: Maybe<Array<Maybe<ReferencePublishersMutationResponse>>>;
  /** update data of the table: "references" */
  updateReferences?: Maybe<ReferencesMutationResponse>;
  /** update single row of the table: "references" */
  updateReferencesByPk?: Maybe<References>;
  /** update multiples rows of table: "references" */
  updateReferencesMany?: Maybe<Array<Maybe<ReferencesMutationResponse>>>;
  /** update data of the table: "relation_record_composer_definitions" */
  updateRelationRecordComposerDefinitions?: Maybe<RelationRecordComposerDefinitionsMutationResponse>;
  /** update single row of the table: "relation_record_composer_definitions" */
  updateRelationRecordComposerDefinitionsByPk?: Maybe<RelationRecordComposerDefinitions>;
  /** update multiples rows of table: "relation_record_composer_definitions" */
  updateRelationRecordComposerDefinitionsMany?: Maybe<Array<Maybe<RelationRecordComposerDefinitionsMutationResponse>>>;
  /** update data of the table: "relation_records" */
  updateRelationRecords?: Maybe<RelationRecordsMutationResponse>;
  /** update single row of the table: "relation_records" */
  updateRelationRecordsByPk?: Maybe<RelationRecords>;
  /** update multiples rows of table: "relation_records" */
  updateRelationRecordsMany?: Maybe<Array<Maybe<RelationRecordsMutationResponse>>>;
  /** update data of the table: "relation_types" */
  updateRelationTypes?: Maybe<RelationTypesMutationResponse>;
  /** update single row of the table: "relation_types" */
  updateRelationTypesByPk?: Maybe<RelationTypes>;
  /** update multiples rows of table: "relation_types" */
  updateRelationTypesMany?: Maybe<Array<Maybe<RelationTypesMutationResponse>>>;
  /** update data of the table: "roles" */
  updateRoles?: Maybe<RolesMutationResponse>;
  /** update single row of the table: "roles" */
  updateRolesByPk?: Maybe<Roles>;
  /** update multiples rows of table: "roles" */
  updateRolesMany?: Maybe<Array<Maybe<RolesMutationResponse>>>;
  /** update data of the table: "source_record_edges" */
  updateSourceRecordEdges?: Maybe<SourceRecordEdgesMutationResponse>;
  /** update single row of the table: "source_record_edges" */
  updateSourceRecordEdgesByPk?: Maybe<SourceRecordEdges>;
  /** update multiples rows of table: "source_record_edges" */
  updateSourceRecordEdgesMany?: Maybe<Array<Maybe<SourceRecordEdgesMutationResponse>>>;
  /** update data of the table: "target_record_edges" */
  updateTargetRecordEdges?: Maybe<TargetRecordEdgesMutationResponse>;
  /** update single row of the table: "target_record_edges" */
  updateTargetRecordEdgesByPk?: Maybe<TargetRecordEdges>;
  /** update multiples rows of table: "target_record_edges" */
  updateTargetRecordEdgesMany?: Maybe<Array<Maybe<TargetRecordEdgesMutationResponse>>>;
  /** update data of the table: "tenant_product_installations" */
  updateTenantProductInstallations?: Maybe<TenantProductInstallationsMutationResponse>;
  /** update single row of the table: "tenant_product_installations" */
  updateTenantProductInstallationsByPk?: Maybe<TenantProductInstallations>;
  /** update multiples rows of table: "tenant_product_installations" */
  updateTenantProductInstallationsMany?: Maybe<Array<Maybe<TenantProductInstallationsMutationResponse>>>;
  /** update data of the table: "tenants" */
  updateTenants?: Maybe<TenantsMutationResponse>;
  /** update single row of the table: "tenants" */
  updateTenantsByPk?: Maybe<Tenants>;
  /** update multiples rows of table: "tenants" */
  updateTenantsMany?: Maybe<Array<Maybe<TenantsMutationResponse>>>;
  /** update data of the table: "unified_evidence_drafts" */
  updateUnifiedEvidenceDrafts?: Maybe<UnifiedEvidenceDraftsMutationResponse>;
  /** update single row of the table: "unified_evidence_drafts" */
  updateUnifiedEvidenceDraftsByPk?: Maybe<UnifiedEvidenceDrafts>;
  /** update multiples rows of table: "unified_evidence_drafts" */
  updateUnifiedEvidenceDraftsMany?: Maybe<Array<Maybe<UnifiedEvidenceDraftsMutationResponse>>>;
  /** update data of the table: "user_groups" */
  updateUserGroups?: Maybe<UserGroupsMutationResponse>;
  /** update single row of the table: "user_groups" */
  updateUserGroupsByPk?: Maybe<UserGroups>;
  /** update multiples rows of table: "user_groups" */
  updateUserGroupsMany?: Maybe<Array<Maybe<UserGroupsMutationResponse>>>;
  /** update data of the table: "user_product_roles" */
  updateUserProductRoles?: Maybe<UserProductRolesMutationResponse>;
  /** update single row of the table: "user_product_roles" */
  updateUserProductRolesByPk?: Maybe<UserProductRoles>;
  /** update multiples rows of table: "user_product_roles" */
  updateUserProductRolesMany?: Maybe<Array<Maybe<UserProductRolesMutationResponse>>>;
  /** update data of the table: "user_segments" */
  updateUserSegments?: Maybe<UserSegmentsMutationResponse>;
  /** update single row of the table: "user_segments" */
  updateUserSegmentsByPk?: Maybe<UserSegments>;
  /** update multiples rows of table: "user_segments" */
  updateUserSegmentsMany?: Maybe<Array<Maybe<UserSegmentsMutationResponse>>>;
  /** update data of the table: "user_tenants" */
  updateUserTenants?: Maybe<UserTenantsMutationResponse>;
  /** update single row of the table: "user_tenants" */
  updateUserTenantsByPk?: Maybe<UserTenants>;
  /** update multiples rows of table: "user_tenants" */
  updateUserTenantsMany?: Maybe<Array<Maybe<UserTenantsMutationResponse>>>;
  /** update data of the table: "user_user_groups" */
  updateUserUserGroups?: Maybe<UserUserGroupsMutationResponse>;
  /** update single row of the table: "user_user_groups" */
  updateUserUserGroupsByPk?: Maybe<UserUserGroups>;
  /** update multiples rows of table: "user_user_groups" */
  updateUserUserGroupsMany?: Maybe<Array<Maybe<UserUserGroupsMutationResponse>>>;
  /** update data of the table: "user_user_segments" */
  updateUserUserSegments?: Maybe<UserUserSegmentsMutationResponse>;
  /** update single row of the table: "user_user_segments" */
  updateUserUserSegmentsByPk?: Maybe<UserUserSegments>;
  /** update multiples rows of table: "user_user_segments" */
  updateUserUserSegmentsMany?: Maybe<Array<Maybe<UserUserSegmentsMutationResponse>>>;
  /** update data of the table: "users" */
  updateUsers?: Maybe<UsersMutationResponse>;
  /** update single row of the table: "users" */
  updateUsersByPk?: Maybe<Users>;
  /** update multiples rows of table: "users" */
  updateUsersMany?: Maybe<Array<Maybe<UsersMutationResponse>>>;
};


/** mutation root */
export type Mutation_RootCnutActivateBatchChangeRequestsJobArgs = {
  input: BatchChangeRequestsJobActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateBatchEvidencesJobArgs = {
  input: BatchEvidencesJobActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateCategoryArgs = {
  input: CategoryActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateDataImportProjectArgs = {
  input: DataImportProjectActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateDataSourceArgs = {
  input: DataSourceActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateDataSourceTemplateArgs = {
  input: DataSourceTemplateActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateEvidenceArgs = {
  input: EvidenceActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateEvidenceImporterArgs = {
  input: EvidenceImporterActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateGeoItemArgs = {
  input: GeoItemActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateProductArgs = {
  input: ProductActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateRecordComposerDefinitionArgs = {
  input: RecordComposerDefinitionActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateReferenceArgs = {
  input: ReferenceActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateRelationTypeArgs = {
  input: RelationTypeActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateTenantArgs = {
  input: TenantActivateInput;
};


/** mutation root */
export type Mutation_RootCnutActivateUserArgs = {
  input?: InputMaybe<UserActivateInput>;
};


/** mutation root */
export type Mutation_RootCnutAddDataImportProjectMembersArgs = {
  input: DataImportProjectAddMembersInput;
};


/** mutation root */
export type Mutation_RootCnutAddTenantMembersArgs = {
  input: TenantAddMembersInput;
};


/** mutation root */
export type Mutation_RootCnutAddTenantProductMembersArgs = {
  input: TenantAddProductMembersInput;
};


/** mutation root */
export type Mutation_RootCnutAssignUserGroupsArgs = {
  input?: InputMaybe<UserGroupAssignInput>;
};


/** mutation root */
export type Mutation_RootCnutAutofixDataSourceArgs = {
  input: DataSourceAutofixInput;
};


/** mutation root */
export type Mutation_RootCnutBatchCreateDataSourcesInImportProjectArgs = {
  input: DataSourceInImportProjectBatchCreateInput;
};


/** mutation root */
export type Mutation_RootCnutBatchUpdateDataSourcesArgs = {
  input: DataSourceBatchUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutBootstrapDataImportProjectArgs = {
  input: DataImportProjectBootstrapInput;
};


/** mutation root */
export type Mutation_RootCnutBootstrapDataImportProjectV2Args = {
  input: BootstrapDataImportProjectV2Input;
};


/** mutation root */
export type Mutation_RootCnutBulkCreateUsersFromFileArgs = {
  input: BulkCreateUsersFromFileInput;
};


/** mutation root */
export type Mutation_RootCnutCancelUserEmailChangeArgs = {
  userId: Scalars['UUID']['input'];
};


/** mutation root */
export type Mutation_RootCnutClaspPushDataSourceGSheetsArgs = {
  input: DataSourceGSheetsClaspPushInput;
};


/** mutation root */
export type Mutation_RootCnutClaspPushSidebarArgs = {
  input: ClaspPushSidebarInput;
};


/** mutation root */
export type Mutation_RootCnutCreateBatchChangeRequestsJobArgs = {
  input: BatchChangeRequestsJobCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateBatchEvidencesJobArgs = {
  input: BatchEvidencesJobCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateChangeRequestArgs = {
  input: ChangeRequestCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateChangeRequestReviewArgs = {
  input: ChangeRequestReviewCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateCompoundRecordVersionArgs = {
  input: CompoundRecordVersionCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateDataImportProjectArgs = {
  input: DataImportProjectCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateDataSourceInImportProjectArgs = {
  input: DataSourceInImportProjectCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateDataSourceTemplateArgs = {
  input: DataSourceTemplateCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateEvidenceSetFromFileArgs = {
  input: EvidenceSetCreateFromFileInput;
};


/** mutation root */
export type Mutation_RootCnutCreateEvidenceSetImportProjectArgs = {
  input: EvidenceSetImportProjectCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateGeoItemArgs = {
  input: GeoItemCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateGeoItemWithoutRecordArgs = {
  input: GeoItemWithoutRecordCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateOrganizationArgs = {
  input: OrganizationCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateTenantArgs = {
  input: TenantCreateInput;
};


/** mutation root */
export type Mutation_RootCnutCreateUserArgs = {
  input?: InputMaybe<UserCreateInput>;
};


/** mutation root */
export type Mutation_RootCnutCreateUserGroupArgs = {
  input?: InputMaybe<UserGroupCreateInput>;
};


/** mutation root */
export type Mutation_RootCnutDeactivateBatchChangeRequestsJobArgs = {
  input: BatchChangeRequestsJobDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateBatchEvidencesJobArgs = {
  input: BatchEvidencesJobDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateCategoryArgs = {
  input: CategoryDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateDataImportProjectArgs = {
  input: DataImportProjectDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateDataSourceArgs = {
  input: DataSourceDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateDataSourceTemplateArgs = {
  input: DataSourceTemplateDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateEvidenceArgs = {
  input: EvidenceDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateEvidenceImporterArgs = {
  input: EvidenceImporterDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateGeoItemArgs = {
  input: GeoItemDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateProductArgs = {
  input: ProductDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateRecordComposerDefinitionArgs = {
  input: RecordComposerDefinitionDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateRecordGeoItemArgs = {
  input: RecordGeoItemDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateReferenceArgs = {
  input: ReferenceDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateRelationTypeArgs = {
  input: RelationTypeDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateTenantArgs = {
  input: TenantDeactivateInput;
};


/** mutation root */
export type Mutation_RootCnutDeactivateUserArgs = {
  input?: InputMaybe<UserDeactivateInput>;
};


/** mutation root */
export type Mutation_RootCnutDeleteCompoundRecordComposerArgs = {
  input: CompoundRecordComposerDeleteInput;
};


/** mutation root */
export type Mutation_RootCnutDeleteEvidenceSetImportProjectArgs = {
  input: EvidenceSetImportProjectDeleteInput;
};


/** mutation root */
export type Mutation_RootCnutExportEvidenceSetArgs = {
  input: EvidenceSetExportInput;
};


/** mutation root */
export type Mutation_RootCnutHandleReferenceFileEventArgs = {
  input: ReferenceFileEventHandleInput;
};


/** mutation root */
export type Mutation_RootCnutImportDirectArgs = {
  input: UserDataImportInput;
};


/** mutation root */
export type Mutation_RootCnutImportDirectAttributedArgs = {
  input: ImportDirectAttributedInput;
};


/** mutation root */
export type Mutation_RootCnutInstallTenantProductArgs = {
  input: TenantInstallProductInput;
};


/** mutation root */
export type Mutation_RootCnutInvokeApplySchemaArgs = {
  input: ApplySchemaInvokeInput;
};


/** mutation root */
export type Mutation_RootCnutInvokeDataImportJobDiagnosisArgs = {
  input: CnutInvokeDataImportJobDiagnosisInput;
};


/** mutation root */
export type Mutation_RootCnutInvokeForceOnEditArgs = {
  input: ForceOnEditInvokeInput;
};


/** mutation root */
export type Mutation_RootCnutInvokeWorkerArgs = {
  input: InvokeWorkerInput;
};


/** mutation root */
export type Mutation_RootCnutPrepareEventNormalizationImportArgs = {
  input: PrepareEventNormalizationImportInput;
};


/** mutation root */
export type Mutation_RootCnutPrepareUserLoginArgs = {
  id: Scalars['UUID']['input'];
};


/** mutation root */
export type Mutation_RootCnutProceedRecordUpdateDataImportProjectArgs = {
  input: RecordUpdateProceedInput;
};


/** mutation root */
export type Mutation_RootCnutRefreshUserEmailChangeArgs = {
  userId: Scalars['UUID']['input'];
};


/** mutation root */
export type Mutation_RootCnutRemoveTenantMembersArgs = {
  input: TenantRemoveMembersInput;
};


/** mutation root */
export type Mutation_RootCnutRemoveTenantProductMemberAccessArgs = {
  input: TenantRemoveProductMemberAccessInput;
};


/** mutation root */
export type Mutation_RootCnutRemoveUserProductRoleArgs = {
  input: UserRemoveProductRoleInput;
};


/** mutation root */
export type Mutation_RootCnutRequestUserEmailChangeArgs = {
  newEmail: Scalars['String']['input'];
  userId: Scalars['UUID']['input'];
};


/** mutation root */
export type Mutation_RootCnutRerunWorkerJobArgs = {
  input: RerunWorkerJobInput;
};


/** mutation root */
export type Mutation_RootCnutSetUserProductRoleArgs = {
  input: UserSetProductRoleInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitBatchChangeRequestReviewsJobArgs = {
  input: RunBatchChangeRequestReviewsJobInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitBatchChangeRequestsJobArgs = {
  input: BatchChangeRequestsJobSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitBatchEvidenceCommitsJobArgs = {
  input: BatchEvidenceCommitsJobSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitBatchEvidencesJobArgs = {
  input: BatchEvidencesJobSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitCategorySchemaMigrationArgs = {
  input: CategorySchemaMigrationSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitDataImportPipelineJobArgs = {
  input: DataImportPipelineJobSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutSubmitReferenceFileJobArgs = {
  input: ReferenceFileJobSubmitInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateBatchChangeRequestReviewsJobRunArgs = {
  input: BatchChangeRequestReviewsJobRunUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateBatchChangeRequestsJobArgs = {
  input: BatchChangeRequestsJobUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateBatchChangeRequestsJobRunArgs = {
  input: BatchChangeRequestsJobRunUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateBatchEvidencesJobArgs = {
  input: BatchEvidencesJobUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateBatchEvidencesJobRunArgs = {
  input: BatchEvidencesJobRunUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateDataImportProjectArgs = {
  input: DataImportProjectUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateDataImportProjectStatusArgs = {
  input: DataImportProjectStatusUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateDataSourceArgs = {
  input: DataSourceUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateDataSourceJsonDataArgs = {
  input: DataSourceJsonDataUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateDataSourceTemplateArgs = {
  input: DataSourceTemplateUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateEvidenceSetArgs = {
  input: EvidenceSetUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateGeoItemArgs = {
  input: GeoItemUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateJobRunArgs = {
  input: JobRunUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateMyProfileArgs = {
  input: UserProfileUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateMyProfileImageArgs = {
  input: UserProfileImageUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateProductAvailableRolesArgs = {
  input: UpdateProductAvailableRolesInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateRecordGeoItemArgs = {
  input: RecordGeoItemUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateRecordMetadataSchemaArgs = {
  input: RecordMetadataSchemaUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateRecordUpdateComposerDefinitionArgs = {
  input: UpdateRecordUpdateComposerDefinitionInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateReferenceFileArgs = {
  input: ReferenceFileUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateTenantArgs = {
  input: TenantUpdateInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateTenantMemberRoleArgs = {
  input: TenantUpdateMemberRoleInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateTenantOwnerArgs = {
  input: TenantUpdateOwnerInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateTenantProductMemberAccessArgs = {
  input: TenantUpdateProductMemberAccessInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateTenantProductVisibilityArgs = {
  input: TenantUpdateProductVisibilityInput;
};


/** mutation root */
export type Mutation_RootCnutUpdateUserArgs = {
  input?: InputMaybe<UserUpdateInput>;
};


/** mutation root */
export type Mutation_RootCnutUpdateUserGroupArgs = {
  input?: InputMaybe<UserGroupUpdateInput>;
};


/** mutation root */
export type Mutation_RootCnutUpdateUserOrganizationArgs = {
  input: UserUpdateOrganizationInput;
};


/** mutation root */
export type Mutation_RootCnutUploadCompoundRecordComposersFileArgs = {
  input: CompoundRecordComposerFileUploadInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertCategoryArgs = {
  input: CategoryUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertEntityComposerDefinitionArgs = {
  input: RecordComposerDefinitionUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertEvidenceImporterArgs = {
  input: EvidenceImporterUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertProductArgs = {
  input: ProductUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertReferenceArgs = {
  input: ReferenceUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertRelationComposerDefinitionArgs = {
  input: RecordComposerDefinitionUpsertInput;
};


/** mutation root */
export type Mutation_RootCnutUpsertRelationTypeArgs = {
  input: RelationTypeUpsertInput;
};


/** mutation root */
export type Mutation_RootDeleteAreaCodesArgs = {
  where: AreaCodesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteAreaCodesByPkArgs = {
  countryId: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestReviewsJobRunsArgs = {
  where: BatchChangeRequestReviewsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestReviewsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestReviewsJobsArgs = {
  where: BatchChangeRequestReviewsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestReviewsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  where: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobRecordComposerDefinitionsByPkArgs = {
  batchChangeRequestsJobId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobRunsArgs = {
  where: BatchChangeRequestsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobsArgs = {
  where: BatchChangeRequestsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchChangeRequestsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidenceCommitsJobRunsArgs = {
  where: BatchEvidenceCommitsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidenceCommitsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidenceCommitsJobsArgs = {
  where: BatchEvidenceCommitsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidenceCommitsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidencesJobRunsArgs = {
  where: BatchEvidencesJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidencesJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidencesJobsArgs = {
  where: BatchEvidencesJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteBatchEvidencesJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCategoriesArgs = {
  where: CategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryPathsArgs = {
  where: CategoryPathsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCategoryPathsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryPropertySchemaSetsArgs = {
  where: CategoryPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCategoryPropertySchemaSetsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCategoryTypesArgs = {
  where: CategoryTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCategoryTypesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestCommitsArgs = {
  where: ChangeRequestCommitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestCommitsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemCommitsArgs = {
  where: ChangeRequestItemCommitsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemCommitsByPkArgs = {
  changeRequestCommitId: Scalars['uuid']['input'];
  changeRequestItemId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemRecordMetadataArgs = {
  where: ChangeRequestItemRecordMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemRecordMetadataByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemRecordsArgs = {
  where: ChangeRequestItemRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemRecordsByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemsArgs = {
  where: ChangeRequestItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestRecordComposerDefinitionsArgs = {
  where: ChangeRequestRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestRecordComposerDefinitionsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestReviewTypesArgs = {
  where: ChangeRequestReviewTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestReviewTypesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestReviewsArgs = {
  where: ChangeRequestReviewsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestReviewsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestStatusesArgs = {
  where: ChangeRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestsArgs = {
  where: ChangeRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteChangeRequestsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCompoundCompoundRecordsArgs = {
  where: CompoundCompoundRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompoundCompoundRecordsByPkArgs = {
  key: Scalars['String']['input'];
  v: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCompoundRecordComposersArgs = {
  where: CompoundRecordComposersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompoundRecordComposersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCompoundRecordVersionsArgs = {
  where: CompoundRecordVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCompoundRecordVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCountriesArgs = {
  where: CountriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCountriesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteCountrySubdivisionsArgs = {
  where: CountrySubdivisionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteCountrySubdivisionsByPkArgs = {
  code: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectRecordComposerDefinitionsArgs = {
  where: DataImportProjectRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectStatusLogsArgs = {
  where: DataImportProjectStatusLogsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectStatusLogsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectStatusesArgs = {
  where: DataImportProjectStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectUsersArgs = {
  where: DataImportProjectUsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectUsersByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectsArgs = {
  where: DataImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataImportProjectsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceGsheetsArgs = {
  where: DataSourceGsheetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceGsheetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceImportProjectRecordComposerDefinitionsArgs = {
  where: DataSourceImportProjectRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceImportProjectsArgs = {
  where: DataSourceImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceJsonsArgs = {
  where: DataSourceJsonsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceJsonsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourcePropertySchemaSetsArgs = {
  where: DataSourcePropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourcePropertySchemaSetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceReferencesArgs = {
  where: DataSourceReferencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceReferencesByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceTemplatePropertySchemaSetsArgs = {
  where: DataSourceTemplatePropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceTemplatePropertySchemaSetsByPkArgs = {
  dataSourceTemplateId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourceTemplatesArgs = {
  where: DataSourceTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourceTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDataSourcesArgs = {
  where: DataSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDataSourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDbpjkitWorkerJobRunsArgs = {
  where: DbpjkitWorkerJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDbpjkitWorkerJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteDbpjkitWorkerJobsArgs = {
  where: DbpjkitWorkerJobsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteDbpjkitWorkerJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEntityRecordComposerDefinitionsArgs = {
  where: EntityRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntityRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEntityRecordsArgs = {
  where: EntityRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEntityRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceChangeRequestsArgs = {
  where: EvidenceChangeRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceChangeRequestsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
  evidenceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceEvidenceSetsArgs = {
  where: EvidenceEvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceEvidenceSetsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceImportersArgs = {
  where: EvidenceImportersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceImportersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceRecordGeoItemsArgs = {
  where: EvidenceRecordGeoItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceRecordGeoItemsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetImportProjectsArgs = {
  where: EvidenceSetImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetPropertySchemaSetsArgs = {
  where: EvidenceSetPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetPropertySchemaSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetsArgs = {
  where: EvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidenceVersionsArgs = {
  where: EvidenceVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidenceVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteEvidencesArgs = {
  where: EvidencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteEvidencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteJobRunStatusesArgs = {
  where: JobRunStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteJobRunStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrganizationKindsArgs = {
  where: OrganizationKindsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOrganizationKindsByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeleteOrganizationsArgs = {
  where: OrganizationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProductRolesArgs = {
  where: ProductRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteProductsArgs = {
  where: ProductsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteProductsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePropertySchemaAssociationsArgs = {
  where: PropertySchemaAssociationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePropertySchemaAssociationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePropertySchemaSetsArgs = {
  where: PropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePropertySchemaSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePropertySchemasArgs = {
  where: PropertySchemasBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePropertySchemasByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeletePropertyTypesArgs = {
  where: PropertyTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePropertyTypesByPkArgs = {
  id: Scalars['String']['input'];
};


/** mutation root */
export type Mutation_RootDeletePublishersArgs = {
  where: PublishersBoolExp;
};


/** mutation root */
export type Mutation_RootDeletePublishersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionEvidenceSetsArgs = {
  where: RecordComposerDefinitionEvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionEvidenceSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionPropertySchemaSetsArgs = {
  where: RecordComposerDefinitionPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionPropertySchemaSetsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionsArgs = {
  where: RecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordComposerDefinitionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordCompoundRecordComposersArgs = {
  where: RecordCompoundRecordComposersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordCompoundRecordComposersByPkArgs = {
  compoundRecordComposerId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordGeoItemsArgs = {
  where: RecordGeoItemsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordGeoItemsByPkArgs = {
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataArgs = {
  where: RecordMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataCategoriesArgs = {
  where: RecordMetadataCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataCategoriesByPkArgs = {
  categoryId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataPropertySchemaSetsArgs = {
  where: RecordMetadataPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordMetadataPropertySchemaSetsByPkArgs = {
  propertySchemaSetId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordPropertySchemaSetsArgs = {
  where: RecordPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordPropertySchemaSetsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordUpdateRecordComposerDefinitionsArgs = {
  where: RecordUpdateRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordUpdateRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRecordsArgs = {
  where: RecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRecordsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteReferenceFilesArgs = {
  where: ReferenceFilesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReferenceFilesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteReferencePublishersArgs = {
  where: ReferencePublishersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReferencePublishersByPkArgs = {
  publisherId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteReferencesArgs = {
  where: ReferencesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRelationRecordComposerDefinitionsArgs = {
  where: RelationRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRelationRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRelationRecordsArgs = {
  where: RelationRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRelationRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRelationTypesArgs = {
  where: RelationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRelationTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteRolesArgs = {
  where: RolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteRolesByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteSourceRecordEdgesArgs = {
  where: SourceRecordEdgesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteSourceRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteTargetRecordEdgesArgs = {
  where: TargetRecordEdgesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTargetRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteTenantProductInstallationsArgs = {
  where: TenantProductInstallationsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTenantProductInstallationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteTenantsArgs = {
  where: TenantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteTenantsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUnifiedEvidenceDraftsArgs = {
  where: UnifiedEvidenceDraftsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUnifiedEvidenceDraftsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserGroupsArgs = {
  where: UserGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserProductRolesArgs = {
  where: UserProductRolesBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserSegmentsArgs = {
  where: UserSegmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserSegmentsByPkArgs = {
  id: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserTenantsArgs = {
  where: UserTenantsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserTenantsByPkArgs = {
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserUserGroupsArgs = {
  where: UserUserGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserUserGroupsByPkArgs = {
  userGroupId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUserUserSegmentsArgs = {
  where: UserUserSegmentsBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUserUserSegmentsByPkArgs = {
  userId: Scalars['uuid']['input'];
  userSegmentId: Scalars['Int']['input'];
};


/** mutation root */
export type Mutation_RootDeleteUsersArgs = {
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootDeleteUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


/** mutation root */
export type Mutation_RootInsertAreaCodesArgs = {
  objects: Array<AreaCodesInsertInput>;
  onConflict?: InputMaybe<AreaCodesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertAreaCodesOneArgs = {
  object: AreaCodesInsertInput;
  onConflict?: InputMaybe<AreaCodesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestReviewsJobRunsArgs = {
  objects: Array<BatchChangeRequestReviewsJobRunsInsertInput>;
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestReviewsJobRunsOneArgs = {
  object: BatchChangeRequestReviewsJobRunsInsertInput;
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestReviewsJobsArgs = {
  objects: Array<BatchChangeRequestReviewsJobsInsertInput>;
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestReviewsJobsOneArgs = {
  object: BatchChangeRequestReviewsJobsInsertInput;
  onConflict?: InputMaybe<BatchChangeRequestReviewsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  objects: Array<BatchChangeRequestsJobRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobRecordComposerDefinitionsOneArgs = {
  object: BatchChangeRequestsJobRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobRunsArgs = {
  objects: Array<BatchChangeRequestsJobRunsInsertInput>;
  onConflict?: InputMaybe<BatchChangeRequestsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobRunsOneArgs = {
  object: BatchChangeRequestsJobRunsInsertInput;
  onConflict?: InputMaybe<BatchChangeRequestsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobsArgs = {
  objects: Array<BatchChangeRequestsJobsInsertInput>;
  onConflict?: InputMaybe<BatchChangeRequestsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchChangeRequestsJobsOneArgs = {
  object: BatchChangeRequestsJobsInsertInput;
  onConflict?: InputMaybe<BatchChangeRequestsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidenceCommitsJobRunsArgs = {
  objects: Array<BatchEvidenceCommitsJobRunsInsertInput>;
  onConflict?: InputMaybe<BatchEvidenceCommitsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidenceCommitsJobRunsOneArgs = {
  object: BatchEvidenceCommitsJobRunsInsertInput;
  onConflict?: InputMaybe<BatchEvidenceCommitsJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidenceCommitsJobsArgs = {
  objects: Array<BatchEvidenceCommitsJobsInsertInput>;
  onConflict?: InputMaybe<BatchEvidenceCommitsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidenceCommitsJobsOneArgs = {
  object: BatchEvidenceCommitsJobsInsertInput;
  onConflict?: InputMaybe<BatchEvidenceCommitsJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidencesJobRunsArgs = {
  objects: Array<BatchEvidencesJobRunsInsertInput>;
  onConflict?: InputMaybe<BatchEvidencesJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidencesJobRunsOneArgs = {
  object: BatchEvidencesJobRunsInsertInput;
  onConflict?: InputMaybe<BatchEvidencesJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidencesJobsArgs = {
  objects: Array<BatchEvidencesJobsInsertInput>;
  onConflict?: InputMaybe<BatchEvidencesJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertBatchEvidencesJobsOneArgs = {
  object: BatchEvidencesJobsInsertInput;
  onConflict?: InputMaybe<BatchEvidencesJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoriesArgs = {
  objects: Array<CategoriesInsertInput>;
  onConflict?: InputMaybe<CategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoriesOneArgs = {
  object: CategoriesInsertInput;
  onConflict?: InputMaybe<CategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryPathsArgs = {
  objects: Array<CategoryPathsInsertInput>;
  onConflict?: InputMaybe<CategoryPathsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryPathsOneArgs = {
  object: CategoryPathsInsertInput;
  onConflict?: InputMaybe<CategoryPathsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryPropertySchemaSetsArgs = {
  objects: Array<CategoryPropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<CategoryPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryPropertySchemaSetsOneArgs = {
  object: CategoryPropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<CategoryPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryTypesArgs = {
  objects: Array<CategoryTypesInsertInput>;
  onConflict?: InputMaybe<CategoryTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCategoryTypesOneArgs = {
  object: CategoryTypesInsertInput;
  onConflict?: InputMaybe<CategoryTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestCommitsArgs = {
  objects: Array<ChangeRequestCommitsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestCommitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestCommitsOneArgs = {
  object: ChangeRequestCommitsInsertInput;
  onConflict?: InputMaybe<ChangeRequestCommitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemCommitsArgs = {
  objects: Array<ChangeRequestItemCommitsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestItemCommitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemCommitsOneArgs = {
  object: ChangeRequestItemCommitsInsertInput;
  onConflict?: InputMaybe<ChangeRequestItemCommitsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemRecordMetadataArgs = {
  objects: Array<ChangeRequestItemRecordMetadataInsertInput>;
  onConflict?: InputMaybe<ChangeRequestItemRecordMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemRecordMetadataOneArgs = {
  object: ChangeRequestItemRecordMetadataInsertInput;
  onConflict?: InputMaybe<ChangeRequestItemRecordMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemRecordsArgs = {
  objects: Array<ChangeRequestItemRecordsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestItemRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemRecordsOneArgs = {
  object: ChangeRequestItemRecordsInsertInput;
  onConflict?: InputMaybe<ChangeRequestItemRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemsArgs = {
  objects: Array<ChangeRequestItemsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestItemsOneArgs = {
  object: ChangeRequestItemsInsertInput;
  onConflict?: InputMaybe<ChangeRequestItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestRecordComposerDefinitionsArgs = {
  objects: Array<ChangeRequestRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestRecordComposerDefinitionsOneArgs = {
  object: ChangeRequestRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<ChangeRequestRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestReviewTypesArgs = {
  objects: Array<ChangeRequestReviewTypesInsertInput>;
  onConflict?: InputMaybe<ChangeRequestReviewTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestReviewTypesOneArgs = {
  object: ChangeRequestReviewTypesInsertInput;
  onConflict?: InputMaybe<ChangeRequestReviewTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestReviewsArgs = {
  objects: Array<ChangeRequestReviewsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestReviewsOneArgs = {
  object: ChangeRequestReviewsInsertInput;
  onConflict?: InputMaybe<ChangeRequestReviewsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestStatusesArgs = {
  objects: Array<ChangeRequestStatusesInsertInput>;
  onConflict?: InputMaybe<ChangeRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestStatusesOneArgs = {
  object: ChangeRequestStatusesInsertInput;
  onConflict?: InputMaybe<ChangeRequestStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestsArgs = {
  objects: Array<ChangeRequestsInsertInput>;
  onConflict?: InputMaybe<ChangeRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertChangeRequestsOneArgs = {
  object: ChangeRequestsInsertInput;
  onConflict?: InputMaybe<ChangeRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundCompoundRecordsArgs = {
  objects: Array<CompoundCompoundRecordsInsertInput>;
  onConflict?: InputMaybe<CompoundCompoundRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundCompoundRecordsOneArgs = {
  object: CompoundCompoundRecordsInsertInput;
  onConflict?: InputMaybe<CompoundCompoundRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundRecordComposersArgs = {
  objects: Array<CompoundRecordComposersInsertInput>;
  onConflict?: InputMaybe<CompoundRecordComposersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundRecordComposersOneArgs = {
  object: CompoundRecordComposersInsertInput;
  onConflict?: InputMaybe<CompoundRecordComposersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundRecordVersionsArgs = {
  objects: Array<CompoundRecordVersionsInsertInput>;
  onConflict?: InputMaybe<CompoundRecordVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCompoundRecordVersionsOneArgs = {
  object: CompoundRecordVersionsInsertInput;
  onConflict?: InputMaybe<CompoundRecordVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountriesArgs = {
  objects: Array<CountriesInsertInput>;
  onConflict?: InputMaybe<CountriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountriesOneArgs = {
  object: CountriesInsertInput;
  onConflict?: InputMaybe<CountriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountrySubdivisionsArgs = {
  objects: Array<CountrySubdivisionsInsertInput>;
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertCountrySubdivisionsOneArgs = {
  object: CountrySubdivisionsInsertInput;
  onConflict?: InputMaybe<CountrySubdivisionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectRecordComposerDefinitionsArgs = {
  objects: Array<DataImportProjectRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<DataImportProjectRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectRecordComposerDefinitionsOneArgs = {
  object: DataImportProjectRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<DataImportProjectRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectStatusLogsArgs = {
  objects: Array<DataImportProjectStatusLogsInsertInput>;
  onConflict?: InputMaybe<DataImportProjectStatusLogsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectStatusLogsOneArgs = {
  object: DataImportProjectStatusLogsInsertInput;
  onConflict?: InputMaybe<DataImportProjectStatusLogsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectStatusesArgs = {
  objects: Array<DataImportProjectStatusesInsertInput>;
  onConflict?: InputMaybe<DataImportProjectStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectStatusesOneArgs = {
  object: DataImportProjectStatusesInsertInput;
  onConflict?: InputMaybe<DataImportProjectStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectUsersArgs = {
  objects: Array<DataImportProjectUsersInsertInput>;
  onConflict?: InputMaybe<DataImportProjectUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectUsersOneArgs = {
  object: DataImportProjectUsersInsertInput;
  onConflict?: InputMaybe<DataImportProjectUsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectsArgs = {
  objects: Array<DataImportProjectsInsertInput>;
  onConflict?: InputMaybe<DataImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataImportProjectsOneArgs = {
  object: DataImportProjectsInsertInput;
  onConflict?: InputMaybe<DataImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceGsheetsArgs = {
  objects: Array<DataSourceGsheetsInsertInput>;
  onConflict?: InputMaybe<DataSourceGsheetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceGsheetsOneArgs = {
  object: DataSourceGsheetsInsertInput;
  onConflict?: InputMaybe<DataSourceGsheetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceImportProjectRecordComposerDefinitionsArgs = {
  objects: Array<DataSourceImportProjectRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceImportProjectRecordComposerDefinitionsOneArgs = {
  object: DataSourceImportProjectRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceImportProjectsArgs = {
  objects: Array<DataSourceImportProjectsInsertInput>;
  onConflict?: InputMaybe<DataSourceImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceImportProjectsOneArgs = {
  object: DataSourceImportProjectsInsertInput;
  onConflict?: InputMaybe<DataSourceImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceJsonsArgs = {
  objects: Array<DataSourceJsonsInsertInput>;
  onConflict?: InputMaybe<DataSourceJsonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceJsonsOneArgs = {
  object: DataSourceJsonsInsertInput;
  onConflict?: InputMaybe<DataSourceJsonsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourcePropertySchemaSetsArgs = {
  objects: Array<DataSourcePropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<DataSourcePropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourcePropertySchemaSetsOneArgs = {
  object: DataSourcePropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<DataSourcePropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceReferencesArgs = {
  objects: Array<DataSourceReferencesInsertInput>;
  onConflict?: InputMaybe<DataSourceReferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceReferencesOneArgs = {
  object: DataSourceReferencesInsertInput;
  onConflict?: InputMaybe<DataSourceReferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceTemplatePropertySchemaSetsArgs = {
  objects: Array<DataSourceTemplatePropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<DataSourceTemplatePropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceTemplatePropertySchemaSetsOneArgs = {
  object: DataSourceTemplatePropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<DataSourceTemplatePropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceTemplatesArgs = {
  objects: Array<DataSourceTemplatesInsertInput>;
  onConflict?: InputMaybe<DataSourceTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourceTemplatesOneArgs = {
  object: DataSourceTemplatesInsertInput;
  onConflict?: InputMaybe<DataSourceTemplatesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourcesArgs = {
  objects: Array<DataSourcesInsertInput>;
  onConflict?: InputMaybe<DataSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDataSourcesOneArgs = {
  object: DataSourcesInsertInput;
  onConflict?: InputMaybe<DataSourcesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbpjkitWorkerJobRunsArgs = {
  objects: Array<DbpjkitWorkerJobRunsInsertInput>;
  onConflict?: InputMaybe<DbpjkitWorkerJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbpjkitWorkerJobRunsOneArgs = {
  object: DbpjkitWorkerJobRunsInsertInput;
  onConflict?: InputMaybe<DbpjkitWorkerJobRunsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbpjkitWorkerJobsArgs = {
  objects: Array<DbpjkitWorkerJobsInsertInput>;
  onConflict?: InputMaybe<DbpjkitWorkerJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertDbpjkitWorkerJobsOneArgs = {
  object: DbpjkitWorkerJobsInsertInput;
  onConflict?: InputMaybe<DbpjkitWorkerJobsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRecordComposerDefinitionsArgs = {
  objects: Array<EntityRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<EntityRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRecordComposerDefinitionsOneArgs = {
  object: EntityRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<EntityRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRecordsArgs = {
  objects: Array<EntityRecordsInsertInput>;
  onConflict?: InputMaybe<EntityRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEntityRecordsOneArgs = {
  object: EntityRecordsInsertInput;
  onConflict?: InputMaybe<EntityRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceChangeRequestsArgs = {
  objects: Array<EvidenceChangeRequestsInsertInput>;
  onConflict?: InputMaybe<EvidenceChangeRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceChangeRequestsOneArgs = {
  object: EvidenceChangeRequestsInsertInput;
  onConflict?: InputMaybe<EvidenceChangeRequestsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceEvidenceSetsArgs = {
  objects: Array<EvidenceEvidenceSetsInsertInput>;
  onConflict?: InputMaybe<EvidenceEvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceEvidenceSetsOneArgs = {
  object: EvidenceEvidenceSetsInsertInput;
  onConflict?: InputMaybe<EvidenceEvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceImportersArgs = {
  objects: Array<EvidenceImportersInsertInput>;
  onConflict?: InputMaybe<EvidenceImportersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceImportersOneArgs = {
  object: EvidenceImportersInsertInput;
  onConflict?: InputMaybe<EvidenceImportersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceRecordGeoItemsArgs = {
  objects: Array<EvidenceRecordGeoItemsInsertInput>;
  onConflict?: InputMaybe<EvidenceRecordGeoItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceRecordGeoItemsOneArgs = {
  object: EvidenceRecordGeoItemsInsertInput;
  onConflict?: InputMaybe<EvidenceRecordGeoItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetImportProjectsArgs = {
  objects: Array<EvidenceSetImportProjectsInsertInput>;
  onConflict?: InputMaybe<EvidenceSetImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetImportProjectsOneArgs = {
  object: EvidenceSetImportProjectsInsertInput;
  onConflict?: InputMaybe<EvidenceSetImportProjectsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetPropertySchemaSetsArgs = {
  objects: Array<EvidenceSetPropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<EvidenceSetPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetPropertySchemaSetsOneArgs = {
  object: EvidenceSetPropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<EvidenceSetPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetsArgs = {
  objects: Array<EvidenceSetsInsertInput>;
  onConflict?: InputMaybe<EvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceSetsOneArgs = {
  object: EvidenceSetsInsertInput;
  onConflict?: InputMaybe<EvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceVersionsArgs = {
  objects: Array<EvidenceVersionsInsertInput>;
  onConflict?: InputMaybe<EvidenceVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidenceVersionsOneArgs = {
  object: EvidenceVersionsInsertInput;
  onConflict?: InputMaybe<EvidenceVersionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidencesArgs = {
  objects: Array<EvidencesInsertInput>;
  onConflict?: InputMaybe<EvidencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertEvidencesOneArgs = {
  object: EvidencesInsertInput;
  onConflict?: InputMaybe<EvidencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobRunStatusesArgs = {
  objects: Array<JobRunStatusesInsertInput>;
  onConflict?: InputMaybe<JobRunStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertJobRunStatusesOneArgs = {
  object: JobRunStatusesInsertInput;
  onConflict?: InputMaybe<JobRunStatusesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationKindsArgs = {
  objects: Array<OrganizationKindsInsertInput>;
  onConflict?: InputMaybe<OrganizationKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationKindsOneArgs = {
  object: OrganizationKindsInsertInput;
  onConflict?: InputMaybe<OrganizationKindsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationsArgs = {
  objects: Array<OrganizationsInsertInput>;
  onConflict?: InputMaybe<OrganizationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertOrganizationsOneArgs = {
  object: OrganizationsInsertInput;
  onConflict?: InputMaybe<OrganizationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductRolesArgs = {
  objects: Array<ProductRolesInsertInput>;
  onConflict?: InputMaybe<ProductRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductRolesOneArgs = {
  object: ProductRolesInsertInput;
  onConflict?: InputMaybe<ProductRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductsArgs = {
  objects: Array<ProductsInsertInput>;
  onConflict?: InputMaybe<ProductsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertProductsOneArgs = {
  object: ProductsInsertInput;
  onConflict?: InputMaybe<ProductsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemaAssociationsArgs = {
  objects: Array<PropertySchemaAssociationsInsertInput>;
  onConflict?: InputMaybe<PropertySchemaAssociationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemaAssociationsOneArgs = {
  object: PropertySchemaAssociationsInsertInput;
  onConflict?: InputMaybe<PropertySchemaAssociationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemaSetsArgs = {
  objects: Array<PropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<PropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemaSetsOneArgs = {
  object: PropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<PropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemasArgs = {
  objects: Array<PropertySchemasInsertInput>;
  onConflict?: InputMaybe<PropertySchemasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertySchemasOneArgs = {
  object: PropertySchemasInsertInput;
  onConflict?: InputMaybe<PropertySchemasOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertyTypesArgs = {
  objects: Array<PropertyTypesInsertInput>;
  onConflict?: InputMaybe<PropertyTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPropertyTypesOneArgs = {
  object: PropertyTypesInsertInput;
  onConflict?: InputMaybe<PropertyTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPublishersArgs = {
  objects: Array<PublishersInsertInput>;
  onConflict?: InputMaybe<PublishersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertPublishersOneArgs = {
  object: PublishersInsertInput;
  onConflict?: InputMaybe<PublishersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionEvidenceSetsArgs = {
  objects: Array<RecordComposerDefinitionEvidenceSetsInsertInput>;
  onConflict?: InputMaybe<RecordComposerDefinitionEvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionEvidenceSetsOneArgs = {
  object: RecordComposerDefinitionEvidenceSetsInsertInput;
  onConflict?: InputMaybe<RecordComposerDefinitionEvidenceSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionPropertySchemaSetsArgs = {
  objects: Array<RecordComposerDefinitionPropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionPropertySchemaSetsOneArgs = {
  object: RecordComposerDefinitionPropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionsArgs = {
  objects: Array<RecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<RecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordComposerDefinitionsOneArgs = {
  object: RecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<RecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordCompoundRecordComposersArgs = {
  objects: Array<RecordCompoundRecordComposersInsertInput>;
  onConflict?: InputMaybe<RecordCompoundRecordComposersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordCompoundRecordComposersOneArgs = {
  object: RecordCompoundRecordComposersInsertInput;
  onConflict?: InputMaybe<RecordCompoundRecordComposersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordGeoItemsArgs = {
  objects: Array<RecordGeoItemsInsertInput>;
  onConflict?: InputMaybe<RecordGeoItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordGeoItemsOneArgs = {
  object: RecordGeoItemsInsertInput;
  onConflict?: InputMaybe<RecordGeoItemsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataArgs = {
  objects: Array<RecordMetadataInsertInput>;
  onConflict?: InputMaybe<RecordMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataCategoriesArgs = {
  objects: Array<RecordMetadataCategoriesInsertInput>;
  onConflict?: InputMaybe<RecordMetadataCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataCategoriesOneArgs = {
  object: RecordMetadataCategoriesInsertInput;
  onConflict?: InputMaybe<RecordMetadataCategoriesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataOneArgs = {
  object: RecordMetadataInsertInput;
  onConflict?: InputMaybe<RecordMetadataOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataPropertySchemaSetsArgs = {
  objects: Array<RecordMetadataPropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<RecordMetadataPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordMetadataPropertySchemaSetsOneArgs = {
  object: RecordMetadataPropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<RecordMetadataPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordPropertySchemaSetsArgs = {
  objects: Array<RecordPropertySchemaSetsInsertInput>;
  onConflict?: InputMaybe<RecordPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordPropertySchemaSetsOneArgs = {
  object: RecordPropertySchemaSetsInsertInput;
  onConflict?: InputMaybe<RecordPropertySchemaSetsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordUpdateRecordComposerDefinitionsArgs = {
  objects: Array<RecordUpdateRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<RecordUpdateRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordUpdateRecordComposerDefinitionsOneArgs = {
  object: RecordUpdateRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<RecordUpdateRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordsArgs = {
  objects: Array<RecordsInsertInput>;
  onConflict?: InputMaybe<RecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRecordsOneArgs = {
  object: RecordsInsertInput;
  onConflict?: InputMaybe<RecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferenceFilesArgs = {
  objects: Array<ReferenceFilesInsertInput>;
  onConflict?: InputMaybe<ReferenceFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferenceFilesOneArgs = {
  object: ReferenceFilesInsertInput;
  onConflict?: InputMaybe<ReferenceFilesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferencePublishersArgs = {
  objects: Array<ReferencePublishersInsertInput>;
  onConflict?: InputMaybe<ReferencePublishersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferencePublishersOneArgs = {
  object: ReferencePublishersInsertInput;
  onConflict?: InputMaybe<ReferencePublishersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferencesArgs = {
  objects: Array<ReferencesInsertInput>;
  onConflict?: InputMaybe<ReferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertReferencesOneArgs = {
  object: ReferencesInsertInput;
  onConflict?: InputMaybe<ReferencesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationRecordComposerDefinitionsArgs = {
  objects: Array<RelationRecordComposerDefinitionsInsertInput>;
  onConflict?: InputMaybe<RelationRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationRecordComposerDefinitionsOneArgs = {
  object: RelationRecordComposerDefinitionsInsertInput;
  onConflict?: InputMaybe<RelationRecordComposerDefinitionsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationRecordsArgs = {
  objects: Array<RelationRecordsInsertInput>;
  onConflict?: InputMaybe<RelationRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationRecordsOneArgs = {
  object: RelationRecordsInsertInput;
  onConflict?: InputMaybe<RelationRecordsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationTypesArgs = {
  objects: Array<RelationTypesInsertInput>;
  onConflict?: InputMaybe<RelationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRelationTypesOneArgs = {
  object: RelationTypesInsertInput;
  onConflict?: InputMaybe<RelationTypesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRolesArgs = {
  objects: Array<RolesInsertInput>;
  onConflict?: InputMaybe<RolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertRolesOneArgs = {
  object: RolesInsertInput;
  onConflict?: InputMaybe<RolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSourceRecordEdgesArgs = {
  objects: Array<SourceRecordEdgesInsertInput>;
  onConflict?: InputMaybe<SourceRecordEdgesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertSourceRecordEdgesOneArgs = {
  object: SourceRecordEdgesInsertInput;
  onConflict?: InputMaybe<SourceRecordEdgesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTargetRecordEdgesArgs = {
  objects: Array<TargetRecordEdgesInsertInput>;
  onConflict?: InputMaybe<TargetRecordEdgesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTargetRecordEdgesOneArgs = {
  object: TargetRecordEdgesInsertInput;
  onConflict?: InputMaybe<TargetRecordEdgesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTenantProductInstallationsArgs = {
  objects: Array<TenantProductInstallationsInsertInput>;
  onConflict?: InputMaybe<TenantProductInstallationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTenantProductInstallationsOneArgs = {
  object: TenantProductInstallationsInsertInput;
  onConflict?: InputMaybe<TenantProductInstallationsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTenantsArgs = {
  objects: Array<TenantsInsertInput>;
  onConflict?: InputMaybe<TenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertTenantsOneArgs = {
  object: TenantsInsertInput;
  onConflict?: InputMaybe<TenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUnifiedEvidenceDraftsArgs = {
  objects: Array<UnifiedEvidenceDraftsInsertInput>;
  onConflict?: InputMaybe<UnifiedEvidenceDraftsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUnifiedEvidenceDraftsOneArgs = {
  object: UnifiedEvidenceDraftsInsertInput;
  onConflict?: InputMaybe<UnifiedEvidenceDraftsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserGroupsArgs = {
  objects: Array<UserGroupsInsertInput>;
  onConflict?: InputMaybe<UserGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserGroupsOneArgs = {
  object: UserGroupsInsertInput;
  onConflict?: InputMaybe<UserGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserProductRolesArgs = {
  objects: Array<UserProductRolesInsertInput>;
  onConflict?: InputMaybe<UserProductRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserProductRolesOneArgs = {
  object: UserProductRolesInsertInput;
  onConflict?: InputMaybe<UserProductRolesOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSegmentsArgs = {
  objects: Array<UserSegmentsInsertInput>;
  onConflict?: InputMaybe<UserSegmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserSegmentsOneArgs = {
  object: UserSegmentsInsertInput;
  onConflict?: InputMaybe<UserSegmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTenantsArgs = {
  objects: Array<UserTenantsInsertInput>;
  onConflict?: InputMaybe<UserTenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserTenantsOneArgs = {
  object: UserTenantsInsertInput;
  onConflict?: InputMaybe<UserTenantsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserUserGroupsArgs = {
  objects: Array<UserUserGroupsInsertInput>;
  onConflict?: InputMaybe<UserUserGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserUserGroupsOneArgs = {
  object: UserUserGroupsInsertInput;
  onConflict?: InputMaybe<UserUserGroupsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserUserSegmentsArgs = {
  objects: Array<UserUserSegmentsInsertInput>;
  onConflict?: InputMaybe<UserUserSegmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUserUserSegmentsOneArgs = {
  object: UserUserSegmentsInsertInput;
  onConflict?: InputMaybe<UserUserSegmentsOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersArgs = {
  objects: Array<UsersInsertInput>;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootInsertUsersOneArgs = {
  object: UsersInsertInput;
  onConflict?: InputMaybe<UsersOnConflict>;
};


/** mutation root */
export type Mutation_RootUpdateAreaCodesArgs = {
  _set?: InputMaybe<AreaCodesSetInput>;
  where: AreaCodesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateAreaCodesByPkArgs = {
  _set?: InputMaybe<AreaCodesSetInput>;
  pkColumns: AreaCodesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateAreaCodesManyArgs = {
  updates: Array<AreaCodesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobRunsArgs = {
  _set?: InputMaybe<BatchChangeRequestReviewsJobRunsSetInput>;
  where: BatchChangeRequestReviewsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobRunsByPkArgs = {
  _set?: InputMaybe<BatchChangeRequestReviewsJobRunsSetInput>;
  pkColumns: BatchChangeRequestReviewsJobRunsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobRunsManyArgs = {
  updates: Array<BatchChangeRequestReviewsJobRunsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobsArgs = {
  _set?: InputMaybe<BatchChangeRequestReviewsJobsSetInput>;
  where: BatchChangeRequestReviewsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobsByPkArgs = {
  _set?: InputMaybe<BatchChangeRequestReviewsJobsSetInput>;
  pkColumns: BatchChangeRequestReviewsJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestReviewsJobsManyArgs = {
  updates: Array<BatchChangeRequestReviewsJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsSetInput>;
  where: BatchChangeRequestsJobRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsSetInput>;
  pkColumns: BatchChangeRequestsJobRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRecordComposerDefinitionsManyArgs = {
  updates: Array<BatchChangeRequestsJobRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRunsArgs = {
  _append?: InputMaybe<BatchChangeRequestsJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchChangeRequestsJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchChangeRequestsJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchChangeRequestsJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchChangeRequestsJobRunsPrependInput>;
  _set?: InputMaybe<BatchChangeRequestsJobRunsSetInput>;
  where: BatchChangeRequestsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRunsByPkArgs = {
  _append?: InputMaybe<BatchChangeRequestsJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchChangeRequestsJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchChangeRequestsJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchChangeRequestsJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchChangeRequestsJobRunsPrependInput>;
  _set?: InputMaybe<BatchChangeRequestsJobRunsSetInput>;
  pkColumns: BatchChangeRequestsJobRunsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobRunsManyArgs = {
  updates: Array<BatchChangeRequestsJobRunsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobsArgs = {
  _set?: InputMaybe<BatchChangeRequestsJobsSetInput>;
  where: BatchChangeRequestsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobsByPkArgs = {
  _set?: InputMaybe<BatchChangeRequestsJobsSetInput>;
  pkColumns: BatchChangeRequestsJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchChangeRequestsJobsManyArgs = {
  updates: Array<BatchChangeRequestsJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobRunsArgs = {
  _append?: InputMaybe<BatchEvidenceCommitsJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchEvidenceCommitsJobRunsPrependInput>;
  _set?: InputMaybe<BatchEvidenceCommitsJobRunsSetInput>;
  where: BatchEvidenceCommitsJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobRunsByPkArgs = {
  _append?: InputMaybe<BatchEvidenceCommitsJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchEvidenceCommitsJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchEvidenceCommitsJobRunsPrependInput>;
  _set?: InputMaybe<BatchEvidenceCommitsJobRunsSetInput>;
  pkColumns: BatchEvidenceCommitsJobRunsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobRunsManyArgs = {
  updates: Array<BatchEvidenceCommitsJobRunsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobsArgs = {
  _set?: InputMaybe<BatchEvidenceCommitsJobsSetInput>;
  where: BatchEvidenceCommitsJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobsByPkArgs = {
  _set?: InputMaybe<BatchEvidenceCommitsJobsSetInput>;
  pkColumns: BatchEvidenceCommitsJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidenceCommitsJobsManyArgs = {
  updates: Array<BatchEvidenceCommitsJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobRunsArgs = {
  _append?: InputMaybe<BatchEvidencesJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchEvidencesJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchEvidencesJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchEvidencesJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchEvidencesJobRunsPrependInput>;
  _set?: InputMaybe<BatchEvidencesJobRunsSetInput>;
  where: BatchEvidencesJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobRunsByPkArgs = {
  _append?: InputMaybe<BatchEvidencesJobRunsAppendInput>;
  _deleteAtPath?: InputMaybe<BatchEvidencesJobRunsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<BatchEvidencesJobRunsDeleteElemInput>;
  _deleteKey?: InputMaybe<BatchEvidencesJobRunsDeleteKeyInput>;
  _prepend?: InputMaybe<BatchEvidencesJobRunsPrependInput>;
  _set?: InputMaybe<BatchEvidencesJobRunsSetInput>;
  pkColumns: BatchEvidencesJobRunsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobRunsManyArgs = {
  updates: Array<BatchEvidencesJobRunsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobsArgs = {
  _set?: InputMaybe<BatchEvidencesJobsSetInput>;
  where: BatchEvidencesJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobsByPkArgs = {
  _set?: InputMaybe<BatchEvidencesJobsSetInput>;
  pkColumns: BatchEvidencesJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateBatchEvidencesJobsManyArgs = {
  updates: Array<BatchEvidencesJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCategoriesArgs = {
  _append?: InputMaybe<CategoriesAppendInput>;
  _deleteAtPath?: InputMaybe<CategoriesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CategoriesDeleteElemInput>;
  _deleteKey?: InputMaybe<CategoriesDeleteKeyInput>;
  _prepend?: InputMaybe<CategoriesPrependInput>;
  _set?: InputMaybe<CategoriesSetInput>;
  where: CategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCategoriesByPkArgs = {
  _append?: InputMaybe<CategoriesAppendInput>;
  _deleteAtPath?: InputMaybe<CategoriesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CategoriesDeleteElemInput>;
  _deleteKey?: InputMaybe<CategoriesDeleteKeyInput>;
  _prepend?: InputMaybe<CategoriesPrependInput>;
  _set?: InputMaybe<CategoriesSetInput>;
  pkColumns: CategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCategoriesManyArgs = {
  updates: Array<CategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPathsArgs = {
  _set?: InputMaybe<CategoryPathsSetInput>;
  where: CategoryPathsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPathsByPkArgs = {
  _set?: InputMaybe<CategoryPathsSetInput>;
  pkColumns: CategoryPathsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPathsManyArgs = {
  updates: Array<CategoryPathsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPropertySchemaSetsArgs = {
  _set?: InputMaybe<CategoryPropertySchemaSetsSetInput>;
  where: CategoryPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<CategoryPropertySchemaSetsSetInput>;
  pkColumns: CategoryPropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCategoryPropertySchemaSetsManyArgs = {
  updates: Array<CategoryPropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCategoryTypesArgs = {
  _set?: InputMaybe<CategoryTypesSetInput>;
  where: CategoryTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCategoryTypesByPkArgs = {
  _set?: InputMaybe<CategoryTypesSetInput>;
  pkColumns: CategoryTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCategoryTypesManyArgs = {
  updates: Array<CategoryTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestCommitsArgs = {
  _set?: InputMaybe<ChangeRequestCommitsSetInput>;
  where: ChangeRequestCommitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestCommitsByPkArgs = {
  _set?: InputMaybe<ChangeRequestCommitsSetInput>;
  pkColumns: ChangeRequestCommitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestCommitsManyArgs = {
  updates: Array<ChangeRequestCommitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemCommitsArgs = {
  _append?: InputMaybe<ChangeRequestItemCommitsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestItemCommitsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestItemCommitsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestItemCommitsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestItemCommitsPrependInput>;
  _set?: InputMaybe<ChangeRequestItemCommitsSetInput>;
  where: ChangeRequestItemCommitsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemCommitsByPkArgs = {
  _append?: InputMaybe<ChangeRequestItemCommitsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestItemCommitsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestItemCommitsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestItemCommitsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestItemCommitsPrependInput>;
  _set?: InputMaybe<ChangeRequestItemCommitsSetInput>;
  pkColumns: ChangeRequestItemCommitsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemCommitsManyArgs = {
  updates: Array<ChangeRequestItemCommitsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordMetadataArgs = {
  _set?: InputMaybe<ChangeRequestItemRecordMetadataSetInput>;
  where: ChangeRequestItemRecordMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordMetadataByPkArgs = {
  _set?: InputMaybe<ChangeRequestItemRecordMetadataSetInput>;
  pkColumns: ChangeRequestItemRecordMetadataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordMetadataManyArgs = {
  updates: Array<ChangeRequestItemRecordMetadataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordsArgs = {
  _set?: InputMaybe<ChangeRequestItemRecordsSetInput>;
  where: ChangeRequestItemRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordsByPkArgs = {
  _set?: InputMaybe<ChangeRequestItemRecordsSetInput>;
  pkColumns: ChangeRequestItemRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemRecordsManyArgs = {
  updates: Array<ChangeRequestItemRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemsArgs = {
  _append?: InputMaybe<ChangeRequestItemsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestItemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestItemsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestItemsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestItemsPrependInput>;
  _set?: InputMaybe<ChangeRequestItemsSetInput>;
  where: ChangeRequestItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemsByPkArgs = {
  _append?: InputMaybe<ChangeRequestItemsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestItemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestItemsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestItemsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestItemsPrependInput>;
  _set?: InputMaybe<ChangeRequestItemsSetInput>;
  pkColumns: ChangeRequestItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestItemsManyArgs = {
  updates: Array<ChangeRequestItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<ChangeRequestRecordComposerDefinitionsSetInput>;
  where: ChangeRequestRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<ChangeRequestRecordComposerDefinitionsSetInput>;
  pkColumns: ChangeRequestRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestRecordComposerDefinitionsManyArgs = {
  updates: Array<ChangeRequestRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewTypesArgs = {
  _set?: InputMaybe<ChangeRequestReviewTypesSetInput>;
  where: ChangeRequestReviewTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewTypesByPkArgs = {
  _set?: InputMaybe<ChangeRequestReviewTypesSetInput>;
  pkColumns: ChangeRequestReviewTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewTypesManyArgs = {
  updates: Array<ChangeRequestReviewTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewsArgs = {
  _set?: InputMaybe<ChangeRequestReviewsSetInput>;
  where: ChangeRequestReviewsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewsByPkArgs = {
  _set?: InputMaybe<ChangeRequestReviewsSetInput>;
  pkColumns: ChangeRequestReviewsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestReviewsManyArgs = {
  updates: Array<ChangeRequestReviewsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestStatusesArgs = {
  _set?: InputMaybe<ChangeRequestStatusesSetInput>;
  where: ChangeRequestStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestStatusesByPkArgs = {
  _set?: InputMaybe<ChangeRequestStatusesSetInput>;
  pkColumns: ChangeRequestStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestStatusesManyArgs = {
  updates: Array<ChangeRequestStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestsArgs = {
  _append?: InputMaybe<ChangeRequestsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestsPrependInput>;
  _set?: InputMaybe<ChangeRequestsSetInput>;
  where: ChangeRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestsByPkArgs = {
  _append?: InputMaybe<ChangeRequestsAppendInput>;
  _deleteAtPath?: InputMaybe<ChangeRequestsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<ChangeRequestsDeleteElemInput>;
  _deleteKey?: InputMaybe<ChangeRequestsDeleteKeyInput>;
  _prepend?: InputMaybe<ChangeRequestsPrependInput>;
  _set?: InputMaybe<ChangeRequestsSetInput>;
  pkColumns: ChangeRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateChangeRequestsManyArgs = {
  updates: Array<ChangeRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompoundCompoundRecordsArgs = {
  _append?: InputMaybe<CompoundCompoundRecordsAppendInput>;
  _deleteAtPath?: InputMaybe<CompoundCompoundRecordsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompoundCompoundRecordsDeleteElemInput>;
  _deleteKey?: InputMaybe<CompoundCompoundRecordsDeleteKeyInput>;
  _inc?: InputMaybe<CompoundCompoundRecordsIncInput>;
  _prepend?: InputMaybe<CompoundCompoundRecordsPrependInput>;
  _set?: InputMaybe<CompoundCompoundRecordsSetInput>;
  where: CompoundCompoundRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompoundCompoundRecordsByPkArgs = {
  _append?: InputMaybe<CompoundCompoundRecordsAppendInput>;
  _deleteAtPath?: InputMaybe<CompoundCompoundRecordsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompoundCompoundRecordsDeleteElemInput>;
  _deleteKey?: InputMaybe<CompoundCompoundRecordsDeleteKeyInput>;
  _inc?: InputMaybe<CompoundCompoundRecordsIncInput>;
  _prepend?: InputMaybe<CompoundCompoundRecordsPrependInput>;
  _set?: InputMaybe<CompoundCompoundRecordsSetInput>;
  pkColumns: CompoundCompoundRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompoundCompoundRecordsManyArgs = {
  updates: Array<CompoundCompoundRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordComposersArgs = {
  _append?: InputMaybe<CompoundRecordComposersAppendInput>;
  _deleteAtPath?: InputMaybe<CompoundRecordComposersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompoundRecordComposersDeleteElemInput>;
  _deleteKey?: InputMaybe<CompoundRecordComposersDeleteKeyInput>;
  _prepend?: InputMaybe<CompoundRecordComposersPrependInput>;
  _set?: InputMaybe<CompoundRecordComposersSetInput>;
  where: CompoundRecordComposersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordComposersByPkArgs = {
  _append?: InputMaybe<CompoundRecordComposersAppendInput>;
  _deleteAtPath?: InputMaybe<CompoundRecordComposersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<CompoundRecordComposersDeleteElemInput>;
  _deleteKey?: InputMaybe<CompoundRecordComposersDeleteKeyInput>;
  _prepend?: InputMaybe<CompoundRecordComposersPrependInput>;
  _set?: InputMaybe<CompoundRecordComposersSetInput>;
  pkColumns: CompoundRecordComposersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordComposersManyArgs = {
  updates: Array<CompoundRecordComposersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordVersionsArgs = {
  _set?: InputMaybe<CompoundRecordVersionsSetInput>;
  where: CompoundRecordVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordVersionsByPkArgs = {
  _set?: InputMaybe<CompoundRecordVersionsSetInput>;
  pkColumns: CompoundRecordVersionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCompoundRecordVersionsManyArgs = {
  updates: Array<CompoundRecordVersionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCountriesArgs = {
  _inc?: InputMaybe<CountriesIncInput>;
  _set?: InputMaybe<CountriesSetInput>;
  where: CountriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCountriesByPkArgs = {
  _inc?: InputMaybe<CountriesIncInput>;
  _set?: InputMaybe<CountriesSetInput>;
  pkColumns: CountriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCountriesManyArgs = {
  updates: Array<CountriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsArgs = {
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  where: CountrySubdivisionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsByPkArgs = {
  _set?: InputMaybe<CountrySubdivisionsSetInput>;
  pkColumns: CountrySubdivisionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateCountrySubdivisionsManyArgs = {
  updates: Array<CountrySubdivisionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<DataImportProjectRecordComposerDefinitionsSetInput>;
  where: DataImportProjectRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<DataImportProjectRecordComposerDefinitionsSetInput>;
  pkColumns: DataImportProjectRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectRecordComposerDefinitionsManyArgs = {
  updates: Array<DataImportProjectRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusLogsArgs = {
  _set?: InputMaybe<DataImportProjectStatusLogsSetInput>;
  where: DataImportProjectStatusLogsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusLogsByPkArgs = {
  _set?: InputMaybe<DataImportProjectStatusLogsSetInput>;
  pkColumns: DataImportProjectStatusLogsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusLogsManyArgs = {
  updates: Array<DataImportProjectStatusLogsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusesArgs = {
  _set?: InputMaybe<DataImportProjectStatusesSetInput>;
  where: DataImportProjectStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusesByPkArgs = {
  _set?: InputMaybe<DataImportProjectStatusesSetInput>;
  pkColumns: DataImportProjectStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectStatusesManyArgs = {
  updates: Array<DataImportProjectStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectUsersArgs = {
  _set?: InputMaybe<DataImportProjectUsersSetInput>;
  where: DataImportProjectUsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectUsersByPkArgs = {
  _set?: InputMaybe<DataImportProjectUsersSetInput>;
  pkColumns: DataImportProjectUsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectUsersManyArgs = {
  updates: Array<DataImportProjectUsersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectsArgs = {
  _inc?: InputMaybe<DataImportProjectsIncInput>;
  _set?: InputMaybe<DataImportProjectsSetInput>;
  where: DataImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectsByPkArgs = {
  _inc?: InputMaybe<DataImportProjectsIncInput>;
  _set?: InputMaybe<DataImportProjectsSetInput>;
  pkColumns: DataImportProjectsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataImportProjectsManyArgs = {
  updates: Array<DataImportProjectsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceGsheetsArgs = {
  _inc?: InputMaybe<DataSourceGsheetsIncInput>;
  _set?: InputMaybe<DataSourceGsheetsSetInput>;
  where: DataSourceGsheetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceGsheetsByPkArgs = {
  _inc?: InputMaybe<DataSourceGsheetsIncInput>;
  _set?: InputMaybe<DataSourceGsheetsSetInput>;
  pkColumns: DataSourceGsheetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceGsheetsManyArgs = {
  updates: Array<DataSourceGsheetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsSetInput>;
  where: DataSourceImportProjectRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsSetInput>;
  pkColumns: DataSourceImportProjectRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectRecordComposerDefinitionsManyArgs = {
  updates: Array<DataSourceImportProjectRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectsArgs = {
  _set?: InputMaybe<DataSourceImportProjectsSetInput>;
  where: DataSourceImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectsByPkArgs = {
  _set?: InputMaybe<DataSourceImportProjectsSetInput>;
  pkColumns: DataSourceImportProjectsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceImportProjectsManyArgs = {
  updates: Array<DataSourceImportProjectsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceJsonsArgs = {
  _set?: InputMaybe<DataSourceJsonsSetInput>;
  where: DataSourceJsonsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceJsonsByPkArgs = {
  _set?: InputMaybe<DataSourceJsonsSetInput>;
  pkColumns: DataSourceJsonsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceJsonsManyArgs = {
  updates: Array<DataSourceJsonsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcePropertySchemaSetsArgs = {
  _set?: InputMaybe<DataSourcePropertySchemaSetsSetInput>;
  where: DataSourcePropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcePropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<DataSourcePropertySchemaSetsSetInput>;
  pkColumns: DataSourcePropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcePropertySchemaSetsManyArgs = {
  updates: Array<DataSourcePropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceReferencesArgs = {
  _set?: InputMaybe<DataSourceReferencesSetInput>;
  where: DataSourceReferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceReferencesByPkArgs = {
  _set?: InputMaybe<DataSourceReferencesSetInput>;
  pkColumns: DataSourceReferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceReferencesManyArgs = {
  updates: Array<DataSourceReferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatePropertySchemaSetsArgs = {
  _set?: InputMaybe<DataSourceTemplatePropertySchemaSetsSetInput>;
  where: DataSourceTemplatePropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatePropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<DataSourceTemplatePropertySchemaSetsSetInput>;
  pkColumns: DataSourceTemplatePropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatePropertySchemaSetsManyArgs = {
  updates: Array<DataSourceTemplatePropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatesArgs = {
  _set?: InputMaybe<DataSourceTemplatesSetInput>;
  where: DataSourceTemplatesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatesByPkArgs = {
  _set?: InputMaybe<DataSourceTemplatesSetInput>;
  pkColumns: DataSourceTemplatesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourceTemplatesManyArgs = {
  updates: Array<DataSourceTemplatesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcesArgs = {
  _set?: InputMaybe<DataSourcesSetInput>;
  where: DataSourcesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcesByPkArgs = {
  _set?: InputMaybe<DataSourcesSetInput>;
  pkColumns: DataSourcesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDataSourcesManyArgs = {
  updates: Array<DataSourcesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobRunsArgs = {
  _set?: InputMaybe<DbpjkitWorkerJobRunsSetInput>;
  where: DbpjkitWorkerJobRunsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobRunsByPkArgs = {
  _set?: InputMaybe<DbpjkitWorkerJobRunsSetInput>;
  pkColumns: DbpjkitWorkerJobRunsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobRunsManyArgs = {
  updates: Array<DbpjkitWorkerJobRunsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobsArgs = {
  _append?: InputMaybe<DbpjkitWorkerJobsAppendInput>;
  _deleteAtPath?: InputMaybe<DbpjkitWorkerJobsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DbpjkitWorkerJobsDeleteElemInput>;
  _deleteKey?: InputMaybe<DbpjkitWorkerJobsDeleteKeyInput>;
  _inc?: InputMaybe<DbpjkitWorkerJobsIncInput>;
  _prepend?: InputMaybe<DbpjkitWorkerJobsPrependInput>;
  _set?: InputMaybe<DbpjkitWorkerJobsSetInput>;
  where: DbpjkitWorkerJobsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobsByPkArgs = {
  _append?: InputMaybe<DbpjkitWorkerJobsAppendInput>;
  _deleteAtPath?: InputMaybe<DbpjkitWorkerJobsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<DbpjkitWorkerJobsDeleteElemInput>;
  _deleteKey?: InputMaybe<DbpjkitWorkerJobsDeleteKeyInput>;
  _inc?: InputMaybe<DbpjkitWorkerJobsIncInput>;
  _prepend?: InputMaybe<DbpjkitWorkerJobsPrependInput>;
  _set?: InputMaybe<DbpjkitWorkerJobsSetInput>;
  pkColumns: DbpjkitWorkerJobsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateDbpjkitWorkerJobsManyArgs = {
  updates: Array<DbpjkitWorkerJobsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<EntityRecordComposerDefinitionsSetInput>;
  where: EntityRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<EntityRecordComposerDefinitionsSetInput>;
  pkColumns: EntityRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordComposerDefinitionsManyArgs = {
  updates: Array<EntityRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordsArgs = {
  _set?: InputMaybe<EntityRecordsSetInput>;
  where: EntityRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordsByPkArgs = {
  _set?: InputMaybe<EntityRecordsSetInput>;
  pkColumns: EntityRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEntityRecordsManyArgs = {
  updates: Array<EntityRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceChangeRequestsArgs = {
  _set?: InputMaybe<EvidenceChangeRequestsSetInput>;
  where: EvidenceChangeRequestsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceChangeRequestsByPkArgs = {
  _set?: InputMaybe<EvidenceChangeRequestsSetInput>;
  pkColumns: EvidenceChangeRequestsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceChangeRequestsManyArgs = {
  updates: Array<EvidenceChangeRequestsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceEvidenceSetsArgs = {
  _set?: InputMaybe<EvidenceEvidenceSetsSetInput>;
  where: EvidenceEvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceEvidenceSetsByPkArgs = {
  _set?: InputMaybe<EvidenceEvidenceSetsSetInput>;
  pkColumns: EvidenceEvidenceSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceEvidenceSetsManyArgs = {
  updates: Array<EvidenceEvidenceSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceImportersArgs = {
  _append?: InputMaybe<EvidenceImportersAppendInput>;
  _deleteAtPath?: InputMaybe<EvidenceImportersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidenceImportersDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidenceImportersDeleteKeyInput>;
  _prepend?: InputMaybe<EvidenceImportersPrependInput>;
  _set?: InputMaybe<EvidenceImportersSetInput>;
  where: EvidenceImportersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceImportersByPkArgs = {
  _append?: InputMaybe<EvidenceImportersAppendInput>;
  _deleteAtPath?: InputMaybe<EvidenceImportersDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidenceImportersDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidenceImportersDeleteKeyInput>;
  _prepend?: InputMaybe<EvidenceImportersPrependInput>;
  _set?: InputMaybe<EvidenceImportersSetInput>;
  pkColumns: EvidenceImportersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceImportersManyArgs = {
  updates: Array<EvidenceImportersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceRecordGeoItemsArgs = {
  _set?: InputMaybe<EvidenceRecordGeoItemsSetInput>;
  where: EvidenceRecordGeoItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceRecordGeoItemsByPkArgs = {
  _set?: InputMaybe<EvidenceRecordGeoItemsSetInput>;
  pkColumns: EvidenceRecordGeoItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceRecordGeoItemsManyArgs = {
  updates: Array<EvidenceRecordGeoItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetImportProjectsArgs = {
  _set?: InputMaybe<EvidenceSetImportProjectsSetInput>;
  where: EvidenceSetImportProjectsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetImportProjectsByPkArgs = {
  _set?: InputMaybe<EvidenceSetImportProjectsSetInput>;
  pkColumns: EvidenceSetImportProjectsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetImportProjectsManyArgs = {
  updates: Array<EvidenceSetImportProjectsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetPropertySchemaSetsArgs = {
  _set?: InputMaybe<EvidenceSetPropertySchemaSetsSetInput>;
  where: EvidenceSetPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetPropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<EvidenceSetPropertySchemaSetsSetInput>;
  pkColumns: EvidenceSetPropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetPropertySchemaSetsManyArgs = {
  updates: Array<EvidenceSetPropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetsArgs = {
  _set?: InputMaybe<EvidenceSetsSetInput>;
  where: EvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetsByPkArgs = {
  _set?: InputMaybe<EvidenceSetsSetInput>;
  pkColumns: EvidenceSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceSetsManyArgs = {
  updates: Array<EvidenceSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceVersionsArgs = {
  _append?: InputMaybe<EvidenceVersionsAppendInput>;
  _deleteAtPath?: InputMaybe<EvidenceVersionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidenceVersionsDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidenceVersionsDeleteKeyInput>;
  _inc?: InputMaybe<EvidenceVersionsIncInput>;
  _prepend?: InputMaybe<EvidenceVersionsPrependInput>;
  _set?: InputMaybe<EvidenceVersionsSetInput>;
  where: EvidenceVersionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceVersionsByPkArgs = {
  _append?: InputMaybe<EvidenceVersionsAppendInput>;
  _deleteAtPath?: InputMaybe<EvidenceVersionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidenceVersionsDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidenceVersionsDeleteKeyInput>;
  _inc?: InputMaybe<EvidenceVersionsIncInput>;
  _prepend?: InputMaybe<EvidenceVersionsPrependInput>;
  _set?: InputMaybe<EvidenceVersionsSetInput>;
  pkColumns: EvidenceVersionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidenceVersionsManyArgs = {
  updates: Array<EvidenceVersionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateEvidencesArgs = {
  _append?: InputMaybe<EvidencesAppendInput>;
  _deleteAtPath?: InputMaybe<EvidencesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidencesDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidencesDeleteKeyInput>;
  _inc?: InputMaybe<EvidencesIncInput>;
  _prepend?: InputMaybe<EvidencesPrependInput>;
  _set?: InputMaybe<EvidencesSetInput>;
  where: EvidencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateEvidencesByPkArgs = {
  _append?: InputMaybe<EvidencesAppendInput>;
  _deleteAtPath?: InputMaybe<EvidencesDeleteAtPathInput>;
  _deleteElem?: InputMaybe<EvidencesDeleteElemInput>;
  _deleteKey?: InputMaybe<EvidencesDeleteKeyInput>;
  _inc?: InputMaybe<EvidencesIncInput>;
  _prepend?: InputMaybe<EvidencesPrependInput>;
  _set?: InputMaybe<EvidencesSetInput>;
  pkColumns: EvidencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateEvidencesManyArgs = {
  updates: Array<EvidencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateJobRunStatusesArgs = {
  _set?: InputMaybe<JobRunStatusesSetInput>;
  where: JobRunStatusesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateJobRunStatusesByPkArgs = {
  _set?: InputMaybe<JobRunStatusesSetInput>;
  pkColumns: JobRunStatusesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateJobRunStatusesManyArgs = {
  updates: Array<JobRunStatusesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationKindsArgs = {
  _set?: InputMaybe<OrganizationKindsSetInput>;
  where: OrganizationKindsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationKindsByPkArgs = {
  _set?: InputMaybe<OrganizationKindsSetInput>;
  pkColumns: OrganizationKindsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationKindsManyArgs = {
  updates: Array<OrganizationKindsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationsArgs = {
  _set?: InputMaybe<OrganizationsSetInput>;
  where: OrganizationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationsByPkArgs = {
  _set?: InputMaybe<OrganizationsSetInput>;
  pkColumns: OrganizationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateOrganizationsManyArgs = {
  updates: Array<OrganizationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateProductRolesArgs = {
  _set?: InputMaybe<ProductRolesSetInput>;
  where: ProductRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateProductRolesByPkArgs = {
  _set?: InputMaybe<ProductRolesSetInput>;
  pkColumns: ProductRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateProductRolesManyArgs = {
  updates: Array<ProductRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateProductsArgs = {
  _set?: InputMaybe<ProductsSetInput>;
  where: ProductsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateProductsByPkArgs = {
  _set?: InputMaybe<ProductsSetInput>;
  pkColumns: ProductsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateProductsManyArgs = {
  updates: Array<ProductsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaAssociationsArgs = {
  _inc?: InputMaybe<PropertySchemaAssociationsIncInput>;
  _set?: InputMaybe<PropertySchemaAssociationsSetInput>;
  where: PropertySchemaAssociationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaAssociationsByPkArgs = {
  _inc?: InputMaybe<PropertySchemaAssociationsIncInput>;
  _set?: InputMaybe<PropertySchemaAssociationsSetInput>;
  pkColumns: PropertySchemaAssociationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaAssociationsManyArgs = {
  updates: Array<PropertySchemaAssociationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaSetsArgs = {
  _set?: InputMaybe<PropertySchemaSetsSetInput>;
  where: PropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<PropertySchemaSetsSetInput>;
  pkColumns: PropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemaSetsManyArgs = {
  updates: Array<PropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemasArgs = {
  _append?: InputMaybe<PropertySchemasAppendInput>;
  _deleteAtPath?: InputMaybe<PropertySchemasDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PropertySchemasDeleteElemInput>;
  _deleteKey?: InputMaybe<PropertySchemasDeleteKeyInput>;
  _prepend?: InputMaybe<PropertySchemasPrependInput>;
  _set?: InputMaybe<PropertySchemasSetInput>;
  where: PropertySchemasBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemasByPkArgs = {
  _append?: InputMaybe<PropertySchemasAppendInput>;
  _deleteAtPath?: InputMaybe<PropertySchemasDeleteAtPathInput>;
  _deleteElem?: InputMaybe<PropertySchemasDeleteElemInput>;
  _deleteKey?: InputMaybe<PropertySchemasDeleteKeyInput>;
  _prepend?: InputMaybe<PropertySchemasPrependInput>;
  _set?: InputMaybe<PropertySchemasSetInput>;
  pkColumns: PropertySchemasPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePropertySchemasManyArgs = {
  updates: Array<PropertySchemasUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePropertyTypesArgs = {
  _set?: InputMaybe<PropertyTypesSetInput>;
  where: PropertyTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePropertyTypesByPkArgs = {
  _set?: InputMaybe<PropertyTypesSetInput>;
  pkColumns: PropertyTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePropertyTypesManyArgs = {
  updates: Array<PropertyTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdatePublishersArgs = {
  _set?: InputMaybe<PublishersSetInput>;
  where: PublishersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdatePublishersByPkArgs = {
  _set?: InputMaybe<PublishersSetInput>;
  pkColumns: PublishersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdatePublishersManyArgs = {
  updates: Array<PublishersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionEvidenceSetsArgs = {
  _set?: InputMaybe<RecordComposerDefinitionEvidenceSetsSetInput>;
  where: RecordComposerDefinitionEvidenceSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionEvidenceSetsByPkArgs = {
  _set?: InputMaybe<RecordComposerDefinitionEvidenceSetsSetInput>;
  pkColumns: RecordComposerDefinitionEvidenceSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionEvidenceSetsManyArgs = {
  updates: Array<RecordComposerDefinitionEvidenceSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionPropertySchemaSetsArgs = {
  _set?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsSetInput>;
  where: RecordComposerDefinitionPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionPropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsSetInput>;
  pkColumns: RecordComposerDefinitionPropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionPropertySchemaSetsManyArgs = {
  updates: Array<RecordComposerDefinitionPropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionsArgs = {
  _append?: InputMaybe<RecordComposerDefinitionsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordComposerDefinitionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordComposerDefinitionsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordComposerDefinitionsDeleteKeyInput>;
  _prepend?: InputMaybe<RecordComposerDefinitionsPrependInput>;
  _set?: InputMaybe<RecordComposerDefinitionsSetInput>;
  where: RecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionsByPkArgs = {
  _append?: InputMaybe<RecordComposerDefinitionsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordComposerDefinitionsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordComposerDefinitionsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordComposerDefinitionsDeleteKeyInput>;
  _prepend?: InputMaybe<RecordComposerDefinitionsPrependInput>;
  _set?: InputMaybe<RecordComposerDefinitionsSetInput>;
  pkColumns: RecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordComposerDefinitionsManyArgs = {
  updates: Array<RecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordCompoundRecordComposersArgs = {
  _set?: InputMaybe<RecordCompoundRecordComposersSetInput>;
  where: RecordCompoundRecordComposersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordCompoundRecordComposersByPkArgs = {
  _set?: InputMaybe<RecordCompoundRecordComposersSetInput>;
  pkColumns: RecordCompoundRecordComposersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordCompoundRecordComposersManyArgs = {
  updates: Array<RecordCompoundRecordComposersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordGeoItemsArgs = {
  _append?: InputMaybe<RecordGeoItemsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordGeoItemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordGeoItemsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordGeoItemsDeleteKeyInput>;
  _prepend?: InputMaybe<RecordGeoItemsPrependInput>;
  _set?: InputMaybe<RecordGeoItemsSetInput>;
  where: RecordGeoItemsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordGeoItemsByPkArgs = {
  _append?: InputMaybe<RecordGeoItemsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordGeoItemsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordGeoItemsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordGeoItemsDeleteKeyInput>;
  _prepend?: InputMaybe<RecordGeoItemsPrependInput>;
  _set?: InputMaybe<RecordGeoItemsSetInput>;
  pkColumns: RecordGeoItemsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordGeoItemsManyArgs = {
  updates: Array<RecordGeoItemsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataArgs = {
  _append?: InputMaybe<RecordMetadataAppendInput>;
  _deleteAtPath?: InputMaybe<RecordMetadataDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordMetadataDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordMetadataDeleteKeyInput>;
  _inc?: InputMaybe<RecordMetadataIncInput>;
  _prepend?: InputMaybe<RecordMetadataPrependInput>;
  _set?: InputMaybe<RecordMetadataSetInput>;
  where: RecordMetadataBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataByPkArgs = {
  _append?: InputMaybe<RecordMetadataAppendInput>;
  _deleteAtPath?: InputMaybe<RecordMetadataDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordMetadataDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordMetadataDeleteKeyInput>;
  _inc?: InputMaybe<RecordMetadataIncInput>;
  _prepend?: InputMaybe<RecordMetadataPrependInput>;
  _set?: InputMaybe<RecordMetadataSetInput>;
  pkColumns: RecordMetadataPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataCategoriesArgs = {
  _set?: InputMaybe<RecordMetadataCategoriesSetInput>;
  where: RecordMetadataCategoriesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataCategoriesByPkArgs = {
  _set?: InputMaybe<RecordMetadataCategoriesSetInput>;
  pkColumns: RecordMetadataCategoriesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataCategoriesManyArgs = {
  updates: Array<RecordMetadataCategoriesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataManyArgs = {
  updates: Array<RecordMetadataUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataPropertySchemaSetsArgs = {
  _set?: InputMaybe<RecordMetadataPropertySchemaSetsSetInput>;
  where: RecordMetadataPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataPropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<RecordMetadataPropertySchemaSetsSetInput>;
  pkColumns: RecordMetadataPropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordMetadataPropertySchemaSetsManyArgs = {
  updates: Array<RecordMetadataPropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordPropertySchemaSetsArgs = {
  _set?: InputMaybe<RecordPropertySchemaSetsSetInput>;
  where: RecordPropertySchemaSetsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordPropertySchemaSetsByPkArgs = {
  _set?: InputMaybe<RecordPropertySchemaSetsSetInput>;
  pkColumns: RecordPropertySchemaSetsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordPropertySchemaSetsManyArgs = {
  updates: Array<RecordPropertySchemaSetsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordUpdateRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<RecordUpdateRecordComposerDefinitionsSetInput>;
  where: RecordUpdateRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordUpdateRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<RecordUpdateRecordComposerDefinitionsSetInput>;
  pkColumns: RecordUpdateRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordUpdateRecordComposerDefinitionsManyArgs = {
  updates: Array<RecordUpdateRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRecordsArgs = {
  _append?: InputMaybe<RecordsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordsDeleteKeyInput>;
  _inc?: InputMaybe<RecordsIncInput>;
  _prepend?: InputMaybe<RecordsPrependInput>;
  _set?: InputMaybe<RecordsSetInput>;
  where: RecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRecordsByPkArgs = {
  _append?: InputMaybe<RecordsAppendInput>;
  _deleteAtPath?: InputMaybe<RecordsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<RecordsDeleteElemInput>;
  _deleteKey?: InputMaybe<RecordsDeleteKeyInput>;
  _inc?: InputMaybe<RecordsIncInput>;
  _prepend?: InputMaybe<RecordsPrependInput>;
  _set?: InputMaybe<RecordsSetInput>;
  pkColumns: RecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRecordsManyArgs = {
  updates: Array<RecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReferenceFilesArgs = {
  _inc?: InputMaybe<ReferenceFilesIncInput>;
  _set?: InputMaybe<ReferenceFilesSetInput>;
  where: ReferenceFilesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReferenceFilesByPkArgs = {
  _inc?: InputMaybe<ReferenceFilesIncInput>;
  _set?: InputMaybe<ReferenceFilesSetInput>;
  pkColumns: ReferenceFilesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReferenceFilesManyArgs = {
  updates: Array<ReferenceFilesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReferencePublishersArgs = {
  _set?: InputMaybe<ReferencePublishersSetInput>;
  where: ReferencePublishersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReferencePublishersByPkArgs = {
  _set?: InputMaybe<ReferencePublishersSetInput>;
  pkColumns: ReferencePublishersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReferencePublishersManyArgs = {
  updates: Array<ReferencePublishersUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateReferencesArgs = {
  _inc?: InputMaybe<ReferencesIncInput>;
  _set?: InputMaybe<ReferencesSetInput>;
  where: ReferencesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateReferencesByPkArgs = {
  _inc?: InputMaybe<ReferencesIncInput>;
  _set?: InputMaybe<ReferencesSetInput>;
  pkColumns: ReferencesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateReferencesManyArgs = {
  updates: Array<ReferencesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordComposerDefinitionsArgs = {
  _set?: InputMaybe<RelationRecordComposerDefinitionsSetInput>;
  where: RelationRecordComposerDefinitionsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordComposerDefinitionsByPkArgs = {
  _set?: InputMaybe<RelationRecordComposerDefinitionsSetInput>;
  pkColumns: RelationRecordComposerDefinitionsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordComposerDefinitionsManyArgs = {
  updates: Array<RelationRecordComposerDefinitionsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordsArgs = {
  _set?: InputMaybe<RelationRecordsSetInput>;
  where: RelationRecordsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordsByPkArgs = {
  _set?: InputMaybe<RelationRecordsSetInput>;
  pkColumns: RelationRecordsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRelationRecordsManyArgs = {
  updates: Array<RelationRecordsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRelationTypesArgs = {
  _set?: InputMaybe<RelationTypesSetInput>;
  where: RelationTypesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRelationTypesByPkArgs = {
  _set?: InputMaybe<RelationTypesSetInput>;
  pkColumns: RelationTypesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRelationTypesManyArgs = {
  updates: Array<RelationTypesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateRolesArgs = {
  _set?: InputMaybe<RolesSetInput>;
  where: RolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateRolesByPkArgs = {
  _set?: InputMaybe<RolesSetInput>;
  pkColumns: RolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateRolesManyArgs = {
  updates: Array<RolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateSourceRecordEdgesArgs = {
  _set?: InputMaybe<SourceRecordEdgesSetInput>;
  where: SourceRecordEdgesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateSourceRecordEdgesByPkArgs = {
  _set?: InputMaybe<SourceRecordEdgesSetInput>;
  pkColumns: SourceRecordEdgesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateSourceRecordEdgesManyArgs = {
  updates: Array<SourceRecordEdgesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTargetRecordEdgesArgs = {
  _set?: InputMaybe<TargetRecordEdgesSetInput>;
  where: TargetRecordEdgesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTargetRecordEdgesByPkArgs = {
  _set?: InputMaybe<TargetRecordEdgesSetInput>;
  pkColumns: TargetRecordEdgesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTargetRecordEdgesManyArgs = {
  updates: Array<TargetRecordEdgesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTenantProductInstallationsArgs = {
  _set?: InputMaybe<TenantProductInstallationsSetInput>;
  where: TenantProductInstallationsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTenantProductInstallationsByPkArgs = {
  _set?: InputMaybe<TenantProductInstallationsSetInput>;
  pkColumns: TenantProductInstallationsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTenantProductInstallationsManyArgs = {
  updates: Array<TenantProductInstallationsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateTenantsArgs = {
  _set?: InputMaybe<TenantsSetInput>;
  where: TenantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateTenantsByPkArgs = {
  _set?: InputMaybe<TenantsSetInput>;
  pkColumns: TenantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateTenantsManyArgs = {
  updates: Array<TenantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUnifiedEvidenceDraftsArgs = {
  _append?: InputMaybe<UnifiedEvidenceDraftsAppendInput>;
  _deleteAtPath?: InputMaybe<UnifiedEvidenceDraftsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UnifiedEvidenceDraftsDeleteElemInput>;
  _deleteKey?: InputMaybe<UnifiedEvidenceDraftsDeleteKeyInput>;
  _prepend?: InputMaybe<UnifiedEvidenceDraftsPrependInput>;
  _set?: InputMaybe<UnifiedEvidenceDraftsSetInput>;
  where: UnifiedEvidenceDraftsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUnifiedEvidenceDraftsByPkArgs = {
  _append?: InputMaybe<UnifiedEvidenceDraftsAppendInput>;
  _deleteAtPath?: InputMaybe<UnifiedEvidenceDraftsDeleteAtPathInput>;
  _deleteElem?: InputMaybe<UnifiedEvidenceDraftsDeleteElemInput>;
  _deleteKey?: InputMaybe<UnifiedEvidenceDraftsDeleteKeyInput>;
  _prepend?: InputMaybe<UnifiedEvidenceDraftsPrependInput>;
  _set?: InputMaybe<UnifiedEvidenceDraftsSetInput>;
  pkColumns: UnifiedEvidenceDraftsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUnifiedEvidenceDraftsManyArgs = {
  updates: Array<UnifiedEvidenceDraftsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserGroupsArgs = {
  _set?: InputMaybe<UserGroupsSetInput>;
  where: UserGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserGroupsByPkArgs = {
  _set?: InputMaybe<UserGroupsSetInput>;
  pkColumns: UserGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserGroupsManyArgs = {
  updates: Array<UserGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserProductRolesArgs = {
  _set?: InputMaybe<UserProductRolesSetInput>;
  where: UserProductRolesBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserProductRolesByPkArgs = {
  _set?: InputMaybe<UserProductRolesSetInput>;
  pkColumns: UserProductRolesPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserProductRolesManyArgs = {
  updates: Array<UserProductRolesUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserSegmentsArgs = {
  _inc?: InputMaybe<UserSegmentsIncInput>;
  _set?: InputMaybe<UserSegmentsSetInput>;
  where: UserSegmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserSegmentsByPkArgs = {
  _inc?: InputMaybe<UserSegmentsIncInput>;
  _set?: InputMaybe<UserSegmentsSetInput>;
  pkColumns: UserSegmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserSegmentsManyArgs = {
  updates: Array<UserSegmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserTenantsArgs = {
  _set?: InputMaybe<UserTenantsSetInput>;
  where: UserTenantsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserTenantsByPkArgs = {
  _set?: InputMaybe<UserTenantsSetInput>;
  pkColumns: UserTenantsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserTenantsManyArgs = {
  updates: Array<UserTenantsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserUserGroupsArgs = {
  _set?: InputMaybe<UserUserGroupsSetInput>;
  where: UserUserGroupsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserUserGroupsByPkArgs = {
  _set?: InputMaybe<UserUserGroupsSetInput>;
  pkColumns: UserUserGroupsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserUserGroupsManyArgs = {
  updates: Array<UserUserGroupsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUserUserSegmentsArgs = {
  _inc?: InputMaybe<UserUserSegmentsIncInput>;
  _set?: InputMaybe<UserUserSegmentsSetInput>;
  where: UserUserSegmentsBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUserUserSegmentsByPkArgs = {
  _inc?: InputMaybe<UserUserSegmentsIncInput>;
  _set?: InputMaybe<UserUserSegmentsSetInput>;
  pkColumns: UserUserSegmentsPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUserUserSegmentsManyArgs = {
  updates: Array<UserUserSegmentsUpdates>;
};


/** mutation root */
export type Mutation_RootUpdateUsersArgs = {
  _set?: InputMaybe<UsersSetInput>;
  where: UsersBoolExp;
};


/** mutation root */
export type Mutation_RootUpdateUsersByPkArgs = {
  _set?: InputMaybe<UsersSetInput>;
  pkColumns: UsersPkColumnsInput;
};


/** mutation root */
export type Mutation_RootUpdateUsersManyArgs = {
  updates: Array<UsersUpdates>;
};

export type ProductRolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ProductRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ProductRolesBoolExp>;
  predicate: IntComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpBool_And = {
  arguments: PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpBool_Or = {
  arguments: PropertySchemaAssociationsSelectColumnPropertySchemaAssociationsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type PropertySchemaAssociationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<PropertySchemaAssociationsBoolExp>;
  predicate: IntComparisonExp;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "area_codes" */
  areaCodes: Array<AreaCodes>;
  /** fetch aggregated fields from the table: "area_codes" */
  areaCodesAggregate: AreaCodesAggregate;
  /** fetch data from the table: "area_codes" using primary key columns */
  areaCodesByPk?: Maybe<AreaCodes>;
  /** An array relationship */
  batchChangeRequestReviewsJobRuns: Array<BatchChangeRequestReviewsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobRunsAggregate: BatchChangeRequestReviewsJobRunsAggregate;
  /** fetch data from the table: "batch_change_request_reviews_job_runs" using primary key columns */
  batchChangeRequestReviewsJobRunsByPk?: Maybe<BatchChangeRequestReviewsJobRuns>;
  /** An array relationship */
  batchChangeRequestReviewsJobs: Array<BatchChangeRequestReviewsJobs>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobsAggregate: BatchChangeRequestReviewsJobsAggregate;
  /** fetch data from the table: "batch_change_request_reviews_jobs" using primary key columns */
  batchChangeRequestReviewsJobsByPk?: Maybe<BatchChangeRequestReviewsJobs>;
  /** An array relationship */
  batchChangeRequestsJobRecordComposerDefinitions: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An aggregate relationship */
  batchChangeRequestsJobRecordComposerDefinitionsAggregate: BatchChangeRequestsJobRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "batch_change_requests_job_record_composer_definitions" using primary key columns */
  batchChangeRequestsJobRecordComposerDefinitionsByPk?: Maybe<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An array relationship */
  batchChangeRequestsJobRuns: Array<BatchChangeRequestsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestsJobRunsAggregate: BatchChangeRequestsJobRunsAggregate;
  /** fetch data from the table: "batch_change_requests_job_runs" using primary key columns */
  batchChangeRequestsJobRunsByPk?: Maybe<BatchChangeRequestsJobRuns>;
  /** An array relationship */
  batchChangeRequestsJobs: Array<BatchChangeRequestsJobs>;
  /** An aggregate relationship */
  batchChangeRequestsJobsAggregate: BatchChangeRequestsJobsAggregate;
  /** fetch data from the table: "batch_change_requests_jobs" using primary key columns */
  batchChangeRequestsJobsByPk?: Maybe<BatchChangeRequestsJobs>;
  /** An array relationship */
  batchEvidenceCommitsJobRuns: Array<BatchEvidenceCommitsJobRuns>;
  /** An aggregate relationship */
  batchEvidenceCommitsJobRunsAggregate: BatchEvidenceCommitsJobRunsAggregate;
  /** fetch data from the table: "batch_evidence_commits_job_runs" using primary key columns */
  batchEvidenceCommitsJobRunsByPk?: Maybe<BatchEvidenceCommitsJobRuns>;
  /** fetch data from the table: "batch_evidence_commits_jobs" */
  batchEvidenceCommitsJobs: Array<BatchEvidenceCommitsJobs>;
  /** fetch aggregated fields from the table: "batch_evidence_commits_jobs" */
  batchEvidenceCommitsJobsAggregate: BatchEvidenceCommitsJobsAggregate;
  /** fetch data from the table: "batch_evidence_commits_jobs" using primary key columns */
  batchEvidenceCommitsJobsByPk?: Maybe<BatchEvidenceCommitsJobs>;
  /** An array relationship */
  batchEvidencesJobRuns: Array<BatchEvidencesJobRuns>;
  /** An aggregate relationship */
  batchEvidencesJobRunsAggregate: BatchEvidencesJobRunsAggregate;
  /** fetch data from the table: "batch_evidences_job_runs" using primary key columns */
  batchEvidencesJobRunsByPk?: Maybe<BatchEvidencesJobRuns>;
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  /** fetch data from the table: "batch_evidences_jobs" using primary key columns */
  batchEvidencesJobsByPk?: Maybe<BatchEvidencesJobs>;
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categoriesAggregate: CategoriesAggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categoriesByPk?: Maybe<Categories>;
  /** fetch data from the table: "category_paths" */
  categoryPaths: Array<CategoryPaths>;
  /** fetch aggregated fields from the table: "category_paths" */
  categoryPathsAggregate: CategoryPathsAggregate;
  /** fetch data from the table: "category_paths" using primary key columns */
  categoryPathsByPk?: Maybe<CategoryPaths>;
  /** fetch data from the table: "category_property_schema_sets" */
  categoryPropertySchemaSets: Array<CategoryPropertySchemaSets>;
  /** fetch aggregated fields from the table: "category_property_schema_sets" */
  categoryPropertySchemaSetsAggregate: CategoryPropertySchemaSetsAggregate;
  /** fetch data from the table: "category_property_schema_sets" using primary key columns */
  categoryPropertySchemaSetsByPk?: Maybe<CategoryPropertySchemaSets>;
  /** fetch data from the table: "category_types" */
  categoryTypes: Array<CategoryTypes>;
  /** fetch aggregated fields from the table: "category_types" */
  categoryTypesAggregate: CategoryTypesAggregate;
  /** fetch data from the table: "category_types" using primary key columns */
  categoryTypesByPk?: Maybe<CategoryTypes>;
  /** fetch data from the table: "change_request_commits" */
  changeRequestCommits: Array<ChangeRequestCommits>;
  /** fetch aggregated fields from the table: "change_request_commits" */
  changeRequestCommitsAggregate: ChangeRequestCommitsAggregate;
  /** fetch data from the table: "change_request_commits" using primary key columns */
  changeRequestCommitsByPk?: Maybe<ChangeRequestCommits>;
  /** fetch data from the table: "change_request_item_commits" */
  changeRequestItemCommits: Array<ChangeRequestItemCommits>;
  /** fetch aggregated fields from the table: "change_request_item_commits" */
  changeRequestItemCommitsAggregate: ChangeRequestItemCommitsAggregate;
  /** fetch data from the table: "change_request_item_commits" using primary key columns */
  changeRequestItemCommitsByPk?: Maybe<ChangeRequestItemCommits>;
  /** An array relationship */
  changeRequestItemRecordMetadata: Array<ChangeRequestItemRecordMetadata>;
  /** An aggregate relationship */
  changeRequestItemRecordMetadataAggregate: ChangeRequestItemRecordMetadataAggregate;
  /** fetch data from the table: "change_request_item_record_metadata" using primary key columns */
  changeRequestItemRecordMetadataByPk?: Maybe<ChangeRequestItemRecordMetadata>;
  /** An array relationship */
  changeRequestItemRecords: Array<ChangeRequestItemRecords>;
  /** An aggregate relationship */
  changeRequestItemRecordsAggregate: ChangeRequestItemRecordsAggregate;
  /** fetch data from the table: "change_request_item_records" using primary key columns */
  changeRequestItemRecordsByPk?: Maybe<ChangeRequestItemRecords>;
  /** fetch data from the table: "change_request_items" */
  changeRequestItems: Array<ChangeRequestItems>;
  /** fetch aggregated fields from the table: "change_request_items" */
  changeRequestItemsAggregate: ChangeRequestItemsAggregate;
  /** fetch data from the table: "change_request_items" using primary key columns */
  changeRequestItemsByPk?: Maybe<ChangeRequestItems>;
  /** An array relationship */
  changeRequestRecordComposerDefinitions: Array<ChangeRequestRecordComposerDefinitions>;
  /** An aggregate relationship */
  changeRequestRecordComposerDefinitionsAggregate: ChangeRequestRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "change_request_record_composer_definitions" using primary key columns */
  changeRequestRecordComposerDefinitionsByPk?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** fetch data from the table: "change_request_review_types" */
  changeRequestReviewTypes: Array<ChangeRequestReviewTypes>;
  /** fetch aggregated fields from the table: "change_request_review_types" */
  changeRequestReviewTypesAggregate: ChangeRequestReviewTypesAggregate;
  /** fetch data from the table: "change_request_review_types" using primary key columns */
  changeRequestReviewTypesByPk?: Maybe<ChangeRequestReviewTypes>;
  /** fetch data from the table: "change_request_reviews" */
  changeRequestReviews: Array<ChangeRequestReviews>;
  /** fetch aggregated fields from the table: "change_request_reviews" */
  changeRequestReviewsAggregate: ChangeRequestReviewsAggregate;
  /** fetch data from the table: "change_request_reviews" using primary key columns */
  changeRequestReviewsByPk?: Maybe<ChangeRequestReviews>;
  /** fetch data from the table: "change_request_statuses" */
  changeRequestStatuses: Array<ChangeRequestStatuses>;
  /** fetch aggregated fields from the table: "change_request_statuses" */
  changeRequestStatusesAggregate: ChangeRequestStatusesAggregate;
  /** fetch data from the table: "change_request_statuses" using primary key columns */
  changeRequestStatusesByPk?: Maybe<ChangeRequestStatuses>;
  /** An array relationship */
  changeRequests: Array<ChangeRequests>;
  /** An aggregate relationship */
  changeRequestsAggregate: ChangeRequestsAggregate;
  /** fetch data from the table: "change_requests" using primary key columns */
  changeRequestsByPk?: Maybe<ChangeRequests>;
  cnutExportBatchChangeRequestsJobDryRunResult: Scalars['String']['output'];
  cnutExportBatchEvidencesJobDryRunResult: Scalars['String']['output'];
  cnutFilterRecordIdsWithGeoItems: RecordIdsWithGeoItemsOutput;
  cnutGetBatchChangeRequestReviewsJobDryRunResult: DryRunBatchChangeRequestReviewsJobResponse;
  cnutGetBatchChangeRequestsJobDryRunResult: DryRunBatchChangeRequestsJobResponse;
  cnutGetBatchEvidencesJobDryRunResult: DryRunBatchEvidencesJobResponse;
  cnutGetCategoryPropertySchemas: GetCategoryPropertySchemasResponse;
  cnutGetCompoundRecordComposer: CompoundRecordComposerGetResponse;
  cnutGetCompoundRecordComposers: CompoundRecordComposersListResponse;
  cnutGetCompoundRecordEvidences: CompoundRecordEvidencesGetResponse;
  cnutGetCompoundRecordEvidencesByCompoundRecordIds: CompoundRecordEvidencesGetByCompoundRecordIdsResponse;
  cnutGetDataImportJobDiagnosis?: Maybe<CnutDataImportJobDiagnosis>;
  cnutGetDataSourceJsonData: GetDataSourceJsonDataResponse;
  cnutGetDataSourceJsonPresignedUrl: GetDataSourceJsonPresignedUrlResponse;
  cnutGetDataSourceStats: GetDataSourceStatsResponse;
  cnutGetEvidenceSetPreview: EvidenceSetPreviewOutput;
  cnutGetGeoItem?: Maybe<GeoItemGetOutput>;
  cnutGetJobLogPresignedUrl?: Maybe<GetJobLogPresignedUrlResponse>;
  cnutGetMe: UserMeResponse;
  cnutGetPublishedRecordGeoItemsByRecord: RecordGeoItemsByRecordResponse;
  cnutGetRecordCompoundRecordComposers: RecordCompoundRecordComposersListResponse;
  cnutGetRecordGeoItemDetail: RecordGeoItemDetailResponse;
  cnutGetRecordGeoItemsByRecord: RecordGeoItemsByRecordResponse;
  cnutGetRecordGeoItemsByRecordIds: RecordGeoItemsByRecordIdsResponse;
  cnutGetRecordUpdateDataImportProjectTargets: RecordUpdateTargetsOutput;
  cnutGetReferenceFileImagePresignedUrl: ReferenceFileImagePresignedUrlOutput;
  cnutGetReferenceFileUrl: ReferenceFileUrlOutput;
  cnutGetSidebarBuildPolicy: GetSidebarBuildPolicyOutput;
  cnutGetTenantMemberPhotos: TenantMemberPhotosOutput;
  cnutGetUser: UserGetOutput;
  cnutListCategories: ListCategoriesResponse;
  cnutListCategorySchemaMigrations: ListCategorySchemaMigrationsOutput;
  cnutListDataImportJobDiagnoses: Array<CnutDataImportJobDiagnosis>;
  cnutListDataSourceColumnNames: ListDataSourceColumnNamesResponse;
  cnutListDataSourceSheets: ListDataSourceSheetsResponse;
  cnutListEffectiveCategoryPropertySchemas: ListEffectiveCategoryPropertySchemasResponse;
  cnutListRecordIdsWithGeoItems: RecordIdsWithGeoItemsPage;
  cnutListUserGroups: UserGroupListOutput;
  cnutListWorkerCommands: ListWorkerCommandsOutput;
  cnutPrepareRecordUpdateDataImportProject: RecordUpdatePreviewOutput;
  cnutSearchEntities: SearchEntitiesOutput;
  cnutSearchGeoItems: GeoItemSearchOutput;
  cnutValidateWorkerJobRerun: ValidateWorkerJobRerunOutput;
  /** fetch data from the table: "compound.compound_records" */
  compoundCompoundRecords: Array<CompoundCompoundRecords>;
  /** fetch aggregated fields from the table: "compound.compound_records" */
  compoundCompoundRecordsAggregate: CompoundCompoundRecordsAggregate;
  /** fetch data from the table: "compound.compound_records" using primary key columns */
  compoundCompoundRecordsByPk?: Maybe<CompoundCompoundRecords>;
  /** fetch data from the table: "compound_record_composers" */
  compoundRecordComposers: Array<CompoundRecordComposers>;
  /** fetch aggregated fields from the table: "compound_record_composers" */
  compoundRecordComposersAggregate: CompoundRecordComposersAggregate;
  /** fetch data from the table: "compound_record_composers" using primary key columns */
  compoundRecordComposersByPk?: Maybe<CompoundRecordComposers>;
  /** fetch data from the table: "compound_record_versions" */
  compoundRecordVersions: Array<CompoundRecordVersions>;
  /** fetch aggregated fields from the table: "compound_record_versions" */
  compoundRecordVersionsAggregate: CompoundRecordVersionsAggregate;
  /** fetch data from the table: "compound_record_versions" using primary key columns */
  compoundRecordVersionsByPk?: Maybe<CompoundRecordVersions>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countriesAggregate: CountriesAggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** An array relationship */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** An aggregate relationship */
  countrySubdivisionsAggregate: CountrySubdivisionsAggregate;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table: "data_import_project_record_composer_definitions" */
  dataImportProjectRecordComposerDefinitions: Array<DataImportProjectRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "data_import_project_record_composer_definitions" */
  dataImportProjectRecordComposerDefinitionsAggregate: DataImportProjectRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "data_import_project_record_composer_definitions" using primary key columns */
  dataImportProjectRecordComposerDefinitionsByPk?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** An array relationship */
  dataImportProjectStatusLogs: Array<DataImportProjectStatusLogs>;
  /** An aggregate relationship */
  dataImportProjectStatusLogsAggregate: DataImportProjectStatusLogsAggregate;
  /** fetch data from the table: "data_import_project_status_logs" using primary key columns */
  dataImportProjectStatusLogsByPk?: Maybe<DataImportProjectStatusLogs>;
  /** fetch data from the table: "data_import_project_statuses" */
  dataImportProjectStatuses: Array<DataImportProjectStatuses>;
  /** fetch aggregated fields from the table: "data_import_project_statuses" */
  dataImportProjectStatusesAggregate: DataImportProjectStatusesAggregate;
  /** fetch data from the table: "data_import_project_statuses" using primary key columns */
  dataImportProjectStatusesByPk?: Maybe<DataImportProjectStatuses>;
  /** An array relationship */
  dataImportProjectUsers: Array<DataImportProjectUsers>;
  /** An aggregate relationship */
  dataImportProjectUsersAggregate: DataImportProjectUsersAggregate;
  /** fetch data from the table: "data_import_project_users" using primary key columns */
  dataImportProjectUsersByPk?: Maybe<DataImportProjectUsers>;
  /** fetch data from the table: "data_import_projects" */
  dataImportProjects: Array<DataImportProjects>;
  /** fetch aggregated fields from the table: "data_import_projects" */
  dataImportProjectsAggregate: DataImportProjectsAggregate;
  /** fetch data from the table: "data_import_projects" using primary key columns */
  dataImportProjectsByPk?: Maybe<DataImportProjects>;
  /** fetch data from the table: "data_source_gsheets" */
  dataSourceGsheets: Array<DataSourceGsheets>;
  /** fetch aggregated fields from the table: "data_source_gsheets" */
  dataSourceGsheetsAggregate: DataSourceGsheetsAggregate;
  /** fetch data from the table: "data_source_gsheets" using primary key columns */
  dataSourceGsheetsByPk?: Maybe<DataSourceGsheets>;
  /** fetch data from the table: "data_source_import_project_record_composer_definitions" */
  dataSourceImportProjectRecordComposerDefinitions: Array<DataSourceImportProjectRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "data_source_import_project_record_composer_definitions" */
  dataSourceImportProjectRecordComposerDefinitionsAggregate: DataSourceImportProjectRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "data_source_import_project_record_composer_definitions" using primary key columns */
  dataSourceImportProjectRecordComposerDefinitionsByPk?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  /** An array relationship */
  dataSourceImportProjects: Array<DataSourceImportProjects>;
  /** An aggregate relationship */
  dataSourceImportProjectsAggregate: DataSourceImportProjectsAggregate;
  /** fetch data from the table: "data_source_import_projects" using primary key columns */
  dataSourceImportProjectsByPk?: Maybe<DataSourceImportProjects>;
  /** fetch data from the table: "data_source_jsons" */
  dataSourceJsons: Array<DataSourceJsons>;
  /** fetch aggregated fields from the table: "data_source_jsons" */
  dataSourceJsonsAggregate: DataSourceJsonsAggregate;
  /** fetch data from the table: "data_source_jsons" using primary key columns */
  dataSourceJsonsByPk?: Maybe<DataSourceJsons>;
  /** fetch data from the table: "data_source_property_schema_sets" */
  dataSourcePropertySchemaSets: Array<DataSourcePropertySchemaSets>;
  /** fetch aggregated fields from the table: "data_source_property_schema_sets" */
  dataSourcePropertySchemaSetsAggregate: DataSourcePropertySchemaSetsAggregate;
  /** fetch data from the table: "data_source_property_schema_sets" using primary key columns */
  dataSourcePropertySchemaSetsByPk?: Maybe<DataSourcePropertySchemaSets>;
  /** An array relationship */
  dataSourceReferences: Array<DataSourceReferences>;
  /** An aggregate relationship */
  dataSourceReferencesAggregate: DataSourceReferencesAggregate;
  /** fetch data from the table: "data_source_references" using primary key columns */
  dataSourceReferencesByPk?: Maybe<DataSourceReferences>;
  /** fetch data from the table: "data_source_template_property_schema_sets" */
  dataSourceTemplatePropertySchemaSets: Array<DataSourceTemplatePropertySchemaSets>;
  /** fetch aggregated fields from the table: "data_source_template_property_schema_sets" */
  dataSourceTemplatePropertySchemaSetsAggregate: DataSourceTemplatePropertySchemaSetsAggregate;
  /** fetch data from the table: "data_source_template_property_schema_sets" using primary key columns */
  dataSourceTemplatePropertySchemaSetsByPk?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** fetch data from the table: "data_source_templates" */
  dataSourceTemplates: Array<DataSourceTemplates>;
  /** fetch aggregated fields from the table: "data_source_templates" */
  dataSourceTemplatesAggregate: DataSourceTemplatesAggregate;
  /** fetch data from the table: "data_source_templates" using primary key columns */
  dataSourceTemplatesByPk?: Maybe<DataSourceTemplates>;
  /** fetch data from the table: "data_sources" */
  dataSources: Array<DataSources>;
  /** fetch aggregated fields from the table: "data_sources" */
  dataSourcesAggregate: DataSourcesAggregate;
  /** fetch data from the table: "data_sources" using primary key columns */
  dataSourcesByPk?: Maybe<DataSources>;
  /** fetch data from the table: "dbpjkit_worker_job_runs" */
  dbpjkitWorkerJobRuns: Array<DbpjkitWorkerJobRuns>;
  /** An aggregate relationship */
  dbpjkitWorkerJobRunsAggregate: DbpjkitWorkerJobRunsAggregate;
  /** fetch data from the table: "dbpjkit_worker_job_runs" using primary key columns */
  dbpjkitWorkerJobRunsByPk?: Maybe<DbpjkitWorkerJobRuns>;
  /** fetch data from the table: "dbpjkit_worker_jobs" */
  dbpjkitWorkerJobs: Array<DbpjkitWorkerJobs>;
  /** fetch aggregated fields from the table: "dbpjkit_worker_jobs" */
  dbpjkitWorkerJobsAggregate: DbpjkitWorkerJobsAggregate;
  /** fetch data from the table: "dbpjkit_worker_jobs" using primary key columns */
  dbpjkitWorkerJobsByPk?: Maybe<DbpjkitWorkerJobs>;
  /** fetch data from the table: "entity_record_composer_definitions" */
  entityRecordComposerDefinitions: Array<EntityRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "entity_record_composer_definitions" */
  entityRecordComposerDefinitionsAggregate: EntityRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "entity_record_composer_definitions" using primary key columns */
  entityRecordComposerDefinitionsByPk?: Maybe<EntityRecordComposerDefinitions>;
  /** fetch data from the table: "entity_records" */
  entityRecords: Array<EntityRecords>;
  /** fetch aggregated fields from the table: "entity_records" */
  entityRecordsAggregate: EntityRecordsAggregate;
  /** fetch data from the table: "entity_records" using primary key columns */
  entityRecordsByPk?: Maybe<EntityRecords>;
  /** An array relationship */
  evidenceChangeRequests: Array<EvidenceChangeRequests>;
  /** An aggregate relationship */
  evidenceChangeRequestsAggregate: EvidenceChangeRequestsAggregate;
  /** fetch data from the table: "evidence_change_requests" using primary key columns */
  evidenceChangeRequestsByPk?: Maybe<EvidenceChangeRequests>;
  /** An array relationship */
  evidenceEvidenceSets: Array<EvidenceEvidenceSets>;
  /** An aggregate relationship */
  evidenceEvidenceSetsAggregate: EvidenceEvidenceSetsAggregate;
  /** fetch data from the table: "evidence_evidence_sets" using primary key columns */
  evidenceEvidenceSetsByPk?: Maybe<EvidenceEvidenceSets>;
  /** fetch data from the table: "evidence_importers" */
  evidenceImporters: Array<EvidenceImporters>;
  /** fetch aggregated fields from the table: "evidence_importers" */
  evidenceImportersAggregate: EvidenceImportersAggregate;
  /** fetch data from the table: "evidence_importers" using primary key columns */
  evidenceImportersByPk?: Maybe<EvidenceImporters>;
  /** An array relationship */
  evidenceRecordGeoItems: Array<EvidenceRecordGeoItems>;
  /** An aggregate relationship */
  evidenceRecordGeoItemsAggregate: EvidenceRecordGeoItemsAggregate;
  /** fetch data from the table: "evidence_record_geo_items" using primary key columns */
  evidenceRecordGeoItemsByPk?: Maybe<EvidenceRecordGeoItems>;
  /** An array relationship */
  evidenceSetImportProjects: Array<EvidenceSetImportProjects>;
  /** An aggregate relationship */
  evidenceSetImportProjectsAggregate: EvidenceSetImportProjectsAggregate;
  /** fetch data from the table: "evidence_set_import_projects" using primary key columns */
  evidenceSetImportProjectsByPk?: Maybe<EvidenceSetImportProjects>;
  /** fetch data from the table: "evidence_set_property_schema_sets" */
  evidenceSetPropertySchemaSets: Array<EvidenceSetPropertySchemaSets>;
  /** fetch aggregated fields from the table: "evidence_set_property_schema_sets" */
  evidenceSetPropertySchemaSetsAggregate: EvidenceSetPropertySchemaSetsAggregate;
  /** fetch data from the table: "evidence_set_property_schema_sets" using primary key columns */
  evidenceSetPropertySchemaSetsByPk?: Maybe<EvidenceSetPropertySchemaSets>;
  /** fetch data from the table: "evidence_sets" */
  evidenceSets: Array<EvidenceSets>;
  /** fetch aggregated fields from the table: "evidence_sets" */
  evidenceSetsAggregate: EvidenceSetsAggregate;
  /** fetch data from the table: "evidence_sets" using primary key columns */
  evidenceSetsByPk?: Maybe<EvidenceSets>;
  /** An array relationship */
  evidenceVersions: Array<EvidenceVersions>;
  /** An aggregate relationship */
  evidenceVersionsAggregate: EvidenceVersionsAggregate;
  /** fetch data from the table: "evidence_versions" using primary key columns */
  evidenceVersionsByPk?: Maybe<EvidenceVersions>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  /** fetch data from the table: "evidences" using primary key columns */
  evidencesByPk?: Maybe<Evidences>;
  getBatchChangeRequestJobDryRunResultUrl: DryRunResultUrl;
  getBatchEvidenceJobDryRunResultUrl: DryRunResultUrl;
  /** fetch data from the table: "job_run_statuses" */
  jobRunStatuses: Array<JobRunStatuses>;
  /** fetch aggregated fields from the table: "job_run_statuses" */
  jobRunStatusesAggregate: JobRunStatusesAggregate;
  /** fetch data from the table: "job_run_statuses" using primary key columns */
  jobRunStatusesByPk?: Maybe<JobRunStatuses>;
  /** fetch data from the table: "organization_kinds" */
  organizationKinds: Array<OrganizationKinds>;
  /** fetch aggregated fields from the table: "organization_kinds" */
  organizationKindsAggregate: OrganizationKindsAggregate;
  /** fetch data from the table: "organization_kinds" using primary key columns */
  organizationKindsByPk?: Maybe<OrganizationKinds>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizationsAggregate: OrganizationsAggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizationsByPk?: Maybe<Organizations>;
  /** An array relationship */
  productRoles: Array<ProductRoles>;
  /** An aggregate relationship */
  productRolesAggregate: ProductRolesAggregate;
  /** fetch data from the table: "product_roles" using primary key columns */
  productRolesByPk?: Maybe<ProductRoles>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  productsAggregate: ProductsAggregate;
  /** fetch data from the table: "products" using primary key columns */
  productsByPk?: Maybe<Products>;
  /** An array relationship */
  propertySchemaAssociations: Array<PropertySchemaAssociations>;
  /** An aggregate relationship */
  propertySchemaAssociationsAggregate: PropertySchemaAssociationsAggregate;
  /** fetch data from the table: "property_schema_associations" using primary key columns */
  propertySchemaAssociationsByPk?: Maybe<PropertySchemaAssociations>;
  /** fetch data from the table: "property_schema_sets" */
  propertySchemaSets: Array<PropertySchemaSets>;
  /** fetch aggregated fields from the table: "property_schema_sets" */
  propertySchemaSetsAggregate: PropertySchemaSetsAggregate;
  /** fetch data from the table: "property_schema_sets" using primary key columns */
  propertySchemaSetsByPk?: Maybe<PropertySchemaSets>;
  /** fetch data from the table: "property_schemas" */
  propertySchemas: Array<PropertySchemas>;
  /** fetch aggregated fields from the table: "property_schemas" */
  propertySchemasAggregate: PropertySchemasAggregate;
  /** fetch data from the table: "property_schemas" using primary key columns */
  propertySchemasByPk?: Maybe<PropertySchemas>;
  /** fetch data from the table: "property_types" */
  propertyTypes: Array<PropertyTypes>;
  /** fetch aggregated fields from the table: "property_types" */
  propertyTypesAggregate: PropertyTypesAggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  propertyTypesByPk?: Maybe<PropertyTypes>;
  /** fetch data from the table: "publishers" */
  publishers: Array<Publishers>;
  /** fetch aggregated fields from the table: "publishers" */
  publishersAggregate: PublishersAggregate;
  /** fetch data from the table: "publishers" using primary key columns */
  publishersByPk?: Maybe<Publishers>;
  /** An array relationship */
  recordComposerDefinitionEvidenceSets: Array<RecordComposerDefinitionEvidenceSets>;
  /** An aggregate relationship */
  recordComposerDefinitionEvidenceSetsAggregate: RecordComposerDefinitionEvidenceSetsAggregate;
  /** fetch data from the table: "record_composer_definition_evidence_sets" using primary key columns */
  recordComposerDefinitionEvidenceSetsByPk?: Maybe<RecordComposerDefinitionEvidenceSets>;
  /** fetch data from the table: "record_composer_definition_property_schema_sets" */
  recordComposerDefinitionPropertySchemaSets: Array<RecordComposerDefinitionPropertySchemaSets>;
  /** fetch aggregated fields from the table: "record_composer_definition_property_schema_sets" */
  recordComposerDefinitionPropertySchemaSetsAggregate: RecordComposerDefinitionPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_composer_definition_property_schema_sets" using primary key columns */
  recordComposerDefinitionPropertySchemaSetsByPk?: Maybe<RecordComposerDefinitionPropertySchemaSets>;
  /** fetch data from the table: "record_composer_definitions" */
  recordComposerDefinitions: Array<RecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "record_composer_definitions" */
  recordComposerDefinitionsAggregate: RecordComposerDefinitionsAggregate;
  /** fetch data from the table: "record_composer_definitions" using primary key columns */
  recordComposerDefinitionsByPk?: Maybe<RecordComposerDefinitions>;
  /** An array relationship */
  recordCompoundRecordComposers: Array<RecordCompoundRecordComposers>;
  /** An aggregate relationship */
  recordCompoundRecordComposersAggregate: RecordCompoundRecordComposersAggregate;
  /** fetch data from the table: "record_compound_record_composers" using primary key columns */
  recordCompoundRecordComposersByPk?: Maybe<RecordCompoundRecordComposers>;
  /** An array relationship */
  recordGeoItems: Array<RecordGeoItems>;
  /** An aggregate relationship */
  recordGeoItemsAggregate: RecordGeoItemsAggregate;
  /** fetch data from the table: "record_geo_items" using primary key columns */
  recordGeoItemsByPk?: Maybe<RecordGeoItems>;
  /** fetch data from the table: "record_metadata" */
  recordMetadata: Array<RecordMetadata>;
  /** fetch aggregated fields from the table: "record_metadata" */
  recordMetadataAggregate: RecordMetadataAggregate;
  /** fetch data from the table: "record_metadata" using primary key columns */
  recordMetadataByPk?: Maybe<RecordMetadata>;
  /** An array relationship */
  recordMetadataCategories: Array<RecordMetadataCategories>;
  /** An aggregate relationship */
  recordMetadataCategoriesAggregate: RecordMetadataCategoriesAggregate;
  /** fetch data from the table: "record_metadata_categories" using primary key columns */
  recordMetadataCategoriesByPk?: Maybe<RecordMetadataCategories>;
  /** fetch data from the table: "record_metadata_property_schema_sets" */
  recordMetadataPropertySchemaSets: Array<RecordMetadataPropertySchemaSets>;
  /** fetch aggregated fields from the table: "record_metadata_property_schema_sets" */
  recordMetadataPropertySchemaSetsAggregate: RecordMetadataPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_metadata_property_schema_sets" using primary key columns */
  recordMetadataPropertySchemaSetsByPk?: Maybe<RecordMetadataPropertySchemaSets>;
  /** An array relationship */
  recordPropertySchemaSets: Array<RecordPropertySchemaSets>;
  /** An aggregate relationship */
  recordPropertySchemaSetsAggregate: RecordPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_property_schema_sets" using primary key columns */
  recordPropertySchemaSetsByPk?: Maybe<RecordPropertySchemaSets>;
  /** fetch data from the table: "record_update_record_composer_definitions" */
  recordUpdateRecordComposerDefinitions: Array<RecordUpdateRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "record_update_record_composer_definitions" */
  recordUpdateRecordComposerDefinitionsAggregate: RecordUpdateRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "record_update_record_composer_definitions" using primary key columns */
  recordUpdateRecordComposerDefinitionsByPk?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** fetch data from the table: "records" */
  records: Array<Records>;
  /** fetch aggregated fields from the table: "records" */
  recordsAggregate: RecordsAggregate;
  /** fetch data from the table: "records" using primary key columns */
  recordsByPk?: Maybe<Records>;
  /** An array relationship */
  referenceFiles: Array<ReferenceFiles>;
  /** An aggregate relationship */
  referenceFilesAggregate: ReferenceFilesAggregate;
  /** fetch data from the table: "reference_files" using primary key columns */
  referenceFilesByPk?: Maybe<ReferenceFiles>;
  /** An array relationship */
  referencePublishers: Array<ReferencePublishers>;
  /** An aggregate relationship */
  referencePublishersAggregate: ReferencePublishersAggregate;
  /** fetch data from the table: "reference_publishers" using primary key columns */
  referencePublishersByPk?: Maybe<ReferencePublishers>;
  /** fetch data from the table: "references" */
  references: Array<References>;
  /** fetch aggregated fields from the table: "references" */
  referencesAggregate: ReferencesAggregate;
  /** fetch data from the table: "references" using primary key columns */
  referencesByPk?: Maybe<References>;
  /** fetch data from the table: "relation_record_composer_definitions" */
  relationRecordComposerDefinitions: Array<RelationRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "relation_record_composer_definitions" */
  relationRecordComposerDefinitionsAggregate: RelationRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "relation_record_composer_definitions" using primary key columns */
  relationRecordComposerDefinitionsByPk?: Maybe<RelationRecordComposerDefinitions>;
  /** fetch data from the table: "relation_records" */
  relationRecords: Array<RelationRecords>;
  /** fetch aggregated fields from the table: "relation_records" */
  relationRecordsAggregate: RelationRecordsAggregate;
  /** fetch data from the table: "relation_records" using primary key columns */
  relationRecordsByPk?: Maybe<RelationRecords>;
  /** fetch data from the table: "relation_types" */
  relationTypes: Array<RelationTypes>;
  /** fetch aggregated fields from the table: "relation_types" */
  relationTypesAggregate: RelationTypesAggregate;
  /** fetch data from the table: "relation_types" using primary key columns */
  relationTypesByPk?: Maybe<RelationTypes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  rolesAggregate: RolesAggregate;
  /** fetch data from the table: "roles" using primary key columns */
  rolesByPk?: Maybe<Roles>;
  /** An array relationship */
  sourceRecordEdges: Array<SourceRecordEdges>;
  /** An aggregate relationship */
  sourceRecordEdgesAggregate: SourceRecordEdgesAggregate;
  /** fetch data from the table: "source_record_edges" using primary key columns */
  sourceRecordEdgesByPk?: Maybe<SourceRecordEdges>;
  /** An array relationship */
  targetRecordEdges: Array<TargetRecordEdges>;
  /** An aggregate relationship */
  targetRecordEdgesAggregate: TargetRecordEdgesAggregate;
  /** fetch data from the table: "target_record_edges" using primary key columns */
  targetRecordEdgesByPk?: Maybe<TargetRecordEdges>;
  /** An array relationship */
  tenantProductInstallations: Array<TenantProductInstallations>;
  /** An aggregate relationship */
  tenantProductInstallationsAggregate: TenantProductInstallationsAggregate;
  /** fetch data from the table: "tenant_product_installations" using primary key columns */
  tenantProductInstallationsByPk?: Maybe<TenantProductInstallations>;
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenantsAggregate: TenantsAggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantsByPk?: Maybe<Tenants>;
  /** An array relationship */
  unifiedEvidenceDrafts: Array<UnifiedEvidenceDrafts>;
  /** An aggregate relationship */
  unifiedEvidenceDraftsAggregate: UnifiedEvidenceDraftsAggregate;
  /** fetch data from the table: "unified_evidence_drafts" using primary key columns */
  unifiedEvidenceDraftsByPk?: Maybe<UnifiedEvidenceDrafts>;
  /** fetch data from the table: "user_groups" */
  userGroups: Array<UserGroups>;
  /** fetch aggregated fields from the table: "user_groups" */
  userGroupsAggregate: UserGroupsAggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  userGroupsByPk?: Maybe<UserGroups>;
  /** An array relationship */
  userProductRoles: Array<UserProductRoles>;
  /** An aggregate relationship */
  userProductRolesAggregate: UserProductRolesAggregate;
  /** fetch data from the table: "user_product_roles" using primary key columns */
  userProductRolesByPk?: Maybe<UserProductRoles>;
  /** fetch data from the table: "user_segments" */
  userSegments: Array<UserSegments>;
  /** fetch aggregated fields from the table: "user_segments" */
  userSegmentsAggregate: UserSegmentsAggregate;
  /** fetch data from the table: "user_segments" using primary key columns */
  userSegmentsByPk?: Maybe<UserSegments>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk?: Maybe<UserTenants>;
  /** An array relationship */
  userUserGroups: Array<UserUserGroups>;
  /** An aggregate relationship */
  userUserGroupsAggregate: UserUserGroupsAggregate;
  /** fetch data from the table: "user_user_groups" using primary key columns */
  userUserGroupsByPk?: Maybe<UserUserGroups>;
  /** An array relationship */
  userUserSegments: Array<UserUserSegments>;
  /** An aggregate relationship */
  userUserSegmentsAggregate: UserUserSegmentsAggregate;
  /** fetch data from the table: "user_user_segments" using primary key columns */
  userUserSegmentsByPk?: Maybe<UserUserSegments>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
};


export type Query_RootAreaCodesArgs = {
  distinctOn?: InputMaybe<Array<AreaCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AreaCodesOrderBy>>;
  where?: InputMaybe<AreaCodesBoolExp>;
};


export type Query_RootAreaCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AreaCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AreaCodesOrderBy>>;
  where?: InputMaybe<AreaCodesBoolExp>;
};


export type Query_RootAreaCodesByPkArgs = {
  countryId: Scalars['String']['input'];
};


export type Query_RootBatchChangeRequestReviewsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


export type Query_RootBatchChangeRequestReviewsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


export type Query_RootBatchChangeRequestReviewsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchChangeRequestReviewsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


export type Query_RootBatchChangeRequestReviewsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


export type Query_RootBatchChangeRequestReviewsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobRecordComposerDefinitionsByPkArgs = {
  batchChangeRequestsJobId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootBatchChangeRequestsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchChangeRequestsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


export type Query_RootBatchChangeRequestsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchEvidenceCommitsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


export type Query_RootBatchEvidenceCommitsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


export type Query_RootBatchEvidenceCommitsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchEvidenceCommitsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};


export type Query_RootBatchEvidenceCommitsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};


export type Query_RootBatchEvidenceCommitsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchEvidencesJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


export type Query_RootBatchEvidencesJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


export type Query_RootBatchEvidencesJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


export type Query_RootBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


export type Query_RootBatchEvidencesJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCategoriesArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


export type Query_RootCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


export type Query_RootCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCategoryPathsArgs = {
  distinctOn?: InputMaybe<Array<CategoryPathsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPathsOrderBy>>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};


export type Query_RootCategoryPathsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryPathsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPathsOrderBy>>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};


export type Query_RootCategoryPathsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


export type Query_RootCategoryPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


export type Query_RootCategoryPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


export type Query_RootCategoryPropertySchemaSetsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


export type Query_RootCategoryTypesArgs = {
  distinctOn?: InputMaybe<Array<CategoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryTypesOrderBy>>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};


export type Query_RootCategoryTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryTypesOrderBy>>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};


export type Query_RootCategoryTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootChangeRequestCommitsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};


export type Query_RootChangeRequestCommitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};


export type Query_RootChangeRequestCommitsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestItemCommitsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


export type Query_RootChangeRequestItemCommitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


export type Query_RootChangeRequestItemCommitsByPkArgs = {
  changeRequestCommitId: Scalars['uuid']['input'];
  changeRequestItemId: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestItemRecordMetadataArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


export type Query_RootChangeRequestItemRecordMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


export type Query_RootChangeRequestItemRecordMetadataByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestItemRecordsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


export type Query_RootChangeRequestItemRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


export type Query_RootChangeRequestItemRecordsByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestItemsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


export type Query_RootChangeRequestItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


export type Query_RootChangeRequestItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


export type Query_RootChangeRequestRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


export type Query_RootChangeRequestRecordComposerDefinitionsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestReviewTypesArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewTypesOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};


export type Query_RootChangeRequestReviewTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewTypesOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};


export type Query_RootChangeRequestReviewTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootChangeRequestReviewsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


export type Query_RootChangeRequestReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


export type Query_RootChangeRequestReviewsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootChangeRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestStatusesOrderBy>>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};


export type Query_RootChangeRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestStatusesOrderBy>>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};


export type Query_RootChangeRequestStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


export type Query_RootChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


export type Query_RootChangeRequestsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCnutExportBatchChangeRequestsJobDryRunResultArgs = {
  input: BatchChangeRequestsJobExportDryRunResultInput;
};


export type Query_RootCnutExportBatchEvidencesJobDryRunResultArgs = {
  input: BatchEvidencesJobExportDryRunResultInput;
};


export type Query_RootCnutFilterRecordIdsWithGeoItemsArgs = {
  input: RecordIdsWithGeoItemsFilterInput;
};


export type Query_RootCnutGetBatchChangeRequestReviewsJobDryRunResultArgs = {
  input: BatchChangeRequestReviewsJobGetDryRunResultInput;
};


export type Query_RootCnutGetBatchChangeRequestsJobDryRunResultArgs = {
  input: BatchChangeRequestsJobGetDryRunResultInput;
};


export type Query_RootCnutGetBatchEvidencesJobDryRunResultArgs = {
  input: BatchEvidencesJobGetDryRunResultInput;
};


export type Query_RootCnutGetCategoryPropertySchemasArgs = {
  input: GetCategoryPropertySchemasInput;
};


export type Query_RootCnutGetCompoundRecordComposerArgs = {
  input: CompoundRecordComposerGetInput;
};


export type Query_RootCnutGetCompoundRecordComposersArgs = {
  input: CompoundRecordComposersListInput;
};


export type Query_RootCnutGetCompoundRecordEvidencesArgs = {
  input: CompoundRecordEvidencesGetInput;
};


export type Query_RootCnutGetCompoundRecordEvidencesByCompoundRecordIdsArgs = {
  input: CompoundRecordEvidencesGetByCompoundRecordIdsInput;
};


export type Query_RootCnutGetDataImportJobDiagnosisArgs = {
  input: CnutGetDataImportJobDiagnosisInput;
};


export type Query_RootCnutGetDataSourceJsonDataArgs = {
  input: GetDataSourceJsonDataInput;
};


export type Query_RootCnutGetDataSourceJsonPresignedUrlArgs = {
  input: GetDataSourceJsonPresignedUrlInput;
};


export type Query_RootCnutGetDataSourceStatsArgs = {
  input: GetDataSourceStatsInput;
};


export type Query_RootCnutGetEvidenceSetPreviewArgs = {
  input: EvidenceSetPreviewInput;
};


export type Query_RootCnutGetGeoItemArgs = {
  input: GeoItemGetInput;
};


export type Query_RootCnutGetJobLogPresignedUrlArgs = {
  input: GetJobLogPresignedUrlInput;
};


export type Query_RootCnutGetPublishedRecordGeoItemsByRecordArgs = {
  input: RecordGeoItemsByRecordInput;
};


export type Query_RootCnutGetRecordCompoundRecordComposersArgs = {
  input: RecordCompoundRecordComposersListInput;
};


export type Query_RootCnutGetRecordGeoItemDetailArgs = {
  input: RecordGeoItemDetailInput;
};


export type Query_RootCnutGetRecordGeoItemsByRecordArgs = {
  input: RecordGeoItemsByRecordInput;
};


export type Query_RootCnutGetRecordGeoItemsByRecordIdsArgs = {
  input: RecordGeoItemsByRecordIdsInput;
};


export type Query_RootCnutGetRecordUpdateDataImportProjectTargetsArgs = {
  input: RecordUpdateTargetsInput;
};


export type Query_RootCnutGetReferenceFileImagePresignedUrlArgs = {
  input: ReferenceFileImagePresignedUrlInput;
};


export type Query_RootCnutGetReferenceFileUrlArgs = {
  input: ReferenceFileUrlInput;
};


export type Query_RootCnutGetTenantMemberPhotosArgs = {
  input: TenantMemberPhotosInput;
};


export type Query_RootCnutGetUserArgs = {
  id: Scalars['UUID']['input'];
};


export type Query_RootCnutListCategoriesArgs = {
  input: ListCategoriesInput;
};


export type Query_RootCnutListCategorySchemaMigrationsArgs = {
  input: ListCategorySchemaMigrationsInput;
};


export type Query_RootCnutListDataImportJobDiagnosesArgs = {
  input: CnutListDataImportJobDiagnosesInput;
};


export type Query_RootCnutListDataSourceColumnNamesArgs = {
  input: ListDataSourceColumnNamesInput;
};


export type Query_RootCnutListDataSourceSheetsArgs = {
  input: ListDataSourceSheetsInput;
};


export type Query_RootCnutListEffectiveCategoryPropertySchemasArgs = {
  input: ListEffectiveCategoryPropertySchemasInput;
};


export type Query_RootCnutListRecordIdsWithGeoItemsArgs = {
  input: RecordIdsWithGeoItemsListInput;
};


export type Query_RootCnutListUserGroupsArgs = {
  input?: InputMaybe<UserGroupListInput>;
};


export type Query_RootCnutListWorkerCommandsArgs = {
  lang?: InputMaybe<LabelLocale>;
};


export type Query_RootCnutPrepareRecordUpdateDataImportProjectArgs = {
  input: RecordUpdatePreviewInput;
};


export type Query_RootCnutSearchEntitiesArgs = {
  input: SearchEntitiesInput;
};


export type Query_RootCnutSearchGeoItemsArgs = {
  input: GeoItemSearchInput;
};


export type Query_RootCnutValidateWorkerJobRerunArgs = {
  input: ValidateWorkerJobRerunInput;
};


export type Query_RootCompoundCompoundRecordsArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


export type Query_RootCompoundCompoundRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


export type Query_RootCompoundCompoundRecordsByPkArgs = {
  key: Scalars['String']['input'];
  v: Scalars['String']['input'];
};


export type Query_RootCompoundRecordComposersArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordComposersOrderBy>>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};


export type Query_RootCompoundRecordComposersAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordComposersOrderBy>>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};


export type Query_RootCompoundRecordComposersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCompoundRecordVersionsArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordVersionsOrderBy>>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};


export type Query_RootCompoundRecordVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordVersionsOrderBy>>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};


export type Query_RootCompoundRecordVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Query_RootCountriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Query_RootCountriesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Query_RootCountrySubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Query_RootCountrySubdivisionsByPkArgs = {
  code: Scalars['String']['input'];
};


export type Query_RootDataImportProjectRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Query_RootDataImportProjectRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Query_RootDataImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootDataImportProjectStatusLogsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


export type Query_RootDataImportProjectStatusLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


export type Query_RootDataImportProjectStatusLogsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDataImportProjectStatusesArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusesOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};


export type Query_RootDataImportProjectStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusesOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};


export type Query_RootDataImportProjectStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootDataImportProjectUsersArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


export type Query_RootDataImportProjectUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


export type Query_RootDataImportProjectUsersByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootDataImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectsOrderBy>>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};


export type Query_RootDataImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectsOrderBy>>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};


export type Query_RootDataImportProjectsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDataSourceGsheetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceGsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceGsheetsOrderBy>>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};


export type Query_RootDataSourceGsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceGsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceGsheetsOrderBy>>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};


export type Query_RootDataSourceGsheetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceImportProjectRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Query_RootDataSourceImportProjectRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Query_RootDataSourceImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


export type Query_RootDataSourceImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


export type Query_RootDataSourceImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceJsonsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceJsonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceJsonsOrderBy>>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};


export type Query_RootDataSourceJsonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceJsonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceJsonsOrderBy>>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};


export type Query_RootDataSourceJsonsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Query_RootDataSourcePropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


export type Query_RootDataSourcePropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


export type Query_RootDataSourcePropertySchemaSetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceReferencesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


export type Query_RootDataSourceReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


export type Query_RootDataSourceReferencesByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceTemplatePropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


export type Query_RootDataSourceTemplatePropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


export type Query_RootDataSourceTemplatePropertySchemaSetsByPkArgs = {
  dataSourceTemplateId: Scalars['uuid']['input'];
};


export type Query_RootDataSourceTemplatesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatesOrderBy>>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};


export type Query_RootDataSourceTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatesOrderBy>>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};


export type Query_RootDataSourceTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDataSourcesArgs = {
  distinctOn?: InputMaybe<Array<DataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
  where?: InputMaybe<DataSourcesBoolExp>;
};


export type Query_RootDataSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
  where?: InputMaybe<DataSourcesBoolExp>;
};


export type Query_RootDataSourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDbpjkitWorkerJobRunsArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


export type Query_RootDbpjkitWorkerJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


export type Query_RootDbpjkitWorkerJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootDbpjkitWorkerJobsArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};


export type Query_RootDbpjkitWorkerJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};


export type Query_RootDbpjkitWorkerJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEntityRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};


export type Query_RootEntityRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};


export type Query_RootEntityRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootEntityRecordsArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordsOrderBy>>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};


export type Query_RootEntityRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordsOrderBy>>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};


export type Query_RootEntityRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


export type Query_RootEvidenceChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


export type Query_RootEvidenceChangeRequestsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
  evidenceId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


export type Query_RootEvidenceEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


export type Query_RootEvidenceEvidenceSetsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceImportersArgs = {
  distinctOn?: InputMaybe<Array<EvidenceImportersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceImportersOrderBy>>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};


export type Query_RootEvidenceImportersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceImportersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceImportersOrderBy>>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};


export type Query_RootEvidenceImportersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvidenceRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


export type Query_RootEvidenceRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


export type Query_RootEvidenceRecordGeoItemsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceSetImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


export type Query_RootEvidenceSetImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


export type Query_RootEvidenceSetImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceSetPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};


export type Query_RootEvidenceSetPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};


export type Query_RootEvidenceSetPropertySchemaSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
};


export type Query_RootEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};


export type Query_RootEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};


export type Query_RootEvidenceSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvidenceVersionsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


export type Query_RootEvidenceVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


export type Query_RootEvidenceVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


export type Query_RootEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


export type Query_RootEvidencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootGetBatchChangeRequestJobDryRunResultUrlArgs = {
  input: GetBatchChangeRequestJobDryRunResultUrlInput;
};


export type Query_RootGetBatchEvidenceJobDryRunResultUrlArgs = {
  input: GetBatchEvidenceJobDryRunResultUrlInput;
};


export type Query_RootJobRunStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobRunStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobRunStatusesOrderBy>>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};


export type Query_RootJobRunStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobRunStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobRunStatusesOrderBy>>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};


export type Query_RootJobRunStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOrganizationKindsArgs = {
  distinctOn?: InputMaybe<Array<OrganizationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationKindsOrderBy>>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};


export type Query_RootOrganizationKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationKindsOrderBy>>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};


export type Query_RootOrganizationKindsByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type Query_RootOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type Query_RootOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootProductRolesArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


export type Query_RootProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


export type Query_RootProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
};


export type Query_RootProductsArgs = {
  distinctOn?: InputMaybe<Array<ProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
  where?: InputMaybe<ProductsBoolExp>;
};


export type Query_RootProductsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
  where?: InputMaybe<ProductsBoolExp>;
};


export type Query_RootProductsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPropertySchemaAssociationsArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


export type Query_RootPropertySchemaAssociationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


export type Query_RootPropertySchemaAssociationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaSetsOrderBy>>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};


export type Query_RootPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaSetsOrderBy>>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};


export type Query_RootPropertySchemaSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPropertySchemasArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemasOrderBy>>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};


export type Query_RootPropertySchemasAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemasOrderBy>>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};


export type Query_RootPropertySchemasByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootPropertyTypesArgs = {
  distinctOn?: InputMaybe<Array<PropertyTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};


export type Query_RootPropertyTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertyTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};


export type Query_RootPropertyTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Query_RootPublishersArgs = {
  distinctOn?: InputMaybe<Array<PublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublishersOrderBy>>;
  where?: InputMaybe<PublishersBoolExp>;
};


export type Query_RootPublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublishersOrderBy>>;
  where?: InputMaybe<PublishersBoolExp>;
};


export type Query_RootPublishersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecordComposerDefinitionEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


export type Query_RootRecordComposerDefinitionEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


export type Query_RootRecordComposerDefinitionEvidenceSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootRecordComposerDefinitionPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordComposerDefinitionPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordComposerDefinitionPropertySchemaSetsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};


export type Query_RootRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};


export type Query_RootRecordComposerDefinitionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecordCompoundRecordComposersArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


export type Query_RootRecordCompoundRecordComposersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


export type Query_RootRecordCompoundRecordComposersByPkArgs = {
  compoundRecordComposerId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Query_RootRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


export type Query_RootRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


export type Query_RootRecordGeoItemsByPkArgs = {
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Query_RootRecordMetadataArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataOrderBy>>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};


export type Query_RootRecordMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataOrderBy>>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};


export type Query_RootRecordMetadataByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRecordMetadataCategoriesArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


export type Query_RootRecordMetadataCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


export type Query_RootRecordMetadataCategoriesByPkArgs = {
  categoryId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


export type Query_RootRecordMetadataPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordMetadataPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordMetadataPropertySchemaSetsByPkArgs = {
  propertySchemaSetId: Scalars['uuid']['input'];
};


export type Query_RootRecordPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


export type Query_RootRecordPropertySchemaSetsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Query_RootRecordUpdateRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};


export type Query_RootRecordUpdateRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};


export type Query_RootRecordUpdateRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootRecordsArgs = {
  distinctOn?: InputMaybe<Array<RecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordsOrderBy>>;
  where?: InputMaybe<RecordsBoolExp>;
};


export type Query_RootRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordsOrderBy>>;
  where?: InputMaybe<RecordsBoolExp>;
};


export type Query_RootRecordsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReferenceFilesArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


export type Query_RootReferenceFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


export type Query_RootReferenceFilesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootReferencePublishersArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


export type Query_RootReferencePublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


export type Query_RootReferencePublishersByPkArgs = {
  publisherId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


export type Query_RootReferencesArgs = {
  distinctOn?: InputMaybe<Array<ReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencesOrderBy>>;
  where?: InputMaybe<ReferencesBoolExp>;
};


export type Query_RootReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencesOrderBy>>;
  where?: InputMaybe<ReferencesBoolExp>;
};


export type Query_RootReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRelationRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};


export type Query_RootRelationRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};


export type Query_RootRelationRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Query_RootRelationRecordsArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordsOrderBy>>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};


export type Query_RootRelationRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordsOrderBy>>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};


export type Query_RootRelationRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Query_RootRelationTypesArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


export type Query_RootRelationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


export type Query_RootRelationTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootRolesArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type Query_RootRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type Query_RootRolesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootSourceRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


export type Query_RootSourceRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


export type Query_RootSourceRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


export type Query_RootTargetRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


export type Query_RootTargetRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


export type Query_RootTargetRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


export type Query_RootTenantProductInstallationsArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


export type Query_RootTenantProductInstallationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


export type Query_RootTenantProductInstallationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Query_RootTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Query_RootTenantsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUnifiedEvidenceDraftsArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


export type Query_RootUnifiedEvidenceDraftsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


export type Query_RootUnifiedEvidenceDraftsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserGroupsArgs = {
  distinctOn?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type Query_RootUserGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type Query_RootUserGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Query_RootUserProductRolesArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


export type Query_RootUserProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


export type Query_RootUserProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserSegmentsArgs = {
  distinctOn?: InputMaybe<Array<UserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSegmentsOrderBy>>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};


export type Query_RootUserSegmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSegmentsOrderBy>>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};


export type Query_RootUserSegmentsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Query_RootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Query_RootUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Query_RootUserTenantsByPkArgs = {
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserUserGroupsArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


export type Query_RootUserUserGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


export type Query_RootUserUserGroupsByPkArgs = {
  userGroupId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Query_RootUserUserSegmentsArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


export type Query_RootUserUserSegmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


export type Query_RootUserUserSegmentsByPkArgs = {
  userId: Scalars['uuid']['input'];
  userSegmentId: Scalars['Int']['input'];
};


export type Query_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Query_RootUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};

export type RecordComposerDefinitionEvidenceSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type RecordComposerDefinitionPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type RecordCompoundRecordComposersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
  predicate: IntComparisonExp;
};

export type RecordGeoItemsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordGeoItemsBoolExp>;
  predicate: IntComparisonExp;
};

export type RecordMetadataCategoriesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordMetadataCategoriesBoolExp>;
  predicate: IntComparisonExp;
};

export type RecordPropertySchemaSetsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
  predicate: IntComparisonExp;
};

export type ReferenceFilesAggregateBoolExpBool_And = {
  arguments: ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReferenceFilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReferenceFilesAggregateBoolExpBool_Or = {
  arguments: ReferenceFilesSelectColumnReferenceFilesAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReferenceFilesBoolExp>;
  predicate: BooleanComparisonExp;
};

export type ReferenceFilesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReferenceFilesBoolExp>;
  predicate: IntComparisonExp;
};

export type ReferencePublishersAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<ReferencePublishersBoolExp>;
  predicate: IntComparisonExp;
};

export type RelationTypesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<RelationTypesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<RelationTypesBoolExp>;
  predicate: IntComparisonExp;
};

export type SourceRecordEdgesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<SourceRecordEdgesBoolExp>;
  predicate: IntComparisonExp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "area_codes" */
  areaCodes: Array<AreaCodes>;
  /** fetch aggregated fields from the table: "area_codes" */
  areaCodesAggregate: AreaCodesAggregate;
  /** fetch data from the table: "area_codes" using primary key columns */
  areaCodesByPk?: Maybe<AreaCodes>;
  /** fetch data from the table in a streaming manner: "area_codes" */
  areaCodesStream: Array<AreaCodes>;
  /** An array relationship */
  batchChangeRequestReviewsJobRuns: Array<BatchChangeRequestReviewsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobRunsAggregate: BatchChangeRequestReviewsJobRunsAggregate;
  /** fetch data from the table: "batch_change_request_reviews_job_runs" using primary key columns */
  batchChangeRequestReviewsJobRunsByPk?: Maybe<BatchChangeRequestReviewsJobRuns>;
  /** fetch data from the table in a streaming manner: "batch_change_request_reviews_job_runs" */
  batchChangeRequestReviewsJobRunsStream: Array<BatchChangeRequestReviewsJobRuns>;
  /** An array relationship */
  batchChangeRequestReviewsJobs: Array<BatchChangeRequestReviewsJobs>;
  /** An aggregate relationship */
  batchChangeRequestReviewsJobsAggregate: BatchChangeRequestReviewsJobsAggregate;
  /** fetch data from the table: "batch_change_request_reviews_jobs" using primary key columns */
  batchChangeRequestReviewsJobsByPk?: Maybe<BatchChangeRequestReviewsJobs>;
  /** fetch data from the table in a streaming manner: "batch_change_request_reviews_jobs" */
  batchChangeRequestReviewsJobsStream: Array<BatchChangeRequestReviewsJobs>;
  /** An array relationship */
  batchChangeRequestsJobRecordComposerDefinitions: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An aggregate relationship */
  batchChangeRequestsJobRecordComposerDefinitionsAggregate: BatchChangeRequestsJobRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "batch_change_requests_job_record_composer_definitions" using primary key columns */
  batchChangeRequestsJobRecordComposerDefinitionsByPk?: Maybe<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "batch_change_requests_job_record_composer_definitions" */
  batchChangeRequestsJobRecordComposerDefinitionsStream: Array<BatchChangeRequestsJobRecordComposerDefinitions>;
  /** An array relationship */
  batchChangeRequestsJobRuns: Array<BatchChangeRequestsJobRuns>;
  /** An aggregate relationship */
  batchChangeRequestsJobRunsAggregate: BatchChangeRequestsJobRunsAggregate;
  /** fetch data from the table: "batch_change_requests_job_runs" using primary key columns */
  batchChangeRequestsJobRunsByPk?: Maybe<BatchChangeRequestsJobRuns>;
  /** fetch data from the table in a streaming manner: "batch_change_requests_job_runs" */
  batchChangeRequestsJobRunsStream: Array<BatchChangeRequestsJobRuns>;
  /** An array relationship */
  batchChangeRequestsJobs: Array<BatchChangeRequestsJobs>;
  /** An aggregate relationship */
  batchChangeRequestsJobsAggregate: BatchChangeRequestsJobsAggregate;
  /** fetch data from the table: "batch_change_requests_jobs" using primary key columns */
  batchChangeRequestsJobsByPk?: Maybe<BatchChangeRequestsJobs>;
  /** fetch data from the table in a streaming manner: "batch_change_requests_jobs" */
  batchChangeRequestsJobsStream: Array<BatchChangeRequestsJobs>;
  /** An array relationship */
  batchEvidenceCommitsJobRuns: Array<BatchEvidenceCommitsJobRuns>;
  /** An aggregate relationship */
  batchEvidenceCommitsJobRunsAggregate: BatchEvidenceCommitsJobRunsAggregate;
  /** fetch data from the table: "batch_evidence_commits_job_runs" using primary key columns */
  batchEvidenceCommitsJobRunsByPk?: Maybe<BatchEvidenceCommitsJobRuns>;
  /** fetch data from the table in a streaming manner: "batch_evidence_commits_job_runs" */
  batchEvidenceCommitsJobRunsStream: Array<BatchEvidenceCommitsJobRuns>;
  /** fetch data from the table: "batch_evidence_commits_jobs" */
  batchEvidenceCommitsJobs: Array<BatchEvidenceCommitsJobs>;
  /** fetch aggregated fields from the table: "batch_evidence_commits_jobs" */
  batchEvidenceCommitsJobsAggregate: BatchEvidenceCommitsJobsAggregate;
  /** fetch data from the table: "batch_evidence_commits_jobs" using primary key columns */
  batchEvidenceCommitsJobsByPk?: Maybe<BatchEvidenceCommitsJobs>;
  /** fetch data from the table in a streaming manner: "batch_evidence_commits_jobs" */
  batchEvidenceCommitsJobsStream: Array<BatchEvidenceCommitsJobs>;
  /** An array relationship */
  batchEvidencesJobRuns: Array<BatchEvidencesJobRuns>;
  /** An aggregate relationship */
  batchEvidencesJobRunsAggregate: BatchEvidencesJobRunsAggregate;
  /** fetch data from the table: "batch_evidences_job_runs" using primary key columns */
  batchEvidencesJobRunsByPk?: Maybe<BatchEvidencesJobRuns>;
  /** fetch data from the table in a streaming manner: "batch_evidences_job_runs" */
  batchEvidencesJobRunsStream: Array<BatchEvidencesJobRuns>;
  /** An array relationship */
  batchEvidencesJobs: Array<BatchEvidencesJobs>;
  /** An aggregate relationship */
  batchEvidencesJobsAggregate: BatchEvidencesJobsAggregate;
  /** fetch data from the table: "batch_evidences_jobs" using primary key columns */
  batchEvidencesJobsByPk?: Maybe<BatchEvidencesJobs>;
  /** fetch data from the table in a streaming manner: "batch_evidences_jobs" */
  batchEvidencesJobsStream: Array<BatchEvidencesJobs>;
  /** An array relationship */
  categories: Array<Categories>;
  /** An aggregate relationship */
  categoriesAggregate: CategoriesAggregate;
  /** fetch data from the table: "categories" using primary key columns */
  categoriesByPk?: Maybe<Categories>;
  /** fetch data from the table in a streaming manner: "categories" */
  categoriesStream: Array<Categories>;
  /** fetch data from the table: "category_paths" */
  categoryPaths: Array<CategoryPaths>;
  /** fetch aggregated fields from the table: "category_paths" */
  categoryPathsAggregate: CategoryPathsAggregate;
  /** fetch data from the table: "category_paths" using primary key columns */
  categoryPathsByPk?: Maybe<CategoryPaths>;
  /** fetch data from the table in a streaming manner: "category_paths" */
  categoryPathsStream: Array<CategoryPaths>;
  /** fetch data from the table: "category_property_schema_sets" */
  categoryPropertySchemaSets: Array<CategoryPropertySchemaSets>;
  /** fetch aggregated fields from the table: "category_property_schema_sets" */
  categoryPropertySchemaSetsAggregate: CategoryPropertySchemaSetsAggregate;
  /** fetch data from the table: "category_property_schema_sets" using primary key columns */
  categoryPropertySchemaSetsByPk?: Maybe<CategoryPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "category_property_schema_sets" */
  categoryPropertySchemaSetsStream: Array<CategoryPropertySchemaSets>;
  /** fetch data from the table: "category_types" */
  categoryTypes: Array<CategoryTypes>;
  /** fetch aggregated fields from the table: "category_types" */
  categoryTypesAggregate: CategoryTypesAggregate;
  /** fetch data from the table: "category_types" using primary key columns */
  categoryTypesByPk?: Maybe<CategoryTypes>;
  /** fetch data from the table in a streaming manner: "category_types" */
  categoryTypesStream: Array<CategoryTypes>;
  /** fetch data from the table: "change_request_commits" */
  changeRequestCommits: Array<ChangeRequestCommits>;
  /** fetch aggregated fields from the table: "change_request_commits" */
  changeRequestCommitsAggregate: ChangeRequestCommitsAggregate;
  /** fetch data from the table: "change_request_commits" using primary key columns */
  changeRequestCommitsByPk?: Maybe<ChangeRequestCommits>;
  /** fetch data from the table in a streaming manner: "change_request_commits" */
  changeRequestCommitsStream: Array<ChangeRequestCommits>;
  /** fetch data from the table: "change_request_item_commits" */
  changeRequestItemCommits: Array<ChangeRequestItemCommits>;
  /** fetch aggregated fields from the table: "change_request_item_commits" */
  changeRequestItemCommitsAggregate: ChangeRequestItemCommitsAggregate;
  /** fetch data from the table: "change_request_item_commits" using primary key columns */
  changeRequestItemCommitsByPk?: Maybe<ChangeRequestItemCommits>;
  /** fetch data from the table in a streaming manner: "change_request_item_commits" */
  changeRequestItemCommitsStream: Array<ChangeRequestItemCommits>;
  /** An array relationship */
  changeRequestItemRecordMetadata: Array<ChangeRequestItemRecordMetadata>;
  /** An aggregate relationship */
  changeRequestItemRecordMetadataAggregate: ChangeRequestItemRecordMetadataAggregate;
  /** fetch data from the table: "change_request_item_record_metadata" using primary key columns */
  changeRequestItemRecordMetadataByPk?: Maybe<ChangeRequestItemRecordMetadata>;
  /** fetch data from the table in a streaming manner: "change_request_item_record_metadata" */
  changeRequestItemRecordMetadataStream: Array<ChangeRequestItemRecordMetadata>;
  /** An array relationship */
  changeRequestItemRecords: Array<ChangeRequestItemRecords>;
  /** An aggregate relationship */
  changeRequestItemRecordsAggregate: ChangeRequestItemRecordsAggregate;
  /** fetch data from the table: "change_request_item_records" using primary key columns */
  changeRequestItemRecordsByPk?: Maybe<ChangeRequestItemRecords>;
  /** fetch data from the table in a streaming manner: "change_request_item_records" */
  changeRequestItemRecordsStream: Array<ChangeRequestItemRecords>;
  /** fetch data from the table: "change_request_items" */
  changeRequestItems: Array<ChangeRequestItems>;
  /** fetch aggregated fields from the table: "change_request_items" */
  changeRequestItemsAggregate: ChangeRequestItemsAggregate;
  /** fetch data from the table: "change_request_items" using primary key columns */
  changeRequestItemsByPk?: Maybe<ChangeRequestItems>;
  /** fetch data from the table in a streaming manner: "change_request_items" */
  changeRequestItemsStream: Array<ChangeRequestItems>;
  /** An array relationship */
  changeRequestRecordComposerDefinitions: Array<ChangeRequestRecordComposerDefinitions>;
  /** An aggregate relationship */
  changeRequestRecordComposerDefinitionsAggregate: ChangeRequestRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "change_request_record_composer_definitions" using primary key columns */
  changeRequestRecordComposerDefinitionsByPk?: Maybe<ChangeRequestRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "change_request_record_composer_definitions" */
  changeRequestRecordComposerDefinitionsStream: Array<ChangeRequestRecordComposerDefinitions>;
  /** fetch data from the table: "change_request_review_types" */
  changeRequestReviewTypes: Array<ChangeRequestReviewTypes>;
  /** fetch aggregated fields from the table: "change_request_review_types" */
  changeRequestReviewTypesAggregate: ChangeRequestReviewTypesAggregate;
  /** fetch data from the table: "change_request_review_types" using primary key columns */
  changeRequestReviewTypesByPk?: Maybe<ChangeRequestReviewTypes>;
  /** fetch data from the table in a streaming manner: "change_request_review_types" */
  changeRequestReviewTypesStream: Array<ChangeRequestReviewTypes>;
  /** fetch data from the table: "change_request_reviews" */
  changeRequestReviews: Array<ChangeRequestReviews>;
  /** fetch aggregated fields from the table: "change_request_reviews" */
  changeRequestReviewsAggregate: ChangeRequestReviewsAggregate;
  /** fetch data from the table: "change_request_reviews" using primary key columns */
  changeRequestReviewsByPk?: Maybe<ChangeRequestReviews>;
  /** fetch data from the table in a streaming manner: "change_request_reviews" */
  changeRequestReviewsStream: Array<ChangeRequestReviews>;
  /** fetch data from the table: "change_request_statuses" */
  changeRequestStatuses: Array<ChangeRequestStatuses>;
  /** fetch aggregated fields from the table: "change_request_statuses" */
  changeRequestStatusesAggregate: ChangeRequestStatusesAggregate;
  /** fetch data from the table: "change_request_statuses" using primary key columns */
  changeRequestStatusesByPk?: Maybe<ChangeRequestStatuses>;
  /** fetch data from the table in a streaming manner: "change_request_statuses" */
  changeRequestStatusesStream: Array<ChangeRequestStatuses>;
  /** An array relationship */
  changeRequests: Array<ChangeRequests>;
  /** An aggregate relationship */
  changeRequestsAggregate: ChangeRequestsAggregate;
  /** fetch data from the table: "change_requests" using primary key columns */
  changeRequestsByPk?: Maybe<ChangeRequests>;
  /** fetch data from the table in a streaming manner: "change_requests" */
  changeRequestsStream: Array<ChangeRequests>;
  /** fetch data from the table: "compound.compound_records" */
  compoundCompoundRecords: Array<CompoundCompoundRecords>;
  /** fetch aggregated fields from the table: "compound.compound_records" */
  compoundCompoundRecordsAggregate: CompoundCompoundRecordsAggregate;
  /** fetch data from the table: "compound.compound_records" using primary key columns */
  compoundCompoundRecordsByPk?: Maybe<CompoundCompoundRecords>;
  /** fetch data from the table in a streaming manner: "compound.compound_records" */
  compoundCompoundRecordsStream: Array<CompoundCompoundRecords>;
  /** fetch data from the table: "compound_record_composers" */
  compoundRecordComposers: Array<CompoundRecordComposers>;
  /** fetch aggregated fields from the table: "compound_record_composers" */
  compoundRecordComposersAggregate: CompoundRecordComposersAggregate;
  /** fetch data from the table: "compound_record_composers" using primary key columns */
  compoundRecordComposersByPk?: Maybe<CompoundRecordComposers>;
  /** fetch data from the table in a streaming manner: "compound_record_composers" */
  compoundRecordComposersStream: Array<CompoundRecordComposers>;
  /** fetch data from the table: "compound_record_versions" */
  compoundRecordVersions: Array<CompoundRecordVersions>;
  /** fetch aggregated fields from the table: "compound_record_versions" */
  compoundRecordVersionsAggregate: CompoundRecordVersionsAggregate;
  /** fetch data from the table: "compound_record_versions" using primary key columns */
  compoundRecordVersionsByPk?: Maybe<CompoundRecordVersions>;
  /** fetch data from the table in a streaming manner: "compound_record_versions" */
  compoundRecordVersionsStream: Array<CompoundRecordVersions>;
  /** fetch data from the table: "countries" */
  countries: Array<Countries>;
  /** fetch aggregated fields from the table: "countries" */
  countriesAggregate: CountriesAggregate;
  /** fetch data from the table: "countries" using primary key columns */
  countriesByPk?: Maybe<Countries>;
  /** fetch data from the table in a streaming manner: "countries" */
  countriesStream: Array<Countries>;
  /** An array relationship */
  countrySubdivisions: Array<CountrySubdivisions>;
  /** An aggregate relationship */
  countrySubdivisionsAggregate: CountrySubdivisionsAggregate;
  /** fetch data from the table: "country_subdivisions" using primary key columns */
  countrySubdivisionsByPk?: Maybe<CountrySubdivisions>;
  /** fetch data from the table in a streaming manner: "country_subdivisions" */
  countrySubdivisionsStream: Array<CountrySubdivisions>;
  /** fetch data from the table: "data_import_project_record_composer_definitions" */
  dataImportProjectRecordComposerDefinitions: Array<DataImportProjectRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "data_import_project_record_composer_definitions" */
  dataImportProjectRecordComposerDefinitionsAggregate: DataImportProjectRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "data_import_project_record_composer_definitions" using primary key columns */
  dataImportProjectRecordComposerDefinitionsByPk?: Maybe<DataImportProjectRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "data_import_project_record_composer_definitions" */
  dataImportProjectRecordComposerDefinitionsStream: Array<DataImportProjectRecordComposerDefinitions>;
  /** An array relationship */
  dataImportProjectStatusLogs: Array<DataImportProjectStatusLogs>;
  /** An aggregate relationship */
  dataImportProjectStatusLogsAggregate: DataImportProjectStatusLogsAggregate;
  /** fetch data from the table: "data_import_project_status_logs" using primary key columns */
  dataImportProjectStatusLogsByPk?: Maybe<DataImportProjectStatusLogs>;
  /** fetch data from the table in a streaming manner: "data_import_project_status_logs" */
  dataImportProjectStatusLogsStream: Array<DataImportProjectStatusLogs>;
  /** fetch data from the table: "data_import_project_statuses" */
  dataImportProjectStatuses: Array<DataImportProjectStatuses>;
  /** fetch aggregated fields from the table: "data_import_project_statuses" */
  dataImportProjectStatusesAggregate: DataImportProjectStatusesAggregate;
  /** fetch data from the table: "data_import_project_statuses" using primary key columns */
  dataImportProjectStatusesByPk?: Maybe<DataImportProjectStatuses>;
  /** fetch data from the table in a streaming manner: "data_import_project_statuses" */
  dataImportProjectStatusesStream: Array<DataImportProjectStatuses>;
  /** An array relationship */
  dataImportProjectUsers: Array<DataImportProjectUsers>;
  /** An aggregate relationship */
  dataImportProjectUsersAggregate: DataImportProjectUsersAggregate;
  /** fetch data from the table: "data_import_project_users" using primary key columns */
  dataImportProjectUsersByPk?: Maybe<DataImportProjectUsers>;
  /** fetch data from the table in a streaming manner: "data_import_project_users" */
  dataImportProjectUsersStream: Array<DataImportProjectUsers>;
  /** fetch data from the table: "data_import_projects" */
  dataImportProjects: Array<DataImportProjects>;
  /** fetch aggregated fields from the table: "data_import_projects" */
  dataImportProjectsAggregate: DataImportProjectsAggregate;
  /** fetch data from the table: "data_import_projects" using primary key columns */
  dataImportProjectsByPk?: Maybe<DataImportProjects>;
  /** fetch data from the table in a streaming manner: "data_import_projects" */
  dataImportProjectsStream: Array<DataImportProjects>;
  /** fetch data from the table: "data_source_gsheets" */
  dataSourceGsheets: Array<DataSourceGsheets>;
  /** fetch aggregated fields from the table: "data_source_gsheets" */
  dataSourceGsheetsAggregate: DataSourceGsheetsAggregate;
  /** fetch data from the table: "data_source_gsheets" using primary key columns */
  dataSourceGsheetsByPk?: Maybe<DataSourceGsheets>;
  /** fetch data from the table in a streaming manner: "data_source_gsheets" */
  dataSourceGsheetsStream: Array<DataSourceGsheets>;
  /** fetch data from the table: "data_source_import_project_record_composer_definitions" */
  dataSourceImportProjectRecordComposerDefinitions: Array<DataSourceImportProjectRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "data_source_import_project_record_composer_definitions" */
  dataSourceImportProjectRecordComposerDefinitionsAggregate: DataSourceImportProjectRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "data_source_import_project_record_composer_definitions" using primary key columns */
  dataSourceImportProjectRecordComposerDefinitionsByPk?: Maybe<DataSourceImportProjectRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "data_source_import_project_record_composer_definitions" */
  dataSourceImportProjectRecordComposerDefinitionsStream: Array<DataSourceImportProjectRecordComposerDefinitions>;
  /** An array relationship */
  dataSourceImportProjects: Array<DataSourceImportProjects>;
  /** An aggregate relationship */
  dataSourceImportProjectsAggregate: DataSourceImportProjectsAggregate;
  /** fetch data from the table: "data_source_import_projects" using primary key columns */
  dataSourceImportProjectsByPk?: Maybe<DataSourceImportProjects>;
  /** fetch data from the table in a streaming manner: "data_source_import_projects" */
  dataSourceImportProjectsStream: Array<DataSourceImportProjects>;
  /** fetch data from the table: "data_source_jsons" */
  dataSourceJsons: Array<DataSourceJsons>;
  /** fetch aggregated fields from the table: "data_source_jsons" */
  dataSourceJsonsAggregate: DataSourceJsonsAggregate;
  /** fetch data from the table: "data_source_jsons" using primary key columns */
  dataSourceJsonsByPk?: Maybe<DataSourceJsons>;
  /** fetch data from the table in a streaming manner: "data_source_jsons" */
  dataSourceJsonsStream: Array<DataSourceJsons>;
  /** fetch data from the table: "data_source_property_schema_sets" */
  dataSourcePropertySchemaSets: Array<DataSourcePropertySchemaSets>;
  /** fetch aggregated fields from the table: "data_source_property_schema_sets" */
  dataSourcePropertySchemaSetsAggregate: DataSourcePropertySchemaSetsAggregate;
  /** fetch data from the table: "data_source_property_schema_sets" using primary key columns */
  dataSourcePropertySchemaSetsByPk?: Maybe<DataSourcePropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "data_source_property_schema_sets" */
  dataSourcePropertySchemaSetsStream: Array<DataSourcePropertySchemaSets>;
  /** An array relationship */
  dataSourceReferences: Array<DataSourceReferences>;
  /** An aggregate relationship */
  dataSourceReferencesAggregate: DataSourceReferencesAggregate;
  /** fetch data from the table: "data_source_references" using primary key columns */
  dataSourceReferencesByPk?: Maybe<DataSourceReferences>;
  /** fetch data from the table in a streaming manner: "data_source_references" */
  dataSourceReferencesStream: Array<DataSourceReferences>;
  /** fetch data from the table: "data_source_template_property_schema_sets" */
  dataSourceTemplatePropertySchemaSets: Array<DataSourceTemplatePropertySchemaSets>;
  /** fetch aggregated fields from the table: "data_source_template_property_schema_sets" */
  dataSourceTemplatePropertySchemaSetsAggregate: DataSourceTemplatePropertySchemaSetsAggregate;
  /** fetch data from the table: "data_source_template_property_schema_sets" using primary key columns */
  dataSourceTemplatePropertySchemaSetsByPk?: Maybe<DataSourceTemplatePropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "data_source_template_property_schema_sets" */
  dataSourceTemplatePropertySchemaSetsStream: Array<DataSourceTemplatePropertySchemaSets>;
  /** fetch data from the table: "data_source_templates" */
  dataSourceTemplates: Array<DataSourceTemplates>;
  /** fetch aggregated fields from the table: "data_source_templates" */
  dataSourceTemplatesAggregate: DataSourceTemplatesAggregate;
  /** fetch data from the table: "data_source_templates" using primary key columns */
  dataSourceTemplatesByPk?: Maybe<DataSourceTemplates>;
  /** fetch data from the table in a streaming manner: "data_source_templates" */
  dataSourceTemplatesStream: Array<DataSourceTemplates>;
  /** fetch data from the table: "data_sources" */
  dataSources: Array<DataSources>;
  /** fetch aggregated fields from the table: "data_sources" */
  dataSourcesAggregate: DataSourcesAggregate;
  /** fetch data from the table: "data_sources" using primary key columns */
  dataSourcesByPk?: Maybe<DataSources>;
  /** fetch data from the table in a streaming manner: "data_sources" */
  dataSourcesStream: Array<DataSources>;
  /** fetch data from the table: "dbpjkit_worker_job_runs" */
  dbpjkitWorkerJobRuns: Array<DbpjkitWorkerJobRuns>;
  /** An aggregate relationship */
  dbpjkitWorkerJobRunsAggregate: DbpjkitWorkerJobRunsAggregate;
  /** fetch data from the table: "dbpjkit_worker_job_runs" using primary key columns */
  dbpjkitWorkerJobRunsByPk?: Maybe<DbpjkitWorkerJobRuns>;
  /** fetch data from the table in a streaming manner: "dbpjkit_worker_job_runs" */
  dbpjkitWorkerJobRunsStream: Array<DbpjkitWorkerJobRuns>;
  /** fetch data from the table: "dbpjkit_worker_jobs" */
  dbpjkitWorkerJobs: Array<DbpjkitWorkerJobs>;
  /** fetch aggregated fields from the table: "dbpjkit_worker_jobs" */
  dbpjkitWorkerJobsAggregate: DbpjkitWorkerJobsAggregate;
  /** fetch data from the table: "dbpjkit_worker_jobs" using primary key columns */
  dbpjkitWorkerJobsByPk?: Maybe<DbpjkitWorkerJobs>;
  /** fetch data from the table in a streaming manner: "dbpjkit_worker_jobs" */
  dbpjkitWorkerJobsStream: Array<DbpjkitWorkerJobs>;
  /** fetch data from the table: "entity_record_composer_definitions" */
  entityRecordComposerDefinitions: Array<EntityRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "entity_record_composer_definitions" */
  entityRecordComposerDefinitionsAggregate: EntityRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "entity_record_composer_definitions" using primary key columns */
  entityRecordComposerDefinitionsByPk?: Maybe<EntityRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "entity_record_composer_definitions" */
  entityRecordComposerDefinitionsStream: Array<EntityRecordComposerDefinitions>;
  /** fetch data from the table: "entity_records" */
  entityRecords: Array<EntityRecords>;
  /** fetch aggregated fields from the table: "entity_records" */
  entityRecordsAggregate: EntityRecordsAggregate;
  /** fetch data from the table: "entity_records" using primary key columns */
  entityRecordsByPk?: Maybe<EntityRecords>;
  /** fetch data from the table in a streaming manner: "entity_records" */
  entityRecordsStream: Array<EntityRecords>;
  /** An array relationship */
  evidenceChangeRequests: Array<EvidenceChangeRequests>;
  /** An aggregate relationship */
  evidenceChangeRequestsAggregate: EvidenceChangeRequestsAggregate;
  /** fetch data from the table: "evidence_change_requests" using primary key columns */
  evidenceChangeRequestsByPk?: Maybe<EvidenceChangeRequests>;
  /** fetch data from the table in a streaming manner: "evidence_change_requests" */
  evidenceChangeRequestsStream: Array<EvidenceChangeRequests>;
  /** An array relationship */
  evidenceEvidenceSets: Array<EvidenceEvidenceSets>;
  /** An aggregate relationship */
  evidenceEvidenceSetsAggregate: EvidenceEvidenceSetsAggregate;
  /** fetch data from the table: "evidence_evidence_sets" using primary key columns */
  evidenceEvidenceSetsByPk?: Maybe<EvidenceEvidenceSets>;
  /** fetch data from the table in a streaming manner: "evidence_evidence_sets" */
  evidenceEvidenceSetsStream: Array<EvidenceEvidenceSets>;
  /** fetch data from the table: "evidence_importers" */
  evidenceImporters: Array<EvidenceImporters>;
  /** fetch aggregated fields from the table: "evidence_importers" */
  evidenceImportersAggregate: EvidenceImportersAggregate;
  /** fetch data from the table: "evidence_importers" using primary key columns */
  evidenceImportersByPk?: Maybe<EvidenceImporters>;
  /** fetch data from the table in a streaming manner: "evidence_importers" */
  evidenceImportersStream: Array<EvidenceImporters>;
  /** An array relationship */
  evidenceRecordGeoItems: Array<EvidenceRecordGeoItems>;
  /** An aggregate relationship */
  evidenceRecordGeoItemsAggregate: EvidenceRecordGeoItemsAggregate;
  /** fetch data from the table: "evidence_record_geo_items" using primary key columns */
  evidenceRecordGeoItemsByPk?: Maybe<EvidenceRecordGeoItems>;
  /** fetch data from the table in a streaming manner: "evidence_record_geo_items" */
  evidenceRecordGeoItemsStream: Array<EvidenceRecordGeoItems>;
  /** An array relationship */
  evidenceSetImportProjects: Array<EvidenceSetImportProjects>;
  /** An aggregate relationship */
  evidenceSetImportProjectsAggregate: EvidenceSetImportProjectsAggregate;
  /** fetch data from the table: "evidence_set_import_projects" using primary key columns */
  evidenceSetImportProjectsByPk?: Maybe<EvidenceSetImportProjects>;
  /** fetch data from the table in a streaming manner: "evidence_set_import_projects" */
  evidenceSetImportProjectsStream: Array<EvidenceSetImportProjects>;
  /** fetch data from the table: "evidence_set_property_schema_sets" */
  evidenceSetPropertySchemaSets: Array<EvidenceSetPropertySchemaSets>;
  /** fetch aggregated fields from the table: "evidence_set_property_schema_sets" */
  evidenceSetPropertySchemaSetsAggregate: EvidenceSetPropertySchemaSetsAggregate;
  /** fetch data from the table: "evidence_set_property_schema_sets" using primary key columns */
  evidenceSetPropertySchemaSetsByPk?: Maybe<EvidenceSetPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "evidence_set_property_schema_sets" */
  evidenceSetPropertySchemaSetsStream: Array<EvidenceSetPropertySchemaSets>;
  /** fetch data from the table: "evidence_sets" */
  evidenceSets: Array<EvidenceSets>;
  /** fetch aggregated fields from the table: "evidence_sets" */
  evidenceSetsAggregate: EvidenceSetsAggregate;
  /** fetch data from the table: "evidence_sets" using primary key columns */
  evidenceSetsByPk?: Maybe<EvidenceSets>;
  /** fetch data from the table in a streaming manner: "evidence_sets" */
  evidenceSetsStream: Array<EvidenceSets>;
  /** An array relationship */
  evidenceVersions: Array<EvidenceVersions>;
  /** An aggregate relationship */
  evidenceVersionsAggregate: EvidenceVersionsAggregate;
  /** fetch data from the table: "evidence_versions" using primary key columns */
  evidenceVersionsByPk?: Maybe<EvidenceVersions>;
  /** fetch data from the table in a streaming manner: "evidence_versions" */
  evidenceVersionsStream: Array<EvidenceVersions>;
  /** An array relationship */
  evidences: Array<Evidences>;
  /** An aggregate relationship */
  evidencesAggregate: EvidencesAggregate;
  /** fetch data from the table: "evidences" using primary key columns */
  evidencesByPk?: Maybe<Evidences>;
  /** fetch data from the table in a streaming manner: "evidences" */
  evidencesStream: Array<Evidences>;
  /** fetch data from the table: "job_run_statuses" */
  jobRunStatuses: Array<JobRunStatuses>;
  /** fetch aggregated fields from the table: "job_run_statuses" */
  jobRunStatusesAggregate: JobRunStatusesAggregate;
  /** fetch data from the table: "job_run_statuses" using primary key columns */
  jobRunStatusesByPk?: Maybe<JobRunStatuses>;
  /** fetch data from the table in a streaming manner: "job_run_statuses" */
  jobRunStatusesStream: Array<JobRunStatuses>;
  /** fetch data from the table: "organization_kinds" */
  organizationKinds: Array<OrganizationKinds>;
  /** fetch aggregated fields from the table: "organization_kinds" */
  organizationKindsAggregate: OrganizationKindsAggregate;
  /** fetch data from the table: "organization_kinds" using primary key columns */
  organizationKindsByPk?: Maybe<OrganizationKinds>;
  /** fetch data from the table in a streaming manner: "organization_kinds" */
  organizationKindsStream: Array<OrganizationKinds>;
  /** fetch data from the table: "organizations" */
  organizations: Array<Organizations>;
  /** fetch aggregated fields from the table: "organizations" */
  organizationsAggregate: OrganizationsAggregate;
  /** fetch data from the table: "organizations" using primary key columns */
  organizationsByPk?: Maybe<Organizations>;
  /** fetch data from the table in a streaming manner: "organizations" */
  organizationsStream: Array<Organizations>;
  /** An array relationship */
  productRoles: Array<ProductRoles>;
  /** An aggregate relationship */
  productRolesAggregate: ProductRolesAggregate;
  /** fetch data from the table: "product_roles" using primary key columns */
  productRolesByPk?: Maybe<ProductRoles>;
  /** fetch data from the table in a streaming manner: "product_roles" */
  productRolesStream: Array<ProductRoles>;
  /** fetch data from the table: "products" */
  products: Array<Products>;
  /** fetch aggregated fields from the table: "products" */
  productsAggregate: ProductsAggregate;
  /** fetch data from the table: "products" using primary key columns */
  productsByPk?: Maybe<Products>;
  /** fetch data from the table in a streaming manner: "products" */
  productsStream: Array<Products>;
  /** An array relationship */
  propertySchemaAssociations: Array<PropertySchemaAssociations>;
  /** An aggregate relationship */
  propertySchemaAssociationsAggregate: PropertySchemaAssociationsAggregate;
  /** fetch data from the table: "property_schema_associations" using primary key columns */
  propertySchemaAssociationsByPk?: Maybe<PropertySchemaAssociations>;
  /** fetch data from the table in a streaming manner: "property_schema_associations" */
  propertySchemaAssociationsStream: Array<PropertySchemaAssociations>;
  /** fetch data from the table: "property_schema_sets" */
  propertySchemaSets: Array<PropertySchemaSets>;
  /** fetch aggregated fields from the table: "property_schema_sets" */
  propertySchemaSetsAggregate: PropertySchemaSetsAggregate;
  /** fetch data from the table: "property_schema_sets" using primary key columns */
  propertySchemaSetsByPk?: Maybe<PropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "property_schema_sets" */
  propertySchemaSetsStream: Array<PropertySchemaSets>;
  /** fetch data from the table: "property_schemas" */
  propertySchemas: Array<PropertySchemas>;
  /** fetch aggregated fields from the table: "property_schemas" */
  propertySchemasAggregate: PropertySchemasAggregate;
  /** fetch data from the table: "property_schemas" using primary key columns */
  propertySchemasByPk?: Maybe<PropertySchemas>;
  /** fetch data from the table in a streaming manner: "property_schemas" */
  propertySchemasStream: Array<PropertySchemas>;
  /** fetch data from the table: "property_types" */
  propertyTypes: Array<PropertyTypes>;
  /** fetch aggregated fields from the table: "property_types" */
  propertyTypesAggregate: PropertyTypesAggregate;
  /** fetch data from the table: "property_types" using primary key columns */
  propertyTypesByPk?: Maybe<PropertyTypes>;
  /** fetch data from the table in a streaming manner: "property_types" */
  propertyTypesStream: Array<PropertyTypes>;
  /** fetch data from the table: "publishers" */
  publishers: Array<Publishers>;
  /** fetch aggregated fields from the table: "publishers" */
  publishersAggregate: PublishersAggregate;
  /** fetch data from the table: "publishers" using primary key columns */
  publishersByPk?: Maybe<Publishers>;
  /** fetch data from the table in a streaming manner: "publishers" */
  publishersStream: Array<Publishers>;
  /** An array relationship */
  recordComposerDefinitionEvidenceSets: Array<RecordComposerDefinitionEvidenceSets>;
  /** An aggregate relationship */
  recordComposerDefinitionEvidenceSetsAggregate: RecordComposerDefinitionEvidenceSetsAggregate;
  /** fetch data from the table: "record_composer_definition_evidence_sets" using primary key columns */
  recordComposerDefinitionEvidenceSetsByPk?: Maybe<RecordComposerDefinitionEvidenceSets>;
  /** fetch data from the table in a streaming manner: "record_composer_definition_evidence_sets" */
  recordComposerDefinitionEvidenceSetsStream: Array<RecordComposerDefinitionEvidenceSets>;
  /** fetch data from the table: "record_composer_definition_property_schema_sets" */
  recordComposerDefinitionPropertySchemaSets: Array<RecordComposerDefinitionPropertySchemaSets>;
  /** fetch aggregated fields from the table: "record_composer_definition_property_schema_sets" */
  recordComposerDefinitionPropertySchemaSetsAggregate: RecordComposerDefinitionPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_composer_definition_property_schema_sets" using primary key columns */
  recordComposerDefinitionPropertySchemaSetsByPk?: Maybe<RecordComposerDefinitionPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "record_composer_definition_property_schema_sets" */
  recordComposerDefinitionPropertySchemaSetsStream: Array<RecordComposerDefinitionPropertySchemaSets>;
  /** fetch data from the table: "record_composer_definitions" */
  recordComposerDefinitions: Array<RecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "record_composer_definitions" */
  recordComposerDefinitionsAggregate: RecordComposerDefinitionsAggregate;
  /** fetch data from the table: "record_composer_definitions" using primary key columns */
  recordComposerDefinitionsByPk?: Maybe<RecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "record_composer_definitions" */
  recordComposerDefinitionsStream: Array<RecordComposerDefinitions>;
  /** An array relationship */
  recordCompoundRecordComposers: Array<RecordCompoundRecordComposers>;
  /** An aggregate relationship */
  recordCompoundRecordComposersAggregate: RecordCompoundRecordComposersAggregate;
  /** fetch data from the table: "record_compound_record_composers" using primary key columns */
  recordCompoundRecordComposersByPk?: Maybe<RecordCompoundRecordComposers>;
  /** fetch data from the table in a streaming manner: "record_compound_record_composers" */
  recordCompoundRecordComposersStream: Array<RecordCompoundRecordComposers>;
  /** An array relationship */
  recordGeoItems: Array<RecordGeoItems>;
  /** An aggregate relationship */
  recordGeoItemsAggregate: RecordGeoItemsAggregate;
  /** fetch data from the table: "record_geo_items" using primary key columns */
  recordGeoItemsByPk?: Maybe<RecordGeoItems>;
  /** fetch data from the table in a streaming manner: "record_geo_items" */
  recordGeoItemsStream: Array<RecordGeoItems>;
  /** fetch data from the table: "record_metadata" */
  recordMetadata: Array<RecordMetadata>;
  /** fetch aggregated fields from the table: "record_metadata" */
  recordMetadataAggregate: RecordMetadataAggregate;
  /** fetch data from the table: "record_metadata" using primary key columns */
  recordMetadataByPk?: Maybe<RecordMetadata>;
  /** An array relationship */
  recordMetadataCategories: Array<RecordMetadataCategories>;
  /** An aggregate relationship */
  recordMetadataCategoriesAggregate: RecordMetadataCategoriesAggregate;
  /** fetch data from the table: "record_metadata_categories" using primary key columns */
  recordMetadataCategoriesByPk?: Maybe<RecordMetadataCategories>;
  /** fetch data from the table in a streaming manner: "record_metadata_categories" */
  recordMetadataCategoriesStream: Array<RecordMetadataCategories>;
  /** fetch data from the table: "record_metadata_property_schema_sets" */
  recordMetadataPropertySchemaSets: Array<RecordMetadataPropertySchemaSets>;
  /** fetch aggregated fields from the table: "record_metadata_property_schema_sets" */
  recordMetadataPropertySchemaSetsAggregate: RecordMetadataPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_metadata_property_schema_sets" using primary key columns */
  recordMetadataPropertySchemaSetsByPk?: Maybe<RecordMetadataPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "record_metadata_property_schema_sets" */
  recordMetadataPropertySchemaSetsStream: Array<RecordMetadataPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "record_metadata" */
  recordMetadataStream: Array<RecordMetadata>;
  /** An array relationship */
  recordPropertySchemaSets: Array<RecordPropertySchemaSets>;
  /** An aggregate relationship */
  recordPropertySchemaSetsAggregate: RecordPropertySchemaSetsAggregate;
  /** fetch data from the table: "record_property_schema_sets" using primary key columns */
  recordPropertySchemaSetsByPk?: Maybe<RecordPropertySchemaSets>;
  /** fetch data from the table in a streaming manner: "record_property_schema_sets" */
  recordPropertySchemaSetsStream: Array<RecordPropertySchemaSets>;
  /** fetch data from the table: "record_update_record_composer_definitions" */
  recordUpdateRecordComposerDefinitions: Array<RecordUpdateRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "record_update_record_composer_definitions" */
  recordUpdateRecordComposerDefinitionsAggregate: RecordUpdateRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "record_update_record_composer_definitions" using primary key columns */
  recordUpdateRecordComposerDefinitionsByPk?: Maybe<RecordUpdateRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "record_update_record_composer_definitions" */
  recordUpdateRecordComposerDefinitionsStream: Array<RecordUpdateRecordComposerDefinitions>;
  /** fetch data from the table: "records" */
  records: Array<Records>;
  /** fetch aggregated fields from the table: "records" */
  recordsAggregate: RecordsAggregate;
  /** fetch data from the table: "records" using primary key columns */
  recordsByPk?: Maybe<Records>;
  /** fetch data from the table in a streaming manner: "records" */
  recordsStream: Array<Records>;
  /** An array relationship */
  referenceFiles: Array<ReferenceFiles>;
  /** An aggregate relationship */
  referenceFilesAggregate: ReferenceFilesAggregate;
  /** fetch data from the table: "reference_files" using primary key columns */
  referenceFilesByPk?: Maybe<ReferenceFiles>;
  /** fetch data from the table in a streaming manner: "reference_files" */
  referenceFilesStream: Array<ReferenceFiles>;
  /** An array relationship */
  referencePublishers: Array<ReferencePublishers>;
  /** An aggregate relationship */
  referencePublishersAggregate: ReferencePublishersAggregate;
  /** fetch data from the table: "reference_publishers" using primary key columns */
  referencePublishersByPk?: Maybe<ReferencePublishers>;
  /** fetch data from the table in a streaming manner: "reference_publishers" */
  referencePublishersStream: Array<ReferencePublishers>;
  /** fetch data from the table: "references" */
  references: Array<References>;
  /** fetch aggregated fields from the table: "references" */
  referencesAggregate: ReferencesAggregate;
  /** fetch data from the table: "references" using primary key columns */
  referencesByPk?: Maybe<References>;
  /** fetch data from the table in a streaming manner: "references" */
  referencesStream: Array<References>;
  /** fetch data from the table: "relation_record_composer_definitions" */
  relationRecordComposerDefinitions: Array<RelationRecordComposerDefinitions>;
  /** fetch aggregated fields from the table: "relation_record_composer_definitions" */
  relationRecordComposerDefinitionsAggregate: RelationRecordComposerDefinitionsAggregate;
  /** fetch data from the table: "relation_record_composer_definitions" using primary key columns */
  relationRecordComposerDefinitionsByPk?: Maybe<RelationRecordComposerDefinitions>;
  /** fetch data from the table in a streaming manner: "relation_record_composer_definitions" */
  relationRecordComposerDefinitionsStream: Array<RelationRecordComposerDefinitions>;
  /** fetch data from the table: "relation_records" */
  relationRecords: Array<RelationRecords>;
  /** fetch aggregated fields from the table: "relation_records" */
  relationRecordsAggregate: RelationRecordsAggregate;
  /** fetch data from the table: "relation_records" using primary key columns */
  relationRecordsByPk?: Maybe<RelationRecords>;
  /** fetch data from the table in a streaming manner: "relation_records" */
  relationRecordsStream: Array<RelationRecords>;
  /** fetch data from the table: "relation_types" */
  relationTypes: Array<RelationTypes>;
  /** fetch aggregated fields from the table: "relation_types" */
  relationTypesAggregate: RelationTypesAggregate;
  /** fetch data from the table: "relation_types" using primary key columns */
  relationTypesByPk?: Maybe<RelationTypes>;
  /** fetch data from the table in a streaming manner: "relation_types" */
  relationTypesStream: Array<RelationTypes>;
  /** fetch data from the table: "roles" */
  roles: Array<Roles>;
  /** fetch aggregated fields from the table: "roles" */
  rolesAggregate: RolesAggregate;
  /** fetch data from the table: "roles" using primary key columns */
  rolesByPk?: Maybe<Roles>;
  /** fetch data from the table in a streaming manner: "roles" */
  rolesStream: Array<Roles>;
  /** An array relationship */
  sourceRecordEdges: Array<SourceRecordEdges>;
  /** An aggregate relationship */
  sourceRecordEdgesAggregate: SourceRecordEdgesAggregate;
  /** fetch data from the table: "source_record_edges" using primary key columns */
  sourceRecordEdgesByPk?: Maybe<SourceRecordEdges>;
  /** fetch data from the table in a streaming manner: "source_record_edges" */
  sourceRecordEdgesStream: Array<SourceRecordEdges>;
  /** An array relationship */
  targetRecordEdges: Array<TargetRecordEdges>;
  /** An aggregate relationship */
  targetRecordEdgesAggregate: TargetRecordEdgesAggregate;
  /** fetch data from the table: "target_record_edges" using primary key columns */
  targetRecordEdgesByPk?: Maybe<TargetRecordEdges>;
  /** fetch data from the table in a streaming manner: "target_record_edges" */
  targetRecordEdgesStream: Array<TargetRecordEdges>;
  /** An array relationship */
  tenantProductInstallations: Array<TenantProductInstallations>;
  /** An aggregate relationship */
  tenantProductInstallationsAggregate: TenantProductInstallationsAggregate;
  /** fetch data from the table: "tenant_product_installations" using primary key columns */
  tenantProductInstallationsByPk?: Maybe<TenantProductInstallations>;
  /** fetch data from the table in a streaming manner: "tenant_product_installations" */
  tenantProductInstallationsStream: Array<TenantProductInstallations>;
  /** An array relationship */
  tenants: Array<Tenants>;
  /** An aggregate relationship */
  tenantsAggregate: TenantsAggregate;
  /** fetch data from the table: "tenants" using primary key columns */
  tenantsByPk?: Maybe<Tenants>;
  /** fetch data from the table in a streaming manner: "tenants" */
  tenantsStream: Array<Tenants>;
  /** An array relationship */
  unifiedEvidenceDrafts: Array<UnifiedEvidenceDrafts>;
  /** An aggregate relationship */
  unifiedEvidenceDraftsAggregate: UnifiedEvidenceDraftsAggregate;
  /** fetch data from the table: "unified_evidence_drafts" using primary key columns */
  unifiedEvidenceDraftsByPk?: Maybe<UnifiedEvidenceDrafts>;
  /** fetch data from the table in a streaming manner: "unified_evidence_drafts" */
  unifiedEvidenceDraftsStream: Array<UnifiedEvidenceDrafts>;
  /** fetch data from the table: "user_groups" */
  userGroups: Array<UserGroups>;
  /** fetch aggregated fields from the table: "user_groups" */
  userGroupsAggregate: UserGroupsAggregate;
  /** fetch data from the table: "user_groups" using primary key columns */
  userGroupsByPk?: Maybe<UserGroups>;
  /** fetch data from the table in a streaming manner: "user_groups" */
  userGroupsStream: Array<UserGroups>;
  /** An array relationship */
  userProductRoles: Array<UserProductRoles>;
  /** An aggregate relationship */
  userProductRolesAggregate: UserProductRolesAggregate;
  /** fetch data from the table: "user_product_roles" using primary key columns */
  userProductRolesByPk?: Maybe<UserProductRoles>;
  /** fetch data from the table in a streaming manner: "user_product_roles" */
  userProductRolesStream: Array<UserProductRoles>;
  /** fetch data from the table: "user_segments" */
  userSegments: Array<UserSegments>;
  /** fetch aggregated fields from the table: "user_segments" */
  userSegmentsAggregate: UserSegmentsAggregate;
  /** fetch data from the table: "user_segments" using primary key columns */
  userSegmentsByPk?: Maybe<UserSegments>;
  /** fetch data from the table in a streaming manner: "user_segments" */
  userSegmentsStream: Array<UserSegments>;
  /** An array relationship */
  userTenants: Array<UserTenants>;
  /** An aggregate relationship */
  userTenantsAggregate: UserTenantsAggregate;
  /** fetch data from the table: "user_tenants" using primary key columns */
  userTenantsByPk?: Maybe<UserTenants>;
  /** fetch data from the table in a streaming manner: "user_tenants" */
  userTenantsStream: Array<UserTenants>;
  /** An array relationship */
  userUserGroups: Array<UserUserGroups>;
  /** An aggregate relationship */
  userUserGroupsAggregate: UserUserGroupsAggregate;
  /** fetch data from the table: "user_user_groups" using primary key columns */
  userUserGroupsByPk?: Maybe<UserUserGroups>;
  /** fetch data from the table in a streaming manner: "user_user_groups" */
  userUserGroupsStream: Array<UserUserGroups>;
  /** An array relationship */
  userUserSegments: Array<UserUserSegments>;
  /** An aggregate relationship */
  userUserSegmentsAggregate: UserUserSegmentsAggregate;
  /** fetch data from the table: "user_user_segments" using primary key columns */
  userUserSegmentsByPk?: Maybe<UserUserSegments>;
  /** fetch data from the table in a streaming manner: "user_user_segments" */
  userUserSegmentsStream: Array<UserUserSegments>;
  /** fetch data from the table: "users" */
  users: Array<Users>;
  /** fetch aggregated fields from the table: "users" */
  usersAggregate: UsersAggregate;
  /** fetch data from the table: "users" using primary key columns */
  usersByPk?: Maybe<Users>;
  /** fetch data from the table in a streaming manner: "users" */
  usersStream: Array<Users>;
};


export type Subscription_RootAreaCodesArgs = {
  distinctOn?: InputMaybe<Array<AreaCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AreaCodesOrderBy>>;
  where?: InputMaybe<AreaCodesBoolExp>;
};


export type Subscription_RootAreaCodesAggregateArgs = {
  distinctOn?: InputMaybe<Array<AreaCodesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<AreaCodesOrderBy>>;
  where?: InputMaybe<AreaCodesBoolExp>;
};


export type Subscription_RootAreaCodesByPkArgs = {
  countryId: Scalars['String']['input'];
};


export type Subscription_RootAreaCodesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<AreaCodesStreamCursorInput>>;
  where?: InputMaybe<AreaCodesBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchChangeRequestReviewsJobRunsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchChangeRequestReviewsJobRunsStreamCursorInput>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestReviewsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestReviewsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


export type Subscription_RootBatchChangeRequestReviewsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchChangeRequestReviewsJobsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchChangeRequestReviewsJobsStreamCursorInput>>;
  where?: InputMaybe<BatchChangeRequestReviewsJobsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRecordComposerDefinitionsByPkArgs = {
  batchChangeRequestsJobId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootBatchChangeRequestsJobRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<BatchChangeRequestsJobRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobRunsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchChangeRequestsJobRunsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchChangeRequestsJobRunsStreamCursorInput>>;
  where?: InputMaybe<BatchChangeRequestsJobRunsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchChangeRequestsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchChangeRequestsJobsOrderBy>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


export type Subscription_RootBatchChangeRequestsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchChangeRequestsJobsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchChangeRequestsJobsStreamCursorInput>>;
  where?: InputMaybe<BatchChangeRequestsJobsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchEvidenceCommitsJobRunsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchEvidenceCommitsJobRunsStreamCursorInput>>;
  where?: InputMaybe<BatchEvidenceCommitsJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidenceCommitsJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidenceCommitsJobsOrderBy>>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};


export type Subscription_RootBatchEvidenceCommitsJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchEvidenceCommitsJobsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchEvidenceCommitsJobsStreamCursorInput>>;
  where?: InputMaybe<BatchEvidenceCommitsJobsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobRunsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobRunsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchEvidencesJobRunsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchEvidencesJobRunsStreamCursorInput>>;
  where?: InputMaybe<BatchEvidencesJobRunsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobsArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<BatchEvidencesJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<BatchEvidencesJobsOrderBy>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


export type Subscription_RootBatchEvidencesJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootBatchEvidencesJobsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<BatchEvidencesJobsStreamCursorInput>>;
  where?: InputMaybe<BatchEvidencesJobsBoolExp>;
};


export type Subscription_RootCategoriesArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


export type Subscription_RootCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoriesOrderBy>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


export type Subscription_RootCategoriesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCategoriesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CategoriesStreamCursorInput>>;
  where?: InputMaybe<CategoriesBoolExp>;
};


export type Subscription_RootCategoryPathsArgs = {
  distinctOn?: InputMaybe<Array<CategoryPathsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPathsOrderBy>>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};


export type Subscription_RootCategoryPathsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryPathsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPathsOrderBy>>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};


export type Subscription_RootCategoryPathsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


export type Subscription_RootCategoryPathsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CategoryPathsStreamCursorInput>>;
  where?: InputMaybe<CategoryPathsBoolExp>;
};


export type Subscription_RootCategoryPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


export type Subscription_RootCategoryPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


export type Subscription_RootCategoryPropertySchemaSetsByPkArgs = {
  categoryId: Scalars['uuid']['input'];
};


export type Subscription_RootCategoryPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CategoryPropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<CategoryPropertySchemaSetsBoolExp>;
};


export type Subscription_RootCategoryTypesArgs = {
  distinctOn?: InputMaybe<Array<CategoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryTypesOrderBy>>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};


export type Subscription_RootCategoryTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CategoryTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CategoryTypesOrderBy>>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};


export type Subscription_RootCategoryTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootCategoryTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CategoryTypesStreamCursorInput>>;
  where?: InputMaybe<CategoryTypesBoolExp>;
};


export type Subscription_RootChangeRequestCommitsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};


export type Subscription_RootChangeRequestCommitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};


export type Subscription_RootChangeRequestCommitsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestCommitsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestCommitsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestCommitsBoolExp>;
};


export type Subscription_RootChangeRequestItemCommitsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


export type Subscription_RootChangeRequestItemCommitsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemCommitsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemCommitsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


export type Subscription_RootChangeRequestItemCommitsByPkArgs = {
  changeRequestCommitId: Scalars['uuid']['input'];
  changeRequestItemId: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestItemCommitsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestItemCommitsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestItemCommitsBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordMetadataArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordMetadataOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordMetadataByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestItemRecordMetadataStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestItemRecordMetadataStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestItemRecordMetadataBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemRecordsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


export type Subscription_RootChangeRequestItemRecordsByPkArgs = {
  changeRequestItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestItemRecordsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestItemRecordsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestItemRecordsBoolExp>;
};


export type Subscription_RootChangeRequestItemsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


export type Subscription_RootChangeRequestItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestItemsOrderBy>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


export type Subscription_RootChangeRequestItemsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestItemsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestItemsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestItemsBoolExp>;
};


export type Subscription_RootChangeRequestRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootChangeRequestRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootChangeRequestRecordComposerDefinitionsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootChangeRequestReviewTypesArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewTypesOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};


export type Subscription_RootChangeRequestReviewTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewTypesOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};


export type Subscription_RootChangeRequestReviewTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootChangeRequestReviewTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestReviewTypesStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestReviewTypesBoolExp>;
};


export type Subscription_RootChangeRequestReviewsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


export type Subscription_RootChangeRequestReviewsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestReviewsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestReviewsOrderBy>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


export type Subscription_RootChangeRequestReviewsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestReviewsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestReviewsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestReviewsBoolExp>;
};


export type Subscription_RootChangeRequestStatusesArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestStatusesOrderBy>>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};


export type Subscription_RootChangeRequestStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestStatusesOrderBy>>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};


export type Subscription_RootChangeRequestStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootChangeRequestStatusesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestStatusesStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestStatusesBoolExp>;
};


export type Subscription_RootChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


export type Subscription_RootChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ChangeRequestsOrderBy>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


export type Subscription_RootChangeRequestsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootChangeRequestsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ChangeRequestsStreamCursorInput>>;
  where?: InputMaybe<ChangeRequestsBoolExp>;
};


export type Subscription_RootCompoundCompoundRecordsArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


export type Subscription_RootCompoundCompoundRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundCompoundRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundCompoundRecordsOrderBy>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


export type Subscription_RootCompoundCompoundRecordsByPkArgs = {
  key: Scalars['String']['input'];
  v: Scalars['String']['input'];
};


export type Subscription_RootCompoundCompoundRecordsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompoundCompoundRecordsStreamCursorInput>>;
  where?: InputMaybe<CompoundCompoundRecordsBoolExp>;
};


export type Subscription_RootCompoundRecordComposersArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordComposersOrderBy>>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};


export type Subscription_RootCompoundRecordComposersAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordComposersOrderBy>>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};


export type Subscription_RootCompoundRecordComposersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompoundRecordComposersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompoundRecordComposersStreamCursorInput>>;
  where?: InputMaybe<CompoundRecordComposersBoolExp>;
};


export type Subscription_RootCompoundRecordVersionsArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordVersionsOrderBy>>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};


export type Subscription_RootCompoundRecordVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CompoundRecordVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CompoundRecordVersionsOrderBy>>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};


export type Subscription_RootCompoundRecordVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootCompoundRecordVersionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CompoundRecordVersionsStreamCursorInput>>;
  where?: InputMaybe<CompoundRecordVersionsBoolExp>;
};


export type Subscription_RootCountriesArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountriesOrderBy>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountriesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootCountriesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CountriesStreamCursorInput>>;
  where?: InputMaybe<CountriesBoolExp>;
};


export type Subscription_RootCountrySubdivisionsArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCountrySubdivisionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<CountrySubdivisionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<CountrySubdivisionsOrderBy>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootCountrySubdivisionsByPkArgs = {
  code: Scalars['String']['input'];
};


export type Subscription_RootCountrySubdivisionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<CountrySubdivisionsStreamCursorInput>>;
  where?: InputMaybe<CountrySubdivisionsBoolExp>;
};


export type Subscription_RootDataImportProjectRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataImportProjectRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootDataImportProjectRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataImportProjectRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<DataImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataImportProjectStatusLogsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


export type Subscription_RootDataImportProjectStatusLogsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusLogsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusLogsOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


export type Subscription_RootDataImportProjectStatusLogsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDataImportProjectStatusLogsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataImportProjectStatusLogsStreamCursorInput>>;
  where?: InputMaybe<DataImportProjectStatusLogsBoolExp>;
};


export type Subscription_RootDataImportProjectStatusesArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusesOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};


export type Subscription_RootDataImportProjectStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectStatusesOrderBy>>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};


export type Subscription_RootDataImportProjectStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootDataImportProjectStatusesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataImportProjectStatusesStreamCursorInput>>;
  where?: InputMaybe<DataImportProjectStatusesBoolExp>;
};


export type Subscription_RootDataImportProjectUsersArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


export type Subscription_RootDataImportProjectUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectUsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectUsersOrderBy>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


export type Subscription_RootDataImportProjectUsersByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootDataImportProjectUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataImportProjectUsersStreamCursorInput>>;
  where?: InputMaybe<DataImportProjectUsersBoolExp>;
};


export type Subscription_RootDataImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectsOrderBy>>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};


export type Subscription_RootDataImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataImportProjectsOrderBy>>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};


export type Subscription_RootDataImportProjectsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDataImportProjectsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataImportProjectsStreamCursorInput>>;
  where?: InputMaybe<DataImportProjectsBoolExp>;
};


export type Subscription_RootDataSourceGsheetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceGsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceGsheetsOrderBy>>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};


export type Subscription_RootDataSourceGsheetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceGsheetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceGsheetsOrderBy>>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};


export type Subscription_RootDataSourceGsheetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceGsheetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceGsheetsStreamCursorInput>>;
  where?: InputMaybe<DataSourceGsheetsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectRecordComposerDefinitionsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceImportProjectRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceImportProjectRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<DataSourceImportProjectRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceImportProjectsOrderBy>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


export type Subscription_RootDataSourceImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  dataSourceId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceImportProjectsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceImportProjectsStreamCursorInput>>;
  where?: InputMaybe<DataSourceImportProjectsBoolExp>;
};


export type Subscription_RootDataSourceJsonsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceJsonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceJsonsOrderBy>>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};


export type Subscription_RootDataSourceJsonsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceJsonsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceJsonsOrderBy>>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};


export type Subscription_RootDataSourceJsonsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceJsonsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceJsonsStreamCursorInput>>;
  where?: InputMaybe<DataSourceJsonsBoolExp>;
};


export type Subscription_RootDataSourcePropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourcePropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourcePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourcePropertySchemaSetsByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourcePropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourcePropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<DataSourcePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourceReferencesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


export type Subscription_RootDataSourceReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceReferencesOrderBy>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


export type Subscription_RootDataSourceReferencesByPkArgs = {
  dataSourceId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceReferencesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceReferencesStreamCursorInput>>;
  where?: InputMaybe<DataSourceReferencesBoolExp>;
};


export type Subscription_RootDataSourceTemplatePropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourceTemplatePropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatePropertySchemaSetsOrderBy>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourceTemplatePropertySchemaSetsByPkArgs = {
  dataSourceTemplateId: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceTemplatePropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceTemplatePropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<DataSourceTemplatePropertySchemaSetsBoolExp>;
};


export type Subscription_RootDataSourceTemplatesArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatesOrderBy>>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};


export type Subscription_RootDataSourceTemplatesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourceTemplatesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourceTemplatesOrderBy>>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};


export type Subscription_RootDataSourceTemplatesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourceTemplatesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourceTemplatesStreamCursorInput>>;
  where?: InputMaybe<DataSourceTemplatesBoolExp>;
};


export type Subscription_RootDataSourcesArgs = {
  distinctOn?: InputMaybe<Array<DataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
  where?: InputMaybe<DataSourcesBoolExp>;
};


export type Subscription_RootDataSourcesAggregateArgs = {
  distinctOn?: InputMaybe<Array<DataSourcesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DataSourcesOrderBy>>;
  where?: InputMaybe<DataSourcesBoolExp>;
};


export type Subscription_RootDataSourcesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDataSourcesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DataSourcesStreamCursorInput>>;
  where?: InputMaybe<DataSourcesBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobRunsArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobRunsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobRunsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobRunsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobRunsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDbpjkitWorkerJobRunsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DbpjkitWorkerJobRunsStreamCursorInput>>;
  where?: InputMaybe<DbpjkitWorkerJobRunsBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobsArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobsAggregateArgs = {
  distinctOn?: InputMaybe<Array<DbpjkitWorkerJobsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<DbpjkitWorkerJobsOrderBy>>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};


export type Subscription_RootDbpjkitWorkerJobsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootDbpjkitWorkerJobsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<DbpjkitWorkerJobsStreamCursorInput>>;
  where?: InputMaybe<DbpjkitWorkerJobsBoolExp>;
};


export type Subscription_RootEntityRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootEntityRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootEntityRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootEntityRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<EntityRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootEntityRecordsArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordsOrderBy>>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};


export type Subscription_RootEntityRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EntityRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EntityRecordsOrderBy>>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};


export type Subscription_RootEntityRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootEntityRecordsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EntityRecordsStreamCursorInput>>;
  where?: InputMaybe<EntityRecordsBoolExp>;
};


export type Subscription_RootEvidenceChangeRequestsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


export type Subscription_RootEvidenceChangeRequestsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceChangeRequestsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceChangeRequestsOrderBy>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


export type Subscription_RootEvidenceChangeRequestsByPkArgs = {
  changeRequestId: Scalars['uuid']['input'];
  evidenceId: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceChangeRequestsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceChangeRequestsStreamCursorInput>>;
  where?: InputMaybe<EvidenceChangeRequestsBoolExp>;
};


export type Subscription_RootEvidenceEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceEvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceEvidenceSetsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceEvidenceSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceEvidenceSetsStreamCursorInput>>;
  where?: InputMaybe<EvidenceEvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceImportersArgs = {
  distinctOn?: InputMaybe<Array<EvidenceImportersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceImportersOrderBy>>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};


export type Subscription_RootEvidenceImportersAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceImportersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceImportersOrderBy>>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};


export type Subscription_RootEvidenceImportersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceImportersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceImportersStreamCursorInput>>;
  where?: InputMaybe<EvidenceImportersBoolExp>;
};


export type Subscription_RootEvidenceRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


export type Subscription_RootEvidenceRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceRecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceRecordGeoItemsOrderBy>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


export type Subscription_RootEvidenceRecordGeoItemsByPkArgs = {
  evidenceId: Scalars['uuid']['input'];
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceRecordGeoItemsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceRecordGeoItemsStreamCursorInput>>;
  where?: InputMaybe<EvidenceRecordGeoItemsBoolExp>;
};


export type Subscription_RootEvidenceSetImportProjectsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


export type Subscription_RootEvidenceSetImportProjectsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetImportProjectsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetImportProjectsOrderBy>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


export type Subscription_RootEvidenceSetImportProjectsByPkArgs = {
  dataImportProjectId: Scalars['uuid']['input'];
  evidenceSetId: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceSetImportProjectsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceSetImportProjectsStreamCursorInput>>;
  where?: InputMaybe<EvidenceSetImportProjectsBoolExp>;
};


export type Subscription_RootEvidenceSetPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};


export type Subscription_RootEvidenceSetPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};


export type Subscription_RootEvidenceSetPropertySchemaSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceSetPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceSetPropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<EvidenceSetPropertySchemaSetsBoolExp>;
};


export type Subscription_RootEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceSetsOrderBy>>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceSetsStreamCursorInput>>;
  where?: InputMaybe<EvidenceSetsBoolExp>;
};


export type Subscription_RootEvidenceVersionsArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


export type Subscription_RootEvidenceVersionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidenceVersionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidenceVersionsOrderBy>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


export type Subscription_RootEvidenceVersionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvidenceVersionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidenceVersionsStreamCursorInput>>;
  where?: InputMaybe<EvidenceVersionsBoolExp>;
};


export type Subscription_RootEvidencesArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


export type Subscription_RootEvidencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<EvidencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<EvidencesOrderBy>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


export type Subscription_RootEvidencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootEvidencesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<EvidencesStreamCursorInput>>;
  where?: InputMaybe<EvidencesBoolExp>;
};


export type Subscription_RootJobRunStatusesArgs = {
  distinctOn?: InputMaybe<Array<JobRunStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobRunStatusesOrderBy>>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};


export type Subscription_RootJobRunStatusesAggregateArgs = {
  distinctOn?: InputMaybe<Array<JobRunStatusesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<JobRunStatusesOrderBy>>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};


export type Subscription_RootJobRunStatusesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootJobRunStatusesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<JobRunStatusesStreamCursorInput>>;
  where?: InputMaybe<JobRunStatusesBoolExp>;
};


export type Subscription_RootOrganizationKindsArgs = {
  distinctOn?: InputMaybe<Array<OrganizationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationKindsOrderBy>>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};


export type Subscription_RootOrganizationKindsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationKindsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationKindsOrderBy>>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};


export type Subscription_RootOrganizationKindsByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootOrganizationKindsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganizationKindsStreamCursorInput>>;
  where?: InputMaybe<OrganizationKindsBoolExp>;
};


export type Subscription_RootOrganizationsArgs = {
  distinctOn?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type Subscription_RootOrganizationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<OrganizationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<OrganizationsOrderBy>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type Subscription_RootOrganizationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootOrganizationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<OrganizationsStreamCursorInput>>;
  where?: InputMaybe<OrganizationsBoolExp>;
};


export type Subscription_RootProductRolesArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


export type Subscription_RootProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductRolesOrderBy>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


export type Subscription_RootProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
};


export type Subscription_RootProductRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProductRolesStreamCursorInput>>;
  where?: InputMaybe<ProductRolesBoolExp>;
};


export type Subscription_RootProductsArgs = {
  distinctOn?: InputMaybe<Array<ProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
  where?: InputMaybe<ProductsBoolExp>;
};


export type Subscription_RootProductsAggregateArgs = {
  distinctOn?: InputMaybe<Array<ProductsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ProductsOrderBy>>;
  where?: InputMaybe<ProductsBoolExp>;
};


export type Subscription_RootProductsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootProductsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ProductsStreamCursorInput>>;
  where?: InputMaybe<ProductsBoolExp>;
};


export type Subscription_RootPropertySchemaAssociationsArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


export type Subscription_RootPropertySchemaAssociationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaAssociationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaAssociationsOrderBy>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


export type Subscription_RootPropertySchemaAssociationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPropertySchemaAssociationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertySchemaAssociationsStreamCursorInput>>;
  where?: InputMaybe<PropertySchemaAssociationsBoolExp>;
};


export type Subscription_RootPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaSetsOrderBy>>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};


export type Subscription_RootPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemaSetsOrderBy>>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};


export type Subscription_RootPropertySchemaSetsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<PropertySchemaSetsBoolExp>;
};


export type Subscription_RootPropertySchemasArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemasOrderBy>>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};


export type Subscription_RootPropertySchemasAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertySchemasSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertySchemasOrderBy>>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};


export type Subscription_RootPropertySchemasByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPropertySchemasStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertySchemasStreamCursorInput>>;
  where?: InputMaybe<PropertySchemasBoolExp>;
};


export type Subscription_RootPropertyTypesArgs = {
  distinctOn?: InputMaybe<Array<PropertyTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};


export type Subscription_RootPropertyTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<PropertyTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PropertyTypesOrderBy>>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};


export type Subscription_RootPropertyTypesByPkArgs = {
  id: Scalars['String']['input'];
};


export type Subscription_RootPropertyTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PropertyTypesStreamCursorInput>>;
  where?: InputMaybe<PropertyTypesBoolExp>;
};


export type Subscription_RootPublishersArgs = {
  distinctOn?: InputMaybe<Array<PublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublishersOrderBy>>;
  where?: InputMaybe<PublishersBoolExp>;
};


export type Subscription_RootPublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<PublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<PublishersOrderBy>>;
  where?: InputMaybe<PublishersBoolExp>;
};


export type Subscription_RootPublishersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootPublishersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<PublishersStreamCursorInput>>;
  where?: InputMaybe<PublishersBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionEvidenceSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionEvidenceSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionEvidenceSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionEvidenceSetsByPkArgs = {
  evidenceSetId: Scalars['uuid']['input'];
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordComposerDefinitionEvidenceSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordComposerDefinitionEvidenceSetsStreamCursorInput>>;
  where?: InputMaybe<RecordComposerDefinitionEvidenceSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionPropertySchemaSetsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordComposerDefinitionPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordComposerDefinitionPropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<RecordComposerDefinitionPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordComposerDefinitionsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<RecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordCompoundRecordComposersArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


export type Subscription_RootRecordCompoundRecordComposersAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordCompoundRecordComposersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordCompoundRecordComposersOrderBy>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


export type Subscription_RootRecordCompoundRecordComposersByPkArgs = {
  compoundRecordComposerId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordCompoundRecordComposersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordCompoundRecordComposersStreamCursorInput>>;
  where?: InputMaybe<RecordCompoundRecordComposersBoolExp>;
};


export type Subscription_RootRecordGeoItemsArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


export type Subscription_RootRecordGeoItemsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordGeoItemsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordGeoItemsOrderBy>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


export type Subscription_RootRecordGeoItemsByPkArgs = {
  geoItemId: Scalars['uuid']['input'];
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordGeoItemsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordGeoItemsStreamCursorInput>>;
  where?: InputMaybe<RecordGeoItemsBoolExp>;
};


export type Subscription_RootRecordMetadataArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataOrderBy>>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};


export type Subscription_RootRecordMetadataAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataOrderBy>>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};


export type Subscription_RootRecordMetadataByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRecordMetadataCategoriesArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


export type Subscription_RootRecordMetadataCategoriesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataCategoriesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataCategoriesOrderBy>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


export type Subscription_RootRecordMetadataCategoriesByPkArgs = {
  categoryId: Scalars['uuid']['input'];
  recordMetadataId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordMetadataCategoriesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordMetadataCategoriesStreamCursorInput>>;
  where?: InputMaybe<RecordMetadataCategoriesBoolExp>;
};


export type Subscription_RootRecordMetadataPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordMetadataPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordMetadataPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordMetadataPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordMetadataPropertySchemaSetsByPkArgs = {
  propertySchemaSetId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordMetadataPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordMetadataPropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<RecordMetadataPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordMetadataStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordMetadataStreamCursorInput>>;
  where?: InputMaybe<RecordMetadataBoolExp>;
};


export type Subscription_RootRecordPropertySchemaSetsArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordPropertySchemaSetsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordPropertySchemaSetsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordPropertySchemaSetsOrderBy>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordPropertySchemaSetsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordPropertySchemaSetsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordPropertySchemaSetsStreamCursorInput>>;
  where?: InputMaybe<RecordPropertySchemaSetsBoolExp>;
};


export type Subscription_RootRecordUpdateRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordUpdateRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordUpdateRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordUpdateRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootRecordUpdateRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordUpdateRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<RecordUpdateRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRecordsArgs = {
  distinctOn?: InputMaybe<Array<RecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordsOrderBy>>;
  where?: InputMaybe<RecordsBoolExp>;
};


export type Subscription_RootRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RecordsOrderBy>>;
  where?: InputMaybe<RecordsBoolExp>;
};


export type Subscription_RootRecordsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRecordsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RecordsStreamCursorInput>>;
  where?: InputMaybe<RecordsBoolExp>;
};


export type Subscription_RootReferenceFilesArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


export type Subscription_RootReferenceFilesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferenceFilesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferenceFilesOrderBy>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


export type Subscription_RootReferenceFilesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReferenceFilesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReferenceFilesStreamCursorInput>>;
  where?: InputMaybe<ReferenceFilesBoolExp>;
};


export type Subscription_RootReferencePublishersArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


export type Subscription_RootReferencePublishersAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencePublishersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencePublishersOrderBy>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


export type Subscription_RootReferencePublishersByPkArgs = {
  publisherId: Scalars['uuid']['input'];
  referenceId: Scalars['uuid']['input'];
};


export type Subscription_RootReferencePublishersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReferencePublishersStreamCursorInput>>;
  where?: InputMaybe<ReferencePublishersBoolExp>;
};


export type Subscription_RootReferencesArgs = {
  distinctOn?: InputMaybe<Array<ReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencesOrderBy>>;
  where?: InputMaybe<ReferencesBoolExp>;
};


export type Subscription_RootReferencesAggregateArgs = {
  distinctOn?: InputMaybe<Array<ReferencesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<ReferencesOrderBy>>;
  where?: InputMaybe<ReferencesBoolExp>;
};


export type Subscription_RootReferencesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootReferencesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<ReferencesStreamCursorInput>>;
  where?: InputMaybe<ReferencesBoolExp>;
};


export type Subscription_RootRelationRecordComposerDefinitionsArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRelationRecordComposerDefinitionsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordComposerDefinitionsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordComposerDefinitionsOrderBy>>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRelationRecordComposerDefinitionsByPkArgs = {
  recordComposerDefinitionId: Scalars['uuid']['input'];
};


export type Subscription_RootRelationRecordComposerDefinitionsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelationRecordComposerDefinitionsStreamCursorInput>>;
  where?: InputMaybe<RelationRecordComposerDefinitionsBoolExp>;
};


export type Subscription_RootRelationRecordsArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordsOrderBy>>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};


export type Subscription_RootRelationRecordsAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationRecordsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationRecordsOrderBy>>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};


export type Subscription_RootRelationRecordsByPkArgs = {
  recordId: Scalars['uuid']['input'];
};


export type Subscription_RootRelationRecordsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelationRecordsStreamCursorInput>>;
  where?: InputMaybe<RelationRecordsBoolExp>;
};


export type Subscription_RootRelationTypesArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


export type Subscription_RootRelationTypesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RelationTypesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RelationTypesOrderBy>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


export type Subscription_RootRelationTypesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRelationTypesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RelationTypesStreamCursorInput>>;
  where?: InputMaybe<RelationTypesBoolExp>;
};


export type Subscription_RootRolesArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type Subscription_RootRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<RolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<RolesOrderBy>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type Subscription_RootRolesByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<RolesStreamCursorInput>>;
  where?: InputMaybe<RolesBoolExp>;
};


export type Subscription_RootSourceRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


export type Subscription_RootSourceRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<SourceRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<SourceRecordEdgesOrderBy>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


export type Subscription_RootSourceRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


export type Subscription_RootSourceRecordEdgesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<SourceRecordEdgesStreamCursorInput>>;
  where?: InputMaybe<SourceRecordEdgesBoolExp>;
};


export type Subscription_RootTargetRecordEdgesArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


export type Subscription_RootTargetRecordEdgesAggregateArgs = {
  distinctOn?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TargetRecordEdgesOrderBy>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


export type Subscription_RootTargetRecordEdgesByPkArgs = {
  entityRecordId: Scalars['uuid']['input'];
  relationRecordId: Scalars['uuid']['input'];
};


export type Subscription_RootTargetRecordEdgesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TargetRecordEdgesStreamCursorInput>>;
  where?: InputMaybe<TargetRecordEdgesBoolExp>;
};


export type Subscription_RootTenantProductInstallationsArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


export type Subscription_RootTenantProductInstallationsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantProductInstallationsOrderBy>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


export type Subscription_RootTenantProductInstallationsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantProductInstallationsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantProductInstallationsStreamCursorInput>>;
  where?: InputMaybe<TenantProductInstallationsBoolExp>;
};


export type Subscription_RootTenantsArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Subscription_RootTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<TenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<TenantsOrderBy>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Subscription_RootTenantsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootTenantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<TenantsStreamCursorInput>>;
  where?: InputMaybe<TenantsBoolExp>;
};


export type Subscription_RootUnifiedEvidenceDraftsArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


export type Subscription_RootUnifiedEvidenceDraftsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UnifiedEvidenceDraftsOrderBy>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


export type Subscription_RootUnifiedEvidenceDraftsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUnifiedEvidenceDraftsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UnifiedEvidenceDraftsStreamCursorInput>>;
  where?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
};


export type Subscription_RootUserGroupsArgs = {
  distinctOn?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type Subscription_RootUserGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserGroupsOrderBy>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type Subscription_RootUserGroupsByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUserGroupsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserGroupsStreamCursorInput>>;
  where?: InputMaybe<UserGroupsBoolExp>;
};


export type Subscription_RootUserProductRolesArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


export type Subscription_RootUserProductRolesAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserProductRolesOrderBy>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


export type Subscription_RootUserProductRolesByPkArgs = {
  productId: Scalars['uuid']['input'];
  roleId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserProductRolesStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserProductRolesStreamCursorInput>>;
  where?: InputMaybe<UserProductRolesBoolExp>;
};


export type Subscription_RootUserSegmentsArgs = {
  distinctOn?: InputMaybe<Array<UserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSegmentsOrderBy>>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};


export type Subscription_RootUserSegmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserSegmentsOrderBy>>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};


export type Subscription_RootUserSegmentsByPkArgs = {
  id: Scalars['Int']['input'];
};


export type Subscription_RootUserSegmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserSegmentsStreamCursorInput>>;
  where?: InputMaybe<UserSegmentsBoolExp>;
};


export type Subscription_RootUserTenantsArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Subscription_RootUserTenantsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserTenantsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserTenantsOrderBy>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Subscription_RootUserTenantsByPkArgs = {
  tenantId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserTenantsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserTenantsStreamCursorInput>>;
  where?: InputMaybe<UserTenantsBoolExp>;
};


export type Subscription_RootUserUserGroupsArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


export type Subscription_RootUserUserGroupsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserGroupsOrderBy>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


export type Subscription_RootUserUserGroupsByPkArgs = {
  userGroupId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
};


export type Subscription_RootUserUserGroupsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserUserGroupsStreamCursorInput>>;
  where?: InputMaybe<UserUserGroupsBoolExp>;
};


export type Subscription_RootUserUserSegmentsArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


export type Subscription_RootUserUserSegmentsAggregateArgs = {
  distinctOn?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UserUserSegmentsOrderBy>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


export type Subscription_RootUserUserSegmentsByPkArgs = {
  userId: Scalars['uuid']['input'];
  userSegmentId: Scalars['Int']['input'];
};


export type Subscription_RootUserUserSegmentsStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UserUserSegmentsStreamCursorInput>>;
  where?: InputMaybe<UserUserSegmentsBoolExp>;
};


export type Subscription_RootUsersArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersAggregateArgs = {
  distinctOn?: InputMaybe<Array<UsersSelectColumn>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<UsersOrderBy>>;
  where?: InputMaybe<UsersBoolExp>;
};


export type Subscription_RootUsersByPkArgs = {
  id: Scalars['uuid']['input'];
};


export type Subscription_RootUsersStreamArgs = {
  batchSize: Scalars['Int']['input'];
  cursor: Array<InputMaybe<UsersStreamCursorInput>>;
  where?: InputMaybe<UsersBoolExp>;
};

export type TargetRecordEdgesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TargetRecordEdgesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TargetRecordEdgesBoolExp>;
  predicate: IntComparisonExp;
};

export type TenantProductInstallationsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TenantProductInstallationsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantProductInstallationsBoolExp>;
  predicate: IntComparisonExp;
};

export type TenantsAggregateBoolExpBool_And = {
  arguments: TenantsSelectColumnTenantsAggregateBoolExpBool_AndArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TenantsAggregateBoolExpBool_Or = {
  arguments: TenantsSelectColumnTenantsAggregateBoolExpBool_OrArgumentsColumns;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantsBoolExp>;
  predicate: BooleanComparisonExp;
};

export type TenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<TenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<TenantsBoolExp>;
  predicate: IntComparisonExp;
};

export type UnifiedEvidenceDraftsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UnifiedEvidenceDraftsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UnifiedEvidenceDraftsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserProductRolesAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserProductRolesSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserProductRolesBoolExp>;
  predicate: IntComparisonExp;
};

export type UserTenantsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserTenantsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserTenantsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserUserGroupsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserUserGroupsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserUserGroupsBoolExp>;
  predicate: IntComparisonExp;
};

export type UserUserSegmentsAggregateBoolExpCount = {
  arguments?: InputMaybe<Array<UserUserSegmentsSelectColumn>>;
  distinct?: InputMaybe<Scalars['Boolean']['input']>;
  filter?: InputMaybe<UserUserSegmentsBoolExp>;
  predicate: IntComparisonExp;
};
